webpackJsonp([1],{

/***/ "./app/actions/account-settings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_PRINTERS = exports.SET_PRINTERS = 'SET_PRINTERS';
var setPrinters = exports.setPrinters = function setPrinters(cards) {
  return {
    type: SET_PRINTERS,
    cards: cards
  };
};

var SET_SETTINGS_PAGE = exports.SET_SETTINGS_PAGE = 'SET_SETTINGS_PAGE';

var SET_INVITES_SENT = exports.SET_INVITES_SENT = 'SET_INVITES_SENT';
var SET_INVITE_ERROR = exports.SET_INVITE_ERROR = 'SET_INVITE_ERROR';
var SET_PENDING_INVITES = exports.SET_PENDING_INVITES = 'SET_PENDING_INVITES';
var SET_USER_INVITE_ACCEPT_PAGE = exports.SET_USER_INVITE_ACCEPT_PAGE = 'SET_USER_INVITE_ACCEPT_PAGE';

var SET_ACCESS_UPDATED = exports.SET_ACCESS_UPDATED = 'SET_ACCESS_UPDATED';
var SET_ACCESS_UPDATED_ERROR = exports.SET_ACCESS_UPDATED_ERROR = 'SET_ACCESS_UPDATED_ERROR';

var SET_USER_PAYMENT_METHODS = exports.SET_USER_PAYMENT_METHODS = 'SET_USER_PAYMENT_METHODS';
var UPDATE_CREDIT_CARD = exports.UPDATE_CREDIT_CARD = 'UPDATE_CREDIT_CARD';
var UPDATE_CREDIT_CARD_ERROR = exports.UPDATE_CREDIT_CARD_ERROR = 'UPDATE_CREDIT_CARD_ERROR';
var SET_USER_PURCHASE_HISTORY = exports.SET_USER_PURCHASE_HISTORY = 'SET_USER_PURCHASE_HISTORY';

/***/ }),

/***/ "./app/actions/account.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CREATE_ACCOUNT = exports.CREATE_ACCOUNT = 'CREATE_ACCOUNT';
var SET_CREATE_ACCOUNT_PAGE = exports.SET_CREATE_ACCOUNT_PAGE = 'SET_CREATE_ACCOUNT_PAGE';

/***/ }),

/***/ "./app/actions/landing.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_GLOWFORGE_LANDING_PAGE = exports.SET_GLOWFORGE_LANDING_PAGE = 'SET_GLOWFORGE_LANDING_PAGE';
var SET_PROJECT_PICS = exports.SET_PROJECT_PICS = 'SET_PROJECT_PICS';

/***/ }),

/***/ "./app/actions/legal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_TOS_PAGE = exports.SET_TOS_PAGE = 'SET_TOS_PAGE';
var SET_LEGAL_PAGES = exports.SET_LEGAL_PAGES = 'SET_LEGAL_PAGES';
var TERMS_ACCEPTED = exports.TERMS_ACCEPTED = 'TERMS_ACCEPTED';

/***/ }),

/***/ "./app/actions/marketing.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_MARKETING_PAGE = exports.SET_MARKETING_PAGE = 'SET_MARKETING_PAGE'; //eslint-disable-line

/***/ }),

/***/ "./app/actions/onboarding.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_UNBOXING_PAGE = exports.SET_UNBOXING_PAGE = 'SET_UNBOXING_PAGE';
var SET_ONBOARDING_FINISH_PAGE = exports.SET_ONBOARDING_FINISH_PAGE = 'SET_ONBOARDING_FINISH_PAGE';
var SET_GLOWFORGE_NAMED = exports.SET_GLOWFORGE_NAMED = 'SET_GLOWFORGE_NAMED';
var SET_GLOWFORGE_NAME_PAGE = exports.SET_GLOWFORGE_NAME_PAGE = 'SET_GLOWFORGE_NAME_PAGE';
var SET_SELECT_PAGE = exports.SET_SELECT_PAGE = 'SET_SELECT_PAGE';
var SET_INSTRUCTIONS_PAGE = exports.SET_INSTRUCTIONS_PAGE = 'SET_INSTRUCTIONS_PAGE';
var SET_SELECTED_MODE = exports.SET_SELECTED_MODE = 'SET_SELECTED_MODE';
var setSelectedMode = exports.setSelectedMode = function setSelectedMode(mode) {
  return {
    type: SET_SELECTED_MODE,
    mode: mode
  };
};

/***/ }),

/***/ "./app/actions/subscriptions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOADING_SUBSCRIPTIONS = exports.LOADING_SUBSCRIPTIONS = 'LOADING_SUBSCRIPTIONS';
var RELOADING_SUBSCRIPTIONS = exports.RELOADING_SUBSCRIPTIONS = 'RELOADING_SUBSCRIPTIONS';
var SET_SUBSCRIPTIONS_STATUS = exports.SET_SUBSCRIPTIONS_STATUS = 'SET_SUBSCRIPTIONS_STATUS';
var SET_SUBSCRIPTIONS_USERS = exports.SET_SUBSCRIPTIONS_USERS = 'SET_SUBSCRIPTIONS_USERS';
var SUBSCRIPTIONS_USER_ADDED = exports.SUBSCRIPTIONS_USER_ADDED = 'SUBSCRIPTIONS_USER_ADDED';
var SUBSCRIPTIONS_USER_REMOVED = exports.SUBSCRIPTIONS_USER_REMOVED = 'SUBSCRIPTIONS_USER_REMOVED';

var MANAGE_PENDING = exports.MANAGE_PENDING = 'SUBSCRIPTIONS_MANAGE_PENDING';
var MANAGE_DONE = exports.MANAGE_DONE = 'SUBSCRIPTIONS_MANAGE_DONE';

/***/ }),

/***/ "./app/actions/support.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_REFERRAL_PAGE = exports.SET_REFERRAL_PAGE = 'SET_REFERRAL_PAGE';
var SET_REFERRAL_INFO = exports.SET_REFERRAL_INFO = 'SET_REFERRAL_INFO';
var PAYMENT_REQUEST_ATTEMPT = exports.PAYMENT_REQUEST_ATTEMPT = 'PAYMENT_REQUEST_ATTEMPT';
var PAYPAL_REQUEST = exports.PAYPAL_REQUEST = 'PAYPAL_REQUEST';

/***/ }),

/***/ "./app/api/account-api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCreateAccountPage = exports.createAccount = undefined;

var _account = __webpack_require__("./app/actions/account.js");

var actions = _interopRequireWildcard(_account);

var _contentfulClient = __webpack_require__("./app/api/contentful-client.js");

var client = _interopRequireWildcard(_contentfulClient);

var _strings = __webpack_require__("./app/strings.js");

var _reduxForm = __webpack_require__("./node_modules/redux-form/es/index.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function validationErrors(err) {
  var data = err.data;

  var _ref = data || {},
      errors = _ref.errors;
  // If there was an error with the email address, return the data block and
  // let the reducer show a special alert to the user with extended instructions


  if (errors.email) {
    return data;
  }
  throw new _reduxForm.SubmissionError(errors || { _error: _strings.GENERIC_SUBMIT_ERROR });
}

var createAccount = exports.createAccount = function createAccount(values) {
  return {
    promise: function promise(http) {
      return http.post('/user/v1/profile', values).catch(validationErrors);
    },
    events: ['PROMISE_PENDING', actions.CREATE_ACCOUNT, 'PROMISE_ERROR']
  };
};

var fetchCreateAccountPage = exports.fetchCreateAccountPage = function fetchCreateAccountPage() {
  return {
    promise: function promise() {
      return client.getPage('create-account-page');
    },
    events: ['PROMISE_PENDING', actions.SET_CREATE_ACCOUNT_PAGE, 'PROMISE_ERROR']
  };
};

/***/ }),

/***/ "./app/api/account-settings-api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchUserSettingsPage = exports.updateUserPaymentMethod = exports.fetchUserPurchaseHistory = exports.fetchUserPaymentMathods = exports.fetchPendingInvites = exports.toggleMachinesForUser = exports.sendInvites = undefined;

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("./node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reduxForm = __webpack_require__("./node_modules/redux-form/es/index.js");

var _accountSettings = __webpack_require__("./app/actions/account-settings.js");

var actions = _interopRequireWildcard(_accountSettings);

var _contentfulClient = __webpack_require__("./app/api/contentful-client.js");

var client = _interopRequireWildcard(_contentfulClient);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sendInvites = exports.sendInvites = function sendInvites(values, afterComplete) {
  return {
    promise: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(http) {
        var emails, machineInvitations, result;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                emails = values.email.split(',').map(function (e) {
                  return e.trim();
                });
                machineInvitations = (0, _lodash2.default)(emails).map(function (email) {
                  return values.machines.map(function (machine) {
                    return {
                      email: email,
                      machine_serial: machine.serial,
                      machine_name: machine.machineName,
                      roles: machine.roles,
                      grants: machine.grants };
                  });
                }).flatten().value();
                _context.next = 4;
                return http.post('/user/v1/machine_invitations', { machine_invitations: machineInvitations });

              case 4:
                result = _context.sent;


                if (afterComplete) afterComplete(result);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined);
      }));

      return function promise(_x) {
        return _ref.apply(this, arguments);
      };
    }(),
    events: ['PROMISE_PENDING', actions.SET_INVITES_SENT, actions.SET_INVITE_ERROR]
  };
};

var toggleMachinesForUser = exports.toggleMachinesForUser = function toggleMachinesForUser(email, machines, initialMachines, afterComplete) {
  var serializeMachine = function serializeMachine(m) {
    return {
      email: email,
      machine_id: m.serial,
      machine_name: m.machineName,
      roles: m.roles
    };
  };
  var updatedMachines = _lodash2.default.map(machines, serializeMachine);
  var originalMachines = _lodash2.default.map(initialMachines, serializeMachine);

  // Add machines when there is a new serial
  var addedMachines = _lodash2.default.differenceBy(updatedMachines, originalMachines, function (m) {
    return m.machine_id;
  });
  // Remove machines only when the serial doesn't exist at all in the new list
  var removedMachines = _lodash2.default.differenceBy(originalMachines, updatedMachines, function (m) {
    return m.machine_id;
  });
  // Modify machines when an existing serial has a change in values
  // final machines
  // - identical to initial machines
  // - newly added machines
  // = modified machines
  var modifiedMachines = _lodash2.default.differenceBy(_lodash2.default.differenceWith(updatedMachines, originalMachines, _lodash2.default.isEqual), addedMachines, function (m) {
    return m.machine_id;
  });

  return {
    promise: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(http) {
        var calls, invitations;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                calls = [];

                if (!_lodash2.default.isEmpty(addedMachines)) {
                  // Re-key machine_id to machine_serial
                  invitations = _lodash2.default.map(addedMachines, function (m) {
                    var invitationMachine = (0, _extends3.default)({}, m, {
                      machine_serial: m.machine_id
                    });
                    delete invitationMachine.machine_id;
                    return invitationMachine;
                  });

                  calls.push(http.post('/user/v1/machine_invitations', { machine_invitations: invitations }));
                }

                if (_lodash2.default.isEmpty(removedMachines)) {
                  _context2.next = 8;
                  break;
                }

                _context2.t0 = calls;
                _context2.next = 6;
                return http.post('/gfcore/users/remove_machine_access', { machine_users: removedMachines });

              case 6:
                _context2.t1 = _context2.sent;

                _context2.t0.push.call(_context2.t0, _context2.t1);

              case 8:
                if (_lodash2.default.isEmpty(modifiedMachines)) {
                  _context2.next = 14;
                  break;
                }

                _context2.t2 = calls;
                _context2.next = 12;
                return http.post('/gfcore/users/modify_machine_access', { machine_users: modifiedMachines });

              case 12:
                _context2.t3 = _context2.sent;

                _context2.t2.push.call(_context2.t2, _context2.t3);

              case 14:
                _context2.next = 16;
                return _promise2.default.all(calls);

              case 16:

                afterComplete();

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, undefined);
      }));

      return function promise(_x2) {
        return _ref2.apply(this, arguments);
      };
    }(),
    events: ['PROMISE_PENDING', actions.SET_ACCESS_UPDATED, actions.SET_ACCESS_UPDATED_ERROR]
  };
};

var fetchPendingInvites = exports.fetchPendingInvites = function fetchPendingInvites() {
  return {
    promise: function promise(http) {
      return http.get('/user/v1/machine_invitations');
    },
    events: ['PROMISE_PENDING', actions.SET_PENDING_INVITES, 'PROMISE_ERROR']
  };
};

var fetchUserPaymentMathods = exports.fetchUserPaymentMathods = function fetchUserPaymentMathods() {
  return {
    promise: function promise(http) {
      return http.get('/storefront/api/payment_methods');
    },
    events: ['PROMISE_PENDING', actions.SET_USER_PAYMENT_METHODS, 'PROMISE_ERROR']
  };
};

var fetchUserPurchaseHistory = exports.fetchUserPurchaseHistory = function fetchUserPurchaseHistory() {
  return {
    promise: function promise(http) {
      return http.get('/base://storefront/api/orders');
    },
    events: ['PROMISE_PENDING', actions.SET_USER_PURCHASE_HISTORY, 'PROMISE_ERROR']
  };
};

var updateUserPaymentMethod = exports.updateUserPaymentMethod = function updateUserPaymentMethod(values) {
  return {
    promise: function promise(http) {
      return http.put('/storefront/api/users/current', values).then(function (results) {
        if (_lodash2.default.get(results, 'status') === 'error') {
          var ccSubmitError = void 0;
          if (_lodash2.default.get(results, 'errors.credit_card.base')) {
            // General Credit Card error
            ccSubmitError = _lodash2.default.get(results, 'errors.credit_card.base')[0];
          } else {
            ccSubmitError = 'There was an issue with your submission. Please try again later.';
          }
          throw new _reduxForm.SubmissionError({ _error: ccSubmitError });
        }

        return results;
      });
    },
    events: ['PROMISE_PENDING', actions.UPDATE_CREDIT_CARD, actions.UPDATE_CREDIT_CARD_ERROR]
  };
};

var fetchUserSettingsPage = exports.fetchUserSettingsPage = function fetchUserSettingsPage() {
  return {
    promise: function promise() {
      return client.getPage('user-account-settings');
    },
    events: ['PROMISE_PENDING', actions.SET_SETTINGS_PAGE, 'PROMISE_ERROR']
  };
};

/***/ }),

/***/ "./app/api/contentful-client.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextString = exports.getGlowforgeComparisonChart = exports.getDefaultMetadata = exports.getGlobalFooter = exports.getLegalPages = exports.getStandalonePageBySlug = exports.getPage = undefined;

var _contentful = __webpack_require__("./node_modules/contentful/dist/es-modules/contentful.js");

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _routeConstants = __webpack_require__("./app/route-constants.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getContentfulGlobalFooterProps = _uiCommon.contentfulModels.getContentfulGlobalFooterProps;


var contentfulClient = void 0;

function initClient(credentials) {
  contentfulClient = (0, _contentful.createClient)(credentials);
  return contentfulClient.getSpace().then(function (contentfulSpace) {
    return contentfulSpace;
  });
}

function getContentfulClient() {
  if (!contentfulClient) {
    initClient(sharedEnv.CONTENTFUL_CLIENT_CONFIG);
  }
  return contentfulClient;
}

function unpackPages(entries) {
  if (!entries.items || entries.items.length === 0) {
    throw new Error(_routeConstants.COMMON.PAGE_ERRORS.PAGE_NOT_FOUND);
  }
  return entries.items;
}

/**
 * Normalizes the data returned from Contentful for an entry representing a single page.
 * @param {Object} entries Contentful Entry objects
 */
function unpackPage(entries) {
  return unpackPages(entries)[0];
}

var getPage = exports.getPage = function getPage(id) {
  return getContentfulClient().getEntries({
    include: 4,
    content_type: 'page',
    'fields.id': id
  }).then(unpackPage);
};

var getStandalonePageBySlug = exports.getStandalonePageBySlug = function getStandalonePageBySlug(slug) {
  return getContentfulClient().getEntries({
    include: 4,
    content_type: 'page',
    'fields.slug': slug
  }).then(function (entries) {
    // Contentful client doesn't support filtering for more than one content type
    var page = unpackPage(entries);
    if (_lodash2.default.get(page, 'fields.pageType') !== 'standalone') {
      throw new Error(_routeConstants.COMMON.PAGE_ERRORS.PAGE_NOT_FOUND);
    }
    return page;
  });
};

// TODO: Figure out how to do individual calls
var getLegalPages = exports.getLegalPages = function getLegalPages() {
  return getContentfulClient().getEntries({
    include: 1,
    content_type: 'legalPage'
  }).then(unpackPages);
};

var getGlobalFooter = exports.getGlobalFooter = function getGlobalFooter() {
  return getContentfulClient().getEntries({
    include: 4,
    content_type: 'section',
    'fields.id': 'global-footer'
  }).then(function (entries) {
    return entries.items.length ? entries.items[0] : {};
  }).then(function (result) {
    return getContentfulGlobalFooterProps(result);
  });
};

var getDefaultMetadata = exports.getDefaultMetadata = function getDefaultMetadata() {
  return getContentfulClient().getEntries({
    include: 4,
    content_type: 'pageMetadata',
    'fields.id': 'default-metadata'
  }).then(function (entries) {
    return entries.items.length ? entries.items[0] : {};
  });
};

var getGlowforgeComparisonChart = exports.getGlowforgeComparisonChart = function getGlowforgeComparisonChart() {
  return getContentfulClient().getEntries({
    include: 2,
    content_type: 'glowforgeComparisonChart',
    'fields.lookupId': 'glowforgeFamilyComparisonChart'
  }).then(unpackPage);
};

var getTextString = exports.getTextString = function getTextString(id) {
  return getContentfulClient().getEntries({
    include: 1,
    content_type: 'textString',
    'fields.id': id
  }).then(unpackPage);
};

/***/ }),

/***/ "./app/api/landing-api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchProjectPics = exports.fetchGlowforgeLandingPage = undefined;

var _regenerator = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("./node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _contentfulClient = __webpack_require__("./app/api/contentful-client.js");

var client = _interopRequireWildcard(_contentfulClient);

var _landing = __webpack_require__("./app/actions/landing.js");

var actions = _interopRequireWildcard(_landing);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchGlowforgeLandingPage = exports.fetchGlowforgeLandingPage = function fetchGlowforgeLandingPage() {
  return {
    promise: function promise() {
      return client.getPage('glowforge-landing-page');
    },
    events: ['PROMISE_PENDING', actions.SET_GLOWFORGE_LANDING_PAGE, 'PROMISE_ERROR']
  };
};

var fetchProjectPics = exports.fetchProjectPics = function fetchProjectPics(albumName) {
  return {
    promise: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(http) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', http.get('/storefront/api/yotpo_album?album_name=' + albumName));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined);
      }));

      return function promise(_x) {
        return _ref.apply(this, arguments);
      };
    }(),
    events: ['PROMISE_PENDING', actions.SET_PROJECT_PICS, 'PROMISE_ERROR']
  };
};

/***/ }),

/***/ "./app/api/legal-api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.acceptTermsAndConditions = exports.fetchToSPage = undefined;

var _regenerator = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("./node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _legal = __webpack_require__("./app/actions/legal.js");

var actions = _interopRequireWildcard(_legal);

var _contentfulClient = __webpack_require__("./app/api/contentful-client.js");

var client = _interopRequireWildcard(_contentfulClient);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchToSPage = exports.fetchToSPage = function fetchToSPage(query) {
  return {
    promise: function promise() {
      return client.getLegalPages(query);
    },
    events: ['PROMISE_PENDING', actions.SET_TOS_PAGE, 'PROMISE_ERROR']
  };
};

var acceptTermsAndConditions = exports.acceptTermsAndConditions = function acceptTermsAndConditions(termsVersion) {
  return {
    promise: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(http) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', http.post('/gfcore/users/accept_terms_of_service?minor_version=' + termsVersion));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined);
      }));

      return function promise(_x) {
        return _ref.apply(this, arguments);
      };
    }(),
    events: ['PROMISE_PENDING', actions.TERMS_ACCEPTED, 'PROMISE_ERROR']
  };
};

/***/ }),

/***/ "./app/api/marketing-api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _marketing = __webpack_require__("./app/actions/marketing.js");

var actions = _interopRequireWildcard(_marketing);

var _contentfulClient = __webpack_require__("./app/api/contentful-client.js");

var client = _interopRequireWildcard(_contentfulClient);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var fetchMarketingPage = function fetchMarketingPage(slug) {
  return {
    promise: function promise() {
      return client.getStandalonePageBySlug(slug);
    },
    events: ['PROMISE_PENDING', actions.SET_MARKETING_PAGE, 'PROMISE_ERROR']
  };
};

exports.default = fetchMarketingPage;

/***/ }),

/***/ "./app/api/onboarding-api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nameMachine = exports.fetchOnboardingFinishPage = exports.fetchGlowforgeNamePage = exports.fetchUnboxingPage = exports.fetchInstructionsPage = exports.fetchSelectPage = undefined;

var _regenerator = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("./node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _onboarding = __webpack_require__("./app/actions/onboarding.js");

var actions = _interopRequireWildcard(_onboarding);

var _contentfulClient = __webpack_require__("./app/api/contentful-client.js");

var client = _interopRequireWildcard(_contentfulClient);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchSelectPage = exports.fetchSelectPage = function fetchSelectPage() {
  return {
    promise: function promise() {
      return client.getPage('onboarding-select');
    },
    events: ['PROMISE_PENDING', actions.SET_SELECT_PAGE, 'PROMISE_ERROR']
  };
};

var fetchInstructionsPage = exports.fetchInstructionsPage = function fetchInstructionsPage() {
  return {
    promise: function promise() {
      return client.getPage('onboarding-instructions');
    },
    events: ['PROMISE_PENDING', actions.SET_INSTRUCTIONS_PAGE, 'PROMISE_ERROR']
  };
};

var fetchUnboxingPage = exports.fetchUnboxingPage = function fetchUnboxingPage() {
  return {
    promise: function promise() {
      return client.getPage('onboarding-unboxing');
    },
    events: ['PROMISE_PENDING', actions.SET_UNBOXING_PAGE, 'PROMISE_ERROR']
  };
};

var fetchGlowforgeNamePage = exports.fetchGlowforgeNamePage = function fetchGlowforgeNamePage() {
  return {
    promise: function promise() {
      return client.getPage('onboarding-machine-naming');
    },
    events: ['PROMISE_PENDING', actions.SET_GLOWFORGE_NAME_PAGE, 'PROMISE_ERROR']
  };
};

var fetchOnboardingFinishPage = exports.fetchOnboardingFinishPage = function fetchOnboardingFinishPage() {
  return {
    promise: function promise() {
      return client.getPage('onboarding-finish-page');
    },
    events: ['PROMISE_PENDING', actions.SET_ONBOARDING_FINISH_PAGE, 'PROMISE_ERROR']
  };
};

var nameMachine = exports.nameMachine = function nameMachine(serial, name) {
  return {
    promise: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(http) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', http.post('/gfcore/users/machines/' + serial + '/set_name', { name: name }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined);
      }));

      return function promise(_x) {
        return _ref.apply(this, arguments);
      };
    }(),
    events: ['PROMISE_PENDING', actions.SET_GLOWFORGE_NAMED, 'PROMISE_ERROR']
  };
};

/***/ }),

/***/ "./app/api/subscriptions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.manageSubscription = exports.removeUserAsMember = exports.addUserAsMember = exports.fetchSubscriptionUsers = exports.fetchSubscriptionsStatus = undefined;

var _regenerator = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("./node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _subscriptions = __webpack_require__("./app/actions/subscriptions.js");

var actions = _interopRequireWildcard(_subscriptions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BASE_URL = '/ecom/api/v1/';

var fetchSubscriptionsStatus = exports.fetchSubscriptionsStatus = function fetchSubscriptionsStatus() {
  return {
    promise: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(http) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', http.get(BASE_URL + 'subscriptions/current'));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined);
      }));

      return function promise(_x) {
        return _ref.apply(this, arguments);
      };
    }(),
    events: [actions.LOADING_SUBSCRIPTIONS, actions.SET_SUBSCRIPTIONS_STATUS, 'PROMISE_ERROR']
  };
};

// TODO: how to make this ignore errors?
var fetchSubscriptionUsers = exports.fetchSubscriptionUsers = function fetchSubscriptionUsers() {
  return {
    promise: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(http) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', http.get(BASE_URL + 'subscriptions/current/added_users'));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, undefined);
      }));

      return function promise(_x2) {
        return _ref2.apply(this, arguments);
      };
    }(),
    events: [actions.RELOADING_SUBSCRIPTIONS, actions.SET_SUBSCRIPTIONS_USERS, 'PROMISE_ERROR']
  };
};

var addedUserUrl = function addedUserUrl(id) {
  return BASE_URL + 'subscriptions/' + id + '/added_users';
};

var addUserAsMember = exports.addUserAsMember = function addUserAsMember(id, email, afterComplete) {
  return {
    promise: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(http) {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return http.post(addedUserUrl(id), { secondary_user_email: email });

              case 2:
                afterComplete();

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, undefined);
      }));

      return function promise(_x3) {
        return _ref3.apply(this, arguments);
      };
    }(),
    events: [actions.RELOADING_SUBSCRIPTIONS, actions.SUBSCRIPTIONS_USER_ADDED, 'PROMISE_ERROR']
  };
};

var removeUserAsMember = exports.removeUserAsMember = function removeUserAsMember(id, addedUserId, afterComplete) {
  return {
    promise: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(http) {
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return http.delete(addedUserUrl(id) + '/' + addedUserId);

              case 2:
                afterComplete();

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, undefined);
      }));

      return function promise(_x4) {
        return _ref4.apply(this, arguments);
      };
    }(),
    events: [actions.RELOADING_SUBSCRIPTIONS, actions.SUBSCRIPTIONS_USER_REMOVED, 'PROMISE_ERROR']
  };
};

var manageSubscription = exports.manageSubscription = function manageSubscription(url, afterComplete) {
  return {
    promise: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(http) {
        var parsedUrl, result;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // TODO: we parse out the url and assume the pathname is available on the
                // version of gf-ecom this is configured to talk to, instead of just using
                // the full provided link which would be assuming less about what system
                // hosts this operation. But for now this works.
                parsedUrl = new URL(url);
                _context5.next = 3;
                return http.post(parsedUrl.pathname, '');

              case 3:
                result = _context5.sent;

                if (result.url) {
                  afterComplete(result.url);
                }
                // This intentionally does not retry but uses PROMISE_ERROR to cause the
                // user to refresh and try again.

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, undefined);
      }));

      return function promise(_x5) {
        return _ref5.apply(this, arguments);
      };
    }(),
    events: [actions.MANAGE_PENDING, actions.MANAGE_DONE, 'PROMISE_ERROR']
  };
};

/***/ }),

/***/ "./app/api/support-api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestPaymentPaypal = exports.requestPaymentNoAuth = exports.requestPaymentOAuth = exports.fetchReferral = exports.fetchReferralPage = undefined;

var _regenerator = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("./node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _support = __webpack_require__("./app/actions/support.js");

var actions = _interopRequireWildcard(_support);

var _contentfulClient = __webpack_require__("./app/api/contentful-client.js");

var client = _interopRequireWildcard(_contentfulClient);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchReferralPage = exports.fetchReferralPage = function fetchReferralPage() {
  return {
    promise: function promise() {
      return client.getPage('referral-payment-page-rto');
    },
    events: ['PROMISE_PENDING', actions.SET_REFERRAL_PAGE, 'PROMISE_ERROR']
  };
};

var fetchReferral = exports.fetchReferral = function fetchReferral(referralState) {
  return {
    promise: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(http) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', http.get('/storefront/api/referrer?state=' + referralState).then(function (response) {
                  if (_lodash2.default.get(response, 'refereeID') === undefined) {
                    throw { status: 404 }; // eslint-disable-line
                  }
                  return response;
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined);
      }));

      return function promise(_x) {
        return _ref.apply(this, arguments);
      };
    }(),
    events: ['PROMISE_PENDING', actions.SET_REFERRAL_INFO, 'PROMISE_ERROR']
  };
};

var requestPaymentOAuth = exports.requestPaymentOAuth = function requestPaymentOAuth(authCode, referralState) {
  return {
    promise: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(http) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', http.post('/storefront/api/requestPayment', { authCode: authCode, referralState: referralState }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, undefined);
      }));

      return function promise(_x2) {
        return _ref2.apply(this, arguments);
      };
    }(),
    events: ['PROMISE_PENDING', actions.PAYMENT_REQUEST_ATTEMPT, 'PROMISE_ERROR']
  };
};

var requestPaymentNoAuth = exports.requestPaymentNoAuth = function requestPaymentNoAuth(stripeID, referralState) {
  return {
    promise: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(http) {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', http.post('/storefront/api/requestPayment', { stripeID: stripeID, referralState: referralState }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, undefined);
      }));

      return function promise(_x3) {
        return _ref3.apply(this, arguments);
      };
    }(),
    events: ['PROMISE_PENDING', actions.PAYMENT_REQUEST_ATTEMPT, 'PROMISE_ERROR']
  };
};

var requestPaymentPaypal = exports.requestPaymentPaypal = function requestPaymentPaypal(paypalEmail, referralState) {
  return {
    promise: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(http) {
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', http.post('/storefront/api/requestPayment', { paypalEmail: paypalEmail, referralState: referralState }));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, undefined);
      }));

      return function promise(_x4) {
        return _ref4.apply(this, arguments);
      };
    }(),
    events: ['PROMISE_PENDING', actions.PAYPAL_REQUEST, 'PROMISE_ERROR']
  };
};

/***/ }),

/***/ "./app/app-constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var COLOR_MODES = {
  ORANGE: 'orange',
  BRAND: 'BRAND'
};

var ACCOUNT_ACCESS = {
  RESTRICTED: 'Restricted',
  FULL_ACCESS: 'Full Access'
};

exports.COLOR_MODES = COLOR_MODES;
exports.ACCOUNT_ACCESS = ACCOUNT_ACCESS;

/***/ }),

/***/ "./app/common/actions/common.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_NO_GLOWFORGE_PAGE = exports.logError = exports.LOG_ERROR = exports.customPromiseError = exports.customPromiseErrorPayload = exports.CUSTOM_PROMISE_ERROR = exports.promiseError = exports.PROMISE_ERROR = exports.fatalError = exports.FATAL_ERROR = exports.SET_REFERRAL_INFO = exports.SET_EMAIL_CAPTURE_STATUS = exports.validationComplete = exports.VALIDATION_COMPLETE = exports.SET_VALIDATED_POSTAL_INFO = exports.SET_SHIPPING_INFO_ERROR = exports.SET_SHIPPING_INFO_SUCCESS = exports.confirmAddressVerify = exports.CONFIRM_ADDRESS_VERIFY = exports.cancelAddressVerify = exports.CANCEL_ADDRESS_VERIFY = exports.SET_ADDRESS_COUNTRIES = exports.SET_ADDRESS_STATES = exports.MACHINES_LOADING = exports.SET_MACHINES = exports.SET_CATEGORIES = exports.UPDATE_PROFILE_ERROR = exports.UPDATE_PROFILE = exports.UPDATE_USER = exports.SET_DEFAULT_METADATA = exports.SET_COOKIE_NOTIFICATION = exports.GET_COOKIE_NOTIFICATION = exports.SET_GLOBAL_FOOTER = exports.SET_FEATURE_FLAGS = exports.SET_USER = exports.GET_USER = undefined;

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GET_USER = exports.GET_USER = 'GET_USER';
var SET_USER = exports.SET_USER = 'SET_USER';
var SET_FEATURE_FLAGS = exports.SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
var SET_GLOBAL_FOOTER = exports.SET_GLOBAL_FOOTER = 'SET_GLOBAL_FOOTER';
var GET_COOKIE_NOTIFICATION = exports.GET_COOKIE_NOTIFICATION = 'GET_COOKIE_NOTIFICATION';
var SET_COOKIE_NOTIFICATION = exports.SET_COOKIE_NOTIFICATION = 'SET_COOKIE_NOTIFICATION';
var SET_DEFAULT_METADATA = exports.SET_DEFAULT_METADATA = 'SET_DEFAULT_METADATA';
var UPDATE_USER = exports.UPDATE_USER = 'UPDATE_USER';
var UPDATE_PROFILE = exports.UPDATE_PROFILE = 'UPDATE_PROFILE';
var UPDATE_PROFILE_ERROR = exports.UPDATE_PROFILE_ERROR = 'UPDATE_PROFILE_ERROR';
var SET_CATEGORIES = exports.SET_CATEGORIES = 'SET_CATEGORIES';
var SET_MACHINES = exports.SET_MACHINES = 'SET_MACHINES';
var MACHINES_LOADING = exports.MACHINES_LOADING = 'MACHINES_LOADING';
var SET_ADDRESS_STATES = exports.SET_ADDRESS_STATES = 'SET_ADDRESS_STATES';
var SET_ADDRESS_COUNTRIES = exports.SET_ADDRESS_COUNTRIES = 'SET_ADDRESS_COUNTRIES';
var CANCEL_ADDRESS_VERIFY = exports.CANCEL_ADDRESS_VERIFY = 'CANCEL_ADDRESS_VERIFY';
var cancelAddressVerify = exports.cancelAddressVerify = function cancelAddressVerify() {
  return {
    type: CANCEL_ADDRESS_VERIFY
  };
};

var CONFIRM_ADDRESS_VERIFY = exports.CONFIRM_ADDRESS_VERIFY = 'CONFIRM_ADDRESS_VERIFY';
var confirmAddressVerify = exports.confirmAddressVerify = function confirmAddressVerify() {
  return {
    type: CONFIRM_ADDRESS_VERIFY
  };
};

var SET_SHIPPING_INFO_SUCCESS = exports.SET_SHIPPING_INFO_SUCCESS = 'SET_SHIPPING_INFO_SUCCESS';
var SET_SHIPPING_INFO_ERROR = exports.SET_SHIPPING_INFO_ERROR = 'SET_SHIPPING_INFO_ERROR';
var SET_VALIDATED_POSTAL_INFO = exports.SET_VALIDATED_POSTAL_INFO = 'SET_VALIDATED_POSTAL_INFO';
var VALIDATION_COMPLETE = exports.VALIDATION_COMPLETE = 'VALIDATION_COMPLETE';
var validationComplete = exports.validationComplete = function validationComplete() {
  return {
    type: VALIDATION_COMPLETE
  };
};

var SET_EMAIL_CAPTURE_STATUS = exports.SET_EMAIL_CAPTURE_STATUS = 'SET_EMAIL_CAPTURE_STATUS';

var SET_REFERRAL_INFO = exports.SET_REFERRAL_INFO = 'SET_REFERRAL_INFO';

/** ERRORS * */

/** Preload Error Action * */

// Fatal Errors can be shown with this
var FATAL_ERROR = exports.FATAL_ERROR = 'FATAL_ERROR';
var fatalError = exports.fatalError = function fatalError(message, error) {
  return {
    type: FATAL_ERROR,
    message: message,
    error: error
  };
};

// Notice Errors can be shown with this - This puts a notification at the top of the page
// to let user know there was a problem and they should try again.
var PROMISE_ERROR = exports.PROMISE_ERROR = 'PROMISE_ERROR';
var promiseError = exports.promiseError = function promiseError(error) {
  return {
    type: PROMISE_ERROR,
    error: error
  };
};
var CUSTOM_PROMISE_ERROR = exports.CUSTOM_PROMISE_ERROR = 'CUSTOM_PROMISE_ERROR';
var customPromiseErrorPayload = exports.customPromiseErrorPayload = function customPromiseErrorPayload() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : CUSTOM_PROMISE_ERROR;
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return {
    data: _lodash2.default.merge({ type: type }, data),
    message: message,
    status: status
  };
};
var customPromiseError = exports.customPromiseError = function customPromiseError() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : CUSTOM_PROMISE_ERROR;
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return {
    type: PROMISE_ERROR,
    error: customPromiseErrorPayload(message, status, type, data)
  };
};

// Errors can be logged without showing a ui error this way
var LOG_ERROR = exports.LOG_ERROR = 'LOG_ERROR';
var logError = exports.logError = function logError(message) {
  return {
    type: LOG_ERROR,
    message: message
  };
};

var SET_NO_GLOWFORGE_PAGE = exports.SET_NO_GLOWFORGE_PAGE = 'SET_NO_GLOWFORGE_PAGE';

/***/ }),

/***/ "./app/common/api/common-api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchReferral = exports.fetchDefaultMetadata = exports.fetchGlobalFooter = exports.fetchNoGlowforgePage = exports.fetchMachinesForUser = exports.setUserShippingInfo = exports.updateUserProfile = exports.fetchAddressCountries = exports.fetchAddressStates = exports.fetchFeatures = exports.fetchUser = undefined;

var _reduxForm = __webpack_require__("./node_modules/redux-form/es/index.js");

var _strings = __webpack_require__("./app/strings.js");

var _strings2 = _interopRequireDefault(_strings);

var _contentfulClient = __webpack_require__("./app/api/contentful-client.js");

var client = _interopRequireWildcard(_contentfulClient);

var _common = __webpack_require__("./app/common/actions/common.js");

var commonActions = _interopRequireWildcard(_common);

var _common2 = __webpack_require__("./app/common/reducers/common.js");

var _common3 = _interopRequireDefault(_common2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validationErrors(err) {
  var data = err.data;

  var _ref = data || {},
      errors = _ref.errors;

  if (!errors) {
    // no validation data, so log this error to understand why it failed
    console.error(err); // eslint-disable-line no-console
  }
  throw new _reduxForm.SubmissionError(errors || { _error: _strings2.default.GENERIC_SUBMIT_ERROR });
}

var fetchUser = exports.fetchUser = function fetchUser() {
  return {
    promise: function promise(http) {
      return http.get('/user/v1/profile').catch(function () {
        return {};
      });
    },
    events: ['PROMISE_PENDING', commonActions.SET_USER, 'PROMISE_ERROR']
  };
};

var fetchFeatures = exports.fetchFeatures = function fetchFeatures(ip) {
  return {
    promise: function promise(http) {
      return http.get('/storefront/api/features?ip=' + ip).catch(function () {
        return {};
      });
    },
    events: ['PROMISE_PENDING', commonActions.SET_FEATURE_FLAGS, 'PROMISE_ERROR']
  };
};

var fetchAddressStates = exports.fetchAddressStates = function fetchAddressStates(id) {
  var uri = '/storefront/api/states';
  uri += id ? '?country_id=' + id : '';
  return {
    promise: function promise(http) {
      return http.get(uri);
    },
    events: ['PROMISE_PENDING', commonActions.SET_ADDRESS_STATES, 'PROMISE_ERROR']
  };
};

var fetchAddressCountries = exports.fetchAddressCountries = function fetchAddressCountries() {
  return {
    promise: function promise(http) {
      return http.get('/api/countries/?per_page=500');
    },
    events: ['PROMISE_PENDING', commonActions.SET_ADDRESS_COUNTRIES, 'PROMISE_ERROR']
  };
};

var updateUserProfile = exports.updateUserProfile = function updateUserProfile(values) {
  return {
    promise: function promise(http) {
      return http.patch('/user/v1/profile', values).catch(validationErrors);
    },
    events: ['PROMISE_PENDING', commonActions.UPDATE_PROFILE, commonActions.UPDATE_PROFILE_ERROR]
  };
};

var setUserShippingInfo = exports.setUserShippingInfo = function setUserShippingInfo(values) {
  return {
    promise: function promise(http) {
      return http.put('/storefront/api/users/current', values);
    },
    events: ['PROMISE_PENDING', commonActions.SET_SHIPPING_INFO_SUCCESS, commonActions.SET_SHIPPING_INFO_ERROR]
  };
};

var fetchMachinesForUser = exports.fetchMachinesForUser = function fetchMachinesForUser() {
  return {
    promise: function promise(http) {
      return http.get('/gfcore/users/machines.json?include_users=true');
    },
    events: [commonActions.MACHINES_LOADING, commonActions.SET_MACHINES, 'PROMISE_ERROR']
  };
};

var fetchNoGlowforgePage = exports.fetchNoGlowforgePage = function fetchNoGlowforgePage() {
  return {
    promise: function promise() {
      return client.getPage('onboarding-no-glowforge');
    },
    events: ['PROMISE_PENDING', commonActions.SET_NO_GLOWFORGE_PAGE, 'PROMISE_ERROR']
  };
};

var fetchGlobalFooter = exports.fetchGlobalFooter = function fetchGlobalFooter() {
  return {
    promise: function promise() {
      return client.getGlobalFooter();
    },
    events: ['PROMISE_PENDING', commonActions.SET_GLOBAL_FOOTER, 'PROMISE_ERROR']
  };
};

var fetchDefaultMetadata = exports.fetchDefaultMetadata = function fetchDefaultMetadata() {
  return {
    promise: function promise() {
      return client.getDefaultMetadata();
    },
    events: ['PROMISE_PENDING', commonActions.SET_DEFAULT_METADATA, 'PROMISE_ERROR']
  };
};

var fetchReferral = exports.fetchReferral = function fetchReferral(email) {
  return {
    promise: function promise(http) {
      return http.get('/base://storefront/api/referral?email=' + email);
    },
    events: ['PROMISE_PENDING', commonActions.SET_REFERRAL_INFO, 'PROMISE_ERROR']
  };
};

/***/ }),

/***/ "./app/common/components/dialog.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__("./node_modules/react-modal/lib/index.js");

var _reactModal2 = _interopRequireDefault(_reactModal);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

__webpack_require__("./app/common/components/dialog.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VerticalScrollBox = _uiCommon.components.VerticalScrollBox;

// React Modal requires us to register the React root

if (typeof window !== 'undefined') {
  _reactModal2.default.setAppElement(document.querySelector('#react'));
}

var Dialog = function Dialog(_ref) {
  var overlayClassName = _ref.overlayClassName,
      className = _ref.className,
      children = _ref.children,
      title = _ref.title,
      isOpen = _ref.isOpen,
      actionButtons = _ref.actionButtons,
      onRequestClose = _ref.onRequestClose,
      withScrollBox = _ref.withScrollBox,
      showTopRightCloseButton = _ref.showTopRightCloseButton,
      withPadding = _ref.withPadding;

  var content = withScrollBox ? _react2.default.createElement(
    VerticalScrollBox,
    { updateKey: children },
    children
  ) : children;
  var header = title ? _react2.default.createElement(
    'h3',
    { className: 'h3' },
    title
  ) : null;
  var topRightCloseButton = showTopRightCloseButton ? _react2.default.createElement(
    'button',
    { className: 'close-button-top-right', onClick: onRequestClose },
    '\u2715'
  ) : null;

  return _react2.default.createElement(
    _reactModal2.default,
    {
      className: (0, _classnames2.default)('Dialog', className, { withPadding: withPadding }),
      overlayClassName: (0, _classnames2.default)('dialogOverlay', overlayClassName),
      contentLabel: title,
      isOpen: isOpen,
      onRequestClose: onRequestClose },
    topRightCloseButton,
    header,
    content,
    _react2.default.createElement(
      'div',
      { className: 'actionButtons' },
      actionButtons
    )
  );
};

Dialog.propTypes = {
  className: _propTypes2.default.string,
  overlayClassName: _propTypes2.default.string,
  isOpen: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  onRequestClose: _propTypes2.default.func,
  withScrollBox: _propTypes2.default.bool,
  showTopRightCloseButton: _propTypes2.default.bool,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired,
  actionButtons: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  withPadding: _propTypes2.default.bool
};

Dialog.defaultProps = {
  className: '',
  overlayClassName: '',
  isOpen: false,
  title: '',
  onRequestClose: null,
  withScrollBox: true,
  showTopRightCloseButton: false,
  actionButtons: null,
  withPadding: false
};

exports.default = Dialog;

/***/ }),

/***/ "./app/common/components/dialog.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/common/components/error-boundary.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__("./app/common/components/error-boundary.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Generic React error boundary.
 */
var ErrorBoundary = function (_React$Component) {
  (0, _inherits3.default)(ErrorBoundary, _React$Component);

  function ErrorBoundary(props) {
    (0, _classCallCheck3.default)(this, ErrorBoundary);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ErrorBoundary.__proto__ || (0, _getPrototypeOf2.default)(ErrorBoundary)).call(this, props));

    _this.onClick = function () {
      location.reload();
    };

    _this.state = { hasError: false };
    return _this;
  }

  (0, _createClass3.default)(ErrorBoundary, [{
    key: 'componentDidCatch',


    // eslint-disable-next-line class-methods-use-this
    value: function componentDidCatch(error) {
      // Log to newrelic
      if (_lodash2.default.has(window, 'newrelic.noticeError')) {
        window.newrelic.noticeError(error, {
          errorType: 'Error Boundary'
        });
      }
    }

    /**
     * Browswer refresh page onClick
     */

  }, {
    key: 'render',
    value: function render() {
      if (this.state.hasError) {
        return _react2.default.createElement(
          'div',
          { className: 'errorBoundary' },
          _react2.default.createElement(
            'p',
            null,
            'Uh oh, something went wrong. Please',
            _react2.default.createElement(
              'button',
              { className: 'button text reloadButton', href: '#', onClick: this.onClick },
              'reload the page.'
            )
          )
        );
      }

      return this.props.children;
    }
  }], [{
    key: 'getDerivedStateFromError',
    value: function getDerivedStateFromError() {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }
  }]);
  return ErrorBoundary;
}(_react2.default.Component);

ErrorBoundary.propTypes = {
  children: _propTypes2.default.node
};
ErrorBoundary.defaultProps = {
  children: null
};
exports.default = ErrorBoundary;

/***/ }),

/***/ "./app/common/components/error-boundary.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/common/components/features-display/features-display-widget.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _featuresDisplay = __webpack_require__("./app/common/components/features-display/features-display.jsx");

var _featuresDisplay2 = _interopRequireDefault(_featuresDisplay);

__webpack_require__("./app/common/components/features-display/features-display.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var widgetDefaultProps = _uiCommon.contentfulModels.widgetDefaultProps,
    widgetPropType = _uiCommon.contentfulModels.widgetPropType;

// Used to map Contentful content to this custom widget.  See ui-common/contentful-widgets/

var FeaturesDisplayWidget = function FeaturesDisplayWidget(_ref) {
  var sections = _ref.sections,
      model = _ref.model;

  var displayTitle = _lodash2.default.get(model, 'textStrings.revolutionary-title');
  var seeMoreText = _lodash2.default.get(model, 'textStrings.media-card-swipe-to-see-more');
  var features = _lodash2.default.map(sections, function (_ref2) {
    var _ref2$fields = _ref2.fields,
        title = _ref2$fields.title,
        text = _ref2$fields.text,
        images = _ref2$fields.images;
    return {
      title: title,
      text: text,
      media: images[0]
    };
  });
  return _react2.default.createElement(_featuresDisplay2.default, { title: displayTitle, seeMoreText: seeMoreText, features: features });
};

FeaturesDisplayWidget.propTypes = widgetPropType;

FeaturesDisplayWidget.defaultProps = widgetDefaultProps;

exports.default = FeaturesDisplayWidget;

/***/ }),

/***/ "./app/common/components/features-display/features-display.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

__webpack_require__("./app/common/components/features-display/features-display.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Image = _uiCommon.contentfulViews.Image;
var Button = _uiCommon.components.Button,
    Markdown = _uiCommon.components.Markdown,
    HorizontalScroll = _uiCommon.components.HorizontalScroll;

/**
 * FeaturesDisplay component. Ported from legacy homepage.
 * Shows a 'hero' card above a grid of buttons on desktop.
 * Shows a HorizontalScroll list of the same cards on mobile.
 *
 * @param title -
 * @param seeMoreText -
 * @param features - An array of Objects of:
 *    {
 *      title: String for object title
 *      text: String for object description
 *      media: Object representing Contentful Media type, passed to Image
 *    }
 */

var FeaturesDisplay = function (_React$Component) {
  (0, _inherits3.default)(FeaturesDisplay, _React$Component);

  function FeaturesDisplay(props) {
    (0, _classCallCheck3.default)(this, FeaturesDisplay);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FeaturesDisplay.__proto__ || (0, _getPrototypeOf2.default)(FeaturesDisplay)).call(this, props));

    _this.onClick = function (index) {
      return function () {
        _this.setState({ selectedIndex: index });
      };
    };

    _this.state = {
      selectedIndex: 0
    };
    return _this;
  }

  // Thunked function. Binds 'index' to specific buttons
  // by returning function bound to index passed.


  (0, _createClass3.default)(FeaturesDisplay, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          features = _props.features,
          seeMoreText = _props.seeMoreText,
          displayTitle = _props.title;
      var selectedIndex = this.state.selectedIndex;

      // Button Grid
      // If selected, then that button is disabled.

      var buttons = _lodash2.default.map(features, function (_ref, index) {
        var buttonTitle = _ref.title;
        return _react2.default.createElement(
          Button,
          {
            key: buttonTitle,
            type: 'secondary',
            disabled: index === selectedIndex,
            onClick: _this2.onClick(index) },
          buttonTitle
        );
      });

      // Cards array
      // Used on desktop to show each card based on index.
      // Used on mobile to show HorizontalList of cards
      var cards = _lodash2.default.map(features, function (_ref2) {
        var title = _ref2.title,
            media = _ref2.media,
            text = _ref2.text;
        return _react2.default.createElement(
          'div',
          { className: 'featureCard', key: title },
          _react2.default.createElement(
            'div',
            { className: 'image' },
            _react2.default.createElement(Image, { className: 'src', media: media })
          ),
          _react2.default.createElement(
            'div',
            { className: 'content' },
            _react2.default.createElement(
              'h3',
              { className: 'title' },
              title
            ),
            _react2.default.createElement(Markdown, { source: text })
          )
        );
      });

      // The 'hero' card to display
      var selectedFeature = cards[selectedIndex];
      return _react2.default.createElement(
        'div',
        { className: 'FeaturesDisplay' },
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement(
            'h2',
            { className: 'displayTitle' },
            displayTitle
          ),
          _react2.default.createElement(
            'div',
            { className: 'selectedFeature' },
            selectedFeature
          ),
          _react2.default.createElement(
            'div',
            { className: 'featuresGrid' },
            buttons
          ),
          _react2.default.createElement(
            'div',
            { className: 'featureCards' },
            _react2.default.createElement(
              HorizontalScroll,
              null,
              cards
            ),
            _react2.default.createElement(
              'span',
              { className: 'seeMore' },
              seeMoreText
            )
          )
        )
      );
    }
  }]);
  return FeaturesDisplay;
}(_react2.default.Component);

FeaturesDisplay.propTypes = {
  title: _propTypes2.default.string,
  seeMoreText: _propTypes2.default.node,
  features: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    title: _propTypes2.default.string,
    text: _propTypes2.default.string,
    media: _propTypes2.default.shape({})
  }))
};

FeaturesDisplay.defaultProps = {
  title: null,
  seeMoreText: null,
  features: []
};

exports.default = FeaturesDisplay;

/***/ }),

/***/ "./app/common/components/features-display/features-display.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/common/components/features-display/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _featuresDisplay = __webpack_require__("./app/common/components/features-display/features-display.jsx");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_featuresDisplay).default;
  }
});

var _featuresDisplayWidget = __webpack_require__("./app/common/components/features-display/features-display-widget.jsx");

Object.defineProperty(exports, 'FeaturesDisplayWidget', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_featuresDisplayWidget).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./app/common/components/forms/phone-number.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactTextMask = __webpack_require__("./node_modules/react-text-mask/dist/reactTextMask.js");

var _reactTextMask2 = _interopRequireDefault(_reactTextMask);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormField = _uiCommon.components.FormField;


var PhoneNumber = function PhoneNumber(props) {
  var input = props.input,
      meta = props.meta,
      infoText = props.infoText,
      otherProps = (0, _objectWithoutProperties3.default)(props, ['input', 'meta', 'infoText']); // eslint-disable-line no-unused-vars

  return _react2.default.createElement(
    FormField,
    props,
    _react2.default.createElement(_reactTextMask2.default, (0, _extends3.default)({
      mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
      guide: false,
      type: 'text'
    }, otherProps, input))
  );
};

PhoneNumber.propTypes = {
  placeholder: _propTypes2.default.string,
  infoText: _propTypes2.default.string,
  input: _propTypes2.default.object, // eslint-disable-line
  meta: _propTypes2.default.object // eslint-disable-line
};

PhoneNumber.defaultProps = {
  placeholder: null,
  infoText: null
};

exports.default = PhoneNumber;

/***/ }),

/***/ "./app/common/components/forms/submit-actions.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

__webpack_require__("./app/common/components/forms/submit-actions.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = _uiCommon.components.Button;


var SubmitActions = function SubmitActions(props) {
  // TODO: Fix all uses of userSubmitError to use SubmissionError error
  // Do not show error if form is submitting
  var err = !props.submitting && (props.error || props.userSubmitError);
  var actionClasses = (0, _classnames2.default)('SubmitActions', {
    submitting: props.submitting,
    submitSucceeded: !props.submitting && props.submitSucceeded && !err,
    error: !props.submitting && err
  });

  var cancelButton = props.onCancel && !props.submitting && !props.submitSucceeded ? _react2.default.createElement(
    Button,
    { type: 'text', onClick: props.onCancel },
    'cancel'
  ) : null;

  return _react2.default.createElement(
    'div',
    { className: actionClasses },
    _react2.default.createElement(
      'div',
      { className: 'saving' },
      props.inProgressMessage
    ),
    _react2.default.createElement(
      'div',
      { className: 'saved' },
      props.successMessage
    ),
    _react2.default.createElement(
      'div',
      { className: 'errorMessage' },
      err
    ),
    cancelButton,
    _react2.default.createElement(
      Button,
      {
        isSubmit: true,
        className: props.submitClass,
        disabled: props.disabled || props.submitting },
      props.submitText
    )
  );
};

SubmitActions.propTypes = {
  submitText: _propTypes2.default.string,
  successMessage: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  inProgressMessage: _propTypes2.default.string,
  submitClass: _propTypes2.default.string,
  submitting: _propTypes2.default.bool,
  submitSucceeded: _propTypes2.default.bool,
  userSubmitError: _propTypes2.default.string,
  error: _propTypes2.default.string,
  onCancel: _propTypes2.default.func
};

SubmitActions.defaultProps = {
  error: null,
  userSubmitError: null,
  submitText: 'Save Changes',
  successMessage: 'Saved!',
  disabled: false,
  inProgressMessage: 'Saving...',
  onCancel: null,
  submitClass: null,
  submitSucceeded: false,
  submitting: false
};

exports.default = SubmitActions;

/***/ }),

/***/ "./app/common/components/forms/submit-actions.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/common/components/global-footer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _navigationItem = __webpack_require__("./app/common/components/navigation/navigation-item.jsx");

var _navigationItem2 = _interopRequireDefault(_navigationItem);

__webpack_require__("./app/common/components/global-footer.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = _uiCommon.components.Footer;


var GlobalFooter = function GlobalFooter(_ref) {
  var globalFooterLinks = _ref.globalFooterLinks,
      globalFooterLogo = _ref.globalFooterLogo,
      globalFooterCopyright = _ref.globalFooterCopyright,
      globalFooterAddress = _ref.globalFooterAddress;
  return _react2.default.createElement(Footer, {
    NavigationItem: _navigationItem2.default,
    globalFooterLinks: globalFooterLinks,
    globalFooterLogo: globalFooterLogo,
    globalFooterCopyright: globalFooterCopyright,
    globalFooterAddress: globalFooterAddress });
};

GlobalFooter.propTypes = Footer.propTypes;

exports.default = GlobalFooter;

/***/ }),

/***/ "./app/common/components/global-footer.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/common/components/link.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRouter = __webpack_require__("./node_modules/react-router/es/index.js");

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Because React-Isomorphic-Render will ignore preloading if you double click a link,
 * we have to prevent links from being double clicked.  We use withRouter to detect location
 * changes and re-enable a link once the route changes.
 *
 * TODO: STORE-3159 This works for an individual link,
 * but we need to account for the case of two links
 */
var BetterLink = function (_React$Component) {
  (0, _inherits3.default)(BetterLink, _React$Component);

  function BetterLink(props) {
    (0, _classCallCheck3.default)(this, BetterLink);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BetterLink.__proto__ || (0, _getPrototypeOf2.default)(BetterLink)).call(this, props));

    _this.onClick = function (event) {
      if (_this.state.clicked) {
        event.preventDefault();
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();
      } else {
        _this.props.onClick(event);
        _this.setState({
          clicked: true
        });
      }
    };

    _this.state = {
      clicked: false,
      prevPathname: props.location.pathname
    };
    return _this;
  }

  /**
   * Invalidate click prevention.  When route changes, we can safely click again
   */


  (0, _createClass3.default)(BetterLink, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var LinkElement = _reactIsomorphicRender.Link;
      // Remove react-isomorphic link so it doesn't even attempt to not preload/navigate prematurely
      if (this.state.clicked) {
        LinkElement = function LinkElement() {
          return _react2.default.createElement(
            'a',
            (0, _extends3.default)({}, _this2.props, { href: _this2.props.to, onClick: _this2.onClick }),
            _this2.props.children
          );
        };
      }
      return _react2.default.createElement(
        LinkElement,
        (0, _extends3.default)({}, this.props, { onClick: this.onClick }),
        _react2.default.createElement(
          'span',
          null,
          this.props.children
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if (props.location.pathname !== state.prevPathname) {
        return {
          clicked: false,
          prevPathname: props.location.pathname
        };
      }
      return null;
    }

    /**
     * Prevent react-ismorphic double-clicks.
     */

  }]);
  return BetterLink;
}(_react2.default.Component);

BetterLink.propTypes = {
  location: _propTypes2.default.shape({ pathname: _propTypes2.default.string }),
  onClick: _propTypes2.default.func,
  to: _propTypes2.default.string,
  children: _propTypes2.default.node
};
BetterLink.defaultProps = {
  location: {},
  onClick: _lodash2.default.noop,
  to: null,
  children: null
};
exports.default = (0, _reactRouter.withRouter)(BetterLink);

/***/ }),

/***/ "./app/common/components/navigation/config.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNavigationTabs = exports.getMarketingRoutes = exports.getAppRoutes = exports.userSecondaryLinks = exports.userRoutes = exports.marketingRoutes = exports.separator = undefined;

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _routeConstants = __webpack_require__("./app/route-constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Navigation Configuration
 * 
 * This file defines the tab/route configuration for the top level
 * navbar across Glowforge settings.
 *
 * There are three Navigations:
 * Marketing (glowforge.com) (Being moved to dotcom repo)
 * Settings (glowforge.com/settings) Unrestricted version
 * Settings (glowforge.com/settings) Restricted version
 * 
 * The Nav bar itself is split in to two parts: top level routes and
 * user routes. On desktop these are distinct menus, but on mobile
 * they are in the same drop down.
 *
 * --------------------------------------------------------------------
 * Feature flags and route-constants:
 *
 * We get constants/flags from three places:
 *  1. app/route-constants.js
 *  2. sharedEnv object defined globally/window
 *  3. Feature flags passed by the backend through api call to /storefront/api/features
 *     These flags come from flip-flop or launchdarkly. See app/common/api/common-api.js
 *
 * --------------------------------------------------------------------
 * Using this config:
 *
 * This file contains configurations objects for routes, and getters
 * for selecting and ordering of routes.
 *
 * Individual tab/route config objects are of the following structure:
 * {
 *   @param {boolean}   local    Whether the route exists within our app. Used to determine whether
 *                            to use React Router <Link /> (can't be an external link) or <a />
 *   @param {string} text     Link text
 *   @param {string} url      relative url if local link, absolute/relative if external
 *   @param {boolean}   disabled If false, the route is visible.
 *   @param {boolean}   openInNewTab If !local, Should we open in a new window? Uses target="_blank"
 *   @param {boolean}   mobileOnly Only render the route on mobile devices/screen widths,
 *                              used for displaying the user menu in the mobile dropdown.
 * }
 */

/**
 * Separator tab
 * Defines where a visual separation should occur in the nav.
 */
var separator = exports.separator = {
  separator: true,
  mobileOnly: true
};

/**
 * Defines navigation routes (tabs) for the Marketing navbar
 */
var marketingRoutes = exports.marketingRoutes = {
  home: {
    local: false,
    text: 'Home',
    url: _routeConstants.GLOWFORGE_LANDING_PAGE.BASE_URI
  },
  products: {
    local: false,
    text: 'Products',
    url: _routeConstants.SHOP.BASE_PRODUCT_URL
  },
  community: {
    local: false,
    text: 'Community',
    url: 'https://community.glowforge.com'
  }
};

/**
 * User menu routes.
 */
var userRoutes = exports.userRoutes = {
  referrals: {
    local: false,
    text: 'Referrals',
    url: 'https://glowforge.com/b/refer-a-friend'
  },
  login: {
    local: false,
    text: 'Sign in',
    url: '' + (typeof sharedEnv === 'undefined' ? '' : sharedEnv.AUTH_SERVER) + _routeConstants.LOGIN.BASE_URI
  }
};

/**
 * Secondary links for user menu.
 */
var userSecondaryLinks = exports.userSecondaryLinks = [(0, _extends3.default)({}, userRoutes.referrals)];

/**
 * @param {Object} features These are feature flags passed by the backend.
 *                          They either come from flip-flop or launchdarkly.
 */
var getAppRoutes = exports.getAppRoutes = function getAppRoutes(_ref) {
  var OLD_SHOP = _ref.OLD_SHOP,
      OLD_CATALOG = _ref.OLD_CATALOG,
      SUPPORT_PAGE_ENABLED = _ref.SUPPORT_PAGE_ENABLED,
      GFCORE_SITE_URL = _ref.GFCORE_SITE_URL,
      COMMUNITY_NEW_TAB = _ref.COMMUNITY_NEW_TAB;
  return {
    home: {
      local: false,
      text: 'Home',
      url: GFCORE_SITE_URL || 'https://glowforge.com'
    },
    catalog: {
      local: !OLD_CATALOG,
      text: 'Catalog',
      url: OLD_CATALOG && OLD_CATALOG.URL || _routeConstants.CATALOG.BASE_URI,
      disabled: !_routeConstants.CATALOG.ENABLED && !OLD_CATALOG
    },
    shop: {
      local: !OLD_SHOP,
      text: 'Shop',
      url: OLD_SHOP && OLD_SHOP.URL || _routeConstants.SHOP.BASE_URL,
      disabled: !_routeConstants.SHOP.ENABLED && !OLD_SHOP
    },
    community: {
      local: false,
      text: 'Community',
      url: 'https://community.glowforge.com',
      openInNewTab: COMMUNITY_NEW_TAB
    },
    support: {
      local: false,
      text: 'Support',
      url: _routeConstants.SUPPORT.BASE_URI,
      disabled: !SUPPORT_PAGE_ENABLED
    }
  };
};

/**
 * @param {Object} features These are feature flags passed by the backend.
 *                          They either come from flip-flop or launchdarkly.
 * @returns {Array} Array of tab objects in Marketing Nav order
 */
var getMarketingRoutes = exports.getMarketingRoutes = function getMarketingRoutes(_ref2) {
  var COMMUNITY_NEW_TAB = _ref2.COMMUNITY_NEW_TAB;
  return [marketingRoutes.home, marketingRoutes.products, (0, _extends3.default)({}, marketingRoutes.community, {
    openInNewTab: COMMUNITY_NEW_TAB
  }), marketingRoutes.gallery];
};

/**
 * getNavigationTabs builds an array of nav objects based on options it is passed.
 *
 * @param {Object of constants} features An object containing constants.
 * @param {boolean} hideNavLinks If true, hide all marketing nav links except for user specific routes
 * @param {boolean} isRestricted If true, hide everything but home link
 * @param {boolean} useMarketingNav Use the marketing site nav otherwise shows the shop/catalog nav
 * @param {Object} user Currently logged in User
 */
var getNavigationTabs = exports.getNavigationTabs = function getNavigationTabs(features, hideNavLinks, isRestricted, useMarketingNav, user) {
  if (useMarketingNav) {
    if (!hideNavLinks) {
      return getMarketingRoutes(features);
    }
  } else {
    var appRoutes = getAppRoutes(features);
    // logged out
    if (_lodash2.default.isEmpty(user)) {
      return [appRoutes.home, appRoutes.community];
    }
    // logged in

    // restricted
    if (isRestricted) return [appRoutes.home];

    // unrestricted
    return [appRoutes.home, appRoutes.catalog, appRoutes.shop, appRoutes.community, appRoutes.support];
  }
};

/***/ }),

/***/ "./app/common/components/navigation/navigation-item.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _link = __webpack_require__("./app/common/components/link.jsx");

var _link2 = _interopRequireDefault(_link);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * NavigationItem is used to render a navigation tab.
 * See ./config for tab (route) definitions
 */
var NavigationItem = function NavigationItem(_ref) {
  var tab = _ref.tab,
      onClick = _ref.onClick,
      className = _ref.className;

  var _ref2 = tab || {},
      disabled = _ref2.disabled,
      secondary = _ref2.secondary,
      separator = _ref2.separator,
      local = _ref2.local,
      url = _ref2.url,
      text = _ref2.text,
      openInNewTab = _ref2.openInNewTab;

  if (disabled || secondary) return null;

  var item = null;
  if (separator) {
    item = _react2.default.createElement('hr', { className: 'navSeparator' });
  } else if (local) {
    item = _react2.default.createElement(
      _link2.default,
      { className: className, to: url, activeClassName: 'active', onClick: onClick },
      text
    );
  } else {
    item = _react2.default.createElement(
      'a',
      {
        className: className,
        href: url,
        target: openInNewTab ? '_blank' : '_self',
        onClick: onClick },
      text
    );
  }

  return item;
};

NavigationItem.propTypes = {
  tab: _propTypes2.default.shape({
    separator: _propTypes2.default.bool,
    local: _propTypes2.default.bool,
    url: _propTypes2.default.string,
    text: _propTypes2.default.string,
    openInNewTab: _propTypes2.default.bool
  }).isRequired,
  disabled: _propTypes2.default.bool,
  secondary: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  className: _propTypes2.default.oneOf(['clearLink'])
};

NavigationItem.defaultProps = {
  onClick: _lodash2.default.noop,
  disabled: false,
  secondary: false,
  className: null
};

exports.default = NavigationItem;

/***/ }),

/***/ "./app/common/components/navigation/navigation.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _user = __webpack_require__("./app/selectors/user.js");

var _features = __webpack_require__("./app/common/containers/features.js");

var _features2 = _interopRequireDefault(_features);

var _routeConstants = __webpack_require__("./app/route-constants.js");

var _navigationItem = __webpack_require__("./app/common/components/navigation/navigation-item.jsx");

var _navigationItem2 = _interopRequireDefault(_navigationItem);

var _config = __webpack_require__("./app/common/components/navigation/config.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopNav = _uiCommon.components.TopNav;

/**
 * Top Navigation for the site.
 * Will render differently for marketing pages, shop/catalog/community, and order page.
 * See ./config for more information.
 *
 * @param {Object}  user Logged in user
 * @param {bool}    hideNavLinks
 */

var Navigation = function (_Component) {
  (0, _inherits3.default)(Navigation, _Component);

  function Navigation(props) {
    (0, _classCallCheck3.default)(this, Navigation);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Navigation.__proto__ || (0, _getPrototypeOf2.default)(Navigation)).call(this, props));

    _this.getBuyButton = function () {
      var _this$props = _this.props,
          includeBuyButton = _this$props.includeBuyButton,
          route = _this$props.route;

      if (!includeBuyButton) {
        return null;
      }

      var classNames = (0, _classnames2.default)('buyButton', 'button', 'primary', 'small', {
        // Only hide buyButton if on homepage and not been below the fold.
        hidden: !_this.state.belowTheFold && route.path === _routeConstants.GLOWFORGE_LANDING_PAGE.BASE_URI,
        // buyButton is inverted colors only on homepage
        inverted: route.path === _routeConstants.GLOWFORGE_LANDING_PAGE.BASE_URI
      });

      return _react2.default.createElement(
        'div',
        { className: 'buyButtonSection' },
        _react2.default.createElement(
          'a',
          {
            className: classNames,
            href: _routeConstants.SHOP.BASE_PRODUCT_URL },
          'Shop Now'
        )
      );
    };

    _this.handleScroll = function () {
      var belowTheFold = _this.state.belowTheFold;

      var belowTheFoldHeight = window.innerHeight * 0.8;
      // only set state if it will be different
      if (!belowTheFold && window.scrollY > belowTheFoldHeight) {
        _this.setState({ belowTheFold: true });
        _this.removeScrollListener();
      }
    };

    _this.state = {
      belowTheFold: false
    };

    _this.throttledScroll = _lodash2.default.throttle(_this.handleScroll, 200);
    return _this;
  }

  (0, _createClass3.default)(Navigation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Only need scroll listener for homepage.
      if (this.props.route.path === _routeConstants.GLOWFORGE_LANDING_PAGE.BASE_URI) {
        window.addEventListener('scroll', this.throttledScroll);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeScrollListener();
    }
  }, {
    key: 'removeScrollListener',


    /**
     * Helper to remove scrollListener
     */
    value: function removeScrollListener() {
      this.throttledScroll.cancel();
      window.removeEventListener('scroll', this.throttledScroll);
    }

    /**
     * Keep track of whether the user has scrolled below the fold.
     * Will remove the scroll listener once belowTheFold is true.
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          isRestricted = _props.isRestricted,
          hideNavLinks = _props.hideNavLinks,
          hideUserSection = _props.hideUserSection,
          useMarketingNav = _props.useMarketingNav,
          features = _props.features;


      var primaryRoutes = (0, _config.getNavigationTabs)(features, hideNavLinks, isRestricted, useMarketingNav, user);

      var logoLink = useMarketingNav ? _routeConstants.GLOWFORGE_LANDING_PAGE.BASE_URI : this.props.features.GFCORE_SITE_URL;

      return _react2.default.createElement(TopNav, {
        marketing: useMarketingNav,
        logoLink: logoLink,
        user: user,
        userRoutes: _config.userRoutes,
        userSecondaryLinks: isRestricted ? null : _config.userSecondaryLinks,
        primaryRoutes: primaryRoutes
        // eslint-disable-next-line react/jsx-no-bind
        , buttonSection: this.getBuyButton(),
        hideNavLinks: hideNavLinks,
        hideUserSection: hideUserSection,
        NavigationItem: _navigationItem2.default });
    }
  }]);
  return Navigation;
}(_react.Component);

Navigation.propTypes = {
  user: _propTypes2.default.shape(_user.userPropTypes),
  hideNavLinks: _propTypes2.default.bool,
  hideUserSection: _propTypes2.default.bool,
  features: _propTypes2.default.object, // eslint-disable-line
  useMarketingNav: _propTypes2.default.bool,
  includeBuyButton: _propTypes2.default.bool,
  route: _propTypes2.default.shape({
    path: _propTypes2.default.string
  })
};
Navigation.defaultProps = {
  user: undefined,
  hideNavLinks: false,
  hideUserSection: false,
  useMarketingNav: false,
  features: {},
  includeBuyButton: false,
  route: { path: null }
};
exports.default = (0, _features2.default)(Navigation);

/***/ }),

/***/ "./app/common/components/scroll-page.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/common/components/terms-and-conditions.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

__webpack_require__("./app/common/components/terms-and-conditions.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = _uiCommon.components.Button,
    Checkbox = _uiCommon.components.Checkbox,
    Markdown = _uiCommon.components.Markdown;

var TermsAndConditionsScroll = function (_Component) {
  (0, _inherits3.default)(TermsAndConditionsScroll, _Component);

  function TermsAndConditionsScroll(props) {
    (0, _classCallCheck3.default)(this, TermsAndConditionsScroll);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TermsAndConditionsScroll.__proto__ || (0, _getPrototypeOf2.default)(TermsAndConditionsScroll)).call(this, props));

    _this.onScroll = function () {
      if (_this.scrollArea.scrollTop + _this.scrollArea.offsetHeight >= _this.scrollArea.scrollHeight) {
        _this.setState({ scrolledToBottom: true });
      }
    };

    _this.onConfirmTermsCheck = function (value) {
      _this.setState({ confirmTermsChecked: value });
    };

    _this.onAcceptTerms = function () {
      var _this$props = _this.props,
          goToNext = _this$props.goToNext,
          terms = _this$props.terms,
          downloadUrl = _this$props.downloadUrl;

      goToNext(_lodash2.default.get(terms, 'minorVersion'), downloadUrl);
    };

    _this.state = { scrolledToBottom: false, confirmTermsChecked: false };
    return _this;
  }

  (0, _createClass3.default)(TermsAndConditionsScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (true) {
        this.scrollArea.addEventListener('scroll', this.onScroll);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.scrollArea.removeEventListener('scroll', this.onScroll);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var scrollMessage = void 0;
      if (this.state.confirmTermsChecked && !this.state.scrolledToBottom) {
        scrollMessage = _react2.default.createElement(
          'div',
          { className: 'scrollReqMessage' },
          'Please scroll to the bottom and read all material provided before you agree'
        );
      }
      var warranty = void 0;
      if (this.props.warranty) {
        warranty = [_react2.default.createElement(
          'h1',
          { key: 'warrantyHeader', className: 'h1' },
          _lodash2.default.get(this.props.warranty, 'title')
        ), _react2.default.createElement(Markdown, { key: 'warrantyContent', className: 'paragraph', source: _lodash2.default.get(this.props.warranty, 'legalContent') })];
      }
      return _react2.default.createElement(
        'div',
        { className: 'TermsAndConditionsScroll grow' },
        this.props.pageTitle && _react2.default.createElement(_reactHelmet2.default, { title: 'Glowforge Setup - ' + this.props.pageTitle }),
        _react2.default.createElement(
          'div',
          { className: 'scrollArea', ref: function ref(div) {
              _this2.scrollArea = div;
            } },
          _react2.default.createElement(
            'h1',
            { className: 'h1' },
            _lodash2.default.get(this.props.terms, 'title')
          ),
          _react2.default.createElement(Markdown, {
            className: 'termsMarkdown paragraph',
            source: _lodash2.default.get(this.props.terms, 'legalContent') + ' ' + _lodash2.default.get(this.props.terms, 'legalContentPart2') }),
          warranty
        ),
        _react2.default.createElement(Checkbox, {
          name: 'confirm',
          value: this.state.confirmTermsChecked,
          onChange: this.onConfirmTermsCheck,
          label: this.props.terms.confirmCheckboxText }),
        _react2.default.createElement(
          'div',
          { className: 'actionButton' },
          scrollMessage,
          _react2.default.createElement(
            Button,
            {
              type: 'primary',
              size: 'large',
              disabled: !this.state.confirmTermsChecked || !this.state.scrolledToBottom,
              onClick: this.onAcceptTerms },
            this.props.terms.confirmButtonText
          )
        )
      );
    }
  }]);
  return TermsAndConditionsScroll;
}(_react.Component);

TermsAndConditionsScroll.propTypes = {
  pageTitle: _propTypes2.default.string,
  terms: _propTypes2.default.object.isRequired, // eslint-disable-line
  confirmButtonText: _propTypes2.default.string.isRequired,
  confirmCheckboxText: _propTypes2.default.string.isRequired,
  goToNext: _propTypes2.default.func.isRequired,
  warranty: _propTypes2.default.object, // eslint-disable-line
  downloadUrl: _propTypes2.default.string.isRequired
};
TermsAndConditionsScroll.defaultProps = {
  subTitle: null,
  pageTitle: null,
  warranty: null,
  features: {}
};
var TermsAndConditions = function TermsAndConditions(props) {
  var title = props.title ? _react2.default.createElement(
    'h1',
    { className: 'h1' },
    props.title
  ) : null;
  var subTitle = props.subTitle ? _react2.default.createElement(
    'div',
    { className: 'subTitle' },
    props.subTitle
  ) : null;
  return _react2.default.createElement(
    'div',
    { className: 'scrollPage contentPage' },
    title,
    subTitle,
    _react2.default.createElement(
      'div',
      { className: 'content grow' },
      _react2.default.createElement(Markdown, { className: 'paragraph', source: props.textBlock }),
      _react2.default.createElement(TermsAndConditionsScroll, props)
    )
  );
};
TermsAndConditions.propTypes = {
  title: _propTypes2.default.string,
  subTitle: _propTypes2.default.string,
  textBlock: _propTypes2.default.string
};
TermsAndConditions.defaultProps = {
  title: null,
  subTitle: null,
  textBlock: null
};
exports.default = TermsAndConditions;

/***/ }),

/***/ "./app/common/components/terms-and-conditions.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/common/containers/base.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseNoAuthPreload = exports.basePreload = exports.baseNoAuthMapDispatchToProps = exports.baseMapDispatchToProps = exports.baseMapStateToProps = undefined;

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _route = __webpack_require__("./app/selectors/route.js");

var _route2 = _interopRequireDefault(_route);

var _user = __webpack_require__("./app/selectors/user.js");

var _common = __webpack_require__("./app/common/actions/common.js");

var _commonApi = __webpack_require__("./app/common/api/common-api.js");

var _common2 = __webpack_require__("./app/common/selectors/common.js");

var _subscriptions = __webpack_require__("./app/selectors/subscriptions.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Basic Props and Dispatches for all root apps
var baseMapStateToProps = exports.baseMapStateToProps = function baseMapStateToProps(state, ownProps) {
  var user = (0, _user.getUser)(state);
  var isRestricted = _subscriptions.subscriptions.getIsRestricted(state);
  var routeConstants = (0, _route2.default)(null, ownProps.route);
  return (0, _extends3.default)({
    user: user,
    isRestricted: isRestricted,
    pageTitle: routeConstants.PAGE_TITLE,
    hideNavLinks: routeConstants.HIDE_NAV_LINKS,
    hideUserSection: routeConstants.HIDE_USER_SECTION,
    useMarketingNav: routeConstants.USE_MARKETING_NAV,
    includeBuyButton: routeConstants.INCLUDE_BUY_BUTTON,
    showFooter: routeConstants.SHOW_GLOBAL_FOOTER,
    canonicalUri: routeConstants.CANONICAL_URI,
    preloadError: _lodash2.default.get(state, 'common.preloadError'),
    noticeLevelError: _lodash2.default.get(state, 'common.noticeLevelError'),
    defaultMetadata: (0, _common2.getDefaultMetadata)(state)
  }, (0, _common2.getGlobalFooterContent)(state));
};

var baseMapDispatchToProps = exports.baseMapDispatchToProps = function baseMapDispatchToProps(dispatch) {
  return {
    clearGlobalError: function clearGlobalError() {
      return dispatch((0, _common.promiseError)(null));
    }
  };
};

// Same as baseMapDispatchToProps, but adds clientPreloads for use with ./client-preload
var baseNoAuthMapDispatchToProps = exports.baseNoAuthMapDispatchToProps = function baseNoAuthMapDispatchToProps(dispatch) {
  return (0, _extends3.default)({
    clientPreloads: [function () {
      return dispatch((0, _commonApi.fetchUser)());
    }]
  }, baseMapDispatchToProps(dispatch));
};

var basePreload = exports.basePreload = function basePreload(dispatch, state) {
  return [dispatch((0, _commonApi.fetchUser)()), dispatch((0, _commonApi.fetchFeatures)(_lodash2.default.get(state, 'common.ip'))), dispatch((0, _commonApi.fetchGlobalFooter)()), dispatch((0, _commonApi.fetchDefaultMetadata)())];
};

// Defer user to front end
var baseNoAuthPreload = exports.baseNoAuthPreload = function baseNoAuthPreload(dispatch, state) {
  return [dispatch((0, _commonApi.fetchFeatures)(_lodash2.default.get(state, 'common.ip'))), dispatch((0, _commonApi.fetchGlobalFooter)()), dispatch((0, _commonApi.fetchDefaultMetadata)())];
};

/***/ }),

/***/ "./app/common/containers/basic-app.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _basicApp = __webpack_require__("./app/components/root-apps/basic-app.jsx");

var _basicApp2 = _interopRequireDefault(_basicApp);

var _base = __webpack_require__("./app/common/containers/base.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return (0, _extends3.default)({}, (0, _base.baseMapStateToProps)(state, ownProps));
};

var AppContainer = (0, _reactRedux.connect)(mapStateToProps, _base.baseMapDispatchToProps)((0, _reactIsomorphicRender.preload)(function (_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;
  return (0, _base.basePreload)(dispatch, getState());
})(_basicApp2.default));

exports.default = AppContainer;

/***/ }),

/***/ "./app/common/containers/basic-client-auth-app.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _basicApp = __webpack_require__("./app/components/root-apps/basic-app.jsx");

var _basicApp2 = _interopRequireDefault(_basicApp);

var _base = __webpack_require__("./app/common/containers/base.js");

var _clientPreload = __webpack_require__("./app/common/containers/client-preload.jsx");

var _clientPreload2 = _interopRequireDefault(_clientPreload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base App for cached SSR pages.  Uses clientPreload and baseNoAuthMapDispatchToProps to defer
 * clientside user specific info to client (componentDidMount)
 */
var BasicClientAuthApp = (0, _reactRedux.connect)(_base.baseMapStateToProps, _base.baseNoAuthMapDispatchToProps)((0, _reactIsomorphicRender.preload)(function (_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;
  return (0, _base.baseNoAuthPreload)(dispatch, getState());
})((0, _clientPreload2.default)(_basicApp2.default)));

exports.default = BasicClientAuthApp;

/***/ }),

/***/ "./app/common/containers/client-preload.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// HOC to defer some api calls to clientside
// componentDidMount is only called clientside, call dispatched actions there.
// for server side data, do that in preload.
// render-props pattern HOC https://reactjs.org/docs/render-props.html
function clientPreload(Component) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    (0, _inherits3.default)(_class, _React$Component);

    function _class() {
      (0, _classCallCheck3.default)(this, _class);
      return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).apply(this, arguments));
    }

    (0, _createClass3.default)(_class, [{
      key: 'componentDidMount',


      // dispatch client side actions here
      value: function componentDidMount() {
        // Map clientPreload functions to the promises they return
        _promise2.default.all(this.props.clientPreloads.map(function (func) {
          return func();
        }));
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, this.props);
      }
    }]);
    return _class;
  }(_react2.default.Component), _class.propTypes = {
    // Client Preloads should be an array of functions that return promises.
    clientPreloads: _propTypes2.default.arrayOf(_propTypes2.default.func)
  }, _class.defaultProps = {
    clientPreloads: [] }, _temp;
}

exports.default = clientPreload;

/***/ }),

/***/ "./app/common/containers/country-code.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IdentifyGeo = undefined;

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = withCountryCode;
exports.withLocation = withLocation;
exports.getValueFromCountryCode = getValueFromCountryCode;

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__("./node_modules/react/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Higher Level component to get country code from Redux.
 */
function withCountryCode(Component) {
  var mapStateToProps = function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({
      countryCode: _lodash2.default.get(state, 'common.country')
    }, ownProps);
  };

  return (0, _reactRedux.connect)(mapStateToProps)(Component);
}

/**
 * 
 * Higher level component to get state and country code from Redux.
 */
function withLocation(Component) {
  var mapStateToProps = function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({
      countryCode: _lodash2.default.get(state, 'common.country'),
      stateCode: _lodash2.default.get(state, 'common.state')
    }, ownProps);
  };

  return (0, _reactRedux.connect)(mapStateToProps)(Component);
}

/**
 * Helper to define a default way of extracting values from an object using a country code.
 * @param {String} key A key for the default string in the hash object
 * @param {String} countryCode Appended to key to build a country specific key
 * @param {Object} hash Object of anything
 */
function getValueFromCountryCode(key, countryCode, hash) {
  var value = hash[key + '-' + countryCode];
  if (!value) {
    value = hash[key];
  }
  return value;
}

/**
 * Helper for sending information to analytics locations
 * @param {String} countryCode Shortened representation of country name
 * @param {String} stateCode Shortened representation of region name in country
 * @returns 
 */
function sendAnalytics(countryCode, stateCode) {
  // for segment tracking
  window.analytics.page('', '', {
    countryCode: countryCode,
    stateCode: stateCode
  });

  // For GTM
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    countryCode: countryCode,
    stateCode: stateCode
  });
}

/**
 * Helper to extract and send state code where it needs to go
 */
function identifyGeo(_ref) {
  var countryCode = _ref.countryCode,
      stateCode = _ref.stateCode;

  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      if (!countryCode || !stateCode) {
        fetch('/dotcom/api/geolocation').then(function (result) {
          return result.json();
        }).then(function (data) {
          sendAnalytics(data.country, data.state);
        }).catch(function (err) {
          sendAnalytics('US', 'unknown');
        });
      } else {
        sendAnalytics(countryCode, stateCode);
      }
    }
  }, []);
  return null;
};

var IdentifyGeo = exports.IdentifyGeo = withLocation(identifyGeo);

/***/ }),

/***/ "./app/common/containers/features.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = loadFeatures;

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Higher Level component that tags on the Feature Flag props
 * onto any component.
 */

// NOTE: To use dispatch(fetchFeatures())
// must be added to the preload at the root level of page: (found in containers/root-apps/base.js)
function loadFeatures(Component) {
  var mapStateToProps = function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({
      features: _lodash2.default.get(state, 'common.features')
    }, ownProps);
  };

  return (0, _reactRedux.connect)(mapStateToProps)(Component);
}

/***/ }),

/***/ "./app/common/reducers/common.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case actions.PROMISE_ERROR:
      {
        return (0, _assign2.default)({}, state, {
          noticeLevelError: extractCustomGlobalPromiseError(action.error)
        });
      }
    case actions.SET_CATEGORIES:
      {
        return (0, _assign2.default)({}, state, {
          shopCategories: _lodash2.default.get(action, 'result.shop') ? _lodash2.default.get(action, 'result.shop') : state.shopCategories,
          designCategories: _lodash2.default.get(action, 'result.catalog') ? _lodash2.default.get(action, 'result.catalog') : state.designCategories
        });
      }
    case actions.SET_USER:
      {
        return (0, _assign2.default)({}, state, {
          user: _lodash2.default.get(action, 'result')
        });
      }
    case actions.SET_FEATURE_FLAGS:
      {
        return (0, _assign2.default)({}, state, {
          features: _lodash2.default.get(action, 'result')
        });
      }
    case actions.SET_GLOBAL_FOOTER:
      {
        return (0, _assign2.default)({}, state, { footer: _lodash2.default.get(action, 'result') });
      }
    case actions.SET_COOKIE_NOTIFICATION:
      {
        return (0, _assign2.default)({}, state, { cookieNotification: _lodash2.default.get(action, 'result') });
      }
    case actions.SET_DEFAULT_METADATA:
      {
        return (0, _assign2.default)({}, state, {
          defaultMetadata: _lodash2.default.get(action, 'result')
        });
      }
    case actions.SET_MACHINES:
      {
        return (0, _assign2.default)({}, state, {
          machines: _lodash2.default.get(action, 'result.machines'),
          machinesLoading: false
        });
      }
    case actions.MACHINES_LOADING:
      {
        return (0, _assign2.default)({}, state, {
          machinesLoading: true
        });
      }
    case actions.UPDATE_PROFILE:
      {
        return (0, _extends3.default)({}, state, { user: action.result });
      }
    case actions.UPDATE_PROFILE_ERROR:
      {
        return (0, _extends3.default)({}, state, { errors: action.result });
      }
    case actions.UPDATE_USER:
      {
        var userSubmitError = void 0;
        if (_lodash2.default.get(action, 'result.status') === 'error') {
          userSubmitError = _strings2.default.GENERIC_SUBMIT_ERROR; // TODO: more specific error handling?
        }
        return (0, _assign2.default)({}, state, {
          user: _lodash2.default.get(action, 'result.user'),
          userSubmitError: userSubmitError
        });
      }
    case actions.VALIDATION_COMPLETE:
      {
        return (0, _assign2.default)({}, state, {
          showConfirmDialog: false,
          validPostalAddress: null
        });
      }
    case actions.SET_VALIDATED_POSTAL_INFO:
      {
        var output = {
          showConfirmDialog: false
        };
        if (_lodash2.default.get(action, 'result.status') === 'success' && _lodash2.default.get(action, 'result.validPostalAddress')) {
          output.showConfirmDialog = true;
          output.validPostalAddress = _lodash2.default.get(action, 'result.validPostalAddress');
          if (_lodash2.default.get(action, 'result.user')) output.user = _lodash2.default.get(action, 'result.user');
        } else if (_lodash2.default.get(action.result, 'errors.invalidPostalAddress')) {
          output.submitError = _lodash2.default.get(action.result, 'errors.invalidPostalAddress')[0];
        } else {
          output.submitError = _strings2.default.GENERIC_SUBMIT_ERROR;
        }

        return (0, _assign2.default)({}, state, output);
      }
    // TODO: This should be merged in with the above SET_VALIDATED_POSTAL_INFO endpoint
    // Right now the shipping info end point also sets address as primary shipping address
    case actions.SET_SHIPPING_INFO_SUCCESS:
      {
        var _output = {
          showConfirmDialog: false
        };
        if (_lodash2.default.get(action, 'result.status') === 'success' && _lodash2.default.get(action, 'result.validPostalAddress')) {
          _output.showConfirmDialog = true;
          _output.validPostalAddress = _lodash2.default.get(action, 'result.validPostalAddress');
        } else if (_lodash2.default.get(action.result, 'errors.invalidPostalAddress')) {
          _output.submitError = _lodash2.default.get(action.result, 'errors.invalidPostalAddress')[0];
        } else {
          _output.submitError = _strings2.default.GENERIC_SUBMIT_ERROR;
        }

        return (0, _assign2.default)({}, state, _output);
      }
    case actions.SET_SHIPPING_INFO_ERROR:
      {
        return (0, _assign2.default)({}, state, {
          errors: _lodash2.default.get(action, 'result')
        });
      }
    case actions.CONFIRM_ADDRESS_VERIFY:
    case actions.CANCEL_ADDRESS_VERIFY:
      {
        return (0, _assign2.default)({}, state, {
          showConfrimDialog: false,
          validPostalAddress: null,
          submitError: null
        });
      }
    case actions.SET_ADDRESS_STATES:
      {
        var newAddressStatesList = (0, _assign2.default)({}, state.addressStates, (0, _defineProperty3.default)({}, action.result.country, action.result));

        return (0, _assign2.default)({}, state, {
          addressStates: newAddressStatesList
        });
      }
    case actions.SET_ADDRESS_COUNTRIES:
      {
        return (0, _assign2.default)({}, state, {
          addressCountries: _lodash2.default.get(action, 'result.countries')
        });
      }
    case actions.SET_WARRANTY_PAGE:
      {
        return (0, _assign2.default)({}, state, {
          warrantyPage: action.result
        });
      }
    case actions.SET_NO_GLOWFORGE_PAGE:
      {
        return (0, _assign2.default)({}, state, {
          noGlowforgePage: _lodash2.default.get(action, 'result.fields')
        });
      }
    case actions.SET_EMAIL_CAPTURE_STATUS:
      {
        var emailSuccess = _lodash2.default.get(action, 'result.status') === 'success';
        var emailError = !emailSuccess;
        return (0, _assign2.default)({}, state, { emailSuccess: emailSuccess, emailError: emailError });
      }
    case actions.SET_REFERRAL_INFO:
      {
        return (0, _assign2.default)({}, state, {
          referral: action.result
        });
      }
    default:
      {
        return state;
      }
  }
};

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _strings = __webpack_require__("./app/strings.js");

var _strings2 = _interopRequireDefault(_strings);

var _common = __webpack_require__("./app/common/actions/common.js");

var actions = _interopRequireWildcard(_common);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function extractCustomGlobalPromiseError(error) {
  if (_lodash2.default.isNil(error)) {
    return null;
  }
  // This is a generic Error and was not raised with customer promise error
  // We show just a generic message for it.
  if (!error.type) {
    return _strings2.default.NOTIFICATION_LEVEL_ERROR_TEXT;
  }
  var message = error.message;
  if (!_lodash2.default.isString(message) || _lodash2.default.isEmpty(message)) {
    return _strings2.default.NOTIFICATION_LEVEL_ERROR_TEXT;
  }
  return message;
}

/**
 * Common Reducer store for items such as user info and elements present accross pages
 */

/***/ }),

/***/ "./app/common/selectors/common.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultMetadata = exports.getReferralInfo = exports.getProducts = exports.getGlobalFooterContent = exports.isIpAddressInUS = exports.getUsCountryISO = exports.getUsCountryID = exports.getCountryOptions = exports.getStatesOptions = undefined;

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var interpretMetadata = _uiCommon.contentfulModels.interpretMetadata;
var getStatesOptions = exports.getStatesOptions = (0, _reselect.createSelector)( // eslint-disable-line
function (store) {
  return _lodash2.default.get(store, 'common.addressStates');
}, function (countries) {
  var stateOptions = {};
  _lodash2.default.forEach(countries, function (country, key) {
    if (!stateOptions[key]) {
      stateOptions[key] = [];
    }
    _lodash2.default.forEach(country.states, function (state) {
      stateOptions[key].push({
        label: state.name,
        value: state.id
      });
    });
  });
  return stateOptions;
});

var getCountryOptions = exports.getCountryOptions = (0, _reselect.createSelector)( // eslint-disable-line
function (store) {
  return _lodash2.default.get(store, 'common.addressCountries');
}, function (countries) {
  // Put the US as the first option
  var US = _lodash2.default.find(countries, { name: 'United States' });
  _lodash2.default.remove(countries, { name: 'United States' });
  countries.unshift(US);

  return _lodash2.default.map(countries, function (country) {
    return {
      label: country.name,
      value: country.id
    };
  });
});

var getUsCountryID = exports.getUsCountryID = (0, _reselect.createSelector)(function (store) {
  return _lodash2.default.get(store, 'common.addressCountries');
}, function (countries) {
  var US = _lodash2.default.find(countries, { name: 'United States' });
  return US.id;
});

var getUsCountryISO = exports.getUsCountryISO = (0, _reselect.createSelector)(function (store) {
  return _lodash2.default.get(store, 'common.addressCountries');
}, function (countries) {
  var US = _lodash2.default.find(countries, { name: 'United States' });
  return US.iso;
});

var isIpAddressInUS = exports.isIpAddressInUS = (0, _reselect.createSelector)(function (store) {
  return _lodash2.default.get(store, 'common.country');
}, getUsCountryISO, function (countryISO, usISO) {
  return countryISO === usISO || !countryISO;
});

var getGlobalFooterContent = exports.getGlobalFooterContent = (0, _reselect.createSelector)(function (store) {
  return _lodash2.default.get(store, 'common.footer');
}, function (footer) {
  return footer;
});

var getProducts = exports.getProducts = function getProducts(state) {
  return _lodash2.default.get(state, 'glowforgeStore.products');
};

var getReferral = function getReferral(state) {
  return _lodash2.default.get(state, 'common.referral');
};
var getReferralInfo = exports.getReferralInfo = (0, _reselect.createSelector)(getReferral, function (referral) {
  if (!referral || !referral.isReferral) return { showReferralInfo: false };
  var promoLink = referral.pl ? referral.pl.id : null;
  var referralCode = referral.code;
  return {
    referredByName: referral.referrerName,
    isAffiliate: referral.isAffiliate,
    photoUrl: referral.photoUrl,
    showReferralInfo: true,
    referralCode: referralCode,
    promoLink: promoLink
  };
});

var getDefaultMetadata = exports.getDefaultMetadata = (0, _reselect.createSelector)(function (store) {
  return _lodash2.default.get(store, 'common.defaultMetadata');
}, function (metadata) {
  return interpretMetadata(metadata);
});

/***/ }),

/***/ "./app/common/selectors/page.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageStringsPropType = exports.pagePropType = exports.getSectionForPageByIdAndType = exports.getAssetsForPage = exports.getMarkdownStringsForPage = exports.getStringsForPage = exports.getContentType = undefined;

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Helpers for pulling content out of pages
 */

var getContentType = exports.getContentType = function getContentType(object) {
  return _lodash2.default.get(object, 'sys.contentType.sys.id');
};

var getStringsForPage = exports.getStringsForPage = function getStringsForPage() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _lodash2.default.reduce(page.unorderedShortText, function (all, string) {
    if (getContentType(string) === 'basicTextString') {
      all[_lodash2.default.get(string.fields, 'id')] = _lodash2.default.get(string.fields, 'text'); // eslint-disable-line no-param-reassign
    }
    return all;
  }, {});
};

var getMarkdownStringsForPage = exports.getMarkdownStringsForPage = function getMarkdownStringsForPage() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _lodash2.default.reduce(page.unorderedShortText, function (all, string) {
    if (getContentType(string) === 'textString') {
      all[_lodash2.default.get(string.fields, 'id')] = _lodash2.default.get(string.fields, 'text'); // eslint-disable-line no-param-reassign
    }
    return all;
  }, {});
};

var getAssetsForPage = exports.getAssetsForPage = function getAssetsForPage() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _lodash2.default.map(page.assets, function (asset) {
    return asset.fields;
  });
};
/**
 * Load a specific section from a page.
 * We require type because IDs are only unique to a type
 * @param page
 * @param id
 * @param type
 */
var getSectionForPageByIdAndType = exports.getSectionForPageByIdAndType = function getSectionForPageByIdAndType(page, id, type) {
  return _lodash2.default.get(_lodash2.default.find(page.sections, {
    fields: { id: id },
    sys: {
      contentType: {
        sys: {
          id: type
        }
      }
    }
  }), 'fields');
};

// Depreacted, use ui-common/models/page.js pagePropType
var pagePropType = exports.pagePropType = {
  title: _propTypes2.default.string,
  internalName: _propTypes2.default.string,
  id: _propTypes2.default.string.isRequired,
  pageType: _propTypes2.default.string,
  sections: _propTypes2.default.arrayOf(_propTypes2.default.object),
  unorderedShortText: _propTypes2.default.arrayOf(_propTypes2.default.object),
  slug: _propTypes2.default.string,
  previewText: _propTypes2.default.string
};

var pageStringsPropType = exports.pageStringsPropType = _propTypes2.default.objectOf(_propTypes2.default.string);

/***/ }),

/***/ "./app/components/account/create-form.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reduxForm = __webpack_require__("./node_modules/redux-form/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _submitActions = __webpack_require__("./app/common/components/forms/submit-actions.jsx");

var _submitActions2 = _interopRequireDefault(_submitActions);

var _generalAccountFields = __webpack_require__("./app/components/settings/general-account-fields.jsx");

__webpack_require__("./app/components/account/create-form.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Notification = _uiCommon.components.Notification,
    Markdown = _uiCommon.components.Markdown;


var CreateAccountForm = function CreateAccountForm(props) {
  var message = null;
  var error = null;
  if (props.success) {
    message = CreateAccountForm.successMassage(props.pageStrings);
  } else if (props.userAlreadyExistsError) {
    message = CreateAccountForm.userExistsMassage(props.pageStrings);
    // Mark as error to not display success message, but do not display error message either
    error = ' ';
  } else if (props.unacceptableEmailError) {
    message = CreateAccountForm.unacceptableEmailMassage(props.pageStrings);
    // Mark as error to not display success message, but do not display error message either
    error = ' ';
  } else if (props.genericError) {
    // Unexpected case, should not be triggered
    message = CreateAccountForm.genericIssueMassage(props.pageStrings);
    // Mark as error to not display success message, but do not display error message either
    error = ' ';
  }

  return _react2.default.createElement(
    'form',
    { className: 'CreateAccountForm', method: 'post', onSubmit: props.handleSubmit },
    message,
    (0, _generalAccountFields.GeneralAccountFields)(false),
    CreateAccountForm.acceptTermsMessage(props.pageStrings),
    _react2.default.createElement(_submitActions2.default, (0, _extends3.default)({}, props, {
      submitText: props.pageStrings['create-account-button-text'],
      inProgressMessage: 'Creating...',
      successMessage: 'Created new account',
      error: error }))
  );
};

CreateAccountForm.successMassage = function (pageStrings) {
  return _react2.default.createElement(Notification, { level: 'success', text: pageStrings['create-account-success-message'], hideHeader: true });
};

CreateAccountForm.userExistsMassage = function (pageStrings) {
  return _react2.default.createElement(Notification, { level: 'error', text: pageStrings['create-account-user-already-exists'], hideHeader: true });
};

CreateAccountForm.unacceptableEmailMassage = function (pageStrings) {
  return _react2.default.createElement(Notification, { level: 'error', text: pageStrings['create-account-unacceptable-email-error-message'], hideHeader: true });
};

CreateAccountForm.genericIssueMassage = function (pageStrings) {
  return _react2.default.createElement(Notification, { level: 'error', text: pageStrings['create-account-generic-issue'], hideHeader: true });
};

CreateAccountForm.acceptTermsMessage = function (pageStrings) {
  return _react2.default.createElement(
    'div',
    { className: 'terms' },
    _react2.default.createElement(Markdown, { source: pageStrings['create-account-privacy-and-terms'] })
  );
};

CreateAccountForm.propTypes = {
  success: _propTypes2.default.bool,
  userAlreadyExistsError: _propTypes2.default.bool,
  unacceptableEmailError: _propTypes2.default.bool,
  genericError: _propTypes2.default.bool,
  handleSubmit: _propTypes2.default.func.isRequired,
  pageStrings: _propTypes2.default.shape({
    'create-account-success-message': _propTypes2.default.string.isRequired,
    'create-account-user-already-exists': _propTypes2.default.string.isRequired,
    'create-account-unacceptable-email': _propTypes2.default.string.isRequired,
    'create-account-generic-issue': _propTypes2.default.string.isRequired,
    'create-account-privacy-and-terms': _propTypes2.default.string.isRequired,
    'create-account-button-text': _propTypes2.default.string.isRequire
  }).isRequired
};

CreateAccountForm.defaultProps = {
  success: false,
  userAlreadyExistsError: false,
  unacceptableEmailError: false,
  genericError: false
};

// Decorate the form component
exports.default = (0, _reduxForm.reduxForm)({
  form: 'CreateAccount',
  enableReinitialize: true,
  validate: _generalAccountFields.validateAccountInfo
})(CreateAccountForm);

/***/ }),

/***/ "./app/components/account/create-form.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/account/create.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _createForm = __webpack_require__("./app/components/account/create-form.jsx");

var _createForm2 = _interopRequireDefault(_createForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// General Create Account Form Wrapper with heading
var CreateAccount = function CreateAccount(props) {
  return _react2.default.createElement(
    'div',
    { className: 'CreateAccount contentPage' },
    _react2.default.createElement(
      'div',
      { className: 'content' },
      _react2.default.createElement(
        'h2',
        { className: 'h2' },
        props.pageStrings['create-account-form-header']
      ),
      _react2.default.createElement(_createForm2.default, props)
    )
  );
};

CreateAccount.propTypes = {
  success: _propTypes2.default.bool,
  userAlreadyExistsError: _propTypes2.default.bool,
  unacceptableEmailError: _propTypes2.default.bool,
  genericError: _propTypes2.default.bool,
  pageStrings: _propTypes2.default.shape({
    'create-account-form-header': _propTypes2.default.string.isRequired
  }).isRequired
};

CreateAccount.defaultProps = {
  success: false,
  userAlreadyExistsError: false,
  unacceptableEmailError: false,
  genericError: false
};

exports.default = CreateAccount;

/***/ }),

/***/ "./app/components/error.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _strings = __webpack_require__("./app/strings.js");

var _strings2 = _interopRequireDefault(_strings);

__webpack_require__("./app/components/error.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Error = function Error() {
  return _react2.default.createElement(
    'div',
    { className: 'Error' },
    _react2.default.createElement(_reactHelmet2.default, { title: 'Error Loading Page' }),
    _react2.default.createElement(
      'h2',
      { className: 'h2' },
      _strings2.default.ERROR_HEADER
    ),
    _react2.default.createElement(
      'h4',
      { className: 'h3' },
      _strings2.default.ERROR_SUB
    )
  );
};

Error.propTypes = {};

exports.default = Error;

/***/ }),

/***/ "./app/components/error.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/landing/call-to-action-banner.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

__webpack_require__("./app/components/landing/call-to-action-banner.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var widgetDefaultProps = _uiCommon.contentfulModels.widgetDefaultProps,
    widgetPropType = _uiCommon.contentfulModels.widgetPropType;
var getWidget = _uiCommon.contentfulViews.getWidget;
var includeWhen = _uiCommon.components.reactUtils.includeWhen;


var CallToActionBanner = function CallToActionBanner(_ref) {
  var sections = _ref.sections,
      model = _ref.model;

  var textStrings = model.textStrings;
  var ctaText = textStrings['call-to-action-banner-text'];
  var buttons = _lodash2.default.map(sections, getWidget);
  var ctaButtons = includeWhen(buttons.length > 0, function () {
    return _react2.default.createElement(
      'div',
      { className: 'ctaButtons' },
      buttons
    );
  });
  return _react2.default.createElement(
    'div',
    { className: 'CallToActionBanner fullWidth noMarginBottom' },
    _react2.default.createElement(
      'div',
      { className: 'content' },
      _react2.default.createElement(
        'div',
        { className: 'ctaText' },
        ctaText
      ),
      ctaButtons
    )
  );
};

CallToActionBanner.propTypes = widgetPropType;

CallToActionBanner.defaultProps = widgetDefaultProps;

exports.default = CallToActionBanner;

/***/ }),

/***/ "./app/components/landing/call-to-action-banner.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/landing/glowforge-landing-page.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _featuresDisplay = __webpack_require__("./app/common/components/features-display/index.js");

var _meetTheFamily = __webpack_require__("./app/components/landing/meet-the-family.jsx");

var _meetTheFamily2 = _interopRequireDefault(_meetTheFamily);

var _callToActionBanner = __webpack_require__("./app/components/landing/call-to-action-banner.jsx");

var _callToActionBanner2 = _interopRequireDefault(_callToActionBanner);

var _mediaCardsList = __webpack_require__("./app/components/landing/media-cards-list.jsx");

var _mediaCardsList2 = _interopRequireDefault(_mediaCardsList);

var _socialCards = __webpack_require__("./app/components/landing/social-cards.jsx");

var _socialCards2 = _interopRequireDefault(_socialCards);

var _materialsDisplayWidget = __webpack_require__("./app/components/landing/materials-display-widget.jsx");

var _materialsDisplayWidget2 = _interopRequireDefault(_materialsDisplayWidget);

var _materialsCarousel3dWidget = __webpack_require__("./app/components/landing/materials-carousel-3d-widget.jsx");

var _materialsCarousel3dWidget2 = _interopRequireDefault(_materialsCarousel3dWidget);

var _messageBanner = __webpack_require__("./app/components/landing/message-banner/index.js");

var _messageBanner2 = _interopRequireDefault(_messageBanner);

__webpack_require__("./app/components/landing/glowforge-landing-page.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pagePropType = _uiCommon.contentfulModels.pagePropType;
var Page = _uiCommon.contentfulViews.Page;
var MadLibProvider = _uiCommon.components.MadLibProvider;

var GlowforgeLandingPage = function (_React$Component) {
  (0, _inherits3.default)(GlowforgeLandingPage, _React$Component);

  function GlowforgeLandingPage() {
    (0, _classCallCheck3.default)(this, GlowforgeLandingPage);
    return (0, _possibleConstructorReturn3.default)(this, (GlowforgeLandingPage.__proto__ || (0, _getPrototypeOf2.default)(GlowforgeLandingPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(GlowforgeLandingPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Analytics calls to track new homepage
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'new_homepage' });
      var FS = window.FS;
      if (FS && typeof FS.event === 'function') {
        FS.event('new_homepage');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          referralInfo = _props.referralInfo,
          products = _props.products,
          page = _props.page;

      var customSections = {
        'meet-the-family': { component: _meetTheFamily2.default },
        'call-to-action': { component: _callToActionBanner2.default },
        'media-cards-list': { component: _mediaCardsList2.default },
        'social-cards': { component: _socialCards2.default },
        'materials-display': { component: _materialsDisplayWidget2.default },
        'materials-carousel-3d': { component: _materialsCarousel3dWidget2.default },
        'features-display': { component: _featuresDisplay.FeaturesDisplayWidget },
        'message-banner': {
          component: _messageBanner2.default,
          props: {
            referralInfo: referralInfo,
            products: products
          }
        }
      };

      var attributions = {
        referralCode: referralInfo ? referralInfo.referralCode : null,
        promoLink: referralInfo ? referralInfo.promoLink : null
      };

      return _react2.default.createElement(
        MadLibProvider,
        { attributions: attributions },
        _react2.default.createElement(Page, (0, _extends3.default)({
          className: 'GlowforgeLandingPage'
        }, page, {
          title: null,
          customSections: customSections }))
      );
    }
  }]);
  return GlowforgeLandingPage;
}(_react2.default.Component);

GlowforgeLandingPage.propTypes = {
  page: _propTypes2.default.shape(pagePropType),
  products: _propTypes2.default.shape({}),
  referralInfo: _propTypes2.default.shape({
    referralCode: _propTypes2.default.string,
    promoLink: _propTypes2.default.string
  })
};

GlowforgeLandingPage.defaultProps = {
  page: {
    sections: []
  },
  products: null,
  referralInfo: null
};

exports.default = GlowforgeLandingPage;

/***/ }),

/***/ "./app/components/landing/glowforge-landing-page.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/landing/materials-carousel-3d-widget.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _materialsCarousel3d = __webpack_require__("./app/components/landing/materials-carousel-3d.jsx");

var _materialsCarousel3d2 = _interopRequireDefault(_materialsCarousel3d);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @ts-check
var widgetDefaultProps = _uiCommon.contentfulModels.widgetDefaultProps,
    widgetPropType = _uiCommon.contentfulModels.widgetPropType;
var getSectionForPageByIdAndType = _uiCommon.contentfulModels.getSectionForPageByIdAndType;

/**
 * @typedef {object} Props
 * @property {{ fields: {id: string, text: string }[] }[]} textStrings
 * @property {{ fields: {title: string, text: string }[] }[]} sections
 */

/**
 * MaterialsCarousel3d Contentful accessor widget.
 * Maps Contentful data to the Carousel3d component.
 * @class
 * @extends {React.PureComponent<Props>}
 */

var MaterialsCarousel3dWidget = function (_React$PureComponent) {
  (0, _inherits3.default)(MaterialsCarousel3dWidget, _React$PureComponent);

  function MaterialsCarousel3dWidget() {
    (0, _classCallCheck3.default)(this, MaterialsCarousel3dWidget);
    return (0, _possibleConstructorReturn3.default)(this, (MaterialsCarousel3dWidget.__proto__ || (0, _getPrototypeOf2.default)(MaterialsCarousel3dWidget)).apply(this, arguments));
  }

  (0, _createClass3.default)(MaterialsCarousel3dWidget, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$sections = _props.sections,
          sections = _props$sections === undefined ? [] : _props$sections,
          _props$textStrings = _props.textStrings,
          textStrings = _props$textStrings === undefined ? [] : _props$textStrings;


      var ctaProps = getSectionForPageByIdAndType({ sections: sections }, 'materials-carousel-3d-learn-more-button-link', 'buttonLink') || {};

      var galleryData = getSectionForPageByIdAndType({ sections: sections }, 'materials-carousel-3d-gallery-items', 'list') || [];

      /**
       * @param {string} id Text field id
       */
      var getTextById = function getTextById(id) {
        if (!textStrings) {
          return '';
        }
        var item = textStrings.find(function (i) {
          return _lodash2.default.get(i, 'fields.id') === id;
        });
        return _lodash2.default.get(item, 'fields.text', '');
      };

      var title = getTextById('materials-carousel-3d-title');
      var text = getTextById('materials-carousel-3d-text');

      var items = _lodash2.default.get(galleryData, 'listItems').map(function (_ref) {
        var fields = _ref.fields;
        return {
          id: _lodash2.default.get(fields, 'id'),
          thumbnailTitle: _lodash2.default.get(fields, 'title', ''),
          thumbnailUrl: _lodash2.default.get(fields, 'listItems[0].fields.media.fields.file.url', '') + '?w=160&h=160',
          heroUrl: _lodash2.default.get(fields, 'listItems[1].fields.media.fields.file.url', '') + '?fm=jpg&fl=progressive',
          heroPlaceholderUrl: _lodash2.default.get(fields, 'listItems[1].fields.media.fields.file.url', '') + '?q=1&fm=jpg&fl=progressive',
          description: _lodash2.default.get(fields, 'text', '')
        };
      });

      return _react2.default.createElement(_materialsCarousel3d2.default, {
        data: items,
        ctaProps: ctaProps,
        title: title,
        text: text });
    }
  }]);
  return MaterialsCarousel3dWidget;
}(_react2.default.PureComponent);

MaterialsCarousel3dWidget.propTypes = (0, _extends3.default)({}, widgetPropType);

MaterialsCarousel3dWidget.defaultProps = (0, _extends3.default)({}, widgetDefaultProps);

exports.default = MaterialsCarousel3dWidget;

/***/ }),

/***/ "./app/components/landing/materials-carousel-3d.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

__webpack_require__("./app/components/landing/materials-carousel-3d.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @ts-check
var Carousel3dGallery = _uiCommon.components.Carousel3dGallery;
var ButtonLinkWidget = _uiCommon.contentfulWidgets.ButtonLinkWidget;

/**
 * @typedef {object} Carousel3dGalleryImageData
 * @property {string} id Unique id for image
 * @property {string} thumbnailUrl Thumbnail image url
 * @property {string} thumbnailTitle Title of the thumbnail
 * @property {string} heroUrl Hero image url
 * @property {string} description Description of the large image
 */

/**
 * @typedef {object} CtaProps
 * @property {string} id
 * @property {string} internalName
 * @property {string} size
 * @property {string} text
 * @property {string} type
 * @property {string} url
 */

/**
 * @typedef {object} Props
 * @property {Carousel3dGalleryImageData[]} data
 * @property {string} title
 * @property {string} text
 * @property {CtaProps} ctaProps
 */

/**
 * @class
 * @extends {React.PureComponent<Props>}
 */

var MaterialsCarousel3d = function (_React$PureComponent) {
  (0, _inherits3.default)(MaterialsCarousel3d, _React$PureComponent);

  function MaterialsCarousel3d() {
    (0, _classCallCheck3.default)(this, MaterialsCarousel3d);
    return (0, _possibleConstructorReturn3.default)(this, (MaterialsCarousel3d.__proto__ || (0, _getPrototypeOf2.default)(MaterialsCarousel3d)).apply(this, arguments));
  }

  (0, _createClass3.default)(MaterialsCarousel3d, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          title = _props.title,
          text = _props.text,
          ctaProps = _props.ctaProps;


      var learnMoreButton = _react2.default.createElement(ButtonLinkWidget, {
        model: { fields: ctaProps },
        key: 'ctaButton',
        className: 'ctaButton' });

      return _react2.default.createElement(
        'div',
        { className: 'MaterialsCarousel3d' },
        _react2.default.createElement(
          'h2',
          { className: 'title' },
          title
        ),
        _react2.default.createElement(Carousel3dGallery, { data: data, thumbnailWidth: 160, thumbnailHeight: 160 }),
        _react2.default.createElement(
          'p',
          { className: 'text' },
          text
        ),
        learnMoreButton
      );
    }
  }]);
  return MaterialsCarousel3d;
}(_react2.default.PureComponent);

MaterialsCarousel3d.itemShape = _propTypes2.default.shape({
  id: _propTypes2.default.string,
  thumbnailTitle: _propTypes2.default.string.isRequired,
  thumbnailUrl: _propTypes2.default.string.isRequired,
  heroUrl: _propTypes2.default.string.isRequired,
  description: _propTypes2.default.string.isRequired
});
MaterialsCarousel3d.propTypes = {
  data: _propTypes2.default.arrayOf(MaterialsCarousel3d.itemShape).isRequired,
  title: _propTypes2.default.string.isRequired,
  text: _propTypes2.default.string.isRequired,
  ctaProps: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    internalName: _propTypes2.default.string.isRequired,
    size: _propTypes2.default.string.isRequired,
    text: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired,
    url: _propTypes2.default.string.isRequired
  }).isRequired
};
exports.default = MaterialsCarousel3d;

/***/ }),

/***/ "./app/components/landing/materials-carousel-3d.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/landing/materials-display-widget.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _materialsDisplay = __webpack_require__("./app/components/landing/materials-display.jsx");

var _materialsDisplay2 = _interopRequireDefault(_materialsDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var widgetDefaultProps = _uiCommon.contentfulModels.widgetDefaultProps,
    widgetPropType = _uiCommon.contentfulModels.widgetPropType;
var getSectionForPageByIdAndType = _uiCommon.contentfulModels.getSectionForPageByIdAndType,
    getContentFieldsByType = _uiCommon.contentfulModels.getContentFieldsByType;
var Image = _uiCommon.contentfulViews.Image;

/**
 * MaterialsDisplay Contentful accessor widget.
 * Maps Contentful data to the MaterialsDisplay widget.
 * @param {Object} widget WidgetPropType ui-common/models/widget
 */

var MaterialsDisplayWidget = function (_React$PureComponent) {
  (0, _inherits3.default)(MaterialsDisplayWidget, _React$PureComponent);

  function MaterialsDisplayWidget() {
    (0, _classCallCheck3.default)(this, MaterialsDisplayWidget);
    return (0, _possibleConstructorReturn3.default)(this, (MaterialsDisplayWidget.__proto__ || (0, _getPrototypeOf2.default)(MaterialsDisplayWidget)).apply(this, arguments));
  }

  (0, _createClass3.default)(MaterialsDisplayWidget, [{
    key: 'render',
    value: function render() {
      var sections = this.props.sections;


      var ctaProps = getSectionForPageByIdAndType({ sections: sections }, 'learn-more-about-materials', 'buttonLink');

      var andMoreButtonProps = getSectionForPageByIdAndType({ sections: sections }, 'materials-homepage-and-dozens-more', 'buttonLink');

      var materialsListContent = getContentFieldsByType(sections, 'list')[0];

      var sectionTitle = _lodash2.default.get(materialsListContent, 'title');
      var description = _lodash2.default.get(materialsListContent, 'text');

      var items = _lodash2.default.get(materialsListContent, 'listItems').map(function (_ref) {
        var fields = _ref.fields;
        return {
          title: _lodash2.default.get(fields, 'title'),
          image: _react2.default.createElement(Image, { media: _lodash2.default.get(fields, 'images[0]') })
        };
      });
      return _react2.default.createElement(_materialsDisplay2.default, {
        items: items,
        andMoreButtonProps: andMoreButtonProps,
        ctaProps: ctaProps,
        title: sectionTitle,
        description: description });
    }
  }]);
  return MaterialsDisplayWidget;
}(_react2.default.PureComponent);

MaterialsDisplayWidget.propTypes = (0, _extends3.default)({}, widgetPropType);

MaterialsDisplayWidget.defaultProps = (0, _extends3.default)({}, widgetDefaultProps);

exports.default = MaterialsDisplayWidget;

/***/ }),

/***/ "./app/components/landing/materials-display.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

__webpack_require__("./app/components/landing/materials-display.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var widgetDefaultProps = _uiCommon.contentfulModels.widgetDefaultProps,
    widgetPropType = _uiCommon.contentfulModels.widgetPropType;
var Button = _uiCommon.components.Button;
var ButtonLinkWidget = _uiCommon.contentfulWidgets.ButtonLinkWidget;

/**
 * MaterialsDisplay custom widget
 * Implemented as PureComponent to give us `shouldComponentUpdate` help.
 */

var MaterialsDisplay = function (_React$PureComponent) {
  (0, _inherits3.default)(MaterialsDisplay, _React$PureComponent);

  function MaterialsDisplay(props) {
    (0, _classCallCheck3.default)(this, MaterialsDisplay);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MaterialsDisplay.__proto__ || (0, _getPrototypeOf2.default)(MaterialsDisplay)).call(this, props));

    _this.onClick = function (index) {
      return function (event) {
        if (window.innerWidth < 960) {
          // Get center of text button within it's parent (it's offset sizing)
          var targetCenter = event.currentTarget.offsetLeft + event.currentTarget.offsetWidth / 2;
          // Center the text button to the visible center of the parent (client width is what's visible)
          var materialsCenter = targetCenter - _this.materialsList.clientWidth / 2;
          _this.materialsList.scrollTo({ left: materialsCenter, behavior: 'smooth' });
        }
        _this.setState({ currentIndex: index });
      };
    };

    _this.onMaterialsListScroll = function (event) {
      // persist() prevents React from flushing the event
      // we need it to stick around long enough to get through the throttle func
      event.persist();
      _this.delayedScrollUpdate(event.target);
    };

    _this.updateScrollIndicators = function () {
      var scrollElement = _this.materialsList;
      if (scrollElement) {
        // Calculate padding padding around scrollElement
        var padding = (window.innerWidth - scrollElement.clientWidth) / 2;
        // Find the leftmost possible scrollLeft for the element
        var leftMax = scrollElement.scrollWidth - scrollElement.clientWidth;
        var left = scrollElement.scrollLeft;
        // Left side scroll indicator
        if (left <= padding) {
          _this.setState({ showLeftIndicator: false });
        } else {
          _this.setState({ showLeftIndicator: true });
        }
        // Right side scroll indicator
        if (left >= leftMax - padding) {
          _this.setState({ showRightIndicator: false });
        } else {
          _this.setState({ showRightIndicator: true });
        }
      }
    };

    _this.materialsListRef = function (ref) {
      _this.materialsList = ref;
      _this.delayedScrollUpdate(_this.materialsList);
    };

    _this.state = {
      currentIndex: 0,
      showLeftIndicator: false,
      showRightIndicator: false
    };

    // Throttle scroll update call to once every 300ms
    _this.delayedScrollUpdate = _lodash2.default.throttle(_this.updateScrollIndicators, 300);
    return _this;
  }

  // Bind onClick to the given 'index'


  // onScroll listener


  /**
   * Scroll Indicator updater
   * Used to show scroll
   * Don't call this directly, call this.delayedScrollUpdate instead
   */


  // Hold a reference to the materialsList element to update scroll indicators


  (0, _createClass3.default)(MaterialsDisplay, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          displayTitle = _props.title,
          description = _props.description,
          andMoreButtonProps = _props.andMoreButtonProps,
          ctaProps = _props.ctaProps,
          items = _props.items;
      var currentIndex = this.state.currentIndex;


      var learnMoreButton = _react2.default.createElement(ButtonLinkWidget, {
        model: { fields: ctaProps },
        key: 'ctaButton',
        className: 'ctaButton' });

      // This is the link that's visible on desktop at the end of the 'textOptions' list
      var andMoreButton = _react2.default.createElement(ButtonLinkWidget, {
        model: { fields: andMoreButtonProps },
        key: 'andMoreButton',
        className: 'materialOption andMoreButton' });

      var textOptions = _lodash2.default.map(items, function (_ref, index) {
        var title = _ref.title;
        return _react2.default.createElement(
          Button,
          {
            key: title,
            className: 'materialOption ' + (currentIndex === index ? 'active' : ''),
            type: 'text',
            onClick: _this2.onClick(index) },
          title
        );
      });
      textOptions.push(andMoreButton);

      // Display the image for the currently selected material
      var image = _lodash2.default.get(items, '[' + currentIndex + '].image');

      var _state = this.state,
          showLeftIndicator = _state.showLeftIndicator,
          showRightIndicator = _state.showRightIndicator;

      var displayClassNames = (0, _classnames2.default)('display', { showLeftIndicator: showLeftIndicator }, { showRightIndicator: showRightIndicator });

      return _react2.default.createElement(
        'div',
        { className: 'MaterialsDisplay' },
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement(
            'h2',
            { className: 'title' },
            displayTitle
          ),
          _react2.default.createElement(
            'h3',
            { className: 'description' },
            description
          ),
          _react2.default.createElement(
            'div',
            { className: 'ctaButton' },
            learnMoreButton
          ),
          _react2.default.createElement(
            'div',
            { className: displayClassNames },
            _react2.default.createElement(
              'div',
              {
                className: 'materialsList',
                ref: this.materialsListRef,
                onScroll: this.onMaterialsListScroll },
              textOptions
            ),
            _react2.default.createElement(
              'div',
              { className: 'selectedMaterial' },
              image
            )
          )
        )
      );
    }
  }]);
  return MaterialsDisplay;
}(_react2.default.PureComponent);

MaterialsDisplay.propTypes = (0, _extends3.default)({}, widgetPropType);

MaterialsDisplay.defaultProps = (0, _extends3.default)({}, widgetDefaultProps);

exports.default = MaterialsDisplay;

/***/ }),

/***/ "./app/components/landing/materials-display.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/landing/media-card.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

__webpack_require__("./app/components/landing/media-card.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Img = _uiCommon.contentfulViews.Image;
var Markdown = _uiCommon.components.Markdown;

/**
 * UI for Card
 * If passed onClick, will be tabbable and clickable.
 */

var MediaCard = function MediaCard(_ref) {
  var children = _ref.children,
      className = _ref.className,
      image = _ref.image,
      text = _ref.text,
      title = _ref.title;
  return _react2.default.createElement(
    'div',
    { className: 'MediaCard ' + className },
    _react2.default.createElement(
      'div',
      { className: 'card-image' },
      _react2.default.createElement(Img, { media: image })
    ),
    _react2.default.createElement(
      'div',
      { className: 'card-content' },
      _react2.default.createElement(
        'h3',
        { className: 'card-title' },
        title
      ),
      _react2.default.createElement(Markdown, { source: text }),
      children
    )
  );
};

MediaCard.propTypes = {
  image: _propTypes2.default.shape(Img.propTypes),
  title: _propTypes2.default.string,
  text: _propTypes2.default.string,
  className: _propTypes2.default.string,
  children: _propTypes2.default.node
};

MediaCard.defaultProps = {
  image: Img.defaultProps,
  title: null,
  text: null,
  className: '',
  children: null
};

exports.default = MediaCard;

/***/ }),

/***/ "./app/components/landing/media-card.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/landing/media-cards-list.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _mediaCard = __webpack_require__("./app/components/landing/media-card.jsx");

var _mediaCard2 = _interopRequireDefault(_mediaCard);

__webpack_require__("./app/components/landing/media-cards-list.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var widgetDefaultProps = _uiCommon.contentfulModels.widgetDefaultProps,
    widgetPropType = _uiCommon.contentfulModels.widgetPropType;
var Button = _uiCommon.components.Button;


var ITEMS_PER_PAGE = 8;
// 400 pixel scroll offset for mobile infinite scroll.
var SCROLL_OFFSET = 400;

/**
 * What can you print?
 * Renders a grid of cards that are clickable to open a dialog/modal.
 * The cards are paged, in that we show multiples of ITEMS_PER_PAGE at a time.
 * ITEMS_PER_PAGE more cards are visible each time a user clicks a show more button.
 */

var MediaCardsList = function (_React$PureComponent) {
  (0, _inherits3.default)(MediaCardsList, _React$PureComponent);

  function MediaCardsList(props) {
    (0, _classCallCheck3.default)(this, MediaCardsList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MediaCardsList.__proto__ || (0, _getPrototypeOf2.default)(MediaCardsList)).call(this, props));

    _this.state = {
      page: 1,
      hasLoadedAllItems: false
    };
    // memoized array for visible items.
    _this.visibleItems = [];
    _this.incrementPage = _this.incrementPage.bind(_this);
    _this.getVisibleItems = _this.getVisibleItems.bind(_this);
    _this.getListItems = _this.getListItems.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.removeScrollListener = _this.removeScrollListener.bind(_this);

    // setup scroll listener
    _this.gridRef = _react2.default.createRef();
    _this.throttledScroll = _lodash2.default.throttle(_this.handleScroll, 200);
    return _this;
  }

  (0, _createClass3.default)(MediaCardsList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Add scroll listener to grid on client
      this.gridRef.current.addEventListener('scroll', this.throttledScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Cancel scroll listner
      this.removeScrollListener();
    }

    /**
     * Helper for getting listItems from props.
     */

  }, {
    key: 'getListItems',
    value: function getListItems() {
      return _lodash2.default.get(this.props, 'sections[0].fields.listItems');
    }

    /**
     * Memoized getter for paged items.  We show ITEMS_PER_PAGE cards
     * at a time in the desktop grid view.
     * @param {Array} items full array of cards/items
     */

  }, {
    key: 'getVisibleItems',
    value: function getVisibleItems() {
      var items = this.getListItems();
      var numPagedItems = this.state.page * ITEMS_PER_PAGE;
      if (this.visibleItems.length < numPagedItems) {
        this.visibleItems = items.slice(0, numPagedItems);
      }
      return this.visibleItems;
    }
  }, {
    key: 'removeScrollListener',
    value: function removeScrollListener() {
      this.throttledScroll.cancel();
      this.gridRef.current.removeEventListener('scroll', this.throttledScroll);
    }

    /**
     * Handle grid scroll.  Used to infinite scroll mobile view.
     */

  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      var items = this.getListItems();
      // Have we loaded all the items yet?
      if (this.visibleItems.length < items.length) {
        var _gridRef$current = this.gridRef.current,
            clientWidth = _gridRef$current.clientWidth,
            scrollWidth = _gridRef$current.scrollWidth,
            scrollLeft = _gridRef$current.scrollLeft;
        // if grid is overflowed horizontally, we're on mobile.

        if (scrollWidth > clientWidth) {
          var rightEdge = scrollLeft + clientWidth;
          // If rightEdge of grid is within SCROLL_OFFSET pixels of end, load more items
          if (scrollWidth - rightEdge < SCROLL_OFFSET) {
            this.incrementPage();
          }
        }
      } else {
        // all items have been loaded, no longer need to scroll.
        this.removeScrollListener();
      }
    }

    /**
     * Increment the page to trigger a re-render and show the
     * next set of items.
     */

  }, {
    key: 'incrementPage',
    value: function incrementPage() {
      var page = this.state.page + 1;
      this.setState({
        page: page
      });
    }
  }, {
    key: 'render',
    value: function render() {
      // Extract data from Contentful
      var textStrings = _lodash2.default.get(this.props, 'model.textStrings');
      var title = textStrings['media-card-title'];
      var seeMoreText = textStrings['media-card-see-more'];
      var swipeToSeeMoreText = textStrings['media-card-swipe-to-see-more'];
      var listItems = this.getListItems();

      // get paged/memoized list of items
      var items = this.getVisibleItems(listItems);

      // If there are more items to be shown, render a show more button.
      var moreItems = items.length < listItems.length;
      var showMoreButton = moreItems ? _react2.default.createElement(
        Button,
        { className: 'button', type: 'secondary', onClick: this.incrementPage },
        seeMoreText
      ) : null;
      var showMoreClasses = moreItems ? 'moreItems' : '';

      // Only render visible items in main view
      var cards = _lodash2.default.map(items, _lodash2.default.property('fields')).map(function (fields) {
        return _react2.default.createElement(_mediaCard2.default, {
          className: _lodash2.default.camelCase(fields.title),
          key: fields.title,
          image: fields.images[0],
          title: fields.title,
          text: fields.text });
      });

      return _react2.default.createElement(
        'div',
        { className: 'MediaCardsList' },
        _react2.default.createElement(
          'h2',
          { className: 'title' },
          title
        ),
        _react2.default.createElement(
          'div',
          { className: 'cards-grid', ref: this.gridRef },
          cards
        ),
        _react2.default.createElement(
          'div',
          { className: 'showMore ' + showMoreClasses },
          _react2.default.createElement(
            'div',
            { className: 'text' },
            swipeToSeeMoreText
          ),
          showMoreButton
        )
      );
    }
  }]);
  return MediaCardsList;
}(_react2.default.PureComponent);

MediaCardsList.propTypes = widgetPropType;

MediaCardsList.defaultProps = widgetDefaultProps;

exports.default = MediaCardsList;

/***/ }),

/***/ "./app/components/landing/media-cards-list.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/landing/meet-the-family.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

__webpack_require__("./app/components/landing/meet-the-family.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var widgetDefaultProps = _uiCommon.contentfulModels.widgetDefaultProps,
    widgetPropType = _uiCommon.contentfulModels.widgetPropType;
var getContentByType = _uiCommon.contentfulModels.getContentByType,
    getContentFieldsByType = _uiCommon.contentfulModels.getContentFieldsByType;
var getWidget = _uiCommon.contentfulViews.getWidget,
    Image = _uiCommon.contentfulViews.Image;

/**
 * MeetTheFamily custom widget
 * @param {Object} widget WidgetPropType ui-common/models/widget
 */

var MeetTheFamily = function MeetTheFamily(_ref) {
  var sections = _ref.sections,
      model = _ref.model;

  var title = _lodash2.default.get(model, 'textStrings.meet-the-family');
  var productsPageLink = _lodash2.default.get(model, 'textStrings.products-page-link');
  var buttonLinks = _lodash2.default.map(getContentByType(sections, 'buttonLink'), getWidget);

  // 2 images per product, stored as a list
  var products = getContentFieldsByType(sections, 'list');
  var productImages = _lodash2.default.map(products, function (product) {
    var logo = _lodash2.default.get(product, 'listItems[0].fields.media');
    var photo = _lodash2.default.get(product, 'listItems[1].fields.media');

    return _react2.default.createElement(
      'a',
      { href: productsPageLink, className: 'product', key: _lodash2.default.get(product, 'id') },
      _react2.default.createElement(Image, { media: logo, className: 'product-logo', lazy: true }),
      _react2.default.createElement(Image, { media: photo, className: 'product-photo', lazy: true })
    );
  });

  return _react2.default.createElement(
    'div',
    { className: 'MeetTheFamily' },
    _react2.default.createElement(
      'h2',
      { className: 'h2' },
      title
    ),
    _react2.default.createElement(
      'div',
      { className: 'ctaButtons' },
      buttonLinks
    ),
    _react2.default.createElement(
      'div',
      { className: 'products' },
      productImages
    )
  );
};

MeetTheFamily.propTypes = (0, _extends3.default)({}, widgetPropType);

MeetTheFamily.defaultProps = (0, _extends3.default)({}, widgetDefaultProps);

exports.default = MeetTheFamily;

/***/ }),

/***/ "./app/components/landing/meet-the-family.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/landing/message-banner/content-body.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnouncementFragment = exports.ReferralFragment = exports.ContentBody = undefined;

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _countryCode = __webpack_require__("./app/common/containers/country-code.js");

__webpack_require__("./app/components/landing/message-banner/message-banner.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Markdown = _uiCommon.components.Markdown,
    includeWhen = _uiCommon.components.reactUtils.includeWhen;
var stringSubstitution = _uiCommon.contentfulUtils.stringSubstitution;

/**
 * Helpers to render the content body for the message banner
 */

var ContentBody = exports.ContentBody = function ContentBody(_ref) {
  var markdownSource = _ref.markdownSource,
      textClassName = _ref.textClassName,
      photoUrl = _ref.photoUrl;
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    includeWhen(photoUrl, function () {
      return _react2.default.createElement(
        'div',
        { className: 'image-wrapper' },
        _react2.default.createElement('div', { className: 'image', style: { backgroundImage: 'url(' + photoUrl + ')' } })
      );
    }),
    _react2.default.createElement(Markdown, { className: (0, _classnames2.default)('message', textClassName), source: markdownSource })
  );
};

ContentBody.propTypes = {
  markdownSource: _propTypes2.default.string.isRequired,
  textClassName: _propTypes2.default.string.isRequired,
  photoUrl: _propTypes2.default.string.isRequired
};

var ReferralFragment = exports.ReferralFragment = function ReferralFragment(_ref2) {
  var isAffiliate = _ref2.isAffiliate,
      referralInfo = _ref2.referralInfo,
      products = _ref2.products,
      strings = _ref2.strings;

  var textKey = isAffiliate ? 'referral-banner-affiliate-text' : 'referral-banner-non-affiliate-text';
  var stringSubText = stringSubstitution(strings[textKey], {
    name: '<span class=\'name\'>' + _lodash2.default.get(referralInfo, 'referredByName') + '</span>',
    proDiscount: _lodash2.default.get(products, 'pro.referral.payment'),
    plusDiscount: _lodash2.default.get(products, 'plus.referral.payment'),
    basicDiscount: _lodash2.default.get(products, 'basic.referral.payment')
  });
  var photoUrl = referralInfo.photoUrl;

  return _react2.default.createElement(ContentBody, {
    markdownSource: stringSubText,
    photoUrl: photoUrl,
    textClassName: 'referral-text' });
};

ReferralFragment.propTypes = {
  isAffiliate: _propTypes2.default.bool.isRequired,
  referralInfo: _propTypes2.default.shape({}).isRequired,
  products: _propTypes2.default.shape({}).isRequired,
  strings: _propTypes2.default.arrayOf({}).isRequired
};

var AnnouncementFragment = exports.AnnouncementFragment = function AnnouncementFragment(_ref3) {
  var announcement = _ref3.announcement,
      countryCode = _ref3.countryCode,
      sections = _ref3.sections;

  // getValueFromCountryCode expects an object with entries of { id: url }
  var urlHash = _lodash2.default.chain(sections).keyBy('fields.id').mapValues('fields.media.fields.file.url').value();
  var iconUrl = (0, _countryCode.getValueFromCountryCode)('announcement-icon', countryCode, urlHash);

  return _react2.default.createElement(ContentBody, {
    markdownSource: announcement,
    photoUrl: iconUrl });
};

AnnouncementFragment.propTypes = {
  announcement: _propTypes2.default.string.isRequired,
  countryCode: _propTypes2.default.string.isRequired,
  sections: _propTypes2.default.arrayOf({}).isRequired
};

/***/ }),

/***/ "./app/components/landing/message-banner/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _messageBanner = __webpack_require__("./app/components/landing/message-banner/message-banner.jsx");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_messageBanner).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./app/components/landing/message-banner/message-banner.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _countryCode = __webpack_require__("./app/common/containers/country-code.js");

var _countryCode2 = _interopRequireDefault(_countryCode);

var _contentBody = __webpack_require__("./app/components/landing/message-banner/content-body.jsx");

__webpack_require__("./app/components/landing/message-banner/message-banner.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMarkdownStringsForWidget = _uiCommon.contentfulModels.getMarkdownStringsForWidget,
    widgetDefaultProps = _uiCommon.contentfulModels.widgetDefaultProps,
    widgetPropType = _uiCommon.contentfulModels.widgetPropType;

/**
 * Homepage Message banner
 * Combines Announcement Banner and Referral Banner for Above The Fold A/B Test.
 * https://glowforge.atlassian.net/wiki/spaces/UD/pages/1064501566/Above+the+Fold
 */

var MessageBanner = function (_React$PureComponent) {
  (0, _inherits3.default)(MessageBanner, _React$PureComponent);

  function MessageBanner() {
    (0, _classCallCheck3.default)(this, MessageBanner);
    return (0, _possibleConstructorReturn3.default)(this, (MessageBanner.__proto__ || (0, _getPrototypeOf2.default)(MessageBanner)).apply(this, arguments));
  }

  (0, _createClass3.default)(MessageBanner, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          countryCode = _props.countryCode,
          referralInfo = _props.referralInfo,
          products = _props.products,
          model = _props.model;


      var strings = getMarkdownStringsForWidget(this.props);
      var showReferralInfo = _lodash2.default.get(referralInfo, 'showReferralInfo');
      var isAffiliate = _lodash2.default.get(referralInfo, 'isAffiliate');
      var announcement = (0, _countryCode.getValueFromCountryCode)('homepage-announcement', countryCode, strings);

      var body = void 0;
      // Wait until all data necessary is available for referral
      if (showReferralInfo && referralInfo && !_lodash2.default.isEmpty(products)) {
        body = _react2.default.createElement(_contentBody.ReferralFragment, {
          isAffiliate: isAffiliate,
          strings: strings,
          referralInfo: referralInfo,
          products: products });
      } else if (announcement) {
        body = _react2.default.createElement(_contentBody.AnnouncementFragment, {
          announcement: announcement,
          countryCode: countryCode,
          sections: _lodash2.default.get(model, 'widgetData.fields.sections') });
      } else {
        // If neither a referral or announcement exists, render nothing.
        return null;
      }

      var className = (0, _classnames2.default)('MessageBanner', 'fullWidth', 'noMarginTop', 'noMarginBottom');
      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'div',
          { className: 'content-wrapper' },
          body
        )
      );
    }
  }]);
  return MessageBanner;
}(_react2.default.PureComponent);

MessageBanner.propTypes = (0, _extends3.default)({}, widgetPropType);

MessageBanner.defaultProps = (0, _extends3.default)({}, widgetDefaultProps);

exports.default = (0, _countryCode2.default)(MessageBanner);

/***/ }),

/***/ "./app/components/landing/message-banner/message-banner.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/landing/social-cards.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

__webpack_require__("./app/components/landing/social-cards.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var widgetDefaultProps = _uiCommon.contentfulModels.widgetDefaultProps,
    widgetPropType = _uiCommon.contentfulModels.widgetPropType,
    getContentByType = _uiCommon.contentfulModels.getContentByType;
var getWidget = _uiCommon.contentfulViews.getWidget;

/**
 * SocialCards custom widget
 * @param {Object} widget WidgetPropType ui-common/models/widget
 */

var SocialCards = function SocialCards(_ref) {
  var sections = _ref.sections,
      model = _ref.model;

  var cardsList = _lodash2.default.map(getContentByType(sections, 'list'), function (_ref2) {
    var customWidgets = _ref2.customWidgets,
        stringSubstitutions = _ref2.stringSubstitutions,
        listModel = (0, _objectWithoutProperties3.default)(_ref2, ['customWidgets', 'stringSubstitutions']);
    return getWidget(listModel, customWidgets, stringSubstitutions);
  });

  var cta = _lodash2.default.map(getContentByType(sections, 'buttonLink'), getWidget);

  var scrollText = _lodash2.default.get(model, 'textStrings.media-card-swipe-to-see-more');
  var scrollMessage = scrollText ? _react2.default.createElement(
    'div',
    { className: 'scroll-message' },
    scrollText
  ) : null;

  return _react2.default.createElement(
    'div',
    { className: 'SocialCards' },
    _react2.default.createElement(
      'div',
      { className: 'cards-list' },
      cardsList
    ),
    scrollMessage,
    _react2.default.createElement(
      'div',
      { className: 'cta' },
      cta
    )
  );
};

SocialCards.propTypes = (0, _extends3.default)({}, widgetPropType);

SocialCards.defaultProps = (0, _extends3.default)({}, widgetDefaultProps);

exports.default = SocialCards;

/***/ }),

/***/ "./app/components/landing/social-cards.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/no-glowforge.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _features = __webpack_require__("./app/common/containers/features.js");

var _features2 = _interopRequireDefault(_features);

__webpack_require__("./app/components/no-glowforge.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonLink = _uiCommon.contentfulViews.ButtonLink,
    TextSection = _uiCommon.contentfulViews.TextSection;
var Markdown = _uiCommon.components.Markdown;


function NoGlowforge(props) {
  return _react2.default.createElement(
    'div',
    { className: 'NoGlowforge contentPage' },
    _react2.default.createElement(
      'div',
      { className: 'content' },
      _react2.default.createElement(Markdown, { source: _lodash2.default.get(props.title, 'text') }),
      _react2.default.createElement(
        'div',
        { className: 'cols fullWidth' },
        _react2.default.createElement(
          'div',
          { className: 'arrived' },
          _react2.default.createElement(TextSection, (0, _extends3.default)({}, props.arrivedSection, { headerClass: 'h4' })),
          _react2.default.createElement(ButtonLink, props.beginSetupButton)
        ),
        _react2.default.createElement(TextSection, (0, _extends3.default)({}, props.notArrivedSection, { headerClass: 'h4' })),
        _react2.default.createElement(TextSection, (0, _extends3.default)({}, props.addSomeonesSection, { headerClass: 'h4' })),
        _react2.default.createElement(TextSection, (0, _extends3.default)({}, props.haventPurchasedSection, { headerClass: 'h4' }))
      )
    )
  );
}

NoGlowforge.propTypes = {
  title: _propTypes2.default.string.isRequired,
  arrivedSection: TextSection.propTypes.isRequired,
  beginSetupButton: ButtonLink.propTypes.isRequired,
  notArrivedSection: TextSection.propTypes.isRequired,
  addSomeonesSection: TextSection.propTypes.isRequired,
  haventPurchasedSection: TextSection.propTypes.isRequired

};

NoGlowforge.defaultProps = {
  content: null
};

exports.default = (0, _features2.default)(NoGlowforge);

/***/ }),

/***/ "./app/components/no-glowforge.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/page-not-found.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _strings = __webpack_require__("./app/strings.js");

var _strings2 = _interopRequireDefault(_strings);

__webpack_require__("./app/components/page-not-found.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gtmEvent = _uiCommon.util.analytics.gtmEvent;

var PageNotFound = function (_React$Component) {
  (0, _inherits3.default)(PageNotFound, _React$Component);

  function PageNotFound() {
    (0, _classCallCheck3.default)(this, PageNotFound);
    return (0, _possibleConstructorReturn3.default)(this, (PageNotFound.__proto__ || (0, _getPrototypeOf2.default)(PageNotFound)).apply(this, arguments));
  }

  (0, _createClass3.default)(PageNotFound, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Log 404 event for analytics
      var referrer = _lodash2.default.get(this.props, 'location.query.ref');
      if (referrer) {
        // page was redirected by ecomm-core with query param as original route.
        gtmEvent('404', { referrer: referrer });
      } else {
        // Page is 404 on ecomm-front-end (route is either 404 or client side)
        var route = _lodash2.default.get(this.props, 'location.pathname');
        gtmEvent('404', { route: route });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'PageNotFound' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Page Not Found' }),
        _react2.default.createElement(
          'h1',
          { className: 'h1' },
          '404'
        ),
        _react2.default.createElement(
          'h4',
          { className: 'h4' },
          _strings2.default.PAGE_NOT_FOUND_SUB
        )
      );
    }
  }]);
  return PageNotFound;
}(_react2.default.Component);

exports.default = PageNotFound;

/***/ }),

/***/ "./app/components/page-not-found.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/root-apps/app.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/root-apps/basic-app.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _isElectron = __webpack_require__("./node_modules/is-electron/index.js");

var _isElectron2 = _interopRequireDefault(_isElectron);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _globalFooter = __webpack_require__("./app/common/components/global-footer.jsx");

var _globalFooter2 = _interopRequireDefault(_globalFooter);

var _navigation = __webpack_require__("./app/common/components/navigation/navigation.jsx");

var _navigation2 = _interopRequireDefault(_navigation);

var _errorBoundary = __webpack_require__("./app/common/components/error-boundary.jsx");

var _errorBoundary2 = _interopRequireDefault(_errorBoundary);

__webpack_require__("./node_modules/@glowforge/ui-common/stylesheets/base.less");

__webpack_require__("./app/components/root-apps/app.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var interpretedMetadataPropType = _uiCommon.contentfulModels.interpretedMetadataPropType;
var Notification = _uiCommon.components.Notification;
var PageMetadata = _uiCommon.contentfulViews.PageMetadata;
var MetaTags = _uiCommon.contentfulUtils.MetaTags;


var meta = function meta(canonicalUri) {
  var tags = new MetaTags();
  tags.push({ 'char-set': 'utf-8' });
  tags.push({ 'http-equiv': 'x-ua-compatible', content: 'ie=edge' });

  tags.name('viewport', 'width=device-width');
  tags.name('robots', 'noodp');

  tags.openGraph('locale', 'en_US');
  // og:url must be a specific page's url blank to default to the current url.
  tags.openGraph('url', canonicalUri);

  return tags.tags;
};

var BasicApp = function BasicApp(props) {
  var noticeLevelError = props.noticeLevelError,
      clearGlobalError = props.clearGlobalError,
      showFooter = props.showFooter,
      canonicalUri = props.canonicalUri,
      className = props.className,
      pageTitle = props.pageTitle,
      defaultMetadata = props.defaultMetadata,
      children = props.children;


  var notification = void 0;
  if (noticeLevelError) {
    notification = _react2.default.createElement(
      'div',
      { className: 'globalNotification' },
      _react2.default.createElement(Notification, {
        title: 'Error',
        text: noticeLevelError,
        onDismiss: clearGlobalError,
        level: 'error' })
    );
  }

  var footer = showFooter ? _react2.default.createElement(_globalFooter2.default, props) : null;

  var links = [{
    rel: 'alternate',
    type: 'application/rss+xml',
    title: 'Glowforge - the 3D Laser Printer » Home Comments Feed',
    href: 'https://glowforge.com/home/feed/'
  }];

  if (canonicalUri) {
    links.push({ rel: 'canonical', href: canonicalUri });
  }

  var navProps = (0, _extends3.default)({}, props);
  delete navProps.className;

  var defaultTitle = defaultMetadata.title,
      trimmedMetadata = (0, _objectWithoutProperties3.default)(defaultMetadata, ['title']);

  // data for global cookie notification.

  var cookieNotification = props.cookieNotification;

  // PageMetadata takes precedence over Helmet due to deeper component nesting.

  return _react2.default.createElement(
    'div',
    { className: 'App ' + className },
    _react2.default.createElement(_reactHelmet2.default, {
      titleTemplate: '%s | Glowforge',
      meta: meta(canonicalUri),
      link: links }),
    _react2.default.createElement(PageMetadata, (0, _extends3.default)({}, trimmedMetadata, {
      pageTitle: pageTitle || defaultTitle || 'Glowforge' })),
    !(0, _isElectron2.default)() && _react2.default.createElement(_navigation2.default, navProps),
    notification,
    _react2.default.createElement(
      _errorBoundary2.default,
      null,
      children
    ),
    footer
  );
};

BasicApp.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired,
  cookieNotification: _propTypes2.default.shape({}),
  pageTitle: _propTypes2.default.string,
  className: _propTypes2.default.string,
  showFooter: _propTypes2.default.bool,
  noticeLevelError: _propTypes2.default.string,
  clearGlobalError: _propTypes2.default.func.isRequired,
  includeBuyButton: _propTypes2.default.bool,
  defaultMetadata: _propTypes2.default.shape(interpretedMetadataPropType),
  canonicalUri: _propTypes2.default.string,
  route: _propTypes2.default.shape({ path: _propTypes2.default.string })
};

BasicApp.defaultProps = {
  cookieNotification: {},
  preloadError: null,
  noticeLevelError: null,
  className: '',
  pageTitle: null,
  showFooter: false,
  includeBuyButton: false,
  defaultMetadata: {},
  canonicalUri: null,
  route: {}
};

exports.default = BasicApp;

/***/ }),

/***/ "./app/components/root-apps/marketing-app.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _globalFooter = __webpack_require__("./app/common/components/global-footer.jsx");

var _globalFooter2 = _interopRequireDefault(_globalFooter);

__webpack_require__("./node_modules/@glowforge/ui-common/stylesheets/base.less");

__webpack_require__("./node_modules/@glowforge/ui-common/components/navigation/top-nav.less");

var _basicApp = __webpack_require__("./app/components/root-apps/basic-app.jsx");

var _basicApp2 = _interopRequireDefault(_basicApp);

__webpack_require__("./app/components/root-apps/marketing-app.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Page = _uiCommon.contentfulViews.Page;


var MarketingApp = function MarketingApp(props) {
  return _react2.default.createElement(
    _basicApp2.default,
    (0, _extends3.default)({}, props, { className: 'MarketingApp', includeBuyButton: true }),
    _react2.default.createElement(Page, props),
    _react2.default.createElement(_globalFooter2.default, props)
  );
};

exports.default = MarketingApp;

/***/ }),

/***/ "./app/components/root-apps/marketing-app.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/root-apps/settings-app.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _globalFooter = __webpack_require__("./app/common/components/global-footer.jsx");

var _globalFooter2 = _interopRequireDefault(_globalFooter);

var _settingsLeftNav = __webpack_require__("./app/components/settings/settings-left-nav.jsx");

var _settingsLeftNav2 = _interopRequireDefault(_settingsLeftNav);

__webpack_require__("./node_modules/@glowforge/ui-common/stylesheets/base.less");

var _basicApp = __webpack_require__("./app/components/root-apps/basic-app.jsx");

var _basicApp2 = _interopRequireDefault(_basicApp);

__webpack_require__("./app/components/root-apps/settings-app.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Wraps the Basic App and sdds a Sub-Nav bar (not needed for all pages)
var SettingsApp = function SettingsApp(props) {
  return _react2.default.createElement(
    _basicApp2.default,
    (0, _extends3.default)({}, props, { className: 'SettingsApp' }),
    _react2.default.createElement(
      'div',
      { className: 'content' },
      _react2.default.createElement(_settingsLeftNav2.default, null),
      _react2.default.createElement(
        'div',
        { className: 'container' },
        props.children
      )
    ),
    _react2.default.createElement(_globalFooter2.default, props)
  );
};

SettingsApp.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired
};

exports.default = SettingsApp;

/***/ }),

/***/ "./app/components/root-apps/settings-app.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/settings/accept-invite.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reduxForm = __webpack_require__("./node_modules/redux-form/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _submitActions = __webpack_require__("./app/common/components/forms/submit-actions.jsx");

var _submitActions2 = _interopRequireDefault(_submitActions);

var _generalAccountFields = __webpack_require__("./app/components/settings/general-account-fields.jsx");

var _passwordFields = __webpack_require__("./app/components/settings/password-fields.jsx");

__webpack_require__("./app/components/settings/accept-invite.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Markdown = _uiCommon.components.Markdown;


function validateAcceptInvite(values) {
  var errors = (0, _generalAccountFields.validateAccountInfo)(values);
  return (0, _passwordFields.validateSetPassword)(values, errors);
}

var AcceptInviteForm = function AcceptInviteForm(props) {
  return _react2.default.createElement(
    'form',
    { className: 'AcceptInviteForm', method: 'post', onSubmit: props.handleSubmit },
    (0, _generalAccountFields.GeneralAccountFields)(),
    (0, _passwordFields.SetPasswordFields)(),
    _react2.default.createElement(_submitActions2.default, (0, _extends3.default)({}, props, { submitText: props.submitButton }))
  );
};

AcceptInviteForm.propTypes = {
  handleSubmit: _propTypes2.default.func.isRequired,
  submitButton: _propTypes2.default.string
};

AcceptInviteForm.defaultProps = {
  submitButton: 'Create Account'
};

// Decorate the form component
AcceptInviteForm = (0, _reduxForm.reduxForm)({
  form: 'acceptInvite',
  enableReinitialize: true,
  validate: validateAcceptInvite
})(AcceptInviteForm);

// General Account Form Wrapper with heading
var GeneralAccount = function GeneralAccount(props) {
  var sideBarContent = void 0;
  if (props.sideBarContent && props.sideBarContent.length > 0) {
    sideBarContent = _react2.default.createElement(Markdown, { className: 'ContentColumn', source: props.sideBarContent });
  }
  return _react2.default.createElement(
    'div',
    { className: 'AcceptInvite' },
    _react2.default.createElement(
      'div',
      { className: 'content' },
      _react2.default.createElement(
        'h2',
        { className: 'h2' },
        props.inviterName,
        _react2.default.createElement('br', null),
        ' ',
        props.title
      ),
      _react2.default.createElement(
        'div',
        { className: 'columns' },
        _react2.default.createElement(
          'div',
          { className: 'AcceptInviteFormColumn' },
          _react2.default.createElement(
            'h3',
            { className: 'h3' },
            props.formHeader
          ),
          _react2.default.createElement(AcceptInviteForm, props)
        ),
        sideBarContent
      )
    )
  );
};

GeneralAccount.propTypes = {
  inviterName: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string,
  formHeader: _propTypes2.default.string,
  sideBarContent: _propTypes2.default.string
};

GeneralAccount.defaultProps = {
  title: 'invited you to print on their Glowforge',
  formHeader: 'Create your account',
  sideBarContent: ''
};

exports.default = GeneralAccount;

/***/ }),

/***/ "./app/components/settings/accept-invite.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/settings/change-access-dialog.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reduxForm = __webpack_require__("./node_modules/redux-form/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _dialog = __webpack_require__("./app/common/components/dialog.jsx");

var _dialog2 = _interopRequireDefault(_dialog);

var _submitActions = __webpack_require__("./app/common/components/forms/submit-actions.jsx");

var _submitActions2 = _interopRequireDefault(_submitActions);

var _machines = __webpack_require__("./app/selectors/machines.js");

var _features = __webpack_require__("./app/common/containers/features.js");

var _features2 = _interopRequireDefault(_features);

var _machineCheckboxGroup = __webpack_require__("./app/components/settings/machine-checkbox-group.jsx");

var _machineCheckboxGroup2 = _interopRequireDefault(_machineCheckboxGroup);

var _machineAccessField = __webpack_require__("./app/containers/settings/machine-access-field.js");

var _machineAccessField2 = _interopRequireDefault(_machineAccessField);

var _subscriptionsToggle = __webpack_require__("./app/components/settings/subscriptions-toggle.jsx");

var _subscriptionsToggle2 = _interopRequireDefault(_subscriptionsToggle);

__webpack_require__("./app/components/settings/change-access-dialog.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageStringsPropType = _uiCommon.contentfulModels.pageStringsPropType;


var UserAccessForm = function UserAccessForm(props) {
  // eslint-disable-line
  var name = _lodash2.default.get(props.user, 'displayName') ? _lodash2.default.get(props.user, 'displayName') : _lodash2.default.get(props.user, 'name');

  var machines = void 0;

  var fieldComponent = _machineCheckboxGroup2.default;
  if (props.features.USER_ROLE_MANAGEMENT) fieldComponent = _machineAccessField2.default;

  // TODO: when this code migrates elsewhere, this kind of cleanup should be
  // done in the layer that gets machine lists -- that is it should mark there
  // whether the current user can modify it (can they even see the list of users
  // on a machine without manage access?!)
  //
  // Users can only change access to machines they manage, so ignore the rest.
  var managedMachines = props.machines.filter(function (machine) {
    return _lodash2.default.includes(machine.abilities, 'manage_access_to');
  });
  // TODO: [APP-3613] always execute this block after cleaning up USER_ROLE_MANAGEMENT flag.
  // For whatever reason, this still executes even as the cancel happens and
  // props.user becomes null so make sure not to try to access it in that case.
  if (props.user && (managedMachines.length > 0 || props.features.USER_ROLE_MANAGEMENT)) {
    machines = _react2.default.createElement(_reduxForm.Field, {
      name: 'machines',
      component: fieldComponent,
      email: props.user.email,
      options: managedMachines,
      pageStrings: props.pageStrings });
  }

  var email = _lodash2.default.get(props.user, 'email');

  return _react2.default.createElement(
    'form',
    { className: 'UserAccessForm', onSubmit: props.handleSubmit },
    _react2.default.createElement(
      'div',
      { className: 'EmailMemberHeader' },
      _react2.default.createElement(
        'h4',
        { className: 'h4' },
        name,
        _react2.default.createElement(
          'span',
          { className: 'email' },
          '(',
          email,
          ')'
        )
      ),
      _react2.default.createElement(_subscriptionsToggle2.default, {
        email: email,
        isSubscriber: props.isSubscriber,
        isSecondaryMember: props.isSecondaryMember,
        addedUsers: props.addedUsers,
        totalUsers: props.totalUsers,
        pageStrings: props.pageStrings })
    ),
    machines,
    _react2.default.createElement(_submitActions2.default, (0, _extends3.default)({}, props, {
      submitText: 'Save',
      successMessage: 'Access Changed!',
      inProgressMessage: 'Saving...',
      onCancel: props.onCancel }))
  );
};

UserAccessForm.propTypes = {
  handleSubmit: _propTypes2.default.func.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  machines: _propTypes2.default.arrayOf(_propTypes2.default.shape(_machines.machinePropType)),
  user: _propTypes2.default.shape({ email: _propTypes2.default.string }).isRequired,
  features: _propTypes2.default.object, // eslint-disable-line
  pageStrings: pageStringsPropType.isRequired,
  isSubscriber: _propTypes2.default.bool,
  isSecondaryMember: _propTypes2.default.bool,
  addedUsers: _propTypes2.default.array, // eslint-disable-line
  totalUsers: _propTypes2.default.number
};

UserAccessForm.defaultProps = {
  machines: [],
  machineListError: null,
  isSubscriber: false,
  isSecondaryMember: false,
  addedUsers: [],
  totalUsers: 0,
  onCancel: function onCancel() {}
};

UserAccessForm = (0, _reduxForm.reduxForm)({
  form: 'userAccessForm'
})(UserAccessForm);

var ChangeAccessDialog = function ChangeAccessDialog(props) {
  if (!props.isOpen) {
    return null;
  }

  var email = _lodash2.default.get(props.user, 'email');
  var isSecondaryMember = !!_lodash2.default.find(props.addedUsers, function (item) {
    return item.attributes.secondary_user_email === email;
  });

  var initialValues = {
    email: _lodash2.default.get(props.user, 'email'),
    machines: _lodash2.default.map(_lodash2.default.get(props.user, 'machines'), function (m) {
      return {
        serial: m.serial,
        machineName: m.machineName,
        roles: m.roles
      };
    }),
    subscriber: isSecondaryMember
  };

  // subscriptions related props
  var isSubscriptionsEnabled = props.isSubscriptionsEnabled,
      subscription = props.subscription,
      addedUsers = props.addedUsers;

  var subscriptionData = isSubscriptionsEnabled ? { subscription: subscription, addedUsers: addedUsers, email: initialValues.email } : {};

  var onSubmit = function onSubmit(values) {
    props.onAccessChangeSubmit(values, initialValues, subscriptionData);
  };

  var onSubmitSuccess = function onSubmitSuccess() {
    // Icky.. but right now the success notification is in the dialog
    // so i'm holding it open for a couple seconds.
    // We need to get global notifications up and running
    setTimeout(props.closeDialog, 2000);
  };

  return _react2.default.createElement(
    _dialog2.default,
    {
      className: 'ChangeAccessDialog',
      title: 'Glowforge Printer Access for:',
      isOpen: props.isOpen },
    _react2.default.createElement(UserAccessForm, (0, _extends3.default)({}, props, {
      isSecondaryMember: isSecondaryMember,
      initialValues: initialValues,
      onSubmit: onSubmit,
      onSubmitSuccess: onSubmitSuccess,
      onCancel: props.closeDialog }))
  );
};

ChangeAccessDialog.propTypes = {
  isOpen: _propTypes2.default.bool,
  onAccessChangeSubmit: _propTypes2.default.func.isRequired, // eslint-disable-line
  closeDialog: _propTypes2.default.func.isRequired,
  machines: _propTypes2.default.arrayOf(_propTypes2.default.shape(_machines.machinePropType)),
  user: _propTypes2.default.object, // eslint-disable-line
  features: _propTypes2.default.object, // eslint-disable-line
  isSubscriptionsEnabled: _propTypes2.default.bool,
  isSubscriber: _propTypes2.default.bool,
  subscription: _propTypes2.default.object, // eslint-disable-line
  addedUsers: _propTypes2.default.array, // eslint-disable-line
  totalUsers: _propTypes2.default.number,
  onSetMembership: _propTypes2.default.func
};

ChangeAccessDialog.defaultProps = {
  isOpen: false,
  machines: [],
  user: null,
  isSubscriptionsEnabled: false,
  isSubscriber: false,
  subscription: {},
  addedUsers: [],
  totalUsers: 0,
  onSetMembership: function onSetMembership() {}
};

exports.default = (0, _features2.default)(ChangeAccessDialog);

/***/ }),

/***/ "./app/components/settings/change-access-dialog.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/settings/general-account-fields.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeneralAccountFields = exports.validateAccountInfo = undefined;

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = __webpack_require__("./node_modules/redux-form/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _phoneNumber = __webpack_require__("./app/common/components/forms/phone-number.jsx");

var _phoneNumber2 = _interopRequireDefault(_phoneNumber);

var _util = __webpack_require__("./app/util.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Text = _uiCommon.components.Text,
    FormField = _uiCommon.components.FormField;


var TextWithLink = function TextWithLink(props) {
  var input = props.input,
      meta = props.meta,
      linkUrl = props.linkUrl,
      linkText = props.linkText,
      otherProps = (0, _objectWithoutProperties3.default)(props, ['input', 'meta', 'linkUrl', 'linkText']); // eslint-disable-line no-unused-vars

  var link = linkUrl && linkText ? _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'a',
      { href: linkUrl },
      linkText
    )
  ) : null;

  return _react2.default.createElement(
    FormField,
    (0, _extends3.default)({}, otherProps, { meta: meta }),
    _react2.default.createElement('input', (0, _extends3.default)({}, otherProps, input)),
    link
  );
};

TextWithLink.propTypes = (0, _extends3.default)({}, Text.propTypes, {
  linkUrl: _propTypes2.default.string,
  linkText: _propTypes2.default.string
});

TextWithLink.defaultProps = (0, _extends3.default)({}, Text.defaultProps);

var normalizePhone = function normalizePhone(value) {
  return (0, _util.removePhoneFormat)(value);
};

var validateAccountInfo = exports.validateAccountInfo = function validateAccountInfo(values) {
  var errors = {};
  if (!values.email) {
    errors.email = 'Required';
  } else if (!(0, _util.isValidEmailFormat)(values.email)) {
    errors.email = 'Invalid Email';
  }
  if (values.phone && (0, _util.removePhoneFormat)(values.phone).length !== 10) {
    errors.phone = 'Invalid Phone Number';
  }
  if (values.display_name && values.display_name.length > 15) {
    errors.display_name = 'Must be 15 characters or less.';
  }
  // Test name length
  // https://ux.stackexchange.com/a/55540
  var MAX_NAME_LENGTH = 50;
  if (values.first_name && values.first_name.length > MAX_NAME_LENGTH) {
    errors.first_name = 'First name must be 50 characters or less.';
  }
  if (values.last_name && values.last_name.length > MAX_NAME_LENGTH) {
    errors.last_name = 'Last name must be 50 characters or less.';
  }
  // Test for punctuation
  // This same regex is checked in ecomm-core, see PRs for STORE-2790
  // See Facebook's Name Policy https://www.facebook.com/help/292517374180078
  var punctuationRegex = /[!"#$%&()*+,./:;<=>?@^_`{|}~\\]+/g;
  if (punctuationRegex.test(values.first_name)) {
    errors.first_name = 'First name must not contain punctuation.';
  }
  if (punctuationRegex.test(values.last_name)) {
    errors.last_name = 'Last name must not contain punctuation.';
  }

  return errors;
};

var defaultOptions = {
  changeEmailLink: null // put a full URL here if you want to display a change email link


  // Add options to control changeEmailLink field, which should only be
  // displayed on the settings page, not the accept invite page
};var GeneralAccountFields = exports.GeneralAccountFields = function GeneralAccountFields() {
  var disableEmailInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;
  return [_react2.default.createElement(_reduxForm.Field, {
    key: 'firstName',
    className: 'firstName',
    name: 'first_name',
    label: 'First Name',
    autoComplete: 'given-name',
    component: Text }), _react2.default.createElement(_reduxForm.Field, {
    key: 'lastName',
    className: 'lastName',
    name: 'last_name',
    label: 'Last Name',
    autoComplete: 'family-name',
    component: Text }), _react2.default.createElement(_reduxForm.Field, {
    key: 'displayName',
    className: 'displayName',
    name: 'display_name',
    label: 'Nickname',
    autoComplete: 'display_name',
    component: Text }), _react2.default.createElement(_reduxForm.Field, {
    key: 'email',
    className: 'email',
    name: 'email',
    label: 'Email',
    disabled: disableEmailInput,
    linkUrl: options.changeEmailLink,
    linkText: 'Change email',
    component: TextWithLink }), _react2.default.createElement(_reduxForm.Field, {
    key: 'phone',
    className: 'phone',
    name: 'phone',
    label: 'Phone',
    normalize: normalizePhone,
    component: _phoneNumber2.default })];
};

/***/ }),

/***/ "./app/components/settings/general-account.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reduxForm = __webpack_require__("./node_modules/redux-form/es/index.js");

var _submitActions = __webpack_require__("./app/common/components/forms/submit-actions.jsx");

var _submitActions2 = _interopRequireDefault(_submitActions);

var _generalAccountFields = __webpack_require__("./app/components/settings/general-account-fields.jsx");

__webpack_require__("./app/components/settings/general-account.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function changeEmailLink() {
  return global.sharedEnv.USER_SERVICE_SERVER + '/users/email_change';
}

var GeneralAccountForm = function GeneralAccountForm(props) {
  return _react2.default.createElement(
    'form',
    { className: 'GeneralAccountForm', onSubmit: props.handleSubmit },
    (0, _generalAccountFields.GeneralAccountFields)(true, { changeEmailLink: changeEmailLink() }),
    _react2.default.createElement(_submitActions2.default, props)
  );
};

GeneralAccountForm.propTypes = {
  handleSubmit: _propTypes2.default.func.isRequired
};

// Decorate the form component
GeneralAccountForm = (0, _reduxForm.reduxForm)({
  form: 'generalAccount',
  enableReinitialize: true,
  validate: _generalAccountFields.validateAccountInfo
})(GeneralAccountForm);

// General Account Form Wrapper with heading
var GeneralAccount = function GeneralAccount(props) {
  return _react2.default.createElement(
    'div',
    { className: 'GeneralAccount' },
    _react2.default.createElement(
      'h1',
      { className: 'h2' },
      'General Account Settings'
    ),
    _react2.default.createElement(GeneralAccountForm, props)
  );
};

exports.default = GeneralAccount;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./app/components/settings/general-account.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/settings/invites.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _machines = __webpack_require__("./app/selectors/machines.js");

var _machineCell = __webpack_require__("./app/components/settings/machine-cell.jsx");

__webpack_require__("./app/components/settings/invites.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Invites = function Invites(props) {
  var rows = _lodash2.default.map(props.pendingInvites, function (invite, index) {
    return _react2.default.createElement(
      'tr',
      { key: index },
      _react2.default.createElement(
        'td',
        { className: 'name' },
        invite.email
      ),
      _react2.default.createElement(
        'td',
        null,
        (0, _machineCell.renderMachineCell)(invite.machines)
      )
    );
  });

  return _react2.default.createElement(
    'div',
    { className: 'Invites' },
    _react2.default.createElement(
      'div',
      { className: 'tableWrapper' },
      _react2.default.createElement(
        'table',
        { className: 'styledTable striped' },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            { className: 'header label' },
            _react2.default.createElement(
              'th',
              null,
              'Email'
            ),
            _react2.default.createElement(
              'th',
              null,
              'Access To...'
            )
          )
        ),
        _react2.default.createElement(
          'tbody',
          null,
          rows
        )
      )
    )
  );
};

Invites.propTypes = {
  pendingInvites: _propTypes2.default.arrayOf(_propTypes2.default.shape(_machines.pendingInvitesPropTypes)).isRequired
};

exports.default = Invites;

/***/ }),

/***/ "./app/components/settings/invites.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/settings/machine-access-field.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _machines = __webpack_require__("./app/selectors/machines.js");

var _strings = __webpack_require__("./app/strings.js");

var _strings2 = _interopRequireDefault(_strings);

__webpack_require__("./app/components/settings/machine-access-field.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageStringsPropType = _uiCommon.contentfulModels.pageStringsPropType;
var stringSubstitution = _uiCommon.contentfulUtils.stringSubstitution;
var Button = _uiCommon.components.Button,
    Checkbox = _uiCommon.components.Checkbox,
    Select = _uiCommon.components.Select,
    MachineBadge = _uiCommon.components.MachineBadge,
    Tooltip = _uiCommon.components.Tooltip,
    SVG = _uiCommon.components.SVG;


var MachineAccessField = function MachineAccessField(props) {
  var grants = props.grants,
      input = props.input,
      isSubscriber = props.isSubscriber,
      pageStrings = props.pageStrings;

  // This has to be set to be _something_. Otherwise, the redux-form select
  // SHOWs the first item in the dropdown but that value isn't passed through
  // when the form is submitted. See:
  // https://github.com/redux-form/redux-form/issues/3226
  //
  // For now setting this to 'standard_user' aka Guest becaues that was the
  // first option in the list but it's possible we want this to be 'manager'
  // because that's the current default behavior (and future behavior for users
  // who don't have subscriptions).

  var defaultRoles = ['standard_user'];

  var selectAll = function selectAll() {
    var newValue = _lodash2.default.cloneDeep(input.value) || [];
    _lodash2.default.each(props.options, function (opt) {
      if (_lodash2.default.isEmpty(_lodash2.default.find(newValue, function (elem) {
        return elem.serial === opt.serial;
      }))) {
        newValue.push({
          serial: opt.serial,
          machineName: opt.machineName,
          roles: defaultRoles,
          grants: grants
        });
      }
    });
    input.onChange(newValue);
  };

  var removeAll = function removeAll() {
    return input.onChange([]);
  };

  var list = _lodash2.default.map(props.options, function (machine, index) {
    var rowValue = _lodash2.default.find(input.value, function (elem) {
      return elem.serial === machine.serial;
    });
    var isOwner = _lodash2.default.includes(machine.ownerEmails, props.email);

    var onCheckboxChange = function onCheckboxChange(value) {
      var newValue = _lodash2.default.cloneDeep(input.value);
      if (_lodash2.default.isNil(newValue) || _lodash2.default.isEmpty(newValue)) newValue = [];
      if (value) {
        newValue.push({
          serial: machine.serial,
          machineName: machine.machineName,
          roles: defaultRoles,
          grants: grants
        });
      } else {
        _lodash2.default.remove(newValue, function (elem) {
          return elem.serial === machine.serial;
        });
      }

      return input.onChange(newValue);
    };

    var onSelectChange = function onSelectChange(value) {
      var newValue = _lodash2.default.cloneDeep(input.value);
      _lodash2.default.find(newValue, function (elem) {
        return elem.serial === machine.serial;
      }).roles = [value.value];

      return input.onChange(newValue);
    };

    var youOwner = pageStrings['settings-users-owner-is-you'] || 'You';
    var nobodyOwner = pageStrings['settings-users-owner-is-nobody'] || 'Nobody';
    var ownedBy = pageStrings['settings-users-owner-is-other'] || 'Owned by: {{ownerName}}';

    var ownerName = machine.isOwner ? youOwner : machine.ownerName;
    if (_lodash2.default.isEmpty(ownerName)) ownerName = nobodyOwner;
    var ownerString = stringSubstitution(ownedBy, { ownerName: ownerName });

    // Pull role labels from contentful if available
    var roleOptions = _lodash2.default.map(_strings2.default.USER_MACHINE_ROLES, function (displayName, role) {
      return {
        value: role,
        label: pageStrings['settings-users-role-label-' + role.replace('_', '-')] || displayName,
        disabled: !isSubscriber && role === 'standard_user' // Guest role disabled for non-subscribers
      };
    });

    // Look up the source for react-select v1.0. Fun times.
    var optionRenderer = function optionRenderer(option) {
      if (!isSubscriber && option.value === 'standard_user') {
        return _react2.default.createElement(
          'span',
          { className: 'optionContainer' },
          _react2.default.createElement(
            'span',
            null,
            option.label
          ),
          _react2.default.createElement(SVG, {
            className: 'clearSvg',
            id: 'premium-gem' })
        );
      }
      return _react2.default.createElement(
        'span',
        { className: 'optionContainer' },
        option.label
      );
    };

    // Default role depends on if you are a subscriber or not.
    // If the user has no roles, then they are assigned a default role
    var roleValue = isSubscriber ? _lodash2.default.first(_lodash2.default.get(rowValue, 'roles')) : 'manager';
    var roleSelectDisabled = _lodash2.default.isNil(rowValue);
    var roleSelect = void 0;
    if (isOwner) {
      roleSelect = pageStrings['settings-users-role-label-owner'] || 'Owner';
    } else {
      roleSelect = _react2.default.createElement(Select, {
        name: machine.serial + '-role',
        value: roleSelectDisabled ? '' : roleValue,
        searchable: false,
        clearable: false,
        options: roleOptions,
        onChange: onSelectChange,
        disabled: roleSelectDisabled,
        optionRenderer: optionRenderer });
    }

    return _react2.default.createElement(
      'tr',
      { key: index, className: isOwner ? 'disabled' : '' },
      _react2.default.createElement(
        'td',
        { className: 'toggle' },
        _react2.default.createElement(Checkbox, (0, _extends3.default)({}, input, {
          id: machine.serial,
          value: _lodash2.default.isObject(rowValue),
          className: 'machine',
          name: machine.serial,
          onChange: onCheckboxChange,
          disabled: isOwner }))
      ),
      _react2.default.createElement(
        'td',
        { className: 'machineName' },
        _react2.default.createElement(
          Tooltip,
          { position: 'top', infoText: ownerString },
          _react2.default.createElement(
            'label',
            { htmlFor: machine.serial },
            machine.machineName,
            ' ',
            _react2.default.createElement(MachineBadge, { model: machine.model })
          )
        )
      ),
      _react2.default.createElement(
        'td',
        { className: 'role' },
        roleSelect
      )
    );
  });

  var errorMessage = void 0;
  if (!_lodash2.default.get(props.meta, 'valid') && (_lodash2.default.get(props.meta, 'dirty') || _lodash2.default.get(props.meta, 'touched'))) {
    errorMessage = _react2.default.createElement(
      'span',
      { className: 'errorMessage' },
      ' - ',
      _lodash2.default.get(props.meta, 'error')
    );
  }

  return _react2.default.createElement(
    'div',
    { className: 'MachineAccessField' },
    _react2.default.createElement(
      'table',
      { className: 'styledTable' },
      _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          { className: 'header label' },
          _react2.default.createElement(
            'th',
            { className: 'toggle' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                Button,
                { type: 'text', onClick: selectAll },
                'All'
              ),
              _react2.default.createElement(
                'span',
                { className: 'divider' },
                '/'
              ),
              _react2.default.createElement(
                Button,
                { type: 'text', onClick: removeAll },
                'None'
              )
            )
          ),
          _react2.default.createElement(
            'th',
            null,
            'Printer ',
            errorMessage
          ),
          _react2.default.createElement(
            'th',
            null,
            'Role'
          )
        )
      ),
      _react2.default.createElement(
        'tbody',
        null,
        list
      )
    )
  );
};

MachineAccessField.propTypes = {
  email: _propTypes2.default.string,
  grants: _propTypes2.default.arrayOf(_propTypes2.default.string),
  input: _propTypes2.default.shape({ onChange: _propTypes2.default.func }).isRequired,
  isSubscriber: _propTypes2.default.bool,
  meta: _propTypes2.default.shape({
    valid: _propTypes2.default.bool.isRequired,
    touched: _propTypes2.default.bool.isRequired,
    error: _propTypes2.default.string
  }).isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape(_machines.machinePropType)).isRequired,
  pageStrings: pageStringsPropType.isRequired
};

MachineAccessField.defaultProps = {
  email: '',
  grants: [],
  isSubscriber: false
};

exports.default = MachineAccessField;

/***/ }),

/***/ "./app/components/settings/machine-access-field.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/settings/machine-cell.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderMachineCell = undefined;

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tooltip = _uiCommon.components.Tooltip;
var renderMachineCell = exports.renderMachineCell = function renderMachineCell(machines) {
  // eslint-disable-line
  if (machines.length <= 3) {
    return _lodash2.default.map(machines, function (m) {
      return m.machineName;
    }).join(' & ');
  }
  var list = _lodash2.default.map(machines, function (m) {
    return _react2.default.createElement(
      'div',
      null,
      m.machineName
    );
  });
  return _react2.default.createElement(
    Tooltip,
    { infoText: list },
    _react2.default.createElement(
      'span',
      null,
      machines.length + ' printers'
    )
  );
};

/***/ }),

/***/ "./app/components/settings/machine-checkbox-group.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/toConsumableArray.js");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _machines = __webpack_require__("./app/selectors/machines.js");

__webpack_require__("./app/components/settings/machine-checkbox-group.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MachineBadge = _uiCommon.components.MachineBadge,
    Button = _uiCommon.components.Button,
    Checkbox = _uiCommon.components.Checkbox;

/**
 * @deprecated Replaced by MachineAccessField {@link MachineAccessField} using feature flag
 * 'USER_ROLE_MANAGEMENT'. See {@link UserInviteForm}. This component will be removed by APP-3613.
 * TODO: Above is not quite correct -- it seems likely we're keeping both forms that this
 * component is part of on the user settings page since one will be a subscriber feature.
 */

var MachineCheckboxGroup = function MachineCheckboxGroup(props) {
  var input = props.input;
  var grants = props.grants;

  var machineNames = _lodash2.default.mapValues(_lodash2.default.keyBy(props.options, 'serial'), 'machineName');

  // The newer version of this component manages a list of machine objects
  // instead of just serials. readValue/writeValue transform between the old
  // style and new style so the components can be switched out with a feature
  // flag.
  var readValue = function readValue(rawValue) {
    return _lodash2.default.map(rawValue, function (m) {
      return m.serial;
    });
  };

  // All users are managers under the legacy system, so use that as the default.
  var writeValue = function writeValue(internalValue) {
    return _lodash2.default.map(internalValue, function (s) {
      return { serial: s, machineName: machineNames[s], roles: ['manager'], grants: grants };
    });
  };

  var selectAll = function selectAll() {
    var newValue = _lodash2.default.map(props.options, function (m) {
      return m.serial;
    });
    input.onChange(writeValue(newValue));
  };

  var removeAll = function removeAll() {
    return input.onChange([]);
  };

  var list = _lodash2.default.map(props.options, function (machine, index) {
    var onChange = function onChange(value) {
      var newValue = [].concat((0, _toConsumableArray3.default)(readValue(input.value)));
      if (value) {
        newValue.push(machine.serial);
      } else {
        newValue.splice(newValue.indexOf(machine.serial), 1);
      }

      return input.onChange(writeValue(newValue));
    };

    return _react2.default.createElement(
      'tr',
      { key: index },
      _react2.default.createElement(
        'td',
        { className: 'toggle' },
        _react2.default.createElement(Checkbox, (0, _extends3.default)({}, input, {
          value: _lodash2.default.includes(readValue(input.value), machine.serial),
          className: 'machine',
          name: machine.serial,
          onChange: onChange }))
      ),
      _react2.default.createElement(
        'td',
        { className: 'machineName' },
        machine.machineName,
        ' ',
        _react2.default.createElement(MachineBadge, { model: machine.model })
      ),
      _react2.default.createElement(
        'td',
        { className: 'ownerName' },
        machine.isOwner ? 'You' : machine.ownerName
      )
    );
  });

  var errorMessage = void 0;
  if (!_lodash2.default.get(props.meta, 'valid') && (_lodash2.default.get(props.meta, 'dirty') || _lodash2.default.get(props.meta, 'touched'))) {
    errorMessage = _react2.default.createElement(
      'span',
      { className: 'errorMessage' },
      ' - ',
      _lodash2.default.get(props.meta, 'error')
    );
  }

  return _react2.default.createElement(
    'div',
    { className: 'MachineCheckboxGroup' },
    _react2.default.createElement(
      'table',
      { className: 'styledTable' },
      _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          { className: 'header label' },
          _react2.default.createElement(
            'th',
            { className: 'toggle' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                Button,
                { type: 'text', onClick: selectAll },
                'All'
              ),
              _react2.default.createElement(
                'span',
                { className: 'divider' },
                '/'
              ),
              _react2.default.createElement(
                Button,
                { type: 'text', onClick: removeAll },
                'None'
              )
            )
          ),
          _react2.default.createElement(
            'th',
            null,
            'Printer ',
            errorMessage
          ),
          _react2.default.createElement(
            'th',
            null,
            'Owner'
          )
        )
      ),
      _react2.default.createElement(
        'tbody',
        null,
        list
      )
    )
  );
};

MachineCheckboxGroup.propTypes = {
  grants: _propTypes2.default.arrayOf(_propTypes2.default.string),
  input: _propTypes2.default.shape({ onChange: _propTypes2.default.func }).isRequired,
  meta: _propTypes2.default.shape({
    valid: _propTypes2.default.bool.isRequired,
    touched: _propTypes2.default.bool.isRequired,
    error: _propTypes2.default.string
  }).isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape(_machines.machinePropType)).isRequired
};

MachineCheckboxGroup.defaultProps = {
  grants: []
};

exports.default = MachineCheckboxGroup;

/***/ }),

/***/ "./app/components/settings/machine-checkbox-group.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/settings/order.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _orderCostSummary = __webpack_require__("./app/store/components/common/order-cost-summary.jsx");

var _orderCostSummary2 = _interopRequireDefault(_orderCostSummary);

var _products = __webpack_require__("./app/store/selectors/products.js");

var _util = __webpack_require__("./app/util.js");

__webpack_require__("./app/components/settings/order.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = function Item(props) {
  return _react2.default.createElement(
    'div',
    { className: 'Item' },
    _react2.default.createElement(
      'div',
      { className: 'description' },
      _react2.default.createElement(
        'h4',
        { className: 'h4' },
        props.name
      ),
      _react2.default.createElement(
        'div',
        { className: 'subTitle caption' },
        props.subTitle
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'ppCost' },
      (0, _util.formatPrice)(props.price),
      ' /ea.'
    ),
    _react2.default.createElement(
      'div',
      { className: 'quantity' },
      'x ',
      props.quantity
    ),
    _react2.default.createElement(
      'div',
      { className: 'totalCost' },
      (0, _util.formatPrice)(props.amount)
    )
  );
};

Item.propTypes = (0, _extends3.default)({}, _products.orderItemPropType);

var Order = function Order(props) {
  var items = _lodash2.default.map(props.items, function (item, index) {
    return _react2.default.createElement(Item, (0, _extends3.default)({ key: index }, item));
  });

  var warning = void 0;
  if (props.warning) {
    warning = _react2.default.createElement(
      'div',
      { className: 'warning' },
      props.warning
    );
  }

  return _react2.default.createElement(
    'div',
    { className: 'Order container' },
    warning,
    _react2.default.createElement(
      'div',
      { className: 'baseInfo' },
      _react2.default.createElement(
        'div',
        { className: 'orderDate' },
        _react2.default.createElement(
          'div',
          { className: 'caption' },
          'Order Placed'
        ),
        _react2.default.createElement(
          'div',
          null,
          (0, _moment2.default)(props.createdAt).format('LL')
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'orderNumber' },
        _react2.default.createElement(
          'div',
          { className: 'caption' },
          'Order Number'
        ),
        _react2.default.createElement(
          'div',
          null,
          props.number
        )
      )
    ),
    items,
    _react2.default.createElement(_orderCostSummary2.default, props)
  );
};

Order.propTypes = (0, _extends3.default)({}, _products.orderPropType);

exports.default = Order;

/***/ }),

/***/ "./app/components/settings/order.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/settings/password-fields.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResetPasswordFields = exports.SetPasswordFields = undefined;

var _toConsumableArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/toConsumableArray.js");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.validateSetPassword = validateSetPassword;
exports.validateResetPassword = validateResetPassword;

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reduxForm = __webpack_require__("./node_modules/redux-form/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Text = _uiCommon.components.Text;


var minPasswordLength = 8; // minimum for user-service

function validateSetPassword(values) {
  var errors = {};
  if (!values.password) {
    errors.password = 'Required';
  } else if (!values.password || values.password.length < minPasswordLength) {
    errors.password = 'Your new password must be at least ' + minPasswordLength + ' characters';
  }
  if (!values.password_confirmation) {
    errors.password_confirmation = 'Required';
  } else if (values.password_confirmation !== values.password) {
    errors.password_confirmation = 'Your passwords do not match!';
  }

  return errors;
}

function validateResetPassword(values) {
  var errors = validateSetPassword(values);
  if (!values.current_password) {
    errors.current_password = 'Required';
  } else if (!values.password && values.current_password === values.password) {
    errors.password = 'Your new password must be different';
  }

  return errors;
}

var SetPasswordFields = exports.SetPasswordFields = function SetPasswordFields() {
  var passwordLabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Password';
  return [_react2.default.createElement(_reduxForm.Field, {
    key: 'newPassword',
    className: 'newPassword',
    name: 'password',
    label: passwordLabel,
    type: 'password',
    component: Text }), _react2.default.createElement(_reduxForm.Field, {
    key: 'verifyPassword',
    className: 'verifyPassword',
    name: 'password_confirmation',
    type: 'password',
    label: 'Confirm ' + passwordLabel,
    component: Text })];
};

var ResetPasswordFields = exports.ResetPasswordFields = function ResetPasswordFields() {
  return [_react2.default.createElement(_reduxForm.Field, {
    key: 'currentPassword',
    className: 'currentPassword',
    name: 'current_password',
    label: 'Current Password',
    type: 'password',
    component: Text })].concat((0, _toConsumableArray3.default)(SetPasswordFields('New Password')));
};

/***/ }),

/***/ "./app/components/settings/password.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reduxForm = __webpack_require__("./node_modules/redux-form/es/index.js");

var _submitActions = __webpack_require__("./app/common/components/forms/submit-actions.jsx");

var _submitActions2 = _interopRequireDefault(_submitActions);

var _passwordFields = __webpack_require__("./app/components/settings/password-fields.jsx");

__webpack_require__("./app/components/settings/password.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResetForm = function ResetForm(props) {
  return _react2.default.createElement(
    'form',
    { className: 'ResetForm', onSubmit: props.handleSubmit },
    (0, _passwordFields.ResetPasswordFields)(),
    _react2.default.createElement(_submitActions2.default, props)
  );
};

ResetForm.propTypes = {
  handleSubmit: _propTypes2.default.func.isRequired
};

var form = 'password';
var passwordFields = ['current_password', 'password', 'password_confirmation'];

// Decorate the form component
ResetForm = (0, _reduxForm.reduxForm)({
  form: form,
  enableReinitialize: true,
  validate: _passwordFields.validateResetPassword,
  // After successfully updating a user's profile, reset the password fields so.
  // they are not available using inspection tools.
  onSubmitSuccess: function onSubmitSuccess(result, dispatch) {
    return passwordFields.forEach(function (field) {
      dispatch((0, _reduxForm.change)(form, field, '')); // reset the field's value
      dispatch((0, _reduxForm.untouch)(form, field)); // reset the field's error
    });
  }
})(ResetForm);

var Password = function Password(props) {
  return _react2.default.createElement(
    'div',
    { className: 'Password' },
    _react2.default.createElement(
      'h1',
      { className: 'h2' },
      'Password Reset'
    ),
    _react2.default.createElement(ResetForm, props)
  );
};

Password.propTypes = {};

exports.default = Password;

/***/ }),

/***/ "./app/components/settings/password.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/settings/premium-gem-yellow.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("./node_modules/react/index.js");

function PremiumGemYellow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#E1A830","fillRule":"evenodd","d":"M2.715 0L0 3.484h3.121L4.488 0H2.715zm2.731 0L4.075 3.484h4.45L7.154 0H5.446zm2.666 0l1.367 3.484H12.6L9.885 0H8.112zM.028 4.48l4.95 5.775-1.87-5.775H.027zm4.019 0L6.3 11.442 8.554 4.48H4.047zm5.446 0l-1.871 5.775 4.95-5.775h-3.08z"}));
}

PremiumGemYellow.defaultProps = {"width":"13","height":"1","viewBox":"-3 -4 17 18"};

module.exports = PremiumGemYellow;

PremiumGemYellow.default = PremiumGemYellow;


/***/ }),

/***/ "./app/components/settings/printers.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _features = __webpack_require__("./app/common/containers/features.js");

var _features2 = _interopRequireDefault(_features);

var _machines = __webpack_require__("./app/selectors/machines.js");

var _strings = __webpack_require__("./app/strings.js");

var _strings2 = _interopRequireDefault(_strings);

var _appConstants = __webpack_require__("./app/app-constants.js");

__webpack_require__("./app/components/settings/printers.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MachineBadge = _uiCommon.components.MachineBadge,
    Button = _uiCommon.components.Button,
    SVG = _uiCommon.components.SVG;
var pageStringsPropType = _uiCommon.contentfulModels.pageStringsPropType;
var USER_MACHINE_ROLES = _strings2.default.USER_MACHINE_ROLES;


function ownershipDashboardLink() {
  return global.sharedEnv.GFCORE_SERVER + '/ownership-dashboard';
}

var Printers = function Printers(props) {
  var features = props.features,
      isLoading = props.isLoading,
      isRestricted = props.isRestricted,
      machines = props.machines,
      pageStrings = props.pageStrings;


  var addAPrinter = function addAPrinter() {
    if (machines.length > 0) {
      window.open('/setup/add_glowforge', '_blank');
    } else {
      window.open('/setup/first_glowforge', '_blank');
    }
  };
  var releaseAPrinter = function releaseAPrinter() {
    window.open(ownershipDashboardLink(), '_blank');
  };

  var ownsAPrinter = false;

  // TODO: probably should add usersString, owned by text, table headers, etc. to contentful

  var printers = _lodash2.default.map(machines, function (printer) {
    var usersString = '1 user has access';
    if (printer.userCount > 1) usersString = printer.userCount + ' users have access';
    if (printer.userCount === 0) usersString = null; // User doesn't have management access

    var lastPrintString = 'Never';
    if (printer.lastPrintAt) lastPrintString = (0, _moment2.default)(printer.lastPrintAt).format('l');

    var roleString = pageStrings['settings-users-role-label-standard-user'] || USER_MACHINE_ROLES.standard_user;
    // TODO: When modifying this to make only the "guest" role be subscriptions,
    // then the 'legacy' else below goes away.
    if (printer.isAdmin && !isRestricted) {
      if (features.USER_ROLE_MANAGEMENT) {
        roleString = pageStrings['settings-users-role-label-manager'] || USER_MACHINE_ROLES.manager;
      } else {
        // legacy, non-user-role case
        roleString = _appConstants.ACCOUNT_ACCESS.FULL_ACCESS;
      }
    } else {
      roleString = _appConstants.ACCOUNT_ACCESS.RESTRICTED;
    }
    if (printer.isOwner) {
      roleString = pageStrings['settings-users-role-label-owner'] || 'Owner';
      ownsAPrinter = true;
    }

    return _react2.default.createElement(
      'tr',
      { key: printer.machineName },
      _react2.default.createElement(
        'td',
        { className: 'name' },
        printer.machineName,
        _react2.default.createElement(MachineBadge, { model: printer.model })
      ),
      _react2.default.createElement(
        'td',
        null,
        roleString
      ),
      _react2.default.createElement(
        'td',
        null,
        lastPrintString
      ),
      _react2.default.createElement(
        'td',
        null,
        _react2.default.createElement(
          'div',
          null,
          usersString
        ),
        _react2.default.createElement(
          'div',
          null,
          '(owned by ',
          printer.ownerName,
          ')'
        )
      )
    );
  });

  var loading = void 0;
  if (isLoading) {
    loading = _react2.default.createElement(
      'div',
      { className: 'loadingIndicator' },
      _react2.default.createElement(SVG, { id: 'spinner' })
    );
  }

  var ownershipDashboardButton = ownsAPrinter ? _react2.default.createElement(
    Button,
    { className: 'secondaryButton secondary', onClick: releaseAPrinter },
    'Release a Printer'
  ) : null;

  var addPrinterButton = isRestricted ? null : _react2.default.createElement(
    Button,
    { onClick: addAPrinter },
    'Add a Printer'
  );

  return _react2.default.createElement(
    'div',
    { className: 'Printers' },
    _react2.default.createElement(
      'h1',
      { className: 'h2' },
      'Glowforge Printers',
      _react2.default.createElement(
        'span',
        { className: 'buttonsRight' },
        ownershipDashboardButton,
        addPrinterButton
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'tableWrapper' },
      _react2.default.createElement(
        'table',
        { className: 'styledTable striped ' + (isLoading ? 'loading' : '') },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            { className: 'header label' },
            _react2.default.createElement(
              'th',
              null,
              'Glowforge Name'
            ),
            _react2.default.createElement(
              'th',
              null,
              'Your Role'
            ),
            _react2.default.createElement(
              'th',
              null,
              'Last Print'
            ),
            _react2.default.createElement(
              'th',
              null,
              'Users'
            )
          )
        ),
        _react2.default.createElement(
          'tbody',
          null,
          printers
        )
      ),
      loading
    )
  );
};

Printers.propTypes = {
  machines: _propTypes2.default.arrayOf(_propTypes2.default.shape(_machines.machinePropType)),
  isLoading: _propTypes2.default.bool,
  isRestricted: _propTypes2.default.bool,
  features: _propTypes2.default.object, // eslint-disable-line
  pageStrings: pageStringsPropType.isRequired
};

Printers.defaultProps = {
  machines: [],
  isLoading: false,
  isRestricted: false
};

exports.default = (0, _features2.default)(Printers);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./app/components/settings/printers.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/settings/purchase-history.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _user = __webpack_require__("./app/selectors/user.js");

var _util = __webpack_require__("./app/util.js");

var _order = __webpack_require__("./app/components/settings/order.jsx");

var _order2 = _interopRequireDefault(_order);

__webpack_require__("./app/components/settings/purchase-history.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageStringsPropType = _uiCommon.contentfulModels.pageStringsPropType;


function getString(strings, key, defaultValue) {
  return _lodash2.default.get(strings, key, defaultValue);
}

var ShopifyAccountLink = function ShopifyAccountLink(props) {
  var pageStrings = props.pageStrings;

  var accountUrl = (0, _util.shopifyMultipassUrlBuilder)('/account', false);
  var text = getString(pageStrings, 'settings-purchase-history-shopify-link-text', 'Newer orders may be here');

  return _react2.default.createElement(
    'div',
    { className: 'shopifyAccountLinkContainer' },
    _react2.default.createElement(
      'a',
      { href: accountUrl },
      text
    )
  );
};

ShopifyAccountLink.propTypes = {
  pageStrings: pageStringsPropType.isRequired
};

var PurchaseHistory = function PurchaseHistory(props) {
  var pageStrings = props.pageStrings;


  var orders = _lodash2.default.map(props.purchaseHistory, function (order, index) {
    return _react2.default.createElement(_order2.default, (0, _extends3.default)({ key: index }, order));
  });

  var pageHeaderText = getString(pageStrings, 'settings-purchase-history-header-text', 'Purchase History');

  var noOrdersText = getString(pageStrings, 'settings-purchase-history-empty-orders-text', 'You have no Purchase History');

  var content = void 0;
  if (_lodash2.default.isEmpty(orders)) {
    content = _react2.default.createElement(
      'div',
      { className: 'empty' },
      noOrdersText
    );
  } else {
    content = _react2.default.createElement(
      'div',
      { className: 'orderList' },
      orders
    );
  }
  return _react2.default.createElement(
    'div',
    { className: 'PurchaseHistory' },
    _react2.default.createElement(
      'h1',
      { className: 'h2' },
      pageHeaderText
    ),
    _react2.default.createElement(ShopifyAccountLink, { pageStrings: pageStrings }),
    content
  );
};

PurchaseHistory.propTypes = {
  purchaseHistory: _propTypes2.default.arrayOf(_propTypes2.default.shape(_user.orderPropType)),
  pageStrings: pageStringsPropType.isRequired,
  isManagePending: _propTypes2.default.bool
};

PurchaseHistory.defaultProps = {
  purchaseHistory: []
};

exports.default = PurchaseHistory;

/***/ }),

/***/ "./app/components/settings/purchase-history.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/settings/settings-left-nav.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _settingsNav = __webpack_require__("./app/containers/settings/settings-nav.js");

var _settingsNav2 = _interopRequireDefault(_settingsNav);

__webpack_require__("./app/components/settings/settings-left-nav.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SETTINGS_UNRESTRICTED_NAV_LINKS = [{ text: 'General', path: '/settings/general' }, { text: 'Password', path: '/settings/password' }, { text: 'Manage Subscription', path: '/settings/subscription' }, { text: 'Glowforge Printers', path: '/settings/printers' }, { text: 'Users', path: '/settings/users' }, { text: 'Purchase History', path: '/settings/purchase-history' }];

var SETTINGS_RESTRICTED_NAV_LINKS = [{ text: 'General', path: '/settings/general' }, { text: 'Password', path: '/settings/password' }, { text: 'Glowforge Printers', path: '/settings/printers' }];

var SettingsLeftNav = function SettingsLeftNav(_ref) {
  var features = _ref.features,
      isRestricted = _ref.isRestricted;

  var accountLinks = isRestricted ? SETTINGS_RESTRICTED_NAV_LINKS : SETTINGS_UNRESTRICTED_NAV_LINKS;

  var enabledLinks = _lodash2.default.filter(accountLinks, function (link) {
    return !link.disabled || !link.disabled(features);
  });

  var links = _lodash2.default.map(enabledLinks, function (link, index) {
    return _react2.default.createElement(
      'li',
      { key: index },
      _react2.default.createElement(
        _reactIsomorphicRender.Link,
        {
          className: 'clearLink',
          to: link.path,
          activeClassName: 'active' },
        link.text
      )
    );
  });

  return _react2.default.createElement(
    'div',
    { className: 'SettingsLeftNav' },
    _react2.default.createElement(
      'ul',
      null,
      links
    )
  );
};

SettingsLeftNav.propTypes = {
  features: _propTypes2.default.object, // eslint-disable-line
  isRestricted: _propTypes2.default.bool
};

SettingsLeftNav.defaultProps = {
  features: {},
  isRestricted: false
};

exports.default = (0, _settingsNav2.default)(SettingsLeftNav);

/***/ }),

/***/ "./app/components/settings/settings-left-nav.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/settings/subscription.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = _uiCommon.components.Button;


function getString(strings, key, defaultValue) {
  return _.get(strings, key, defaultValue);
}
var pageStringsPropType = _uiCommon.contentfulModels.pageStringsPropType;


var Subscription = function Subscription(_ref) {
  var canManageSubscriptions = _ref.canManageSubscriptions,
      isManagePending = _ref.isManagePending,
      onManageSubscriptions = _ref.onManageSubscriptions,
      pageStrings = _ref.pageStrings,
      subscriptionManageLink = _ref.subscriptionManageLink;


  if (!canManageSubscriptions || !subscriptionManageLink || subscriptionManageLink.length == 0) {
    return null;
  }

  var handleUrl = function handleUrl(url) {
    window.open(url, '_blank');
  };

  var onClick = function onClick(e) {
    e.preventDefault();
    e.target.disabled = true;
    onManageSubscriptions(subscriptionManageLink, handleUrl);
  };

  var text = getString(pageStrings, 'settings-purchase-history-subscriptions-link-text', 'Manage Subscription');

  return _react2.default.createElement(
    'div',
    { className: 'Subscription' },
    _react2.default.createElement(
      'h1',
      { className: 'h2' },
      'Glowforge Premium'
    ),
    _react2.default.createElement(
      'div',
      { className: 'manageSubscriptionsLinkContainer' },
      _react2.default.createElement(
        Button,
        {
          type: 'text',
          className: 'externalLink',
          onClick: onClick,
          disabled: isManagePending },
        text
      )
    )
  );
};

Subscription.propTypes = {
  canManageSubscriptions: _propTypes2.default.bool,
  isManagePending: _propTypes2.default.bool,
  onManageSubscriptions: _propTypes2.default.func.isRequired, // eslint-disable-line
  pageStrings: pageStringsPropType.isRequired,
  subscriptionManageLink: _propTypes2.default.string
};

Subscription.defaultProps = {
  subscriptionManageLink: '',
  canManageSubscriptions: false,
  isManagePending: false
};

exports.default = Subscription;

/***/ }),

/***/ "./app/components/settings/subscriptions-toggle.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reduxForm = __webpack_require__("./node_modules/redux-form/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

__webpack_require__("./app/components/settings/subscriptions-toggle.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: This should eventually come from ui-common?
var PremiumIcon = __webpack_require__("./app/components/settings/premium-gem-yellow.svg");

var Checkbox = _uiCommon.components.Checkbox;
var stringSubstitution = _uiCommon.contentfulUtils.stringSubstitution;
var pageStringsPropType = _uiCommon.contentfulModels.pageStringsPropType;

/**
 * Control for making a user a subscription member or not.
 */

var SubscriptionsToggle = function SubscriptionsToggle(props) {
  if (!props.isSubscriber) {
    return null;
  }

  var addedUsers = props.addedUsers,
      totalUsers = props.totalUsers,
      isSecondaryMember = props.isSecondaryMember;


  var description = stringSubstitution(props.pageStrings['settings-users-seats-left-message'], { remaining: totalUsers - addedUsers.length, total: totalUsers });
  var isDisabled = addedUsers.length >= totalUsers && !isSecondaryMember;

  var renderCheckbox = function renderCheckbox(field) {
    return _react2.default.createElement(Checkbox, (0, _extends3.default)({}, field.input, {
      disabled: isDisabled,
      label: description,
      className: 'checkbox' }));
  };

  return _react2.default.createElement(
    'div',
    { className: 'SubscriptionsToggle' },
    _react2.default.createElement(_reduxForm.Field, { name: 'subscriber', component: renderCheckbox }),
    _react2.default.createElement(PremiumIcon, { className: 'premiumIcon' })
  );
  // TODO: above needs the (?) button to open help docs?
};

SubscriptionsToggle.propTypes = {
  isSubscriber: _propTypes2.default.bool,
  isSecondaryMember: _propTypes2.default.bool,
  addedUsers: _propTypes2.default.array, // eslint-disable-line
  totalUsers: _propTypes2.default.number,
  pageStrings: pageStringsPropType.isRequired
};

SubscriptionsToggle.defaultProps = {
  isSubscriber: false,
  isSecondaryMember: false,
  addedUsers: [],
  totalUsers: 0
};

exports.default = SubscriptionsToggle;

/***/ }),

/***/ "./app/components/settings/subscriptions-toggle.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/settings/user-invite-form.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserInviteForm = exports.formValidation = undefined;

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = __webpack_require__("./node_modules/redux-form/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _submitActions = __webpack_require__("./app/common/components/forms/submit-actions.jsx");

var _submitActions2 = _interopRequireDefault(_submitActions);

var _machines = __webpack_require__("./app/selectors/machines.js");

var _util = __webpack_require__("./app/util.js");

var _features = __webpack_require__("./app/common/containers/features.js");

var _features2 = _interopRequireDefault(_features);

var _machineAccessField = __webpack_require__("./app/containers/settings/machine-access-field.js");

var _machineAccessField2 = _interopRequireDefault(_machineAccessField);

var _machineCheckboxGroup = __webpack_require__("./app/components/settings/machine-checkbox-group.jsx");

var _machineCheckboxGroup2 = _interopRequireDefault(_machineCheckboxGroup);

__webpack_require__("./app/components/settings/user-invite-form.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageStringsPropType = _uiCommon.contentfulModels.pageStringsPropType;
var Markdown = _uiCommon.components.Markdown,
    SVG = _uiCommon.components.SVG,
    Text = _uiCommon.components.Text;
var formValidation = exports.formValidation = function formValidation(values) {
  var errors = {};
  if (!values.email) {
    errors.email = 'Required';
  } else {
    var invalidEmails = (0, _util.getInvalidEmails)(values.email).filter(Boolean);

    if (invalidEmails.length > 1) {
      errors.email = invalidEmails.join(', ') + ' are not valid emails.';
    } else if (invalidEmails.length === 1) {
      errors.email = invalidEmails[0] + ' is not a valid email.';
    }
  }

  if (!_lodash2.default.size(values.machines)) {
    errors.machines = 'Please select a machine';
  }
  return errors;
};

var exceedsAddedUserCount = function exceedsAddedUserCount(totalAllowed) {
  return function (value) {
    if (!value) return null;

    var emailCount = value.split(',').filter(Boolean).length;
    // May change based on product review
    return totalAllowed < emailCount ? 'You have filled up your additional seats' : null;
  };
};

var UserInviteForm = exports.UserInviteForm = function UserInviteForm(props) {
  var machines = props.machines,
      managedMachines = props.managedMachines,
      isLoading = props.isLoading,
      featureFlags = props.features,
      handleSubmit = props.handleSubmit,
      onCancel = props.onCancel,
      email = props.email,
      pageStrings = props.pageStrings,
      pageMarkdownStrings = props.pageMarkdownStrings,
      formInvalid = props.formInvalid,
      subscription = props.subscription,
      addedUsers = props.addedUsers;


  if (isLoading) {
    return _react2.default.createElement(
      'div',
      { className: 'loadingIndicator' },
      _react2.default.createElement(SVG, { id: 'spinner' })
    );
  }

  if (_lodash2.default.isEmpty(machines)) {
    return _react2.default.createElement(
      'div',
      { className: 'UserInviteForm empty' },
      _react2.default.createElement(Markdown, { source: pageMarkdownStrings['settings-users-tab-no-machines'] })
    );
  }

  if (_lodash2.default.isEmpty(managedMachines)) {
    return _react2.default.createElement(
      'div',
      { className: 'UserInviteForm empty' },
      _react2.default.createElement(Markdown, { source: pageMarkdownStrings['settings-users-tab-not-a-manager'] })
    );
  }

  var isSubscriptionOwner = subscription.attributes && subscription.attributes.external;
  var plan = isSubscriptionOwner ? subscription.attributes.external.plan_id : '';
  var isEduAccount = plan.toLowerCase().includes('edu') && featureFlags.MIZZLE_FRIZZLE;

  var emailsAddedCount = (0, _react.useCallback)(function (values) {
    if (isSubscriptionOwner && isEduAccount) {
      var totalUsersLeft = subscription.attributes.total_users - addedUsers.length;
      return exceedsAddedUserCount(totalUsersLeft)(values);
    }
  }, [subscription]);

  var machineRows = void 0;
  var fieldComponent = _machineCheckboxGroup2.default;
  if (featureFlags.USER_ROLE_MANAGEMENT) fieldComponent = _machineAccessField2.default;
  if (managedMachines.length > 0 || featureFlags.USER_ROLE_MANAGEMENT) {
    machineRows = _react2.default.createElement(
      _react2.default.Fragment,
      null,
      _react2.default.createElement(
        'h2',
        { className: 'h3' },
        'Which Printers should they have access to?'
      ),
      _react2.default.createElement(_reduxForm.Field, {
        name: 'machines',
        component: fieldComponent,
        email: email,
        grants: isEduAccount ? ['added_student'] : [],
        options: managedMachines,
        pageStrings: pageStrings })
    );
  }

  return _react2.default.createElement(
    'form',
    { className: 'UserInviteForm', onSubmit: handleSubmit },
    _react2.default.createElement(
      'h2',
      { className: 'h3' },
      'Who do you want to add',
      managedMachines.length === 1 ? ' to your Glowforge' : '',
      '?'
    ),
    _react2.default.createElement(
      'div',
      { className: 'hint' },
      'To add multiple users, separate each email by comma.'
    ),
    _react2.default.createElement(_reduxForm.Field, {
      className: 'email',
      name: 'email',
      placeholder: 'enter email addresses (comma separated)',
      validate: [emailsAddedCount],
      component: Text }),
    machineRows,
    _react2.default.createElement(_submitActions2.default, (0, _extends3.default)({}, props, {
      disabled: formInvalid,
      submitText: 'Add Users',
      successMessage: 'Invite Sent!',
      inProgressMessage: 'Sending...',
      onCancel: onCancel }))
  );
};

UserInviteForm.propTypes = {
  handleSubmit: _propTypes2.default.func.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool,
  machines: _propTypes2.default.arrayOf(_propTypes2.default.shape(_machines.machinePropType)),
  managedMachines: _propTypes2.default.arrayOf(_propTypes2.default.shape(_machines.machinePropType)),
  email: _propTypes2.default.string,
  features: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  pageStrings: pageStringsPropType.isRequired,
  pageMarkdownStrings: pageStringsPropType.isRequired,
  formInvalid: _propTypes2.default.bool,
  subscription: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  addedUsers: _propTypes2.default.array // eslint-disable-line react/forbid-prop-types
};

UserInviteForm.defaultProps = {
  machines: [],
  managedMachines: [],
  machineListError: null,
  isLoading: false,
  onCancel: function onCancel() {},
  email: '',
  features: {},
  formInvalid: false,
  subscription: {},
  addedUsers: []
};

var UserInviteReduxForm = (0, _reduxForm.reduxForm)({
  form: 'userInviteForm',
  validate: formValidation
})(UserInviteForm);

exports.default = (0, _features2.default)(UserInviteReduxForm);

/***/ }),

/***/ "./app/components/settings/user-invite-form.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/settings/user-invite.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _userInviteForm = __webpack_require__("./app/components/settings/user-invite-form.jsx");

var _userInviteForm2 = _interopRequireDefault(_userInviteForm);

__webpack_require__("./app/components/settings/user-invite.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserInvite = function UserInvite(props) {
  return _react2.default.createElement(
    'div',
    { className: 'UserInvite' },
    _react2.default.createElement(
      'h1',
      { className: 'h2' },
      'Users and Invites'
    ),
    _react2.default.createElement(_userInviteForm2.default, props)
  );
};

exports.default = UserInvite;

/***/ }),

/***/ "./app/components/settings/user-invite.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/settings/users-and-invites.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _machines = __webpack_require__("./app/selectors/machines.js");

var _invites = __webpack_require__("./app/components/settings/invites.jsx");

var _invites2 = _interopRequireDefault(_invites);

var _users = __webpack_require__("./app/components/settings/users.jsx");

var _users2 = _interopRequireDefault(_users);

__webpack_require__("./app/components/settings/users-and-invites.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageStringsPropType = _uiCommon.contentfulModels.pageStringsPropType;
var Button = _uiCommon.components.Button;


var TABS = {
  USERS: 1,
  INVITES: 2
};

var UsersAndInvites = function (_Component) {
  (0, _inherits3.default)(UsersAndInvites, _Component);

  function UsersAndInvites(props) {
    (0, _classCallCheck3.default)(this, UsersAndInvites);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UsersAndInvites.__proto__ || (0, _getPrototypeOf2.default)(UsersAndInvites)).call(this, props));

    _this.showInvites = function () {
      _this.setState({ viewedTab: TABS.INVITES });
    };

    _this.showUsers = function () {
      _this.setState({ viewedTab: TABS.USERS });
    };

    _this.state = { viewedTab: TABS.USERS };
    return _this;
  }

  (0, _createClass3.default)(UsersAndInvites, [{
    key: 'render',
    value: function render() {
      var table = _react2.default.createElement(_users2.default, this.props);
      var tabs = void 0;
      if (!_lodash2.default.isEmpty(this.props.pendingInvites)) {
        if (this.state.viewedTab === TABS.INVITES) {
          table = _react2.default.createElement(_invites2.default, this.props);
        }

        tabs = _react2.default.createElement(
          'div',
          { className: 'tabs' },
          _react2.default.createElement(
            'button',
            {
              className: 'clearButton ' + (this.state.viewedTab === TABS.USERS ? 'selected' : ''),
              onClick: this.showUsers },
            this.props.pageStrings['settings-users-tab-name']
          ),
          _react2.default.createElement(
            'button',
            {
              className: 'clearButton ' + (this.state.viewedTab === TABS.INVITES ? 'selected' : ''),
              onClick: this.showInvites },
            this.props.pageStrings['settings-tab-pending-invites'],
            ' (',
            this.props.pendingInvites.length,
            ')'
          )
        );
      }

      var inviteButton = void 0;
      if (!_lodash2.default.isEmpty(this.props.managedMachines)) {
        inviteButton = _react2.default.createElement(
          Button,
          { onClick: this.props.gotoInviteForm },
          this.props.pageStrings['add-user-button']
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'UsersAndInvites' },
        _react2.default.createElement(
          'h1',
          { className: 'h2' },
          this.props.pageStrings['settings-users-tab-name'],
          inviteButton
        ),
        tabs,
        table
      );
    }
  }]);
  return UsersAndInvites;
}(_react.Component);

UsersAndInvites.propTypes = {
  gotoInviteForm: _propTypes2.default.func.isRequired,
  pendingInvites: _propTypes2.default.arrayOf(_propTypes2.default.shape(_machines.pendingInvitesPropTypes)),
  machines: _propTypes2.default.arrayOf(_propTypes2.default.shape(_machines.machinePropType)),
  managedMachines: _propTypes2.default.arrayOf(_propTypes2.default.shape(_machines.machinePropType)),
  pageStrings: pageStringsPropType.isRequired
};

UsersAndInvites.defaultProps = {
  pendingInvites: [],
  machines: [],
  managedMachines: []
};

exports.default = UsersAndInvites;

/***/ }),

/***/ "./app/components/settings/users-and-invites.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/settings/users.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _machines = __webpack_require__("./app/selectors/machines.js");

var _changeAccessDialog = __webpack_require__("./app/containers/settings/change-access-dialog.js");

var _changeAccessDialog2 = _interopRequireDefault(_changeAccessDialog);

var _machineCell = __webpack_require__("./app/components/settings/machine-cell.jsx");

__webpack_require__("./app/components/settings/users.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: This should eventually come from ui-common?
var PremiumIcon = __webpack_require__("./app/components/settings/premium-gem-yellow.svg");

var pageStringsPropType = _uiCommon.contentfulModels.pageStringsPropType;
var Markdown = _uiCommon.components.Markdown,
    SVG = _uiCommon.components.SVG;

var Users = function (_Component) {
  (0, _inherits3.default)(Users, _Component);

  function Users(props) {
    (0, _classCallCheck3.default)(this, Users);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Users.__proto__ || (0, _getPrototypeOf2.default)(Users)).call(this, props));

    _this.showAccessDialog = function (user) {
      _this.setState({ showAccessDialogUser: user });
    };

    _this.hideAccessDialog = function () {
      _this.setState({ showAccessDialogUser: null });
    };

    _this.state = { showAccessDialogUser: null };
    return _this;
  }

  (0, _createClass3.default)(Users, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          machines = _props.machines,
          managedMachines = _props.managedMachines,
          isLoading = _props.isLoading,
          pageStrings = _props.pageStrings,
          pageMarkdownStrings = _props.pageMarkdownStrings,
          users = _props.users;
      var showAccessDialogUser = this.state.showAccessDialogUser;

      if (_lodash2.default.isEmpty(machines) && !isLoading) {
        return _react2.default.createElement(
          'div',
          { className: 'Users empty' },
          _react2.default.createElement(Markdown, { source: pageMarkdownStrings['settings-users-tab-no-machines'] })
        );
      }

      if (_lodash2.default.isEmpty(managedMachines) && !isLoading) {
        return _react2.default.createElement(
          'div',
          { className: 'Users empty' },
          _react2.default.createElement(Markdown, { source: pageMarkdownStrings['settings-users-tab-not-a-manager'] })
        );
      }

      if (_lodash2.default.isEmpty(users) && !isLoading) {
        return _react2.default.createElement(
          'div',
          { className: 'Users empty' },
          _react2.default.createElement(Markdown, { source: pageMarkdownStrings['settings-no-users-on-machine'] })
        );
      }

      var loading = void 0;
      if (isLoading) {
        loading = _react2.default.createElement(
          'div',
          { className: 'loadingIndicator' },
          _react2.default.createElement(SVG, { id: 'spinner' })
        );
      }

      var membershipIndicator = function membershipIndicator() {
        return _react2.default.createElement(
          'span',
          { className: 'premiumMember' },
          _react2.default.createElement(PremiumIcon, { className: 'premiumIcon' }),
          pageStrings['settings-users-subscription-member']
        );
      };

      // TODO: what does this page look like for an added user of the subscription?

      var rows = _lodash2.default.map(users, function (user, index) {
        var showAccessForUser = function showAccessForUser() {
          return _this2.showAccessDialog(user);
        };

        if (_this2.props.isSubscriber) {
          var activeUsers = _this2.props.subscriptionUsers;

          // TODO: is email the right comparison? it's really the only one we have here.
          var isMember = _lodash2.default.find(activeUsers, function (u) {
            return u.attributes.secondary_user_email === user.email;
          });
          return _react2.default.createElement(
            'tr',
            { key: index, onClick: showAccessForUser },
            _react2.default.createElement(
              'td',
              { className: 'name' },
              user.name
            ),
            _react2.default.createElement(
              'td',
              { className: 'member' },
              isMember ? membershipIndicator() : ''
            ),
            _react2.default.createElement(
              'td',
              null,
              (0, _machineCell.renderMachineCell)(user.machines)
            )
          );
        }
        return _react2.default.createElement(
          'tr',
          { key: index, onClick: showAccessForUser },
          _react2.default.createElement(
            'td',
            { className: 'name' },
            user.name
          ),
          _react2.default.createElement(
            'td',
            null,
            (0, _machineCell.renderMachineCell)(user.machines)
          )
        );
      });

      var userNameHeader = pageStrings['settings-users-headers-username'] || 'User Name';
      var accessHeader = pageStrings['settings-users-headers-access'] || 'Access To ...';
      var membershipHeader = pageStrings['settings-users-headers-membership'] || 'Premium Membership';
      var tableHeaders = _react2.default.createElement(
        'tr',
        { className: 'header label' },
        _react2.default.createElement(
          'th',
          null,
          userNameHeader
        ),
        _react2.default.createElement(
          'th',
          null,
          accessHeader
        )
      );
      if (this.props.isSubscriber) {
        tableHeaders = _react2.default.createElement(
          'tr',
          { className: 'header label' },
          _react2.default.createElement(
            'th',
            null,
            userNameHeader
          ),
          _react2.default.createElement(
            'th',
            null,
            membershipHeader
          ),
          _react2.default.createElement(
            'th',
            null,
            accessHeader
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'Users' },
        _react2.default.createElement(
          'div',
          { className: 'tableWrapper' },
          _react2.default.createElement(
            'table',
            { className: 'styledTable striped ' + (isLoading ? 'loading' : '') },
            _react2.default.createElement(
              'thead',
              null,
              tableHeaders
            ),
            _react2.default.createElement(
              'tbody',
              null,
              rows
            )
          ),
          loading
        ),
        _react2.default.createElement(_changeAccessDialog2.default, (0, _extends3.default)({}, this.props, {
          closeDialog: this.hideAccessDialog,
          isOpen: !!showAccessDialogUser,
          user: showAccessDialogUser }))
      );
    }
  }]);
  return Users;
}(_react.Component);

Users.propTypes = {
  users: _propTypes2.default.arrayOf(_propTypes2.default.shape(_machines.machineUsersPropType)),
  machines: _propTypes2.default.arrayOf(_propTypes2.default.shape(_machines.machinePropType)),
  managedMachines: _propTypes2.default.arrayOf(_propTypes2.default.shape(_machines.machinePropType)),
  pageStrings: pageStringsPropType.isRequired,
  pageMarkdownStrings: pageStringsPropType.isRequired,
  isLoading: _propTypes2.default.bool,
  isSubscriptionActive: _propTypes2.default.bool,
  isSubscriber: _propTypes2.default.bool,
  subscriptionUsers: _propTypes2.default.array // eslint-disable-line
};

Users.defaultProps = {
  users: [],
  machines: [],
  managedMachines: [],
  isLoading: false,
  isSubscriptionActive: false,
  isSubscriber: false,
  subscriptionUsers: []
};

exports.default = Users;

/***/ }),

/***/ "./app/components/settings/users.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/setup/action-buttons.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = _uiCommon.components.Button,
    Markdown = _uiCommon.components.Markdown;


var ActionButtons = function ActionButtons(_ref) {
  var getHelpMarkdownSource = _ref.getHelpMarkdownSource,
      nextStepOnClick = _ref.nextStepOnClick,
      nextStepStr = _ref.nextStepStr;
  return _react2.default.createElement(
    'div',
    { className: 'actionButtons' },
    _react2.default.createElement(Markdown, { source: getHelpMarkdownSource }),
    _react2.default.createElement(
      Button,
      { className: 'btn clearLink', onClick: nextStepOnClick },
      nextStepStr
    )
  );
};

ActionButtons.propTypes = {
  getHelpMarkdownSource: _propTypes2.default.string.isRequired,
  nextStepOnClick: _propTypes2.default.func.isRequired,
  nextStepStr: _propTypes2.default.string.isRequired
};

exports.default = ActionButtons;

/***/ }),

/***/ "./app/components/setup/add-glowforge.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _util = __webpack_require__("./app/util.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddGlowforge = function (_React$Component) {
  (0, _inherits3.default)(AddGlowforge, _React$Component);

  function AddGlowforge(props) {
    (0, _classCallCheck3.default)(this, AddGlowforge);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AddGlowforge.__proto__ || (0, _getPrototypeOf2.default)(AddGlowforge)).call(this, props));

    _this.state = {
      redirect: false
    };
    return _this;
  }

  (0, _createClass3.default)(AddGlowforge, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var downloadUrl = this.props.downloadUrl;

      if (window.sessionStorage.getItem('disallowedSetupChromeVersion') || (0, _util.getChromeVersion)() >= 101 || (0, _util.isEdge)()) {
        window.location.replace(downloadUrl);
      } else {
        window.location.replace('/setup/select');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return AddGlowforge;
}(_react2.default.Component);

AddGlowforge.propTypes = {
  downloadUrl: _propTypes2.default.string.isRequired
};

exports.default = AddGlowforge;

/***/ }),

/***/ "./app/components/setup/article-card.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _support = __webpack_require__("./app/selectors/support.js");

__webpack_require__("./app/components/setup/article-card.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArticleCard = function ArticleCard(_ref) {
  var article = _ref.article,
      _onClick = _ref.onClick;
  var _article$fields = article.fields,
      title = _article$fields.title,
      description = _article$fields.description,
      thumbnail = _article$fields.thumbnail,
      id = _article$fields.id;

  var getThumbnail = function getThumbnail() {
    if (!thumbnail) return { fileName: null, url: null };
    var _thumbnail$fields$fil = thumbnail.fields.file,
        fileName = _thumbnail$fields$fil.fileName,
        url = _thumbnail$fields$fil.url;

    return { fileName: fileName, url: url };
  };

  var _getThumbnail = getThumbnail(),
      fileName = _getThumbnail.fileName,
      url = _getThumbnail.url;

  return _react2.default.createElement(
    'div',
    { className: 'card', role: 'button', tabIndex: 0, onClick: function onClick() {
        return _onClick(id);
      } },
    _react2.default.createElement('img', { className: 'card-img', src: url, alt: fileName }),
    _react2.default.createElement(
      'div',
      { className: 'card-text' },
      _react2.default.createElement(
        'h1',
        { className: 'card-title' },
        title
      ),
      _react2.default.createElement(
        'p',
        { className: 'card-description' },
        description
      )
    )
  );
};

ArticleCard.propTypes = {
  article: _propTypes2.default.shape(_support.articlePropTypes),
  onClick: _propTypes2.default.func.isRequired
};

ArticleCard.defaultProps = {
  article: {}
};

exports.default = ArticleCard;

/***/ }),

/***/ "./app/components/setup/article-card.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/setup/article-step-group.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _support = __webpack_require__("./app/selectors/support.js");

var _video = __webpack_require__("./app/components/support/video.jsx");

var _video2 = _interopRequireDefault(_video);

__webpack_require__("./app/components/setup/article-step-group.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArticleStepGroup = function ArticleStepGroup(_ref) {
  var article = _ref.article;
  var _article$fields = article.fields,
      id = _article$fields.id,
      title = _article$fields.title,
      entries = _article$fields.entries;


  return _react2.default.createElement(
    'div',
    { id: id, className: 'stepGroup' },
    title && _react2.default.createElement(
      'h2',
      { className: 'title' },
      title
    ),
    entries.map(function (entry) {
      var _entry$fields = entry.fields,
          steps = _entry$fields.steps,
          video = _entry$fields.video,
          slug = _entry$fields.slug;


      return _react2.default.createElement(
        'div',
        { key: slug, className: 'entry' },
        _react2.default.createElement(
          'ol',
          { className: 'steps' },
          steps && steps.map(function (step) {
            var _step$fields = step.fields,
                stepNumber = _step$fields.stepNumber,
                text = _step$fields.text;


            return _react2.default.createElement(
              'li',
              { key: 'aura-unboxing-step-' + stepNumber, className: 'step' },
              _react2.default.createElement(
                'h3',
                { className: 'stepNumber' },
                stepNumber
              ),
              _react2.default.createElement(
                'span',
                { className: 'stepText' },
                text
              )
            );
          })
        ),
        video && _react2.default.createElement(
          'div',
          { className: 'video-container' },
          _react2.default.createElement(_video2.default, { src: video[0].fields.file.url })
        )
      );
    })
  );
};

ArticleStepGroup.propTypes = {
  article: _propTypes2.default.shape(_support.articlePropTypes)
};

ArticleStepGroup.defaultProps = {
  article: {}
};

exports.default = ArticleStepGroup;

/***/ }),

/***/ "./app/components/setup/article-step-group.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/setup/bottom-button.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _chevronLeft = __webpack_require__("./app/components/setup/chevron-left.svg");

var _chevronLeft2 = _interopRequireDefault(_chevronLeft);

var _chevronUp = __webpack_require__("./app/components/setup/chevron-up.svg");

var _chevronUp2 = _interopRequireDefault(_chevronUp);

__webpack_require__("./app/components/setup/bottom-button.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = _uiCommon.components.Button;
function BottomButton(_ref) {
  var label = _ref.label,
      next = _ref.next,
      prev = _ref.prev,
      _onClick = _ref.onClick,
      canGoBack = _ref.canGoBack;

  return _react2.default.createElement(
    'div',
    { className: 'bottomButtonContainer' },
    _react2.default.createElement(
      'div',
      { className: 'navButtons' },
      canGoBack && _react2.default.createElement(
        Button,
        { onClick: function onClick() {
            return _onClick('');
          }, className: 'clearButton secondaryButton' },
        _react2.default.createElement(_chevronUp2.default, { className: 'clearSvg' }),
        'Contents'
      ),
      canGoBack && _react2.default.createElement(
        Button,
        { onClick: function onClick() {
            return _onClick(prev);
          }, className: 'clearButton secondaryButton' },
        _react2.default.createElement(_chevronLeft2.default, { className: 'clearSvg' }),
        'Back'
      )
    ),
    next && _react2.default.createElement(
      Button,
      { onClick: function onClick() {
          return _onClick(next);
        }, className: 'clearButton nextButton' },
      label
    )
  );
}

exports.default = BottomButton;
BottomButton.propTypes = {
  label: _propTypes2.default.string,
  next: _propTypes2.default.string,
  onClick: _propTypes2.default.func.isRequired,
  canGoBack: _propTypes2.default.bool.isRequired,
  prev: _propTypes2.default.string
};

BottomButton.defaultProps = {
  label: null,
  next: null,
  prev: null
};

/***/ }),

/***/ "./app/components/setup/bottom-button.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/setup/chevron-left.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("./node_modules/react/index.js");

function ChevronLeft (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"chevron-left"),React.createElement("path",{"d":"M22.13,36.83L7.34,22a1.36,1.36,0,0,1,0-1.92l14.6-14.6","transform":"translate(-4.19 -2.77)","style":{"strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"5.49805142246211px"},"key":1})]);
}

ChevronLeft.defaultProps = {"viewBox":"0 0 20.68 36.81"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;


/***/ }),

/***/ "./app/components/setup/chevron-up.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("./node_modules/react/index.js");

function ChevronUp (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"chevron-up"),React.createElement("path",{"d":"M22.13,36.83L7.34,22a1.36,1.36,0,0,1,0-1.92l14.6-14.6","transform":"translate(16.7 -2.77) rotate(90, 12.15, 10.7)","style":{"strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"5.49805142246211px"},"key":1})]);
}

ChevronUp.defaultProps = {"viewBox":"0 0 36.81 20.68"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;


/***/ }),

/***/ "./app/components/setup/exhaust.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _support = __webpack_require__("./app/selectors/support.js");

var _article = __webpack_require__("./app/components/support/article.jsx");

var _article2 = _interopRequireDefault(_article);

var _articleStepGroup = __webpack_require__("./app/components/setup/article-step-group.jsx");

var _articleStepGroup2 = _interopRequireDefault(_articleStepGroup);

var _actionButtons = __webpack_require__("./app/components/setup/action-buttons.jsx");

var _actionButtons2 = _interopRequireDefault(_actionButtons);

__webpack_require__("./app/components/setup/shared.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageStringsPropType = _uiCommon.contentfulModels.pageStringsPropType;


var Exhaust = function Exhaust(_ref) {
  var pageStrings = _ref.pageStrings,
      pageMarkdownStrings = _ref.pageMarkdownStrings,
      nextUrl = _ref.nextUrl,
      exhaustPowerArticle = _ref.exhaustPowerArticle,
      personalFilterArticle = _ref.personalFilterArticle,
      windowVentingArticle = _ref.windowVentingArticle,
      connectPowerArticle = _ref.connectPowerArticle;
  return _react2.default.createElement(
    'div',
    { className: 'Exhaust PageContainer' },
    _react2.default.createElement(_articleStepGroup2.default, { article: exhaustPowerArticle }),
    _react2.default.createElement(_articleStepGroup2.default, { article: personalFilterArticle }),
    _react2.default.createElement(_article2.default, (0, _extends3.default)({}, windowVentingArticle, { unboxingUpdateEnabled: true })),
    _react2.default.createElement(_article2.default, connectPowerArticle),
    _react2.default.createElement(_actionButtons2.default, {
      getHelpMarkdownSource: pageMarkdownStrings['instructions-get-help'],
      nextStepOnClick: function nextStepOnClick() {
        window.location = nextUrl + '?mode=orange';
      },
      nextStepStr: pageStrings['exhaust-next-step'] })
  );
};

Exhaust.propTypes = {
  pageStrings: pageStringsPropType.isRequired,
  pageMarkdownStrings: pageStringsPropType.isRequired,
  nextUrl: _propTypes2.default.string.isRequired,
  exhaustPowerArticle: _propTypes2.default.shape(_support.articlePropTypes),
  personalFilterArticle: _propTypes2.default.shape(_support.articlePropTypes),
  windowVentingArticle: _propTypes2.default.shape(_support.articlePropTypes),
  connectPowerArticle: _propTypes2.default.shape(_support.articlePropTypes)
};

Exhaust.defaultProps = {
  exhaustPowerArticle: {},
  personalFilterArticle: {},
  windowVentingArticle: {},
  connectPowerArticle: {}
};

exports.default = Exhaust;

/***/ }),

/***/ "./app/components/setup/finish.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _isElectron = __webpack_require__("./node_modules/is-electron/index.js");

var _isElectron2 = _interopRequireDefault(_isElectron);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__("./app/lib/confetti.js");

__webpack_require__("./app/components/setup/finish.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Finish = function (_Component) {
  (0, _inherits3.default)(Finish, _Component);

  function Finish() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Finish);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Finish.__proto__ || (0, _getPrototypeOf2.default)(Finish)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      var finalHost = _this.props.finalHost;

      if ((0, _isElectron2.default)()) {
        window.open(finalHost, '_blank');
        window.close();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Finish, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.makeConfetti();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          finalHost = _props.finalHost,
          isOrangeMode = _props.isOrangeMode,
          pageStrings = _props.pageStrings;

      return _react2.default.createElement(
        'div',
        { className: 'Finish contentPage' },
        _react2.default.createElement(
          'h1',
          null,
          'Connect Your Glowforge to Wi-Fi'
        ),
        _react2.default.createElement(_reactHelmet2.default, { title: 'Glowforge Setup' }),
        _react2.default.createElement(
          'p',
          { className: 'title' },
          pageStrings['onboarding-finish-setup-complete']
        ),
        _react2.default.createElement(
          'a',
          {
            href: finalHost,
            onClick: this.handleClick,
            className: (0, _classnames2.default)('btn', 'clearLink', {
              orange: isOrangeMode
            }) },
          pageStrings['onboarding-finish-link-message']
        ),
        (0, _isElectron2.default)() && _react2.default.createElement(
          'p',
          { className: 'closing-message' },
          pageStrings['onboarding-finish-closing-message']
        ),
        _react2.default.createElement('canvas', { id: 'confetti' })
      );
    }
  }]);
  return Finish;
}(_react.Component);

Finish.propTypes = {
  pageStrings: _propTypes2.default.shape({
    'onboarding-finish-setup-complete': _propTypes2.default.string.isRequired,
    'onboarding-finish-link-message': _propTypes2.default.string.isRequired,
    'onboarding-finish-closing-message': _propTypes2.default.string.isRequired
  }).isRequired,
  finalHost: _propTypes2.default.string.isRequired,
  isOrangeMode: _propTypes2.default.bool.isRequired
};
exports.default = Finish;

/***/ }),

/***/ "./app/components/setup/finish.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/setup/instructions.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _support = __webpack_require__("./app/selectors/support.js");

var _article = __webpack_require__("./app/components/support/article.jsx");

var _article2 = _interopRequireDefault(_article);

var _articleStepGroup = __webpack_require__("./app/components/setup/article-step-group.jsx");

var _articleStepGroup2 = _interopRequireDefault(_articleStepGroup);

var _actionButtons = __webpack_require__("./app/components/setup/action-buttons.jsx");

var _actionButtons2 = _interopRequireDefault(_actionButtons);

__webpack_require__("./app/components/setup/shared.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageStringsPropType = _uiCommon.contentfulModels.pageStringsPropType;


var Instructions = function Instructions(_ref) {
  var pageStrings = _ref.pageStrings,
      pageMarkdownStrings = _ref.pageMarkdownStrings,
      onNext = _ref.onNext,
      headerArticle = _ref.headerArticle,
      unboxArticle = _ref.unboxArticle,
      printHeadArticle = _ref.printHeadArticle,
      cuttingTrayArticle = _ref.cuttingTrayArticle;
  return _react2.default.createElement(
    'div',
    { className: 'Instructions PageContainer' },
    _react2.default.createElement(_article2.default, headerArticle),
    _react2.default.createElement(_articleStepGroup2.default, { article: unboxArticle }),
    _react2.default.createElement(_articleStepGroup2.default, { article: printHeadArticle }),
    _react2.default.createElement(_articleStepGroup2.default, { article: cuttingTrayArticle }),
    _react2.default.createElement(_actionButtons2.default, {
      getHelpMarkdownSource: pageMarkdownStrings['instructions-get-help'],
      nextStepOnClick: onNext,
      nextStepStr: pageStrings['instructions-next-step'] })
  );
};

Instructions.propTypes = {
  pageStrings: pageStringsPropType.isRequired,
  pageMarkdownStrings: pageStringsPropType.isRequired,
  onNext: _propTypes2.default.func.isRequired,
  headerArticle: _propTypes2.default.shape(_support.articlePropTypes),
  unboxArticle: _propTypes2.default.shape(_support.articlePropTypes),
  printHeadArticle: _propTypes2.default.shape(_support.articlePropTypes),
  cuttingTrayArticle: _propTypes2.default.shape(_support.articlePropTypes)
};

Instructions.defaultProps = {
  headerArticle: {},
  unboxArticle: {},
  printHeadArticle: {},
  cuttingTrayArticle: {}
};

exports.default = Instructions;

/***/ }),

/***/ "./app/components/setup/machine-name.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formValidation = undefined;

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _features = __webpack_require__("./app/common/containers/features.js");

var _features2 = _interopRequireDefault(_features);

var _reduxForm = __webpack_require__("./node_modules/redux-form/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _submitActions = __webpack_require__("./app/common/components/forms/submit-actions.jsx");

var _submitActions2 = _interopRequireDefault(_submitActions);

var _util = __webpack_require__("./app/util.js");

__webpack_require__("./app/components/setup/machine-name.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageStringsPropType = _uiCommon.contentfulModels.pageStringsPropType;
var Text = _uiCommon.components.Text;
var formValidation = exports.formValidation = function formValidation(values) {
  var errors = {};
  if (values.email) {
    var invalidEmails = (0, _util.getInvalidEmails)(values.email);
    if (invalidEmails.length > 1) {
      errors.email = invalidEmails.join(', ') + ' are not valid emails.';
    } else if (invalidEmails.length === 1) {
      errors.email = invalidEmails[0] + ' is not a valid email.';
    }
  }

  if (!values.name || values.name.trim().length === 0) {
    errors.name = 'Required';
  }
  if (values.name.length > 15) {
    errors.name = 'Machine name must be 15 characters or less.';
  }

  return errors;
};

var MachineName = function MachineName(props) {
  var emailFormExplanation = '';
  if (props.features.USER_ROLE_MANAGEMENT) {
    emailFormExplanation = _react2.default.createElement(
      'div',
      { className: 'row compact' },
      _react2.default.createElement(
        'p',
        null,
        props.pageStrings['onboarding-email-form-explanation']
      )
    );
  }

  return _react2.default.createElement(
    'form',
    { className: 'MachineName contentPage', onSubmit: props.handleSubmit },
    _react2.default.createElement(_reactHelmet2.default, { title: 'Glowforge Setup - ' + props.title }),
    _react2.default.createElement(
      'div',
      { className: 'content' },
      _react2.default.createElement(
        'h1',
        { className: 'h2' },
        props.title
      ),
      _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(_reduxForm.Field, {
          className: 'name',
          name: 'name',
          label: props.pageStrings['onboarding-gf-name-label'],
          placeholder: props.pageStrings['onboarding-name-placeholder'],
          component: Text }),
        _react2.default.createElement(
          'p',
          null,
          props.pageStrings['onboarding-gf-name-description']
        )
      ),
      _react2.default.createElement(
        'h4',
        { className: 'h4' },
        props.pageStrings['onboarding-invite-user-header']
      ),
      _react2.default.createElement(
        'div',
        { className: 'row compact' },
        _react2.default.createElement(_reduxForm.Field, {
          className: 'email',
          name: 'email',
          label: '\xA0',
          placeholder: props.pageStrings['onboarding-email-form-placeholder'],
          component: Text }),
        _react2.default.createElement(
          'p',
          null,
          props.pageStrings['onboarding-email-form-description']
        )
      ),
      emailFormExplanation,
      _react2.default.createElement(_submitActions2.default, (0, _extends3.default)({}, props, {
        successMessage: props.pageStrings['onboarding-sucess-message'],
        inProgressMessage: props.pageStrings['onboarding-naming-pending-submit-message'],
        submitClass: (props.isOrangeMode ? 'orange' : 'brand') + ' large clearButton' }))
    )
  );
};

MachineName.propTypes = {
  handleSubmit: _propTypes2.default.func.isRequired,
  title: _propTypes2.default.string,
  pageStrings: pageStringsPropType.isRequired,
  features: _propTypes2.default.object, // eslint-disable-line
  isOrangeMode: _propTypes2.default.bool
};

MachineName.defaultProps = {
  title: '',
  namePlaceHolder: '',
  emailPlaceHolder: '',
  nameLabel: '',
  nameDescription: '',
  emailDescription: '',
  inviteHeader: '',
  isOrangeMode: false
};

var MachineNameForm = (0, _reduxForm.reduxForm)({
  form: 'machineNameForm',
  validate: formValidation
})((0, _features2.default)(MachineName));

exports.default = MachineNameForm;

/***/ }),

/***/ "./app/components/setup/machine-name.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/setup/select-machine.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _appConstants = __webpack_require__("./app/app-constants.js");

__webpack_require__("./app/components/setup/shared.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageStringsPropType = _uiCommon.contentfulModels.pageStringsPropType;
var Button = _uiCommon.components.Button;


var SelectMachine = function SelectMachine(_ref) {
  var pageStrings = _ref.pageStrings,
      title = _ref.title,
      onSelect = _ref.onSelect,
      assets = _ref.assets;

  var headerImg = { src: _lodash2.default.get(assets, '[0].file.url'), alt: _lodash2.default.get(assets, '[0].file.title') };
  var mainImg = { src: _lodash2.default.get(assets, '[1].file.url'), alt: _lodash2.default.get(assets, '[1].file.title') };
  return _react2.default.createElement(
    'div',
    { className: 'SelectMachine PageContainer' },
    _react2.default.createElement(
      'div',
      { className: 'header' },
      _react2.default.createElement('img', { src: headerImg.src, alt: headerImg.alt })
    ),
    _react2.default.createElement(
      'div',
      { className: 'title' },
      title
    ),
    _react2.default.createElement(
      'div',
      { className: 'main' },
      _react2.default.createElement('img', { src: mainImg.src, alt: mainImg.alt })
    ),
    _react2.default.createElement(
      'div',
      { className: 'actionButtons' },
      _react2.default.createElement(
        Button,
        {
          className: 'clearButton orange',
          onClick: function onClick() {
            return onSelect(_appConstants.COLOR_MODES.ORANGE);
          } },
        pageStrings['orange-setup-button']
      ),
      _react2.default.createElement(
        Button,
        {
          className: 'clearButton brand',
          onClick: function onClick() {
            return onSelect(_appConstants.COLOR_MODES.BRAND);
          } },
        pageStrings['brand-setup-button']
      )
    )
  );
};

SelectMachine.propTypes = {
  pageStrings: pageStringsPropType.isRequired,
  title: _propTypes2.default.string,
  onSelect: _propTypes2.default.func.isRequired,
  assets: _propTypes2.default.arrayOf(_propTypes2.default.object)
};

SelectMachine.defaultProps = {
  title: null,
  subTitle: null,
  assets: {}
};

exports.default = SelectMachine;

/***/ }),

/***/ "./app/components/setup/shared.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/setup/unboxing.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _isElectron = __webpack_require__("./node_modules/is-electron/index.js");

var _isElectron2 = _interopRequireDefault(_isElectron);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _support = __webpack_require__("./app/selectors/support.js");

var _article = __webpack_require__("./app/components/support/article.jsx");

var _article2 = _interopRequireDefault(_article);

var _bottomButton = __webpack_require__("./app/components/setup/bottom-button.jsx");

var _bottomButton2 = _interopRequireDefault(_bottomButton);

var _articleCard = __webpack_require__("./app/components/setup/article-card.jsx");

var _articleCard2 = _interopRequireDefault(_articleCard);

__webpack_require__("./app/common/components/scroll-page.less");

__webpack_require__("./app/components/setup/unboxing.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageStringsPropType = _uiCommon.contentfulModels.pageStringsPropType;
var Button = _uiCommon.components.Button;


var Unboxing = function Unboxing(_ref) {
  var pageStrings = _ref.pageStrings,
      nextUrl = _ref.nextUrl,
      title = _ref.title,
      subTitle = _ref.subTitle,
      unboxingArticle = _ref.unboxingArticle,
      features = _ref.features,
      goTo = _ref.goTo,
      params = _ref.params,
      articleList = _ref.articleList;
  var UNBOXING_UPDATE_ENABLED = features.UNBOXING_UPDATE_ENABLED;

  var header = title && !UNBOXING_UPDATE_ENABLED ? _react2.default.createElement(
    'h1',
    { className: 'h1' },
    title
  ) : null;
  var subHeader = subTitle ? _react2.default.createElement(
    'div',
    { className: 'subTitle' },
    subTitle
  ) : null;
  var goToNext = function goToNext() {
    window.location = nextUrl;
  };

  (0, _react.useEffect)(function () {
    document.querySelectorAll('a').forEach(function (el) {
      if (el.getAttribute('id') === 'setup-url') {
        el.setAttribute('href', nextUrl);
      } else if ((0, _isElectron2.default)()) {
        el.setAttribute('target', '_blank');
        el.setAttribute('rel', 'noopenner noreferrer');
      }
    });
  }, []);

  if (unboxingArticle.fields) {
    _lodash2.default.pull(unboxingArticle.fields.entries, _lodash2.default.find(unboxingArticle.fields.entries, { fields: { id: 'wifi-setup' } }));
  }

  var onClick = function onClick(articleId) {
    if (articleId === 'connect-to-wi-fi') {
      goToNext();
      return;
    }
    goTo(articleId);
  };

  var slug = params.slug;

  var nextArticle = slug ? pageStrings[slug + '-next'] : pageStrings['unboxing-next'];
  var id = unboxingArticle.fields.id;

  var canGoBack = id !== 'lets-get-started';
  var prevArticle = canGoBack && pageStrings[slug + '-prev'];

  return _react2.default.createElement(
    'div',
    { className: 'Unboxing scrollPage contentPage' },
    _react2.default.createElement(_reactHelmet2.default, { title: 'Glowforge Setup - ' + title }),
    header,
    subHeader,
    _react2.default.createElement(
      'div',
      { className: 'content grow' },
      _react2.default.createElement(
        'div',
        { className: UNBOXING_UPDATE_ENABLED && 'articleContainer' },
        _react2.default.createElement(_article2.default, (0, _extends3.default)({}, unboxingArticle, { unboxingUpdateEnabled: UNBOXING_UPDATE_ENABLED })),
        UNBOXING_UPDATE_ENABLED ? _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { className: 'setupGuideContainer' },
            !slug && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(
                'h3',
                { className: 'setupGuideHeader' },
                pageStrings['setup-guide-header']
              ),
              articleList.map(function (article) {
                return _react2.default.createElement(_articleCard2.default, {
                  key: article.fields.id,
                  article: article,
                  onClick: onClick });
              }),
              _react2.default.createElement(
                'p',
                null,
                pageStrings['need-help'],
                _react2.default.createElement(
                  'a',
                  {
                    target: 'blank',
                    rel: 'noopenner noreferrer',
                    href: pageStrings['customer-support-link'] },
                  pageStrings['customer-support-text']
                )
              )
            )
          ),
          _react2.default.createElement(_bottomButton2.default, {
            next: nextArticle,
            prev: prevArticle,
            label: pageStrings[nextArticle],
            onClick: onClick,
            canGoBack: canGoBack })
        ) : _react2.default.createElement(
          'div',
          { className: 'actionButton' },
          _react2.default.createElement(
            Button,
            {
              type: 'primary',
              size: 'large',
              onClick: goToNext },
            pageStrings['onboarding-next-button']
          )
        )
      )
    )
  );
};

Unboxing.propTypes = {
  pageStrings: pageStringsPropType.isRequired,
  nextUrl: _propTypes2.default.string.isRequired, // eslint-disable-line react/no-unused-prop-types
  title: _propTypes2.default.string,
  subTitle: _propTypes2.default.string,
  unboxingArticle: _propTypes2.default.shape(_support.articlePropTypes),
  features: _propTypes2.default.shape({
    UNBOXING_UPDATE_ENABLED: _propTypes2.default.bool
  }),
  goTo: _propTypes2.default.func.isRequired,
  params: _propTypes2.default.shape({
    slug: _propTypes2.default.string
  }),
  articleList: _propTypes2.default.arrayOf(_propTypes2.default.shape(_support.articlePropTypes)).isRequired
};

Unboxing.defaultProps = {
  title: null,
  subTitle: null,
  textBlock: null,
  article: {},
  unboxingArticle: {},
  features: {},
  params: {}
};

exports.default = Unboxing;

/***/ }),

/***/ "./app/components/setup/unboxing.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/support/article.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _routeConstants = __webpack_require__("./app/route-constants.js");

var _support = __webpack_require__("./app/selectors/support.js");

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _steps = __webpack_require__("./app/components/support/entries/steps.jsx");

var _steps2 = _interopRequireDefault(_steps);

var _textEntry = __webpack_require__("./app/components/support/entries/text-entry.jsx");

var _textEntry2 = _interopRequireDefault(_textEntry);

__webpack_require__("./app/components/support/article.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Markdown = _uiCommon.components.Markdown;


var Article = function Article(props) {
  // TODO: Check here for different entry types
  var entries = _lodash2.default.map(_lodash2.default.get(props, 'fields.entries'), function (entry, index) {
    var contentType = _lodash2.default.get(entry, 'sys.contentType.sys.id');

    // If Content type isn't supported, skip
    if (!_lodash2.default.includes(_routeConstants.SUPPORT.SUPPORT_ENTRY_TYPES, contentType)) return null;

    switch (contentType) {
      case 'questionAndAnswer':
      case 'supportEntryTextAndMedia':
        return _react2.default.createElement(
          'li',
          { key: index },
          _react2.default.createElement(_textEntry2.default, (0, _extends3.default)({}, entry.fields, { unboxingUpdateEnabled: props.unboxingUpdateEnabled }))
        );
      case 'supportEntryInstructions':
        return _react2.default.createElement(
          'li',
          { key: index },
          _react2.default.createElement(_steps2.default, (0, _extends3.default)({}, entry.fields, { unboxingUpdateEnabled: props.unboxingUpdateEnabled }))
        );
      case 'supportEntryTipOrAlert':
        return _react2.default.createElement(
          'li',
          { key: index, className: 'tip-or-alert' },
          _react2.default.createElement(
            'div',
            { className: entry.fields.tip ? 'tip-block' : 'alert-block' },
            _react2.default.createElement(Markdown, { className: 'text paragraph', source: entry.fields.text })
          )
        );
      default:
        return null;
    }
  });

  var getTitle = function getTitle() {
    return props.unboxingUpdateEnabled ? _react2.default.createElement(
      'h3',
      { className: 'articleTitle' },
      _lodash2.default.get(props, 'fields.sectionHeader')
    ) : props.topicTitle && _react2.default.createElement(
      _react2.default.Fragment,
      null,
      _react2.default.createElement(_reactHelmet2.default, { title: props.topicTitle + ' - ' + _lodash2.default.get(props, 'fields.title') }),
      _react2.default.createElement(
        'h2',
        { className: 'h1' },
        _lodash2.default.get(props, 'fields.title')
      )
    );
  };

  return _react2.default.createElement(
    'div',
    { className: 'Article' },
    getTitle(),
    _react2.default.createElement(
      'ul',
      { className: 'entries' },
      entries
    )
  );
};

Article.propTypes = (0, _extends3.default)({}, _support.articlePropTypes, {
  topicTitle: _propTypes2.default.string,
  unboxingUpdateEnabled: _propTypes2.default.bool
});

Article.defaultProps = {
  unboxingUpdateEnabled: false
};

Article.defaultProps = {
  topicTitle: ''
};

exports.default = Article;

/***/ }),

/***/ "./app/components/support/article.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/support/entries/entries.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/support/entries/multi-step-text-entry.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/toConsumableArray.js");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _support = __webpack_require__("./app/selectors/support.js");

__webpack_require__("./app/components/support/entries/entries.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Markdown = _uiCommon.components.Markdown;


var MultiStepTextEntry = function MultiStepTextEntry(_ref) {
  var steps = _ref.steps;
  return steps.map(function (step) {
    var _step$fields = step.fields,
        stepNumber = _step$fields.stepNumber,
        text = _step$fields.text;

    return _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)('textSection', {
          withStep: stepNumber
        }) },
      _react2.default.createElement(
        'p',
        { className: 'stepNumber' },
        stepNumber
      ),
      _react2.default.createElement(Markdown, { className: 'text paragraph stepText', source: text })
    );
  });
};

MultiStepTextEntry.propTypes = {
  steps: _propTypes2.default.arrayOf.apply(_propTypes2.default, (0, _toConsumableArray3.default)(_support.textPropTypes)).isRequired
};

exports.default = MultiStepTextEntry;

/***/ }),

/***/ "./app/components/support/entries/steps.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _support = __webpack_require__("./app/selectors/support.js");

var _video = __webpack_require__("./app/components/support/video.jsx");

var _video2 = _interopRequireDefault(_video);

__webpack_require__("./app/components/support/entries/steps.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MediaObject = _uiCommon.contentfulViews.MediaObject;
var Markdown = _uiCommon.components.Markdown;


var Step = function Step(props) {
  var assets = [];
  if (props.video) {
    if (props.video && props.video.length) {
      var src = void 0;
      var poster = void 0;
      props.video.forEach(function (content) {
        var _content$fields$file = content.fields.file,
            contentType = _content$fields$file.contentType,
            url = _content$fields$file.url;

        if (contentType === 'video/mp4') {
          src = url;
        } else {
          poster = url;
        }
      });
      assets.push(_react2.default.createElement(_video2.default, { key: '0', src: src, poster: poster }));
    }
  }

  if (props.image) {
    var _props$image$fields$f = props.image.fields.file,
        contentType = _props$image$fields$f.contentType,
        url = _props$image$fields$f.url;

    if (contentType === 'video/mp4') {
      assets.push(_react2.default.createElement(_video2.default, { key: '1', src: url }));
    } else {
      assets.push(_react2.default.createElement(MediaObject, (0, _extends3.default)({ key: '1' }, props.image.fields)));
    }
  }

  if (props.imageTwo) {
    var _props$imageTwo$field = props.imageTwo.fields.file,
        _contentType = _props$imageTwo$field.contentType,
        _url = _props$imageTwo$field.url;

    if (_contentType === 'video/mp4') {
      assets.push(_react2.default.createElement(_video2.default, { key: '2', src: _url }));
    } else {
      assets.push(_react2.default.createElement(MediaObject, (0, _extends3.default)({ key: '2' }, props.imageTwo.fields)));
    }
  }

  var summary = props.summary ? _react2.default.createElement(Markdown, { className: 'paragraph', source: props.summary }) : null;

  var classNames = (0, _classnames2.default)('Step', { multiImage: assets.length > 1 });

  return _react2.default.createElement(
    'div',
    { className: classNames },
    _react2.default.createElement(
      'div',
      { className: 'instructions' },
      _react2.default.createElement(
        'div',
        { className: 'count' },
        props.count
      ),
      _react2.default.createElement(
        'div',
        { className: 'text' },
        _react2.default.createElement(
          'h4',
          { className: 'header' },
          props.title
        ),
        _react2.default.createElement(
          'div',
          { className: 'summary' },
          summary
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'image' },
      assets
    )
  );
};

Step.propTypes = (0, _extends3.default)({}, _support.stepPropTypes, {
  count: _propTypes2.default.number.isRequired,
  unboxingUpdateEnabled: _propTypes2.default.bool
});

Step.defaultProps = {
  unboxingUpdateEnabled: false
};

var Steps = function Steps(props) {
  var steps = _lodash2.default.map(props.steps, function (step, index) {
    return _react2.default.createElement(Step, (0, _extends3.default)({
      key: index
    }, step.fields, {
      count: parseInt(index, 0) + 1,
      unboxingUpdateEnabled: props.unboxingUpdateEnabled }));
  });

  return _react2.default.createElement(
    'div',
    { className: 'Steps' },
    _react2.default.createElement(
      'h3',
      { className: props.unboxingUpdateEnabled ? 'sectionHeader' : 'h2', id: props.slug },
      props.title
    ),
    _react2.default.createElement(
      'div',
      { className: 'paragraph' },
      props.summary
    ),
    steps
  );
};

Steps.propTypes = (0, _extends3.default)({}, _support.instructionsPropTypes, {
  unboxingUpdateEnabled: _propTypes2.default.bool
});

Steps.defaultProps = {
  unboxingUpdateEnabled: false
};

exports.default = Steps;

/***/ }),

/***/ "./app/components/support/entries/steps.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/support/entries/text-entry.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/toConsumableArray.js");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _support = __webpack_require__("./app/selectors/support.js");

var _video = __webpack_require__("./app/components/support/video.jsx");

var _video2 = _interopRequireDefault(_video);

var _multiStepTextEntry = __webpack_require__("./app/components/support/entries/multi-step-text-entry.jsx");

var _multiStepTextEntry2 = _interopRequireDefault(_multiStepTextEntry);

__webpack_require__("./app/components/support/entries/entries.less");

__webpack_require__("./app/components/support/entries/text-entry.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Markdown = _uiCommon.components.Markdown;


var TextEntry = function TextEntry(_ref) {
  var slug = _ref.slug,
      title = _ref.title,
      text = _ref.text,
      video = _ref.video,
      media = _ref.media,
      unboxingUpdateEnabled = _ref.unboxingUpdateEnabled,
      stepNumber = _ref.stepNumber,
      multipleSteps = _ref.multipleSteps,
      steps = _ref.steps;

  var getAsset = function getAsset() {
    if (video && video.length) {
      var src = void 0;
      var poster = void 0;
      video.forEach(function (content) {
        var _content$fields$file = content.fields.file,
            contentType = _content$fields$file.contentType,
            url = _content$fields$file.url;

        if (contentType === 'video/mp4' || contentType === 'video/quicktime') {
          src = url;
        } else {
          poster = url;
        }
      });
      return _react2.default.createElement(_video2.default, { key: '1', src: src, poster: poster });
    }

    if (media) {
      return _react2.default.createElement('img', {
        src: _lodash2.default.get(media, 'fields.file.url') + '?w=600',
        alt: _lodash2.default.get(media, 'fields.file.title') });
    }
    return null;
  };

  var asset = getAsset();

  return unboxingUpdateEnabled ? _react2.default.createElement(
    'div',
    { className: 'TextEntryUpdated', id: slug },
    _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)('textSection', {
          withAsset: asset,
          withTitle: title
        }) },
      title && _react2.default.createElement(
        'h3',
        { className: 'sectionHeader' },
        title
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('textSection', {
            withStep: stepNumber
          }) },
        stepNumber && _react2.default.createElement(
          'p',
          { className: 'stepNumber' },
          stepNumber
        ),
        multipleSteps ? _react2.default.createElement(_multiStepTextEntry2.default, { steps: steps }) : _react2.default.createElement(Markdown, { className: 'text paragraph', source: text })
      )
    ),
    asset && _react2.default.createElement(
      'div',
      { className: 'mediaSection' },
      asset
    )
  ) : _react2.default.createElement(
    'div',
    { className: 'TextEntry', id: slug },
    title && _react2.default.createElement(
      'h3',
      { className: 'h2' },
      title
    ),
    _react2.default.createElement(Markdown, { className: 'text paragraph', source: text }),
    asset
  );
};

TextEntry.propTypes = (0, _extends3.default)({}, _support.textPropTypes, {
  video: _propTypes2.default.arrayOf.apply(_propTypes2.default, (0, _toConsumableArray3.default)(_support.textPropTypes)),
  stepNumber: _propTypes2.default.number,
  unboxingUpdateEnabled: _propTypes2.default.bool
});

TextEntry.defaultProps = {
  video: null,
  stepNumber: null,
  unboxingUpdateEnabled: false
};

exports.default = TextEntry;

/***/ }),

/***/ "./app/components/support/entries/text-entry.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/support/play-button.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("./node_modules/react/index.js");

function PlayButton (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Play Button"),React.createElement("g",{"id":"Play-Button","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},[React.createElement("g",{"id":"Group","fill":"#FFFFFF","fillOpacity":"0.9","key":0},React.createElement("circle",{"id":"Combined-Shape","cx":"22.5","cy":"22.5","r":"22.5"})),React.createElement("polygon",{"id":"Triangle","fill":"#26B8CE","transform":"translate(24.709247, 22.500000) rotate(-270.000000) translate(-24.709247, -22.500000) ","points":"24.7092471 12.375 34.8342471 32.625 14.5842471 32.625","key":1})])]);
}

PlayButton.defaultProps = {"width":"45px","height":"45px","viewBox":"0 0 45 45","version":"1.1"};

module.exports = PlayButton;

PlayButton.default = PlayButton;


/***/ }),

/***/ "./app/components/support/referral/confirmation.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextSection = _uiCommon.contentfulViews.TextSection;


var ReferralConfirmation = function ReferralConfirmation(props) {
  return _react2.default.createElement(
    'div',
    { className: 'ReferralPaymentPage contentPage' },
    _react2.default.createElement(TextSection, (0, _extends3.default)({}, props.confirmationPageContent, {
      headerClass: 'h1',
      className: 'content' }))
  );
};

ReferralConfirmation.propTypes = {
  confirmationPageContent: _propTypes2.default.shape(TextSection.propTypes).isRequired
};

exports.default = ReferralConfirmation;

/***/ }),

/***/ "./app/components/support/referral/error.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Markdown = _uiCommon.components.Markdown;


var ReferralError = function ReferralError(props) {
  var errorMessage = _lodash2.default.find(props.errorStrings, { fields: { id: props.status } });
  var errorTitle = _lodash2.default.get(errorMessage, 'fields.title') || 'Unknown Error';
  return _react2.default.createElement(
    'div',
    { className: 'ReferralPaymentPage contentPage' },
    _react2.default.createElement(
      'h1',
      { className: 'h1' },
      errorTitle
    ),
    _react2.default.createElement(Markdown, { className: 'paragraph content', source: _lodash2.default.get(errorMessage, 'fields.text') })
  );
};

ReferralError.propTypes = {
  status: _propTypes2.default.string.isRequired,
  errorStrings: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
};

exports.default = ReferralError;

/***/ }),

/***/ "./app/components/support/referral/main.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextSection = _uiCommon.contentfulViews.TextSection;


var ReferralMain = function ReferralMain(props) {
  return _react2.default.createElement(TextSection, (0, _extends3.default)({}, props.mainPageContent, {
    headerClass: 'h1',
    className: 'content' }));
};

ReferralMain.propTypes = {
  mainPageContent: _propTypes2.default.shape(TextSection.propTypes).isRequired
};

exports.default = ReferralMain;

/***/ }),

/***/ "./app/components/support/referral/payment-page.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _confirmation = __webpack_require__("./app/components/support/referral/confirmation.jsx");

var _confirmation2 = _interopRequireDefault(_confirmation);

var _error = __webpack_require__("./app/components/support/referral/error.jsx");

var _error2 = _interopRequireDefault(_error);

var _paypalConfirmation = __webpack_require__("./app/components/support/referral/paypal-confirmation.jsx");

var _paypalConfirmation2 = _interopRequireDefault(_paypalConfirmation);

var _paypalPage = __webpack_require__("./app/components/support/referral/paypal-page.jsx");

var _paypalPage2 = _interopRequireDefault(_paypalPage);

var _stripeFirst = __webpack_require__("./app/components/support/referral/stripe-first.jsx");

var _stripeFirst2 = _interopRequireDefault(_stripeFirst);

var _stripeReturn = __webpack_require__("./app/components/support/referral/stripe-return.jsx");

var _stripeReturn2 = _interopRequireDefault(_stripeReturn);

__webpack_require__("./app/components/support/referral/payment-page.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReferralPaymentPage = function ReferralPaymentPage(props) {
  var navigateToStripe = function navigateToStripe() {
    window.location.replace('https://connect.stripe.com/express/oauth/authorize?client_id=' + props.clientID + '&state=' + props.path + '&redirect_uri=' + props.redirectURI);
  };

  if (props.payoutRequested || props.status === 'success') {
    if (props.paypal) return _react2.default.createElement(_paypalConfirmation2.default, props);
    return _react2.default.createElement(_confirmation2.default, props);
  } else if (props.status) {
    return _react2.default.createElement(_error2.default, props);
  } else if (props.paypal) {
    return _react2.default.createElement(_paypalPage2.default, props);
  } else if (props.stripeID) {
    return _react2.default.createElement(_stripeReturn2.default, (0, _extends3.default)({}, props, { navigateToStripe: navigateToStripe }));
  }

  return _react2.default.createElement(_stripeFirst2.default, (0, _extends3.default)({}, props, { navigateToStripe: navigateToStripe }));
};

ReferralPaymentPage.propTypes = {
  path: _propTypes2.default.string,
  paypal: _propTypes2.default.string,
  redirectURI: _propTypes2.default.string.isRequired,
  payoutRequested: _propTypes2.default.bool,
  stripeID: _propTypes2.default.string,
  clientID: _propTypes2.default.string,
  status: _propTypes2.default.string
};

ReferralPaymentPage.defaultProps = {
  path: null,
  paypal: null,
  refereeID: null,
  referrerID: null,
  payoutRequested: false,
  stripeID: '',
  clientID: '',
  status: null
};

exports.default = ReferralPaymentPage;

/***/ }),

/***/ "./app/components/support/referral/payment-page.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/support/referral/paypal-confirmation.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextSection = _uiCommon.contentfulViews.TextSection;


var PaypalConfirmation = function PaypalConfirmation(props) {
  return _react2.default.createElement(
    'div',
    { className: 'ReferralPaymentPage contentPage' },
    _react2.default.createElement(TextSection, (0, _extends3.default)({}, props.paypalConfirmationPageContent, {
      headerClass: 'h1',
      className: 'content' }))
  );
};

PaypalConfirmation.propTypes = {
  paypalConfirmationPageContent: _propTypes2.default.shape(TextSection.propTypes).isRequired
};

exports.default = PaypalConfirmation;

/***/ }),

/***/ "./app/components/support/referral/paypal-page.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextSection = _uiCommon.contentfulViews.TextSection;
var Button = _uiCommon.components.Button,
    Markdown = _uiCommon.components.Markdown;


var ReferralPaypalPage = function ReferralPaypalPage(props) {
  var email = '';
  var onPaymentRequest = function onPaymentRequest() {
    props.requestPaypal(email, props.path);
  };
  var updateEmail = function updateEmail(event) {
    email = event.target.value;
  };
  return _react2.default.createElement(
    'div',
    { className: 'ReferralPaymentPage contentPage' },
    _react2.default.createElement(TextSection, (0, _extends3.default)({}, props.paypalPageContent, {
      headerClass: 'h1',
      className: 'content' })),
    _react2.default.createElement(
      'div',
      { className: 'content' },
      _react2.default.createElement('input', {
        type: 'text',
        placeholder: 'email',
        className: 'paypalEmailInput',
        onChange: updateEmail }),
      _react2.default.createElement(
        Button,
        {
          type: 'default',
          size: 'small',
          className: 'paypalSubmitButton',
          onClick: onPaymentRequest },
        props.pageStrings['credit-removal-button-for-returning-users-rto']
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'content footer-info' },
      _react2.default.createElement(Markdown, { source: props.createPaypalText.text })
    )
  );
};

ReferralPaypalPage.propTypes = {
  requestPaypal: _propTypes2.default.func.isRequired, // eslint-disable-line
  path: _propTypes2.default.string.isRequired, // eslint-disable-line
  paypalPageContent: _propTypes2.default.shape(TextSection.propTypes).isRequired,
  createPaypalText: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
  pageStrings: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired
};

exports.default = ReferralPaypalPage;

/***/ }),

/***/ "./app/components/support/referral/stripe-first.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _link = __webpack_require__("./app/common/components/link.jsx");

var _link2 = _interopRequireDefault(_link);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _main = __webpack_require__("./app/components/support/referral/main.jsx");

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = _uiCommon.components.Button,
    Markdown = _uiCommon.components.Markdown;


var ReferralStripe = function ReferralStripe(props) {
  return _react2.default.createElement(
    'div',
    { className: 'ReferralPaymentPage contentPage' },
    _react2.default.createElement(_main2.default, props),
    _react2.default.createElement(
      Button,
      {
        onClick: props.navigateToStripe,
        type: 'default',
        size: 'large' },
      props.pageStrings['credit-removal-button-rto']
    ),
    _react2.default.createElement(
      'div',
      { className: 'content footer-info' },
      _react2.default.createElement(Markdown, { className: 'paragraph', source: _lodash2.default.get(props.paypalLinkText, 'text') }),
      _react2.default.createElement(
        _link2.default,
        { to: '/referral-payment?state=' + props.path + '&paypal=true', className: 'button text' },
        _lodash2.default.get(props.paypalLinkText, 'title')
      )
    )
  );
};

ReferralStripe.propTypes = {
  navigateToStripe: _propTypes2.default.func.isRequired,
  pageStrings: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
  paypalLinkText: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
  path: _propTypes2.default.string.isRequired
};

exports.default = ReferralStripe;

/***/ }),

/***/ "./app/components/support/referral/stripe-return.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _link = __webpack_require__("./app/common/components/link.jsx");

var _link2 = _interopRequireDefault(_link);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _main = __webpack_require__("./app/components/support/referral/main.jsx");

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = _uiCommon.components.Button,
    Markdown = _uiCommon.components.Markdown;


var ReferralStripeReturn = function ReferralStripeReturn(props) {
  var onPaymentRequest = function onPaymentRequest() {
    props.requestPayment(props.stripeID, props.path);
  };

  return _react2.default.createElement(
    'div',
    { className: 'ReferralPaymentPage contentPage' },
    _react2.default.createElement(_main2.default, props),
    _react2.default.createElement(
      Button,
      {
        onClick: onPaymentRequest,
        type: 'default',
        size: 'large' },
      props.pageStrings['credit-removal-button-for-returning-users-rto']
    ),
    _react2.default.createElement(
      'div',
      { className: 'content footer-info' },
      _react2.default.createElement(Markdown, { className: 'paragraph', source: _lodash2.default.get(props.returningText, 'text') }),
      _react2.default.createElement(
        Button,
        {
          onClick: props.navigateToStripe,
          type: 'text' },
        _lodash2.default.get(props.returningText, 'title')
      ),
      _react2.default.createElement(Markdown, { className: 'paragraph', source: _lodash2.default.get(props.paypalLinkText, 'text') }),
      _react2.default.createElement(
        _link2.default,
        { to: '/referral-payment?state=' + props.path + '&paypal=true', className: 'button text' },
        _lodash2.default.get(props.paypalLinkText, 'title')
      )
    )
  );
};

ReferralStripeReturn.propTypes = {
  requestPayment: _propTypes2.default.func.isRequired,
  stripeID: _propTypes2.default.string.isRequired,
  path: _propTypes2.default.string.isRequired,
  navigateToStripe: _propTypes2.default.func.isRequired,
  pageStrings: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
  paypalLinkText: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
  returningText: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired
};

exports.default = ReferralStripeReturn;

/***/ }),

/***/ "./app/components/support/video.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/slicedToArray.js");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _playButton = __webpack_require__("./app/components/support/play-button.svg");

var _playButton2 = _interopRequireDefault(_playButton);

__webpack_require__("./app/components/support/video.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatTime = function formatTime(timeInSeconds) {
  var minutes = Math.round(timeInSeconds / 60);
  var seconds = Math.round(timeInSeconds % 60);
  return (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
};

/* eslint-disable jsx-a11y/media-has-caption */
// A customized video component used in setup guide.
// These typically will not have any soundtrack
var Video = function Video(_ref) {
  var src = _ref.src,
      poster = _ref.poster;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      isPlaying = _useState2[0],
      setIsPlaying = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      currentTimeLine = _useState4[0],
      setcurrentTimeLine = _useState4[1];

  var videoRef = (0, _react.useRef)(null);
  var timelineRef = (0, _react.useRef)(null);

  var onPlay = function onPlay() {
    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  var onEnded = function onEnded() {
    setIsPlaying(false);
    videoRef.current.load();
  };

  var getTimeLeft = function getTimeLeft() {
    var _videoRef$current = videoRef.current,
        duration = _videoRef$current.duration,
        currentTime = _videoRef$current.currentTime;

    return formatTime(currentTime) + ' / ' + formatTime(duration);
  };

  var onTimeUpdate = function onTimeUpdate() {
    var _videoRef$current2 = videoRef.current,
        currentTime = _videoRef$current2.currentTime,
        duration = _videoRef$current2.duration;

    var percentagePosition = 100 * currentTime / duration;
    if (timelineRef && timelineRef.current) {
      timelineRef.current.style.backgroundSize = percentagePosition + '% 100%';
    }
    setcurrentTimeLine(percentagePosition);
  };

  var onChangeTime = function onChangeTime(e) {
    var value = e.target.value;
    var duration = videoRef.current.duration;

    var updatedTime = value * duration / 100;
    videoRef.current.currentTime = updatedTime;
  };

  var onMouseDown = function onMouseDown() {
    videoRef.current.pause();
  };

  var onMouseUp = function onMouseUp() {
    videoRef.current.play();
  };

  return _react2.default.createElement(
    'div',
    { className: 'video-player ' + (isPlaying ? 'playing' : '') },
    _react2.default.createElement(
      'video',
      {
        id: 'video',
        onClick: onPlay,
        onEnded: onEnded,
        ref: videoRef,
        onTimeUpdate: onTimeUpdate,
        poster: poster },
      _react2.default.createElement('source', { src: src, type: 'video/mp4' })
    ),
    _react2.default.createElement(
      'div',
      { className: 'controls' },
      !isPlaying && _react2.default.createElement(
        'button',
        { className: 'play-button control-button clearButton', onClick: onPlay },
        _react2.default.createElement(_playButton2.default, { className: 'clearSvg' })
      ),
      isPlaying && _react2.default.createElement(
        'div',
        { className: 'timeline-container' },
        _react2.default.createElement(
          'span',
          { className: 'time' },
          getTimeLeft()
        ),
        _react2.default.createElement('input', {
          type: 'range',
          min: '0',
          max: '100',
          className: 'timeline',
          onMouseDown: onMouseDown,
          onMouseUp: onMouseUp,
          onInput: onChangeTime,
          value: currentTimeLine,
          ref: timelineRef })
      )
    )
  );
};

Video.propTypes = {
  src: _propTypes2.default.string.isRequired,
  poster: _propTypes2.default.string
};

Video.defaultProps = {
  poster: null
};

exports.default = Video;

/***/ }),

/***/ "./app/components/support/video.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/unauthorized.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _strings = __webpack_require__("./app/strings.js");

var _strings2 = _interopRequireDefault(_strings);

__webpack_require__("./app/components/page-not-found.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Unauthorized = function Unauthorized() {
  return _react2.default.createElement(
    'div',
    { className: 'PageNotFound' },
    _react2.default.createElement(_reactHelmet2.default, { title: 'Unauthorized Access' }),
    _react2.default.createElement(
      'h1',
      { className: 'h1' },
      '403'
    ),
    _react2.default.createElement(
      'h4',
      { className: 'h4' },
      _strings2.default.UNAUTHORIZED_SUB
    )
  );
};

exports.default = Unauthorized;

/***/ }),

/***/ "./app/containers/account/create.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _create = __webpack_require__("./app/components/account/create.jsx");

var _create2 = _interopRequireDefault(_create);

var _accountApi = __webpack_require__("./app/api/account-api.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStringsForPage = _uiCommon.contentfulModels.getStringsForPage;


var mapStateToProps = function mapStateToProps(state) {
  return {
    success: _lodash2.default.get(state, 'account.createAccount.success'),
    userAlreadyExistsError: _lodash2.default.get(state, 'account.createAccount.error.userAlreadyExists'),
    unacceptableEmailError: _lodash2.default.get(state, 'account.createAccount.error.unacceptableEmail'),
    genericError: _lodash2.default.get(state, 'account.createAccount.error.generic'),
    pageStrings: getStringsForPage(_lodash2.default.get(state, 'account.createAccountPage'))
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(values) {
      return dispatch((0, _accountApi.createAccount)(values));
    }
  };
};

var hasCreateAccountContent = function hasCreateAccountContent(dispatch) {
  return dispatch((0, _accountApi.fetchCreateAccountPage)());
};

var CreateAccountContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIsomorphicRender.preload)(function (_ref) {
  var dispatch = _ref.dispatch;
  return hasCreateAccountContent(dispatch);
})(_create2.default));

exports.default = CreateAccountContainer;

/***/ }),

/***/ "./app/containers/landing/glowforge-landing.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _glowforgeLandingPage = __webpack_require__("./app/components/landing/glowforge-landing-page.jsx");

var _glowforgeLandingPage2 = _interopRequireDefault(_glowforgeLandingPage);

var _common = __webpack_require__("./app/common/selectors/common.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    page: (0, _extends3.default)({}, _lodash2.default.get(state, 'landing.glowforgeLandingPage')),
    referralInfo: (0, _common.getReferralInfo)(state),
    products: (0, _common.getProducts)(state)
  };
};

// Please do all preload in landing-app for performance reasons
// to make all requests in parallel
var GlowforgeLandingPageContainer = (0, _reactRedux.connect)(mapStateToProps)(_glowforgeLandingPage2.default);

exports.default = GlowforgeLandingPageContainer;

/***/ }),

/***/ "./app/containers/landing/landing-app.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/toConsumableArray.js");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _basicApp = __webpack_require__("./app/components/root-apps/basic-app.jsx");

var _basicApp2 = _interopRequireDefault(_basicApp);

var _base = __webpack_require__("./app/common/containers/base.js");

var _landingApi = __webpack_require__("./app/api/landing-api.js");

var _glowforgeStoreApi = __webpack_require__("./app/store/api/glowforge-store-api.js");

var _commonApi = __webpack_require__("./app/common/api/common-api.js");

var _clientPreload = __webpack_require__("./app/common/containers/client-preload.jsx");

var _clientPreload2 = _interopRequireDefault(_clientPreload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  var _baseNoAuthMapDispatc = (0, _base.baseNoAuthMapDispatchToProps)(dispatch),
      clientPreloadBase = _baseNoAuthMapDispatc.clientPreloads,
      base = (0, _objectWithoutProperties3.default)(_baseNoAuthMapDispatc, ['clientPreloads']);
  // merge client preloads


  var clientPreloads = [].concat((0, _toConsumableArray3.default)(clientPreloadBase), [function () {
    return dispatch((0, _commonApi.fetchReferral)());
  }]);
  return (0, _extends3.default)({}, base, {
    clientPreloads: clientPreloads
  });
};

var AppContainer = (0, _reactRedux.connect)(_base.baseMapStateToProps, mapDispatchToProps)((0, _reactIsomorphicRender.preload)(function (_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;
  return (0, _base.baseNoAuthPreload)(dispatch, getState()).concat([dispatch((0, _glowforgeStoreApi.fetchProducts)()), dispatch((0, _landingApi.fetchGlowforgeLandingPage)())]);
})((0, _clientPreload2.default)(_basicApp2.default)));

exports.default = AppContainer;

/***/ }),

/***/ "./app/containers/marketing-page.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _marketingApp = __webpack_require__("./app/components/root-apps/marketing-app.jsx");

var _marketingApp2 = _interopRequireDefault(_marketingApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return (0, _extends3.default)({}, _lodash2.default.get(state, 'marketing.marketingPage'));
};

var MarketingContainer = mapStateToProps(_marketingApp2.default);

exports.default = MarketingContainer;

/***/ }),

/***/ "./app/containers/no-glowforge.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _commonApi = __webpack_require__("./app/common/api/common-api.js");

var _noGlowforge = __webpack_require__("./app/components/no-glowforge.jsx");

var _noGlowforge2 = _interopRequireDefault(_noGlowforge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSectionForPageByIdAndType = _uiCommon.contentfulModels.getSectionForPageByIdAndType;


var mapStateToProps = function mapStateToProps(state) {
  var page = _lodash2.default.get(state, 'common.noGlowforgePage');
  return {
    arrivedSection: getSectionForPageByIdAndType(page, 'onboarding-no-gf-arrived', 'textSection'),
    notArrivedSection: getSectionForPageByIdAndType(page, 'onboarding-no-gf-not-arrived', 'textSection'),
    addSomeonesSection: getSectionForPageByIdAndType(page, 'onboarding-no-gf-add-someones', 'textSection'),
    haventPurchasedSection: getSectionForPageByIdAndType(page, 'onboarding-no-gf-havent-purchased', 'textSection'),
    title: getSectionForPageByIdAndType(page, 'onboarding-no-gf-title', 'textString'),
    beginSetupButton: getSectionForPageByIdAndType(page, 'onboarding-begin-setup', 'buttonLink')
  };
};

var hasNoGlowforgePageContent = function hasNoGlowforgePageContent(dispatch) {
  return _promise2.default.all([dispatch((0, _commonApi.fetchNoGlowforgePage)())]);
};

var NoGlowforgeContainer = (0, _reactRedux.connect)(mapStateToProps)((0, _reactIsomorphicRender.preload)(function (_ref) {
  var dispatch = _ref.dispatch;
  return hasNoGlowforgePageContent(dispatch);
})(_noGlowforge2.default));

exports.default = NoGlowforgeContainer;

/***/ }),

/***/ "./app/containers/root-apps/marketing-app.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _marketingApi = __webpack_require__("./app/api/marketing-api.js");

var _marketingApi2 = _interopRequireDefault(_marketingApi);

var _base = __webpack_require__("./app/common/containers/base.js");

var _marketingApp = __webpack_require__("./app/components/root-apps/marketing-app.jsx");

var _marketingApp2 = _interopRequireDefault(_marketingApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return (0, _extends3.default)({}, (0, _base.baseMapStateToProps)(state, ownProps), _lodash2.default.get(state, 'marketing.marketingPage'));
};

var MarketingContainer = (0, _reactRedux.connect)(mapStateToProps, _base.baseMapDispatchToProps)((0, _reactIsomorphicRender.preload)(function (_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState,
      parameters = _ref.parameters;
  return _promise2.default.all([dispatch((0, _marketingApi2.default)(parameters.slug))].concat((0, _base.basePreload)(dispatch, getState())));
})(_marketingApp2.default));

exports.default = MarketingContainer;

/***/ }),

/***/ "./app/containers/root-apps/settings-app.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/toConsumableArray.js");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _accountSettingsApi = __webpack_require__("./app/api/account-settings-api.js");

var _base = __webpack_require__("./app/common/containers/base.js");

var _commonApi = __webpack_require__("./app/common/api/common-api.js");

var _subscriptionsUtils = __webpack_require__("./app/containers/settings/subscriptions-utils.js");

var _settingsApp = __webpack_require__("./app/components/root-apps/settings-app.jsx");

var _settingsApp2 = _interopRequireDefault(_settingsApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return (0, _extends3.default)({}, (0, _base.baseMapStateToProps)(state, ownProps));
};

var AppContainer = (0, _reactRedux.connect)(mapStateToProps, _base.baseMapDispatchToProps)((0, _reactIsomorphicRender.preload)(function (_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;
  return _promise2.default.all([dispatch((0, _accountSettingsApi.fetchUserSettingsPage)()), dispatch((0, _commonApi.fetchAddressCountries)())].concat((0, _toConsumableArray3.default)((0, _base.basePreload)(dispatch, getState()))))
  // Need this to happen after we have user info
  .then(function () {
    return _promise2.default.all((0, _subscriptionsUtils.preloadSubscriptions)(getState(), dispatch));
  });
})(_settingsApp2.default));

exports.default = AppContainer;

/***/ }),

/***/ "./app/containers/settings/accept-invite.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _commonApi = __webpack_require__("./app/common/api/common-api.js");

var _acceptInvite = __webpack_require__("./app/components/settings/accept-invite.jsx");

var _acceptInvite2 = _interopRequireDefault(_acceptInvite);

var _user = __webpack_require__("./app/selectors/user.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    inviterName: ownProps.location.query.inviter,
    initialValues: (0, _user.getBasicAccountInfo)(state),
    userSubmitError: _lodash2.default.get(state, 'common.userSubmitError')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
  return {
    // The (valid, pending) invitation token is necessary to authorize the user to
    // update their password
    onSubmit: function onSubmit(values) {
      return dispatch((0, _commonApi.updateUserProfile)((0, _extends3.default)({}, values, { invitation: props.location.query.invitation
      }))).then(function () {
        return dispatch((0, _reactIsomorphicRender.goto)('/setup/terms-and-conditions?entry=new_user'));
      });
    }
  };
};

var AcceptInviteContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_acceptInvite2.default);

exports.default = AcceptInviteContainer;

/***/ }),

/***/ "./app/containers/settings/change-access-dialog.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _subscriptions = __webpack_require__("./app/selectors/subscriptions.js");

var _changeAccessDialog = __webpack_require__("./app/components/settings/change-access-dialog.jsx");

var _changeAccessDialog2 = _interopRequireDefault(_changeAccessDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    isSubscriptionsEnabled: _subscriptions.subscriptions.isEnabled(state),
    isSubscriber: _subscriptions.subscriptions.isSubscriber(state),
    subscription: _subscriptions.subscriptions.current(state),
    addedUsers: _subscriptions.subscriptions.getAddedUsers(state),
    totalUsers: _subscriptions.subscriptions.getTotalUsers(state)
  };
};

var ChangeAccessDialogContainer = (0, _reactRedux.connect)(mapStateToProps)(_changeAccessDialog2.default);

exports.default = ChangeAccessDialogContainer;

/***/ }),

/***/ "./app/containers/settings/general-account.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _commonApi = __webpack_require__("./app/common/api/common-api.js");

var _generalAccount = __webpack_require__("./app/components/settings/general-account.jsx");

var _generalAccount2 = _interopRequireDefault(_generalAccount);

var _user = __webpack_require__("./app/selectors/user.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    initialValues: (0, _user.getBasicAccountInfo)(state),
    userSubmitError: _lodash2.default.get(state, 'common.userSubmitError')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(values) {
      return dispatch((0, _commonApi.updateUserProfile)(values));
    }
  };
};

var GeneralAccountContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_generalAccount2.default);

exports.default = GeneralAccountContainer;

/***/ }),

/***/ "./app/containers/settings/invite.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _reduxForm = __webpack_require__("./node_modules/redux-form/es/index.js");

var _accountSettingsApi = __webpack_require__("./app/api/account-settings-api.js");

var api = _interopRequireWildcard(_accountSettingsApi);

var _commonApi = __webpack_require__("./app/common/api/common-api.js");

var _userInvite = __webpack_require__("./app/components/settings/user-invite.jsx");

var _userInvite2 = _interopRequireDefault(_userInvite);

var _machines = __webpack_require__("./app/selectors/machines.js");

var machines = _interopRequireWildcard(_machines);

var _subscriptions = __webpack_require__("./app/selectors/subscriptions.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStringsForPage = _uiCommon.contentfulModels.getStringsForPage,
    getMarkdownStringsForPage = _uiCommon.contentfulModels.getMarkdownStringsForPage;


var REDIRECT_DELAY = 500;

var mapStateToProps = function mapStateToProps(state) {
  return {
    machines: machines.getMachineList(state),
    managedMachines: machines.getManagedMachineList(state),
    initialValues: machines.getInitialMachineForInvite(state),
    machineListError: _lodash2.default.get((0, _reduxForm.getFormSyncErrors)('userInviteForm')(state), 'machines'),
    formInvalid: (0, _reduxForm.isInvalid)('userInviteForm')(state),
    pageStrings: getStringsForPage(_lodash2.default.get(state, 'accountSettings.settingsPage.fields')),
    pageMarkdownStrings: getMarkdownStringsForPage(_lodash2.default.get(state, 'accountSettings.settingsPage.fields')),
    isLoading: _lodash2.default.get(state, 'common.machinesLoading') || !true,
    subscription: _subscriptions.subscriptions.current(state),
    addedUsers: _subscriptions.subscriptions.getAddedUsers(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
  return {
    onCancel: function onCancel() {
      if (props.location.query.returnUrl) {
        window.location.href = props.location.query.returnUrl;
      } else {
        dispatch((0, _reactIsomorphicRender.goto)('/settings/users'));
      }
    },
    onSubmit: function onSubmit(values) {
      return new _promise2.default(function (resolve) {
        dispatch(api.sendInvites(values, function () {
          setTimeout(function () {
            if (props.location.query.returnUrl) {
              window.location.href = props.location.query.returnUrl;
            } else {
              dispatch((0, _reactIsomorphicRender.goto)('/settings/users'));
            }
          }, REDIRECT_DELAY);
          resolve();
        }));
      });
    }
  };
};

var UserInviteContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIsomorphicRender.preload)(function (_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;

  var promises = [];
  // If we already have a list of machines for users show that list and
  // kick off async refresh calls
  if (!_lodash2.default.get(getState(), 'common.machinesLoading')) {
    promises.push(dispatch((0, _commonApi.fetchMachinesForUser)()));
  }

  return _promise2.default.all(promises);
}, {})(_userInvite2.default));

exports.default = UserInviteContainer;

/***/ }),

/***/ "./app/containers/settings/machine-access-field.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _subscriptions = __webpack_require__("./app/selectors/subscriptions.js");

var _machineAccessField = __webpack_require__("./app/components/settings/machine-access-field.jsx");

var _machineAccessField2 = _interopRequireDefault(_machineAccessField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    isSubscriber: _subscriptions.subscriptions.isSubscriber(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

var MachineAccessFieldContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_machineAccessField2.default);

exports.default = MachineAccessFieldContainer;

/***/ }),

/***/ "./app/containers/settings/password.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _commonApi = __webpack_require__("./app/common/api/common-api.js");

var _password = __webpack_require__("./app/components/settings/password.jsx");

var _password2 = _interopRequireDefault(_password);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    userSubmitError: _lodash2.default.get(state, 'common.userSubmitError')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(values) {
      return dispatch((0, _commonApi.updateUserProfile)(values));
    }
  };
};

var PasswordContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_password2.default);

exports.default = PasswordContainer;

/***/ }),

/***/ "./app/containers/settings/printers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _commonApi = __webpack_require__("./app/common/api/common-api.js");

var _printers = __webpack_require__("./app/components/settings/printers.jsx");

var _printers2 = _interopRequireDefault(_printers);

var _machines = __webpack_require__("./app/selectors/machines.js");

var machineSelectors = _interopRequireWildcard(_machines);

var _subscriptions = __webpack_require__("./app/selectors/subscriptions.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStringsForPage = _uiCommon.contentfulModels.getStringsForPage;


var mapStateToProps = function mapStateToProps(state) {
  return {
    machines: machineSelectors.getMachineList(state),
    isLoading: _lodash2.default.get(state, 'common.machinesLoading') || !true,
    isRestricted: _subscriptions.subscriptions.getIsRestricted(state),
    pageStrings: getStringsForPage(_lodash2.default.get(state, 'accountSettings.settingsPage.fields'))
  };
};

var PrintersContainer = (0, _reactRedux.connect)(mapStateToProps)((0, _reactIsomorphicRender.preload)(function (_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;

  if (!_lodash2.default.get(getState(), 'common.machinesLoading')) {
    dispatch((0, _commonApi.fetchMachinesForUser)());
  }
  return _promise2.default.resolve();
}, { client: true, blocking: false })(_printers2.default));

exports.default = PrintersContainer;

/***/ }),

/***/ "./app/containers/settings/purchase-history.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _accountSettingsApi = __webpack_require__("./app/api/account-settings-api.js");

var _purchaseHistory = __webpack_require__("./app/components/settings/purchase-history.jsx");

var _purchaseHistory2 = _interopRequireDefault(_purchaseHistory);

var _user = __webpack_require__("./app/selectors/user.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStringsForPage = _uiCommon.contentfulModels.getStringsForPage;


var mapStateToProps = function mapStateToProps(state) {
  return {
    purchaseHistory: (0, _user.getPurchaseHistory)(state),
    pageStrings: getStringsForPage(_.get(state, 'accountSettings.settingsPage.fields'))
  };
};

var PurchaseHistoryContainer = (0, _reactRedux.connect)(mapStateToProps)((0, _reactIsomorphicRender.preload)(function (_ref) {
  var dispatch = _ref.dispatch;
  return _promise2.default.all([dispatch((0, _accountSettingsApi.fetchUserPurchaseHistory)())]);
})(_purchaseHistory2.default));

exports.default = PurchaseHistoryContainer;

/***/ }),

/***/ "./app/containers/settings/settings-nav.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = loadSettings;

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _subscriptions = __webpack_require__("./app/selectors/subscriptions.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loadSettings(Component) {
  var mapStateToProps = function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({
      features: _lodash2.default.get(state, 'common.features'),
      isRestricted: _subscriptions.subscriptions.getIsRestricted(state)
    }, ownProps);
  };

  return (0, _reactRedux.connect)(mapStateToProps)(Component);
}

/***/ }),

/***/ "./app/containers/settings/subscription.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _subscriptions = __webpack_require__("./app/selectors/subscriptions.js");

var _subscriptions2 = __webpack_require__("./app/api/subscriptions.js");

var _subscription = __webpack_require__("./app/components/settings/subscription.jsx");

var _subscription2 = _interopRequireDefault(_subscription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStringsForPage = _uiCommon.contentfulModels.getStringsForPage;


var mapStateToProps = function mapStateToProps(state) {
  return {
    canManageSubscriptions: _subscriptions.subscriptions.canManage(state),
    subscriptionManageLink: _subscriptions.subscriptions.getManageLink(state),
    subscription: _subscriptions.subscriptions.current(state),
    pageStrings: getStringsForPage(_.get(state, 'accountSettings.settingsPage.fields'))
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onManageSubscriptions: function onManageSubscriptions(url, onComplete) {
      return dispatch((0, _subscriptions2.manageSubscription)(url, onComplete));
    }
  };
};

var SubscriptionContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIsomorphicRender.preload)(function (_ref) {
  var dispatch = _ref.dispatch;
  return _promise2.default.all([dispatch((0, _subscriptions2.fetchSubscriptionsStatus)())]);
})(_subscription2.default));

exports.default = SubscriptionContainer;

/***/ }),

/***/ "./app/containers/settings/subscriptions-utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preloadSubscriptions = exports.subscriptionsLoading = undefined;

var _subscriptions = __webpack_require__("./app/api/subscriptions.js");

var _subscriptions2 = __webpack_require__("./app/selectors/subscriptions.js");

var subscriptionsLoading = exports.subscriptionsLoading = function subscriptionsLoading(state) {
  return _subscriptions2.subscriptions.isLoading(state);
};

var preloadSubscriptions = exports.preloadSubscriptions = function preloadSubscriptions(state, dispatch) {
  // Load subscription info
  var enabled = _subscriptions2.subscriptions.isEnabled(state);
  var loading = _subscriptions2.subscriptions.isLoading(state);
  if (enabled && !loading) {
    return [dispatch((0, _subscriptions.fetchSubscriptionsStatus)()), dispatch((0, _subscriptions.fetchSubscriptionUsers)())];
  }
};

/***/ }),

/***/ "./app/containers/settings/users.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _accountSettingsApi = __webpack_require__("./app/api/account-settings-api.js");

var _commonApi = __webpack_require__("./app/common/api/common-api.js");

var _subscriptions = __webpack_require__("./app/api/subscriptions.js");

var _usersAndInvites = __webpack_require__("./app/components/settings/users-and-invites.jsx");

var _usersAndInvites2 = _interopRequireDefault(_usersAndInvites);

var _machines = __webpack_require__("./app/selectors/machines.js");

var machineSelectors = _interopRequireWildcard(_machines);

var _subscriptions2 = __webpack_require__("./app/selectors/subscriptions.js");

var _subscriptionsUtils = __webpack_require__("./app/containers/settings/subscriptions-utils.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStringsForPage = _uiCommon.contentfulModels.getStringsForPage,
    getMarkdownStringsForPage = _uiCommon.contentfulModels.getMarkdownStringsForPage;


var mapStateToProps = function mapStateToProps(state) {
  return {
    users: machineSelectors.getSortedAllUsersForCurrentUsersMachines(state),
    pendingInvites: machineSelectors.getPendingInvites(state),
    machines: machineSelectors.getMachineList(state),
    managedMachines: machineSelectors.getManagedMachineList(state),
    pageStrings: getStringsForPage(_lodash2.default.get(state, 'accountSettings.settingsPage.fields')),
    pageMarkdownStrings: getMarkdownStringsForPage(_lodash2.default.get(state, 'accountSettings.settingsPage.fields')),
    isLoading: _lodash2.default.get(state, 'common.machinesLoading') || !true || (0, _subscriptionsUtils.subscriptionsLoading)(state),
    isSubscriptionActive: _subscriptions2.subscriptions.isActive(state),
    isSubscriber: _subscriptions2.subscriptions.isSubscriber(state),
    subscriptionUsers: _subscriptions2.subscriptions.getAddedUsers(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    gotoInviteForm: function gotoInviteForm() {
      return dispatch((0, _reactIsomorphicRender.goto)('/settings/users/invite'));
    },
    /**
     * onAccessChangeSubmit handles the submit of the user change access dialog form.
     * It allows you to update an added machine user's machine access, as well as their
     * Subscription added user status.  If you remove a user from all machines you have access to,
     * and they are also an added Subscription user on your account, this will remove that user as
     * an added user on your Subscription.
     */
    onAccessChangeSubmit: function onAccessChangeSubmit(values, initialValues, subscriptionData) {
      var allMachinesDeselected = _lodash2.default.get(values, 'machines.length', 0) === 0;
      var subscriberChanged = initialValues.subscriber !== values.subscriber || allMachinesDeselected;
      if (subscriberChanged && !_lodash2.default.isEmpty(subscriptionData.email)) {
        var _done = function _done() {
          return dispatch((0, _subscriptions.fetchSubscriptionUsers)());
        };
        // user must be on your machine to be a subscriber
        // if removed from all machines, will remove them as added user
        var flag = allMachinesDeselected ? false : values.subscriber;
        var subscription = subscriptionData.subscription,
            addedUsers = subscriptionData.addedUsers,
            email = subscriptionData.email;

        var addedUser = _lodash2.default.find(addedUsers, function (u) {
          return u.attributes.secondary_user_email === email;
        });
        if (!flag && addedUser) {
          dispatch((0, _subscriptions.removeUserAsMember)(subscription.id, addedUser.id, _done));
        } else if (flag && !addedUser) {
          dispatch((0, _subscriptions.addUserAsMember)(subscription.id, email, _done));
        }
      }

      var done = function done() {
        dispatch((0, _commonApi.fetchMachinesForUser)());
        dispatch((0, _accountSettingsApi.fetchPendingInvites)());
      };

      var initialMachines = initialValues.machines;

      if (!_lodash2.default.isEqual(values.machines, initialMachines)) {
        dispatch((0, _accountSettingsApi.toggleMachinesForUser)(values.email, values.machines, initialMachines, done));
      }
    }
  };
};

var UsersContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIsomorphicRender.preload)(function (_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;

  var state = getState();
  var promises = [];
  if (!_lodash2.default.get(state, 'common.machinesLoading')) {
    promises.push(dispatch((0, _commonApi.fetchMachinesForUser)()));
  }

  promises.push(dispatch((0, _accountSettingsApi.fetchPendingInvites)()));

  return _promise2.default.all(promises);
}, { client: true, blocking: false })(_usersAndInvites2.default));

exports.default = UsersContainer;

/***/ }),

/***/ "./app/containers/setup/add-glowforge.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _addGlowforge = __webpack_require__("./app/components/setup/add-glowforge.jsx");

var _addGlowforge2 = _interopRequireDefault(_addGlowforge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    downloadUrl: _lodash2.default.get(state.common, 'features').GFCORE_SITE_URL + '/setup/download'
  };
};

var AddGlowforgeContainer = (0, _reactRedux.connect)(mapStateToProps)(_addGlowforge2.default);

exports.default = AddGlowforgeContainer;

/***/ }),

/***/ "./app/containers/setup/exhaust.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _onboardingApi = __webpack_require__("./app/api/onboarding-api.js");

var _exhaust = __webpack_require__("./app/components/setup/exhaust.jsx");

var _exhaust2 = _interopRequireDefault(_exhaust);

var _features = __webpack_require__("./app/common/containers/features.js");

var _features2 = _interopRequireDefault(_features);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStringsForPage = _uiCommon.contentfulModels.getStringsForPage,
    getMarkdownStringsForPage = _uiCommon.contentfulModels.getMarkdownStringsForPage,
    getSectionForPageByIdAndType = _uiCommon.contentfulModels.getSectionForPageByIdAndType;


var mapStateToProps = function mapStateToProps(state) {
  var instructionsPage = _lodash2.default.get(state, 'onboarding.instructionsPage');
  return {
    pageStrings: getStringsForPage(instructionsPage),
    pageMarkdownStrings: getMarkdownStringsForPage(instructionsPage),
    nextUrl: _lodash2.default.get(state.common, 'features').GFCORE_SITE_URL + '/setup/',
    exhaustPowerArticle: {
      fields: getSectionForPageByIdAndType(instructionsPage, 'set-up-exhaust-power-aura', 'supportArticle')
    },
    personalFilterArticle: {
      fields: getSectionForPageByIdAndType(instructionsPage, 'personal-filter-aura', 'supportArticle')
    },
    windowVentingArticle: {
      fields: getSectionForPageByIdAndType(instructionsPage, 'window-venting-aura', 'supportArticle')
    },
    connectPowerArticle: {
      fields: getSectionForPageByIdAndType(instructionsPage, 'connect-power-aura', 'supportArticle')
    }
  };
};

var preloadContent = function preloadContent(_ref) {
  var dispatch = _ref.dispatch;
  return _promise2.default.all([dispatch((0, _onboardingApi.fetchInstructionsPage)())]);
};

var ExhaustContainer = (0, _reactRedux.connect)(mapStateToProps, undefined)((0, _reactIsomorphicRender.preload)(preloadContent)(_exhaust2.default));

exports.default = (0, _features2.default)(ExhaustContainer);

/***/ }),

/***/ "./app/containers/setup/finish.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _onboardingApi = __webpack_require__("./app/api/onboarding-api.js");

var _appConstants = __webpack_require__("./app/app-constants.js");

var _finish = __webpack_require__("./app/components/setup/finish.jsx");

var _finish2 = _interopRequireDefault(_finish);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStringsForPage = _uiCommon.contentfulModels.getStringsForPage;


var mapStateToProps = function mapStateToProps(state) {
  return {
    pageStrings: getStringsForPage(_lodash2.default.get(state, 'onboarding.finishPage')),
    finalHost: _lodash2.default.get(state.common, 'features').GFCORE_SITE_URL,
    isOrangeMode: _lodash2.default.get(state.onboarding, 'mode') === _appConstants.COLOR_MODES.ORANGE
  };
};

var FinishContainer = (0, _reactRedux.connect)(mapStateToProps)((0, _reactIsomorphicRender.preload)(function (_ref) {
  var dispatch = _ref.dispatch;
  return dispatch((0, _onboardingApi.fetchOnboardingFinishPage)());
})(_finish2.default));

exports.default = FinishContainer;

/***/ }),

/***/ "./app/containers/setup/instructions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _onboardingApi = __webpack_require__("./app/api/onboarding-api.js");

var _instructions = __webpack_require__("./app/components/setup/instructions.jsx");

var _instructions2 = _interopRequireDefault(_instructions);

var _features = __webpack_require__("./app/common/containers/features.js");

var _features2 = _interopRequireDefault(_features);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStringsForPage = _uiCommon.contentfulModels.getStringsForPage,
    getMarkdownStringsForPage = _uiCommon.contentfulModels.getMarkdownStringsForPage,
    getSectionForPageByIdAndType = _uiCommon.contentfulModels.getSectionForPageByIdAndType;


var mapStateToProps = function mapStateToProps(state) {
  var instructionsPage = _lodash2.default.get(state, 'onboarding.instructionsPage');
  return {
    pageStrings: getStringsForPage(instructionsPage),
    pageMarkdownStrings: getMarkdownStringsForPage(instructionsPage),
    headerArticle: {
      fields: getSectionForPageByIdAndType(instructionsPage, 'lets-get-started-aura', 'supportArticle')
    },
    unboxArticle: {
      fields: getSectionForPageByIdAndType(instructionsPage, 'unbox-your-glowforge-aura', 'supportArticle')
    },
    printHeadArticle: {
      fields: getSectionForPageByIdAndType(instructionsPage, 'install-print-head-aura', 'supportArticle')
    },
    cuttingTrayArticle: {
      fields: getSectionForPageByIdAndType(instructionsPage, 'install-cutting-tray-aura', 'supportArticle')
    }
  };
};

var preloadContent = function preloadContent(_ref) {
  var dispatch = _ref.dispatch;
  return _promise2.default.all([dispatch((0, _onboardingApi.fetchInstructionsPage)())]);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onNext: function onNext() {
      dispatch((0, _reactIsomorphicRender.goto)('/setup/exhaust'));
    }
  };
};

var InstructionsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIsomorphicRender.preload)(preloadContent)(_instructions2.default));

exports.default = (0, _features2.default)(InstructionsContainer);

/***/ }),

/***/ "./app/containers/setup/machine-name.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _accountSettingsApi = __webpack_require__("./app/api/account-settings-api.js");

var api = _interopRequireWildcard(_accountSettingsApi);

var _onboardingApi = __webpack_require__("./app/api/onboarding-api.js");

var _machineName = __webpack_require__("./app/components/setup/machine-name.jsx");

var _machineName2 = _interopRequireDefault(_machineName);

var _features = __webpack_require__("./app/common/containers/features.js");

var _features2 = _interopRequireDefault(_features);

var _appConstants = __webpack_require__("./app/app-constants.js");

var _onboarding = __webpack_require__("./app/actions/onboarding.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStringsForPage = _uiCommon.contentfulModels.getStringsForPage;


var mapStateToProps = function mapStateToProps(state, route) {
  var pageStrings = getStringsForPage(_lodash2.default.get(state, 'onboarding.glowforgeNamePage'));
  var isOrangeMode = _lodash2.default.get(route, 'location.query.mode') === _appConstants.COLOR_MODES.ORANGE;

  return {
    initialValues: {
      name: pageStrings['onboarding-name-placeholder']
    },
    pageStrings: pageStrings,
    title: _lodash2.default.get(state, 'onboarding.glowforgeNamePage.title'),
    isOrangeMode: isOrangeMode
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
  return {
    onSubmit: function onSubmit(values) {
      var invites = _promise2.default.resolve();
      var defaultRoles = props.features.USER_ROLE_MANAGEMENT ? [] : ['manager'];
      if (values.email && values.email.length > 0) {
        invites = dispatch(api.sendInvites({
          email: values.email,
          machines: [{
            serial: props.params.serial,
            machineName: values.name,
            roles: defaultRoles
          }]
        }));
      }
      return _promise2.default.all([invites, dispatch((0, _onboardingApi.nameMachine)(props.params.serial, values.name))]).then(function () {
        dispatch((0, _reactIsomorphicRender.goto)('/setup/finished'));
      });
    }
  };
};

var PreloadedMachinePage = (0, _reactIsomorphicRender.preload)(function (_ref) {
  var dispatch = _ref.dispatch,
      location = _ref.location;

  var promises = [dispatch((0, _onboardingApi.fetchGlowforgeNamePage)())];
  var searchParams = new URLSearchParams(location.search);
  var mode = searchParams.get('mode');
  if (mode) {
    promises.push(dispatch((0, _onboarding.setSelectedMode)(mode)));
  }
  return _promise2.default.all(promises);
})(_machineName2.default);

var MachineNameContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PreloadedMachinePage);

exports.default = (0, _features2.default)(MachineNameContainer);

/***/ }),

/***/ "./app/containers/setup/select-machine.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _onboardingApi = __webpack_require__("./app/api/onboarding-api.js");

var _selectMachine = __webpack_require__("./app/components/setup/select-machine.jsx");

var _selectMachine2 = _interopRequireDefault(_selectMachine);

var _features = __webpack_require__("./app/common/containers/features.js");

var _features2 = _interopRequireDefault(_features);

var _onboarding = __webpack_require__("./app/actions/onboarding.js");

var _appConstants = __webpack_require__("./app/app-constants.js");

var _page = __webpack_require__("./app/common/selectors/page.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStringsForPage = _uiCommon.contentfulModels.getStringsForPage;


var mapStateToProps = function mapStateToProps(state) {
  var selectMachinePage = _lodash2.default.get(state, 'onboarding.selectMachinePage');
  return {
    title: selectMachinePage.title,
    pageStrings: getStringsForPage(selectMachinePage),
    assets: (0, _page.getAssetsForPage)(selectMachinePage)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSelect: function onSelect(mode) {
      dispatch((0, _onboarding.setSelectedMode)({ mode: mode }));
      if (mode === _appConstants.COLOR_MODES.ORANGE) {
        dispatch((0, _reactIsomorphicRender.goto)('/setup/instructions'));
      } else {
        dispatch((0, _reactIsomorphicRender.goto)('/setup/unboxing'));
      }
    }
  };
};

var preloadContent = function preloadContent(_ref) {
  var dispatch = _ref.dispatch;
  return _promise2.default.all([dispatch((0, _onboardingApi.fetchSelectPage)())]);
};

var SelectMachineContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIsomorphicRender.preload)(preloadContent)(_selectMachine2.default));

exports.default = (0, _features2.default)(SelectMachineContainer);

/***/ }),

/***/ "./app/containers/setup/terms-and-conditions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _legalApi = __webpack_require__("./app/api/legal-api.js");

var _termsAndConditions = __webpack_require__("./app/common/components/terms-and-conditions.jsx");

var _termsAndConditions2 = _interopRequireDefault(_termsAndConditions);

var _features = __webpack_require__("./app/common/containers/features.js");

var _features2 = _interopRequireDefault(_features);

var _util = __webpack_require__("./app/util.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    terms: _lodash2.default.get(state, 'legal.termsOfServicePage'),
    pageTitle: 'Terms of Service',
    downloadUrl: _lodash2.default.get(state.common, 'features').GFCORE_SITE_URL + '/setup/download'
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    goToNext: function goToNext(termsVersion, downloadUrl) {
      dispatch((0, _legalApi.acceptTermsAndConditions)(termsVersion)).then(function () {
        if (ownProps.location.query.entry === 'new_user') {
          dispatch((0, _reactIsomorphicRender.goto)('/setup/finished'));
        } else if (window.sessionStorage.getItem('disallowedSetupChromeVersion') || (0, _util.getChromeVersion)() >= 101 || (0, _util.isEdge)()) {
          window.location.replace(downloadUrl);
        } else {
          dispatch((0, _reactIsomorphicRender.goto)('/setup/select'));
        }
      });
    }
  };
};

var TermsAndConditionsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIsomorphicRender.preload)(function (_ref) {
  var dispatch = _ref.dispatch;
  return _promise2.default.all([dispatch((0, _legalApi.fetchToSPage)())]);
})(_termsAndConditions2.default));

exports.default = (0, _features2.default)(TermsAndConditionsContainer);

/***/ }),

/***/ "./app/containers/setup/unboxing.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _onboardingApi = __webpack_require__("./app/api/onboarding-api.js");

var _unboxing = __webpack_require__("./app/components/setup/unboxing.jsx");

var _unboxing2 = _interopRequireDefault(_unboxing);

var _features = __webpack_require__("./app/common/containers/features.js");

var _features2 = _interopRequireDefault(_features);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStringsForPage = _uiCommon.contentfulModels.getStringsForPage,
    getSectionForPageByIdAndType = _uiCommon.contentfulModels.getSectionForPageByIdAndType;


var mapStateToProps = function mapStateToProps(state, ownProps) {
  var unboxingUpdateEnabled = _lodash2.default.get(state.common, 'features').UNBOXING_UPDATE_ENABLED;

  var slug = ownProps.params.slug;

  var articleId = 'unboxing-instructions';
  if (unboxingUpdateEnabled) {
    if (!slug) {
      articleId = 'lets-get-started';
    } else {
      articleId = slug;
    }
  }

  var articleList = _lodash2.default.get(state, 'onboarding.unboxingPage').sections.filter(function (section) {
    var id = section.fields.id;

    return !(id === 'unboxing-instructions' || id === 'lets-get-started');
  });

  return {
    title: _lodash2.default.get(state, 'onboarding.unboxingPage.title'),
    pageStrings: getStringsForPage(_lodash2.default.get(state, 'onboarding.unboxingPage')),
    articleList: articleList,
    unboxingArticle: {
      // Backwards compat with article common components.
      fields: getSectionForPageByIdAndType(_lodash2.default.get(state, 'onboarding.unboxingPage'), articleId, 'supportArticle')
    },
    nextUrl: _lodash2.default.get(state.common, 'features').GFCORE_SITE_URL + '/setup/'
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    goTo: function goTo(slug) {
      if (!slug) {
        dispatch((0, _reactIsomorphicRender.goto)('/setup/unboxing'));
        return;
      }
      dispatch((0, _reactIsomorphicRender.goto)('/setup/unboxing/' + slug));
    }
  };
};

var preloadContent = function preloadContent(_ref) {
  var dispatch = _ref.dispatch;
  return _promise2.default.all([dispatch((0, _onboardingApi.fetchUnboxingPage)())]);
};

var UnboxingContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIsomorphicRender.preload)(preloadContent)(_unboxing2.default));

exports.default = (0, _features2.default)(UnboxingContainer);

/***/ }),

/***/ "./app/containers/support/referral-payment.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _supportApi = __webpack_require__("./app/api/support-api.js");

var _page = __webpack_require__("./app/common/selectors/page.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _paymentPage = __webpack_require__("./app/components/support/referral/payment-page.jsx");

var _paymentPage2 = _interopRequireDefault(_paymentPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stringSubstitution = _uiCommon.contentfulUtils.stringSubstitution;

// Recursively iterates through a contentful object and its children to replace occurences of
// {{cash-amount}} and {{credit-amount}} with the appropriate values

var replaceExchangeValues = function replaceExchangeValues(replaceable, cashAmount, creditAmount) {
  if (typeof replaceable === 'string') {
    return stringSubstitution(replaceable, [{
      name: 'cash-amount',
      value: cashAmount
    }, {
      name: 'credit-amount',
      value: creditAmount
    }]);
  }
  _lodash2.default.forEach(replaceable, function (value, key) {
    if (key === 'sys') return;
    var replacedObject = {};
    replacedObject[key] = replaceExchangeValues(value, cashAmount, creditAmount);
    _lodash2.default.assign(replaceable, replacedObject);
  });

  return replaceable;
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var cashAmount = _lodash2.default.get(state, 'support.referralInfo.cashAmount');
  var creditAmount = _lodash2.default.get(state, 'support.referralInfo.creditAmount');
  var page = replaceExchangeValues(_lodash2.default.get(state, 'support.referralPage'), cashAmount, creditAmount);

  return (0, _extends3.default)({}, _lodash2.default.get(state, 'support.referralInfo'), {
    status: _lodash2.default.get(state, 'support.status'),
    path: _lodash2.default.get(ownProps, 'location.query.state'),
    paypal: _lodash2.default.get(ownProps, 'location.query.paypal'),
    pageStrings: (0, _page.getStringsForPage)(page),
    mainPageContent: (0, _page.getSectionForPageByIdAndType)(page, 'stripe-exchange-content', 'textSection'),
    paypalLinkText: (0, _page.getSectionForPageByIdAndType)(page, 'paypal-request-page-link-text', 'textSection'),
    paypalPageContent: (0, _page.getSectionForPageByIdAndType)(page, 'paypal-page', 'textSection'),
    createPaypalText: (0, _page.getSectionForPageByIdAndType)(page, 'create-paypal-text', 'textString'),
    returningText: (0, _page.getSectionForPageByIdAndType)(page, 'returner-reconnect-text', 'textSection'),
    confirmationPageContent: (0, _page.getSectionForPageByIdAndType)(page, 'stripe-exchange-confirmation', 'textSection'),
    paypalConfirmationPageContent: (0, _page.getSectionForPageByIdAndType)(page, 'paypal-confirmation-page-rto', 'textSection'),
    errorStrings: _lodash2.default.get((0, _page.getSectionForPageByIdAndType)(page, 'error-strings-rto', 'list'), 'listItems')
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    requestPayment: function requestPayment(stripeID, referralState) {
      return dispatch((0, _supportApi.requestPaymentNoAuth)(stripeID, referralState));
    },
    requestPaypal: function requestPaypal(paypalEmail, referralState) {
      return dispatch((0, _supportApi.requestPaymentPaypal)(paypalEmail, referralState));
    }
  };
};

var ReferralPaymentContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIsomorphicRender.preload)(function (_ref) {
  var dispatch = _ref.dispatch,
      location = _ref.location;
  return _promise2.default.all([dispatch((0, _supportApi.fetchReferralPage)()), dispatch((0, _supportApi.fetchReferral)(location.query.state)), dispatch((0, _supportApi.requestPaymentOAuth)(location.query.code, location.query.state))]);
})(_paymentPage2.default));

exports.default = ReferralPaymentContainer;

/***/ }),

/***/ "./app/lib/confetti.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

/* eslint-disable */
/*
 Copyright (c) 2016 by Linmiao Xu (http://codepen.io/linrock/pen/Amdhr)

 Permission is hereby granted, free of charge, to any person obtaining a copy of this software
 and associated documentation files (the "Software"), to deal in the Software without restriction,
 including without limitation the rights to use, copy, modify, merge, publish, distribute,
 sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all copies or
 substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
 NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
if (global.window) {
  window.makeConfetti = function () {
    var COLORS, Confetti, NUM_CONFETTI, PI_2, canvas, confetti, context, drawCircle, i, range, xpos, w, h, getCanvasSize;

    NUM_CONFETTI = 350;

    COLORS = [[0, 159, 176], [0, 159, 176], [0, 159, 176], [40, 121, 132], [147, 188, 193]];

    PI_2 = 2 * Math.PI;

    canvas = document.getElementById("confetti");

    context = canvas.getContext("2d");

    getCanvasSize = function getCanvasSize() {
      w = canvas.width = canvas.getBoundingClientRect().width;
      h = canvas.height = canvas.getBoundingClientRect().height;
    };

    window.addEventListener('resize', getCanvasSize, false);

    getCanvasSize();

    range = function range(a, b) {
      return (b - a) * Math.random() + a;
    };

    drawCircle = function drawCircle(x, y, r, style) {
      context.beginPath();
      context.arc(x, y, r, 0, PI_2, false);
      context.fillStyle = style;
      return context.fill();
    };

    xpos = 0.5;

    window.requestAnimationFrame = function () {
      return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
        return window.setTimeout(callback, 1000 / 60);
      };
    }();

    Confetti = function () {
      function Confetti() {
        this.style = COLORS[~~range(0, 5)];
        this.rgb = "rgba(" + this.style[0] + "," + this.style[1] + "," + this.style[2];
        this.r = ~~range(2, 6);
        this.r2 = 2 * this.r;
        this.replace();
      }

      Confetti.prototype.replace = function () {
        this.opacity = 0;
        this.dop = 0.03 * range(1, 4);
        this.x = range(-this.r2, w - this.r2);
        this.y = range(-20, h - this.r2);
        this.xmax = w - this.r;
        this.ymax = h - this.r;
        this.vx = range(0, 2) + 8 * xpos - 5;
        return this.vy = 0.7 * this.r + range(-1, 1);
      };

      Confetti.prototype.draw = function () {
        var ref;
        this.x += this.vx;
        this.y += this.vy;
        this.opacity += this.dop;
        if (this.opacity > 1) {
          this.opacity = 1;
          this.dop *= -1;
        }
        if (this.opacity < 0 || this.y > this.ymax) {
          this.replace();
        }
        if (!(0 < (ref = this.x) && ref < this.xmax)) {
          this.x = (this.x + this.xmax) % this.xmax;
        }
        return drawCircle(~~this.x, ~~this.y, this.r, this.rgb + "," + this.opacity + ")");
      };

      return Confetti;
    }();

    confetti = function () {
      var j, ref, results;
      results = [];
      for (i = j = 1, ref = NUM_CONFETTI; 1 <= ref ? j <= ref : j >= ref; i = 1 <= ref ? ++j : --j) {
        results.push(new Confetti());
      }
      return results;
    }();

    window.step = function () {
      var c, j, len, results;
      requestAnimationFrame(step);
      context.clearRect(0, 0, w, h);
      results = [];
      for (j = 0, len = confetti.length; j < len; j++) {
        c = confetti[j];
        results.push(c.draw());
      }
      return results;
    };

    step();
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./app/react-isomorphic-render.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reducers = __webpack_require__("./app/reducers/index.js");

var reducer = _interopRequireWildcard(_reducers);

var _routeConstants = __webpack_require__("./app/route-constants.js");

var _routes = __webpack_require__("./app/routes.jsx");

var _routes2 = _interopRequireDefault(_routes);

var _wrapper = __webpack_require__("./app/wrapper.jsx");

var _wrapper2 = _interopRequireDefault(_wrapper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// These needs the '/' before it because of an odd bug in react-isomorphic-render
// Around adding cookies to the request
var CATALOG_URL_PREFIX = '/catalog:/';
var BASE_URL_PREFIX = '/base:/';

exports.default = {
  reducer: reducer,
  routes: _routes2.default,
  wrapper: _wrapper2.default,
  error: function error(_error, _ref) {
    var path = _ref.path,
        redirect = _ref.redirect,
        url = _ref.url;

    // Not authenticated
    if (_error.status === 401 && path !== '/login') {
      return redirect('/login?redirect_to=' + url);
    } else if (_error.message === _routeConstants.COMMON.PAGE_ERRORS.PAGE_NOT_FOUND || _error.status === 404) {
      return redirect('/404');
    } else if (_error.status === 403) {
      return redirect('/unauthorized');
    } else if (path !== '/error') {
      // Only redirect if production for debugging
      if (true) {
        console.error('Error:', { path: path, error: _error, url: url }); // eslint-disable-line
        return redirect('/error');
      }
    }

    // Unknown error.. keep trowing
    console.error('Error:', { path: path, error: _error }); // eslint-disable-line
    throw _error;
  },
  http: {
    request: function request(_request) {
      if (_request.url.indexOf(sharedEnv.STOREFRONT_API_URL) === 0 || _request.url.indexOf(sharedEnv.CATALOG_API_URL) === 0 || _request.url.indexOf(sharedEnv.BASE_API_URL) === 0 || _request.url.indexOf(sharedEnv.GF_ECOM_SERVER) === 0) {
        _request.withCredentials();
      }
    },

    url: function url(requestPath) {
      if (sharedEnv.USE_DEV_PROXY === 'true' && sharedEnv.DEV_PROXY_URL) {
        var path = requestPath.replace(/\/(\w+):\//, '');
        return '' + sharedEnv.DEV_PROXY_URL + path;
      } else if (requestPath.match(CATALOG_URL_PREFIX)) {
        return _lodash2.default.replace(requestPath, CATALOG_URL_PREFIX, sharedEnv.CATALOG_API_URL);
      } else if (requestPath.match(BASE_URL_PREFIX)) {
        return _lodash2.default.replace(requestPath, BASE_URL_PREFIX, sharedEnv.BASE_API_URL);
      } else if (requestPath.match('^/(ecom|gfcore|user)')) {
        return '' + sharedEnv.GF_ECOM_API_URL + requestPath;
      }

      // Default to shop
      return '' + sharedEnv.BASE_API_URL + requestPath;
    },

    error: function error(_error2, _ref2) {
      var path = _ref2.path,
          redirect = _ref2.redirect,
          url = _ref2.url;

      // Not authenticated
      if (_error2.status === 401 && path !== '/login') {
        return redirect('/login?redirect_to=' + url);
      }

      // Log error to heroku ?
      if (false) {
        console.error('Error at http:', { path: path, error: _error2, url: url }); // eslint-disable-line
      }

      throw _error2;
    }
  }
};

/***/ }),

/***/ "./app/reducers/account-settings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case actions.SET_PENDING_INVITES:
      {
        return (0, _assign2.default)({}, state, {
          pendingInvites: _lodash2.default.get(action, 'result')
        });
      }
    case actions.SET_USER_PURCHASE_HISTORY:
      {
        return (0, _assign2.default)({}, state, {
          purchaseHistory: _lodash2.default.get(action, 'result.orders')
        });
      }
    case actions.SET_SETTINGS_PAGE:
      {
        return (0, _assign2.default)({}, state, {
          settingsPage: _lodash2.default.get(action, 'result')
        });
      }
    case actions.SET_USER_PAYMENT_METHODS:
      {
        return (0, _assign2.default)({}, state, {
          creditCards: _lodash2.default.get(action, 'result.credit_cards'),
          availableCredit: _lodash2.default.get(action, 'result.store_credit')
        });
      }
    case actions.SET_USER_INVITE_ACCEPT_PAGE:
      {
        return (0, _assign2.default)({}, state, {
          SET_NO_GLOWFORGE_PAGE: _lodash2.default.get(action, 'result.fields')
        });
      }
    case actions.UPDATE_CREDIT_CARD:
      {
        return (0, _assign2.default)({}, state, { creditCards: _lodash2.default.get(action, 'result.payment') });
      }
    case actions.UPDATE_CREDIT_CARD_ERROR:
      {
        // NOTE: THIS IS A BUG WITH CREDIT CARD SETTING
        // IF THERE IS AN ERROR IT RE-SETS YOU PAYMENT METHODS TO NOTHING
        return (0, _assign2.default)({}, state, { creditCards: null });
      }
    default:
      {
        return state;
      }
  }
};

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _accountSettings = __webpack_require__("./app/actions/account-settings.js");

var actions = _interopRequireWildcard(_accountSettings);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./app/reducers/account.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case actions.SET_CREATE_ACCOUNT_PAGE:
      {
        return (0, _assign2.default)({}, state, {
          createAccountPage: _lodash2.default.get(action, 'result.fields')
        });
      }
    case actions.CREATE_ACCOUNT:
      {
        var result = action.result;
        var id = result.id,
            errors = result.errors;

        if (id) {
          // An `id` in the result indicates that the user was properly created.
          return createState(state, { success: true });
        }
        // The user was not created, but the validation handler decided to not
        // throw so that this could provide some specialized error UI.

        var _ref = errors || {},
            emailErrors = _ref.email;

        if (!emailErrors || !emailErrors.length) {
          // No email errors (we should never get here, but just in case).
          return createError(state, 'generic');
        }
        if (emailErrors.some(function (err) {
          return err.includes('taken');
        })) {
          // One of the errors indicates the email address was already taken.
          return createError(state, 'userAlreadyExists');
        }
        // The email address was otherwise 'unacceptable'.
        return createError(state, 'unacceptableEmail');
      }
    default:
      {
        return state;
      }
  }
};

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _account = __webpack_require__("./app/actions/account.js");

var actions = _interopRequireWildcard(_account);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createState(state, newState) {
  return (0, _extends3.default)({}, state, { createAccount: newState });
}

function createError(state, error) {
  return createState(state, { error: (0, _defineProperty3.default)({}, error, true) });
}

/***/ }),

/***/ "./app/reducers/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _glowforgeStore = __webpack_require__("./app/store/reducers/glowforge-store.js");

Object.defineProperty(exports, 'glowforgeStore', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_glowforgeStore).default;
  }
});

var _common = __webpack_require__("./app/common/reducers/common.js");

Object.defineProperty(exports, 'common', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_common).default;
  }
});

var _onboarding = __webpack_require__("./app/reducers/onboarding.js");

Object.defineProperty(exports, 'onboarding', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_onboarding).default;
  }
});

var _accountSettings = __webpack_require__("./app/reducers/account-settings.js");

Object.defineProperty(exports, 'accountSettings', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_accountSettings).default;
  }
});

var _legal = __webpack_require__("./app/reducers/legal.js");

Object.defineProperty(exports, 'legal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_legal).default;
  }
});

var _marketing = __webpack_require__("./app/reducers/marketing.js");

Object.defineProperty(exports, 'marketing', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_marketing).default;
  }
});

var _account = __webpack_require__("./app/reducers/account.js");

Object.defineProperty(exports, 'account', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_account).default;
  }
});

var _landing = __webpack_require__("./app/reducers/landing.js");

Object.defineProperty(exports, 'landing', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_landing).default;
  }
});

var _support = __webpack_require__("./app/reducers/support.js");

Object.defineProperty(exports, 'support', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_support).default;
  }
});

var _reduxForm = __webpack_require__("./node_modules/redux-form/es/index.js");

Object.defineProperty(exports, 'form', {
  enumerable: true,
  get: function get() {
    return _reduxForm.reducer;
  }
});

var _subscriptions = __webpack_require__("./app/reducers/subscriptions.js");

Object.defineProperty(exports, 'subscriptions', {
  enumerable: true,
  get: function get() {
    return _subscriptions.reducer;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./app/reducers/landing.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case actions.SET_GLOWFORGE_LANDING_PAGE:
      {
        return (0, _assign2.default)({}, state, {
          glowforgeLandingPage: _lodash2.default.get(action, 'result.fields')
        });
      }
    case actions.SET_PROJECT_PICS:
      {
        return (0, _assign2.default)({}, state, {
          projectPics: action.result
        });
      }
    default:
      {
        return state;
      }
  }
};

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _landing = __webpack_require__("./app/actions/landing.js");

var actions = _interopRequireWildcard(_landing);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./app/reducers/legal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case actions.SET_LEGAL_PAGES:
      {
        return (0, _assign2.default)({}, state, {
          termsOfServicePage: (0, _extends3.default)({}, _lodash2.default.find(action.result, { fields: { type: 'termsOfService' } }).fields, {
            minorVersion: _lodash2.default.find(action.result, { fields: { type: 'termsOfService' } }).sys.revision
          })
        });
      }
    case actions.SET_TOS_PAGE:
      {
        return (0, _assign2.default)({}, state, {
          termsOfServicePage: (0, _extends3.default)({}, _lodash2.default.find(action.result, { fields: { type: 'termsOfService' } }).fields, {
            minorVersion: _lodash2.default.find(action.result, { fields: { type: 'termsOfService' } }).sys.revision
          })
        });
      }
    default:
      {
        return state;
      }
  }
};

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _legal = __webpack_require__("./app/actions/legal.js");

var actions = _interopRequireWildcard(_legal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./app/reducers/marketing.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case actions.SET_MARKETING_PAGE:
      {
        return (0, _assign2.default)({}, state, {
          marketingPage: _lodash2.default.get(action, 'result.fields')
        });
      }
    default:
      {
        return state;
      }
  }
};

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _marketing = __webpack_require__("./app/actions/marketing.js");

var actions = _interopRequireWildcard(_marketing);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./app/reducers/onboarding.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case actions.SET_SELECT_PAGE:
      {
        return (0, _assign2.default)({}, state, {
          selectMachinePage: _lodash2.default.get(action, 'result.fields')
        });
      }
    case actions.SET_INSTRUCTIONS_PAGE:
      {
        return (0, _assign2.default)({}, state, {
          instructionsPage: _lodash2.default.get(action, 'result.fields')
        });
      }
    case actions.SET_UNBOXING_PAGE:
      {
        return (0, _assign2.default)({}, state, {
          unboxingPage: _lodash2.default.get(action, 'result.fields')
        });
      }
    case actions.SET_GLOWFORGE_NAME_PAGE:
      {
        return (0, _assign2.default)({}, state, {
          glowforgeNamePage: _lodash2.default.get(action, 'result.fields')
        });
      }
    case actions.SET_AIR_FILTER_CHOICE_PAGE:
      {
        return (0, _assign2.default)({}, state, {
          airFilterChoicePage: _lodash2.default.get(action, 'result.fields')
        });
      }
    case actions.SET_ONBOARDING_FINISH_PAGE:
      {
        return (0, _assign2.default)({}, state, {
          finishPage: _lodash2.default.get(action, 'result.fields')
        });
      }
    case actions.SET_SELECTED_MODE:
      {
        return (0, _assign2.default)({}, state, {
          mode: action.mode
        });
      }
    default:
      {
        return state;
      }
  }
};

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _onboarding = __webpack_require__("./app/actions/onboarding.js");

var actions = _interopRequireWildcard(_onboarding);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./app/reducers/subscriptions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.DEFAULT_STATE = exports.SUBSCRIPTION_STATES = undefined;

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _subscriptions = __webpack_require__("./app/actions/subscriptions.js");

var actions = _interopRequireWildcard(_subscriptions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SUBSCRIPTION_STATES = exports.SUBSCRIPTION_STATES = {
  pending: 'pending',
  loading: 'loading',
  loaded: 'loaded',
  error: 'error'
};

var DEFAULT_STATE = exports.DEFAULT_STATE = _lodash2.default.assign({}, {
  state: SUBSCRIPTION_STATES.pending,
  managePending: false,
  current: null,
  addedUsers: null
});

var reducer = exports.reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var action = arguments[1];

  switch (action.type) {
    // Uses default state to initialize!
    case actions.LOADING_SUBSCRIPTIONS:
      {
        return (0, _assign2.default)({}, DEFAULT_STATE, {
          state: SUBSCRIPTION_STATES.loading
        });
      }
    // Intentionally does not clear other state!
    case actions.RELOADING_SUBSCRIPTIONS:
      {
        return (0, _assign2.default)({}, state, {
          state: SUBSCRIPTION_STATES.loading
        });
      }
    case actions.SET_SUBSCRIPTIONS_STATUS:
      {
        var newState = (0, _assign2.default)({}, state, {
          current: _lodash2.default.get(action, 'result')
        });

        if (_lodash2.default.get(newState, 'addedUsers') !== null) {
          newState = (0, _assign2.default)({}, newState, {
            state: SUBSCRIPTION_STATES.loaded
          });
        }
        // TODO: handle errors?

        return newState;
      }
    case actions.SET_SUBSCRIPTIONS_USERS:
      {
        var _newState = (0, _assign2.default)({}, state, {
          addedUsers: _lodash2.default.get(action, 'result'),
          state: SUBSCRIPTION_STATES.loaded
        });

        if (_lodash2.default.get(_newState, 'current') !== null) {
          _newState = (0, _assign2.default)({}, _newState, {
            state: SUBSCRIPTION_STATES.loaded
          });
        }
        // TODO: handle errors?

        return _newState;
      }
    case actions.SUBSCRIPTIONS_USER_ADDED:
      {
        // TODO: not clear what needs to be done here yet
        return state;
      }
    case actions.SUBSCRIPTIONS_USER_REMOVED:
      {
        // TODO: not clear what needs to be done here yet
        return state;
      }
    case actions.MANAGE_PENDING:
      {
        return (0, _assign2.default)({}, state, { managePending: true });
      }
    case actions.MANAGE_DONE:
      {
        return (0, _assign2.default)({}, state, { managePending: false });
      }
    default:
      {
        return state;
      }
  }
};

/***/ }),

/***/ "./app/reducers/support.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case actions.SET_REFERRAL_PAGE:
      {
        return (0, _assign2.default)({}, state, {
          referralPage: _lodash2.default.get(action, 'result.fields')
        });
      }
    case actions.SET_REFERRAL_INFO:
      {
        return (0, _assign2.default)({}, state, {
          referralInfo: _lodash2.default.get(action, 'result')
        });
      }
    case actions.PAYMENT_REQUEST_ATTEMPT:
      {
        return (0, _assign2.default)({}, state, {
          status: _lodash2.default.get(action, 'result.status')
        });
      }
    case actions.PAYPAL_REQUEST:
      {
        return (0, _assign2.default)({}, state, {
          status: _lodash2.default.get(action, 'result.status')
        });
      }
    default:
      {
        return state;
      }
  }
};

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _support = __webpack_require__("./app/actions/support.js");

var actions = _interopRequireWildcard(_support);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./app/route-constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COMMON = exports.LOGIN = exports.PAGE_NOT_FOUND = exports.GLOWFORGE_LANDING_PAGE_HOME_CDN_TEST = exports.GLOWFORGE_LANDING_PAGE_HOME = exports.GLOWFORGE_LANDING_PAGE = exports.SETUP = exports.MARKETING = exports.SETTINGS_ACCEPT_INVITE = exports.REFERRAL_PAYMENT = exports.CREATE_ACCOUNT = exports.SETTINGS = exports.SUPPORT = exports.GLOWFORGE_CONFIRMATION = exports.CATALOG = exports.SHOP = undefined;

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Route Constants
 * File to hold constants related to routing.
 */

var SHOP = exports.SHOP = {
  STORE_TYPE: 'shop',
  BASE_URL: 'https://shop.glowforge.com',
  BASE_PRODUCT_URL: 'https://shop.glowforge.com/collections/printers',
  ENABLED: true
};

var CATALOG = exports.CATALOG = {
  STORE_TYPE: 'catalog',
  BASE_URI: '/catalog',
  BASE_PRODUCT_URI: '/catalog/product',
  BASE_CATEGORY_URI: '/catalog/category',
  SEARCH_URI: '/catalog/search',
  PAGE_TITLE: 'Design Catalog',
  SEARCH_PLACEHOLDER_TEXT: 'Search for Designs',
  SHOW_CART: false,
  SHOW_SEARCH: true,
  ENABLED: false
};

var GLOWFORGE_CONFIRMATION = exports.GLOWFORGE_CONFIRMATION = {
  BASE_URI: '/confirmation',
  SHOW_GLOBAL_FOOTER: true,
  USE_MARKETING_NAV: true,
  HIDE_NAV_LINKS: true
};

var SUPPORT = exports.SUPPORT = {
  BASE_URI: '/support',
  SHOW_CART: false,
  SHOW_SEARCH: false,
  SUPPORT_ENTRY_TYPES: ['questionAndAnswer', 'supportEntryInstructions', 'supportEntryTextAndMedia', 'supportEntryTipOrAlert']
};

var SETTINGS = exports.SETTINGS = {
  PAGE_TITLE: 'User Settings',
  BASE_URI: '/settings'
};

var CREATE_ACCOUNT = exports.CREATE_ACCOUNT = {
  PAGE_TITLE: 'Create Account',
  BASE_URI: '/create-account',
  USE_MARKETING_NAV: true
};

var REFERRAL_PAYMENT = exports.REFERRAL_PAYMENT = {
  PAGE_TITLE: 'Referral Payment',
  BASE_URI: '/referral-payment'
};

var SETTINGS_ACCEPT_INVITE = exports.SETTINGS_ACCEPT_INVITE = {
  PAGE_TITLE: 'User Create',
  BASE_URI: '/settings/invite/accept',
  HIDE_NAV_LINKS: true,
  HIDE_USER_SECTION: true
};

var MARKETING = exports.MARKETING = {
  BASE_URI: '/m/',
  USE_MARKETING_NAV: true,
  INCLUDE_BUY_BUTTON: true
};

var SETUP = exports.SETUP = {
  PAGE_TITLE: 'Glowforge',
  BASE_URI: '/setup',
  HIDE_NAV_LINKS: true,
  HIDE_USER_SECTION: true
};

var GLOWFORGE_LANDING_PAGE = exports.GLOWFORGE_LANDING_PAGE = {
  PAGE_TITLE: 'Glowforge - the 3D laser printer',
  BASE_URI: '/',
  USE_MARKETING_NAV: true,
  INCLUDE_BUY_BUTTON: true,
  SHOW_GLOBAL_FOOTER: true
};

var GLOWFORGE_LANDING_PAGE_HOME = exports.GLOWFORGE_LANDING_PAGE_HOME = (0, _extends3.default)({}, GLOWFORGE_LANDING_PAGE, {
  BASE_URI: '/home',
  INCLUDE_BUY_BUTTON: true,
  CANONICAL_URI: '/'
});

var GLOWFORGE_LANDING_PAGE_HOME_CDN_TEST = exports.GLOWFORGE_LANDING_PAGE_HOME_CDN_TEST = (0, _extends3.default)({}, GLOWFORGE_LANDING_PAGE, {
  BASE_URI: '/home-2',
  INCLUDE_BUY_BUTTON: true,
  CANONICAL_URI: '/'
});

var PAGE_NOT_FOUND = exports.PAGE_NOT_FOUND = {
  BASE_URI: '/404',
  USE_MARKETING_NAV: true,
  SHOW_GLOBAL_FOOTER: true
};

var LOGIN = exports.LOGIN = {
  PAGE_TITLE: 'Sign In',
  BASE_URI: '/login',
  USE_MARKETING_NAV: true,
  SHOW_GLOBAL_FOOTER: true
};

var COMMON = exports.COMMON = {
  PAGE_ERRORS: {
    PAGE_NOT_FOUND: '404',
    NOT_AUTHENTICATED: '401'
  }
};

/***/ }),

/***/ "./app/routes.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRouter = __webpack_require__("./node_modules/react-router/es/index.js");

var _basicApp = __webpack_require__("./app/common/containers/basic-app.js");

var _basicApp2 = _interopRequireDefault(_basicApp);

var _basicClientAuthApp = __webpack_require__("./app/common/containers/basic-client-auth-app.jsx");

var _basicClientAuthApp2 = _interopRequireDefault(_basicClientAuthApp);

var _error = __webpack_require__("./app/components/error.jsx");

var _error2 = _interopRequireDefault(_error);

var _appConstants = __webpack_require__("./app/app-constants.js");

var _pageNotFound = __webpack_require__("./app/components/page-not-found.jsx");

var _pageNotFound2 = _interopRequireDefault(_pageNotFound);

var _unauthorized = __webpack_require__("./app/components/unauthorized.jsx");

var _unauthorized2 = _interopRequireDefault(_unauthorized);

var _create = __webpack_require__("./app/containers/account/create.js");

var _create2 = _interopRequireDefault(_create);

var _marketingPage = __webpack_require__("./app/containers/marketing-page.js");

var _marketingPage2 = _interopRequireDefault(_marketingPage);

var _noGlowforge = __webpack_require__("./app/containers/no-glowforge.js");

var _noGlowforge2 = _interopRequireDefault(_noGlowforge);

var _marketingApp = __webpack_require__("./app/containers/root-apps/marketing-app.js");

var _marketingApp2 = _interopRequireDefault(_marketingApp);

var _settingsApp = __webpack_require__("./app/containers/root-apps/settings-app.js");

var _settingsApp2 = _interopRequireDefault(_settingsApp);

var _generalAccount = __webpack_require__("./app/containers/settings/general-account.js");

var _generalAccount2 = _interopRequireDefault(_generalAccount);

var _invite = __webpack_require__("./app/containers/settings/invite.js");

var _invite2 = _interopRequireDefault(_invite);

var _password = __webpack_require__("./app/containers/settings/password.js");

var _password2 = _interopRequireDefault(_password);

var _printers = __webpack_require__("./app/containers/settings/printers.js");

var _printers2 = _interopRequireDefault(_printers);

var _acceptInvite = __webpack_require__("./app/containers/settings/accept-invite.js");

var _acceptInvite2 = _interopRequireDefault(_acceptInvite);

var _purchaseHistory = __webpack_require__("./app/containers/settings/purchase-history.js");

var _purchaseHistory2 = _interopRequireDefault(_purchaseHistory);

var _subscription = __webpack_require__("./app/containers/settings/subscription.js");

var _subscription2 = _interopRequireDefault(_subscription);

var _users = __webpack_require__("./app/containers/settings/users.js");

var _users2 = _interopRequireDefault(_users);

var _termsAndConditions = __webpack_require__("./app/containers/setup/terms-and-conditions.js");

var _termsAndConditions2 = _interopRequireDefault(_termsAndConditions);

var _unboxing = __webpack_require__("./app/containers/setup/unboxing.js");

var _unboxing2 = _interopRequireDefault(_unboxing);

var _addGlowforge = __webpack_require__("./app/containers/setup/add-glowforge.js");

var _addGlowforge2 = _interopRequireDefault(_addGlowforge);

var _selectMachine = __webpack_require__("./app/containers/setup/select-machine.js");

var _selectMachine2 = _interopRequireDefault(_selectMachine);

var _instructions = __webpack_require__("./app/containers/setup/instructions.js");

var _instructions2 = _interopRequireDefault(_instructions);

var _exhaust = __webpack_require__("./app/containers/setup/exhaust.js");

var _exhaust2 = _interopRequireDefault(_exhaust);

var _finish = __webpack_require__("./app/containers/setup/finish.js");

var _finish2 = _interopRequireDefault(_finish);

var _machineName = __webpack_require__("./app/containers/setup/machine-name.js");

var _machineName2 = _interopRequireDefault(_machineName);

var _landingApp = __webpack_require__("./app/containers/landing/landing-app.jsx");

var _landingApp2 = _interopRequireDefault(_landingApp);

var _glowforgeLanding = __webpack_require__("./app/containers/landing/glowforge-landing.js");

var _glowforgeLanding2 = _interopRequireDefault(_glowforgeLanding);

var _referralPayment = __webpack_require__("./app/containers/support/referral-payment.js");

var _referralPayment2 = _interopRequireDefault(_referralPayment);

var _confirmation = __webpack_require__("./app/store/containers/glowforge/confirmation.js");

var _confirmation2 = _interopRequireDefault(_confirmation);

var _routeConstants = __webpack_require__("./app/route-constants.js");

var constants = _interopRequireWildcard(_routeConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Glowforge Store Containers */


/* Common Pages */
var getUser = function getUser(state) {
  return _lodash2.default.isEmpty(state.common.user) ? undefined : state.common.user;
};

/** Support Containers * */


/** Landing Pages */


/** Setup/Onboarding Pages * */


/** Account Settings Containers * */

var getSubscription = function getSubscription(state) {
  return _lodash2.default.isEmpty(state.subscriptions) ? undefined : state.subscriptions.current;
};

var marketingIsVisible = function marketingIsVisible(state) {
  var visibility = _lodash2.default.get(state, 'marketing.marketingPage.visibility');
  var user = state.common.user;
  return !(visibility === 'logged-in-only' && _lodash2.default.isEmpty(user) || visibility === 'admin-only' && !_lodash2.default.get(user, 'is_admin'));
};

var allSettingsIsVisible = function allSettingsIsVisible(state) {
  var currentUser = getUser(state);
  // Not logged in, can't see page anyway
  if (!currentUser) return false;

  var currentSubscription = getSubscription(state);
  // Logged in but no subscription means definitely not a restricted user
  if (!currentSubscription && !currentSubscription.data) return true;

  // If logged in but has external values, they're the account owner
  // and not restricted.
  if (!_lodash2.default.isEmpty(currentSubscription, 'data.attributes.external')) return true;

  // Otherwise they're an added user and we need to check their account access
  if (currentSubscription.additional_users_access_status === _appConstants.ACCOUNT_ACCESS.RESTRICTED) return false;
};

// Restricts a `<Route/>` to logged-in users
var restricted = function restricted(route, authorization) {
  return (0, _reactIsomorphicRender.authorize)(getUser, authorization, route);
};

var marketingVisibilityRestricted = function marketingVisibilityRestricted(route, authorization) {
  return (0, _reactIsomorphicRender.authorize)(marketingIsVisible, authorization, route);
};

var addedUserVisibilityRestricted = function addedUserVisibilityRestricted(route, authorization) {
  return (0, _reactIsomorphicRender.authorize)(allSettingsIsVisible, authorization, route);
};

exports.default = _react2.default.createElement(
  _reactRouter.Route,
  { path: '' },
  _react2.default.createElement(
    _reactRouter.Route,
    { path: constants.GLOWFORGE_LANDING_PAGE.BASE_URI, component: _landingApp2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _glowforgeLanding2.default })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: constants.GLOWFORGE_LANDING_PAGE_HOME.BASE_URI, component: _landingApp2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _glowforgeLanding2.default })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: constants.GLOWFORGE_LANDING_PAGE_HOME_CDN_TEST.BASE_URI, component: _landingApp2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _glowforgeLanding2.default })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: constants.GLOWFORGE_CONFIRMATION.BASE_URI + '/:orderNumber', component: _basicApp2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _confirmation2.default })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'no_glowforge', component: _basicApp2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: restricted(_noGlowforge2.default) })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: constants.SETTINGS_ACCEPT_INVITE.BASE_URI, component: _basicApp2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: restricted(_acceptInvite2.default) })
  ),
  _react2.default.createElement(_reactRouter.Redirect, { from: constants.SETTINGS.BASE_URI, to: '/settings/general' }),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: constants.SETUP.BASE_URI, component: _basicApp2.default },
    _react2.default.createElement(_reactRouter.Route, { path: 'terms-and-conditions', component: restricted(_termsAndConditions2.default) }),
    _react2.default.createElement(_reactRouter.Route, { path: 'machine/:serial/name', component: restricted(_machineName2.default) }),
    _react2.default.createElement(_reactRouter.Route, { path: 'unboxing', component: restricted(_unboxing2.default) }),
    _react2.default.createElement(_reactRouter.Route, { path: 'unboxing/:slug', component: restricted(_unboxing2.default) }),
    _react2.default.createElement(_reactRouter.Route, { path: 'select', component: restricted(_selectMachine2.default) }),
    _react2.default.createElement(_reactRouter.Route, { path: 'instructions', component: restricted(_instructions2.default) }),
    _react2.default.createElement(_reactRouter.Route, { path: 'exhaust', component: restricted(_exhaust2.default) }),
    _react2.default.createElement(_reactRouter.Route, { path: 'finished', component: restricted(_finish2.default) }),
    _react2.default.createElement(_reactRouter.Route, { path: 'add_glowforge', component: restricted(_addGlowforge2.default) }),
    _react2.default.createElement(_reactRouter.Redirect, { from: 'first_glowforge', to: 'terms-and-conditions?entry=first' })
  ),
  _react2.default.createElement(_reactRouter.Redirect, { from: constants.SETUP.BASE_URI, to: constants.SETUP.BASE_URI + '/select' }),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: constants.SETTINGS.BASE_URI, component: _settingsApp2.default },
    _react2.default.createElement(_reactRouter.Route, { path: 'general', component: restricted(_generalAccount2.default) }),
    _react2.default.createElement(_reactRouter.Route, { path: 'password', component: restricted(_password2.default) }),
    _react2.default.createElement(_reactRouter.Route, { path: 'purchase-history', component: addedUserVisibilityRestricted(_purchaseHistory2.default) }),
    _react2.default.createElement(_reactRouter.Route, { path: 'subscription', component: addedUserVisibilityRestricted(_subscription2.default) }),
    _react2.default.createElement(_reactRouter.Route, { path: 'printers', component: addedUserVisibilityRestricted(_printers2.default) }),
    _react2.default.createElement(_reactRouter.Route, { path: 'users', component: addedUserVisibilityRestricted(_users2.default) }),
    _react2.default.createElement(_reactRouter.Route, { path: 'users/invite', component: addedUserVisibilityRestricted(_invite2.default) }),
    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _pageNotFound2.default, status: 404 })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: constants.CREATE_ACCOUNT.BASE_URI, component: _basicApp2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _create2.default })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: constants.REFERRAL_PAYMENT.BASE_URI, component: _basicApp2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: restricted(_referralPayment2.default) })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: constants.MARKETING.BASE_URI + ':slug', component: _marketingApp2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: marketingVisibilityRestricted(_marketingPage2.default) })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'error', component: _basicClientAuthApp2.default, status: 502 },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _error2.default, status: 502 })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'unauthorized', component: _basicClientAuthApp2.default, status: 403 },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _unauthorized2.default, status: 403 })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: constants.PAGE_NOT_FOUND.BASE_URI, component: _basicClientAuthApp2.default, status: 404 },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _pageNotFound2.default, status: 404 })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: '*', component: _basicClientAuthApp2.default, status: 404 },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _pageNotFound2.default, status: 404 })
  )
);

/***/ }),

/***/ "./app/selectors/machines.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pendingInvitesPropTypes = exports.machineUsersPropType = exports.machinePropType = exports.getPendingInvites = exports.getSortedAllUsersForCurrentUsersMachines = exports.getAllUsersForCurrentUsersMachines = exports.getInitialMachineForInvite = exports.getManagedMachineList = exports.getMachineList = exports.getManagedMachinesForUser = exports.getMachinesForUser = undefined;

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");

var _user = __webpack_require__("./app/selectors/user.js");

var _subscriptions = __webpack_require__("./app/selectors/subscriptions.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMachinesForUser = exports.getMachinesForUser = function getMachinesForUser(store) {
  return _lodash2.default.get(store, 'common.machines');
};
var getInvites = function getInvites(store) {
  return _lodash2.default.get(store, 'accountSettings.pendingInvites');
};

// Guests get machine blobs that put owner in an 'owner' field. Managers may see
// a list of user blobs that include users with role owner, so look in both
// places for owners.
var getMachineOwners = function getMachineOwners(machine) {
  var owners = _lodash2.default.filter(machine.users, function (u) {
    return _lodash2.default.includes(u.roles, 'owner');
  });
  var machineOwner = _lodash2.default.get(machine, 'owner');

  if (machineOwner && !_lodash2.default.find(owners, function (u) {
    return u.email === machineOwner.email;
  })) {
    owners.push(machineOwner);
  }

  return owners;
};

function groomMachine(user, machine) {
  var machineUser = _lodash2.default.find(machine.users, function (u) {
    return u.email === user.email;
  }) || {};
  var machineOwners = getMachineOwners(machine);

  return {
    machineName: machine.display_name,
    serial: machine.serial,
    model: machine.model,
    ownerName: _lodash2.default.join(_lodash2.default.map(machineOwners, _lodash2.default.property('name')), ', '),
    ownerEmails: _lodash2.default.map(machineOwners, _lodash2.default.property('email')),
    isOwner: _lodash2.default.includes(machineUser.roles, 'owner'),
    isAdmin: _lodash2.default.includes(machineUser.roles, 'manager'),
    abilities: machine.abilities || null,
    lastPrintAt: machine.last_print_at || null,
    userCount: _lodash2.default.size(machine.users)
  };
}

var getManagedMachinesForUser = exports.getManagedMachinesForUser = (0, _reselect.createSelector)(getMachinesForUser, function (machines) {
  return _lodash2.default.filter(machines, function (machine) {
    return _lodash2.default.includes(_lodash2.default.get(machine, 'abilities'), 'manage_access_to');
  });
});

var getMachineList = exports.getMachineList = (0, _reselect.createSelector)(_user.getUser, getMachinesForUser, function (user, machines) {
  return _lodash2.default.map(machines, function (machine) {
    return groomMachine(user, machine);
  });
});

var getManagedMachineList = exports.getManagedMachineList = (0, _reselect.createSelector)(_user.getUser, getManagedMachinesForUser, function (user, machines) {
  return _lodash2.default.map(machines, function (machine) {
    return groomMachine(user, machine);
  });
});

// If we only have one machines we set it as the initial form value
var getInitialMachineForInvite = exports.getInitialMachineForInvite = (0, _reselect.createSelector)(getMachineList, function (machines) {
  if (machines.length === 1) {
    return {
      // This needs to be manager for the legacy UX, but should be empty when
      // cleaning up USER_ROLE_MANAGEMENT flag.
      machines: [{ serial: machines[0].serial, roles: ['manager'] }]
    };
  }
  return null;
});

var getAllUsersForCurrentUsersMachines = exports.getAllUsersForCurrentUsersMachines = (0, _reselect.createSelector)(_user.getUser, getManagedMachinesForUser, _subscriptions.subscriptions.getAddedUsers, function (currentUser, machines, addedUsers) {
  var userMap = {};
  _lodash2.default.forEach(machines, function (machine) {
    _lodash2.default.forEach(machine.users, function (user) {
      if (user.email === currentUser.email) {
        return;
      }
      if (!userMap[user.email]) {
        userMap[user.email] = (0, _extends3.default)({}, user, { machines: [] });
      }
      userMap[user.email].machines.push({
        machineName: machine.display_name,
        serial: machine.serial,
        roles: user.roles });
    });
  });

  // merge with addedUsers who are not also machine users
  _lodash2.default.forEach(addedUsers, function (user) {
    var email = _lodash2.default.get(user, 'attributes.secondary_user_email', '');
    if (email && !userMap[email]) {
      userMap[email] = {
        email: email,
        machines: [],
        name: email, // addedUser data only has email
        lastPrintAt: '',
        addedAt: ''
      };
    }
  });

  var userList = [];
  _lodash2.default.reduce(userMap, function (results, user) {
    results.push({
      name: user.name,
      addedAt: user.added_at,
      lastPrintAt: user.last_print_at,
      email: user.email,
      machines: user.machines
    });
    return results;
  }, userList);

  return userList;
});

var getSortedAllUsersForCurrentUsersMachines = exports.getSortedAllUsersForCurrentUsersMachines = (0, _reselect.createSelector)(getAllUsersForCurrentUsersMachines, function (users) {
  return _lodash2.default.sortBy(users, function (u) {
    return u.name;
  });
});

var getPendingInvites = exports.getPendingInvites = (0, _reselect.createSelector)(getInvites, getMachinesForUser, function (pending, machines) {
  var userMap = {};
  _lodash2.default.forEach(pending, function (invite) {
    var machine = _lodash2.default.find(machines, { serial: invite.machine_serial });

    // Note: if invited someone but then lost access to the machine you invited them too
    // we don't show the pending invitation any more.
    if (!userMap[invite.invited_email] && machine) {
      userMap[invite.invited_email] = (0, _extends3.default)({}, invite, { machines: [] });
    }

    if (machine) {
      userMap[invite.invited_email].machines.push({
        machineName: machine.display_name,
        serial: machine.serial
      });
    }
  });

  var results = [];
  _lodash2.default.reduce(userMap, function (result, invite) {
    result.push({
      createdAt: invite.created_at,
      email: invite.invited_email,
      id: invite.id,
      machines: invite.machines
    });
    return result;
  }, results);

  return results;
});

var machinePropType = exports.machinePropType = {
  machineName: _propTypes2.default.string,
  serial: _propTypes2.default.string,
  isOwner: _propTypes2.default.bool,
  ownerName: _propTypes2.default.string,
  ownerEmails: _propTypes2.default.arrayOf(_propTypes2.default.string),
  isAdmin: _propTypes2.default.bool,
  roles: _propTypes2.default.arrayOf(_propTypes2.default.string),
  abilities: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

var machineUsersPropType = exports.machineUsersPropType = {
  displayName: _propTypes2.default.string,
  name: _propTypes2.default.string,
  email: _propTypes2.default.string,
  roles: _propTypes2.default.arrayOf(_propTypes2.default.string),
  machines: _propTypes2.default.arrayOf(_propTypes2.default.shape(machinePropType))
};

var pendingInvitesPropTypes = exports.pendingInvitesPropTypes = {
  created_at: _propTypes2.default.string,
  email: _propTypes2.default.string,
  machins: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

/***/ }),

/***/ "./app/selectors/route.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");

var _routeConstants = __webpack_require__("./app/route-constants.js");

var ROUTE_CONSTANTS = _interopRequireWildcard(_routeConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO STORE-2701: 404 will never display 'Marketing Nav' because a route
//      with the status '404' will not be found in route-constants.js
var getConstants = function getConstants(state, route) {
  return (0, _lodash2.default)(ROUTE_CONSTANTS).filter(function (config) {
    return _lodash2.default.get(route, 'path').indexOf(config.BASE_URI) === 0;
  })
  // find deepest matching constant (take /thing/child not /thing)
  // case of '/' is special
  .maxBy(function (config) {
    return config.BASE_URI === '/' ? 1 : config.BASE_URI.split('/').length;
  }) || {
    HIDE_NAV_LINKS: false,
    HIDE_USER_SECTION: false,
    USE_MARKETING_NAV: true,
    INCLUDE_BUY_BUTTON: true,
    SHOW_GLOBAL_FOOTER: true
  };
};

var getRouteConstants = (0, _reselect.createSelector)(getConstants, function (constants) {
  return constants;
});

exports.default = getRouteConstants;

/***/ }),

/***/ "./app/selectors/subscriptions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscriptions = exports.getSubscriptionsData = undefined;

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");

var _subscriptions = __webpack_require__("./app/reducers/subscriptions.js");

var _appConstants = __webpack_require__("./app/app-constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSubscriptionsData = exports.getSubscriptionsData = function getSubscriptionsData(state) {
  return _lodash2.default.get(state, 'subscriptions');
};

// Subscription statuses for effective active statuses that can
// manage / update other user statuses.
var CAN_MANAGE_STATUSES = ['active', 'non_renewing'];

function userCanManage(subscriptions) {
  var status = _lodash2.default.get(subscriptions, 'attributes.status');
  var messagingState = _lodash2.default.get(subscriptions, 'attributes.messaging_state');
  return _lodash2.default.includes(CAN_MANAGE_STATUSES, status) || status === 'in_trial' && messagingState === 'trial_paying';
}

var isSubscriptionsEnabled = function isSubscriptionsEnabled(state) {
  var features = _lodash2.default.get(state, 'common.features');
  return features && !!features.SAPPHIRE_SUN;
};

var getSubscription = (0, _reselect.createSelector)(isSubscriptionsEnabled, getSubscriptionsData,
// TODO: how do we handle multiple subscriptions in here? Also should the reducer
// extract this instead of just plopping the whole blob down here?
function (enabled, settings) {
  return enabled ? _lodash2.default.get(settings, 'current.data') || {} : {};
});

var isSubscriptionActive = (0, _reselect.createSelector)(isSubscriptionsEnabled, getSubscription, function (enabled, subscriptions) {
  return enabled && userCanManage(subscriptions);
});

var getSubscriptionRole = (0, _reselect.createSelector)(isSubscriptionsEnabled, getSubscription, function (enabled, subscriptions) {
  return enabled && _lodash2.default.get(subscriptions, 'attributes.role');
});

var isSubscriber = (0, _reselect.createSelector)(isSubscriptionsEnabled, isSubscriptionActive, getSubscriptionRole, function (enabled, active, role) {
  return enabled && active && role === 'subscriber';
});

function isLoadingState(value) {
  return value === _subscriptions.SUBSCRIPTION_STATES.loading;
}

var isSubscriptionDataLoading = (0, _reselect.createSelector)(isSubscriptionsEnabled, getSubscriptionsData, function (enabled, subscriptions) {
  return (
    // Subscription data obviously "loaded" if not enabled
    enabled && isLoadingState(_lodash2.default.get(subscriptions, 'state'))
  );
});

var getSubscriptionsTotalAllowedUsers = (0, _reselect.createSelector)(getSubscription, function (subscriptions) {
  return _lodash2.default.get(subscriptions, 'attributes.total_users') || 0;
});

var getSubscriptionsAddedUsers = (0, _reselect.createSelector)(isSubscriptionsEnabled, getSubscriptionsData, function (enabled, subscriptions) {
  return enabled ? _lodash2.default.get(subscriptions, 'addedUsers.data') || [] : [];
});

var getSubscriptionsActiveAddedUsers = (0, _reselect.createSelector)(getSubscriptionsAddedUsers, function (addedUsers) {
  return _lodash2.default.filter(addedUsers, function (u) {
    return _lodash2.default.get(u, 'attributes.status') === 'active';
  });
});

var getSubscriptionIsRestricted = (0, _reselect.createSelector)(getSubscriptionsData, isSubscriptionsEnabled, function (subscriptions, enabled) {
  var currentSubscription = _lodash2.default.get(subscriptions, 'current.data');
  var isOwner = !_lodash2.default.isEmpty(_lodash2.default.get(currentSubscription, 'attributes.external'));
  var accountAccess = _lodash2.default.get(currentSubscription, 'attributes.additional_users_access_status');

  return enabled && !isOwner && accountAccess === _appConstants.ACCOUNT_ACCESS.RESTRICTED;
});

var canManageSubscriptions = (0, _reselect.createSelector)(isSubscriptionsEnabled, getSubscriptionsData, function (enabled, data) {
  var subscriptions = _lodash2.default.get(data, 'current.data');
  return enabled && userCanManage(subscriptions);
});

var isManagePending = (0, _reselect.createSelector)(isSubscriptionsEnabled, getSubscriptionsData, function (enabled, data) {
  if (!enabled) {
    return false;
  }

  return _lodash2.default.get(data, 'managePending', false);
});

var getManageSubscriptionsLink = (0, _reselect.createSelector)(canManageSubscriptions, getSubscription, function (enabled, subscriptions) {
  if (!enabled) {
    return '';
  }

  return _lodash2.default.get(subscriptions, 'links.portal');
});

var subscriptions = exports.subscriptions = {
  isEnabled: isSubscriptionsEnabled,
  isActive: isSubscriptionActive,
  isSubscriber: isSubscriber,
  isLoading: isSubscriptionDataLoading,
  current: getSubscription,
  getTotalUsers: getSubscriptionsTotalAllowedUsers,
  getAddedUsers: getSubscriptionsActiveAddedUsers,
  getIsRestricted: getSubscriptionIsRestricted,
  getManageLink: getManageSubscriptionsLink,
  canManage: canManageSubscriptions,
  isManagePending: isManagePending
};

/***/ }),

/***/ "./app/selectors/support.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instructionsPropTypes = exports.stepPropTypes = exports.topicPropTypes = exports.articlePropTypes = exports.textPropTypes = exports.topicCardPropTypes = exports.getSelectedArticle = undefined;

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ** Article Details Selectors **//
var getSelectedArticle = exports.getSelectedArticle = (0, _reselect.createSelector)(function (store) {
  return _lodash2.default.get(store, 'support.selectedArticleSlug');
}, function (store) {
  return _lodash2.default.get(store, 'support.loadedArticles');
}, function (selectedArticleSlug, articles) {
  if (articles) {
    return articles[selectedArticleSlug];
  }
  return null;
});

var topicCardPropTypes = exports.topicCardPropTypes = {
  fields: _propTypes2.default.shape({
    title: _propTypes2.default.string,
    summary: _propTypes2.default.string,
    iconAssetId: _propTypes2.default.string,
    slug: _propTypes2.default.string
  })
};

// TODO: Change this to a text entry?
var textPropTypes = exports.textPropTypes = {
  fields: _propTypes2.default.shape({
    title: _propTypes2.default.string,
    text: _propTypes2.default.string,
    slug: _propTypes2.default.string
  })
};

var articlePropTypes = exports.articlePropTypes = {
  fields: _propTypes2.default.shape({
    title: _propTypes2.default.string,
    slug: _propTypes2.default.string,
    entries: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.shape(textPropTypes)]))
  })
};

var topicPropTypes = exports.topicPropTypes = (0, _extends3.default)({}, topicCardPropTypes, {
  articles: _propTypes2.default.arrayOf(_propTypes2.default.shape(articlePropTypes))
});

var stepPropTypes = exports.stepPropTypes = {
  title: _propTypes2.default.string,
  summary: _propTypes2.default.string,
  image: _propTypes2.default.shape({
    title: _propTypes2.default.string,
    file: _propTypes2.default.shape({ url: _propTypes2.default.string })
  }),
  imageTwo: _propTypes2.default.shape({
    title: _propTypes2.default.string,
    file: _propTypes2.default.shape({ url: _propTypes2.default.string })
  })
};

var instructionsPropTypes = exports.instructionsPropTypes = {
  title: _propTypes2.default.string,
  summary: _propTypes2.default.string,
  steps: _propTypes2.default.arrayOf(_propTypes2.default.shape(stepPropTypes))
};

/***/ }),

/***/ "./app/selectors/user.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeCreditPropType = exports.creditCardsPropType = exports.userPropTypes = exports.getPurchaseHistory = exports.getPaymentMethods = exports.getBasicAccountInfo = exports.getUser = undefined;

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUserData = function getUserData(store) {
  return _lodash2.default.get(store, 'common.user');
};
var getCreditCards = function getCreditCards(store) {
  return _lodash2.default.get(store, 'accountSettings.creditCards');
};
var getStoreCredit = function getStoreCredit(store) {
  return _lodash2.default.get(store, 'accountSettings.availableCredit');
};
var getOrderHistory = function getOrderHistory(store) {
  return _lodash2.default.get(store, 'accountSettings.purchaseHistory');
};

var getUser = exports.getUser = (0, _reselect.createSelector)(getUserData, function (user) {
  return user;
});

var getBasicAccountInfo = exports.getBasicAccountInfo = (0, _reselect.createSelector)(getUser, function (user) {
  return {
    first_name: user.first_name,
    last_name: user.last_name,
    display_name: user.display_name,
    email: user.email,
    phone: user.phone
  };
});

var getPaymentMethods = exports.getPaymentMethods = (0, _reselect.createSelector)(getCreditCards, getStoreCredit, function (creditCards, storeCredit) {
  return { creditCards: creditCards, storeCredit: storeCredit };
});

var getPurchaseHistory = exports.getPurchaseHistory = (0, _reselect.createSelector)(getOrderHistory, function (purchaseHistory) {
  return purchaseHistory;
});

var userPropTypes = exports.userPropTypes = {
  id: _propTypes2.default.number,
  email: _propTypes2.default.string,
  first_name: _propTypes2.default.string,
  last_name: _propTypes2.default.string,
  display_name: _propTypes2.default.string
};

var creditCardsPropType = exports.creditCardsPropType = {
  name: _propTypes2.default.string,
  lastDigits: _propTypes2.default.string.isRequired,
  cc_type: _propTypes2.default.string.isRequired,
  year: _propTypes2.default.string.isRequired,
  month: _propTypes2.default.string.isRequired
};

var storeCreditPropType = exports.storeCreditPropType = {
  design: _propTypes2.default.string,
  glowforge: _propTypes2.default.string,
  shop: _propTypes2.default.string,
  all: _propTypes2.default.string
};

/***/ }),

/***/ "./app/store/actions/glowforge-store.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_GLOWFORGE_PRODUCT_LIST = exports.SET_GLOWFORGE_PRODUCT_LIST = 'SET_GLOWFORGE_PRODUCT_LIST';
var SET_ORDER_DETAILS = exports.SET_ORDER_DETAILS = 'SET_ORDER_DETAILS';
var SET_CONFIRMATION_PAGE = exports.SET_CONFIRMATION_PAGE = 'SET_CONFIRMATION_PAGE';

/***/ }),

/***/ "./app/store/api/glowforge-store-api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchConfirmationPage = exports.fetchOrderDetails = exports.fetchProducts = undefined;

var _regenerator = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("./node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _contentfulClient = __webpack_require__("./app/api/contentful-client.js");

var contentfulClient = _interopRequireWildcard(_contentfulClient);

var _glowforgeStore = __webpack_require__("./app/store/actions/glowforge-store.js");

var actions = _interopRequireWildcard(_glowforgeStore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchProducts = exports.fetchProducts = function fetchProducts() {
  return {
    promise: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(http) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', http.get('/base://storefront/api/search'));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined);
      }));

      return function promise(_x) {
        return _ref.apply(this, arguments);
      };
    }(),
    events: ['PROMISE_PENDING', actions.SET_GLOWFORGE_PRODUCT_LIST, 'PROMISE_ERROR']
  };
};

var fetchOrderDetails = exports.fetchOrderDetails = function fetchOrderDetails(orderNumber, key) {
  return {
    promise: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(http) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', http.get('/base://storefront/api/orders/details?number=' + orderNumber + '&key=' + key));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, undefined);
      }));

      return function promise(_x2) {
        return _ref2.apply(this, arguments);
      };
    }(),
    events: ['PROMISE_PENDING', actions.SET_ORDER_DETAILS, 'PROMISE_ERROR']
  };
};

var fetchConfirmationPage = exports.fetchConfirmationPage = function fetchConfirmationPage() {
  return {
    promise: function promise() {
      return contentfulClient.getPage('glowforge-confirmation-page');
    },
    events: ['PROMISE_PENDING', actions.SET_CONFIRMATION_PAGE, 'PROMISE_ERROR']
  };
};

/***/ }),

/***/ "./app/store/components/common/order-cost-summary.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _util = __webpack_require__("./app/util.js");

var _products = __webpack_require__("./app/store/selectors/products.js");

__webpack_require__("./app/store/components/common/order-cost-summary.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderCostSummary = function OrderCostSummary(props) {
  var shippingCosts = [];
  if (props.air_filter_shipping) {
    shippingCosts.push(_react2.default.createElement(
      'div',
      { className: 'row', key: '1a' },
      _react2.default.createElement(
        'div',
        { className: 'type' },
        'Air Filter Shipping:'
      ),
      _react2.default.createElement(
        'div',
        { className: 'amount' },
        (0, _util.formatPrice)(props.air_filter_shipping)
      )
    ));
  }

  if (props.glowforge_shipping) {
    shippingCosts.push(_react2.default.createElement(
      'div',
      { className: 'row', key: '2a' },
      _react2.default.createElement(
        'div',
        { className: 'type' },
        'Glowforge Shipping:'
      ),
      _react2.default.createElement(
        'div',
        { className: 'amount' },
        (0, _util.formatPrice)(props.glowforge_shipping)
      )
    ));
  }

  if (_lodash2.default.isEmpty(shippingCosts) && props.shipping) {
    shippingCosts.push(_react2.default.createElement(
      'div',
      { className: 'row', key: '3a' },
      _react2.default.createElement(
        'div',
        { className: 'type' },
        'Shipping:'
      ),
      _react2.default.createElement(
        'div',
        { className: 'amount' },
        (0, _util.formatPrice)(props.shipping)
      )
    ));
  }

  var discounts = void 0;
  if (props.discounts) {
    discounts = _react2.default.createElement(
      'div',
      { className: 'row discount' },
      _react2.default.createElement(
        'div',
        { className: 'type' },
        'Discount:'
      ),
      _react2.default.createElement(
        'div',
        { className: 'amount' },
        '-',
        (0, _util.formatPrice)(props.discounts)
      )
    );
  }

  var adjustments = _lodash2.default.map(props.adjustments, function (adj, index) {
    return _react2.default.createElement(
      'div',
      { className: 'row', key: index },
      _react2.default.createElement(
        'div',
        { className: 'type' },
        adj.label,
        ':'
      ),
      _react2.default.createElement(
        'div',
        { className: 'amount' },
        (0, _util.formatPrice)(adj.amount)
      )
    );
  });

  var storeCredits = void 0;
  if (props.storeCredits) {
    storeCredits = _react2.default.createElement(
      'div',
      { className: 'row discount' },
      _react2.default.createElement(
        'div',
        { className: 'type' },
        'Store Credits:'
      ),
      _react2.default.createElement(
        'div',
        { className: 'amount' },
        '-',
        (0, _util.formatPrice)(props.storeCredits)
      )
    );
  }

  return _react2.default.createElement(
    'div',
    { className: 'OrderCostSummary' },
    _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        'div',
        { className: 'type' },
        'Subtotal:'
      ),
      _react2.default.createElement(
        'div',
        { className: 'amount' },
        (0, _util.formatPrice)(props.subtotal)
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        'div',
        { className: 'type' },
        'Taxes:'
      ),
      _react2.default.createElement(
        'div',
        { className: 'amount' },
        (0, _util.formatPrice)(props.salesTax)
      )
    ),
    shippingCosts,
    discounts,
    storeCredits,
    adjustments,
    _react2.default.createElement(
      'div',
      { className: 'row total' },
      _react2.default.createElement(
        'div',
        { className: 'type' },
        'Total:'
      ),
      _react2.default.createElement(
        'div',
        { className: 'amount' },
        (0, _util.formatPrice)(props.total)
      )
    )
  );
};

OrderCostSummary.propTypes = (0, _extends3.default)({}, _products.orderPropType);

exports.default = OrderCostSummary;

/***/ }),

/***/ "./app/store/components/common/order-cost-summary.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/store/components/glowforge/confirmation/confirmation-page.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _page = __webpack_require__("./app/common/selectors/page.js");

var _orderDetails = __webpack_require__("./app/store/components/glowforge/confirmation/order-details.jsx");

var _orderDetails2 = _interopRequireDefault(_orderDetails);

__webpack_require__("./app/store/components/glowforge/confirmation/confirmation-page.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Page = _uiCommon.contentfulViews.Page;

var ConfirmationPage = function (_Component) {
  (0, _inherits3.default)(ConfirmationPage, _Component);

  function ConfirmationPage() {
    (0, _classCallCheck3.default)(this, ConfirmationPage);
    return (0, _possibleConstructorReturn3.default)(this, (ConfirmationPage.__proto__ || (0, _getPrototypeOf2.default)(ConfirmationPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(ConfirmationPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.GTM_NEW_ORDER_CONFIG = _lodash2.default.get(this.props, 'gtmNewOrderConfig');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(_lodash2.default.get(this.props, 'gtmNewOrderConfig'));
    }
  }, {
    key: 'render',
    value: function render() {
      var customSections = {
        'glowforge-order-summary': {
          component: _orderDetails2.default,
          props: {
            priceSummary: _lodash2.default.get(this.props, 'priceSummary'),
            shippingSummary: _lodash2.default.get(this.props, 'shippingSummary'),
            orderNumber: this.props.params.orderNumber
          }
        }
      };

      var stringSubstitutions = [{ name: 'email', value: _lodash2.default.get(this.props, 'orderEmail') }, { name: 'referral-url', value: this.props.referralURL }];

      return _react2.default.createElement(Page, (0, _extends3.default)({ className: 'ConfirmationPage' }, this.props.page, { customSections: customSections, stringSubstitutions: stringSubstitutions }));
    }
  }]);
  return ConfirmationPage;
}(_react.Component);

ConfirmationPage.propTypes = {
  page: _propTypes2.default.shape(_page.pagePropType).isRequired,
  orderNumber: _propTypes2.default.string.isRequired,
  params: _propTypes2.default.shape({ orderNumber: _propTypes2.default.string.isRequired }).isRequired,
  referralURL: _propTypes2.default.string.isRequired
};

exports.default = ConfirmationPage;

/***/ }),

/***/ "./app/store/components/glowforge/confirmation/confirmation-page.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/store/components/glowforge/confirmation/order-details.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _util = __webpack_require__("./app/util.js");

var _uiCommon = __webpack_require__("./node_modules/@glowforge/ui-common/main.js");

__webpack_require__("./app/store/components/glowforge/confirmation/order-details.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSectionForPageByIdAndType = _uiCommon.contentfulModels.getSectionForPageByIdAndType;
var Markdown = _uiCommon.components.Markdown;
var TextAndImageSection = _uiCommon.contentfulViews.TextAndImageSection;


var OrderDetails = function OrderDetails(props) {
  var imageSection = getSectionForPageByIdAndType(props, 'order-summary-glowforge-image', 'textAndImageSection');

  // This makes me feel dirty... but i'm not sure a better way to manage it easily
  var imageIndex = _lodash2.default.findIndex(imageSection.images, { fields: { title: 'BASIC FRONT CLOSED' } });
  if (props.priceSummary.glowforgeName === 'Glowforge Pro') {
    imageIndex = _lodash2.default.findIndex(imageSection.images, { fields: { title: 'PRO FRONT CLOSED' } });
  } else if (props.priceSummary.glowforgeName === 'Glowforge Plus') {
    imageIndex = _lodash2.default.findIndex(imageSection.images, { fields: { title: 'PLUS FRONT CLOSED' } });
  }

  var sectionTitle = _lodash2.default.get(_lodash2.default.find(props.textStrings, { fields: { id: 'order-details-title' } }), 'fields.text');
  var discountLine = props.priceSummary.discountTotal < 0 ? _react2.default.createElement(
    'div',
    { className: 'row' },
    _react2.default.createElement(
      'div',
      { className: 'col' },
      'Discount Total:'
    ),
    _react2.default.createElement(
      'div',
      { className: 'col' },
      (0, _util.formatPrice)(props.priceSummary.discountTotal)
    )
  ) : null;
  var supportText = _lodash2.default.get(_lodash2.default.find(props.textStrings, { fields: { id: 'order-details-support' } }), 'fields.text');

  return _react2.default.createElement(
    'div',
    { className: 'OrderDetails fullWidth contentWide' },
    _react2.default.createElement(
      'div',
      { className: 'summary' },
      _react2.default.createElement(
        'h2',
        { className: 'h2' },
        sectionTitle
      ),
      _react2.default.createElement(
        'div',
        { className: 'breakDown' },
        _react2.default.createElement(
          'h3',
          { className: 'h3' },
          'Summary'
        ),
        _react2.default.createElement(
          'div',
          { className: 'table' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col' },
              'Price before discounts:'
            ),
            _react2.default.createElement(
              'div',
              { className: 'col' },
              (0, _util.formatPrice)(props.priceSummary.priceBeforeDiscounts)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col' },
              'Items Purchased:'
            ),
            _react2.default.createElement(
              'div',
              { className: 'col' },
              _lodash2.default.join(props.priceSummary.itemsPurchased, ', ')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col' },
              'Shipping Cost:'
            ),
            _react2.default.createElement(
              'div',
              { className: 'col' },
              (0, _util.formatPrice)(props.priceSummary.shippingCost)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col' },
              'Sales Tax:'
            ),
            _react2.default.createElement(
              'div',
              { className: 'col' },
              (0, _util.formatPrice)(props.priceSummary.salesTax)
            )
          ),
          discountLine,
          _react2.default.createElement(
            'div',
            { className: 'row totalPaid' },
            _react2.default.createElement(
              'div',
              { className: 'col' },
              'Total Paid:'
            ),
            _react2.default.createElement(
              'div',
              { className: 'col' },
              (0, _util.formatPrice)(props.priceSummary.totalPaid)
            )
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'shippingAddress' },
        _react2.default.createElement(
          'h3',
          { className: 'h3' },
          'Shipping Address'
        ),
        _react2.default.createElement(
          'div',
          null,
          props.shippingSummary.name
        ),
        _react2.default.createElement(
          'div',
          null,
          props.shippingSummary.addressLine1
        ),
        _react2.default.createElement(
          'div',
          null,
          props.shippingSummary.addressLine2
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'orderNumber' },
        _react2.default.createElement(
          'h3',
          { className: 'h3' },
          'Order Number'
        ),
        _react2.default.createElement(
          'div',
          null,
          props.orderNumber
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'contactInfo' },
        _react2.default.createElement(Markdown, { source: supportText })
      )
    ),
    _react2.default.createElement(TextAndImageSection, (0, _extends3.default)({}, imageSection, { imageIndex: imageIndex }))
  );
};

OrderDetails.propTypes = {
  textStrings: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  priceSummary: _propTypes2.default.shape({
    priceBeforeDiscounts: _propTypes2.default.number,
    itemsPurchased: _propTypes2.default.arrayOf(_propTypes2.default.string),
    shippingCost: _propTypes2.default.number,
    glowforgeName: _propTypes2.default.string,
    salesTax: _propTypes2.default.number,
    discountTotal: _propTypes2.default.number,
    totalPaid: _propTypes2.default.number
  }).isRequired,
  shippingSummary: _propTypes2.default.shape({
    name: _propTypes2.default.string,
    addressLine1: _propTypes2.default.string,
    addressLine2: _propTypes2.default.string
  }).isRequired,
  orderNumber: _propTypes2.default.string.isRequired
};

exports.default = OrderDetails;

/***/ }),

/***/ "./app/store/components/glowforge/confirmation/order-details.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/store/containers/glowforge/confirmation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _glowforgeStoreApi = __webpack_require__("./app/store/api/glowforge-store-api.js");

var _confirmationPage = __webpack_require__("./app/store/components/glowforge/confirmation/confirmation-page.jsx");

var _confirmationPage2 = _interopRequireDefault(_confirmationPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    page: (0, _extends3.default)({}, _lodash2.default.get(state, 'glowforgeStore.orderConfirmationPage')),
    priceSummary: _lodash2.default.get(state, 'glowforgeStore.priceSummary'),
    shippingSummary: _lodash2.default.get(state, 'glowforgeStore.shippingSummary'),
    referralURL: _lodash2.default.get(state, 'glowforgeStore.referralURL'),
    orderEmail: _lodash2.default.get(state, 'glowforgeStore.orderEmail'),
    gtmNewOrderConfig: _lodash2.default.get(state, 'glowforgeStore.gtmNewOrderConfig')
  };
};

var ShopCategoryContainer = (0, _reactRedux.connect)(mapStateToProps)((0, _reactIsomorphicRender.preload)(function (_ref) {
  var dispatch = _ref.dispatch,
      location = _ref.location,
      parameters = _ref.parameters;

  var key = _lodash2.default.get(location, 'query.key');
  return _promise2.default.all([dispatch((0, _glowforgeStoreApi.fetchOrderDetails)(parameters.orderNumber, key)), dispatch((0, _glowforgeStoreApi.fetchConfirmationPage)())]);
})(_confirmationPage2.default));

exports.default = ShopCategoryContainer;

/***/ }),

/***/ "./app/store/reducers/glowforge-store.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case actions.SET_GLOWFORGE_PRODUCT_LIST:
      {
        return (0, _assign2.default)({}, state, {
          products: _lodash2.default.get(action.result, 'products')
        });
      }
    case actions.SET_CONFIRMATION_PAGE:
      {
        return (0, _assign2.default)({}, state, {
          orderConfirmationPage: _lodash2.default.get(action, 'result.fields')
        });
      }
    case _common.PROMISE_ERROR:
      {
        switch (_lodash2.default.get(action, 'error.type')) {
          case actions.ORDER_SUBMIT_ERROR:
            {
              return (0, _assign2.default)({}, state, {
                submittingOrder: false
              });
            }
          case actions.ORDER_TOTALS_ERROR:
            {
              return (0, _assign2.default)({}, state, {
                gettingOrderTotals: false,
                orderTotals: null
              });
            }
          default:
            {
              return state;
            }
        }
      }
    default:
      {
        return state;
      }
  }
};

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _glowforgeStore = __webpack_require__("./app/store/actions/glowforge-store.js");

var actions = _interopRequireWildcard(_glowforgeStore);

var _common = __webpack_require__("./app/common/actions/common.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./app/store/selectors/products.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderPropType = exports.orderItemPropType = exports.imagePropType = undefined;

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Figure out a better place for these prop types to live

// Shop specific for now... will adjust with design
var imagePropType = exports.imagePropType = {
  id: _propTypes2.default.number,
  imageUrl: _propTypes2.default.string
};

var orderItemPropType = exports.orderItemPropType = {
  id: _propTypes2.default.number,
  quantity: _propTypes2.default.number,
  name: _propTypes2.default.string,
  slug: _propTypes2.default.string,
  subTitle: _propTypes2.default.string,
  price: _propTypes2.default.number,
  amount: _propTypes2.default.number,
  images: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

var orderPropType = exports.orderPropType = {
  number: _propTypes2.default.string,
  state: _propTypes2.default.string,
  createdAt: _propTypes2.default.string,
  subtotal: _propTypes2.default.number,
  shipping: _propTypes2.default.number,
  air_filter_shipping: _propTypes2.default.number,
  glowforge_shipping: _propTypes2.default.number,
  promoDiscounts: _propTypes2.default.number,
  salesTax: _propTypes2.default.number,
  total: _propTypes2.default.number,
  email: _propTypes2.default.string,
  billingMatch: _propTypes2.default.bool,
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape(orderItemPropType)),
  adjustments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    amount: _propTypes2.default.number,
    label: _propTypes2.default.string
  }))
};

/***/ }),

/***/ "./app/strings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var strings = {
  ERROR_HEADER: 'Whoops! There was an error.',
  ERROR_SUB: 'We are on it. Please try again later.',
  PAGE_NOT_FOUND_SUB: 'Whoops! That page does not exist.',
  NOTIFICATION_LEVEL_ERROR_TEXT: 'We\'re sorry there was an error on the page. Please refresh and try again',
  GENERIC_SUBMIT_ERROR: 'There was an issue with your submission. Please try again later.',
  UNAUTHORIZED_SUB: 'You are not authorized to view this page',
  USER_MACHINE_ROLES: {
    standard_user: 'Guest',
    manager: 'Admin'
  }
};

exports.default = strings;

/***/ }),

/***/ "./app/util.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEdge = exports.getChromeVersion = exports.shopifyMultipassUrlBuilder = exports.getInvalidEmails = exports.isValidEmailFormat = exports.removePhoneFormat = exports.userFullName = exports.userDisplayName = exports.formatPrice = undefined;

var _isInteger = __webpack_require__("./node_modules/babel-runtime/core-js/number/is-integer.js");

var _isInteger2 = _interopRequireDefault(_isInteger);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _numeral = __webpack_require__("./node_modules/numeral/numeral.js");

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Util to build out with useful helper methods * */

var formatPrice = exports.formatPrice = function formatPrice(price) {
  //eslint-disable-line
  var priceFormat = (0, _isInteger2.default)(price) ? '$0,0' : '$0,0.00';
  return (0, _numeral2.default)(price, 0).format(priceFormat);
};

var userDisplayName = exports.userDisplayName = function userDisplayName(user) {
  if (user.display_name) {
    return '' + user.display_name;
  }
  if (user.first_name && user.last_name) {
    return user.first_name + ' ' + (user.last_name[0] || '');
  }
  if (user.first_name) {
    return user.first_name;
  }
  return user.email;
};
var userFullName = exports.userFullName = function userFullName(user) {
  if (user.first_name) {
    return user.first_name + ' ' + user.last_name;
  }
  return user.email;
};

// For removing phone formating from masked form element
var removePhoneFormat = exports.removePhoneFormat = function removePhoneFormat(prettyFormatNumber) {
  return prettyFormatNumber.replace(/[^\d]/g, '');
};

var isValidEmailFormat = exports.isValidEmailFormat = function isValidEmailFormat(email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

var getInvalidEmails = exports.getInvalidEmails = function getInvalidEmails(commaSeparatedEmails) {
  // Check if comma separated list of valid emails
  var emails = commaSeparatedEmails.split(',').map(function (e) {
    return e.trim();
  });
  return _lodash2.default.reject(emails, isValidEmailFormat);
};

var shopifyMultipassUrlBuilder = exports.shopifyMultipassUrlBuilder = function shopifyMultipassUrlBuilder(returnUrl, skipLogin) {
  var returnUrlParam = encodeURIComponent(returnUrl);
  var multipassUrl = global.sharedEnv.USER_SERVICE_SERVER + '/multipass?return_url=' + returnUrlParam;
  if (skipLogin) {
    multipassUrl += '&skip_login=true';
  }
  return multipassUrl;
};

var getChromeVersion = exports.getChromeVersion = function getChromeVersion() {
  var chrome = navigator.userAgentData && navigator.userAgentData.brands.find(function (_ref) {
    var brand = _ref.brand;
    return brand === 'Google Chrome';
  });
  return chrome && Number(chrome.version);
};

var isEdge = exports.isEdge = function isEdge() {
  // recommended way of browser detection:
  // https://learn.microsoft.com/en-us/microsoft-edge/web-platform/user-agent-guidance
  var edge = navigator.userAgentData && navigator.userAgentData.brands.find(function (_ref2) {
    var brand = _ref2.brand;
    return brand === 'Microsoft Edge';
  });

  if (!edge) {
    // legacy way as a fallback in non secure connections
    edge = navigator.userAgent.match(/(Edg)([a-z]+)?\/([0-9]+)\./);
  }
  return !!edge;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./app/wrapper.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactHotLoader = __webpack_require__("./node_modules/react-hot-loader/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _countryCode = __webpack_require__("./app/common/containers/country-code.js");

__webpack_require__("./node_modules/@glowforge/ui-common/main.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = function Wrapper(_ref) {
  var store = _ref.store,
      children = _ref.children;
  return _react2.default.createElement(
    _reactHotLoader.AppContainer,
    null,
    _react2.default.createElement(
      _reactRedux.Provider,
      { store: store },
      _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(_countryCode.IdentifyGeo, null),
        children
      )
    )
  );
};

Wrapper.propTypes = {
  store: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
  children: _propTypes2.default.element.isRequired
};

exports.default = Wrapper;

/***/ }),

/***/ "./client/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("./node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _reactIsomorphicRender = __webpack_require__("./node_modules/react-isomorphic-render/index.es6.js");

__webpack_require__("./node_modules/regenerator-runtime/runtime.js");

var _reactIsomorphicRender2 = __webpack_require__("./app/react-isomorphic-render.js");

var _reactIsomorphicRender3 = _interopRequireDefault(_reactIsomorphicRender2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (false) {
  import('source-map-support/register');
}

// Client Side Hookup
// eslint-disable-line import/no-extraneous-dependencies
(0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
  return _regenerator2.default.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _reactIsomorphicRender.render)(_reactIsomorphicRender3.default, {}).then(function (_ref2) {
            var store = _ref2.store,
                rerender = _ref2.rerender;

            if (false) {
              module.hot.accept('../app/react-isomorphic-render', function () {
                store.hotReload(_reactIsomorphicRender3.default.reducer);
                rerender();
              });
            }
          });

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _callee, this);
}))();

/***/ }),

/***/ "./node_modules/@glowforge/ui-common/components/navigation/top-nav.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/@glowforge/ui-common/main.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/@glowforge/ui-common/main.js":
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__("./node_modules/react/index.js"), __webpack_require__("./node_modules/react-dom/index.js"), __webpack_require__("./node_modules/react-helmet/lib/Helmet.js"), __webpack_require__("./node_modules/isomorphic-fetch/fetch-npm-browserify.js"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ReactDOM", "ReactHelmet", "IsomorphicFetch"], factory);
	else if(typeof exports === 'object')
		exports["ui-common"] = factory(require("react"), require("react-dom"), require("react-helmet"), require("isomorphic-fetch"));
	else
		root["ui-common"] = factory(root["React"], root["ReactDOM"], root["ReactHelmet"], root["IsomorphicFetch"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__8__, __WEBPACK_EXTERNAL_MODULE__165__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 229);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (true) {
  var ReactIs = __webpack_require__(9);

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(62)(ReactIs.isElement, throwOnDirectAccess);
} else {}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(16), __webpack_require__(64)(module)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(20)(module)))

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (false) {} else {
  module.exports = __webpack_require__(61);
}


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forceVisible = exports.forceCheck = exports.lazyload = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(5);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _event = __webpack_require__(120);

var _scrollParent = __webpack_require__(121);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _debounce = __webpack_require__(122);

var _debounce2 = _interopRequireDefault(_debounce);

var _throttle = __webpack_require__(123);

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
var LISTEN_FLAG = 'data-lazyload-listened';
var listeners = [];
var pending = [];

// try to handle passive events
var passiveEventSupported = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      passiveEventSupported = true;
    }
  });
  window.addEventListener('test', null, opts);
} catch (e) {}
// if they are supported, setup the optional params
// IMPORTANT: FALSE doubles as the default CAPTURE value!
var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;

/**
 * Check if `component` is visible in overflow container `parent`
 * @param  {node} component React component
 * @param  {node} parent    component's scroll parent
 * @return {bool}
 */
var checkOverflowVisible = function checkOverflowVisible(component, parent) {
  var node = _reactDom2.default.findDOMNode(component);
  // const node = component.ref;

  var parentTop = void 0;
  var parentLeft = void 0;
  var parentHeight = void 0;
  var parentWidth = void 0;

  try {
    var _parent$getBoundingCl = parent.getBoundingClientRect();

    parentTop = _parent$getBoundingCl.top;
    parentLeft = _parent$getBoundingCl.left;
    parentHeight = _parent$getBoundingCl.height;
    parentWidth = _parent$getBoundingCl.width;
  } catch (e) {
    parentTop = defaultBoundingClientRect.top;
    parentLeft = defaultBoundingClientRect.left;
    parentHeight = defaultBoundingClientRect.height;
    parentWidth = defaultBoundingClientRect.width;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
  var windowInnerWidth = window.innerWidth || document.documentElement.clientWidth;

  // calculate top and height of the intersection of the element's scrollParent and viewport
  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
  var intersectionLeft = Math.max(parentLeft, 0); // intersection's left relative to viewport
  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
  var intersectionWidth = Math.min(windowInnerWidth, parentLeft + parentWidth) - intersectionLeft; // width

  // check whether the element is visible in the intersection
  var top = void 0;
  var left = void 0;
  var height = void 0;
  var width = void 0;

  try {
    var _node$getBoundingClie = node.getBoundingClientRect();

    top = _node$getBoundingClie.top;
    left = _node$getBoundingClie.left;
    height = _node$getBoundingClie.height;
    width = _node$getBoundingClie.width;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    left = defaultBoundingClientRect.left;
    height = defaultBoundingClientRect.height;
    width = defaultBoundingClientRect.width;
  }

  var offsetTop = top - intersectionTop; // element's top relative to intersection
  var offsetLeft = left - intersectionLeft; // element's left relative to intersection

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0 && offsetLeft - offsets[0] <= intersectionWidth && offsetLeft + width + offsets[1] >= 0;
};

/**
 * Check if `component` is visible in document
 * @param  {node} component React component
 * @return {bool}
 */
var checkNormalVisible = function checkNormalVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);
  // const node = component.ref;

  // If this element is hidden by css rules somehow, it's definitely invisible
  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;

  var top = void 0;
  var elementHeight = void 0;

  try {
    var _node$getBoundingClie2 = node.getBoundingClientRect();

    top = _node$getBoundingClie2.top;
    elementHeight = _node$getBoundingClie2.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    elementHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
};

/**
 * Detect if element is visible in viewport, if so, set `visible` state to true.
 * If `once` prop is provided true, remove component as listener after checkVisible
 *
 * @param  {React} component   React component that respond to scroll and resize
 */
var checkVisible = function checkVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);
  // const node = component.ref;
  if (!(node instanceof HTMLElement)) {
    return;
  }

  var parent = (0, _scrollParent2.default)(node);
  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
  if (visible) {
    // Avoid extra render if previously is visible
    if (!component.visible) {
      if (component.props.once) {
        pending.push(component);
      }

      component.visible = true;
      component.forceUpdate();
    }
  } else if (!(component.props.once && component.visible)) {
    component.visible = false;
    if (component.props.unmountIfInvisible) {
      component.forceUpdate();
    }
  }
};

var purgePending = function purgePending() {
  pending.forEach(function (component) {
    var index = listeners.indexOf(component);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  });

  pending = [];
};

var lazyLoadHandler = function lazyLoadHandler() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    checkVisible(listener);
  }
  // Remove `once` component in listeners
  purgePending();
};

/**
 * Forces the component to display regardless of whether the element is visible in the viewport.
 */
var forceVisible = function forceVisible() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    listener.visible = true;
    listener.forceUpdate();
  }
  // Remove `once` component in listeners
  purgePending();
};

// Depending on component's props
var delayType = void 0;
var finalLazyLoadHandler = null;

var isString = function isString(string) {
  return typeof string === 'string';
};

var LazyLoad = function (_Component) {
  _inherits(LazyLoad, _Component);

  function LazyLoad(props) {
    _classCallCheck(this, LazyLoad);

    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

    _this.visible = false;
    // this.setRef = this.setRef.bind(this);
    return _this;
  }

  // setRef(element) {
  //   if (element) {
  //     this.ref = element;
  //   }
  // }

  _createClass(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // It's unlikely to change delay type on the fly, this is mainly
      // designed for tests
      var scrollport = window;
      var scrollContainer = this.props.scrollContainer;

      if (scrollContainer) {
        if (isString(scrollContainer)) {
          scrollport = scrollport.document.querySelector(scrollContainer);
        }
      }
      var needResetFinalLazyLoadHandler = this.props.debounce !== undefined && delayType === 'throttle' || delayType === 'debounce' && this.props.debounce === undefined;

      if (needResetFinalLazyLoadHandler) {
        (0, _event.off)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        finalLazyLoadHandler = null;
      }

      if (!finalLazyLoadHandler) {
        if (this.props.debounce !== undefined) {
          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
          delayType = 'debounce';
        } else if (this.props.throttle !== undefined) {
          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
          delayType = 'throttle';
        } else {
          finalLazyLoadHandler = lazyLoadHandler;
        }
      }

      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        // const parent = scrollParent(this.ref);
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
          if (listenerCount === 1) {
            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
          }
          parent.setAttribute(LISTEN_FLAG, listenerCount);
        }
      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
        var _props = this.props,
            scroll = _props.scroll,
            resize = _props.resize;


        if (scroll) {
          (0, _event.on)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        }

        if (resize) {
          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        }
      }

      listeners.push(this);
      checkVisible(this);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        // const parent = scrollParent(this.ref);
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
          if (listenerCount === 0) {
            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
            parent.removeAttribute(LISTEN_FLAG);
          } else {
            parent.setAttribute(LISTEN_FLAG, listenerCount);
          }
        }
      }

      var index = listeners.indexOf(this);
      if (index !== -1) {
        listeners.splice(index, 1);
      }

      if (listeners.length === 0 && typeof window !== 'undefined') {
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
      // <span ref={this.setRef} className="lazyload-custom-placeholder">
      //   {this.props.placeholder}
      // </span> :
      // <div ref={this.setRef} style={{ height: this.props.height }} className="lazyload-placeholder" />;
    }
  }]);

  return LazyLoad;
}(_react.Component);

LazyLoad.propTypes = {
  once: _propTypes2.default.bool,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
  overflow: _propTypes2.default.bool,
  resize: _propTypes2.default.bool,
  scroll: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  placeholder: _propTypes2.default.node,
  scrollContainer: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  unmountIfInvisible: _propTypes2.default.bool
};

LazyLoad.defaultProps = {
  once: false,
  offset: 0,
  overflow: false,
  resize: false,
  scroll: true,
  unmountIfInvisible: false
};

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var decorator = function decorator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function lazyload(WrappedComponent) {
    return function (_Component2) {
      _inherits(LazyLoadDecorated, _Component2);

      function LazyLoadDecorated() {
        _classCallCheck(this, LazyLoadDecorated);

        var _this2 = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));

        _this2.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
        return _this2;
      }

      _createClass(LazyLoadDecorated, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(
            LazyLoad,
            options,
            _react2.default.createElement(WrappedComponent, this.props)
          );
        }
      }]);

      return LazyLoadDecorated;
    }(_react.Component);
  };
};

exports.lazyload = decorator;
exports.default = LazyLoad;
exports.forceCheck = lazyLoadHandler;
exports.forceVisible = forceVisible;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(5);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _chainFunction = __webpack_require__(27);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _warning = __webpack_require__(28);

var _warning2 = _interopRequireDefault(_warning);

var _requestAnimationFrame = __webpack_require__(17);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _ReactCSSTransitionReplaceChild = __webpack_require__(112);

var _ReactCSSTransitionReplaceChild2 = _interopRequireDefault(_ReactCSSTransitionReplaceChild);

var _PropTypes = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? _defaults(subClass, superClass) : _defaults(subClass, superClass); }

var reactCSSTransitionReplaceChild = _react2.default.createFactory(_ReactCSSTransitionReplaceChild2.default);

var ReactCSSTransitionReplace = (_temp = _class = function (_React$Component) {
  _inherits(ReactCSSTransitionReplace, _React$Component);

  function ReactCSSTransitionReplace(props, context) {
    _classCallCheck(this, ReactCSSTransitionReplace);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleDoneAppearing = function (key) {
      delete _this.transitioningKeys[key];
      if (key !== _this.state.currentKey) {
        // This child was removed before it had fully appeared. Remove it.
        _this.performLeave(key);
      }
    };

    _this.performLeave = function (key) {
      _this.transitioningKeys[key] = true;
      _this.childRefs[key].componentWillLeave(_this.handleDoneLeaving.bind(_this, key));
      if (!_this.state.currentChild || !(0, _reactDom.findDOMNode)(_this.childRefs[_this.state.currentKey])) {
        // The enter transition dominates, but if there is no entering
        // component or it renders null the height is set to zero.
        _this.enqueueHeightTransition();
      }
    };

    _this.performHeightTransition = function () {
      if (!_this.unmounted) {
        var state = _this.state;

        var currentChildNode = state.currentChild ? (0, _reactDom.findDOMNode)(_this.childRefs[state.currentKey]) : null;
        _this.setState({
          height: currentChildNode ? currentChildNode.offsetHeight : 0,
          width: _this.props.changeWidth ? currentChildNode ? currentChildNode.offsetWidth : 0 : null
        });
      }
      _this.rafHandle = null;
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      currentKey: '1',
      currentChild: _this.props.children ? _react2.default.Children.only(_this.props.children) : undefined,
      prevChildren: {},
      height: null,
      width: null
    };
    return _this;
  }

  ReactCSSTransitionReplace.prototype.componentWillMount = function componentWillMount() {
    this.shouldEnterCurrent = false;
    this.keysToLeave = [];
    this.transitioningKeys = {};
  };

  ReactCSSTransitionReplace.prototype.componentDidMount = function componentDidMount() {
    if (this.props.transitionAppear && this.state.currentChild) {
      this.performAppear(this.state.currentKey);
    }
  };

  ReactCSSTransitionReplace.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;
  };

  ReactCSSTransitionReplace.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChild = nextProps.children ? _react2.default.Children.only(nextProps.children) : undefined;
    var currentChild = this.state.currentChild;


    if (currentChild && nextChild && nextChild.key === currentChild.key && !this.state.nextChild) {
      // This is the same child, but receiving new props means the child itself has re-rendered
      return this.setState({
        currentChild: nextChild
      });
    }

    var _state = this.state,
        currentKey = _state.currentKey,
        prevChildren = _state.prevChildren;


    var nextState = {
      currentKey: String(Number(currentKey) + 1),
      currentChild: nextChild,
      height: 0,
      width: this.props.changeWidth ? 0 : null
    };

    if (nextChild) {
      this.shouldEnterCurrent = true;
    }

    if (currentChild) {
      var _extends2;

      var currentChildNode = (0, _reactDom.findDOMNode)(this.childRefs[currentKey]);
      nextState.height = currentChildNode ? currentChildNode.offsetHeight : 0;
      nextState.width = this.props.changeWidth ? currentChildNode ? currentChildNode.offsetWidth : 0 : null;
      nextState.prevChildren = _extends({}, prevChildren, (_extends2 = {}, _extends2[currentKey] = currentChild, _extends2));
      if (!this.transitioningKeys[currentKey]) {
        this.keysToLeave.push(currentKey);
      }
    }

    this.setState(nextState);
  };

  ReactCSSTransitionReplace.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.shouldEnterCurrent) {
      this.shouldEnterCurrent = false;
      // If the current child renders null there is nothing to enter
      if ((0, _reactDom.findDOMNode)(this.childRefs[this.state.currentKey])) {
        this.performEnter(this.state.currentKey);
      }
    }

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(this.performLeave);
  };

  ReactCSSTransitionReplace.prototype.performAppear = function performAppear(key) {
    this.transitioningKeys[key] = true;
    this.childRefs[key].componentWillAppear(this.handleDoneAppearing.bind(this, key));
  };

  ReactCSSTransitionReplace.prototype.performEnter = function performEnter(key) {
    this.transitioningKeys[key] = true;
    this.childRefs[key].componentWillEnter(this.handleDoneEntering.bind(this, key));
    this.enqueueHeightTransition();
  };

  ReactCSSTransitionReplace.prototype.handleDoneEntering = function handleDoneEntering(key) {
    delete this.transitioningKeys[key];
    if (key === this.state.currentKey) {
      // The current child has finished entering so the height transition is also cleared.
      this.setState({ height: null });
    } else {
      // This child was removed before it had fully appeared. Remove it.
      this.performLeave(key);
    }
  };

  ReactCSSTransitionReplace.prototype.handleDoneLeaving = function handleDoneLeaving(key) {
    delete this.transitioningKeys[key];

    var nextState = { prevChildren: _extends({}, this.state.prevChildren) };
    delete nextState.prevChildren[key];
    delete this.childRefs[key];

    if (!this.state.currentChild || !(0, _reactDom.findDOMNode)(this.childRefs[this.state.currentKey])) {
      nextState.height = null;
    }

    this.setState(nextState);
  };

  ReactCSSTransitionReplace.prototype.enqueueHeightTransition = function enqueueHeightTransition() {
    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(this.performHeightTransition);
    }
  };

  ReactCSSTransitionReplace.prototype.wrapChild = function wrapChild(child, moreProps) {
    var transitionName = this.props.transitionName;

    if ((typeof transitionName === 'undefined' ? 'undefined' : _typeof(transitionName)) === 'object' && transitionName !== null) {
      transitionName = _extends({}, transitionName);
      delete transitionName.height;
    }

    // We need to provide this childFactory so that
    // ReactCSSTransitionReplaceChild can receive updates to name,
    // enter, and leave while it is leaving.
    return reactCSSTransitionReplaceChild(_extends({
      name: transitionName,
      appear: this.props.transitionAppear,
      enter: this.props.transitionEnter,
      leave: this.props.transitionLeave,
      appearTimeout: this.props.transitionAppearTimeout,
      enterTimeout: this.props.transitionEnterTimeout,
      leaveTimeout: this.props.transitionLeaveTimeout
    }, moreProps), child);
  };

  ReactCSSTransitionReplace.prototype.storeChildRef = function storeChildRef(child, key) {
    var _this2 = this;

    var isCallbackRef = typeof child.ref !== 'string';
    (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of ReactCSSTransitionReplace and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute');

    return (0, _chainFunction2.default)(isCallbackRef ? child.ref : null, function (r) {
      _this2.childRefs[key] = r;
    });
  };

  ReactCSSTransitionReplace.prototype.render = function render() {
    var _this3 = this;

    var _state2 = this.state,
        currentKey = _state2.currentKey,
        currentChild = _state2.currentChild,
        prevChildren = _state2.prevChildren,
        height = _state2.height,
        width = _state2.width;

    var childrenToRender = [];

    var _props = this.props,
        overflowHidden = _props.overflowHidden,
        transitionName = _props.transitionName,
        component = _props.component,
        childComponent = _props.childComponent,
        notifyLeaving = _props.notifyLeaving,
        transitionAppear = _props.transitionAppear,
        transitionEnter = _props.transitionEnter,
        transitionLeave = _props.transitionLeave,
        changeWidth = _props.changeWidth,
        transitionAppearTimeout = _props.transitionAppearTimeout,
        transitionEnterTimeout = _props.transitionEnterTimeout,
        transitionLeaveTimeout = _props.transitionLeaveTimeout,
        containerProps = _objectWithoutProperties(_props, ['overflowHidden', 'transitionName', 'component', 'childComponent', 'notifyLeaving', 'transitionAppear', 'transitionEnter', 'transitionLeave', 'changeWidth', 'transitionAppearTimeout', 'transitionEnterTimeout', 'transitionLeaveTimeout']);

    var transitioning = this.shouldEnterCurrent || this.keysToLeave.length || Object.keys(this.transitioningKeys).length;

    containerProps.style = _extends({}, containerProps.style);

    if (transitioning) {
      containerProps.style.position = 'relative';
      if (overflowHidden) {
        containerProps.style.overflow = 'hidden';
      }
    }

    if (height !== null) {
      var heightClassName = typeof transitionName === 'string' ? transitionName + '-height' : transitionName && transitionName.height || '';

      containerProps.className = String(containerProps.className || '') + ' ' + String(heightClassName);
      containerProps.style.height = height;
    }

    if (width !== null) {
      containerProps.style.width = width;
    }

    var positionAbsolute = {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      // In Chrome a selection on a child due to multiple clicks often transfers to the final child after
      // the transitions completes. This prevents selection of the child without other side-effects.
      userSelect: 'none'
    };

    Object.keys(prevChildren).forEach(function (key) {
      var child = prevChildren[key];
      childrenToRender.push(_react2.default.createElement(childComponent, { key: key, style: positionAbsolute }, _this3.wrapChild(notifyLeaving && typeof child.type !== 'string' ? _react2.default.cloneElement(child, { isLeaving: true }) : child, { ref: _this3.storeChildRef(child, key) })));
    });

    if (currentChild) {
      childrenToRender.push(_react2.default.createElement(childComponent, {
        key: currentKey,
        // While there are leaving children positioning must always be specified to keep the current
        // child on top; the current child can switch to relative positioning after entering though.
        style: this.transitioningKeys[currentKey] ? positionAbsolute : transitioning ? { position: 'relative' } : null
      }, this.wrapChild(currentChild, { ref: this.storeChildRef(currentChild, currentKey) })));
    }

    return _react2.default.createElement(component, containerProps, childrenToRender);
  };

  return ReactCSSTransitionReplace;
}(_react2.default.Component), _class.displayName = 'ReactCSSTransitionReplace', _class.defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true,
  overflowHidden: true,
  changeWidth: false,
  notifyLeaving: false,
  component: 'div',
  childComponent: 'span'
}, _temp);
exports.default = ReactCSSTransitionReplace;
module.exports = exports['default'];

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(16)))

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _root_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var _stubFalse_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || _stubFalse_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(20)(module)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(18);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(29));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */


var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 18 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;

var _exenv = __webpack_require__(158);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if (!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var isBuffer = __webpack_require__(152)

module.exports = flatten
flatten.flatten = flatten
flatten.unflatten = unflatten

function flatten (target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var maxDepth = opts.maxDepth
  var output = {}

  function step (object, prev, currentDepth) {
    currentDepth = currentDepth || 1
    Object.keys(object).forEach(function (key) {
      var value = object[key]
      var isarray = opts.safe && Array.isArray(value)
      var type = Object.prototype.toString.call(value)
      var isbuffer = isBuffer(value)
      var isobject = (
        type === '[object Object]' ||
        type === '[object Array]'
      )

      var newKey = prev
        ? prev + delimiter + key
        : key

      if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
        (!opts.maxDepth || currentDepth < maxDepth)) {
        return step(value, newKey, currentDepth + 1)
      }

      output[newKey] = value
    })
  }

  step(target)

  return output
}

function unflatten (target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var overwrite = opts.overwrite || false
  var result = {}

  var isbuffer = isBuffer(target)
  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
    return target
  }

  // safely ensure that the key is
  // an integer.
  function getkey (key) {
    var parsedKey = Number(key)

    return (
      isNaN(parsedKey) ||
      key.indexOf('.') !== -1 ||
      opts.object
    ) ? key
      : parsedKey
  }

  var sortedKeys = Object.keys(target).sort(function (keyA, keyB) {
    return keyA.length - keyB.length
  })

  sortedKeys.forEach(function (key) {
    var split = key.split(delimiter)
    var key1 = getkey(split.shift())
    var key2 = getkey(split[0])
    var recipient = result

    while (key2 !== undefined) {
      var type = Object.prototype.toString.call(recipient[key1])
      var isobject = (
        type === '[object Object]' ||
        type === '[object Array]'
      )

      // do not write over falsey, non-undefined values if overwrite is false
      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
        return
      }

      if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
        recipient[key1] = (
          typeof key2 === 'number' &&
          !opts.object ? [] : {}
        )
      }

      recipient = recipient[key1]
      if (split.length > 0) {
        key1 = getkey(split.shift())
        key2 = getkey(split[0])
      }
    }

    // unflatten again for 'messy objects'
    recipient[key1] = unflatten(target[key], opts)
  })

  return result
}


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(153);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(9);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(this && this[key] || key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ }),
/* 27 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (true) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(18);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(113));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(18);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(29));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string,
  height: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string,
  height: _propTypes2.default.string,
  heightActive: _propTypes2.default.string
})]);

/***/ }),
/* 34 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var DISPLAY_NONE = "none";
var DISPLAY_CONTENTS = "contents";

var tabbableNode = /input|select|textarea|button|object|iframe/;

function isNotOverflowing(element, style) {
  return style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0;
}

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  try {
    // Otherwise we need to check some styles
    var style = window.getComputedStyle(element);
    var displayValue = style.getPropertyValue("display");
    return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
  } catch (exception) {
    // eslint-disable-next-line no-console
    console.warn("Failed to inspect element style");
    return false;
  }
}

function visible(element) {
  var parentElement = element;
  var rootNode = element.getRootNode && element.getRootNode();
  while (parentElement) {
    if (parentElement === document.body) break;

    // if we are not hidden yet, skip to checking outside the Web Component
    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;

    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
  }, []);
  return descendants.filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = resetState;
exports.log = log;
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;

var _warning = __webpack_require__(157);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}

/* istanbul ignore next */
function log() {
  if (true) {
    var check = globalElement || {};
    console.log("ariaAppHider ----------");
    console.log(check.nodeName, check.className, check.id);
    console.log("end ariaAppHider ----------");
  }
}
/* eslint-enable no-console */

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.log = log;
exports.resetState = resetState;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (true) {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Cannot register modal instance that's already open");
      }
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (true) {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
      }
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

/* eslint-disable no-console */
/* istanbul ignore next */
function log() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}

/* istanbul ignore next */
function resetState() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */

exports.default = portalOpenInstances;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
  Keypress version 2.1.5 (c) 2018 David Mauro.
  Licensed under the Apache License, Version 2.0
  http://www.apache.org/licenses/LICENSE-2.0
*/
(function(){var o,u,x,y,z,r,v,A,E,B,F,G,q,s,p,k,t,C,H,D={}.hasOwnProperty,j=[].indexOf||function(a){for(var c=0,b=this.length;c<b;c++)if(c in this&&this[c]===a)return c;return-1};r={is_unordered:!1,is_counting:!1,is_exclusive:!1,is_solitary:!1,prevent_default:!1,prevent_repeat:!1,normalize_caps_lock:!1};C="meta alt option ctrl shift cmd".split(" ");k="ctrl";o={debug:!1};var w=function(a){var c,b;for(c in a)D.call(a,c)&&(b=a[c],!1!==b&&(this[c]=b));this.keys=this.keys||[];this.count=this.count||0};
w.prototype.allows_key_repeat=function(){return!this.prevent_repeat&&"function"===typeof this.on_keydown};w.prototype.reset=function(){this.count=0;return this.keyup_fired=null};var g=function(a,c){var b,d;"undefined"!==typeof jQuery&&null!==jQuery&&a instanceof jQuery&&(1!==a.length&&p("Warning: your jQuery selector should have exactly one object."),a=a[0]);this.should_force_event_defaults=this.should_suppress_event_defaults=!1;this.sequence_delay=800;this._registered_combos=[];this._keys_down=[];
this._active_combos=[];this._sequence=[];this._sequence_timer=null;this._prevent_capture=!1;this._defaults=c||{};for(b in r)D.call(r,b)&&(d=r[b],this._defaults[b]=this._defaults[b]||d);this.element=a||document.body;b=function(a,b,c){a.addEventListener?a.addEventListener(b,c):a.attachEvent&&a.attachEvent("on"+b,c);return c};var e=this;this.keydown_event=b(this.element,"keydown",function(a){a=a||window.event;e._receive_input(a,true);return e._bug_catcher(a)});var f=this;this.keyup_event=b(this.element,
"keyup",function(a){a=a||window.event;return f._receive_input(a,false)});var h=this;this.blur_event=b(window,"blur",function(){var a,b,c,d;d=h._keys_down;b=0;for(c=d.length;b<c;b++){a=d[b];h._key_up(a,{})}return h._keys_down=[]})};g.prototype.destroy=function(){var a;a=function(a,b,d){if(null!=a.removeEventListener)return a.removeEventListener(b,d);if(null!=a.removeEvent)return a.removeEvent("on"+b,d)};a(this.element,"keydown",this.keydown_event);a(this.element,"keyup",this.keyup_event);return a(window,
"blur",this.blur_event)};g.prototype._bug_catcher=function(a){var c,b;if("cmd"===k&&0<=j.call(this._keys_down,"cmd")&&"cmd"!==(c=y(null!=(b=a.keyCode)?b:a.key))&&"shift"!==c&&"alt"!==c&&"caps"!==c&&"tab"!==c)return this._receive_input(a,!1)};g.prototype._cmd_bug_check=function(a){return"cmd"===k&&0<=j.call(this._keys_down,"cmd")&&0>j.call(a,"cmd")?!1:!0};g.prototype._prevent_default=function(a,c){if((c||this.should_suppress_event_defaults)&&!this.should_force_event_defaults)if(a.preventDefault?a.preventDefault():
a.returnValue=!1,a.stopPropagation)return a.stopPropagation()};g.prototype._get_active_combos=function(a){var c,b;c=[];b=v(this._keys_down,function(b){return b!==a});b.push(a);this._match_combo_arrays(b,function(a){return function(b){if(a._cmd_bug_check(b.keys))return c.push(b)}}(this));this._fuzzy_match_combo_arrays(b,function(a){return function(b){if(!(0<=j.call(c,b))&&!b.is_solitary&&a._cmd_bug_check(b.keys))return c.push(b)}}(this));return c};g.prototype._get_potential_combos=function(a){var c,
b,d,e,f;b=[];f=this._registered_combos;d=0;for(e=f.length;d<e;d++)c=f[d],c.is_sequence||0<=j.call(c.keys,a)&&this._cmd_bug_check(c.keys)&&b.push(c);return b};g.prototype._add_to_active_combos=function(a){var c,b,d,e,f,h,i,g,n,l,m;h=!1;f=!0;d=!1;if(0<=j.call(this._active_combos,a))return!0;if(this._active_combos.length){e=i=0;for(l=this._active_combos.length;0<=l?i<l:i>l;e=0<=l?++i:--i)if((c=this._active_combos[e])&&c.is_exclusive&&a.is_exclusive){c=c.keys;if(!h){g=0;for(n=c.length;g<n;g++)if(b=c[g],
h=!0,0>j.call(a.keys,b)){h=!1;break}}if(f&&!h){m=a.keys;g=0;for(n=m.length;g<n;g++)if(b=m[g],f=!1,0>j.call(c,b)){f=!0;break}}h&&(d?(c=this._active_combos.splice(e,1)[0],null!=c&&c.reset()):(c=this._active_combos.splice(e,1,a)[0],null!=c&&c.reset(),d=!0),f=!1)}}f&&this._active_combos.unshift(a);return h||f};g.prototype._remove_from_active_combos=function(a){var c,b,d,e;b=d=0;for(e=this._active_combos.length;0<=e?d<e:d>e;b=0<=e?++d:--d)if(c=this._active_combos[b],c===a){a=this._active_combos.splice(b,
1)[0];a.reset();break}};g.prototype._get_possible_sequences=function(){var a,c,b,d,e,f,h,i,g,n,l,m;d=[];n=this._registered_combos;f=0;for(g=n.length;f<g;f++){a=n[f];c=h=1;for(l=this._sequence.length;1<=l?h<=l:h>=l;c=1<=l?++h:--h)if(e=this._sequence.slice(-c),a.is_sequence){if(0>j.call(a.keys,"shift")&&(e=v(e,function(a){return"shift"!==a}),!e.length))continue;c=i=0;for(m=e.length;0<=m?i<m:i>m;c=0<=m?++i:--i)if(a.keys[c]===e[c])b=!0;else{b=!1;break}b&&d.push(a)}}return d};g.prototype._add_key_to_sequence=
function(a,c){var b,d,e,f;this._sequence.push(a);d=this._get_possible_sequences();if(d.length){e=0;for(f=d.length;e<f;e++)b=d[e],this._prevent_default(c,b.prevent_default);this._sequence_timer&&clearTimeout(this._sequence_timer);if(-1<this.sequence_delay){var h=this;this._sequence_timer=setTimeout(function(){return h._sequence=[]},this.sequence_delay)}}else this._sequence=[]};g.prototype._get_sequence=function(a){var c,b,d,e,f,h,i,g,n,l,m,k;l=this._registered_combos;h=0;for(n=l.length;h<n;h++)if(c=
l[h],c.is_sequence){b=i=1;for(m=this._sequence.length;1<=m?i<=m:i>=m;b=1<=m?++i:--i)if(f=v(this._sequence,function(a){return 0<=j.call(c.keys,"shift")?!0:"shift"!==a}).slice(-b),c.keys.length===f.length){b=g=0;for(k=f.length;0<=k?g<k:g>k;b=0<=k?++g:--g)if(e=f[b],!(0>j.call(c.keys,"shift")&&"shift"===e)&&!("shift"===a&&0>j.call(c.keys,"shift")))if(c.keys[b]===e)d=!0;else{d=!1;break}}if(d)return c.is_exclusive&&(this._sequence=[]),c}return!1};g.prototype._receive_input=function(a,c){var b,d;if(this._prevent_capture)this._keys_down.length&&
(this._keys_down=[]);else if(b=y(null!=(d=a.keyCode)?d:a.key),(c||this._keys_down.length||!("alt"===b||b===k))&&b)return c?this._key_down(b,a):this._key_up(b,a)};g.prototype._fire=function(a,c,b,d){"function"===typeof c["on_"+a]&&this._prevent_default(b,!0!==c["on_"+a].call(c["this"],b,c.count,d));"release"===a&&(c.count=0);if("keyup"===a)return c.keyup_fired=!0};g.prototype._match_combo_arrays=function(a,c){var b,d,e,f,h;h=this._registered_combos;e=0;for(f=h.length;e<f;e++)d=h[e],b=a.slice(0),d.normalize_caps_lock&&
0<=j.call(b,"caps")&&b.splice(b.indexOf("caps"),1),(!d.is_unordered&&x(b,d.keys)||d.is_unordered&&u(b,d.keys))&&c(d)};g.prototype._fuzzy_match_combo_arrays=function(a,c){var b,d,e,f;f=this._registered_combos;d=0;for(e=f.length;d<e;d++)b=f[d],(!b.is_unordered&&B(b.keys,a)||b.is_unordered&&E(b.keys,a))&&c(b)};g.prototype._keys_remain=function(a){var c,b,d,e;e=a.keys;b=0;for(d=e.length;b<d;b++)if(a=e[b],0<=j.call(this._keys_down,a)){c=!0;break}return c};g.prototype._key_down=function(a,c){var b,d,e,
f,h;(b=z(a,c))&&(a=b);this._add_key_to_sequence(a,c);(b=this._get_sequence(a))&&this._fire("keydown",b,c);for(e in t)b=t[e],c[b]&&(e===a||0<=j.call(this._keys_down,e)||this._keys_down.push(e));for(e in t)if(b=t[e],e!==a&&0<=j.call(this._keys_down,e)&&!c[b]&&!("cmd"===e&&"cmd"!==k)){b=d=0;for(f=this._keys_down.length;0<=f?d<f:d>f;b=0<=f?++d:--d)this._keys_down[b]===e&&this._keys_down.splice(b,1)}d=this._get_active_combos(a);e=this._get_potential_combos(a);f=0;for(h=d.length;f<h;f++)b=d[f],this._handle_combo_down(b,
e,a,c);if(e.length){d=0;for(f=e.length;d<f;d++)b=e[d],this._prevent_default(c,b.prevent_default)}0>j.call(this._keys_down,a)&&this._keys_down.push(a)};g.prototype._handle_combo_down=function(a,c,b,d){var e,f,h,g,k;if(0>j.call(a.keys,b))return!1;this._prevent_default(d,a&&a.prevent_default);e=!1;if(0<=j.call(this._keys_down,b)&&(e=!0,!a.allows_key_repeat()))return!1;h=this._add_to_active_combos(a,b);b=a.keyup_fired=!1;if(a.is_exclusive){g=0;for(k=c.length;g<k;g++)if(f=c[g],f.is_exclusive&&f.keys.length>
a.keys.length){b=!0;break}}if(!b&&(a.is_counting&&"function"===typeof a.on_keydown&&(a.count+=1),h))return this._fire("keydown",a,d,e)};g.prototype._key_up=function(a,c){var b,d,e,f,h,g;b=a;(e=z(a,c))&&(a=e);e=s[b];c.shiftKey?e&&0<=j.call(this._keys_down,e)||(a=b):b&&0<=j.call(this._keys_down,b)||(a=e);(f=this._get_sequence(a))&&this._fire("keyup",f,c);if(0>j.call(this._keys_down,a))return!1;f=h=0;for(g=this._keys_down.length;0<=g?h<g:h>g;f=0<=g?++h:--h)if((d=this._keys_down[f])===a||d===e||d===b){this._keys_down.splice(f,
1);break}d=this._active_combos.length;e=[];g=this._active_combos;f=0;for(h=g.length;f<h;f++)b=g[f],0<=j.call(b.keys,a)&&e.push(b);f=0;for(h=e.length;f<h;f++)b=e[f],this._handle_combo_up(b,c,a);if(1<d){h=this._active_combos;d=0;for(f=h.length;d<f;d++)b=h[d],void 0===b||0<=j.call(e,b)||this._keys_remain(b)||this._remove_from_active_combos(b)}};g.prototype._handle_combo_up=function(a,c,b){var d,e;this._prevent_default(c,a&&a.prevent_default);e=this._keys_remain(a);if(!a.keyup_fired&&(d=this._keys_down.slice(),
d.push(b),!a.is_solitary||u(d,a.keys)))this._fire("keyup",a,c),a.is_counting&&("function"===typeof a.on_keyup&&"function"!==typeof a.on_keydown)&&(a.count+=1);e||(this._fire("release",a,c),this._remove_from_active_combos(a))};g.prototype.simple_combo=function(a,c){return this.register_combo({keys:a,on_keydown:c})};g.prototype.counting_combo=function(a,c){return this.register_combo({keys:a,is_counting:!0,is_unordered:!1,on_keydown:c})};g.prototype.sequence_combo=function(a,c){return this.register_combo({keys:a,
on_keydown:c,is_sequence:!0,is_exclusive:!0})};g.prototype.register_combo=function(a){var c,b,d;"string"===typeof a.keys&&(a.keys=a.keys.split(" "));d=this._defaults;for(c in d)D.call(d,c)&&(b=d[c],void 0===a[c]&&(a[c]=b));a=new w(a);if(H(a))return this._registered_combos.push(a),a};g.prototype.register_many=function(a){var c,b,d,e;e=[];b=0;for(d=a.length;b<d;b++)c=a[b],e.push(this.register_combo(c));return e};g.prototype.unregister_combo=function(a){var c,b,d,e,f,g;if(!a)return!1;var i=this;b=function(a){var b,
c,d,e;e=[];b=c=0;for(d=i._registered_combos.length;0<=d?c<d:c>d;b=0<=d?++c:--c)if(a===i._registered_combos[b]){i._registered_combos.splice(b,1);break}else e.push(void 0);return e};if(a instanceof w)return b(a);if("string"===typeof a){a=a.split(" ");c=d=0;for(e=a.length;0<=e?d<e:d>e;c=0<=e?++d:--d)"meta"===a[c]&&(a[c]=k)}f=this._registered_combos;g=[];d=0;for(e=f.length;d<e;d++)c=f[d],null!=c&&(c.is_unordered&&u(a,c.keys)||!c.is_unordered&&x(a,c.keys)?g.push(b(c)):g.push(void 0));return g};g.prototype.unregister_many=
function(a){var c,b,d,e;e=[];b=0;for(d=a.length;b<d;b++)c=a[b],e.push(this.unregister_combo(c));return e};g.prototype.get_registered_combos=function(){return this._registered_combos};g.prototype.reset=function(){return this._registered_combos=[]};g.prototype.listen=function(){return this._prevent_capture=!1};g.prototype.stop_listening=function(){return this._prevent_capture=!0};g.prototype.get_meta_key=function(){return k};o.Listener=g;y=function(a){return q[a]};v=function(a,c){var b;if(a.filter)return a.filter(c);
var d,e,f;f=[];d=0;for(e=a.length;d<e;d++)b=a[d],c(b)&&f.push(b);return f};u=function(a,c){var b,d,e;if(a.length!==c.length)return!1;d=0;for(e=a.length;d<e;d++)if(b=a[d],!(0<=j.call(c,b)))return!1;return!0};x=function(a,c){var b,d,e;if(a.length!==c.length)return!1;b=d=0;for(e=a.length;0<=e?d<e:d>e;b=0<=e?++d:--d)if(a[b]!==c[b])return!1;return!0};E=function(a,c){var b,d,e;d=0;for(e=a.length;d<e;d++)if(b=a[d],0>j.call(c,b))return!1;return!0};A=Array.prototype.indexOf||function(a,c){var b,d,e;b=d=0;
for(e=a.length;0<=e?d<=e:d>=e;b=0<=e?++d:--d)if(a[b]===c)return b;return-1};B=function(a,c){var b,d,e,f;e=d=0;for(f=a.length;e<f;e++)if(b=a[e],b=A.call(c,b),b>=d)d=b;else return!1;return!0};p=function(){if(o.debug)return console.log.apply(console,arguments)};F=function(a){var c,b,d;c=!1;for(d in q)if(b=q[d],a===b){c=!0;break}if(!c)for(d in s)if(b=s[d],a===b){c=!0;break}return c};H=function(a){var c,b,d,e,f,g,i;f=!0;a.keys.length||p("You're trying to bind a combo with no keys:",a);b=g=0;for(i=a.keys.length;0<=
i?g<i:g>i;b=0<=i?++g:--g)d=a.keys[b],(c=G[d])&&(d=a.keys[b]=c),"meta"===d&&a.keys.splice(b,1,k),"cmd"===d&&p('Warning: use the "meta" key rather than "cmd" for Windows compatibility');i=a.keys;c=0;for(g=i.length;c<g;c++)d=i[c],F(d)||(p('Do not recognize the key "'+d+'"'),f=!1);if(0<=j.call(a.keys,"meta")||0<=j.call(a.keys,"cmd")){c=a.keys.slice();g=0;for(i=C.length;g<i;g++)d=C[g],-1<(b=A.call(c,d))&&c.splice(b,1);1<c.length&&(p("META and CMD key combos cannot have more than 1 non-modifier keys",a,
c),f=!1)}for(e in a)"undefined"===r[e]&&p("The property "+e+" is not a valid combo property. Your combo has still been registered.");return f};z=function(a,c){var b;if(!c.shiftKey)return!1;b=s[a];return null!=b?b:!1};t={cmd:"metaKey",ctrl:"ctrlKey",shift:"shiftKey",alt:"altKey"};G={escape:"esc",control:"ctrl",command:"cmd","break":"pause",windows:"cmd",option:"alt",caps_lock:"caps",apostrophe:"'",semicolon:";",tilde:"~",accent:"`",scroll_lock:"scroll",num_lock:"num"};s={"/":"?",".":">",",":"<","'":'"',
";":":","[":"{","]":"}","\\":"|","`":"~","=":"+","-":"_",1:"!",2:"@",3:"#",4:"$",5:"%",6:"^",7:"&",8:"*",9:"(","0":")"};q={"0":"\\",8:"backspace",9:"tab",12:"num",13:"enter",16:"shift",17:"ctrl",18:"alt",19:"pause",20:"caps",27:"esc",32:"space",33:"pageup",34:"pagedown",35:"end",36:"home",37:"left",38:"up",39:"right",40:"down",44:"print",45:"insert",46:"delete",48:"0",49:"1",50:"2",51:"3",52:"4",53:"5",54:"6",55:"7",56:"8",57:"9",65:"a",66:"b",67:"c",68:"d",69:"e",70:"f",71:"g",72:"h",73:"i",74:"j",
75:"k",76:"l",77:"m",78:"n",79:"o",80:"p",81:"q",82:"r",83:"s",84:"t",85:"u",86:"v",87:"w",88:"x",89:"y",90:"z",91:"cmd",92:"cmd",93:"cmd",96:"num_0",97:"num_1",98:"num_2",99:"num_3",100:"num_4",101:"num_5",102:"num_6",103:"num_7",104:"num_8",105:"num_9",106:"num_multiply",107:"num_add",108:"num_enter",109:"num_subtract",110:"num_decimal",111:"num_divide",112:"f1",113:"f2",114:"f3",115:"f4",116:"f5",117:"f6",118:"f7",119:"f8",120:"f9",121:"f10",122:"f11",123:"f12",124:"print",144:"num",145:"scroll",
186:";",187:"=",188:",",189:"-",190:".",191:"/",192:"`",219:"[",220:"\\",221:"]",222:"'",223:"`",224:"cmd",225:"alt",57392:"ctrl",63289:"num",59:";",61:"=",173:"-"};o._keycode_dictionary=q;o._is_array_in_array_sorted=B;-1!==navigator.userAgent.indexOf("Mac OS X")&&(k="cmd");-1!==navigator.userAgent.indexOf("Opera")&&(q["17"]="cmd"); true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function(){return o}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):undefined}).call(this);


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

(function(a,b){ true?module.exports=b(__webpack_require__(124),__webpack_require__(126),__webpack_require__(127),__webpack_require__(128),__webpack_require__(130),__webpack_require__(34),__webpack_require__(131),__webpack_require__(133),__webpack_require__(1),__webpack_require__(134)):undefined})(this,function(a,b,c,d,e,f,g,h,i,j){'use strict';function k(a,b){var c=Object.keys(a);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(a);b&&(d=d.filter(function(b){return Object.getOwnPropertyDescriptor(a,b).enumerable})),c.push.apply(c,d)}return c}function l(a){for(var b,c=1;c<arguments.length;c++)b=null==arguments[c]?{}:arguments[c],c%2?k(Object(b),!0).forEach(function(c){h(a,c,b[c])}):Object.getOwnPropertyDescriptors?Object.defineProperties(a,Object.getOwnPropertyDescriptors(b)):k(Object(b)).forEach(function(c){Object.defineProperty(a,c,Object.getOwnPropertyDescriptor(b,c))});return a}a=a&&a.hasOwnProperty("default")?a["default"]:a,b=b&&b.hasOwnProperty("default")?b["default"]:b,c=c&&c.hasOwnProperty("default")?c["default"]:c,d=d&&d.hasOwnProperty("default")?d["default"]:d,e=e&&e.hasOwnProperty("default")?e["default"]:e,f=f&&f.hasOwnProperty("default")?f["default"]:f,g=g&&g.hasOwnProperty("default")?g["default"]:g,h=h&&h.hasOwnProperty("default")?h["default"]:h;var m="default"in i?i["default"]:i,n={},o={loader:j.node,unloader:j.node,decode:j.bool,crossorigin:j.string,src:j.oneOfType([j.string,j.array]),container:j.func,loaderContainer:j.func,unloaderContainer:j.func},p=function(i){function j(a){var c;b(this,j),c=d(this,e(j).call(this,a)),h(f(c),"srcToArray",function(a){return(Array.isArray(a)?a:[a]).filter(function(a){return a})}),h(f(c),"onLoad",function(){n[c.sourceList[c.state.currentIndex]]=!0,c.i&&c.setState({isLoaded:!0})}),h(f(c),"onError",function(){if(n[c.sourceList[c.state.currentIndex]]=!1,!c.i)return!1;for(var a,b=c.state.currentIndex+1;b<c.sourceList.length;b++){if(a=c.sourceList[b],!(a in n)){c.setState({currentIndex:b});break}if(!0===n[a])return c.setState({currentIndex:b,isLoading:!1,isLoaded:!0}),!0;!1===n[a]}return b===c.sourceList.length?c.setState({isLoading:!1}):void c.loadImg()}),h(f(c),"loadImg",function(){c.i=new Image,c.i.src=c.sourceList[c.state.currentIndex],c.props.crossorigin&&(c.i.crossOrigin=c.props.crossorigin),c.props.decode&&c.i.decode?c.i.decode().then(c.onLoad)["catch"](c.onError):(c.i.onload=c.onLoad,c.i.onerror=c.onError)}),h(f(c),"unloadImg",function(){c.i.onerror=null,c.i.onload=null,c.i.src="";try{delete c.i.src}catch(a){}delete c.i}),c.loaderContainer=a.loaderContainer||a.container,c.unloaderContainer=a.unloaderContainer||a.container,c.sourceList=c.srcToArray(c.props.src);for(var g=0;g<c.sourceList.length&&!!(c.sourceList[g]in n);g++)if(!0===n[c.sourceList[g]])return c.state={currentIndex:g,isLoading:!1,isLoaded:!0},d(c);return c.state=c.sourceList.length?{currentIndex:0,isLoading:!0,isLoaded:!1}:{isLoading:!1,isLoaded:!1},c}return g(j,i),c(j,[{key:"componentDidMount",value:function(){this.state.isLoading&&this.loadImg()}},{key:"componentWillUnmount",value:function(){this.i&&this.unloadImg()}},{key:"UNSAFE_componentWillReceiveProps",value:function(a){var b=this;this.loaderContainer=a.loaderContainer||a.container,this.unloaderContainer=a.unloaderContainer||a.container;var c=this.srcToArray(a.src),d=c.filter(function(a){return-1===b.sourceList.indexOf(a)}),e=this.sourceList.filter(function(a){return-1===c.indexOf(a)});if(d.length||e.length){if(this.sourceList=c,!c.length)return this.setState({isLoading:!1,isLoaded:!1});this.setState({currentIndex:0,isLoading:!0,isLoaded:!1},this.loadImg)}}},{key:"render",value:function(){var b=this.props,c=b.container,d=b.loader,e=b.unloader,f=b.src,g=b.decode,h=b.loaderContainer,i=b.unloaderContainer,j=b.mockImage,k=a(b,["container","loader","unloader","src","decode","loaderContainer","unloaderContainer","mockImage"]);if(this.state.isLoaded){var n=l({},{src:this.sourceList[this.state.currentIndex]},{},k);return c(m.createElement("img",n))}return!this.state.isLoaded&&this.state.isLoading?d?this.loaderContainer(d):null:this.state.isLoaded||this.state.isLoading?void 0:e?this.unloaderContainer(e):null}}]),j}(i.Component);return h(p,"defaultProps",{loader:!1,unloader:!1,decode:!0,src:[],container:function(a){return a}}),p.propTypes={},p});
//# sourceMappingURL=index.js.map


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  // polyfill
  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if (
      'scrollBehavior' in d.documentElement.style &&
      w.__forceSmoothScrollPolyfill__ !== true
    ) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now =
      w.performance && w.performance.now
        ? w.performance.now.bind(w.performance)
        : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (
        firstArg === null ||
        typeof firstArg !== 'object' ||
        firstArg.behavior === undefined ||
        firstArg.behavior === 'auto' ||
        firstArg.behavior === 'instant'
      ) {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions ' +
          firstArg.behavior +
          ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      while (el !== d.body && isScrollable(el) === false) {
        el = el.parentNode || el.host;
      }

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : w.scrollX || w.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : w.scrollY || w.pageYOffset
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : w.scrollX || w.pageXOffset,
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : w.scrollY || w.pageYOffset
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object' ? arguments[0] : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined ? arguments[1] : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {}

}());


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(168);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _root_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(20)(module)))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



module.exports = __webpack_require__(198);


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1),__webpack_require__(0),__webpack_require__(208)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(this, function (React, PropTypes, createReactClass) {

  /**
   * To prevent text selection while dragging.
   * http://stackoverflow.com/questions/5429827/how-can-i-prevent-text-element-selection-with-cursor-drag
   */
  function pauseEvent(e) {
    if (e.stopPropagation) e.stopPropagation();
    if (e.preventDefault) e.preventDefault();
    return false;
  }

  function stopPropagation(e) {
    if (e.stopPropagation) e.stopPropagation();
  }

  /**
   * Spreads `count` values equally between `min` and `max`.
   */
  function linspace(min, max, count) {
    var range = (max - min) / (count - 1);
    var res = [];
    for (var i = 0; i < count; i++) {
      res.push(min + range * i);
    }
    return res;
  }

  function ensureArray(x) {
    return x == null ? [] : Array.isArray(x) ? x : [x];
  }

  function undoEnsureArray(x) {
    return x != null && x.length === 1 ? x[0] : x;
  }

  // undoEnsureArray(ensureArray(x)) === x

  var ReactSlider = createReactClass({
    displayName: 'ReactSlider',

    propTypes: {

      /**
       * The minimum value of the slider.
       */
      min: PropTypes.number,

      /**
       * The maximum value of the slider.
       */
      max: PropTypes.number,

      /**
       * Value to be added or subtracted on each step the slider makes.
       * Must be greater than zero.
       * `max - min` should be evenly divisible by the step value.
       */
      step: PropTypes.number,

      /**
       * The minimal distance between any pair of handles.
       * Must be positive, but zero means they can sit on top of each other.
       */
      minDistance: PropTypes.number,

      /**
       * Determines the initial positions of the handles and the number of handles if the component has no children.
       *
       * If a number is passed a slider with one handle will be rendered.
       * If an array is passed each value will determine the position of one handle.
       * The values in the array must be sorted.
       * If the component has children, the length of the array must match the number of children.
       */
      defaultValue: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.arrayOf(PropTypes.number)
      ]),

      /**
       * Like `defaultValue` but for [controlled components](http://facebook.github.io/react/docs/forms.html#controlled-components).
       */
      value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.arrayOf(PropTypes.number)
      ]),

      /**
       * Determines whether the slider moves horizontally (from left to right) or vertically (from top to bottom).
       */
      orientation: PropTypes.oneOf(['horizontal', 'vertical']),

      /**
       * The css class set on the slider node.
       */
      className: PropTypes.string,

      /**
       * The css class set on each handle node.
       *
       * In addition each handle will receive a numbered css class of the form `${handleClassName}-${i}`,
       * e.g. `handle-0`, `handle-1`, ...
       */
      handleClassName: PropTypes.string,

      /**
       * The css class set on the handle that is currently being moved.
       */
      handleActiveClassName: PropTypes.string,

      /**
       * If `true` bars between the handles will be rendered.
       */
      withBars: PropTypes.bool,

      /**
       * The css class set on the bars between the handles.
       * In addition bar fragment will receive a numbered css class of the form `${barClassName}-${i}`,
       * e.g. `bar-0`, `bar-1`, ...
       */
      barClassName: PropTypes.string,

      /**
       * If `true` the active handle will push other handles
       * within the constraints of `min`, `max`, `step` and `minDistance`.
       */
      pearling: PropTypes.bool,

      /**
       * If `true` the handles can't be moved.
       */
      disabled: PropTypes.bool,

      /**
       * Disables handle move when clicking the slider bar
       */
      snapDragDisabled: PropTypes.bool,

      /**
       * Inverts the slider.
       */
      invert: PropTypes.bool,

      /**
       * Callback called before starting to move a handle.
       */
      onBeforeChange: PropTypes.func,

      /**
       * Callback called on every value change.
       */
      onChange: PropTypes.func,

      /**
       * Callback called only after moving a handle has ended.
       */
      onAfterChange: PropTypes.func,

      /**
       *  Callback called when the the slider is clicked (handle or bars).
       *  Receives the value at the clicked position as argument.
       */
      onSliderClick: PropTypes.func
    },

    getDefaultProps: function () {
      return {
        min: 0,
        max: 100,
        step: 1,
        minDistance: 0,
        defaultValue: 0,
        orientation: 'horizontal',
        className: 'slider',
        handleClassName: 'handle',
        handleActiveClassName: 'active',
        barClassName: 'bar',
        withBars: false,
        pearling: false,
        disabled: false,
        snapDragDisabled: false,
        invert: false
      };
    },

    getInitialState: function () {
      var value = this._or(ensureArray(this.props.value), ensureArray(this.props.defaultValue));

      // reused throughout the component to store results of iterations over `value`
      this.tempArray = value.slice();

      // array for storing resize timeouts ids
      this.pendingResizeTimeouts = [];

      var zIndices = [];
      for (var i = 0; i < value.length; i++) {
        value[i] = this._trimAlignValue(value[i], this.props);
        zIndices.push(i);
      }

      return {
        index: -1,
        upperBound: 0,
        sliderLength: 0,
        value: value,
        zIndices: zIndices
      };
    },

    // Keep the internal `value` consistent with an outside `value` if present.
    // This basically allows the slider to be a controlled component.
    componentWillReceiveProps: function (newProps) {
      var value = this._or(ensureArray(newProps.value), this.state.value);

      // ensure the array keeps the same size as `value`
      this.tempArray = value.slice();

      for (var i = 0; i < value.length; i++) {
        this.state.value[i] = this._trimAlignValue(value[i], newProps);
      }
      if (this.state.value.length > value.length)
        this.state.value.length = value.length;

      // If an upperBound has not yet been determined (due to the component being hidden
      // during the mount event, or during the last resize), then calculate it now
      if (this.state.upperBound === 0) {
        this._handleResize();
      }
    },

    // Check if the arity of `value` or `defaultValue` matches the number of children (= number of custom handles).
    // If no custom handles are provided, just returns `value` if present and `defaultValue` otherwise.
    // If custom handles are present but neither `value` nor `defaultValue` are applicable the handles are spread out
    // equally.
    // TODO: better name? better solution?
    _or: function (value, defaultValue) {
      var count = React.Children.count(this.props.children);
      switch (count) {
        case 0:
          return value.length > 0 ? value : defaultValue;
        case value.length:
          return value;
        case defaultValue.length:
          return defaultValue;
        default:
          if (value.length !== count || defaultValue.length !== count) {
            console.warn(this.constructor.displayName + ": Number of values does not match number of children.");
          }
          return linspace(this.props.min, this.props.max, count);
      }
    },

    componentDidMount: function () {
      window.addEventListener('resize', this._handleResize);
      this._handleResize();
    },

    componentWillUnmount: function () {
      this._clearPendingResizeTimeouts();
      window.removeEventListener('resize', this._handleResize);
    },

    getValue: function () {
      return undoEnsureArray(this.state.value);
    },

    _handleResize: function () {
      // setTimeout of 0 gives element enough time to have assumed its new size if it is being resized
      var resizeTimeout = window.setTimeout(function() {
        // drop this timeout from pendingResizeTimeouts to reduce memory usage
        this.pendingResizeTimeouts.shift();

        var slider = this.refs.slider;
        var handle = this.refs.handle0;
        var rect = slider.getBoundingClientRect();

        var size = this._sizeKey();

        var sliderMax = rect[this._posMaxKey()];
        var sliderMin = rect[this._posMinKey()];

        this.setState({
          upperBound: slider[size] - handle[size],
          sliderLength: Math.abs(sliderMax - sliderMin),
          handleSize: handle[size],
          sliderStart: this.props.invert ? sliderMax : sliderMin
        });
      }.bind(this), 0);

      this.pendingResizeTimeouts.push(resizeTimeout);
    },

    // clear all pending timeouts to avoid error messages after unmounting
    _clearPendingResizeTimeouts: function() {
      do {
        var nextTimeout = this.pendingResizeTimeouts.shift();

        clearTimeout(nextTimeout);
      } while (this.pendingResizeTimeouts.length);
    },

    // calculates the offset of a handle in pixels based on its value.
    _calcOffset: function (value) {
      var range = this.props.max - this.props.min;
      if (range === 0) {
        return 0;
      }
      var ratio = (value - this.props.min) / range;
      return ratio * this.state.upperBound;
    },

    // calculates the value corresponding to a given pixel offset, i.e. the inverse of `_calcOffset`.
    _calcValue: function (offset) {
      var ratio = offset / this.state.upperBound;
      return ratio * (this.props.max - this.props.min) + this.props.min;
    },

    _buildHandleStyle: function (offset, i) {
      var style = {
        position: 'absolute',
        willChange: this.state.index >= 0 ? this._posMinKey() : '',
        zIndex: this.state.zIndices.indexOf(i) + 1
      };
      style[this._posMinKey()] = offset + 'px';
      return style;
    },

    _buildBarStyle: function (min, max) {
      var obj = {
        position: 'absolute',
        willChange: this.state.index >= 0 ? this._posMinKey() + ',' + this._posMaxKey() : ''
      };
      obj[this._posMinKey()] = min;
      obj[this._posMaxKey()] = max;
      return obj;
    },

    _getClosestIndex: function (pixelOffset) {
      var minDist = Number.MAX_VALUE;
      var closestIndex = -1;

      var value = this.state.value;
      var l = value.length;

      for (var i = 0; i < l; i++) {
        var offset = this._calcOffset(value[i]);
        var dist = Math.abs(pixelOffset - offset);
        if (dist < minDist) {
          minDist = dist;
          closestIndex = i;
        }
      }

      return closestIndex;
    },

    _calcOffsetFromPosition: function (position) {
      var pixelOffset = position - this.state.sliderStart;
      if (this.props.invert) pixelOffset = this.state.sliderLength - pixelOffset;
      pixelOffset -= (this.state.handleSize / 2);
      return pixelOffset;
    },

    // Snaps the nearest handle to the value corresponding to `position` and calls `callback` with that handle's index.
    _forceValueFromPosition: function (position, callback) {
      var pixelOffset = this._calcOffsetFromPosition(position);
      var closestIndex = this._getClosestIndex(pixelOffset);
      var nextValue = this._trimAlignValue(this._calcValue(pixelOffset));

      var value = this.state.value.slice(); // Clone this.state.value since we'll modify it temporarily
      value[closestIndex] = nextValue;

      // Prevents the slider from shrinking below `props.minDistance`
      for (var i = 0; i < value.length - 1; i += 1) {
        if (value[i + 1] - value[i] < this.props.minDistance) return;
      }

      this.setState({value: value}, callback.bind(this, closestIndex));
    },

    _getMousePosition: function (e) {
      return [
        e['page' + this._axisKey()],
        e['page' + this._orthogonalAxisKey()]
      ];
    },

    _getTouchPosition: function (e) {
      var touch = e.touches[0];
      return [
        touch['page' + this._axisKey()],
        touch['page' + this._orthogonalAxisKey()]
      ];
    },

    _getKeyDownEventMap: function () {
      return {
        'keydown': this._onKeyDown,
        'focusout': this._onBlur
      }
    },

    _getMouseEventMap: function () {
      return {
        'mousemove': this._onMouseMove,
        'mouseup': this._onMouseUp
      }
    },

    _getTouchEventMap: function () {
      return {
        'touchmove': this._onTouchMove,
        'touchend': this._onTouchEnd
      }
    },

    // create the `keydown` handler for the i-th handle
    _createOnKeyDown: function (i) {
      return function (e) {
        if (this.props.disabled) return;
        this._start(i);
        this._addHandlers(this._getKeyDownEventMap());
        pauseEvent(e);
      }.bind(this);
    },

    // create the `mousedown` handler for the i-th handle
    _createOnMouseDown: function (i) {
      return function (e) {
        if (this.props.disabled) return;
        var position = this._getMousePosition(e);
        this._start(i, position[0]);
        this._addHandlers(this._getMouseEventMap());
        pauseEvent(e);
      }.bind(this);
    },

    // create the `touchstart` handler for the i-th handle
    _createOnTouchStart: function (i) {
      return function (e) {
        if (this.props.disabled || e.touches.length > 1) return;
        var position = this._getTouchPosition(e);
        this.startPosition = position;
        this.isScrolling = undefined; // don't know yet if the user is trying to scroll
        this._start(i, position[0]);
        this._addHandlers(this._getTouchEventMap());
        stopPropagation(e);
      }.bind(this);
    },

    _addHandlers: function (eventMap) {
      for (var key in eventMap) {
        document.addEventListener(key, eventMap[key], false);
      }
    },

    _removeHandlers: function (eventMap) {
      for (var key in eventMap) {
        document.removeEventListener(key, eventMap[key], false);
      }
    },

    _start: function (i, position) {
      var activeEl = document.activeElement;
      var handleRef = this.refs['handle' + i];
      // if activeElement is body window will lost focus in IE9
      if (activeEl && activeEl != document.body && activeEl != handleRef) {
        activeEl.blur && activeEl.blur();
      }

      this.hasMoved = false;

      this._fireChangeEvent('onBeforeChange');

      var zIndices = this.state.zIndices;
      zIndices.splice(zIndices.indexOf(i), 1); // remove wherever the element is
      zIndices.push(i); // add to end

      this.setState({
        startValue: this.state.value[i],
        startPosition: position,
        index: i,
        zIndices: zIndices
      });
    },

    _onMouseUp: function () {
      this._onEnd(this._getMouseEventMap());
    },

    _onTouchEnd: function () {
      this._onEnd(this._getTouchEventMap());
    },

    _onBlur: function () {
      this._onEnd(this._getKeyDownEventMap());
    },

    _onEnd: function (eventMap) {
      this._removeHandlers(eventMap);
      this.setState({index: -1}, this._fireChangeEvent.bind(this, 'onAfterChange'));
    },

    _onMouseMove: function (e) {
      var position = this._getMousePosition(e);
      var diffPosition = this._getDiffPosition(position[0]);
      var newValue = this._getValueFromPosition(diffPosition);
      this._move(newValue);
    },

    _onTouchMove: function (e) {
      if (e.touches.length > 1) return;

      var position = this._getTouchPosition(e);

      if (typeof this.isScrolling === 'undefined') {
        var diffMainDir = position[0] - this.startPosition[0];
        var diffScrollDir = position[1] - this.startPosition[1];
        this.isScrolling = Math.abs(diffScrollDir) > Math.abs(diffMainDir);
      }

      if (this.isScrolling) {
        this.setState({index: -1});
        return;
      }

      pauseEvent(e);

      var diffPosition = this._getDiffPosition(position[0]);
      var newValue = this._getValueFromPosition(diffPosition);

      this._move(newValue);
    },

    _onKeyDown: function (e) {
      if (e.ctrlKey || e.shiftKey || e.altKey) return;
      switch (e.key) {
        case "ArrowLeft":
        case "ArrowUp":
          return this._moveDownOneStep();
        case "ArrowRight":
        case "ArrowDown":
          return this._moveUpOneStep();
        case "Home":
          return this._move(this.props.min);
        case "End":
          return this._move(this.props.max);
        default:
          return;
      }
    },

    _moveUpOneStep: function () {
      var oldValue = this.state.value[this.state.index];
      var newValue = oldValue + this.props.step;
      this._move(Math.min(newValue, this.props.max));
    },

    _moveDownOneStep: function () {
      var oldValue = this.state.value[this.state.index];
      var newValue = oldValue - this.props.step;
      this._move(Math.max(newValue, this.props.min));
    },

    _getValueFromPosition: function (position) {
      var diffValue = position / (this.state.sliderLength - this.state.handleSize) * (this.props.max - this.props.min);
      return this._trimAlignValue(this.state.startValue + diffValue);
    },

    _getDiffPosition: function (position) {
      var diffPosition = position - this.state.startPosition;
      if (this.props.invert) diffPosition *= -1;
      return diffPosition;
    },

    _move: function (newValue) {
      this.hasMoved = true;

      var props = this.props;
      var state = this.state;
      var index = state.index;

      var value = state.value;
      var length = value.length;
      var oldValue = value[index];

      var minDistance = props.minDistance;

      // if "pearling" (= handles pushing each other) is disabled,
      // prevent the handle from getting closer than `minDistance` to the previous or next handle.
      if (!props.pearling) {
        if (index > 0) {
          var valueBefore = value[index - 1];
          if (newValue < valueBefore + minDistance) {
            newValue = valueBefore + minDistance;
          }
        }

        if (index < length - 1) {
          var valueAfter = value[index + 1];
          if (newValue > valueAfter - minDistance) {
            newValue = valueAfter - minDistance;
          }
        }
      }

      value[index] = newValue;

      // if "pearling" is enabled, let the current handle push the pre- and succeeding handles.
      if (props.pearling && length > 1) {
        if (newValue > oldValue) {
          this._pushSucceeding(value, minDistance, index);
          this._trimSucceeding(length, value, minDistance, props.max);
        }
        else if (newValue < oldValue) {
          this._pushPreceding(value, minDistance, index);
          this._trimPreceding(length, value, minDistance, props.min);
        }
      }

      // Normally you would use `shouldComponentUpdate`, but since the slider is a low-level component,
      // the extra complexity might be worth the extra performance.
      if (newValue !== oldValue) {
        this.setState({value: value}, this._fireChangeEvent.bind(this, 'onChange'));
      }
    },

    _pushSucceeding: function (value, minDistance, index) {
      var i, padding;
      for (i = index, padding = value[i] + minDistance;
           value[i + 1] != null && padding > value[i + 1];
           i++, padding = value[i] + minDistance) {
        value[i + 1] = this._alignValue(padding);
      }
    },

    _trimSucceeding: function (length, nextValue, minDistance, max) {
      for (var i = 0; i < length; i++) {
        var padding = max - i * minDistance;
        if (nextValue[length - 1 - i] > padding) {
          nextValue[length - 1 - i] = padding;
        }
      }
    },

    _pushPreceding: function (value, minDistance, index) {
      var i, padding;
      for (i = index, padding = value[i] - minDistance;
           value[i - 1] != null && padding < value[i - 1];
           i--, padding = value[i] - minDistance) {
        value[i - 1] = this._alignValue(padding);
      }
    },

    _trimPreceding: function (length, nextValue, minDistance, min) {
      for (var i = 0; i < length; i++) {
        var padding = min + i * minDistance;
        if (nextValue[i] < padding) {
          nextValue[i] = padding;
        }
      }
    },

    _axisKey: function () {
      var orientation = this.props.orientation;
      if (orientation === 'horizontal') return 'X';
      if (orientation === 'vertical') return 'Y';
    },

    _orthogonalAxisKey: function () {
      var orientation = this.props.orientation;
      if (orientation === 'horizontal') return 'Y';
      if (orientation === 'vertical') return 'X';
    },

    _posMinKey: function () {
      var orientation = this.props.orientation;
      if (orientation === 'horizontal') return this.props.invert ? 'right' : 'left';
      if (orientation === 'vertical') return this.props.invert ? 'bottom' : 'top';
    },

    _posMaxKey: function () {
      var orientation = this.props.orientation;
      if (orientation === 'horizontal') return this.props.invert ? 'left' : 'right';
      if (orientation === 'vertical') return this.props.invert ? 'top' : 'bottom';
    },

    _sizeKey: function () {
      var orientation = this.props.orientation;
      if (orientation === 'horizontal') return 'clientWidth';
      if (orientation === 'vertical') return 'clientHeight';
    },

    _trimAlignValue: function (val, props) {
      return this._alignValue(this._trimValue(val, props), props);
    },

    _trimValue: function (val, props) {
      props = props || this.props;

      if (val <= props.min) val = props.min;
      if (val >= props.max) val = props.max;

      return val;
    },

    _alignValue: function (val, props) {
      props = props || this.props;

      var valModStep = (val - props.min) % props.step;
      var alignValue = val - valModStep;

      if (Math.abs(valModStep) * 2 >= props.step) {
        alignValue += (valModStep > 0) ? props.step : (-props.step);
      }

      return parseFloat(alignValue.toFixed(5));
    },

    _renderHandle: function (style, child, i) {
      var className = this.props.handleClassName + ' ' +
        (this.props.handleClassName + '-' + i) + ' ' +
        (this.state.index === i ? this.props.handleActiveClassName : '');

      return (
        React.createElement('div', {
            ref: 'handle' + i,
            key: 'handle' + i,
            className: className,
            style: style,
            onMouseDown: this._createOnMouseDown(i),
            onTouchStart: this._createOnTouchStart(i),
            onFocus: this._createOnKeyDown(i),
            tabIndex: 0,
            role: "slider",
            "aria-valuenow": this.state.value[i],
            "aria-valuemin": this.props.min,
            "aria-valuemax": this.props.max,
          },
          child
        )
      );
    },

    _renderHandles: function (offset) {
      var length = offset.length;

      var styles = this.tempArray;
      for (var i = 0; i < length; i++) {
        styles[i] = this._buildHandleStyle(offset[i], i);
      }

      var res = this.tempArray;
      var renderHandle = this._renderHandle;
      if (React.Children.count(this.props.children) > 0) {
        React.Children.forEach(this.props.children, function (child, i) {
          res[i] = renderHandle(styles[i], child, i);
        });
      } else {
        for (i = 0; i < length; i++) {
          res[i] = renderHandle(styles[i], null, i);
        }
      }
      return res;
    },

    _renderBar: function (i, offsetFrom, offsetTo) {
      return (
        React.createElement('div', {
          key: 'bar' + i,
          ref: 'bar' + i,
          className: this.props.barClassName + ' ' + this.props.barClassName + '-' + i,
          style: this._buildBarStyle(offsetFrom, this.state.upperBound - offsetTo)
        })
      );
    },

    _renderBars: function (offset) {
      var bars = [];
      var lastIndex = offset.length - 1;

      bars.push(this._renderBar(0, 0, offset[0]));

      for (var i = 0; i < lastIndex; i++) {
        bars.push(this._renderBar(i + 1, offset[i], offset[i + 1]));
      }

      bars.push(this._renderBar(lastIndex + 1, offset[lastIndex], this.state.upperBound));

      return bars;
    },

    _onSliderMouseDown: function (e) {
      if (this.props.disabled) return;
      this.hasMoved = false;
      if (!this.props.snapDragDisabled) {
        var position = this._getMousePosition(e);
        this._forceValueFromPosition(position[0], function (i) {
          this._fireChangeEvent('onChange');
          this._start(i, position[0]);
          this._addHandlers(this._getMouseEventMap());
        }.bind(this));
      }

      pauseEvent(e);
    },

    _onSliderClick: function (e) {
      if (this.props.disabled) return;

      if (this.props.onSliderClick && !this.hasMoved) {
        var position = this._getMousePosition(e);
        var valueAtPos = this._trimAlignValue(this._calcValue(this._calcOffsetFromPosition(position[0])));
        this.props.onSliderClick(valueAtPos);
      }
    },

    _fireChangeEvent: function (event) {
      if (this.props[event]) {
        this.props[event](undoEnsureArray(this.state.value));
      }
    },

    render: function () {
      var state = this.state;
      var props = this.props;

      var offset = this.tempArray;
      var value = state.value;
      var l = value.length;
      for (var i = 0; i < l; i++) {
        offset[i] = this._calcOffset(value[i], i);
      }

      var bars = props.withBars ? this._renderBars(offset) : null;
      var handles = this._renderHandles(offset);

      return (
        React.createElement('div', {
            ref: 'slider',
            style: {position: 'relative'},
            className: props.className + (props.disabled ? ' disabled' : ''),
            onMouseDown: this._onSliderMouseDown,
            onClick: this._onSliderClick
          },
          bars,
          handles
        )
      );
    }
  });

  return ReactSlider;
}));


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function ShareAltRegular (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m352 320c-25.6 0-48.9 10-66.1 26.4l-98.3-61.5c5.9-18.8 5.9-39.1 0-57.8l98.3-61.5c17.2 16.4 40.5 26.4 66.1 26.4 53 0 96-43 96-96s-43-96-96-96-96 43-96 96c0 9.8 1.5 19.6 4.4 28.9l-98.3 61.5c-17.2-16.4-40.5-26.4-66.1-26.4-53 0-96 43-96 96s43 96 96 96c25.6 0 48.9-10 66.1-26.4l98.3 61.5c-2.9 9.4-4.4 19.1-4.4 28.9 0 53 43 96 96 96s96-43 96-96-43-96-96-96zm0-272c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm-256 256c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm256 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"}));
}

ShareAltRegular.defaultProps = {"viewBox":"0 0 448 512"};

module.exports = ShareAltRegular;

ShareAltRegular.default = ShareAltRegular;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function ShareAltLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M352 320c-28.6 0-54.2 12.5-71.8 32.3l-95.5-59.7c9.6-23.4 9.7-49.8 0-73.2l95.5-59.7c17.6 19.8 43.2 32.3 71.8 32.3 53 0 96-43 96-96S405 0 352 0s-96 43-96 96c0 13 2.6 25.3 7.2 36.6l-95.5 59.7C150.2 172.5 124.6 160 96 160c-53 0-96 43-96 96s43 96 96 96c28.6 0 54.2-12.5 71.8-32.3l95.5 59.7c-4.7 11.3-7.2 23.6-7.2 36.6 0 53 43 96 96 96s96-43 96-96c-.1-53-43.1-96-96.1-96zm0-288c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm256 160c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"}));
}

ShareAltLight.defaultProps = {"viewBox":"0 0 448 512"};

module.exports = ShareAltLight;

ShareAltLight.default = ShareAltLight;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function EnvelopeSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7v204.5c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-204.4c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zm-246.3 129.2c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48h-416c-26.5 0-48 21.5-48 48v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"}));
}

EnvelopeSolid.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = EnvelopeSolid;

EnvelopeSolid.default = EnvelopeSolid;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function FacebookFBrands (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m215.8 85h48.2v-81.4c-8.3-1.1-36.9-3.6-70.2-3.6-69.5 0-117.1 42.4-117.1 120.3v71.7h-76.7v91h76.7v229h94v-229h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"}));
}

FacebookFBrands.defaultProps = {"viewBox":"0 0 264 512"};

module.exports = FacebookFBrands;

FacebookFBrands.default = FacebookFBrands;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function LinkedinInBrands (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m100.3 448h-92.9v-299.1h92.9zm-46.5-339.9c-29.7 0-53.8-24.6-53.8-54.3s24.1-53.8 53.8-53.8 53.8 24.1 53.8 53.8-24.1 54.3-53.8 54.3zm394.2 339.9h-92.7v-145.6c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7v148.1h-92.8v-299.1h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3v164.3z"}));
}

LinkedinInBrands.defaultProps = {"viewBox":"0 0 448 512"};

module.exports = LinkedinInBrands;

LinkedinInBrands.default = LinkedinInBrands;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function PinterestPBrands (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m204 6.5c-102.6 0-204 68.4-204 179.1 0 70.4 39.6 110.4 63.6 110.4 9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8 0-99.3-85.8-164.1-180-164.1z"}));
}

PinterestPBrands.defaultProps = {"viewBox":"0 0 384 512"};

module.exports = PinterestPBrands;

PinterestPBrands.default = PinterestPBrands;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function TumblrBrands (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144h-47.5c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4v133.2c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"}));
}

TumblrBrands.defaultProps = {"viewBox":"0 0 320 512"};

module.exports = TumblrBrands;

TumblrBrands.default = TumblrBrands;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function TwitterBrands (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"}));
}

TwitterBrands.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = TwitterBrands;

TwitterBrands.default = TwitterBrands;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function InstagramBrands (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9 114.9-51.3 114.9-114.9-51.3-114.9-114.9-114.9zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zm-47.8 224.5c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"}));
}

InstagramBrands.defaultProps = {"viewBox":"0 0 448 512"};

module.exports = InstagramBrands;

InstagramBrands.default = InstagramBrands;


/***/ }),
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





if (true) {
  (function() {
'use strict';

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(9);
var assign = __webpack_require__(15);

var ReactPropTypesSecret = __webpack_require__(25);
var has = __webpack_require__(26);
var checkPropTypes = __webpack_require__(63);

var printWarning = function() {};

if (true) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (true) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if ( true && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (true) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       true ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : undefined;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (true) {
  var ReactPropTypesSecret = __webpack_require__(25);
  var loggedTypeFailures = {};
  var has = __webpack_require__(26);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (true) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (true) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./badge-icon-basic.svg": 68,
	"./badge-icon-plus.svg": 69,
	"./badge-icon-pro.svg": 70,
	"./cart.svg": 71,
	"./check-circle.svg": 72,
	"./checkmark.svg": 73,
	"./chevron-bold.svg": 74,
	"./chevron-light.svg": 75,
	"./chevron-medium.svg": 76,
	"./close.svg": 77,
	"./coupon.svg": 78,
	"./customizable.svg": 79,
	"./edit.svg": 80,
	"./error.svg": 81,
	"./exclamation-circle.svg": 82,
	"./glowforge-icon.svg": 83,
	"./glowforge-logo.svg": 84,
	"./heart.svg": 85,
	"./img-placeholder.svg": 86,
	"./info-circle.svg": 87,
	"./info.svg": 88,
	"./lock.svg": 89,
	"./long-arrow-right.svg": 90,
	"./menu.svg": 91,
	"./minus.svg": 92,
	"./pencil-ruler.svg": 93,
	"./play-button.svg": 94,
	"./play-circle.svg": 95,
	"./plus-solid.svg": 96,
	"./plus.svg": 97,
	"./premium-gem.svg": 98,
	"./proofgrade-badge.svg": 99,
	"./proofgrade.svg": 100,
	"./remove.svg": 101,
	"./save.svg": 102,
	"./search.svg": 103,
	"./sliders.svg": 104,
	"./spinner.svg": 105,
	"./success.svg": 106,
	"./times-circle.svg": 107,
	"./trash.svg": 108,
	"./warning.svg": 109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function BadgeIconBasic (props) {
    return React.createElement("svg",props);
}

BadgeIconBasic.defaultProps = {};

module.exports = BadgeIconBasic;

BadgeIconBasic.default = BadgeIconBasic;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function BadgeIconPlus (props) {
    return React.createElement("svg",props);
}

BadgeIconPlus.defaultProps = {};

module.exports = BadgeIconPlus;

BadgeIconPlus.default = BadgeIconPlus;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function BadgeIconPro (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.46 21.65c-4.68 8.1-9.36 16.2-14.03 24.3 -0.02 0.03-0.04 0.06-0.05 0.09 -0.32 0.6-0.69 1.17-1.48 0.88 -0.83-0.3-0.63-1.03-0.52-1.65 0.36-2.04 0.76-4.07 1.14-6.1 0.68-3.57 1.36-7.15 2.03-10.73 0.06-0.3 0.07-0.62 0.13-1.05 -0.44-0.02-0.82-0.05-1.19-0.05 -2.64 0.01-5.29 0.03-7.93 0.04 -1.55 0-1.92-0.64-1.13-2.01C5.08 17.25 9.76 9.15 14.44 1.05c0.02-0.03 0.04-0.06 0.05-0.09 0.32-0.6 0.69-1.17 1.48-0.88 0.83 0.3 0.63 1.03 0.52 1.65 -0.36 2.04-0.75 4.07-1.14 6.1 -0.68 3.57-1.36 7.15-2.03 10.73 -0.06 0.3-0.07 0.62-0.12 1.05 0.44 0.02 0.82 0.05 1.19 0.05 2.64-0.01 5.29-0.03 7.93-0.04C23.88 19.63 24.25 20.28 23.46 21.65z"}));
}

BadgeIconPro.defaultProps = {"viewBox":"0 0 23.86 47"};

module.exports = BadgeIconPro;

BadgeIconPro.default = BadgeIconPro;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Cart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.54 15C7.54 15.39 7.4 15.72 7.11 16 6.83 16.29 6.5 16.43 6.11 16.43 5.72 16.43 5.39 16.29 5.11 16 4.82 15.72 4.68 15.39 4.68 15 4.68 14.61 4.82 14.28 5.11 14 5.39 13.71 5.72 13.57 6.11 13.57 6.5 13.57 6.83 13.71 7.11 14 7.4 14.28 7.54 14.61 7.54 15ZM17.54 15C17.54 15.39 17.4 15.72 17.11 16 16.83 16.29 16.5 16.43 16.11 16.43 15.72 16.43 15.39 16.29 15.11 16 14.82 15.72 14.68 15.39 14.68 15 14.68 14.61 14.82 14.28 15.11 14 15.39 13.71 15.72 13.57 16.11 13.57 16.5 13.57 16.83 13.71 17.11 14 17.4 14.28 17.54 14.61 17.54 15ZM18.97 2.86L18.97 8.57C18.97 8.75 18.91 8.91 18.78 9.05 18.66 9.18 18.51 9.26 18.33 9.29L6.68 10.65C6.78 11.09 6.82 11.35 6.82 11.43 6.82 11.55 6.74 11.79 6.56 12.14L16.82 12.14C17.02 12.14 17.19 12.21 17.33 12.35 17.47 12.5 17.54 12.66 17.54 12.86 17.54 13.05 17.47 13.22 17.33 13.36 17.19 13.5 17.02 13.57 16.82 13.57L5.4 13.57C5.2 13.57 5.04 13.5 4.89 13.36 4.75 13.22 4.68 13.05 4.68 12.86 4.68 12.78 4.71 12.66 4.77 12.51 4.83 12.35 4.89 12.22 4.95 12.1 5.01 11.99 5.09 11.84 5.19 11.66 5.29 11.48 5.35 11.37 5.36 11.33L3.39 2.14 1.11 2.14C0.92 2.14 0.75 2.07 0.61 1.93 0.47 1.79 0.4 1.62 0.4 1.43 0.4 1.24 0.47 1.07 0.61 0.93 0.75 0.78 0.92 0.71 1.11 0.71L3.97 0.71C4.09 0.71 4.19 0.74 4.29 0.79 4.38 0.84 4.45 0.89 4.5 0.96 4.56 1.03 4.6 1.12 4.65 1.23 4.69 1.35 4.72 1.45 4.74 1.52 4.75 1.6 4.77 1.71 4.8 1.85 4.83 1.99 4.84 2.09 4.85 2.14L18.25 2.14C18.45 2.14 18.61 2.21 18.76 2.35 18.9 2.5 18.97 2.66 18.97 2.86Z"}));
}

Cart.defaultProps = {"viewBox":"0 0 19 17"};

module.exports = Cart;

Cart.default = Cart;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function CheckCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M50 0c9 0 17.34 2.25 25 6.75A50.52 50.52 0 0 1 93.25 25c4.5 7.66 6.75 16 6.75 25s-2.25 17.34-6.75 25A50.52 50.52 0 0 1 75 93.25c-7.66 4.5-16 6.75-25 6.75s-17.34-2.25-25-6.75A50.52 50.52 0 0 1 6.75 75C2.25 67.34 0 59 0 50s2.25-17.34 6.75-25A50.52 50.52 0 0 1 25 6.75C32.66 2.25 41 0 50 0zm0 93.55a42.5 42.5 0 0 0 21.88-5.85A43.35 43.35 0 0 0 87.7 71.77a42.85 42.85 0 0 0 5.85-21.87c0-7.86-1.95-15.12-5.85-21.77A43.35 43.35 0 0 0 71.77 12.3 42.85 42.85 0 0 0 49.9 6.45a42.31 42.31 0 0 0-21.77 5.85A43.35 43.35 0 0 0 12.3 28.23 42.85 42.85 0 0 0 6.45 50.1c0 7.86 1.95 15.12 5.85 21.77A43.35 43.35 0 0 0 28.23 87.7 42.66 42.66 0 0 0 50 93.55zm-7.86-19.36c-.4.54-.94.81-1.62.81a2.5 2.5 0 0 1-1.81-.8L21.37 56.64c-.4-.4-.6-.94-.6-1.61 0-.67.2-1.28.6-1.81l1.82-1.62c.4-.4.94-.6 1.6-.6.68 0 1.29.2 1.82.6l13.91 14.12L73.4 32.86c.53-.4 1.14-.6 1.81-.6.67 0 1.21.27 1.61.8l1.82 1.62c.4.54.6 1.14.6 1.81 0 .67-.2 1.21-.6 1.61l-36.5 36.1z"}));
}

CheckCircle.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Category-Page","stroke":"none","strokeWidth":"1","fillRule":"evenodd"},React.createElement("g",{"id":"Glowforge---Acrylic-Open","transform":"translate(-331.000000, -485.000000)"},React.createElement("g",{"id":"Group","transform":"translate(35.000000, 444.000000)"},React.createElement("g",{"id":"Effect","transform":"translate(290.000000, 0.000000)"},React.createElement("g",{"id":"2-color","transform":"translate(1.000000, 35.000000)"},React.createElement("polygon",{"id":"Mask","points":"8.73937247 16.3633603 5 12.6232287 6.34134615 11.2811235 8.67484818 13.6146255 15.5964069 6 17 7.27682186"})))))));
}

Checkmark.defaultProps = {"viewBox":"0 0 12 11","version":"1.1"};

module.exports = Checkmark;

Checkmark.default = Checkmark;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function ChevronBold (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.9 1.5l58.6 58.7c1 .9 1.5 2.2 1.4 3.5a5 5 0 0 1-1.4 3.5l-58.6 58.7c-1 1-2.3 1.5-3.7 1.5-1.4 0-2.6-.6-3.5-1.5L1.5 113a5.1 5.1 0 0 1-1.5-3.5c0-1.4.6-2.6 1.5-3.5l42.1-42.1L1.5 21.7c-1-.9-1.5-2.2-1.5-3.5 0-1.3.6-2.5 1.5-3.5L14.7 1.5C15.6.6 16.8 0 18.2 0s2.6.6 3.7 1.5z"}));
}

ChevronBold.defaultProps = {"viewBox":"0 0 81.9 127.7"};

module.exports = ChevronBold;

ChevronBold.default = ChevronBold;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function ChevronLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M44.7 41.5L4 .8S2.2-1 .8.8.4 4 .4 4l39.9 39.8L.5 83s-1.4 1.8.5 3.2c1.4 1.4 3.2.5 3.2.5L44.9 46s1-1 1-2.2c-.2-1.5-1.2-2.3-1.2-2.3z"}));
}

ChevronLight.defaultProps = {"viewBox":"0 0 45.9 87"};

module.exports = ChevronLight;

ChevronLight.default = ChevronLight;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function ChevronMedium (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M145.4 136.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L105.8 128 3.6 27.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116a12.1 12.1 0 0 1-.1 17z"}));
}

ChevronMedium.defaultProps = {"viewBox":"0 0 149 256.1"};

module.exports = ChevronMedium;

ChevronMedium.default = ChevronMedium;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.09 9.09C11.09 9.33 11.01 9.53 10.84 9.7L9.63 10.91C9.46 11.08 9.26 11.16 9.02 11.16 8.78 11.16 8.58 11.08 8.41 10.91L5.79 8.29 3.16 10.91C2.99 11.08 2.79 11.16 2.55 11.16 2.32 11.16 2.11 11.08 1.95 10.91L0.73 9.7C0.57 9.53 0.48 9.33 0.48 9.09 0.48 8.85 0.57 8.65 0.73 8.48L3.36 5.86 0.73 3.23C0.57 3.07 0.48 2.86 0.48 2.63 0.48 2.39 0.57 2.18 0.73 2.02L1.95 0.8C2.11 0.64 2.32 0.55 2.55 0.55 2.79 0.55 2.99 0.64 3.16 0.8L5.79 3.43 8.41 0.8C8.58 0.64 8.78 0.55 9.02 0.55 9.26 0.55 9.46 0.64 9.63 0.8L10.84 2.02C11.01 2.18 11.09 2.39 11.09 2.63 11.09 2.86 11.01 3.07 10.84 3.23L8.21 5.86 10.84 8.48C11.01 8.65 11.09 8.85 11.09 9.09Z"}));
}

Close.defaultProps = {"viewBox":"0 0 12 12"};

module.exports = Close;

Close.default = Close;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Coupon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.5,4 C23.3033233,4 23.9591546,4.6415118 23.9981643,5.44775606 L24,5.52380952 L24,18.4761905 C24,19.2922649 23.3685118,19.9585062 22.5748651,19.9981351 L22.5,20 L7.13072305,20 C6.72928825,20 6.34587971,19.8366121 6.06504513,19.5485695 L6.00646712,19.4849522 L0.375744074,13.0087617 C-0.10735545,12.4531236 -0.124609004,11.6288792 0.32398341,11.0540549 L0.375744074,10.9912383 L6.00646712,4.51504782 C6.2722169,4.20939503 6.64657978,4.02563024 7.04500803,4.00248672 L7.13072305,4 L22.5,4 Z M5.72712179,9.87511368 C4.55357949,9.87511368 3.60223548,10.8264577 3.60223548,12 C3.60223548,13.1735423 4.55357949,14.1248863 5.72712179,14.1248863 C6.9006641,14.1248863 7.85200811,13.1735423 7.85200811,12 C7.85200811,10.8264577 6.9006641,9.87511368 5.72712179,9.87511368 Z","fillRule":"nonzero"}));
}

Coupon.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Coupon;

Coupon.default = Coupon;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Customizable (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.41 12.88L11.77 11.52 9.98 9.73 8.63 11.09 8.63 11.75 9.75 11.75 9.75 12.88 10.41 12.88ZM15.56 4.44C15.44 4.31 15.31 4.32 15.18 4.45L11.07 8.55C10.94 8.68 10.94 8.81 11.06 8.94 11.19 9.06 11.32 9.06 11.45 8.93L15.55 4.82C15.68 4.69 15.69 4.56 15.56 4.44ZM16.5 11.4L16.5 13.63C16.5 14.55 16.17 15.35 15.51 16.01 14.85 16.67 14.05 17 13.13 17L3.38 17C2.45 17 1.65 16.67 0.99 16.01 0.33 15.35 0 14.55 0 13.63L0 3.88C0 2.95 0.33 2.15 0.99 1.49 1.65 0.83 2.45 0.5 3.38 0.5L13.13 0.5C13.62 0.5 14.07 0.6 14.5 0.79 14.61 0.85 14.68 0.94 14.71 1.06 14.73 1.2 14.7 1.31 14.6 1.4L14.03 1.98C13.92 2.09 13.79 2.12 13.65 2.07 13.47 2.02 13.3 2 13.13 2L3.38 2C2.86 2 2.42 2.18 2.05 2.55 1.68 2.92 1.5 3.36 1.5 3.88L1.5 13.63C1.5 14.14 1.68 14.58 2.05 14.95 2.42 15.32 2.86 15.5 3.38 15.5L13.13 15.5C13.64 15.5 14.08 15.32 14.45 14.95 14.82 14.58 15 14.14 15 13.63L15 12.15C15 12.05 15.04 11.96 15.11 11.89L15.86 11.14C15.97 11.02 16.11 11 16.27 11.06 16.42 11.12 16.5 11.23 16.5 11.4ZM15.38 2.75L18.75 6.13 10.88 14 7.5 14 7.5 10.63 15.38 2.75ZM20.58 4.3L19.5 5.38 16.13 2 17.2 0.92C17.42 0.7 17.69 0.59 18 0.59 18.31 0.59 18.58 0.7 18.8 0.92L20.58 2.7C20.8 2.92 20.91 3.19 20.91 3.5 20.91 3.81 20.8 4.08 20.58 4.3Z"}));
}

Customizable.defaultProps = {"viewBox":"0 0 21 17"};

module.exports = Customizable;

Customizable.default = Customizable;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Edit (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fillRule":"evenodd"},React.createElement("g",{"id":"interactions","transform":"translate(-41.000000, -30.000000)"},React.createElement("g",{"id":"edit","transform":"translate(41.000000, 30.000000)"},[React.createElement("path",{"d":"M16.7736071,5.43733333 L18.5758929,3.56266667 C19.1058571,3.04166667 19.1058571,2.104 18.5758929,1.47933333 L17.515625,0.437333333 C16.9853214,-0.0833333333 16.03125,-0.0833333333 15.3950893,0.437333333 L13.5924643,2.20833333 L16.7736071,5.43733333 Z","id":"Fill-1","key":0}),React.createElement("polygon",{"points":"12.6383929 3.354 0.127232143 15.646 0.127232143 18.875 3.20217857 18.875 15.713 6.47933333","key":1})]))));
}

Edit.defaultProps = {"viewBox":"0 0 19 19","version":"1.1"};

module.exports = Edit;

Edit.default = Edit;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Error (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"  all"),React.createElement("g",{"data-name":"Zoom In","key":1},React.createElement("g",{"data-name":"Calendar"},[React.createElement("path",{"d":"M76.7 58H23.3V42H76.7V58Z","key":0}),React.createElement("rect",{"x":"23.3","y":"42","width":"53.4","height":"16","key":1}),React.createElement("path",{"d":"M50 0a50 50 0 1 0 50 50A50 50 0 0 0 50 0Zm0 92.2A42.2 42.2 0 1 1 92.2 50 42.2 42.2 0 0 1 50 92.2Z","key":2})]))]);
}

Error.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 100 100"};

module.exports = Error;

Error.default = Error;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function ExclamationCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M50 6.45a42.5 42.5 0 0 0-21.88 5.85A43.58 43.58 0 0 0 12.3 28.12 42.5 42.5 0 0 0 6.45 50a42.5 42.5 0 0 0 5.85 21.88A43.58 43.58 0 0 0 28.12 87.7 42.5 42.5 0 0 0 50 93.55a42.5 42.5 0 0 0 21.88-5.85A43.58 43.58 0 0 0 87.7 71.87 42.5 42.5 0 0 0 93.55 50a42.5 42.5 0 0 0-5.85-21.88A43.35 43.35 0 0 0 71.77 12.3 42.66 42.66 0 0 0 50 6.45zM50 0c9 0 17.34 2.25 25 6.75A50.52 50.52 0 0 1 93.25 25c4.5 7.66 6.75 16 6.75 25s-2.25 17.34-6.75 25A50.52 50.52 0 0 1 75 93.25c-7.66 4.5-16 6.75-25 6.75s-17.34-2.25-25-6.75A50.52 50.52 0 0 1 6.75 75C2.25 67.34 0 59 0 50s2.25-17.34 6.75-25A50.52 50.52 0 0 1 25 6.75C32.66 2.25 41 0 50 0zm2.22 24.2c.8 0 1.44.23 1.91.7s.64 1.04.5 1.71l-1.4 33.87c0 .68-.24 1.25-.71 1.72s-1.04.7-1.71.7h-1.62c-.67 0-1.24-.23-1.71-.7s-.7-.98-.7-1.51L45.35 26.6c-.13-.67.04-1.24.5-1.71.48-.47 1.12-.7 1.92-.7h4.44zM50 66.93a5.47 5.47 0 0 1 5.65 5.65c0 1.6-.54 2.95-1.62 4.02A5.47 5.47 0 0 1 50 78.23a5.47 5.47 0 0 1-4.03-1.62 5.47 5.47 0 0 1-1.62-4.03c0-1.61.54-2.96 1.62-4.03A5.47 5.47 0 0 1 50 66.94z"}));
}

ExclamationCircle.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = ExclamationCircle;

ExclamationCircle.default = ExclamationCircle;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function GlowforgeIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M70.6069336,56.7549057c8.5642853-14.8296051,6.1236572-33.5488014-6.0156784-45.6881409\n\tC57.4543991,3.9301863,47.9500961,0,37.8288727,0C27.7079239,0,18.2036228,3.9301863,11.0670424,11.0667658\n\tS0,27.7079239,0,37.8291473c0,10.1209488,3.9304624,19.6252518,11.0670424,26.7621078l26.762104,26.7618256\n\tc1.5762711-1.5762711,21.9973907-21.9973907,26.2092514-26.2089691c0.0115967-0.011879,0.0220947-0.0229263,0.0309296-0.0328674\n\tc-1.0963211-1.0960388-19.3242455-19.3242416-19.3242455-19.3242416l-0.8000107-0.799736L43.9459,44.9867172l-1.5942192-1.5945015\n\tc0,0-7.6054878-7.605484-9.2994003-9.299118c-1.8590508,2.3588829-1.6928062,5.8400459,0.4730492,8.0061798l21.5765343,21.5765343\n\tc0.3899269,0.3899231,0.604496,0.9027405,0.6042175,1.4439926c-0.0002747,0.5235825-0.2101479,1.0333633-0.5754967,1.3987122\n\tc-0.1869545,0.1869507-4.4283638,4.4286346-4.7440071,4.744278c-0.4702835,0.4702835-0.9687386,0.5691452-1.3037071,0.5691452\n\tc-0.3487816,0-0.8734703-0.1088028-1.3923569-0.6279678c-4.7837715-4.783493-21.2426682-21.2434959-21.7574139-21.759346\n\tc-6.3302193-6.4890022-6.2636662-16.9697762,0.1391792-23.3723469c3.1357002-3.1356983,7.3111095-4.8627491,11.7568684-4.8627491\n\ts8.62117,1.7270508,11.7568703,4.8627491c3.5612488,3.5609722,5.2974091,8.4877872,4.7633324,13.5170574\n\tc-0.0480499,0.4526138-0.0613022,0.8469582,0.2559929,1.1642532l4.03899,4.03899\n\tc2.6168098-7.8623047,0.5782623-16.6168556-5.2918892-22.4870052c-4.1395073-4.1392326-9.6525955-6.419138-15.523571-6.419138\n\tc-5.8707027,0-11.3837891,2.2799053-15.5232983,6.419138c-4.1149311,4.1154842-6.398427,9.5865955-6.4293556,15.4056568\n\tc-0.0312052,5.8140907,2.1871185,11.3031502,6.2462673,15.4556389c0.0370045,0.0375595,1.7162819,1.7184906,21.6698761,21.6723633\n\tc0.9797821,0.9795074,0.7931061,2.2241211,0.1203995,2.8976517l-0.507843,0.5075684\n\tc-1.1700516,1.1703262-3.9114075,3.9114075-4.132328,4.1326065c-0.5382195,0.537941-1.0927315,0.6506119-1.4630508,0.6506119\n\tc-0.4984512,0-0.9800606-0.2068405-1.3556252-0.5826797L14.8334713,60.8245506\n\tc-12.6800432-12.6797676-12.6800432-33.3113136,0-45.9910812c6.1327686-6.1330462,14.2993946-9.5106535,22.9954014-9.5106535\n\tc8.6962814,0,16.8629074,3.3776073,22.9956779,9.5106535c4.9754143,4.9751434,8.1439781,11.283268,9.16325,18.2428341\n\tc0.9822769,6.7066154-0.1778412,13.6949005-3.2668686,19.6829681c-0.006073,0.0400391-0.0033112,0.0985832,0.0066299,0.1206779\n\tL70.6069336,56.7549057z"}));
}

GlowforgeIcon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 75.685379 91.3530807","style":{"enableBackground":"new 0 0 75.685379 91.3530807"},"xmlSpace":"preserve"};

module.exports = GlowforgeIcon;

GlowforgeIcon.default = GlowforgeIcon;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function GlowforgeLogo (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Logo","transform":"translate(-30.934 -0.537)"},React.createElement("g",{"id":"Layer_5","data-name":"Layer 5","transform":"translate(0 0.015)"},[React.createElement("g",{"id":"Registered_Trademark","data-name":"Registered Trademark","transform":"translate(157.637 6.192)","key":0},React.createElement("path",{"id":"Path_1","data-name":"Path 1","d":"M425,17.648a1.752,1.752,0,1,1-.934-.934,1.739,1.739,0,0,1,.934.934ZM423.942,17a1.439,1.439,0,1,0,.766.766,1.426,1.426,0,0,0-.766-.766Zm-.172,1.506.4.73a.059.059,0,0,1,0,.061.055.055,0,0,1-.053.031h-.3a.056.056,0,0,1-.055-.033l-.38-.715h-.3v.685a.062.062,0,0,1-.018.045.061.061,0,0,1-.045.017h-.262a.061.061,0,0,1-.045-.017.062.062,0,0,1-.018-.045V17.39a.06.06,0,0,1,.063-.063h.576a1.1,1.1,0,0,1,.372.047.508.508,0,0,1,.262.214.648.648,0,0,1,.1.352.636.636,0,0,1-.083.324.526.526,0,0,1-.226.214l.018.031Zm-.1-.558a.246.246,0,0,0-.117-.237.524.524,0,0,0-.229-.035h-.241v.55h.317a.265.265,0,0,0,.2-.073.282.282,0,0,0,.07-.205Z","transform":"translate(-421.628 -16.576)","fill":"#27b8ce"})),React.createElement("path",{"id":"Path_2","data-name":"Path 2","d":"M128.615,22.725h2.309l-1.09-2.046H129.1c-.752,0-1.076-.621-1.076-1.6V5.29c0-2.157-1.123-3.488-2.988-3.488h-1.2V3.849h.838A1.08,1.08,0,0,1,125.712,5V18.766C125.712,21.016,126.28,22.725,128.615,22.725Z","transform":"translate(-77.537 -1.134)","fill":"#27b8ce","key":1}),React.createElement("path",{"id":"Path_3","data-name":"Path 3","d":"M149.507,16.742a7.784,7.784,0,0,0-7.925,7.808,7.94,7.94,0,1,0,15.881,0A7.8,7.8,0,0,0,149.507,16.742Zm.029,13.659a5.662,5.662,0,0,1-5.586-5.85,5.572,5.572,0,1,1,11.145,0,5.65,5.65,0,0,1-5.558,5.85Z","transform":"translate(-88.648 -10.487)","fill":"#27b8ce","key":2}),React.createElement("path",{"id":"Path_4","data-name":"Path 4","d":"M216.181,7.419h-4.764V7.05c0-3.076,1.958-3.535,3.125-3.535a3.448,3.448,0,0,1,.67.055l.192.042V1.493l-.133-.022a6.272,6.272,0,0,0-.934-.061c-1.572,0-5.229.55-5.229,5.639v.369h-3.646c-1.345,0-1.985.243-2.466,1.75l-3.049,9.352c-.08.25-.163.544-.246.874l-.056.221-.064-.219c-.1-.337-.19-.632-.271-.877L195.669,7.478h-2.222l-3.641,11.041c-.083.25-.178.555-.28.906l-.062.213-.058-.214c-.094-.349-.184-.653-.267-.9l-3.019-9.35c-.479-1.5-1.036-1.752-2.467-1.752h-2.566l1.144,2.046h.777c.513,0,.735.143.876.568l4.257,12.446H190.6l3.612-10.857c.073-.2.141-.469.2-.7.031-.12.059-.231.085-.322l.061-.213.058.214c.027.1.058.227.09.361.053.221.113.471.173.661l3.642,10.859h2.425L205.2,10.031a.774.774,0,0,1,.876-.565h3.03V22.479h2.31V9.467h3.689Z","transform":"translate(-113.384 -0.889)","fill":"#27b8ce","key":3}),React.createElement("path",{"id":"Path_5","data-name":"Path 5","d":"M280.17,16.539a7.784,7.784,0,0,0-7.925,7.808,7.94,7.94,0,0,0,15.881,0A7.8,7.8,0,0,0,280.17,16.539ZM280.2,30.2a5.662,5.662,0,0,1-5.587-5.85,5.572,5.572,0,1,1,11.145,0A5.65,5.65,0,0,1,280.2,30.2Z","transform":"translate(-170.458 -10.36)","fill":"#27b8ce","key":4}),React.createElement("path",{"id":"Path_6","data-name":"Path 6","d":"M322.746,19.394h0l.984-2.142h0a3.348,3.348,0,0,0-1.212-.167,5.082,5.082,0,0,0-4.385,2.967l-.118.238v-.62c0-1.694-1.038-2.439-2.7-2.439h-2.687l1.075,2.046h.888c.779,0,1.149.393,1.149,1.4V32.29h2.31V25.918C318.046,21.765,319.627,19.57,322.746,19.394Z","transform":"translate(-195.741 -10.7)","fill":"#27b8ce","key":5}),React.createElement("path",{"id":"Path_7","data-name":"Path 7","d":"M355.069,19.529a.482.482,0,0,1,.549-.549h1.3l1.187-1.922h-3.335c-1.189,0-1.767.559-1.767,1.709v.243l-.114-.177c-.513-.794-1.812-2.126-4.743-2.126-3.94,0-6.486,2.96-6.486,7.541a8.3,8.3,0,0,0,1.822,5.5,6.173,6.173,0,0,0,4.84,2.155,5,5,0,0,0,4.459-2.174l.12-.18-.006.216c0,.163-.008.352-.008.547v1.29c0,2.882-1.845,4.535-5.062,4.535l-.179,0v2.007h.1l.061,0,.081,0c3.475,0,7.189-1.735,7.189-6.6Zm-6.457,10.4c-2.862,0-4.711-2.24-4.711-5.707,0-3.5,1.621-5.5,4.447-5.5,3.071,0,4.564,1.809,4.564,5.531C352.913,27.91,351.386,29.926,348.613,29.926Z","transform":"translate(-213.92 -10.467)","fill":"#27b8ce","key":6}),React.createElement("path",{"id":"Path_8","data-name":"Path 8","d":"M88.882,38.148l.08,0c3.476,0,7.189-1.735,7.189-6.6V19.53a.482.482,0,0,1,.548-.549H98V17.059H95.85c-1.189,0-1.767.559-1.767,1.709v.243l-.114-.177c-.513-.794-1.812-2.126-4.743-2.126-3.94,0-6.486,2.96-6.486,7.541a8.3,8.3,0,0,0,1.822,5.5,6.173,6.173,0,0,0,4.84,2.155,5,5,0,0,0,4.459-2.174l.12-.18-.006.216c0,.163-.008.352-.008.547v1.29c0,2.882-1.845,4.535-5.062,4.535l-.179,0v2.007h.095Zm.813-8.222c-2.862,0-4.711-2.24-4.711-5.707,0-3.5,1.621-5.5,4.447-5.5C92.5,18.717,94,20.527,94,24.249c0,3.661-1.527,5.678-4.3,5.678Z","transform":"translate(-51.805 -10.467)","fill":"#27b8ce","key":7}),React.createElement("path",{"id":"Path_9","data-name":"Path 9","d":"M391.737,16.54a7.3,7.3,0,0,0-5.231,2.1,8,8,0,0,0-2.2,5.794,7.609,7.609,0,0,0,7.867,7.867,8.209,8.209,0,0,0,2.947-.555l.142-.055-.673-1.971-.154.06a5.981,5.981,0,0,1-2.175.415,5.449,5.449,0,0,1-5.55-5.481l0-.065h11.3l.014-.15c.01-.11.059-.676.059-1C398.08,20.035,396.118,16.54,391.737,16.54Zm-4.91,6.214.016-.075a4.915,4.915,0,0,1,4.866-4.152c2.243,0,3.809,1.633,3.991,4.16l0,.066Z","transform":"translate(-240.625 -10.361)","fill":"#27b8ce","key":8})])));
}

GlowforgeLogo.defaultProps = {"width":"130.21","height":"27.162","viewBox":"0 0 130.21 27.162"};

module.exports = GlowforgeLogo;

GlowforgeLogo.default = GlowforgeLogo;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.94 3.25C10.75 1.34 12.59 0 14.74 0 17.63 0 19.71 2.47 19.97 5.42 19.97 5.42 20.11 6.15 19.8 7.47 19.38 9.26 18.38 10.85 17.04 12.07L9.94 18.4 2.96 12.07C1.62 10.85 0.62 9.26 0.2 7.47 -0.11 6.15 0.03 5.42 0.03 5.42 0.29 2.47 2.37 0 5.26 0 7.41 0 9.13 1.34 9.94 3.25L9.94 3.25Z"}));
}

Heart.defaultProps = {"viewBox":"0 0 20 19"};

module.exports = Heart;

Heart.default = Heart;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function ImgPlaceholder (props) {
    return React.createElement("svg",props,React.createElement("switch",null,[React.createElement("foreignObject",{"requiredExtensions":"http://ns.adobe.com/AdobeIllustrator/10.0/","width":"1","height":"1","key":0}),React.createElement("path",{"d":"M-864.2 953.5h-69.6c-7 0-12.7 5.7-12.7 12.7v69.6c0 7 5.7 12.7 12.7 12.7h69.6c7 0 12.7-5.7 12.7-12.7v-69.6C-851.5 959.2-857.2 953.5-864.2 953.5zM-933.8 960.6h69.6c3.1 0 5.6 2.5 5.6 5.6v37.1l-16.1-20.3c-1.9-2.5-5.7-2.5-7.6 0l-23.5 29.7 -9.8-10.7c-2-2.2-5.5-2.2-7.5 0l-16.3 17.7v-53.5C-939.4 963.1-936.9 960.6-933.8 960.6z","key":1}),React.createElement("circle",{"cx":"-922","cy":"978","r":"8","key":2})]));
}

ImgPlaceholder.defaultProps = {"viewBox":"-949 951 100 100"};

module.exports = ImgPlaceholder;

ImgPlaceholder.default = ImgPlaceholder;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function InfoCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M50 6.45a42.5 42.5 0 0 0-21.88 5.85A43.58 43.58 0 0 0 12.3 28.12 42.5 42.5 0 0 0 6.45 50a42.5 42.5 0 0 0 5.85 21.88A43.58 43.58 0 0 0 28.12 87.7 42.5 42.5 0 0 0 50 93.55a42.5 42.5 0 0 0 21.88-5.85A43.58 43.58 0 0 0 87.7 71.87 42.5 42.5 0 0 0 93.55 50a42.5 42.5 0 0 0-5.85-21.88A43.35 43.35 0 0 0 71.77 12.3 42.66 42.66 0 0 0 50 6.45zM50 0c9 0 17.34 2.25 25 6.75A50.52 50.52 0 0 1 93.25 25c4.5 7.66 6.75 16 6.75 25s-2.25 17.34-6.75 25A50.52 50.52 0 0 1 75 93.25c-7.66 4.5-16 6.75-25 6.75s-17.34-2.25-25-6.75A50.52 50.52 0 0 1 6.75 75C2.25 67.34 0 59 0 50s2.25-17.34 6.75-25A50.52 50.52 0 0 1 25 6.75C32.66 2.25 41 0 50 0zm-4.84 69.35V45.16h-2.42c-.67 0-1.24-.23-1.71-.7a2.33 2.33 0 0 1-.7-1.72v-1.61c0-.67.23-1.24.7-1.71.47-.48 1.04-.71 1.71-.71h9.68c.67 0 1.24.23 1.71.7.47.48.7 1.05.7 1.72v28.22h2.43c.67 0 1.24.24 1.71.71s.7 1.04.7 1.71v1.62c0 .67-.23 1.24-.7 1.71s-1.04.7-1.71.7H42.74c-.67 0-1.24-.23-1.71-.7a2.33 2.33 0 0 1-.7-1.71v-1.62c0-.67.23-1.24.7-1.71s1.04-.7 1.71-.7h2.42zM50 20.97a6.2 6.2 0 0 1 4.54 1.91 6.2 6.2 0 0 1 1.91 4.54 6.2 6.2 0 0 1-1.91 4.54A6.2 6.2 0 0 1 50 33.87a6.2 6.2 0 0 1-4.54-1.91 6.2 6.2 0 0 1-1.91-4.54 6.2 6.2 0 0 1 1.91-4.54A6.2 6.2 0 0 1 50 20.97z"}));
}

InfoCircle.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = InfoCircle;

InfoCircle.default = InfoCircle;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Info (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"  all"),React.createElement("g",{"data-name":"Zoom In","key":1},React.createElement("g",{"data-name":"Calendar"},[React.createElement("path",{"d":"M56.7 76.6H43.3v-33H56.7v33ZM50 38.1a7.3 7.3 0 1 1 7.3-7.3A7.3 7.3 0 0 1 50 38.1Z","key":0}),React.createElement("path",{"d":"M85.4 14.6a50 50 0 1 0 0 70.7A49.8 49.8 0 0 0 85.4 14.6ZM79.8 79.8A42.2 42.2 0 0 1 20.2 20.2a42.2 42.2 0 0 1 59.7 0h0A42.2 42.2 0 0 1 79.8 79.8Z","key":1}),React.createElement("circle",{"cx":"50","cy":"30.7","r":"7.3","key":2}),React.createElement("rect",{"x":"43.3","y":"43.6","width":"13.4","height":"33","key":3})]))]);
}

Info.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 100 100"};

module.exports = Info;

Info.default = Info;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Lock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.95 7C13.18 7 13.4 7.04 13.6 7.13 13.8 7.21 13.97 7.33 14.12 7.48 14.26 7.63 14.38 7.81 14.47 8.01 14.55 8.21 14.6 8.43 14.6 8.65L14.6 17.45C14.6 17.68 14.55 17.9 14.47 18.1 14.38 18.3 14.26 18.47 14.12 18.62 13.97 18.76 13.8 18.88 13.6 18.97 13.4 19.05 13.18 19.1 12.95 19.1L1.95 19.1C1.72 19.1 1.51 19.05 1.31 18.97 1.11 18.88 0.93 18.76 0.78 18.62 0.63 18.47 0.51 18.3 0.43 18.1 0.34 17.9 0.3 17.68 0.3 17.45L0.3 8.65C0.3 8.43 0.34 8.21 0.43 8.01 0.51 7.81 0.63 7.63 0.78 7.48 0.93 7.33 1.11 7.21 1.31 7.13 1.51 7.04 1.72 7 1.95 7L2.5 7 2.5 5.35C2.5 4.67 2.63 4.02 2.89 3.42 3.15 2.82 3.51 2.3 3.96 1.85 4.4 1.4 4.93 1.05 5.53 0.79 6.13 0.53 6.77 0.4 7.45 0.4 8.13 0.4 8.77 0.53 9.38 0.79 9.98 1.05 10.5 1.4 10.95 1.85 11.4 2.3 11.75 2.82 12.01 3.42 12.27 4.02 12.4 4.67 12.4 5.35L12.4 7 12.95 7ZM3.6 5.35L3.6 7 11.3 7 11.3 5.35C11.3 4.82 11.2 4.32 11 3.85 10.8 3.39 10.52 2.98 10.17 2.63 9.82 2.28 9.41 2 8.95 1.8 8.48 1.6 7.98 1.5 7.45 1.5 6.92 1.5 6.42 1.6 5.95 1.8 5.48 2 5.08 2.28 4.73 2.63 4.38 2.98 4.11 3.39 3.9 3.85 3.7 4.32 3.6 4.82 3.6 5.35ZM13.5 17.45L13.5 8.65C13.5 8.58 13.49 8.5 13.46 8.43 13.43 8.37 13.39 8.31 13.34 8.26 13.29 8.21 13.23 8.17 13.16 8.14 13.09 8.11 13.02 8.1 12.95 8.1L1.95 8.1C1.87 8.1 1.8 8.11 1.74 8.14 1.67 8.17 1.62 8.21 1.57 8.26 1.52 8.31 1.48 8.37 1.45 8.43 1.42 8.5 1.4 8.58 1.4 8.65L1.4 17.45C1.4 17.52 1.42 17.59 1.45 17.66 1.48 17.73 1.52 17.79 1.57 17.84 1.62 17.89 1.67 17.93 1.74 17.96 1.8 17.99 1.87 18 1.95 18L12.95 18C13.02 18 13.09 17.99 13.16 17.96 13.23 17.93 13.29 17.89 13.34 17.84 13.39 17.79 13.43 17.73 13.46 17.66 13.49 17.59 13.5 17.52 13.5 17.45Z"}));
}

Lock.defaultProps = {"viewBox":"0 0 15 20"};

module.exports = Lock;

Lock.default = Lock;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function LongArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M295.515 115.716l-19.626 19.626c-4.753 4.753-4.675 12.484.173 17.14L356.78 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h344.78l-80.717 77.518c-4.849 4.656-4.927 12.387-.173 17.14l19.626 19.626c4.686 4.686 12.284 4.686 16.971 0l131.799-131.799c4.686-4.686 4.686-12.284 0-16.971L312.485 115.716c-4.686-4.686-12.284-4.686-16.97 0z"}));
}

LongArrowRight.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"far","data-icon":"long-arrow-right","className":"svg-inline--fa fa-long-arrow-right fa-w-14","role":"img","viewBox":"0 0 448 512"};

module.exports = LongArrowRight;

LongArrowRight.default = LongArrowRight;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0 -952.36)"},React.createElement("path",{"d":"m13 974.36c-2.2091 0-4 1.7908-4 4 0 2.2092 1.7909 4 4 4h74c2.2091 0 4-1.7908 4-4 0-2.2092-1.7909-4-4-4zm0 24c-2.2091 0-4 1.7908-4 4s1.7909 4 4 4h74c2.2091 0 4-1.7908 4-4s-1.7909-4-4-4zm0 24c-2.2091 0-4 1.7908-4 4s1.7909 4 4 4h74c2.2091 0 4-1.7908 4-4s-1.7909-4-4-4z","color":"#000000","overflow":"visible","style":{"blockProgression":"tb","textIndent":"0","textTransform":"none"}})));
}

Menu.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = Menu;

Menu.default = Menu;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.21 9.21L12.21 7.93C12.21 7.75 12.15 7.6 12.02 7.48 11.9 7.35 11.75 7.29 11.57 7.29L3.86 7.29C3.68 7.29 3.53 7.35 3.41 7.48 3.28 7.6 3.21 7.75 3.21 7.93L3.21 9.21C3.21 9.39 3.28 9.54 3.41 9.67 3.53 9.79 3.68 9.86 3.86 9.86L11.57 9.86C11.75 9.86 11.9 9.79 12.02 9.67 12.15 9.54 12.21 9.39 12.21 9.21ZM15.43 8.57C15.43 9.97 15.08 11.26 14.39 12.44 13.7 13.63 12.77 14.56 11.59 15.25 10.4 15.94 9.11 16.29 7.71 16.29 6.31 16.29 5.02 15.94 3.84 15.25 2.66 14.56 1.72 13.63 1.03 12.44 0.34 11.26 0 9.97 0 8.57 0 7.17 0.34 5.88 1.03 4.7 1.72 3.52 2.66 2.58 3.84 1.89 5.02 1.2 6.31 0.86 7.71 0.86 9.11 0.86 10.4 1.2 11.59 1.89 12.77 2.58 13.7 3.52 14.39 4.7 15.08 5.88 15.43 7.17 15.43 8.57Z"}));
}

Minus.defaultProps = {"viewBox":"0 0 16 17"};

module.exports = Minus;

Minus.default = Minus;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function PencilRuler (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M109.5 244L244 109.5l-44-44.1-61.8 61.6a8 8 0 0 1-11.2 0l-11.2-11.2a8 8 0 0 1 0-11.2L177.5 43 143.9 9.3a31.7 31.7 0 0 0-44.9 0L9.3 99a31.7 31.7 0 0 0 0 44.9L109.5 244zm388.4-116.8a48 48 0 0 0 0-67.9l-45.2-45.2a48 48 0 0 0-68 0l-46 46L452 173.3l46-46zM316.1 82.7l-297 297L.3 487A21.2 21.2 0 0 0 25 511.7l107.5-18.9L429.3 196 316 82.7zm186.6 285.4l-33.6-33.6-61.7 61.7a8 8 0 0 1-11.2 0L385 385a8 8 0 0 1 0-11.2l61.7-61.7-44.2-44.2L268 402.5l100.2 100.2a31.7 31.7 0 0 0 44.9 0l89.7-89.7a31.7 31.7 0 0 0 0-44.9z"}));
}

PencilRuler.defaultProps = {"aria-hidden":"true","data-icon":"pencil-ruler","viewBox":"0 0 512 512"};

module.exports = PencilRuler;

PencilRuler.default = PencilRuler;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function PlayButton (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"className":"outer-circle","cx":"89","cy":"89","r":"89","fill":"#000","fillOpacity":".2","key":0}),React.createElement("circle",{"className":"inner-circle","cx":"89","cy":"89","r":"71","fill":"#009FAF","fillOpacity":".3","key":1}),React.createElement("path",{"className":"right-triangle","fill":"#FFF","d":"M70.57 53.537l51.837 31.066a5 5 0 0 1 .012 8.57L70.582 124.43A5 5 0 0 1 63 120.147V57.826a5 5 0 0 1 7.57-4.29z","key":2})]));
}

PlayButton.defaultProps = {"width":"178","height":"178","viewBox":"0 0 178 178"};

module.exports = PlayButton;

PlayButton.default = PlayButton;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function PlayCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"white","d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"}));
}

PlayCircle.defaultProps = {"aria-hidden":"true","data-prefix":"fas","data-icon":"play-circle","className":"svg-inline--fa fa-play-circle fa-w-16","role":"img","viewBox":"0 0 512 512"};

module.exports = PlayCircle;

PlayCircle.default = PlayCircle;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function PlusSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M416 208H272V64a32 32 0 0 0-32-32h-32a32 32 0 0 0-32 32v144H32a32 32 0 0 0-32 32v32a32 32 0 0 0 32 32h144v144a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V304h144a32 32 0 0 0 32-32v-32a32 32 0 0 0-32-32z"}));
}

PlusSolid.defaultProps = {"aria-hidden":"true","data-icon":"plus","viewBox":"0 0 448 512"};

module.exports = PlusSolid;

PlusSolid.default = PlusSolid;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.21 8.36L12.21 7.07C12.21 6.9 12.15 6.75 12.02 6.62 11.9 6.49 11.75 6.43 11.57 6.43L9 6.43 9 3.86C9 3.68 8.94 3.53 8.81 3.41 8.68 3.28 8.53 3.21 8.36 3.21L7.07 3.21C6.9 3.21 6.75 3.28 6.62 3.41 6.49 3.53 6.43 3.68 6.43 3.86L6.43 6.43 3.86 6.43C3.68 6.43 3.53 6.49 3.41 6.62 3.28 6.75 3.21 6.9 3.21 7.07L3.21 8.36C3.21 8.53 3.28 8.68 3.41 8.81 3.53 8.94 3.68 9 3.86 9L6.43 9 6.43 11.57C6.43 11.75 6.49 11.9 6.62 12.02 6.75 12.15 6.9 12.21 7.07 12.21L8.36 12.21C8.53 12.21 8.68 12.15 8.81 12.02 8.94 11.9 9 11.75 9 11.57L9 9 11.57 9C11.75 9 11.9 8.94 12.02 8.81 12.15 8.68 12.21 8.53 12.21 8.36ZM15.43 7.71C15.43 9.11 15.08 10.4 14.39 11.59 13.7 12.77 12.77 13.7 11.59 14.39 10.4 15.08 9.11 15.43 7.71 15.43 6.31 15.43 5.02 15.08 3.84 14.39 2.66 13.7 1.72 12.77 1.03 11.59 0.34 10.4 0 9.11 0 7.71 0 6.31 0.34 5.02 1.03 3.84 1.72 2.66 2.66 1.72 3.84 1.03 5.02 0.34 6.31 0 7.71 0 9.11 0 10.4 0.34 11.59 1.03 12.77 1.72 13.7 2.66 14.39 3.84 15.08 5.02 15.43 6.31 15.43 7.71Z"}));
}

Plus.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Plus;

Plus.default = Plus;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function PremiumGem (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M2.715 0L0 3.484h3.121L4.488 0H2.715zm2.731 0L4.075 3.484h4.45L7.154 0H5.446zm2.666 0l1.367 3.484H12.6L9.885 0H8.112zM.028 4.48l4.95 5.775-1.87-5.775H.027zm4.019 0L6.3 11.442 8.554 4.48H4.047zm5.446 0l-1.871 5.775 4.95-5.775h-3.08z"}));
}

PremiumGem.defaultProps = {"width":"13","height":"12"};

module.exports = PremiumGem;

PremiumGem.default = PremiumGem;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function ProofgradeBadge (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},".a{fill:#ECECEC;}.b{fill:#D3B95F;}"),React.createElement("title",{"key":1},"  Page 1"),React.createElement("desc",{"key":2},"  Created with Sketch."),React.createElement("g",{"transform":"translate(-306 -2172)translate(306 2172)","key":3},[React.createElement("path",{"d":"M130.92 67.73C130.92 84.69 124.32 100.63 112.32 112.62 100.33 124.62 84.39 131.22 67.42 131.22 50.46 131.22 34.52 124.62 22.53 112.62 10.53 100.63 3.93 84.69 3.93 67.73 3.93 50.76 10.53 34.82 22.53 22.83 34.52 10.83 50.46 4.23 67.42 4.23 84.39 4.23 100.33 10.83 112.32 22.83 124.32 34.82 130.92 50.76 130.92 67.73M129.55 41.48C126.15 33.45 121.29 26.24 115.1 20.05 108.91 13.86 101.7 9 93.67 5.6 85.36 2.08 76.53 0.3 67.42 0.3 58.32 0.3 49.49 2.08 41.18 5.6 33.15 9 25.94 13.86 19.75 20.05 13.56 26.24 8.7 33.45 5.3 41.48 1.78 49.79 0 58.62 0 67.73 0 76.83 1.78 85.66 5.3 93.97 8.7 102 13.56 109.21 19.75 115.4 25.94 121.59 33.15 126.45 41.18 129.85 49.49 133.37 58.32 135.15 67.42 135.15 76.53 135.15 85.36 133.37 93.67 129.85 101.7 126.45 108.91 121.59 115.1 115.4 121.29 109.21 126.15 102 129.55 93.97 133.07 85.66 134.85 76.83 134.85 67.73 134.85 58.62 133.07 49.79 129.55 41.48","className":"a","key":0}),React.createElement("polygon",{"points":"81.92 68.55 69.18 61.27 69.18 46.66 94.67 61.12","className":"b","key":1}),React.createElement("polygon",{"points":"56.43 83 43.69 75.72 43.69 61.11 69.18 75.57","className":"b","key":2}),React.createElement("path",{"d":"M95.11 60.36L69.63 45.9 69.63 45.9C69.42 45.78 69.18 45.75 68.96 45.81 68.95 45.81 68.95 45.81 68.95 45.81 68.93 45.82 68.9 45.83 68.88 45.83 68.87 45.84 68.85 45.84 68.84 45.85 68.82 45.85 68.81 45.86 68.79 45.87 68.77 45.88 68.75 45.89 68.73 45.9L68.73 45.9 68.73 45.9 43.38 60.29C43.33 60.3 43.29 60.32 43.24 60.35 42.97 60.5 42.8 60.79 42.8 61.11L42.8 75.72C42.8 76.03 42.97 76.32 43.24 76.48L55.87 83.69C55.9 83.72 55.94 83.75 55.98 83.77L68.72 91.2C68.87 91.28 69.02 91.32 69.18 91.32 69.34 91.32 69.49 91.28 69.63 91.2L82.37 83.92C82.65 83.76 82.82 83.47 82.82 83.16L82.82 69.05 95.12 61.88C95.4 61.72 95.56 61.43 95.56 61.12 95.56 60.81 95.39 60.52 95.11 60.36L95.11 60.36ZM69.36 74.66L58.43 68.46 69.18 62.28 80.14 68.55 69.36 74.66ZM68.28 60.76L56.64 67.44 52.02 64.82 68.28 55.71 68.28 60.76ZM68.28 53.68L50.23 63.8 45.49 61.12 68.28 48.18 68.28 53.68ZM44.59 62.65L56.17 69.23C56.23 69.27 56.29 69.29 56.35 69.31L67.41 75.58 56.43 81.98 44.59 75.21 44.59 62.65ZM81.03 70.07L81.03 75.57 62.87 85.75 58.21 83.03 81.03 70.07ZM69.19 89.42L64.64 86.78 81.03 77.6 81.03 82.65 69.19 89.42ZM81.91 67.53L70.07 60.76 70.07 48.18 92.89 61.13 81.91 67.53Z","fill":"#1E1F1E","key":3}),React.createElement("path",{"d":"M30.76 103.09C31.11 103.46 31.56 103.52 31.91 103.2 32.27 102.87 32.24 102.41 31.9 102.04L31.36 101.46 30.23 102.51 30.76 103.09ZM29.37 103.29L27.76 104.76 26.85 103.77 31.3 99.67 32.85 101.35C33.68 102.25 33.66 103.42 32.83 104.19 31.99 104.96 30.83 104.88 30 103.97L29.37 103.29Z","key":4}),React.createElement("path",{"d":"M37.09 108.74C37.53 109.08 37.95 109.02 38.21 108.68 38.49 108.32 38.42 107.91 37.98 107.57L37.35 107.09 36.46 108.25 37.09 108.74ZM36.13 109.47L35.75 109.17 34.37 110.96 33.3 110.14 37 105.34 38.9 106.8C39.85 107.53 39.96 108.65 39.3 109.5 38.8 110.15 38.06 110.37 37.31 110.13L36.79 112.82 35.61 111.91 36.13 109.47Z","key":5}),React.createElement("path",{"d":"M43.92 115.64C44.67 116.02 45.73 115.92 46.3 114.8 46.87 113.67 46.32 112.75 45.58 112.37 44.82 111.99 43.76 112.09 43.19 113.22 42.62 114.35 43.17 115.26 43.92 115.64M46.17 111.2C47.69 111.96 48.42 113.72 47.55 115.44 46.69 117.14 44.84 117.6 43.32 116.83 41.8 116.06 41.07 114.3 41.93 112.59 42.8 110.88 44.65 110.42 46.17 111.2","key":6}),React.createElement("path",{"d":"M53.87 119.45C54.67 119.67 55.69 119.36 56.02 118.14 56.35 116.91 55.63 116.13 54.82 115.91 54 115.69 52.98 116.01 52.65 117.23 52.32 118.45 53.05 119.23 53.87 119.45M55.16 114.64C56.8 115.08 57.87 116.65 57.37 118.51 56.88 120.36 55.16 121.18 53.52 120.73 51.87 120.29 50.8 118.72 51.29 116.87 51.79 115.02 53.51 114.2 55.16 114.64","key":7}),React.createElement("polygon",{"points":"61.44 122.13 61.91 116.1 65.8 116.4 65.7 117.68 63.16 117.48 63.06 118.76 65.3 118.93 65.2 120.16 62.97 119.98 62.79 122.24","key":8}),React.createElement("path",{"d":"M74.58 122L74.43 121.39C74.21 121.8 73.67 122.22 72.81 122.3 71.14 122.47 69.64 121.37 69.45 119.47 69.26 117.57 70.58 116.18 72.28 116.01 74 115.84 74.9 116.78 75.25 117.6L74 118.17C73.87 117.81 73.4 117.17 72.4 117.27 71.58 117.35 70.68 117.99 70.81 119.33 70.94 120.59 71.83 121.16 72.81 121.07 73.81 120.97 74.16 120.28 74.2 119.93L72.39 120.11 72.28 118.97 75.35 118.67 75.67 121.89 74.58 122Z","key":9}),React.createElement("path",{"d":"M81.73 116.96C82.26 116.8 82.46 116.42 82.34 116.01 82.21 115.58 81.85 115.39 81.31 115.55L80.55 115.77 80.97 117.18 81.73 116.96ZM81.75 118.16L81.3 118.29 81.93 120.46 80.64 120.84 78.93 115.03 81.23 114.35C82.38 114.01 83.34 114.58 83.65 115.62 83.88 116.4 83.62 117.13 82.98 117.59L84.86 119.6 83.43 120.02 81.75 118.16Z","key":10}),React.createElement("path",{"d":"M89.82 114.82L91.13 114.16 89.54 112.62 89.82 114.82ZM92.07 115.06L89.98 116.12 90.15 117.42 88.89 118.06 88.18 111.62 89.57 110.92 94.33 115.29 93.02 115.96 92.07 115.06Z","key":11}),React.createElement("path",{"d":"M99.17 110.41C99.9 109.84 100.17 108.95 99.43 107.99 98.69 107.03 97.75 107.07 97.01 107.64L96.39 108.12 98.55 110.89 99.17 110.41ZM98.26 112.73L94.55 107.94 96.28 106.6C97.72 105.48 99.39 105.65 100.54 107.12 101.69 108.6 101.43 110.26 99.99 111.38L98.26 112.73Z","key":12}),React.createElement("polygon",{"points":"105.9 106.14 101.4 102.08 103.97 99.23 104.92 100.09 103.25 101.93 104.11 102.71 105.62 101.03 106.5 101.83 104.99 103.5 105.86 104.28 107.52 102.43 108.48 103.28","key":13}),React.createElement("path",{"d":"M19.27 47.79C19 47.71 18.47 47.73 18.17 48.4 17.96 48.86 18.12 49.29 18.43 49.42 18.69 49.54 18.96 49.46 19.2 49.11L19.67 48.43C20.33 47.46 21.25 47.22 22.04 47.57 22.91 47.95 23.47 49.07 22.89 50.39 22.21 51.92 20.92 52.14 20.11 51.87L20.34 50.61C20.87 50.79 21.46 50.65 21.8 49.89 22.01 49.4 21.91 49 21.57 48.85 21.29 48.73 20.98 48.86 20.75 49.2L20.27 49.89C19.68 50.75 18.8 51.04 17.98 50.68 16.93 50.22 16.61 48.97 17.08 47.91 17.69 46.53 18.75 46.37 19.45 46.54L19.27 47.79Z","key":14}),React.createElement("path",{"d":"M24.13 42.63L24.94 41.41 22.8 40.85 24.13 42.63ZM26.2 41.73L24.91 43.68 25.7 44.72 24.91 45.9 21.13 40.66 21.99 39.36 28.28 40.82 27.47 42.05 26.2 41.73Z","key":15}),React.createElement("polygon",{"points":"30.38 38.34 25.96 34.2 28.62 31.35 29.56 32.23 27.81 34.09 28.75 34.97 30.28 33.33 31.18 34.17 29.65 35.8 31.31 37.35","key":16}),React.createElement("polygon",{"points":"35.61 33.17 31.87 28.4 34.89 26.03 35.68 27.04 33.72 28.57 34.43 29.48 36.21 28.09 36.94 29.02 35.17 30.41 35.88 31.33 37.85 29.79 38.64 30.8","key":17}),React.createElement("polygon",{"points":"41.88 23.22 44.18 27.4 42.99 28.05 40.7 23.87 39.07 24.77 38.44 23.63 42.9 21.19 43.52 22.32","key":18}),React.createElement("polygon",{"points":"46.51 19.57 48.01 19.06 49.91 20.78 50.37 18.25 51.79 17.76 50.92 21.79 51.74 24.18 50.46 24.62 49.64 22.23","key":19}),React.createElement("path",{"d":"M62.68 17.92L62.84 18.07 63.06 17.88C63.3 17.69 63.39 17.48 63.38 17.28 63.36 16.99 63.12 16.78 62.82 16.8 62.56 16.82 62.32 17 62.34 17.35 62.35 17.59 62.53 17.78 62.68 17.92L62.68 17.92ZM63.72 20.51L62.72 19.56 62.68 19.6C62.42 19.82 62.24 20.05 62.26 20.38 62.28 20.7 62.56 20.99 62.95 20.96 63.25 20.94 63.49 20.78 63.72 20.51L63.72 20.51ZM64.52 21.27C64.13 21.72 63.62 22.03 62.98 22.07 61.79 22.15 61.06 21.36 61.01 20.53 60.97 19.78 61.32 19.33 61.94 18.82L61.85 18.73C61.54 18.43 61.17 18.02 61.14 17.47 61.07 16.44 61.91 15.82 62.75 15.76 63.75 15.7 64.52 16.29 64.58 17.21 64.62 17.81 64.24 18.31 63.81 18.66L63.63 18.81 64.49 19.62 66 17.87 66.1 19.46 65.3 20.37 66.74 21.72 65.11 21.82 64.52 21.27Z","key":20}),React.createElement("path",{"d":"M77.21 21.74C77.41 21.78 77.62 21.8 77.84 21.77L77.17 20.63 78.21 20.09 78.87 21.23C79.07 21 79.22 20.71 79.3 20.33 79.57 19.09 78.81 18.34 77.99 18.16 77.17 17.98 76.16 18.35 75.89 19.58 75.62 20.82 76.39 21.56 77.21 21.74M78.27 16.88C79.93 17.24 81.08 18.75 80.67 20.63 80.5 21.43 80.1 22.04 79.57 22.46L80.13 23.41 79.1 23.95 78.55 22.99C78.04 23.15 77.48 23.16 76.93 23.04 75.26 22.68 74.11 21.16 74.52 19.29 74.93 17.41 76.6 16.51 78.27 16.88","key":21}),React.createElement("path",{"d":"M84.09 22.67L85.6 19.1 86.84 19.63 85.38 23.09C85.09 23.77 85.32 24.27 85.91 24.52 86.5 24.77 87.02 24.59 87.31 23.91L88.78 20.45 90.02 20.98 88.51 24.54C87.92 25.94 86.62 26.26 85.39 25.74 84.17 25.22 83.5 24.07 84.09 22.67","key":22}),React.createElement("path",{"d":"M93.56 27.09L94.79 27.89 95.32 25.74 93.56 27.09ZM94.48 29.15L92.52 27.88 91.48 28.67 90.29 27.9 95.5 24.06 96.81 24.92 95.4 31.22 94.17 30.42 94.48 29.15Z","key":23}),React.createElement("polygon",{"points":"97.9 33.3 102 28.84 102.99 29.75 99.77 33.26 101.69 35.03 100.82 35.98","key":24}),React.createElement("polygon",{"points":"103.11 38.52 107.75 34.63 108.63 35.68 103.98 39.57","key":25}),React.createElement("polygon",{"points":"111.8 42.38 107.76 44.92 107.05 43.78 111.08 41.24 110.09 39.66 111.18 38.98 113.89 43.28 112.79 43.97","key":26}),React.createElement("polygon",{"points":"115.71 46.78 116.31 48.25 114.7 50.25 117.26 50.56 117.83 51.95 113.76 51.32 111.42 52.28 110.9 51.03 113.24 50.07","key":27}),React.createElement("path",{"d":"M22.96 92.1C19.29 85.1 17.21 77.14 17.21 68.7 17.21 66.15 17.4 63.6 17.76 61.2L16.25 61.2C15.9 63.6 15.71 66.15 15.71 68.7 15.71 77.11 17.71 85.06 21.27 92.1L22.96 92.1Z","className":"a","key":28}),React.createElement("path",{"d":"M112.39 92.4L114.09 92.4C117.74 85.29 119.81 77.23 119.81 68.7 119.81 66.15 119.62 63.65 119.26 61.2L117.75 61.2C118.11 63.65 118.31 66.15 118.31 68.7 118.31 77.26 116.16 85.33 112.39 92.4","className":"a","key":29})])]);
}

ProofgradeBadge.defaultProps = {"viewBox":"0 0 135 136"};

module.exports = ProofgradeBadge;

ProofgradeBadge.default = ProofgradeBadge;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Proofgrade (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none"},[React.createElement("polygon",{"points":"22.1 12.8 14.9 8.7 14.9 0.5 29.2 8.7","fill":"#D3B95F","key":0}),React.createElement("polygon",{"points":"7.7 21 0.5 16.9 0.5 8.6 14.9 16.8","fill":"#D3B95F","key":1}),React.createElement("path",{"d":"M29.5 8.2L15.1 0.1 15.1 0.1C15 0 14.9 0 14.8 0 14.7 0 14.7 0 14.7 0 14.7 0 14.7 0 14.7 0 14.7 0 14.7 0 14.7 0 14.7 0 14.7 0 14.7 0 14.6 0.1 14.6 0.1 14.6 0.1L14.6 0.1 14.6 0.1 0.3 8.2C0.3 8.2 0.3 8.2 0.3 8.2 0.1 8.3 0 8.5 0 8.6L0 16.9C0 17.1 0.1 17.2 0.3 17.3L7.4 21.4C7.4 21.4 7.4 21.4 7.4 21.4L14.6 25.6C14.7 25.7 14.8 25.7 14.9 25.7 15 25.7 15.1 25.7 15.1 25.6L22.3 21.5C22.5 21.4 22.6 21.3 22.6 21.1L22.6 13.1 29.5 9.1C29.7 9 29.8 8.8 29.8 8.6 29.8 8.5 29.7 8.3 29.5 8.2L29.5 8.2ZM15 16.3L8.8 12.8 14.9 9.3 21.1 12.8 15 16.3ZM14.4 8.4L7.8 12.2 5.2 10.7 14.4 5.6 14.4 8.4ZM14.4 4.5L4.2 10.2 1.5 8.6 14.4 1.4 14.4 4.5ZM1 9.5L7.5 13.2C7.6 13.2 7.6 13.3 7.6 13.3L13.9 16.8 7.7 20.4 1 16.6 1 9.5ZM21.6 13.7L21.6 16.8 11.3 22.5 8.7 21 21.6 13.7ZM14.9 24.6L12.3 23.1 21.6 17.9 21.6 20.8 14.9 24.6ZM22.1 12.3L15.4 8.4 15.4 1.4 28.2 8.7 22.1 12.3Z","fill":"#1E1F1E","key":2})]));
}

Proofgrade.defaultProps = {"width":"30","height":"26","viewBox":"0 0 30 26"};

module.exports = Proofgrade;

Proofgrade.default = Proofgrade;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Remove (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M648.59 99.88H509.16C500.28 43.49 452.76 0 394.44 0S287.7 43.49 279.73 99.88H142.32c-26.73 0-48.43 21.79-48.43 48.43v49.44c0 24.72 17.76 44.49 41.56 47.42V727.64c0 35.61 28.66 64.27 64.27 64.27h392.48c35.61 0 64.27-28.65 64.27-64.27V246.09c23.71-3.94 41.56-23.71 41.56-47.42v-49.44C697.02 121.67 675.23 99.88 648.59 99.88zM394.44 36.62c38.54 0 70.22 26.73 77.08 63.26H316.35C324.23 64.27 355.9 36.62 394.44 36.62zM618.92 728.74c0 14.83-11.9 27.65-27.65 27.65H198.71c-14.83 0-27.65-11.9-27.65-27.65V247.19h446.95v481.55H618.92zM660.4 197.75c0 6.96-4.94 11.9-11.9 11.9H142.22c-6.96 0-11.9-4.94-11.9-11.9v-49.44c0-6.96 4.94-11.9 11.9-11.9h505.27c6.96 0 11.9 4.94 11.9 11.9v49.44H660.4zM253.09 661.45V349.08c0-9.89 7.87-17.76 17.76-17.76s17.76 7.87 17.76 17.76V661.45c0 9.89-7.87 17.76-17.76 17.76C260.96 680.31 253.09 671.34 253.09 661.45zM378.61 661.45V349.08c0-9.89 7.87-17.76 17.76-17.76 9.89 0 17.76 7.87 17.76 17.76V661.45c0 9.89-7.87 17.76-17.76 17.76C386.57 680.31 378.61 671.34 378.61 661.45zM504.21 661.45V349.08c0-9.89 7.87-17.76 17.76-17.76s17.76 7.87 17.76 17.76V661.45c0 9.89-7.87 17.76-17.76 17.76C513.09 680.31 504.21 671.34 504.21 661.45z"}));
}

Remove.defaultProps = {"viewBox":"0 0 791.91 791.91"};

module.exports = Remove;

Remove.default = Remove;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Save (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M434 130l-84-84a48 48 0 0 0-33.9-14H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V163.9a48 48 0 0 0-14-34zM224 416a64 64 0 1 1 0-128 64 64 0 0 1 0 128zm96-304.5V212a12 12 0 0 1-12 12H76a12 12 0 0 1-12-12V108a12 12 0 0 1 12-12h228.5a12 12 0 0 1 8.5 3.5l3.5 3.5a12 12 0 0 1 3.5 8.5z"}));
}

Save.defaultProps = {"aria-hidden":"true","data-icon":"save","viewBox":"0 0 448 512"};

module.exports = Save;

Save.default = Save;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.29 6.71C10.29 5.61 9.89 4.67 9.11 3.89 8.33 3.11 7.39 2.71 6.29 2.71 5.18 2.71 4.24 3.11 3.46 3.89 2.68 4.67 2.29 5.61 2.29 6.71 2.29 7.82 2.68 8.76 3.46 9.54 4.24 10.32 5.18 10.71 6.29 10.71 7.39 10.71 8.33 10.32 9.11 9.54 9.89 8.76 10.29 7.82 10.29 6.71ZM14.86 14.14C14.86 14.45 14.74 14.72 14.52 14.95 14.29 15.17 14.02 15.29 13.71 15.29 13.39 15.29 13.13 15.17 12.91 14.95L9.85 11.89C8.78 12.63 7.6 13 6.29 13 5.43 13 4.62 12.83 3.84 12.5 3.07 12.17 2.4 11.73 1.83 11.17 1.27 10.6 0.83 9.93 0.5 9.16 0.17 8.38 0 7.57 0 6.71 0 5.86 0.17 5.05 0.5 4.27 0.83 3.5 1.27 2.83 1.83 2.26 2.4 1.7 3.07 1.25 3.84 0.92 4.62 0.59 5.43 0.43 6.29 0.43 7.14 0.43 7.95 0.59 8.73 0.92 9.5 1.25 10.17 1.7 10.74 2.26 11.3 2.83 11.75 3.5 12.08 4.27 12.41 5.05 12.57 5.86 12.57 6.71 12.57 8.02 12.2 9.21 11.46 10.28L14.53 13.34C14.75 13.56 14.86 13.83 14.86 14.14Z"}));
}

Search.defaultProps = {"viewBox":"0 0 15 16"};

module.exports = Search;

Search.default = Search;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Sliders (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M496 384H160v-16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h80v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h336a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160h-80v-16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h336v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h80a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H288V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v16H16A16 16 0 0 0 0 80v32a16 16 0 0 0 16 16h208v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h208a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"}));
}

Sliders.defaultProps = {"aria-hidden":"true","data-icon":"sliders-h","viewBox":"0 0 512 512"};

module.exports = Sliders;

Sliders.default = Sliders;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Spinner (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M33.51 66.99c18.47 0 33.5-15.02 33.5-33.5 0-1.48-1.2-2.68-2.68-2.68S61.64 32.01 61.64 33.5c0 15.51-12.62 28.13-28.13 28.13S5.38 49 5.38 33.5 18 5.37 33.51 5.37c7.87 0 15.27 3.32 20.53 8.93l-3.74-1c-1.43-0.38-2.9 0.46-3.29 1.9 -0.38 1.43 0.46 2.9 1.9 3.29l10.44 2.79c0.23 0.06 0.46 0.09 0.69 0.09 0.54 0 1.07-0.16 1.52-0.47 0.07-0.05 0.13-0.11 0.2-0.17 1.13-0.68 1.58-2.06 1.11-3.27l0.94-8.75c0.16-1.48-0.91-2.8-2.38-2.95 -1.47-0.16-2.8 0.91-2.95 2.38L58.18 10.88C51.9 4.05 42.99 0 33.5 0 15.02 0 0 15.02 0 33.5c0.01 18.47 15.03 33.5 33.51 33.5L33.51 66.99z"}));
}

Spinner.defaultProps = {"viewBox":"0 0 67 66.99"};

module.exports = Spinner;

Spinner.default = Spinner;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Success (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M38.93 7.48C40.01 8.56 40.96 9.72 41.79 10.96 42.62 12.21 43.31 13.51 43.88 14.88 44.44 16.25 44.87 17.66 45.16 19.12 45.46 20.58 45.61 22.08 45.61 23.61 45.61 25.13 45.46 26.62 45.16 28.09 44.87 29.55 44.44 30.97 43.88 32.33 43.31 33.69 42.62 34.99 41.79 36.24 40.96 37.49 40.01 38.65 38.93 39.71 37.85 40.79 36.69 41.75 35.45 42.58 34.21 43.42 32.9 44.12 31.54 44.68 30.17 45.24 28.75 45.67 27.28 45.96 25.81 46.25 24.32 46.39 22.8 46.39 21.27 46.39 19.78 46.25 18.32 45.96 16.86 45.67 15.44 45.24 14.07 44.68 12.71 44.12 11.4 43.42 10.16 42.58 8.92 41.75 7.76 40.79 6.68 39.71 5.6 38.65 4.65 37.49 3.82 36.24 2.99 34.99 2.29 33.69 1.72 32.33 1.15 30.97 0.72 29.55 0.43 28.09 0.14 26.62 0 25.13 0 23.61 0 22.08 0.14 20.58 0.43 19.12 0.72 17.66 1.15 16.25 1.72 14.88 2.29 13.51 2.99 12.21 3.82 10.96 4.65 9.72 5.6 8.56 6.68 7.48 7.76 6.41 8.92 5.45 10.16 4.63 11.4 3.8 12.71 3.1 14.07 2.53 15.44 1.96 16.86 1.53 18.32 1.24 19.78 0.95 21.27 0.8 22.8 0.8 24.32 0.8 25.81 0.95 27.28 1.24 28.75 1.53 30.17 1.96 31.54 2.53 32.9 3.1 34.21 3.8 35.45 4.63 36.69 5.45 37.85 6.41 38.93 7.48ZM22.8 44C25.62 44 28.26 43.46 30.74 42.39 33.21 41.32 35.37 39.87 37.22 38.02 39.06 36.18 40.52 34.02 41.59 31.54 42.66 29.07 43.2 26.42 43.2 23.61 43.2 20.8 42.66 18.15 41.59 15.68 40.52 13.2 39.06 11.04 37.22 9.18 35.37 7.33 33.21 5.87 30.74 4.8 28.26 3.73 25.62 3.2 22.8 3.2 19.99 3.2 17.35 3.73 14.87 4.8 12.39 5.87 10.23 7.33 8.38 9.18 6.53 11.04 5.07 13.2 4 15.68 2.93 18.15 2.39 20.8 2.39 23.61 2.39 26.42 2.93 29.07 4 31.54 5.07 34.02 6.53 36.18 8.38 38.02 10.23 39.87 12.39 41.32 14.87 42.39 17.35 43.46 19.99 44 22.8 44ZM15.61 35.61C15.53 35.61 15.45 35.6 15.38 35.59 15.3 35.57 15.22 35.55 15.15 35.52 15.08 35.48 15.01 35.45 14.94 35.4 14.87 35.35 14.8 35.3 14.74 35.26L8.18 28.67C8.07 28.56 7.98 28.43 7.92 28.29 7.86 28.14 7.83 27.98 7.83 27.83 7.83 27.67 7.86 27.52 7.92 27.37 7.98 27.22 8.07 27.09 8.18 26.98 8.3 26.86 8.44 26.77 8.59 26.71 8.74 26.66 8.89 26.63 9.04 26.63 9.18 26.63 9.33 26.66 9.48 26.71 9.63 26.77 9.77 26.86 9.89 26.98L15.61 32.7 33.77 14.54C33.9 14.41 34.03 14.32 34.17 14.27 34.31 14.21 34.46 14.19 34.62 14.19 34.77 14.19 34.93 14.21 35.07 14.27 35.22 14.32 35.35 14.41 35.46 14.54 35.59 14.65 35.68 14.78 35.73 14.93 35.79 15.07 35.81 15.23 35.81 15.38 35.81 15.54 35.79 15.69 35.73 15.83 35.68 15.97 35.59 16.1 35.46 16.23L16.45 35.26C16.39 35.3 16.32 35.35 16.25 35.4 16.18 35.45 16.11 35.48 16.04 35.52 15.97 35.55 15.9 35.57 15.83 35.59 15.76 35.6 15.69 35.61 15.61 35.61Z"}));
}

Success.defaultProps = {"viewBox":"0 0 46 47"};

module.exports = Success;

Success.default = Success;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function TimesCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M50 0c9 0 17.34 2.25 25 6.75A50.52 50.52 0 0 1 93.25 25c4.5 7.66 6.75 16 6.75 25s-2.25 17.34-6.75 25A50.52 50.52 0 0 1 75 93.25c-7.66 4.5-16 6.75-25 6.75s-17.34-2.25-25-6.75A50.52 50.52 0 0 1 6.75 75C2.25 67.34 0 59 0 50s2.25-17.34 6.75-25A50.52 50.52 0 0 1 25 6.75C32.66 2.25 41 0 50 0zm0 93.55a42.5 42.5 0 0 0 21.88-5.85A43.35 43.35 0 0 0 87.7 71.77a42.85 42.85 0 0 0 5.85-21.87c0-7.86-1.95-15.12-5.85-21.77A43.35 43.35 0 0 0 71.77 12.3 42.85 42.85 0 0 0 49.9 6.45a42.31 42.31 0 0 0-21.77 5.85A43.35 43.35 0 0 0 12.3 28.23 42.85 42.85 0 0 0 6.45 50.1c0 7.86 1.95 15.12 5.85 21.77A43.35 43.35 0 0 0 28.23 87.7 42.66 42.66 0 0 0 50 93.55zM55.24 50l13.91 13.91c.4.54.6 1.14.6 1.82 0 .67-.2 1.2-.6 1.6l-1.81 1.82c-.4.4-.94.6-1.61.6-.68 0-1.28-.2-1.82-.6L50 55.04 36.09 69.15c-.54.4-1.14.6-1.82.6-.67 0-1.2-.2-1.6-.6l-1.82-1.81c-.4-.4-.6-.94-.6-1.61 0-.68.2-1.28.6-1.82L44.96 50 30.85 36.09c-.4-.54-.6-1.14-.6-1.82 0-.67.2-1.2.6-1.6l1.81-1.82c.4-.4.94-.6 1.61-.6.68 0 1.28.2 1.82.6L50 44.75l13.91-13.9c.54-.4 1.14-.6 1.82-.6.67 0 1.2.2 1.6.6l1.82 1.81c.4.4.6.94.6 1.61 0 .68-.2 1.28-.6 1.82L55.25 50z"}));
}

TimesCircle.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = TimesCircle;

TimesCircle.default = TimesCircle;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Trash (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 84V56a24 24 0 0 1 24-24h112l9.4-18.7c4-8.2 12.3-13.3 21.4-13.3h114.3a24 24 0 0 1 21.5 13.3L312 32h112a24 24 0 0 1 24 24v28a12 12 0 0 1-12 12H12A12 12 0 0 1 0 84zm416 56v324a48 48 0 0 1-48 48H80a48 48 0 0 1-48-48V140a12 12 0 0 1 12-12h360a12 12 0 0 1 12 12zm-272 68c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208z"}));
}

Trash.defaultProps = {"aria-hidden":"true","data-icon":"trash-alt","viewBox":"0 0 448 512"};

module.exports = Trash;

Trash.default = Trash;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);

function Warning (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"all"),React.createElement("g",{"key":1},React.createElement("g",null,React.createElement("g",{"data-name":"Zoom In"},React.createElement("g",{"data-name":"Calendar"},React.createElement("g",null,[React.createElement("path",{"d":"M44.91,39.42H55.09V63.08H44.91V39.42Zm5.09,39a5.57,5.57,0,1,1,5.57-5.57A5.57,5.57,0,0,1,50,78.43Z","key":0}),React.createElement("path",{"d":"M97.92,79.3l-39-67.62C56.43,7.44,53.22,5.33,50,5.33s-6.43,2.11-8.87,6.34L2.08,79.3C-2.8,87.75,1.2,94.67,11,94.67H89C98.8,94.67,102.8,87.75,97.92,79.3Zm-5.39,7.13c-0.12.16-1.11,0.8-3.48,0.8H11c-2.37,0-3.36-.64-3.48-0.79s-0.14-1.36,1-3.42l39-67.62c1.19-2.05,2.24-2.59,2.42-2.62s1.25,0.56,2.43,2.62L91.47,83C92.66,85.07,92.6,86.25,92.53,86.42Z","key":1}),React.createElement("circle",{"cx":"50","cy":"72.86","r":"5.57","key":2}),React.createElement("rect",{"x":"44.91","y":"39.42","width":"10.18","height":"23.66","key":3})])))))]);
}

Warning.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 100 100","x":"0px","y":"0px"};

module.exports = Warning;

Warning.default = Warning;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2; /**
                     * From react-transition-group v1.2.1
                     *
                     * In addition, the first animation frame is skipped when starting new transitions since
                     * entering absolutely positioned elements in Chrome does not animate otherwise.
                     */


var _addClass = __webpack_require__(30);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(31);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(17);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(32);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(5);

var _PropTypes = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? _defaults(subClass, superClass) : _defaults(subClass, superClass); }

var events = [];
if (_properties.transitionEnd) {
  events.push(_properties.transitionEnd);
}
if (_properties.animationEnd) {
  events.push(_properties.animationEnd);
}

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) {
      return;
    }
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = (_temp2 = _class = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) {
        removeListeners();
      }

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) {
        removeListeners();
      }

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      // The first animation frame is skipped when starting new transitions since
      // entering absolutely positioned elements in Chrome does not animate otherwise.
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueueOnNextFrame();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueueOnNextFrame = function flushClassNameAndNodeQueueOnNextFrame() {
    var _this3 = this;

    this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
      return _this3.flushClassNameAndNodeQueue();
    });
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component), _class.displayName = 'CSSTransitionGroupChild', _temp2);
exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.on = on;
exports.off = off;
function on(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.addEventListener) {
    el.addEventListener(eventName, callback, opts);
  } else if (el.attachEvent) {
    el.attachEvent("on" + eventName, function (e) {
      callback.call(el, e || window.event);
    });
  }
}

function off(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.removeEventListener) {
    el.removeEventListener(eventName, callback, opts);
  } else if (el.detachEvent) {
    el.detachEvent("on" + eventName, callback);
  }
}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @fileOverview Find scroll parent
 */

exports.default = function (node) {
  if (!(node instanceof HTMLElement)) {
    return document.documentElement;
  }

  var excludeStaticParent = node.style.position === 'absolute';
  var overflowRegex = /(scroll|auto)/;
  var parent = node;

  while (parent) {
    if (!parent.parentNode) {
      return node.ownerDocument || document.documentElement;
    }

    var style = window.getComputedStyle(parent);
    var position = style.position;
    var overflow = style.overflow;
    var overflowX = style['overflow-x'];
    var overflowY = style['overflow-y'];

    if (position === 'static' && excludeStaticParent) {
      parent = parent.parentNode;
      continue;
    }

    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return node.ownerDocument || node.documentElement || document.documentElement;
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = debounce;
function debounce(func, wait, immediate) {
  var timeout = void 0;
  var args = void 0;
  var context = void 0;
  var timestamp = void 0;
  var result = void 0;

  var later = function later() {
    var last = +new Date() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function debounced() {
    context = this;
    args = arguments;
    timestamp = +new Date();

    var callNow = immediate && !timeout;
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }

    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };
}

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = throttle;
/*eslint-disable */
function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(125);
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 125 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 126 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 127 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(129)["default"];
var assertThisInitialized = __webpack_require__(34);
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 129 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 130 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(132);
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 132 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 133 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (true) {
  var ReactIs = __webpack_require__(9);

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(135)(ReactIs.isElement, throwOnDirectAccess);
} else {}


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(9);
var assign = __webpack_require__(15);

var ReactPropTypesSecret = __webpack_require__(35);
var checkPropTypes = __webpack_require__(136);

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (true) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (true) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if ( true && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (true) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       true ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : undefined;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (true) {
  var ReactPropTypesSecret = __webpack_require__(35);
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (true) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (true) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {}

})(window, document, 'Hammer');


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 152 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(5);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(154);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(37);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(19);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(161);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

if (true) {
  Modal.setCreateHTMLElement = function (fn) {
    return createHTMLElement = fn;
  };
}

exports.default = Modal;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(155);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(156);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(37);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(159);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(19);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__(38);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__(160);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */
var isTabKey = function isTabKey(event) {
  return event.code === "Tab" || event.keyCode === 9;
};
var isEscKey = function isEscKey(event) {
  return event.code === "Escape" || event.keyCode === 27;
};

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName,
          parentSelector = _this$props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Remove classes.
      bodyOpenClassName && classList.remove(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus(_this.props.preventScroll);
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.openAnimationFrame = requestAnimationFrame(function () {
            _this.setState({ afterOpen: true });

            if (_this.props.isOpen && _this.props.onAfterOpen) {
              _this.props.onAfterOpen({
                overlayEl: _this.overlay,
                contentEl: _this.content
              });
            }
          });
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (isTabKey(event)) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (true) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.openAnimationFrame);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName,
          parentSelector = _props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Add classes.
      bodyOpenClassName && classList.add(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  parentSelector: _propTypes2.default.func,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = resetState;
exports.log = log;
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(36);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  focusLaterElements = [];
}

/* istanbul ignore next */
function log() {
  if (true) {
    console.log("focusManager ----------");
    focusLaterElements.forEach(function (f) {
      var check = f || {};
      console.log(check.nodeName, check.className, check.id);
    });
    console.log("end focusManager ----------");
  }
}
/* eslint-enable no-console */

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(36);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getActiveElement() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];
  var activeElement = getActiveElement();

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === activeElement && !shiftKey) {
    target = head;
  }

  if (head === activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "development" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}());


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = resetState;
exports.log = log;
var htmlClassList = {};
var docBodyClassList = {};

/* eslint-disable no-console */
/* istanbul ignore next */
function removeClass(at, cls) {
  at.classList.remove(cls);
}

/* istanbul ignore next */
function resetState() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}

/* istanbul ignore next */
function log() {
  if (true) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n  ";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n  ";
    }

    classes = document.body.className;

    buffer += "\n\ndoc.body (" + classes + "):\n  ";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n  ";
    }

    buffer += "\n";

    console.log(buffer);
  }
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = resetState;
exports.log = log;

var _portalOpenInstances = __webpack_require__(38);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  var _arr = [before, after];

  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}

/* istanbul ignore next */
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */

function focusContent() {
  if (instances.length === 0) {
    if (true) {
      // eslint-disable-next-line no-console
      console.warn("React-Modal: Open instances > 0 expected");
    }
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__165__;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(169);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(170);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (true) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(16)))

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(171);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (true) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(199);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(201);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  true ? propTypes : undefined;
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(27);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(28);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(200);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         true ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : undefined;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  true ? propTypes : undefined;
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(1);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(30);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(31);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(17);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(32);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(5);

var _PropTypes = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  true ? propTypes : undefined;

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(1);
var factory = __webpack_require__(209);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(15);

// -- Inlined from fbjs --

var emptyObject = {};

if (true) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (true) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (true) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (true) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (true) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (true) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (true) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (true) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (true) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (true) {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (true) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (true) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (true) {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (true) {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (true) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (true) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (true) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (true) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (true) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "components", function() { return /* reexport */ components_namespaceObject; });
__webpack_require__.d(__webpack_exports__, "contentfulViews", function() { return /* reexport */ contentful_views_namespaceObject; });
__webpack_require__.d(__webpack_exports__, "socialComponents", function() { return /* reexport */ social_namespaceObject; });
__webpack_require__.d(__webpack_exports__, "contentfulModels", function() { return /* reexport */ models_namespaceObject; });
__webpack_require__.d(__webpack_exports__, "contentfulWidgets", function() { return /* reexport */ contentful_widgets_namespaceObject; });
__webpack_require__.d(__webpack_exports__, "contentfulUtils", function() { return /* reexport */ contentful_views_util_namespaceObject; });
__webpack_require__.d(__webpack_exports__, "util", function() { return /* reexport */ util_namespaceObject; });

// NAMESPACE OBJECT: ./src/components/react-utils.js
var react_utils_namespaceObject = {};
__webpack_require__.r(react_utils_namespaceObject);
__webpack_require__.d(react_utils_namespaceObject, "includeWhen", function() { return includeWhen; });
__webpack_require__.d(react_utils_namespaceObject, "default", function() { return react_utils; });

// NAMESPACE OBJECT: ./src/util/user-util.js
var user_util_namespaceObject = {};
__webpack_require__.r(user_util_namespaceObject);
__webpack_require__.d(user_util_namespaceObject, "userDisplayName", function() { return userDisplayName; });
__webpack_require__.d(user_util_namespaceObject, "userFullName", function() { return userFullName; });

// NAMESPACE OBJECT: ./src/util/index.js
var util_namespaceObject = {};
__webpack_require__.r(util_namespaceObject);
__webpack_require__.d(util_namespaceObject, "userUtil", function() { return userUtil; });
__webpack_require__.d(util_namespaceObject, "validateName", function() { return validateName; });
__webpack_require__.d(util_namespaceObject, "analytics", function() { return analytics; });
__webpack_require__.d(util_namespaceObject, "getReactRoot", function() { return react_root_getReactRoot; });

// NAMESPACE OBJECT: ./src/components/contentful-views/util/index.js
var contentful_views_util_namespaceObject = {};
__webpack_require__.r(contentful_views_util_namespaceObject);
__webpack_require__.d(contentful_views_util_namespaceObject, "stringSubstitution", function() { return stringSubstitution; });
__webpack_require__.d(contentful_views_util_namespaceObject, "componentSubstitution", function() { return componentSubstitution; });
__webpack_require__.d(contentful_views_util_namespaceObject, "MetaTags", function() { return meta_tags_MetaTags; });

// NAMESPACE OBJECT: ./src/components/contentful-views/index.js
var contentful_views_namespaceObject = {};
__webpack_require__.r(contentful_views_namespaceObject);
__webpack_require__.d(contentful_views_namespaceObject, "ButtonLink", function() { return button_link; });
__webpack_require__.d(contentful_views_namespaceObject, "CollapsibleText", function() { return contentful_views_collapsible_text; });
__webpack_require__.d(contentful_views_namespaceObject, "Counter", function() { return contentful_views_counter_counter; });
__webpack_require__.d(contentful_views_namespaceObject, "Image", function() { return contentful_views_image; });
__webpack_require__.d(contentful_views_namespaceObject, "MediaObject", function() { return contentful_views_media_object; });
__webpack_require__.d(contentful_views_namespaceObject, "PageMetadata", function() { return page_metadata; });
__webpack_require__.d(contentful_views_namespaceObject, "Page", function() { return contentful_views_page; });
__webpack_require__.d(contentful_views_namespaceObject, "Quote", function() { return components_contentful_views_quote; });
__webpack_require__.d(contentful_views_namespaceObject, "Sections", function() { return components_contentful_views_sections; });
__webpack_require__.d(contentful_views_namespaceObject, "TextAndImageSection", function() { return components_contentful_views_text_and_image_section; });
__webpack_require__.d(contentful_views_namespaceObject, "TextSection", function() { return text_section; });
__webpack_require__.d(contentful_views_namespaceObject, "VideoSection", function() { return contentful_views_video_section; });
__webpack_require__.d(contentful_views_namespaceObject, "Video", function() { return components_contentful_views_video; });
__webpack_require__.d(contentful_views_namespaceObject, "WistiaSection", function() { return contentful_views_wistia_section; });
__webpack_require__.d(contentful_views_namespaceObject, "getWidget", function() { return sections_getWidget; });
__webpack_require__.d(contentful_views_namespaceObject, "getSectionsArray", function() { return sections_getSectionsArray; });

// NAMESPACE OBJECT: ./src/components/index.js
var components_namespaceObject = {};
__webpack_require__.r(components_namespaceObject);
__webpack_require__.d(components_namespaceObject, "reactUtils", function() { return reactUtils; });
__webpack_require__.d(components_namespaceObject, "ButtonLink", function() { return button_link; });
__webpack_require__.d(components_namespaceObject, "Button", function() { return src_components_button; });
__webpack_require__.d(components_namespaceObject, "Carousel", function() { return components_carousel; });
__webpack_require__.d(components_namespaceObject, "GalleryCarouselNav", function() { return gallery_carousel_gallery_carousel_nav; });
__webpack_require__.d(components_namespaceObject, "GalleryCarousel", function() { return gallery_carousel_gallery_carousel; });
__webpack_require__.d(components_namespaceObject, "Checkbox", function() { return src_components_checkbox; });
__webpack_require__.d(components_namespaceObject, "FormField", function() { return components_form_field; });
__webpack_require__.d(components_namespaceObject, "HeroBanner", function() { return hero_banner_hero_banner; });
__webpack_require__.d(components_namespaceObject, "HorizontalScroll", function() { return horizontal_scroll_horizontal_scroll; });
__webpack_require__.d(components_namespaceObject, "KeyboardCommands", function() { return keyboard_commands; });
__webpack_require__.d(components_namespaceObject, "LazyImage", function() { return lazy_image; });
__webpack_require__.d(components_namespaceObject, "lazyLoadForceCheck", function() { return lib["forceCheck"]; });
__webpack_require__.d(components_namespaceObject, "List", function() { return components_list_list; });
__webpack_require__.d(components_namespaceObject, "MachineBadge", function() { return components_machine_badge; });
__webpack_require__.d(components_namespaceObject, "MadLibEmail", function() { return mad_lib_email_mad_lib; });
__webpack_require__.d(components_namespaceObject, "MadLibContext", function() { return MadLibContext; });
__webpack_require__.d(components_namespaceObject, "MadLibProvider", function() { return mad_lib_context_MadLibProvider; });
__webpack_require__.d(components_namespaceObject, "hasMadLibStorageFlag", function() { return hasStorageFlag; });
__webpack_require__.d(components_namespaceObject, "Markdown", function() { return components_markdown; });
__webpack_require__.d(components_namespaceObject, "MediaCard", function() { return media_cards_media_card; });
__webpack_require__.d(components_namespaceObject, "Modal", function() { return components_modal; });
__webpack_require__.d(components_namespaceObject, "Dialog", function() { return dialog_dialog; });
__webpack_require__.d(components_namespaceObject, "NavCarousel", function() { return components_nav_carousel; });
__webpack_require__.d(components_namespaceObject, "NotificationList", function() { return components_notification_list; });
__webpack_require__.d(components_namespaceObject, "Notification", function() { return src_components_notification; });
__webpack_require__.d(components_namespaceObject, "OnClickOutside", function() { return on_click_outside; });
__webpack_require__.d(components_namespaceObject, "PageableGridList", function() { return pageable_grid_list_pageable_grid_list; });
__webpack_require__.d(components_namespaceObject, "Popover", function() { return popover_Popover; });
__webpack_require__.d(components_namespaceObject, "Radio", function() { return src_components_radio; });
__webpack_require__.d(components_namespaceObject, "RangeSlider", function() { return components_range_slider; });
__webpack_require__.d(components_namespaceObject, "Select", function() { return src_components_select; });
__webpack_require__.d(components_namespaceObject, "SlideInPanel", function() { return components_slide_in_panel; });
__webpack_require__.d(components_namespaceObject, "SVG", function() { return src_components_svg; });
__webpack_require__.d(components_namespaceObject, "Text", function() { return src_components_text; });
__webpack_require__.d(components_namespaceObject, "TextAndImageSection", function() { return text_and_image_section_text_and_image_section; });
__webpack_require__.d(components_namespaceObject, "ToggleButton", function() { return components_toggle_button; });
__webpack_require__.d(components_namespaceObject, "Tooltip", function() { return components_tooltip; });
__webpack_require__.d(components_namespaceObject, "VerticalScrollBox", function() { return vertical_scroll_box_VerticalScrollBox; });
__webpack_require__.d(components_namespaceObject, "WistiaButton", function() { return wistia_button_wistia_button; });
__webpack_require__.d(components_namespaceObject, "withPopover", function() { return withPopover; });
__webpack_require__.d(components_namespaceObject, "Footer", function() { return footer_footer; });
__webpack_require__.d(components_namespaceObject, "TopNav", function() { return navigation_top_nav; });

// NAMESPACE OBJECT: ./src/components/social/index.js
var social_namespaceObject = {};
__webpack_require__.r(social_namespaceObject);
__webpack_require__.d(social_namespaceObject, "ShareButton", function() { return social_share_button; });
__webpack_require__.d(social_namespaceObject, "ShareGroup", function() { return social_share_group; });
__webpack_require__.d(social_namespaceObject, "ShareWidget", function() { return social_share_widget; });
__webpack_require__.d(social_namespaceObject, "SocialIcon", function() { return social_social_icon; });
__webpack_require__.d(social_namespaceObject, "SocialCard", function() { return social_social_card; });

// NAMESPACE OBJECT: ./src/models/index.js
var models_namespaceObject = {};
__webpack_require__.r(models_namespaceObject);
__webpack_require__.d(models_namespaceObject, "pagePropType", function() { return pagePropType; });
__webpack_require__.d(models_namespaceObject, "pageStringsPropType", function() { return pageStringsPropType; });
__webpack_require__.d(models_namespaceObject, "getContentType", function() { return page_getContentType; });
__webpack_require__.d(models_namespaceObject, "getStringsForPage", function() { return page_getStringsForPage; });
__webpack_require__.d(models_namespaceObject, "getMarkdownStringsForPage", function() { return page_getMarkdownStringsForPage; });
__webpack_require__.d(models_namespaceObject, "getSectionForPageByIdAndType", function() { return page_getSectionForPageByIdAndType; });
__webpack_require__.d(models_namespaceObject, "getContentByType", function() { return page_getContentByType; });
__webpack_require__.d(models_namespaceObject, "getSectionsForPageByType", function() { return getSectionsForPageByType; });
__webpack_require__.d(models_namespaceObject, "getContentFieldsByType", function() { return page_getContentFieldsByType; });
__webpack_require__.d(models_namespaceObject, "contentfulMetadataPropType", function() { return contentfulMetadataPropType; });
__webpack_require__.d(models_namespaceObject, "interpretedMetadataPropType", function() { return interpretedMetadataPropType; });
__webpack_require__.d(models_namespaceObject, "interpretMetadata", function() { return page_metadata_interpretMetadata; });
__webpack_require__.d(models_namespaceObject, "getStringsForWidget", function() { return widget_getStringsForWidget; });
__webpack_require__.d(models_namespaceObject, "getMarkdownStringsForWidget", function() { return widget_getMarkdownStringsForWidget; });
__webpack_require__.d(models_namespaceObject, "getImagesForWidget", function() { return widget_getImagesForWidget; });
__webpack_require__.d(models_namespaceObject, "widgetPropType", function() { return widgetPropType; });
__webpack_require__.d(models_namespaceObject, "widgetDefaultProps", function() { return widgetDefaultProps; });
__webpack_require__.d(models_namespaceObject, "WidgetModel", function() { return WidgetModel; });
__webpack_require__.d(models_namespaceObject, "getContentfulGlobalFooterProps", function() { return models_footer; });

// NAMESPACE OBJECT: ./src/contentful-widgets/index.js
var contentful_widgets_namespaceObject = {};
__webpack_require__.r(contentful_widgets_namespaceObject);
__webpack_require__.d(contentful_widgets_namespaceObject, "ButtonLinkWidget", function() { return contentful_widgets_button_link; });
__webpack_require__.d(contentful_widgets_namespaceObject, "EmbeddableShareWidget", function() { return contentful_widgets_embeddable_share_widget; });
__webpack_require__.d(contentful_widgets_namespaceObject, "ListWidget", function() { return contentful_widgets_list; });
__webpack_require__.d(contentful_widgets_namespaceObject, "SocialCardWidget", function() { return contentful_widgets_social_card; });
__webpack_require__.d(contentful_widgets_namespaceObject, "WistiaButtonWidget", function() { return contentful_widgets_wistia_button; });
__webpack_require__.d(contentful_widgets_namespaceObject, "HeroBannerWidget", function() { return hero_banner_widget; });

// EXTERNAL MODULE: ./src/stylesheets/base.less
var base = __webpack_require__(60);

// CONCATENATED MODULE: ./src/components/react-utils.js
function includeWhen(shouldInclude, component) {
  return shouldInclude ? component() : null;
}

/* harmony default export */ var react_utils = (includeWhen);
// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
var external_commonjs_react_commonjs2_react_amd_React_root_React_ = __webpack_require__(1);
var external_commonjs_react_commonjs2_react_amd_React_root_React_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_react_commonjs2_react_amd_React_root_React_);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(0);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ./src/components/button-link.jsx
var _excluded = ["text", "url", "className", "icon", "size", "rel", "target", "type"];function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}


var button_link_ButtonLink = function ButtonLink(_ref) {var
    text = _ref.text,
    url = _ref.url,
    className = _ref.className,
    icon = _ref.icon,
    size = _ref.size,
    rel = _ref.rel,
    target = _ref.target,
    type = _ref.type,
    otherProps = _objectWithoutProperties(_ref, _excluded);return /*#__PURE__*/(

    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("a", _extends({
      href: url,
      rel: rel,
      target: target },
    otherProps, {
      className: "button ".concat(type, " ").concat(size, " ").concat(className, " uic") }),
    text,
    icon));};



var buttonLinkPropTypes = {
  text: prop_types_default.a.string.isRequired,
  url: prop_types_default.a.string.isRequired,
  className: prop_types_default.a.string,
  icon: prop_types_default.a.node,
  rel: prop_types_default.a.string,
  size: prop_types_default.a.oneOf(['small', 'medium', 'large']),
  target: prop_types_default.a.oneOf(['_self', '_blank', '_parent', '_top']),
  type: prop_types_default.a.oneOf(['text', 'default', 'primary', 'secondary', 'clearButton'])
};

button_link_ButtonLink.propTypes = buttonLinkPropTypes;

button_link_ButtonLink.defaultProps = {
  className: '',
  icon: null,
  rel: undefined,
  size: 'medium',
  target: undefined,
  type: 'default'
};

/* harmony default export */ var button_link = (button_link_ButtonLink);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(2);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/components/svg.less
var components_svg = __webpack_require__(65);

// EXTERNAL MODULE: ./src/components/svg-rebrand.less
var svg_rebrand = __webpack_require__(66);

// CONCATENATED MODULE: ./src/components/svg.jsx
function _typeof(obj) {"@babel/helpers - typeof";return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, _typeof(obj);}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) _setPrototypeOf(subClass, superClass);}function _setPrototypeOf(o, p) {_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return _setPrototypeOf(o, p);}function _createSuper(Derived) {var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {var Super = _getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return _possibleConstructorReturn(this, result);};}function _possibleConstructorReturn(self, call) {if (call && (_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function _getPrototypeOf(o) {_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return _getPrototypeOf(o);}







/**
 * The SVG component leverages the webpack config
 * found in index.js that runs svg-react-loader on all svgs in the svg folder
 *
 * Usage:
 *
 * For core Icon loaded in UI common:
 *  <SVG id='<icon file name>' />
 *  i.e <SVG id='checkmark' />
 *
 * For Contentful objects of type Icon:
 * <SVG core={false} svgAsset={contentfulIconObject} />
 * i.e <SVG core={false} svgAsset={props.globalFooterLogo} />
 *
 * NOTE: The last classname passed will be appended with 'Wrapper'.
 */
var svg_SVG = function SVG(_ref)





{var id = _ref.id,className = _ref.className,onClick = _ref.onClick,core = _ref.core,svgAsset = _ref.svgAsset;
  var svgClassName = classnames_default()(
  'icon uic',
  id,
  className,
  { hasClick: onClick });

  var wrapperClassName = classnames_default()("".concat(
  className, "Wrapper"));


  if (core) {
    var iconName = id;
    try {
      var Icon = __webpack_require__(67)("./".concat(iconName, ".svg")); // eslint-disable-line
      return /*#__PURE__*/ (
        // Note, the last class name will be appended with 'Wrapper'
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: wrapperClassName }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Icon, { className: svgClassName, onClick: onClick })));


    } catch (e) {
      console.error(e);
      return null;
    }
  }
  var url = "".concat(lodash_default.a.get(svgAsset, 'fields.file.url'));

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(svg_ExternalSVG, {
      className: svgClassName,
      wrapperClass: wrapperClassName,
      onClick: onClick,
      url: url }));

};

svg_SVG.propTypes = {
  core: prop_types_default.a.bool,
  id: prop_types_default.a.string,
  svgAsset: prop_types_default.a.objectOf(prop_types_default.a.object),
  className: prop_types_default.a.string,
  onClick: prop_types_default.a.func
};

svg_SVG.defaultProps = {
  core: true,
  id: null,
  svgAsset: null,
  className: 'default',
  onClick: null
};

/* harmony default export */ var src_components_svg = (svg_SVG);var

svg_ExternalSVG = /*#__PURE__*/function (_React$PureComponent) {_inherits(ExternalSVG, _React$PureComponent);var _super = _createSuper(ExternalSVG);
  function ExternalSVG(props) {var _this;_classCallCheck(this, ExternalSVG);
    _this = _super.call(this, props);
    _this.state = {};return _this;
  }_createClass(ExternalSVG, [{ key: "componentDidMount", value:

    function componentDidMount() {var _this2 = this;
      var _this$props =



        this.props,url = _this$props.url,className = _this$props.className,onClick = _this$props.onClick;

      fetch(url).then(
      function (response) {return response.text();}).
      then(function (svgData) {
        var svgString;
        try {
          var svg = new DOMParser().parseFromString(svgData, 'text/xml').documentElement;
          svg.setAttribute('class', className);
          svg.setAttribute('onClick', onClick);
          svgString = new XMLSerializer().serializeToString(svg);
        } catch (e) {
          svgString = '';
        }
        _this2.setState({ svgData: svgString });
      });
    } }, { key: "render", value:

    function render() {
      var wrapperClass = this.props.wrapperClass;
      var svgData = this.state.svgData;
      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", {
          className: wrapperClass,
          dangerouslySetInnerHTML: { __html: svgData } }));

    } }]);return ExternalSVG;}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.PureComponent);


svg_ExternalSVG.propTypes = {
  url: prop_types_default.a.string.isRequired,
  className: prop_types_default.a.string.isRequired,
  wrapperClass: prop_types_default.a.string.isRequired,
  onClick: prop_types_default.a.func
};

svg_ExternalSVG.defaultProps = {
  onClick: null
};
// EXTERNAL MODULE: ./src/components/button.less
var components_button = __webpack_require__(110);

// EXTERNAL MODULE: ./src/components/button-rebrand.less
var button_rebrand = __webpack_require__(111);

// CONCATENATED MODULE: ./src/components/button.jsx
var button_excluded = ["children", "className", "icon", "isSubmit", "size", "type", "modifier"];function button_extends() {button_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return button_extends.apply(this, arguments);}function button_objectWithoutProperties(source, excluded) {if (source == null) return {};var target = button_objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function button_objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}







/**
 * All other props besides those defined below are passed to <button/> html element.
 * @param {Object} props
 * @param {Node} props.children
 * @param {String} props.className
 * @param {String} props.icon id passed to SVG component
 * @param {Boolean} props.isSubmit Sets button type to submit if true, otherwise type is button
 * @param {String} props.size See proptypes, added as a class on button
 * @param {String} props.type See proptypes, added as a class on button
 * @param {String} props.modifier Modify the appearance of the button. For example, use a light
 *                                outline
 */
var button_Button = function Button(_ref)








{var children = _ref.children,className = _ref.className,icon = _ref.icon,isSubmit = _ref.isSubmit,size = _ref.size,type = _ref.type,modifier = _ref.modifier,otherProps = button_objectWithoutProperties(_ref, button_excluded);
  var svg = icon ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { id: icon, className: "buttonIcon" }) : null;
  var classes = classnames_default()(type, size, modifier, className, 'uic');

  return /*#__PURE__*/ (
    // turning this off, eslint thinks its undefined
    // eslint-disable-next-line react/button-has-type
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("button", button_extends({
      className: classes },
    otherProps, {
      type: isSubmit ? 'submit' : 'button' }),
    svg, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", null, children)));


};

button_Button.propTypes = {
  type: prop_types_default.a.oneOf(['text', 'secondary', 'default', 'primary', 'clearButton']),
  size: prop_types_default.a.oneOf(['small', 'medium', 'large']),
  modifier: prop_types_default.a.oneOf(['button-outline-light']),
  children: prop_types_default.a.node.isRequired,
  className: prop_types_default.a.string,
  icon: prop_types_default.a.string,
  isSubmit: prop_types_default.a.bool
};

button_Button.defaultProps = {
  type: 'default',
  size: 'medium',
  modifier: null,
  icon: null,
  className: null,
  isSubmit: false
};

/* harmony default export */ var src_components_button = (button_Button);
// EXTERNAL MODULE: ./node_modules/react-css-transition-replace/lib/ReactCSSTransitionReplace.js
var ReactCSSTransitionReplace = __webpack_require__(11);
var ReactCSSTransitionReplace_default = /*#__PURE__*/__webpack_require__.n(ReactCSSTransitionReplace);

// EXTERNAL MODULE: ./src/components/carousel.less
var carousel = __webpack_require__(114);

// EXTERNAL MODULE: ./src/components/carousel-rebrand.less
var carousel_rebrand = __webpack_require__(115);

// CONCATENATED MODULE: ./src/components/carousel.jsx
function carousel_typeof(obj) {"@babel/helpers - typeof";return carousel_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, carousel_typeof(obj);}function carousel_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function carousel_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function carousel_createClass(Constructor, protoProps, staticProps) {if (protoProps) carousel_defineProperties(Constructor.prototype, protoProps);if (staticProps) carousel_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function carousel_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) carousel_setPrototypeOf(subClass, superClass);}function carousel_setPrototypeOf(o, p) {carousel_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return carousel_setPrototypeOf(o, p);}function carousel_createSuper(Derived) {var hasNativeReflectConstruct = carousel_isNativeReflectConstruct();return function _createSuperInternal() {var Super = carousel_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = carousel_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return carousel_possibleConstructorReturn(this, result);};}function carousel_possibleConstructorReturn(self, call) {if (call && (carousel_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return carousel_assertThisInitialized(self);}function carousel_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function carousel_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function carousel_getPrototypeOf(o) {carousel_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return carousel_getPrototypeOf(o);}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}





var

carousel_Carousel = /*#__PURE__*/function (_Component) {carousel_inherits(Carousel, _Component);var _super = carousel_createSuper(Carousel);









  function Carousel(props) {var _this;carousel_classCallCheck(this, Carousel);
    _this = _super.call(this, props);_defineProperty(carousel_assertThisInitialized(_this), "move",



    function (index) {
      var newIndex = index;
      if (newIndex > _this.props.children.length - 1) {
        newIndex = 0; // Loop back to the start
      } else if (newIndex < 0) {
        newIndex = _this.props.children.length - 1; // Go to end
      }
      _this.setState({ viewedIndex: newIndex });
    });_defineProperty(carousel_assertThisInitialized(_this), "moveBack",

    function () {
      _this.move(_this.state.viewedIndex - 1);
    });_defineProperty(carousel_assertThisInitialized(_this), "moveForward",

    function () {
      _this.move(_this.state.viewedIndex + 1);
    });_this.state = { viewedIndex: props.startIndex || 0 };return _this;}carousel_createClass(Carousel, [{ key: "render", value:

    function render() {var _this2 = this;
      var visibleChild = this.props.children[this.state.viewedIndex];

      var indicators = [];var _loop = function _loop(
      i) {
        var moveTo = function moveTo() {return _this2.move(i);};
        indicators.push( /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("button", {
          type: "button",
          key: i,
          onClick: moveTo,
          className: "circle clearButton ".concat(_this2.state.viewedIndex === i ? 'selected' : '') }));};for (var i = 0; i < this.props.children.length; i += 1) {_loop(i);

      }

      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "Carousel uic" }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(ReactCSSTransitionReplace_default.a, {
          transitionName: "fade-wait",
          transitionEnterTimeout: 1000,
          transitionLeaveTimeout: 600 }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "slide-container", key: visibleChild.key },
        visibleChild)), /*#__PURE__*/


        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { id: "chevron-light", className: "arrow back", onClick: this.moveBack }), /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { id: "chevron-light", className: "arrow forward", onClick: this.moveForward }), /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "indicators" }, indicators)));


    } }]);return Carousel;}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);_defineProperty(carousel_Carousel, "propTypes", { children: prop_types_default.a.arrayOf(prop_types_default.a.node).isRequired, startIndex: prop_types_default.a.number });_defineProperty(carousel_Carousel, "defaultProps", { startIndex: 0 });


/* harmony default export */ var components_carousel = (carousel_Carousel);
// EXTERNAL MODULE: ./node_modules/keypress.js/keypress-2.1.5.min.js
var keypress_2_1_5_min = __webpack_require__(40);
var keypress_2_1_5_min_default = /*#__PURE__*/__webpack_require__.n(keypress_2_1_5_min);

// CONCATENATED MODULE: ./src/components/keyboard-commands.jsx
function keyboard_commands_typeof(obj) {"@babel/helpers - typeof";return keyboard_commands_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, keyboard_commands_typeof(obj);}function keyboard_commands_extends() {keyboard_commands_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return keyboard_commands_extends.apply(this, arguments);}function keyboard_commands_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function keyboard_commands_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function keyboard_commands_createClass(Constructor, protoProps, staticProps) {if (protoProps) keyboard_commands_defineProperties(Constructor.prototype, protoProps);if (staticProps) keyboard_commands_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function keyboard_commands_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) keyboard_commands_setPrototypeOf(subClass, superClass);}function keyboard_commands_setPrototypeOf(o, p) {keyboard_commands_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return keyboard_commands_setPrototypeOf(o, p);}function keyboard_commands_createSuper(Derived) {var hasNativeReflectConstruct = keyboard_commands_isNativeReflectConstruct();return function _createSuperInternal() {var Super = keyboard_commands_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = keyboard_commands_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return keyboard_commands_possibleConstructorReturn(this, result);};}function keyboard_commands_possibleConstructorReturn(self, call) {if (call && (keyboard_commands_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return keyboard_commands_assertThisInitialized(self);}function keyboard_commands_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function keyboard_commands_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function keyboard_commands_getPrototypeOf(o) {keyboard_commands_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return keyboard_commands_getPrototypeOf(o);}



function filterInputs(handler) {
  return function (e) {return e.target.matches('input, input, select, select *, textarea') || handler(e);};
}

function filterPopovers(handler) {
  return function (e) {
    return e.target.matches('.MuiPopover-paper') || handler(e);
  };
}

/**
 * [keyboardCommands description]
 * @param  {[type]} WrappedComponent component to wrap and add keyboard commands to
 * @param  {[type]} combos           keypress combos array https://dmauro.github.io/Keypress/
 *                                   instead of on_keydown
 *                                   add connectCommand(prop, event, wrappedComponent)
 *                                     this will be called when your combo is pressed
 *                                     in order to control the wrapped component just have
 *                                     this method pass back an object with any props you
 *                                     want overridden on the wrapped component
 *                                   add includeInputs to override input filtering so that
 *                                     a command will run even if the command is run while focused
 *                                     on an input element
 *                                   add excludePopovers to apply popover filtering so that
 *                                     a command will not run while focused on a popover element
 *  EXAMPLES
 *  export default keyboardCommands(WrappedComponent, [{
 *    keys: 'escape',
 *    connectCommand(props) {
 *      props.handlerPassedOnPropsToWrappedComponent();
 *    },
 *  }, {
 *    keys: 'escape',
 *    includeInputs: true, // don't filter out calls that are targeting inputs
 *    excludePopovers: true, // filter out calls that target popovers
 *    connectCommand() {
 *      return { props: 'to', send: 'to', wrapped: 'component'}
 *    },
 *  }]);
 */
function keyboardCommands(WrappedComponent, combos) {
  return /*#__PURE__*/function (_React$PureComponent) {keyboard_commands_inherits(KeyboardCommands, _React$PureComponent);var _super = keyboard_commands_createSuper(KeyboardCommands);
    function KeyboardCommands() {var _this;keyboard_commands_classCallCheck(this, KeyboardCommands);
      _this = _super.call(this);
      _this.boundMountComponent = _this.mountComponent.bind(keyboard_commands_assertThisInitialized(_this));return _this;
    }keyboard_commands_createClass(KeyboardCommands, [{ key: "componentWillUnmount", value:

      function componentWillUnmount() {
        if (this.listener) {
          this.listener.destroy();
        }
      } }, { key: "getStateWithProps", value:

      function getStateWithProps() {
        // this is used when sending props forward to the wrapped component
        // this enforces that any state that a command has returned is
        // provided to the wrapped component
        return lodash_default.a.assign({}, this.props, this.state);
      } }, { key: "mountComponent", value:

      function mountComponent(component) {var _this2 = this;
        if (this.listener) {
          return;
        }

        this.component = component;

        var handleCommand = function handleCommand(connect, includeInputs, excludePopovers) {
          if (!connect) {
            return function () {};
          }

          var handler = function handler(event) {
            // call the connectCommand function offloading the work to the usage code
            var state = connect(
            _this2.getStateWithProps(),
            event,
            _this2.component);


            // if we have returned a state update the internal state so that it can
            // be pushed down to the wrapped component.
            if (state) {
              _this2.setState(state);
              return state.disablePreventDefault;
            }
          };

          // don't execute add an input filter if the combo is set up to
          // include inputs
          var filteredHandler = includeInputs ? handler : filterInputs(handler);
          return excludePopovers ? filterPopovers(filteredHandler) : filteredHandler;
        };

        this.listener = new keypress_2_1_5_min_default.a.Listener();
        this.listener.register_many(
        combos.map(function (combo) {
          var initialCombo = lodash_default.a.assign(combo, {
            is_solitary: true
          });
          if (combo.connectCommand) {
            initialCombo.on_keydown = handleCommand(combo.connectCommand, combo.includeInputs, combo.excludePopovers);
          }

          if (combo.connectReleaseCommand) {
            initialCombo.on_keyup = handleCommand(combo.connectReleaseCommand, combo.includeInputs, combo.excludePopovers);
          }
          return initialCombo;
        }));

      } }, { key: "render", value:

      function render() {
        // use the merged state and props into the wrapped component.
        return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(WrappedComponent, keyboard_commands_extends({}, this.getStateWithProps(), { ref: this.boundMountComponent }));
      } }]);return KeyboardCommands;}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.PureComponent);

}

/* harmony default export */ var keyboard_commands = (keyboardCommands);
// CONCATENATED MODULE: ./src/util/layout-constants.js

/**
 * Values used to determine when layouts should update. If you make updates to
 * this file, you should also update `stylesheets/media.less` so CSS and JS
 * layouts stay in sync.
 */
var layoutConstants = {
  extraLarge: 1600,
  large: 1220,
  medium: 960,
  small: 770,
  extraSmall: 450
};

/* harmony default export */ var layout_constants = (layoutConstants);
// EXTERNAL MODULE: ./src/components/gallery-carousel/gallery-carousel-nav.less
var gallery_carousel_nav = __webpack_require__(116);

// EXTERNAL MODULE: ./src/components/gallery-carousel/gallery-carousel-nav-rebrand.less
var gallery_carousel_nav_rebrand = __webpack_require__(117);

// CONCATENATED MODULE: ./src/components/gallery-carousel/gallery-carousel-nav.jsx
function gallery_carousel_nav_typeof(obj) {"@babel/helpers - typeof";return gallery_carousel_nav_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, gallery_carousel_nav_typeof(obj);}function gallery_carousel_nav_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function gallery_carousel_nav_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function gallery_carousel_nav_createClass(Constructor, protoProps, staticProps) {if (protoProps) gallery_carousel_nav_defineProperties(Constructor.prototype, protoProps);if (staticProps) gallery_carousel_nav_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function gallery_carousel_nav_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) gallery_carousel_nav_setPrototypeOf(subClass, superClass);}function gallery_carousel_nav_setPrototypeOf(o, p) {gallery_carousel_nav_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return gallery_carousel_nav_setPrototypeOf(o, p);}function gallery_carousel_nav_createSuper(Derived) {var hasNativeReflectConstruct = gallery_carousel_nav_isNativeReflectConstruct();return function _createSuperInternal() {var Super = gallery_carousel_nav_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = gallery_carousel_nav_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return gallery_carousel_nav_possibleConstructorReturn(this, result);};}function gallery_carousel_nav_possibleConstructorReturn(self, call) {if (call && (gallery_carousel_nav_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return gallery_carousel_nav_assertThisInitialized(self);}function gallery_carousel_nav_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function gallery_carousel_nav_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function gallery_carousel_nav_getPrototypeOf(o) {gallery_carousel_nav_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return gallery_carousel_nav_getPrototypeOf(o);}function gallery_carousel_nav_defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;} // @ts-check










/**
 * @typedef {object} GalleryCarouselNavItemData
 * @property {string} id Unique id for image
 * @property {string} title Title of the image, displayed below the image
 */

/**
 * @callback GalleryCarouselNavOnChange
 * @param {string} image The id of the image that moved to the front of the
 * carousel
 * @returns {void}
 */

/**
 * @typedef {object} GalleryCarouselNavProps
 * @property {GalleryCarouselNavItemData[]} data A list of items used to populate
 * items in the carousel
 * @property {string} currentTitle Id of the currently showing title
 * @property {GalleryCarouselNavOnChange} onChange Called when a new image moves to the
 *                                         front of the carousel
 */

/**
 * @class
 * @extends {React.Component<GalleryCarouselNavProps>}
 */
var gallery_carousel_nav_GalleryCarouselNavComponent = /*#__PURE__*/function (_React$Component) {gallery_carousel_nav_inherits(GalleryCarouselNavComponent, _React$Component);var _super = gallery_carousel_nav_createSuper(GalleryCarouselNavComponent);
  /** This is necessary for server-side rendering, where there is no global
   * window object */
















  function GalleryCarouselNavComponent(props) {var _this;gallery_carousel_nav_classCallCheck(this, GalleryCarouselNavComponent);
    _this = _super.call(this, props);gallery_carousel_nav_defineProperty(gallery_carousel_nav_assertThisInitialized(_this), "resize",

































    function () {
      if (!_this.containerRef.current) {return;}
      _this.setState({ containerWidth: _this.containerRef.current.offsetWidth });
    });gallery_carousel_nav_defineProperty(gallery_carousel_nav_assertThisInitialized(_this), "nextImage",


    function () {
      var _this$props = _this.props,data = _this$props.data,currentTitle = _this$props.currentTitle,onChange = _this$props.onChange;
      var index = data.findIndex(function (i) {return i.id === currentTitle;});
      var nextImageIndex = (index + 1) % data.length;
      onChange(data[nextImageIndex].id);
    });gallery_carousel_nav_defineProperty(gallery_carousel_nav_assertThisInitialized(_this), "previousImage",


    function () {
      var _this$props2 = _this.props,data = _this$props2.data,currentTitle = _this$props2.currentTitle,onChange = _this$props2.onChange;
      var index = data.findIndex(function (i) {return i.id === currentTitle;});
      var previousIndex = index === 0 ? data.length - 1 : index - 1;
      onChange(data[previousIndex].id);
    });_this.containerRef = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_["createRef"]();_this.debouncedResize = lodash_default.a.debounce(_this.resize, GalleryCarouselNavComponent.resizeDebounceWait);_this.state = { containerWidth: 0 };return _this;}gallery_carousel_nav_createClass(GalleryCarouselNavComponent, [{ key: "componentDidMount", value: function componentDidMount() {var _this2 = this;this.resize(); // Fix issue that can occur when JavaScript is executed before styles are
      // applied to the page
      setTimeout(function () {return _this2.resize();});if (GalleryCarouselNavComponent.windowExists()) {// Fix issue that can occur when JavaScript is executed before styles are
        // applied to the page
        window.addEventListener('load', this.resize);window.addEventListener('resize', this.debouncedResize);}} /** Clean up event listeners and clear any animations that are in progress */ }, { key: "componentWillUnmount", value: function componentWillUnmount() {if (GalleryCarouselNavComponent.windowExists()) {window.removeEventListener('load', this.resize);this.debouncedResize.cancel();window.removeEventListener('resize', this.debouncedResize);}} /** Adjust properties needed for layout */ }, { key: "render", value:









    function render() {
      var _this$props3 =


        this.props,data = _this$props3.data,currentTitle = _this$props3.currentTitle;

      var
      containerWidth =
      this.state.containerWidth;

      var mobileView = containerWidth < layout_constants.small;
      var classes = classnames_default()('GalleryCarouselNav uic', { 'mobile-view': mobileView });

      /* eslint-disable jsx-a11y/click-events-have-key-events,
       jsx-a11y/no-static-element-interactions */
      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", {
          className: classes,
          ref: this.containerRef }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("div", { className: "GalleryCarouselNavItem" },
        data.find(function (i) {return i.id === currentTitle;}).title), /*#__PURE__*/

        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("button", {
          type: "button",
          className: "arrow-left-button",
          name: "Previous Image",
          onClick: this.previousImage }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](src_components_svg, {
          className: "arrow-left",
          id: "chevron-light" })), /*#__PURE__*/

        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"]("button", {
          type: "button",
          className: "arrow-right-button",
          name: "Next Image",
          onClick: this.nextImage }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"](src_components_svg, {
          className: "arrow-right",
          id: "chevron-light" }))));



    } }]);return GalleryCarouselNavComponent;}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);gallery_carousel_nav_defineProperty(gallery_carousel_nav_GalleryCarouselNavComponent, "windowExists", function () {return typeof window !== 'undefined';});gallery_carousel_nav_defineProperty(gallery_carousel_nav_GalleryCarouselNavComponent, "propTypes", { data: prop_types_default.a.arrayOf(prop_types_default.a.shape({ id: prop_types_default.a.string, title: prop_types_default.a.string })), currentTitle: prop_types_default.a.string, onChange: prop_types_default.a.func.isRequired });gallery_carousel_nav_defineProperty(gallery_carousel_nav_GalleryCarouselNavComponent, "defaultProps", { data: [], currentTitle: null });gallery_carousel_nav_defineProperty(gallery_carousel_nav_GalleryCarouselNavComponent, "resizeDebounceWait", 300);gallery_carousel_nav_defineProperty(gallery_carousel_nav_GalleryCarouselNavComponent, "maxImageScaleWidth", 1200);gallery_carousel_nav_defineProperty(gallery_carousel_nav_GalleryCarouselNavComponent, "minImageScaleWidth", 600);


/* harmony default export */ var gallery_carousel_gallery_carousel_nav = (gallery_carousel_nav_GalleryCarouselNavComponent.windowExists() ? keyboardCommands(
// @ts-ignore
gallery_carousel_nav_GalleryCarouselNavComponent,
[{
  keys: 'right',
  connectCommand: function connectCommand(props, event, component) {
    component.nextImage();
  }
}, {
  keys: 'left',
  connectCommand: function connectCommand(props, event, component) {
    component.previousImage();
  }
}]) :
gallery_carousel_nav_GalleryCarouselNavComponent);
// CONCATENATED MODULE: ./src/components/gallery-carousel/gallery-carousel-prop-types.js


// eslint-disable-next-line import/prefer-default-export
var imagePropType = prop_types_default.a.shape({
  id: prop_types_default.a.string,
  heroUrl: prop_types_default.a.string.isRequired,
  heroNavTitle: prop_types_default.a.string.isRequired,
  description: prop_types_default.a.string.isRequired
});
// CONCATENATED MODULE: ./node_modules/remarkable/dist/esm/index.browser.js
var index_browser_textarea;

function decodeEntity(name) {
  index_browser_textarea = index_browser_textarea || document.createElement('textarea');
  index_browser_textarea.innerHTML = '&' + name + ';';
  return index_browser_textarea.value;
}

/**
 * Utility functions
 */

function typeOf(obj) {
  return Object.prototype.toString.call(obj);
}

function isString(obj) {
  return typeOf(obj) === '[object String]';
}

var hasOwn = Object.prototype.hasOwnProperty;

function has(object, key) {
  return object
    ? hasOwn.call(object, key)
    : false;
}

// Extend objects
//
function index_browser_assign(obj /*from1, from2, from3, ...*/) {
  var sources = [].slice.call(arguments, 1);

  sources.forEach(function (source) {
    if (!source) { return; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be object');
    }

    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });

  return obj;
}

////////////////////////////////////////////////////////////////////////////////

var UNESCAPE_MD_RE = /\\([\\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;

function unescapeMd(str) {
  if (str.indexOf('\\') < 0) { return str; }
  return str.replace(UNESCAPE_MD_RE, '$1');
}

////////////////////////////////////////////////////////////////////////////////

function isValidEntityCode(c) {
  /*eslint no-bitwise:0*/
  // broken sequence
  if (c >= 0xD800 && c <= 0xDFFF) { return false; }
  // never used
  if (c >= 0xFDD0 && c <= 0xFDEF) { return false; }
  if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) { return false; }
  // control codes
  if (c >= 0x00 && c <= 0x08) { return false; }
  if (c === 0x0B) { return false; }
  if (c >= 0x0E && c <= 0x1F) { return false; }
  if (c >= 0x7F && c <= 0x9F) { return false; }
  // out of range
  if (c > 0x10FFFF) { return false; }
  return true;
}

function fromCodePoint(c) {
  /*eslint no-bitwise:0*/
  if (c > 0xffff) {
    c -= 0x10000;
    var surrogate1 = 0xd800 + (c >> 10),
        surrogate2 = 0xdc00 + (c & 0x3ff);

    return String.fromCharCode(surrogate1, surrogate2);
  }
  return String.fromCharCode(c);
}

var NAMED_ENTITY_RE   = /&([a-z#][a-z0-9]{1,31});/gi;
var DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;

function replaceEntityPattern(match, name) {
  var code = 0;
  var decoded = decodeEntity(name);

  if (name !== decoded) {
    return decoded;
  } else if (name.charCodeAt(0) === 0x23/* # */ && DIGITAL_ENTITY_TEST_RE.test(name)) {
    code = name[1].toLowerCase() === 'x' ?
      parseInt(name.slice(2), 16)
    :
      parseInt(name.slice(1), 10);
    if (isValidEntityCode(code)) {
      return fromCodePoint(code);
    }
  }
  return match;
}

function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(NAMED_ENTITY_RE, replaceEntityPattern);
}

////////////////////////////////////////////////////////////////////////////////

var HTML_ESCAPE_TEST_RE = /[&<>"]/;
var HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var HTML_REPLACEMENTS = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;'
};

function replaceUnsafeChar(ch) {
  return HTML_REPLACEMENTS[ch];
}

function escapeHtml(str) {
  if (HTML_ESCAPE_TEST_RE.test(str)) {
    return str.replace(HTML_ESCAPE_REPLACE_RE, replaceUnsafeChar);
  }
  return str;
}

var utils = /*#__PURE__*/Object.freeze({
  isString: isString,
  has: has,
  assign: index_browser_assign,
  unescapeMd: unescapeMd,
  isValidEntityCode: isValidEntityCode,
  fromCodePoint: fromCodePoint,
  replaceEntities: replaceEntities,
  escapeHtml: escapeHtml
});

/**
 * Renderer rules cache
 */

var rules = {};

/**
 * Blockquotes
 */

rules.blockquote_open = function(/* tokens, idx, options, env */) {
  return '<blockquote>\n';
};

rules.blockquote_close = function(tokens, idx /*, options, env */) {
  return '</blockquote>' + getBreak(tokens, idx);
};

/**
 * Code
 */

rules.code = function(tokens, idx /*, options, env */) {
  if (tokens[idx].block) {
    return '<pre><code>' + escapeHtml(tokens[idx].content) + '</code></pre>' + getBreak(tokens, idx);
  }
  return '<code>' + escapeHtml(tokens[idx].content) + '</code>';
};

/**
 * Fenced code blocks
 */

rules.fence = function(tokens, idx, options, env, instance) {
  var token = tokens[idx];
  var langClass = '';
  var langPrefix = options.langPrefix;
  var langName = '', fences, fenceName;
  var highlighted;

  if (token.params) {

    //
    // ```foo bar
    //
    // Try custom renderer "foo" first. That will simplify overwrite
    // for diagrams, latex, and any other fenced block with custom look
    //

    fences = token.params.split(/\s+/g);
    fenceName = fences.join(' ');

    if (has(instance.rules.fence_custom, fences[0])) {
      return instance.rules.fence_custom[fences[0]](tokens, idx, options, env, instance);
    }

    langName = escapeHtml(replaceEntities(unescapeMd(fenceName)));
    langClass = ' class="' + langPrefix + langName + '"';
  }

  if (options.highlight) {
    highlighted = options.highlight.apply(options.highlight, [ token.content ].concat(fences))
      || escapeHtml(token.content);
  } else {
    highlighted = escapeHtml(token.content);
  }

  return '<pre><code' + langClass + '>'
        + highlighted
        + '</code></pre>'
        + getBreak(tokens, idx);
};

rules.fence_custom = {};

/**
 * Headings
 */

rules.heading_open = function(tokens, idx /*, options, env */) {
  return '<h' + tokens[idx].hLevel + '>';
};
rules.heading_close = function(tokens, idx /*, options, env */) {
  return '</h' + tokens[idx].hLevel + '>\n';
};

/**
 * Horizontal rules
 */

rules.hr = function(tokens, idx, options /*, env */) {
  return (options.xhtmlOut ? '<hr />' : '<hr>') + getBreak(tokens, idx);
};

/**
 * Bullets
 */

rules.bullet_list_open = function(/* tokens, idx, options, env */) {
  return '<ul>\n';
};
rules.bullet_list_close = function(tokens, idx /*, options, env */) {
  return '</ul>' + getBreak(tokens, idx);
};

/**
 * List items
 */

rules.list_item_open = function(/* tokens, idx, options, env */) {
  return '<li>';
};
rules.list_item_close = function(/* tokens, idx, options, env */) {
  return '</li>\n';
};

/**
 * Ordered list items
 */

rules.ordered_list_open = function(tokens, idx /*, options, env */) {
  var token = tokens[idx];
  var order = token.order > 1 ? ' start="' + token.order + '"' : '';
  return '<ol' + order + '>\n';
};
rules.ordered_list_close = function(tokens, idx /*, options, env */) {
  return '</ol>' + getBreak(tokens, idx);
};

/**
 * Paragraphs
 */

rules.paragraph_open = function(tokens, idx /*, options, env */) {
  return tokens[idx].tight ? '' : '<p>';
};
rules.paragraph_close = function(tokens, idx /*, options, env */) {
  var addBreak = !(tokens[idx].tight && idx && tokens[idx - 1].type === 'inline' && !tokens[idx - 1].content);
  return (tokens[idx].tight ? '' : '</p>') + (addBreak ? getBreak(tokens, idx) : '');
};

/**
 * Links
 */

rules.link_open = function(tokens, idx, options /* env */) {
  var title = tokens[idx].title ? (' title="' + escapeHtml(replaceEntities(tokens[idx].title)) + '"') : '';
  var target = options.linkTarget ? (' target="' + options.linkTarget + '"') : '';
  return '<a href="' + escapeHtml(tokens[idx].href) + '"' + title + target + '>';
};
rules.link_close = function(/* tokens, idx, options, env */) {
  return '</a>';
};

/**
 * Images
 */

rules.image = function(tokens, idx, options /*, env */) {
  var src = ' src="' + escapeHtml(tokens[idx].src) + '"';
  var title = tokens[idx].title ? (' title="' + escapeHtml(replaceEntities(tokens[idx].title)) + '"') : '';
  var alt = ' alt="' + (tokens[idx].alt ? escapeHtml(replaceEntities(unescapeMd(tokens[idx].alt))) : '') + '"';
  var suffix = options.xhtmlOut ? ' /' : '';
  return '<img' + src + alt + title + suffix + '>';
};

/**
 * Tables
 */

rules.table_open = function(/* tokens, idx, options, env */) {
  return '<table>\n';
};
rules.table_close = function(/* tokens, idx, options, env */) {
  return '</table>\n';
};
rules.thead_open = function(/* tokens, idx, options, env */) {
  return '<thead>\n';
};
rules.thead_close = function(/* tokens, idx, options, env */) {
  return '</thead>\n';
};
rules.tbody_open = function(/* tokens, idx, options, env */) {
  return '<tbody>\n';
};
rules.tbody_close = function(/* tokens, idx, options, env */) {
  return '</tbody>\n';
};
rules.tr_open = function(/* tokens, idx, options, env */) {
  return '<tr>';
};
rules.tr_close = function(/* tokens, idx, options, env */) {
  return '</tr>\n';
};
rules.th_open = function(tokens, idx /*, options, env */) {
  var token = tokens[idx];
  return '<th'
    + (token.align ? ' style="text-align:' + token.align + '"' : '')
    + '>';
};
rules.th_close = function(/* tokens, idx, options, env */) {
  return '</th>';
};
rules.td_open = function(tokens, idx /*, options, env */) {
  var token = tokens[idx];
  return '<td'
    + (token.align ? ' style="text-align:' + token.align + '"' : '')
    + '>';
};
rules.td_close = function(/* tokens, idx, options, env */) {
  return '</td>';
};

/**
 * Bold
 */

rules.strong_open = function(/* tokens, idx, options, env */) {
  return '<strong>';
};
rules.strong_close = function(/* tokens, idx, options, env */) {
  return '</strong>';
};

/**
 * Italicize
 */

rules.em_open = function(/* tokens, idx, options, env */) {
  return '<em>';
};
rules.em_close = function(/* tokens, idx, options, env */) {
  return '</em>';
};

/**
 * Strikethrough
 */

rules.del_open = function(/* tokens, idx, options, env */) {
  return '<del>';
};
rules.del_close = function(/* tokens, idx, options, env */) {
  return '</del>';
};

/**
 * Insert
 */

rules.ins_open = function(/* tokens, idx, options, env */) {
  return '<ins>';
};
rules.ins_close = function(/* tokens, idx, options, env */) {
  return '</ins>';
};

/**
 * Highlight
 */

rules.mark_open = function(/* tokens, idx, options, env */) {
  return '<mark>';
};
rules.mark_close = function(/* tokens, idx, options, env */) {
  return '</mark>';
};

/**
 * Super- and sub-script
 */

rules.sub = function(tokens, idx /*, options, env */) {
  return '<sub>' + escapeHtml(tokens[idx].content) + '</sub>';
};
rules.sup = function(tokens, idx /*, options, env */) {
  return '<sup>' + escapeHtml(tokens[idx].content) + '</sup>';
};

/**
 * Breaks
 */

rules.hardbreak = function(tokens, idx, options /*, env */) {
  return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
rules.softbreak = function(tokens, idx, options /*, env */) {
  return options.breaks ? (options.xhtmlOut ? '<br />\n' : '<br>\n') : '\n';
};

/**
 * Text
 */

rules.text = function(tokens, idx /*, options, env */) {
  return escapeHtml(tokens[idx].content);
};

/**
 * Content
 */

rules.htmlblock = function(tokens, idx /*, options, env */) {
  return tokens[idx].content;
};
rules.htmltag = function(tokens, idx /*, options, env */) {
  return tokens[idx].content;
};

/**
 * Abbreviations, initialism
 */

rules.abbr_open = function(tokens, idx /*, options, env */) {
  return '<abbr title="' + escapeHtml(replaceEntities(tokens[idx].title)) + '">';
};
rules.abbr_close = function(/* tokens, idx, options, env */) {
  return '</abbr>';
};

/**
 * Footnotes
 */

rules.footnote_ref = function(tokens, idx) {
  var n = Number(tokens[idx].id + 1).toString();
  var id = 'fnref' + n;
  if (tokens[idx].subId > 0) {
    id += ':' + tokens[idx].subId;
  }
  return '<sup class="footnote-ref"><a href="#fn' + n + '" id="' + id + '">[' + n + ']</a></sup>';
};
rules.footnote_block_open = function(tokens, idx, options) {
  var hr = options.xhtmlOut
    ? '<hr class="footnotes-sep" />\n'
    : '<hr class="footnotes-sep">\n';
  return hr + '<section class="footnotes">\n<ol class="footnotes-list">\n';
};
rules.footnote_block_close = function() {
  return '</ol>\n</section>\n';
};
rules.footnote_open = function(tokens, idx) {
  var id = Number(tokens[idx].id + 1).toString();
  return '<li id="fn' + id + '"  class="footnote-item">';
};
rules.footnote_close = function() {
  return '</li>\n';
};
rules.footnote_anchor = function(tokens, idx) {
  var n = Number(tokens[idx].id + 1).toString();
  var id = 'fnref' + n;
  if (tokens[idx].subId > 0) {
    id += ':' + tokens[idx].subId;
  }
  return ' <a href="#' + id + '" class="footnote-backref">↩</a>';
};

/**
 * Definition lists
 */

rules.dl_open = function() {
  return '<dl>\n';
};
rules.dt_open = function() {
  return '<dt>';
};
rules.dd_open = function() {
  return '<dd>';
};
rules.dl_close = function() {
  return '</dl>\n';
};
rules.dt_close = function() {
  return '</dt>\n';
};
rules.dd_close = function() {
  return '</dd>\n';
};

/**
 * Helper functions
 */

function nextToken(tokens, idx) {
  if (++idx >= tokens.length - 2) {
    return idx;
  }
  if ((tokens[idx].type === 'paragraph_open' && tokens[idx].tight) &&
      (tokens[idx + 1].type === 'inline' && tokens[idx + 1].content.length === 0) &&
      (tokens[idx + 2].type === 'paragraph_close' && tokens[idx + 2].tight)) {
    return nextToken(tokens, idx + 2);
  }
  return idx;
}

/**
 * Check to see if `\n` is needed before the next token.
 *
 * @param  {Array} `tokens`
 * @param  {Number} `idx`
 * @return {String} Empty string or newline
 * @api private
 */

var getBreak = rules.getBreak = function getBreak(tokens, idx) {
  idx = nextToken(tokens, idx);
  if (idx < tokens.length && tokens[idx].type === 'list_item_close') {
    return '';
  }
  return '\n';
};

/**
 * Renderer class. Renders HTML and exposes `rules` to allow
 * local modifications.
 */

function Renderer() {
  this.rules = index_browser_assign({}, rules);

  // exported helper, for custom rules only
  this.getBreak = rules.getBreak;
}

/**
 * Render a string of inline HTML with the given `tokens` and
 * `options`.
 *
 * @param  {Array} `tokens`
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @return {String}
 * @api public
 */

Renderer.prototype.renderInline = function (tokens, options, env) {
  var _rules = this.rules;
  var len = tokens.length, i = 0;
  var result = '';

  while (len--) {
    result += _rules[tokens[i].type](tokens, i++, options, env, this);
  }

  return result;
};

/**
 * Render a string of HTML with the given `tokens` and
 * `options`.
 *
 * @param  {Array} `tokens`
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @return {String}
 * @api public
 */

Renderer.prototype.render = function (tokens, options, env) {
  var _rules = this.rules;
  var len = tokens.length, i = -1;
  var result = '';

  while (++i < len) {
    if (tokens[i].type === 'inline') {
      result += this.renderInline(tokens[i].children, options, env);
    } else {
      result += _rules[tokens[i].type](tokens, i, options, env, this);
    }
  }
  return result;
};

/**
 * Ruler is a helper class for building responsibility chains from
 * parse rules. It allows:
 *
 *   - easy stack rules chains
 *   - getting main chain and named chains content (as arrays of functions)
 *
 * Helper methods, should not be used directly.
 * @api private
 */

function Ruler() {
  // List of added rules. Each element is:
  //
  // { name: XXX,
  //   enabled: Boolean,
  //   fn: Function(),
  //   alt: [ name2, name3 ] }
  //
  this.__rules__ = [];

  // Cached rule chains.
  //
  // First level - chain name, '' for default.
  // Second level - digital anchor for fast filtering by charcodes.
  //
  this.__cache__ = null;
}

/**
 * Find the index of a rule by `name`.
 *
 * @param  {String} `name`
 * @return {Number} Index of the given `name`
 * @api private
 */

Ruler.prototype.__find__ = function (name) {
  var len = this.__rules__.length;
  var i = -1;

  while (len--) {
    if (this.__rules__[++i].name === name) {
      return i;
    }
  }
  return -1;
};

/**
 * Build the rules lookup cache
 *
 * @api private
 */

Ruler.prototype.__compile__ = function () {
  var self = this;
  var chains = [ '' ];

  // collect unique names
  self.__rules__.forEach(function (rule) {
    if (!rule.enabled) {
      return;
    }

    rule.alt.forEach(function (altName) {
      if (chains.indexOf(altName) < 0) {
        chains.push(altName);
      }
    });
  });

  self.__cache__ = {};

  chains.forEach(function (chain) {
    self.__cache__[chain] = [];
    self.__rules__.forEach(function (rule) {
      if (!rule.enabled) {
        return;
      }

      if (chain && rule.alt.indexOf(chain) < 0) {
        return;
      }
      self.__cache__[chain].push(rule.fn);
    });
  });
};

/**
 * Ruler public methods
 * ------------------------------------------------
 */

/**
 * Replace rule function
 *
 * @param  {String} `name` Rule name
 * @param  {Function `fn`
 * @param  {Object} `options`
 * @api private
 */

Ruler.prototype.at = function (name, fn, options) {
  var idx = this.__find__(name);
  var opt = options || {};

  if (idx === -1) {
    throw new Error('Parser rule not found: ' + name);
  }

  this.__rules__[idx].fn = fn;
  this.__rules__[idx].alt = opt.alt || [];
  this.__cache__ = null;
};

/**
 * Add a rule to the chain before given the `ruleName`.
 *
 * @param  {String}   `beforeName`
 * @param  {String}   `ruleName`
 * @param  {Function} `fn`
 * @param  {Object}   `options`
 * @api private
 */

Ruler.prototype.before = function (beforeName, ruleName, fn, options) {
  var idx = this.__find__(beforeName);
  var opt = options || {};

  if (idx === -1) {
    throw new Error('Parser rule not found: ' + beforeName);
  }

  this.__rules__.splice(idx, 0, {
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};

/**
 * Add a rule to the chain after the given `ruleName`.
 *
 * @param  {String}   `afterName`
 * @param  {String}   `ruleName`
 * @param  {Function} `fn`
 * @param  {Object}   `options`
 * @api private
 */

Ruler.prototype.after = function (afterName, ruleName, fn, options) {
  var idx = this.__find__(afterName);
  var opt = options || {};

  if (idx === -1) {
    throw new Error('Parser rule not found: ' + afterName);
  }

  this.__rules__.splice(idx + 1, 0, {
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};

/**
 * Add a rule to the end of chain.
 *
 * @param  {String}   `ruleName`
 * @param  {Function} `fn`
 * @param  {Object}   `options`
 * @return {String}
 */

Ruler.prototype.push = function (ruleName, fn, options) {
  var opt = options || {};

  this.__rules__.push({
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};

/**
 * Enable a rule or list of rules.
 *
 * @param  {String|Array} `list` Name or array of rule names to enable
 * @param  {Boolean} `strict` If `true`, all non listed rules will be disabled.
 * @api private
 */

Ruler.prototype.enable = function (list, strict) {
  list = !Array.isArray(list)
    ? [ list ]
    : list;

  // In strict mode disable all existing rules first
  if (strict) {
    this.__rules__.forEach(function (rule) {
      rule.enabled = false;
    });
  }

  // Search by name and enable
  list.forEach(function (name) {
    var idx = this.__find__(name);
    if (idx < 0) {
      throw new Error('Rules manager: invalid rule name ' + name);
    }
    this.__rules__[idx].enabled = true;
  }, this);

  this.__cache__ = null;
};


/**
 * Disable a rule or list of rules.
 *
 * @param  {String|Array} `list` Name or array of rule names to disable
 * @api private
 */

Ruler.prototype.disable = function (list) {
  list = !Array.isArray(list)
    ? [ list ]
    : list;

  // Search by name and disable
  list.forEach(function (name) {
    var idx = this.__find__(name);
    if (idx < 0) {
      throw new Error('Rules manager: invalid rule name ' + name);
    }
    this.__rules__[idx].enabled = false;
  }, this);

  this.__cache__ = null;
};

/**
 * Get a rules list as an array of functions.
 *
 * @param  {String} `chainName`
 * @return {Object}
 * @api private
 */

Ruler.prototype.getRules = function (chainName) {
  if (this.__cache__ === null) {
    this.__compile__();
  }
  return this.__cache__[chainName] || [];
};

function block(state) {

  if (state.inlineMode) {
    state.tokens.push({
      type: 'inline',
      content: state.src.replace(/\n/g, ' ').trim(),
      level: 0,
      lines: [ 0, 1 ],
      children: []
    });

  } else {
    state.block.parse(state.src, state.options, state.env, state.tokens);
  }
}

// Inline parser state

function StateInline(src, parserInline, options, env, outTokens) {
  this.src = src;
  this.env = env;
  this.options = options;
  this.parser = parserInline;
  this.tokens = outTokens;
  this.pos = 0;
  this.posMax = this.src.length;
  this.level = 0;
  this.pending = '';
  this.pendingLevel = 0;

  this.cache = [];        // Stores { start: end } pairs. Useful for backtrack
                          // optimization of pairs parse (emphasis, strikes).

  // Link parser state vars

  this.isInLabel = false; // Set true when seek link label - we should disable
                          // "paired" rules (emphasis, strikes) to not skip
                          // tailing `]`

  this.linkLevel = 0;     // Increment for each nesting link. Used to prevent
                          // nesting in definitions

  this.linkContent = '';  // Temporary storage for link url

  this.labelUnmatchedScopes = 0; // Track unpaired `[` for link labels
                                 // (backtrack optimization)
}

// Flush pending text
//
StateInline.prototype.pushPending = function () {
  this.tokens.push({
    type: 'text',
    content: this.pending,
    level: this.pendingLevel
  });
  this.pending = '';
};

// Push new token to "stream".
// If pending text exists - flush it as text token
//
StateInline.prototype.push = function (token) {
  if (this.pending) {
    this.pushPending();
  }

  this.tokens.push(token);
  this.pendingLevel = this.level;
};

// Store value to cache.
// !!! Implementation has parser-specific optimizations
// !!! keys MUST be integer, >= 0; values MUST be integer, > 0
//
StateInline.prototype.cacheSet = function (key, val) {
  for (var i = this.cache.length; i <= key; i++) {
    this.cache.push(0);
  }

  this.cache[key] = val;
};

// Get cache value
//
StateInline.prototype.cacheGet = function (key) {
  return key < this.cache.length ? this.cache[key] : 0;
};

/**
 * Parse link labels
 *
 * This function assumes that first character (`[`) already matches;
 * returns the end of the label.
 *
 * @param  {Object} state
 * @param  {Number} start
 * @api private
 */

function parseLinkLabel(state, start) {
  var level, found, marker,
      labelEnd = -1,
      max = state.posMax,
      oldPos = state.pos,
      oldFlag = state.isInLabel;

  if (state.isInLabel) { return -1; }

  if (state.labelUnmatchedScopes) {
    state.labelUnmatchedScopes--;
    return -1;
  }

  state.pos = start + 1;
  state.isInLabel = true;
  level = 1;

  while (state.pos < max) {
    marker = state.src.charCodeAt(state.pos);
    if (marker === 0x5B /* [ */) {
      level++;
    } else if (marker === 0x5D /* ] */) {
      level--;
      if (level === 0) {
        found = true;
        break;
      }
    }

    state.parser.skipToken(state);
  }

  if (found) {
    labelEnd = state.pos;
    state.labelUnmatchedScopes = 0;
  } else {
    state.labelUnmatchedScopes = level - 1;
  }

  // restore old state
  state.pos = oldPos;
  state.isInLabel = oldFlag;

  return labelEnd;
}

// Parse abbreviation definitions, i.e. `*[abbr]: description`


function parseAbbr(str, parserInline, options, env) {
  var state, labelEnd, pos, max, label, title;

  if (str.charCodeAt(0) !== 0x2A/* * */) { return -1; }
  if (str.charCodeAt(1) !== 0x5B/* [ */) { return -1; }

  if (str.indexOf(']:') === -1) { return -1; }

  state = new StateInline(str, parserInline, options, env, []);
  labelEnd = parseLinkLabel(state, 1);

  if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A/* : */) { return -1; }

  max = state.posMax;

  // abbr title is always one line, so looking for ending "\n" here
  for (pos = labelEnd + 2; pos < max; pos++) {
    if (state.src.charCodeAt(pos) === 0x0A) { break; }
  }

  label = str.slice(2, labelEnd);
  title = str.slice(labelEnd + 2, pos).trim();
  if (title.length === 0) { return -1; }
  if (!env.abbreviations) { env.abbreviations = {}; }
  // prepend ':' to avoid conflict with Object.prototype members
  if (typeof env.abbreviations[':' + label] === 'undefined') {
    env.abbreviations[':' + label] = title;
  }

  return pos;
}

function abbr(state) {
  var tokens = state.tokens, i, l, content, pos;

  if (state.inlineMode) {
    return;
  }

  // Parse inlines
  for (i = 1, l = tokens.length - 1; i < l; i++) {
    if (tokens[i - 1].type === 'paragraph_open' &&
        tokens[i].type === 'inline' &&
        tokens[i + 1].type === 'paragraph_close') {

      content = tokens[i].content;
      while (content.length) {
        pos = parseAbbr(content, state.inline, state.options, state.env);
        if (pos < 0) { break; }
        content = content.slice(pos).trim();
      }

      tokens[i].content = content;
      if (!content.length) {
        tokens[i - 1].tight = true;
        tokens[i + 1].tight = true;
      }
    }
  }
}

function normalizeLink(url) {
  var normalized = replaceEntities(url);
  // We shouldn't care about the result of malformed URIs,
  // and should not throw an exception.
  try {
    normalized = decodeURI(normalized);
  } catch (err) {}
  return encodeURI(normalized);
}

/**
 * Parse link destination
 *
 *   - on success it returns a string and updates state.pos;
 *   - on failure it returns null
 *
 * @param  {Object} state
 * @param  {Number} pos
 * @api private
 */

function parseLinkDestination(state, pos) {
  var code, level, link,
      start = pos,
      max = state.posMax;

  if (state.src.charCodeAt(pos) === 0x3C /* < */) {
    pos++;
    while (pos < max) {
      code = state.src.charCodeAt(pos);
      if (code === 0x0A /* \n */) { return false; }
      if (code === 0x3E /* > */) {
        link = normalizeLink(unescapeMd(state.src.slice(start + 1, pos)));
        if (!state.parser.validateLink(link)) { return false; }
        state.pos = pos + 1;
        state.linkContent = link;
        return true;
      }
      if (code === 0x5C /* \ */ && pos + 1 < max) {
        pos += 2;
        continue;
      }

      pos++;
    }

    // no closing '>'
    return false;
  }

  // this should be ... } else { ... branch

  level = 0;
  while (pos < max) {
    code = state.src.charCodeAt(pos);

    if (code === 0x20) { break; }

    // ascii control chars
    if (code < 0x20 || code === 0x7F) { break; }

    if (code === 0x5C /* \ */ && pos + 1 < max) {
      pos += 2;
      continue;
    }

    if (code === 0x28 /* ( */) {
      level++;
      if (level > 1) { break; }
    }

    if (code === 0x29 /* ) */) {
      level--;
      if (level < 0) { break; }
    }

    pos++;
  }

  if (start === pos) { return false; }

  link = unescapeMd(state.src.slice(start, pos));
  if (!state.parser.validateLink(link)) { return false; }

  state.linkContent = link;
  state.pos = pos;
  return true;
}

/**
 * Parse link title
 *
 *   - on success it returns a string and updates state.pos;
 *   - on failure it returns null
 *
 * @param  {Object} state
 * @param  {Number} pos
 * @api private
 */

function parseLinkTitle(state, pos) {
  var code,
      start = pos,
      max = state.posMax,
      marker = state.src.charCodeAt(pos);

  if (marker !== 0x22 /* " */ && marker !== 0x27 /* ' */ && marker !== 0x28 /* ( */) { return false; }

  pos++;

  // if opening marker is "(", switch it to closing marker ")"
  if (marker === 0x28) { marker = 0x29; }

  while (pos < max) {
    code = state.src.charCodeAt(pos);
    if (code === marker) {
      state.pos = pos + 1;
      state.linkContent = unescapeMd(state.src.slice(start + 1, pos));
      return true;
    }
    if (code === 0x5C /* \ */ && pos + 1 < max) {
      pos += 2;
      continue;
    }

    pos++;
  }

  return false;
}

function normalizeReference(str) {
  // use .toUpperCase() instead of .toLowerCase()
  // here to avoid a conflict with Object.prototype
  // members (most notably, `__proto__`)
  return str.trim().replace(/\s+/g, ' ').toUpperCase();
}

function parseReference(str, parser, options, env) {
  var state, labelEnd, pos, max, code, start, href, title, label;

  if (str.charCodeAt(0) !== 0x5B/* [ */) { return -1; }

  if (str.indexOf(']:') === -1) { return -1; }

  state = new StateInline(str, parser, options, env, []);
  labelEnd = parseLinkLabel(state, 0);

  if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A/* : */) { return -1; }

  max = state.posMax;

  // [label]:   destination   'title'
  //         ^^^ skip optional whitespace here
  for (pos = labelEnd + 2; pos < max; pos++) {
    code = state.src.charCodeAt(pos);
    if (code !== 0x20 && code !== 0x0A) { break; }
  }

  // [label]:   destination   'title'
  //            ^^^^^^^^^^^ parse this
  if (!parseLinkDestination(state, pos)) { return -1; }
  href = state.linkContent;
  pos = state.pos;

  // [label]:   destination   'title'
  //                       ^^^ skipping those spaces
  start = pos;
  for (pos = pos + 1; pos < max; pos++) {
    code = state.src.charCodeAt(pos);
    if (code !== 0x20 && code !== 0x0A) { break; }
  }

  // [label]:   destination   'title'
  //                          ^^^^^^^ parse this
  if (pos < max && start !== pos && parseLinkTitle(state, pos)) {
    title = state.linkContent;
    pos = state.pos;
  } else {
    title = '';
    pos = start;
  }

  // ensure that the end of the line is empty
  while (pos < max && state.src.charCodeAt(pos) === 0x20/* space */) { pos++; }
  if (pos < max && state.src.charCodeAt(pos) !== 0x0A) { return -1; }

  label = normalizeReference(str.slice(1, labelEnd));
  if (typeof env.references[label] === 'undefined') {
    env.references[label] = { title: title, href: href };
  }

  return pos;
}


function references(state) {
  var tokens = state.tokens, i, l, content, pos;

  state.env.references = state.env.references || {};

  if (state.inlineMode) {
    return;
  }

  // Scan definitions in paragraph inlines
  for (i = 1, l = tokens.length - 1; i < l; i++) {
    if (tokens[i].type === 'inline' &&
        tokens[i - 1].type === 'paragraph_open' &&
        tokens[i + 1].type === 'paragraph_close') {

      content = tokens[i].content;
      while (content.length) {
        pos = parseReference(content, state.inline, state.options, state.env);
        if (pos < 0) { break; }
        content = content.slice(pos).trim();
      }

      tokens[i].content = content;
      if (!content.length) {
        tokens[i - 1].tight = true;
        tokens[i + 1].tight = true;
      }
    }
  }
}

function inline(state) {
  var tokens = state.tokens, tok, i, l;

  // Parse inlines
  for (i = 0, l = tokens.length; i < l; i++) {
    tok = tokens[i];
    if (tok.type === 'inline') {
      state.inline.parse(tok.content, state.options, state.env, tok.children);
    }
  }
}

function footnote_block(state) {
  var i, l, j, t, lastParagraph, list, tokens, current, currentLabel,
      level = 0,
      insideRef = false,
      refTokens = {};

  if (!state.env.footnotes) { return; }

  state.tokens = state.tokens.filter(function(tok) {
    if (tok.type === 'footnote_reference_open') {
      insideRef = true;
      current = [];
      currentLabel = tok.label;
      return false;
    }
    if (tok.type === 'footnote_reference_close') {
      insideRef = false;
      // prepend ':' to avoid conflict with Object.prototype members
      refTokens[':' + currentLabel] = current;
      return false;
    }
    if (insideRef) { current.push(tok); }
    return !insideRef;
  });

  if (!state.env.footnotes.list) { return; }
  list = state.env.footnotes.list;

  state.tokens.push({
    type: 'footnote_block_open',
    level: level++
  });
  for (i = 0, l = list.length; i < l; i++) {
    state.tokens.push({
      type: 'footnote_open',
      id: i,
      level: level++
    });

    if (list[i].tokens) {
      tokens = [];
      tokens.push({
        type: 'paragraph_open',
        tight: false,
        level: level++
      });
      tokens.push({
        type: 'inline',
        content: '',
        level: level,
        children: list[i].tokens
      });
      tokens.push({
        type: 'paragraph_close',
        tight: false,
        level: --level
      });
    } else if (list[i].label) {
      tokens = refTokens[':' + list[i].label];
    }

    state.tokens = state.tokens.concat(tokens);
    if (state.tokens[state.tokens.length - 1].type === 'paragraph_close') {
      lastParagraph = state.tokens.pop();
    } else {
      lastParagraph = null;
    }

    t = list[i].count > 0 ? list[i].count : 1;
    for (j = 0; j < t; j++) {
      state.tokens.push({
        type: 'footnote_anchor',
        id: i,
        subId: j,
        level: level
      });
    }

    if (lastParagraph) {
      state.tokens.push(lastParagraph);
    }

    state.tokens.push({
      type: 'footnote_close',
      level: --level
    });
  }
  state.tokens.push({
    type: 'footnote_block_close',
    level: --level
  });
}

// Enclose abbreviations in <abbr> tags
//

var PUNCT_CHARS = ' \n()[]\'".,!?-';


// from Google closure library
// http://closure-library.googlecode.com/git-history/docs/local_closure_goog_string_string.js.source.html#line1021
function regEscape(s) {
  return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1');
}


function abbr2(state) {
  var i, j, l, tokens, token, text, nodes, pos, level, reg, m, regText,
      blockTokens = state.tokens;

  if (!state.env.abbreviations) { return; }
  if (!state.env.abbrRegExp) {
    regText = '(^|[' + PUNCT_CHARS.split('').map(regEscape).join('') + '])'
            + '(' + Object.keys(state.env.abbreviations).map(function (x) {
                      return x.substr(1);
                    }).sort(function (a, b) {
                      return b.length - a.length;
                    }).map(regEscape).join('|') + ')'
            + '($|[' + PUNCT_CHARS.split('').map(regEscape).join('') + '])';
    state.env.abbrRegExp = new RegExp(regText, 'g');
  }
  reg = state.env.abbrRegExp;

  for (j = 0, l = blockTokens.length; j < l; j++) {
    if (blockTokens[j].type !== 'inline') { continue; }
    tokens = blockTokens[j].children;

    // We scan from the end, to keep position when new tags added.
    for (i = tokens.length - 1; i >= 0; i--) {
      token = tokens[i];
      if (token.type !== 'text') { continue; }

      pos = 0;
      text = token.content;
      reg.lastIndex = 0;
      level = token.level;
      nodes = [];

      while ((m = reg.exec(text))) {
        if (reg.lastIndex > pos) {
          nodes.push({
            type: 'text',
            content: text.slice(pos, m.index + m[1].length),
            level: level
          });
        }

        nodes.push({
          type: 'abbr_open',
          title: state.env.abbreviations[':' + m[2]],
          level: level++
        });
        nodes.push({
          type: 'text',
          content: m[2],
          level: level
        });
        nodes.push({
          type: 'abbr_close',
          level: --level
        });
        pos = reg.lastIndex - m[3].length;
      }

      if (!nodes.length) { continue; }

      if (pos < text.length) {
        nodes.push({
          type: 'text',
          content: text.slice(pos),
          level: level
        });
      }

      // replace current node
      blockTokens[j].children = tokens = [].concat(tokens.slice(0, i), nodes, tokens.slice(i + 1));
    }
  }
}

// Simple typographical replacements
//
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - miltiplication 2 x 4 -> 2 × 4

var RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;

var SCOPED_ABBR_RE = /\((c|tm|r|p)\)/ig;
var SCOPED_ABBR = {
  'c': '©',
  'r': '®',
  'p': '§',
  'tm': '™'
};

function replaceScopedAbbr(str) {
  if (str.indexOf('(') < 0) { return str; }

  return str.replace(SCOPED_ABBR_RE, function(match, name) {
    return SCOPED_ABBR[name.toLowerCase()];
  });
}


function replace(state) {
  var i, token, text, inlineTokens, blkIdx;

  if (!state.options.typographer) { return; }

  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {

    if (state.tokens[blkIdx].type !== 'inline') { continue; }

    inlineTokens = state.tokens[blkIdx].children;

    for (i = inlineTokens.length - 1; i >= 0; i--) {
      token = inlineTokens[i];
      if (token.type === 'text') {
        text = token.content;

        text = replaceScopedAbbr(text);

        if (RARE_RE.test(text)) {
          text = text
            .replace(/\+-/g, '±')
            // .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, '…').replace(/([?!])…/g, '$1..')
            .replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')
            // em-dash
            .replace(/(^|[^-])---([^-]|$)/mg, '$1\u2014$2')
            // en-dash
            .replace(/(^|\s)--(\s|$)/mg, '$1\u2013$2')
            .replace(/(^|[^-\s])--([^-\s]|$)/mg, '$1\u2013$2');
        }

        token.content = text;
      }
    }
  }
}

// Convert straight quotation marks to typographic ones
//

var QUOTE_TEST_RE = /['"]/;
var QUOTE_RE = /['"]/g;
var PUNCT_RE = /[-\s()\[\]]/;
var APOSTROPHE = '’';

// This function returns true if the character at `pos`
// could be inside a word.
function isLetter(str, pos) {
  if (pos < 0 || pos >= str.length) { return false; }
  return !PUNCT_RE.test(str[pos]);
}


function replaceAt(str, index, ch) {
  return str.substr(0, index) + ch + str.substr(index + 1);
}


function smartquotes(state) {
  /*eslint max-depth:0*/
  var i, token, text, t, pos, max, thisLevel, lastSpace, nextSpace, item,
      canOpen, canClose, j, isSingle, blkIdx, tokens,
      stack;

  if (!state.options.typographer) { return; }

  stack = [];

  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {

    if (state.tokens[blkIdx].type !== 'inline') { continue; }

    tokens = state.tokens[blkIdx].children;
    stack.length = 0;

    for (i = 0; i < tokens.length; i++) {
      token = tokens[i];

      if (token.type !== 'text' || QUOTE_TEST_RE.test(token.text)) { continue; }

      thisLevel = tokens[i].level;

      for (j = stack.length - 1; j >= 0; j--) {
        if (stack[j].level <= thisLevel) { break; }
      }
      stack.length = j + 1;

      text = token.content;
      pos = 0;
      max = text.length;

      /*eslint no-labels:0,block-scoped-var:0*/
      OUTER:
      while (pos < max) {
        QUOTE_RE.lastIndex = pos;
        t = QUOTE_RE.exec(text);
        if (!t) { break; }

        lastSpace = !isLetter(text, t.index - 1);
        pos = t.index + 1;
        isSingle = (t[0] === "'");
        nextSpace = !isLetter(text, pos);

        if (!nextSpace && !lastSpace) {
          // middle of word
          if (isSingle) {
            token.content = replaceAt(token.content, t.index, APOSTROPHE);
          }
          continue;
        }

        canOpen = !nextSpace;
        canClose = !lastSpace;

        if (canClose) {
          // this could be a closing quote, rewind the stack to get a match
          for (j = stack.length - 1; j >= 0; j--) {
            item = stack[j];
            if (stack[j].level < thisLevel) { break; }
            if (item.single === isSingle && stack[j].level === thisLevel) {
              item = stack[j];
              if (isSingle) {
                tokens[item.token].content = replaceAt(tokens[item.token].content, item.pos, state.options.quotes[2]);
                token.content = replaceAt(token.content, t.index, state.options.quotes[3]);
              } else {
                tokens[item.token].content = replaceAt(tokens[item.token].content, item.pos, state.options.quotes[0]);
                token.content = replaceAt(token.content, t.index, state.options.quotes[1]);
              }
              stack.length = j;
              continue OUTER;
            }
          }
        }

        if (canOpen) {
          stack.push({
            token: i,
            pos: t.index,
            single: isSingle,
            level: thisLevel
          });
        } else if (canClose && isSingle) {
          token.content = replaceAt(token.content, t.index, APOSTROPHE);
        }
      }
    }
  }
}

/**
 * Core parser `rules`
 */

var _rules = [
  [ 'block',          block          ],
  [ 'abbr',           abbr           ],
  [ 'references',     references     ],
  [ 'inline',         inline         ],
  [ 'footnote_tail',  footnote_block  ],
  [ 'abbr2',          abbr2          ],
  [ 'replacements',   replace   ],
  [ 'smartquotes',    smartquotes    ],
];

/**
 * Class for top level (`core`) parser rules
 *
 * @api private
 */

function Core() {
  this.options = {};
  this.ruler = new Ruler();
  for (var i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1]);
  }
}

/**
 * Process rules with the given `state`
 *
 * @param  {Object} `state`
 * @api private
 */

Core.prototype.process = function (state) {
  var i, l, rules;
  rules = this.ruler.getRules('');
  for (i = 0, l = rules.length; i < l; i++) {
    rules[i](state);
  }
};

// Parser state class

function StateBlock(src, parser, options, env, tokens) {
  var ch, s, start, pos, len, indent, indent_found;

  this.src = src;

  // Shortcuts to simplify nested calls
  this.parser = parser;

  this.options = options;

  this.env = env;

  //
  // Internal state vartiables
  //

  this.tokens = tokens;

  this.bMarks = [];  // line begin offsets for fast jumps
  this.eMarks = [];  // line end offsets for fast jumps
  this.tShift = [];  // indent for each line

  // block parser variables
  this.blkIndent  = 0; // required block content indent
                       // (for example, if we are in list)
  this.line       = 0; // line index in src
  this.lineMax    = 0; // lines count
  this.tight      = false;  // loose/tight mode for lists
  this.parentType = 'root'; // if `list`, block parser stops on two newlines
  this.ddIndent   = -1; // indent of the current dd block (-1 if there isn't any)

  this.level = 0;

  // renderer
  this.result = '';

  // Create caches
  // Generate markers.
  s = this.src;
  indent = 0;
  indent_found = false;

  for (start = pos = indent = 0, len = s.length; pos < len; pos++) {
    ch = s.charCodeAt(pos);

    if (!indent_found) {
      if (ch === 0x20/* space */) {
        indent++;
        continue;
      } else {
        indent_found = true;
      }
    }

    if (ch === 0x0A || pos === len - 1) {
      if (ch !== 0x0A) { pos++; }
      this.bMarks.push(start);
      this.eMarks.push(pos);
      this.tShift.push(indent);

      indent_found = false;
      indent = 0;
      start = pos + 1;
    }
  }

  // Push fake entry to simplify cache bounds checks
  this.bMarks.push(s.length);
  this.eMarks.push(s.length);
  this.tShift.push(0);

  this.lineMax = this.bMarks.length - 1; // don't count last fake line
}

StateBlock.prototype.isEmpty = function isEmpty(line) {
  return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};

StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
  for (var max = this.lineMax; from < max; from++) {
    if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) {
      break;
    }
  }
  return from;
};

// Skip spaces from given position.
StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
  for (var max = this.src.length; pos < max; pos++) {
    if (this.src.charCodeAt(pos) !== 0x20/* space */) { break; }
  }
  return pos;
};

// Skip char codes from given position
StateBlock.prototype.skipChars = function skipChars(pos, code) {
  for (var max = this.src.length; pos < max; pos++) {
    if (this.src.charCodeAt(pos) !== code) { break; }
  }
  return pos;
};

// Skip char codes reverse from given position - 1
StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
  if (pos <= min) { return pos; }

  while (pos > min) {
    if (code !== this.src.charCodeAt(--pos)) { return pos + 1; }
  }
  return pos;
};

// cut lines range from source.
StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
  var i, first, last, queue, shift,
      line = begin;

  if (begin >= end) {
    return '';
  }

  // Opt: don't use push queue for single line;
  if (line + 1 === end) {
    first = this.bMarks[line] + Math.min(this.tShift[line], indent);
    last = keepLastLF ? this.eMarks[line] + 1 : this.eMarks[line];
    return this.src.slice(first, last);
  }

  queue = new Array(end - begin);

  for (i = 0; line < end; line++, i++) {
    shift = this.tShift[line];
    if (shift > indent) { shift = indent; }
    if (shift < 0) { shift = 0; }

    first = this.bMarks[line] + shift;

    if (line + 1 < end || keepLastLF) {
      // No need for bounds check because we have fake entry on tail.
      last = this.eMarks[line] + 1;
    } else {
      last = this.eMarks[line];
    }

    queue[i] = this.src.slice(first, last);
  }

  return queue.join('');
};

// Code block (4 spaces padded)

function code(state, startLine, endLine/*, silent*/) {
  var nextLine, last;

  if (state.tShift[startLine] - state.blkIndent < 4) { return false; }

  last = nextLine = startLine + 1;

  while (nextLine < endLine) {
    if (state.isEmpty(nextLine)) {
      nextLine++;
      continue;
    }
    if (state.tShift[nextLine] - state.blkIndent >= 4) {
      nextLine++;
      last = nextLine;
      continue;
    }
    break;
  }

  state.line = nextLine;
  state.tokens.push({
    type: 'code',
    content: state.getLines(startLine, last, 4 + state.blkIndent, true),
    block: true,
    lines: [ startLine, state.line ],
    level: state.level
  });

  return true;
}

// fences (``` lang, ~~~ lang)

function fences(state, startLine, endLine, silent) {
  var marker, len, params, nextLine, mem,
      haveEndMarker = false,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  if (pos + 3 > max) { return false; }

  marker = state.src.charCodeAt(pos);

  if (marker !== 0x7E/* ~ */ && marker !== 0x60 /* ` */) {
    return false;
  }

  // scan marker length
  mem = pos;
  pos = state.skipChars(pos, marker);

  len = pos - mem;

  if (len < 3) { return false; }

  params = state.src.slice(pos, max).trim();

  if (params.indexOf('`') >= 0) { return false; }

  // Since start is found, we can report success here in validation mode
  if (silent) { return true; }

  // search end of block
  nextLine = startLine;

  for (;;) {
    nextLine++;
    if (nextLine >= endLine) {
      // unclosed block should be autoclosed by end of document.
      // also block seems to be autoclosed by end of parent
      break;
    }

    pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
    max = state.eMarks[nextLine];

    if (pos < max && state.tShift[nextLine] < state.blkIndent) {
      // non-empty line with negative indent should stop the list:
      // - ```
      //  test
      break;
    }

    if (state.src.charCodeAt(pos) !== marker) { continue; }

    if (state.tShift[nextLine] - state.blkIndent >= 4) {
      // closing fence should be indented less than 4 spaces
      continue;
    }

    pos = state.skipChars(pos, marker);

    // closing code fence must be at least as long as the opening one
    if (pos - mem < len) { continue; }

    // make sure tail has spaces only
    pos = state.skipSpaces(pos);

    if (pos < max) { continue; }

    haveEndMarker = true;
    // found!
    break;
  }

  // If a fence has heading spaces, they should be removed from its inner block
  len = state.tShift[startLine];

  state.line = nextLine + (haveEndMarker ? 1 : 0);
  state.tokens.push({
    type: 'fence',
    params: params,
    content: state.getLines(startLine + 1, nextLine, len, true),
    lines: [ startLine, state.line ],
    level: state.level
  });

  return true;
}

// Block quotes

function blockquote(state, startLine, endLine, silent) {
  var nextLine, lastLineEmpty, oldTShift, oldBMarks, oldIndent, oldParentType, lines,
      terminatorRules,
      i, l, terminate,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  if (pos > max) { return false; }

  // check the block quote marker
  if (state.src.charCodeAt(pos++) !== 0x3E/* > */) { return false; }

  if (state.level >= state.options.maxNesting) { return false; }

  // we know that it's going to be a valid blockquote,
  // so no point trying to find the end of it in silent mode
  if (silent) { return true; }

  // skip one optional space after '>'
  if (state.src.charCodeAt(pos) === 0x20) { pos++; }

  oldIndent = state.blkIndent;
  state.blkIndent = 0;

  oldBMarks = [ state.bMarks[startLine] ];
  state.bMarks[startLine] = pos;

  // check if we have an empty blockquote
  pos = pos < max ? state.skipSpaces(pos) : pos;
  lastLineEmpty = pos >= max;

  oldTShift = [ state.tShift[startLine] ];
  state.tShift[startLine] = pos - state.bMarks[startLine];

  terminatorRules = state.parser.ruler.getRules('blockquote');

  // Search the end of the block
  //
  // Block ends with either:
  //  1. an empty line outside:
  //     ```
  //     > test
  //
  //     ```
  //  2. an empty line inside:
  //     ```
  //     >
  //     test
  //     ```
  //  3. another tag
  //     ```
  //     > test
  //      - - -
  //     ```
  for (nextLine = startLine + 1; nextLine < endLine; nextLine++) {
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    max = state.eMarks[nextLine];

    if (pos >= max) {
      // Case 1: line is not inside the blockquote, and this line is empty.
      break;
    }

    if (state.src.charCodeAt(pos++) === 0x3E/* > */) {
      // This line is inside the blockquote.

      // skip one optional space after '>'
      if (state.src.charCodeAt(pos) === 0x20) { pos++; }

      oldBMarks.push(state.bMarks[nextLine]);
      state.bMarks[nextLine] = pos;

      pos = pos < max ? state.skipSpaces(pos) : pos;
      lastLineEmpty = pos >= max;

      oldTShift.push(state.tShift[nextLine]);
      state.tShift[nextLine] = pos - state.bMarks[nextLine];
      continue;
    }

    // Case 2: line is not inside the blockquote, and the last line was empty.
    if (lastLineEmpty) { break; }

    // Case 3: another tag found.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }

    oldBMarks.push(state.bMarks[nextLine]);
    oldTShift.push(state.tShift[nextLine]);

    // A negative number means that this is a paragraph continuation;
    //
    // Any negative number will do the job here, but it's better for it
    // to be large enough to make any bugs obvious.
    state.tShift[nextLine] = -1337;
  }

  oldParentType = state.parentType;
  state.parentType = 'blockquote';
  state.tokens.push({
    type: 'blockquote_open',
    lines: lines = [ startLine, 0 ],
    level: state.level++
  });
  state.parser.tokenize(state, startLine, nextLine);
  state.tokens.push({
    type: 'blockquote_close',
    level: --state.level
  });
  state.parentType = oldParentType;
  lines[1] = state.line;

  // Restore original tShift; this might not be necessary since the parser
  // has already been here, but just to make sure we can do that.
  for (i = 0; i < oldTShift.length; i++) {
    state.bMarks[i + startLine] = oldBMarks[i];
    state.tShift[i + startLine] = oldTShift[i];
  }
  state.blkIndent = oldIndent;

  return true;
}

// Horizontal rule

function hr(state, startLine, endLine, silent) {
  var marker, cnt, ch,
      pos = state.bMarks[startLine],
      max = state.eMarks[startLine];

  pos += state.tShift[startLine];

  if (pos > max) { return false; }

  marker = state.src.charCodeAt(pos++);

  // Check hr marker
  if (marker !== 0x2A/* * */ &&
      marker !== 0x2D/* - */ &&
      marker !== 0x5F/* _ */) {
    return false;
  }

  // markers can be mixed with spaces, but there should be at least 3 one

  cnt = 1;
  while (pos < max) {
    ch = state.src.charCodeAt(pos++);
    if (ch !== marker && ch !== 0x20/* space */) { return false; }
    if (ch === marker) { cnt++; }
  }

  if (cnt < 3) { return false; }

  if (silent) { return true; }

  state.line = startLine + 1;
  state.tokens.push({
    type: 'hr',
    lines: [ startLine, state.line ],
    level: state.level
  });

  return true;
}

// Lists

// Search `[-+*][\n ]`, returns next pos arter marker on success
// or -1 on fail.
function skipBulletListMarker(state, startLine) {
  var marker, pos, max;

  pos = state.bMarks[startLine] + state.tShift[startLine];
  max = state.eMarks[startLine];

  if (pos >= max) { return -1; }

  marker = state.src.charCodeAt(pos++);
  // Check bullet
  if (marker !== 0x2A/* * */ &&
      marker !== 0x2D/* - */ &&
      marker !== 0x2B/* + */) {
    return -1;
  }

  if (pos < max && state.src.charCodeAt(pos) !== 0x20) {
    // " 1.test " - is not a list item
    return -1;
  }

  return pos;
}

// Search `\d+[.)][\n ]`, returns next pos arter marker on success
// or -1 on fail.
function skipOrderedListMarker(state, startLine) {
  var ch,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  if (pos + 1 >= max) { return -1; }

  ch = state.src.charCodeAt(pos++);

  if (ch < 0x30/* 0 */ || ch > 0x39/* 9 */) { return -1; }

  for (;;) {
    // EOL -> fail
    if (pos >= max) { return -1; }

    ch = state.src.charCodeAt(pos++);

    if (ch >= 0x30/* 0 */ && ch <= 0x39/* 9 */) {
      continue;
    }

    // found valid marker
    if (ch === 0x29/* ) */ || ch === 0x2e/* . */) {
      break;
    }

    return -1;
  }


  if (pos < max && state.src.charCodeAt(pos) !== 0x20/* space */) {
    // " 1.test " - is not a list item
    return -1;
  }
  return pos;
}

function markTightParagraphs(state, idx) {
  var i, l,
      level = state.level + 2;

  for (i = idx + 2, l = state.tokens.length - 2; i < l; i++) {
    if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
      state.tokens[i + 2].tight = true;
      state.tokens[i].tight = true;
      i += 2;
    }
  }
}


function list(state, startLine, endLine, silent) {
  var nextLine,
      indent,
      oldTShift,
      oldIndent,
      oldTight,
      oldParentType,
      start,
      posAfterMarker,
      max,
      indentAfterMarker,
      markerValue,
      markerCharCode,
      isOrdered,
      contentStart,
      listTokIdx,
      prevEmptyEnd,
      listLines,
      itemLines,
      tight = true,
      terminatorRules,
      i, l, terminate;

  // Detect list type and position after marker
  if ((posAfterMarker = skipOrderedListMarker(state, startLine)) >= 0) {
    isOrdered = true;
  } else if ((posAfterMarker = skipBulletListMarker(state, startLine)) >= 0) {
    isOrdered = false;
  } else {
    return false;
  }

  if (state.level >= state.options.maxNesting) { return false; }

  // We should terminate list on style change. Remember first one to compare.
  markerCharCode = state.src.charCodeAt(posAfterMarker - 1);

  // For validation mode we can terminate immediately
  if (silent) { return true; }

  // Start list
  listTokIdx = state.tokens.length;

  if (isOrdered) {
    start = state.bMarks[startLine] + state.tShift[startLine];
    markerValue = Number(state.src.substr(start, posAfterMarker - start - 1));

    state.tokens.push({
      type: 'ordered_list_open',
      order: markerValue,
      lines: listLines = [ startLine, 0 ],
      level: state.level++
    });

  } else {
    state.tokens.push({
      type: 'bullet_list_open',
      lines: listLines = [ startLine, 0 ],
      level: state.level++
    });
  }

  //
  // Iterate list items
  //

  nextLine = startLine;
  prevEmptyEnd = false;
  terminatorRules = state.parser.ruler.getRules('list');

  while (nextLine < endLine) {
    contentStart = state.skipSpaces(posAfterMarker);
    max = state.eMarks[nextLine];

    if (contentStart >= max) {
      // trimming space in "-    \n  3" case, indent is 1 here
      indentAfterMarker = 1;
    } else {
      indentAfterMarker = contentStart - posAfterMarker;
    }

    // If we have more than 4 spaces, the indent is 1
    // (the rest is just indented code block)
    if (indentAfterMarker > 4) { indentAfterMarker = 1; }

    // If indent is less than 1, assume that it's one, example:
    //  "-\n  test"
    if (indentAfterMarker < 1) { indentAfterMarker = 1; }

    // "  -  test"
    //  ^^^^^ - calculating total length of this thing
    indent = (posAfterMarker - state.bMarks[nextLine]) + indentAfterMarker;

    // Run subparser & write tokens
    state.tokens.push({
      type: 'list_item_open',
      lines: itemLines = [ startLine, 0 ],
      level: state.level++
    });

    oldIndent = state.blkIndent;
    oldTight = state.tight;
    oldTShift = state.tShift[startLine];
    oldParentType = state.parentType;
    state.tShift[startLine] = contentStart - state.bMarks[startLine];
    state.blkIndent = indent;
    state.tight = true;
    state.parentType = 'list';

    state.parser.tokenize(state, startLine, endLine, true);

    // If any of list item is tight, mark list as tight
    if (!state.tight || prevEmptyEnd) {
      tight = false;
    }
    // Item become loose if finish with empty line,
    // but we should filter last element, because it means list finish
    prevEmptyEnd = (state.line - startLine) > 1 && state.isEmpty(state.line - 1);

    state.blkIndent = oldIndent;
    state.tShift[startLine] = oldTShift;
    state.tight = oldTight;
    state.parentType = oldParentType;

    state.tokens.push({
      type: 'list_item_close',
      level: --state.level
    });

    nextLine = startLine = state.line;
    itemLines[1] = nextLine;
    contentStart = state.bMarks[startLine];

    if (nextLine >= endLine) { break; }

    if (state.isEmpty(nextLine)) {
      break;
    }

    //
    // Try to check if list is terminated or continued.
    //
    if (state.tShift[nextLine] < state.blkIndent) { break; }

    // fail if terminating block found
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }

    // fail if list has another type
    if (isOrdered) {
      posAfterMarker = skipOrderedListMarker(state, nextLine);
      if (posAfterMarker < 0) { break; }
    } else {
      posAfterMarker = skipBulletListMarker(state, nextLine);
      if (posAfterMarker < 0) { break; }
    }

    if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) { break; }
  }

  // Finilize list
  state.tokens.push({
    type: isOrdered ? 'ordered_list_close' : 'bullet_list_close',
    level: --state.level
  });
  listLines[1] = nextLine;

  state.line = nextLine;

  // mark paragraphs tight if needed
  if (tight) {
    markTightParagraphs(state, listTokIdx);
  }

  return true;
}

// Process footnote reference list

function footnote(state, startLine, endLine, silent) {
  var oldBMark, oldTShift, oldParentType, pos, label,
      start = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // line should be at least 5 chars - "[^x]:"
  if (start + 4 > max) { return false; }

  if (state.src.charCodeAt(start) !== 0x5B/* [ */) { return false; }
  if (state.src.charCodeAt(start + 1) !== 0x5E/* ^ */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  for (pos = start + 2; pos < max; pos++) {
    if (state.src.charCodeAt(pos) === 0x20) { return false; }
    if (state.src.charCodeAt(pos) === 0x5D /* ] */) {
      break;
    }
  }

  if (pos === start + 2) { return false; } // no empty footnote labels
  if (pos + 1 >= max || state.src.charCodeAt(++pos) !== 0x3A /* : */) { return false; }
  if (silent) { return true; }
  pos++;

  if (!state.env.footnotes) { state.env.footnotes = {}; }
  if (!state.env.footnotes.refs) { state.env.footnotes.refs = {}; }
  label = state.src.slice(start + 2, pos - 2);
  state.env.footnotes.refs[':' + label] = -1;

  state.tokens.push({
    type: 'footnote_reference_open',
    label: label,
    level: state.level++
  });

  oldBMark = state.bMarks[startLine];
  oldTShift = state.tShift[startLine];
  oldParentType = state.parentType;
  state.tShift[startLine] = state.skipSpaces(pos) - pos;
  state.bMarks[startLine] = pos;
  state.blkIndent += 4;
  state.parentType = 'footnote';

  if (state.tShift[startLine] < state.blkIndent) {
    state.tShift[startLine] += state.blkIndent;
    state.bMarks[startLine] -= state.blkIndent;
  }

  state.parser.tokenize(state, startLine, endLine, true);

  state.parentType = oldParentType;
  state.blkIndent -= 4;
  state.tShift[startLine] = oldTShift;
  state.bMarks[startLine] = oldBMark;

  state.tokens.push({
    type: 'footnote_reference_close',
    level: --state.level
  });

  return true;
}

// heading (#, ##, ...)

function heading(state, startLine, endLine, silent) {
  var ch, level, tmp,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  if (pos >= max) { return false; }

  ch  = state.src.charCodeAt(pos);

  if (ch !== 0x23/* # */ || pos >= max) { return false; }

  // count heading level
  level = 1;
  ch = state.src.charCodeAt(++pos);
  while (ch === 0x23/* # */ && pos < max && level <= 6) {
    level++;
    ch = state.src.charCodeAt(++pos);
  }

  if (level > 6 || (pos < max && ch !== 0x20/* space */)) { return false; }

  if (silent) { return true; }

  // Let's cut tails like '    ###  ' from the end of string

  max = state.skipCharsBack(max, 0x20, pos); // space
  tmp = state.skipCharsBack(max, 0x23, pos); // #
  if (tmp > pos && state.src.charCodeAt(tmp - 1) === 0x20/* space */) {
    max = tmp;
  }

  state.line = startLine + 1;

  state.tokens.push({ type: 'heading_open',
    hLevel: level,
    lines: [ startLine, state.line ],
    level: state.level
  });

  // only if header is not empty
  if (pos < max) {
    state.tokens.push({
      type: 'inline',
      content: state.src.slice(pos, max).trim(),
      level: state.level + 1,
      lines: [ startLine, state.line ],
      children: []
    });
  }
  state.tokens.push({ type: 'heading_close', hLevel: level, level: state.level });

  return true;
}

// lheading (---, ===)

function lheading(state, startLine, endLine/*, silent*/) {
  var marker, pos, max,
      next = startLine + 1;

  if (next >= endLine) { return false; }
  if (state.tShift[next] < state.blkIndent) { return false; }

  // Scan next line

  if (state.tShift[next] - state.blkIndent > 3) { return false; }

  pos = state.bMarks[next] + state.tShift[next];
  max = state.eMarks[next];

  if (pos >= max) { return false; }

  marker = state.src.charCodeAt(pos);

  if (marker !== 0x2D/* - */ && marker !== 0x3D/* = */) { return false; }

  pos = state.skipChars(pos, marker);

  pos = state.skipSpaces(pos);

  if (pos < max) { return false; }

  pos = state.bMarks[startLine] + state.tShift[startLine];

  state.line = next + 1;
  state.tokens.push({
    type: 'heading_open',
    hLevel: marker === 0x3D/* = */ ? 1 : 2,
    lines: [ startLine, state.line ],
    level: state.level
  });
  state.tokens.push({
    type: 'inline',
    content: state.src.slice(pos, state.eMarks[startLine]).trim(),
    level: state.level + 1,
    lines: [ startLine, state.line - 1 ],
    children: []
  });
  state.tokens.push({
    type: 'heading_close',
    hLevel: marker === 0x3D/* = */ ? 1 : 2,
    level: state.level
  });

  return true;
}

// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks

var html_blocks = {};

[
  'article',
  'aside',
  'button',
  'blockquote',
  'body',
  'canvas',
  'caption',
  'col',
  'colgroup',
  'dd',
  'div',
  'dl',
  'dt',
  'embed',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'header',
  'hgroup',
  'hr',
  'iframe',
  'li',
  'map',
  'object',
  'ol',
  'output',
  'p',
  'pre',
  'progress',
  'script',
  'section',
  'style',
  'table',
  'tbody',
  'td',
  'textarea',
  'tfoot',
  'th',
  'tr',
  'thead',
  'ul',
  'video'
].forEach(function (name) { html_blocks[name] = true; });

// HTML block


var HTML_TAG_OPEN_RE = /^<([a-zA-Z]{1,15})[\s\/>]/;
var HTML_TAG_CLOSE_RE = /^<\/([a-zA-Z]{1,15})[\s>]/;

function isLetter$1(ch) {
  /*eslint no-bitwise:0*/
  var lc = ch | 0x20; // to lower case
  return (lc >= 0x61/* a */) && (lc <= 0x7a/* z */);
}

function htmlblock(state, startLine, endLine, silent) {
  var ch, match, nextLine,
      pos = state.bMarks[startLine],
      max = state.eMarks[startLine],
      shift = state.tShift[startLine];

  pos += shift;

  if (!state.options.html) { return false; }

  if (shift > 3 || pos + 2 >= max) { return false; }

  if (state.src.charCodeAt(pos) !== 0x3C/* < */) { return false; }

  ch = state.src.charCodeAt(pos + 1);

  if (ch === 0x21/* ! */ || ch === 0x3F/* ? */) {
    // Directive start / comment start / processing instruction start
    if (silent) { return true; }

  } else if (ch === 0x2F/* / */ || isLetter$1(ch)) {

    // Probably start or end of tag
    if (ch === 0x2F/* \ */) {
      // closing tag
      match = state.src.slice(pos, max).match(HTML_TAG_CLOSE_RE);
      if (!match) { return false; }
    } else {
      // opening tag
      match = state.src.slice(pos, max).match(HTML_TAG_OPEN_RE);
      if (!match) { return false; }
    }
    // Make sure tag name is valid
    if (html_blocks[match[1].toLowerCase()] !== true) { return false; }
    if (silent) { return true; }

  } else {
    return false;
  }

  // If we are here - we detected HTML block.
  // Let's roll down till empty line (block end).
  nextLine = startLine + 1;
  while (nextLine < state.lineMax && !state.isEmpty(nextLine)) {
    nextLine++;
  }

  state.line = nextLine;
  state.tokens.push({
    type: 'htmlblock',
    level: state.level,
    lines: [ startLine, state.line ],
    content: state.getLines(startLine, nextLine, 0, true)
  });

  return true;
}

// GFM table, non-standard

function getLine(state, line) {
  var pos = state.bMarks[line] + state.blkIndent,
      max = state.eMarks[line];

  return state.src.substr(pos, max - pos);
}

function table(state, startLine, endLine, silent) {
  var ch, lineText, pos, i, nextLine, rows, cell,
      aligns, t, tableLines, tbodyLines;

  // should have at least three lines
  if (startLine + 2 > endLine) { return false; }

  nextLine = startLine + 1;

  if (state.tShift[nextLine] < state.blkIndent) { return false; }

  // first character of the second line should be '|' or '-'

  pos = state.bMarks[nextLine] + state.tShift[nextLine];
  if (pos >= state.eMarks[nextLine]) { return false; }

  ch = state.src.charCodeAt(pos);
  if (ch !== 0x7C/* | */ && ch !== 0x2D/* - */ && ch !== 0x3A/* : */) { return false; }

  lineText = getLine(state, startLine + 1);
  if (!/^[-:| ]+$/.test(lineText)) { return false; }

  rows = lineText.split('|');
  if (rows <= 2) { return false; }
  aligns = [];
  for (i = 0; i < rows.length; i++) {
    t = rows[i].trim();
    if (!t) {
      // allow empty columns before and after table, but not in between columns;
      // e.g. allow ` |---| `, disallow ` ---||--- `
      if (i === 0 || i === rows.length - 1) {
        continue;
      } else {
        return false;
      }
    }

    if (!/^:?-+:?$/.test(t)) { return false; }
    if (t.charCodeAt(t.length - 1) === 0x3A/* : */) {
      aligns.push(t.charCodeAt(0) === 0x3A/* : */ ? 'center' : 'right');
    } else if (t.charCodeAt(0) === 0x3A/* : */) {
      aligns.push('left');
    } else {
      aligns.push('');
    }
  }

  lineText = getLine(state, startLine).trim();
  if (lineText.indexOf('|') === -1) { return false; }
  rows = lineText.replace(/^\||\|$/g, '').split('|');
  if (aligns.length !== rows.length) { return false; }
  if (silent) { return true; }

  state.tokens.push({
    type: 'table_open',
    lines: tableLines = [ startLine, 0 ],
    level: state.level++
  });
  state.tokens.push({
    type: 'thead_open',
    lines: [ startLine, startLine + 1 ],
    level: state.level++
  });

  state.tokens.push({
    type: 'tr_open',
    lines: [ startLine, startLine + 1 ],
    level: state.level++
  });
  for (i = 0; i < rows.length; i++) {
    state.tokens.push({
      type: 'th_open',
      align: aligns[i],
      lines: [ startLine, startLine + 1 ],
      level: state.level++
    });
    state.tokens.push({
      type: 'inline',
      content: rows[i].trim(),
      lines: [ startLine, startLine + 1 ],
      level: state.level,
      children: []
    });
    state.tokens.push({ type: 'th_close', level: --state.level });
  }
  state.tokens.push({ type: 'tr_close', level: --state.level });
  state.tokens.push({ type: 'thead_close', level: --state.level });

  state.tokens.push({
    type: 'tbody_open',
    lines: tbodyLines = [ startLine + 2, 0 ],
    level: state.level++
  });

  for (nextLine = startLine + 2; nextLine < endLine; nextLine++) {
    if (state.tShift[nextLine] < state.blkIndent) { break; }

    lineText = getLine(state, nextLine).trim();
    if (lineText.indexOf('|') === -1) { break; }
    rows = lineText.replace(/^\||\|$/g, '').split('|');

    state.tokens.push({ type: 'tr_open', level: state.level++ });
    for (i = 0; i < rows.length; i++) {
      state.tokens.push({ type: 'td_open', align: aligns[i], level: state.level++ });
      // 0x7c === '|'
      cell = rows[i].substring(
          rows[i].charCodeAt(0) === 0x7c ? 1 : 0,
          rows[i].charCodeAt(rows[i].length - 1) === 0x7c ? rows[i].length - 1 : rows[i].length
      ).trim();
      state.tokens.push({
        type: 'inline',
        content: cell,
        level: state.level,
        children: []
      });
      state.tokens.push({ type: 'td_close', level: --state.level });
    }
    state.tokens.push({ type: 'tr_close', level: --state.level });
  }
  state.tokens.push({ type: 'tbody_close', level: --state.level });
  state.tokens.push({ type: 'table_close', level: --state.level });

  tableLines[1] = tbodyLines[1] = nextLine;
  state.line = nextLine;
  return true;
}

// Definition lists

// Search `[:~][\n ]`, returns next pos after marker on success
// or -1 on fail.
function skipMarker(state, line) {
  var pos, marker,
      start = state.bMarks[line] + state.tShift[line],
      max = state.eMarks[line];

  if (start >= max) { return -1; }

  // Check bullet
  marker = state.src.charCodeAt(start++);
  if (marker !== 0x7E/* ~ */ && marker !== 0x3A/* : */) { return -1; }

  pos = state.skipSpaces(start);

  // require space after ":"
  if (start === pos) { return -1; }

  // no empty definitions, e.g. "  : "
  if (pos >= max) { return -1; }

  return pos;
}

function markTightParagraphs$1(state, idx) {
  var i, l,
      level = state.level + 2;

  for (i = idx + 2, l = state.tokens.length - 2; i < l; i++) {
    if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
      state.tokens[i + 2].tight = true;
      state.tokens[i].tight = true;
      i += 2;
    }
  }
}

function deflist(state, startLine, endLine, silent) {
  var contentStart,
      ddLine,
      dtLine,
      itemLines,
      listLines,
      listTokIdx,
      nextLine,
      oldIndent,
      oldDDIndent,
      oldParentType,
      oldTShift,
      oldTight,
      prevEmptyEnd,
      tight;

  if (silent) {
    // quirk: validation mode validates a dd block only, not a whole deflist
    if (state.ddIndent < 0) { return false; }
    return skipMarker(state, startLine) >= 0;
  }

  nextLine = startLine + 1;
  if (state.isEmpty(nextLine)) {
    if (++nextLine > endLine) { return false; }
  }

  if (state.tShift[nextLine] < state.blkIndent) { return false; }
  contentStart = skipMarker(state, nextLine);
  if (contentStart < 0) { return false; }

  if (state.level >= state.options.maxNesting) { return false; }

  // Start list
  listTokIdx = state.tokens.length;

  state.tokens.push({
    type: 'dl_open',
    lines: listLines = [ startLine, 0 ],
    level: state.level++
  });

  //
  // Iterate list items
  //

  dtLine = startLine;
  ddLine = nextLine;

  // One definition list can contain multiple DTs,
  // and one DT can be followed by multiple DDs.
  //
  // Thus, there is two loops here, and label is
  // needed to break out of the second one
  //
  /*eslint no-labels:0,block-scoped-var:0*/
  OUTER:
  for (;;) {
    tight = true;
    prevEmptyEnd = false;

    state.tokens.push({
      type: 'dt_open',
      lines: [ dtLine, dtLine ],
      level: state.level++
    });
    state.tokens.push({
      type: 'inline',
      content: state.getLines(dtLine, dtLine + 1, state.blkIndent, false).trim(),
      level: state.level + 1,
      lines: [ dtLine, dtLine ],
      children: []
    });
    state.tokens.push({
      type: 'dt_close',
      level: --state.level
    });

    for (;;) {
      state.tokens.push({
        type: 'dd_open',
        lines: itemLines = [ nextLine, 0 ],
        level: state.level++
      });

      oldTight = state.tight;
      oldDDIndent = state.ddIndent;
      oldIndent = state.blkIndent;
      oldTShift = state.tShift[ddLine];
      oldParentType = state.parentType;
      state.blkIndent = state.ddIndent = state.tShift[ddLine] + 2;
      state.tShift[ddLine] = contentStart - state.bMarks[ddLine];
      state.tight = true;
      state.parentType = 'deflist';

      state.parser.tokenize(state, ddLine, endLine, true);

      // If any of list item is tight, mark list as tight
      if (!state.tight || prevEmptyEnd) {
        tight = false;
      }
      // Item become loose if finish with empty line,
      // but we should filter last element, because it means list finish
      prevEmptyEnd = (state.line - ddLine) > 1 && state.isEmpty(state.line - 1);

      state.tShift[ddLine] = oldTShift;
      state.tight = oldTight;
      state.parentType = oldParentType;
      state.blkIndent = oldIndent;
      state.ddIndent = oldDDIndent;

      state.tokens.push({
        type: 'dd_close',
        level: --state.level
      });

      itemLines[1] = nextLine = state.line;

      if (nextLine >= endLine) { break OUTER; }

      if (state.tShift[nextLine] < state.blkIndent) { break OUTER; }
      contentStart = skipMarker(state, nextLine);
      if (contentStart < 0) { break; }

      ddLine = nextLine;

      // go to the next loop iteration:
      // insert DD tag and repeat checking
    }

    if (nextLine >= endLine) { break; }
    dtLine = nextLine;

    if (state.isEmpty(dtLine)) { break; }
    if (state.tShift[dtLine] < state.blkIndent) { break; }

    ddLine = dtLine + 1;
    if (ddLine >= endLine) { break; }
    if (state.isEmpty(ddLine)) { ddLine++; }
    if (ddLine >= endLine) { break; }

    if (state.tShift[ddLine] < state.blkIndent) { break; }
    contentStart = skipMarker(state, ddLine);
    if (contentStart < 0) { break; }

    // go to the next loop iteration:
    // insert DT and DD tags and repeat checking
  }

  // Finilize list
  state.tokens.push({
    type: 'dl_close',
    level: --state.level
  });
  listLines[1] = nextLine;

  state.line = nextLine;

  // mark paragraphs tight if needed
  if (tight) {
    markTightParagraphs$1(state, listTokIdx);
  }

  return true;
}

// Paragraph

function paragraph(state, startLine/*, endLine*/) {
  var endLine, content, terminate, i, l,
      nextLine = startLine + 1,
      terminatorRules;

  endLine = state.lineMax;

  // jump line-by-line until empty one or EOF
  if (nextLine < endLine && !state.isEmpty(nextLine)) {
    terminatorRules = state.parser.ruler.getRules('paragraph');

    for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
      // this would be a code block normally, but after paragraph
      // it's considered a lazy continuation regardless of what's there
      if (state.tShift[nextLine] - state.blkIndent > 3) { continue; }

      // Some tags can terminate paragraph without empty line.
      terminate = false;
      for (i = 0, l = terminatorRules.length; i < l; i++) {
        if (terminatorRules[i](state, nextLine, endLine, true)) {
          terminate = true;
          break;
        }
      }
      if (terminate) { break; }
    }
  }

  content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();

  state.line = nextLine;
  if (content.length) {
    state.tokens.push({
      type: 'paragraph_open',
      tight: false,
      lines: [ startLine, state.line ],
      level: state.level
    });
    state.tokens.push({
      type: 'inline',
      content: content,
      level: state.level + 1,
      lines: [ startLine, state.line ],
      children: []
    });
    state.tokens.push({
      type: 'paragraph_close',
      tight: false,
      level: state.level
    });
  }

  return true;
}

/**
 * Parser rules
 */

var _rules$1 = [
  [ 'code',       code ],
  [ 'fences',     fences,     [ 'paragraph', 'blockquote', 'list' ] ],
  [ 'blockquote', blockquote, [ 'paragraph', 'blockquote', 'list' ] ],
  [ 'hr',         hr,         [ 'paragraph', 'blockquote', 'list' ] ],
  [ 'list',       list,       [ 'paragraph', 'blockquote' ] ],
  [ 'footnote',   footnote,   [ 'paragraph' ] ],
  [ 'heading',    heading,    [ 'paragraph', 'blockquote' ] ],
  [ 'lheading',   lheading ],
  [ 'htmlblock',  htmlblock,  [ 'paragraph', 'blockquote' ] ],
  [ 'table',      table,      [ 'paragraph' ] ],
  [ 'deflist',    deflist,    [ 'paragraph' ] ],
  [ 'paragraph',  paragraph ]
];

/**
 * Block Parser class
 *
 * @api private
 */

function ParserBlock() {
  this.ruler = new Ruler();
  for (var i = 0; i < _rules$1.length; i++) {
    this.ruler.push(_rules$1[i][0], _rules$1[i][1], {
      alt: (_rules$1[i][2] || []).slice()
    });
  }
}

/**
 * Generate tokens for the given input range.
 *
 * @param  {Object} `state` Has properties like `src`, `parser`, `options` etc
 * @param  {Number} `startLine`
 * @param  {Number} `endLine`
 * @api private
 */

ParserBlock.prototype.tokenize = function (state, startLine, endLine) {
  var rules = this.ruler.getRules('');
  var len = rules.length;
  var line = startLine;
  var hasEmptyLines = false;
  var ok, i;

  while (line < endLine) {
    state.line = line = state.skipEmptyLines(line);
    if (line >= endLine) {
      break;
    }

    // Termination condition for nested calls.
    // Nested calls currently used for blockquotes & lists
    if (state.tShift[line] < state.blkIndent) {
      break;
    }

    // Try all possible rules.
    // On success, rule should:
    //
    // - update `state.line`
    // - update `state.tokens`
    // - return true

    for (i = 0; i < len; i++) {
      ok = rules[i](state, line, endLine, false);
      if (ok) {
        break;
      }
    }

    // set state.tight iff we had an empty line before current tag
    // i.e. latest empty line should not count
    state.tight = !hasEmptyLines;

    // paragraph might "eat" one newline after it in nested lists
    if (state.isEmpty(state.line - 1)) {
      hasEmptyLines = true;
    }

    line = state.line;

    if (line < endLine && state.isEmpty(line)) {
      hasEmptyLines = true;
      line++;

      // two empty lines should stop the parser in list mode
      if (line < endLine && state.parentType === 'list' && state.isEmpty(line)) { break; }
      state.line = line;
    }
  }
};

var TABS_SCAN_RE = /[\n\t]/g;
var NEWLINES_RE  = /\r[\n\u0085]|[\u2424\u2028\u0085]/g;
var SPACES_RE    = /\u00a0/g;

/**
 * Tokenize the given `str`.
 *
 * @param  {String} `str` Source string
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @param  {Array} `outTokens`
 * @api private
 */

ParserBlock.prototype.parse = function (str, options, env, outTokens) {
  var state, lineStart = 0, lastTabPos = 0;
  if (!str) { return []; }

  // Normalize spaces
  str = str.replace(SPACES_RE, ' ');

  // Normalize newlines
  str = str.replace(NEWLINES_RE, '\n');

  // Replace tabs with proper number of spaces (1..4)
  if (str.indexOf('\t') >= 0) {
    str = str.replace(TABS_SCAN_RE, function (match, offset) {
      var result;
      if (str.charCodeAt(offset) === 0x0A) {
        lineStart = offset + 1;
        lastTabPos = 0;
        return match;
      }
      result = '    '.slice((offset - lineStart - lastTabPos) % 4);
      lastTabPos = offset - lineStart + 1;
      return result;
    });
  }

  state = new StateBlock(str, this, options, env, outTokens);
  this.tokenize(state, state.line, state.lineMax);
};

// Skip text characters for text token, place those to pending buffer
// and increment current pos

// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions

function isTerminatorChar(ch) {
  switch (ch) {
    case 0x0A/* \n */:
    case 0x5C/* \ */:
    case 0x60/* ` */:
    case 0x2A/* * */:
    case 0x5F/* _ */:
    case 0x5E/* ^ */:
    case 0x5B/* [ */:
    case 0x5D/* ] */:
    case 0x21/* ! */:
    case 0x26/* & */:
    case 0x3C/* < */:
    case 0x3E/* > */:
    case 0x7B/* { */:
    case 0x7D/* } */:
    case 0x24/* $ */:
    case 0x25/* % */:
    case 0x40/* @ */:
    case 0x7E/* ~ */:
    case 0x2B/* + */:
    case 0x3D/* = */:
    case 0x3A/* : */:
      return true;
    default:
      return false;
  }
}

function index_browser_text(state, silent) {
  var pos = state.pos;

  while (pos < state.posMax && !isTerminatorChar(state.src.charCodeAt(pos))) {
    pos++;
  }

  if (pos === state.pos) { return false; }

  if (!silent) { state.pending += state.src.slice(state.pos, pos); }

  state.pos = pos;

  return true;
}

// Proceess '\n'

function newline(state, silent) {
  var pmax, max, pos = state.pos;

  if (state.src.charCodeAt(pos) !== 0x0A/* \n */) { return false; }

  pmax = state.pending.length - 1;
  max = state.posMax;

  // '  \n' -> hardbreak
  // Lookup in pending chars is bad practice! Don't copy to other rules!
  // Pending string is stored in concat mode, indexed lookups will cause
  // convertion to flat mode.
  if (!silent) {
    if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
      if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
        // Strip out all trailing spaces on this line.
        for (var i = pmax - 2; i >= 0; i--) {
          if (state.pending.charCodeAt(i) !== 0x20) {
            state.pending = state.pending.substring(0, i + 1);
            break;
          }
        }
        state.push({
          type: 'hardbreak',
          level: state.level
        });
      } else {
        state.pending = state.pending.slice(0, -1);
        state.push({
          type: 'softbreak',
          level: state.level
        });
      }

    } else {
      state.push({
        type: 'softbreak',
        level: state.level
      });
    }
  }

  pos++;

  // skip heading spaces for next line
  while (pos < max && state.src.charCodeAt(pos) === 0x20) { pos++; }

  state.pos = pos;
  return true;
}

// Proceess escaped chars and hardbreaks

var ESCAPED = [];

for (var index_browser_i = 0; index_browser_i < 256; index_browser_i++) { ESCAPED.push(0); }

'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'
  .split('').forEach(function(ch) { ESCAPED[ch.charCodeAt(0)] = 1; });


function index_browser_escape(state, silent) {
  var ch, pos = state.pos, max = state.posMax;

  if (state.src.charCodeAt(pos) !== 0x5C/* \ */) { return false; }

  pos++;

  if (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (ch < 256 && ESCAPED[ch] !== 0) {
      if (!silent) { state.pending += state.src[pos]; }
      state.pos += 2;
      return true;
    }

    if (ch === 0x0A) {
      if (!silent) {
        state.push({
          type: 'hardbreak',
          level: state.level
        });
      }

      pos++;
      // skip leading whitespaces from next line
      while (pos < max && state.src.charCodeAt(pos) === 0x20) { pos++; }

      state.pos = pos;
      return true;
    }
  }

  if (!silent) { state.pending += '\\'; }
  state.pos++;
  return true;
}

// Parse backticks

function backticks(state, silent) {
  var start, max, marker, matchStart, matchEnd,
      pos = state.pos,
      ch = state.src.charCodeAt(pos);

  if (ch !== 0x60/* ` */) { return false; }

  start = pos;
  pos++;
  max = state.posMax;

  while (pos < max && state.src.charCodeAt(pos) === 0x60/* ` */) { pos++; }

  marker = state.src.slice(start, pos);

  matchStart = matchEnd = pos;

  while ((matchStart = state.src.indexOf('`', matchEnd)) !== -1) {
    matchEnd = matchStart + 1;

    while (matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60/* ` */) { matchEnd++; }

    if (matchEnd - matchStart === marker.length) {
      if (!silent) {
        state.push({
          type: 'code',
          content: state.src.slice(pos, matchStart)
                              .replace(/[ \n]+/g, ' ')
                              .trim(),
          block: false,
          level: state.level
        });
      }
      state.pos = matchEnd;
      return true;
    }
  }

  if (!silent) { state.pending += marker; }
  state.pos += marker.length;
  return true;
}

// Process ~~deleted text~~

function del(state, silent) {
  var found,
      pos,
      stack,
      max = state.posMax,
      start = state.pos,
      lastChar,
      nextChar;

  if (state.src.charCodeAt(start) !== 0x7E/* ~ */) { return false; }
  if (silent) { return false; } // don't run any pairs in validation mode
  if (start + 4 >= max) { return false; }
  if (state.src.charCodeAt(start + 1) !== 0x7E/* ~ */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
  nextChar = state.src.charCodeAt(start + 2);

  if (lastChar === 0x7E/* ~ */) { return false; }
  if (nextChar === 0x7E/* ~ */) { return false; }
  if (nextChar === 0x20 || nextChar === 0x0A) { return false; }

  pos = start + 2;
  while (pos < max && state.src.charCodeAt(pos) === 0x7E/* ~ */) { pos++; }
  if (pos > start + 3) {
    // sequence of 4+ markers taking as literal, same as in a emphasis
    state.pos += pos - start;
    if (!silent) { state.pending += state.src.slice(start, pos); }
    return true;
  }

  state.pos = start + 2;
  stack = 1;

  while (state.pos + 1 < max) {
    if (state.src.charCodeAt(state.pos) === 0x7E/* ~ */) {
      if (state.src.charCodeAt(state.pos + 1) === 0x7E/* ~ */) {
        lastChar = state.src.charCodeAt(state.pos - 1);
        nextChar = state.pos + 2 < max ? state.src.charCodeAt(state.pos + 2) : -1;
        if (nextChar !== 0x7E/* ~ */ && lastChar !== 0x7E/* ~ */) {
          if (lastChar !== 0x20 && lastChar !== 0x0A) {
            // closing '~~'
            stack--;
          } else if (nextChar !== 0x20 && nextChar !== 0x0A) {
            // opening '~~'
            stack++;
          } // else {
            //  // standalone ' ~~ ' indented with spaces
            // }
          if (stack <= 0) {
            found = true;
            break;
          }
        }
      }
    }

    state.parser.skipToken(state);
  }

  if (!found) {
    // parser failed to find ending tag, so it's not valid emphasis
    state.pos = start;
    return false;
  }

  // found!
  state.posMax = state.pos;
  state.pos = start + 2;

  if (!silent) {
    state.push({ type: 'del_open', level: state.level++ });
    state.parser.tokenize(state);
    state.push({ type: 'del_close', level: --state.level });
  }

  state.pos = state.posMax + 2;
  state.posMax = max;
  return true;
}

// Process ++inserted text++

function ins(state, silent) {
  var found,
      pos,
      stack,
      max = state.posMax,
      start = state.pos,
      lastChar,
      nextChar;

  if (state.src.charCodeAt(start) !== 0x2B/* + */) { return false; }
  if (silent) { return false; } // don't run any pairs in validation mode
  if (start + 4 >= max) { return false; }
  if (state.src.charCodeAt(start + 1) !== 0x2B/* + */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
  nextChar = state.src.charCodeAt(start + 2);

  if (lastChar === 0x2B/* + */) { return false; }
  if (nextChar === 0x2B/* + */) { return false; }
  if (nextChar === 0x20 || nextChar === 0x0A) { return false; }

  pos = start + 2;
  while (pos < max && state.src.charCodeAt(pos) === 0x2B/* + */) { pos++; }
  if (pos !== start + 2) {
    // sequence of 3+ markers taking as literal, same as in a emphasis
    state.pos += pos - start;
    if (!silent) { state.pending += state.src.slice(start, pos); }
    return true;
  }

  state.pos = start + 2;
  stack = 1;

  while (state.pos + 1 < max) {
    if (state.src.charCodeAt(state.pos) === 0x2B/* + */) {
      if (state.src.charCodeAt(state.pos + 1) === 0x2B/* + */) {
        lastChar = state.src.charCodeAt(state.pos - 1);
        nextChar = state.pos + 2 < max ? state.src.charCodeAt(state.pos + 2) : -1;
        if (nextChar !== 0x2B/* + */ && lastChar !== 0x2B/* + */) {
          if (lastChar !== 0x20 && lastChar !== 0x0A) {
            // closing '++'
            stack--;
          } else if (nextChar !== 0x20 && nextChar !== 0x0A) {
            // opening '++'
            stack++;
          } // else {
            //  // standalone ' ++ ' indented with spaces
            // }
          if (stack <= 0) {
            found = true;
            break;
          }
        }
      }
    }

    state.parser.skipToken(state);
  }

  if (!found) {
    // parser failed to find ending tag, so it's not valid emphasis
    state.pos = start;
    return false;
  }

  // found!
  state.posMax = state.pos;
  state.pos = start + 2;

  if (!silent) {
    state.push({ type: 'ins_open', level: state.level++ });
    state.parser.tokenize(state);
    state.push({ type: 'ins_close', level: --state.level });
  }

  state.pos = state.posMax + 2;
  state.posMax = max;
  return true;
}

// Process ==highlighted text==

function mark(state, silent) {
  var found,
      pos,
      stack,
      max = state.posMax,
      start = state.pos,
      lastChar,
      nextChar;

  if (state.src.charCodeAt(start) !== 0x3D/* = */) { return false; }
  if (silent) { return false; } // don't run any pairs in validation mode
  if (start + 4 >= max) { return false; }
  if (state.src.charCodeAt(start + 1) !== 0x3D/* = */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
  nextChar = state.src.charCodeAt(start + 2);

  if (lastChar === 0x3D/* = */) { return false; }
  if (nextChar === 0x3D/* = */) { return false; }
  if (nextChar === 0x20 || nextChar === 0x0A) { return false; }

  pos = start + 2;
  while (pos < max && state.src.charCodeAt(pos) === 0x3D/* = */) { pos++; }
  if (pos !== start + 2) {
    // sequence of 3+ markers taking as literal, same as in a emphasis
    state.pos += pos - start;
    if (!silent) { state.pending += state.src.slice(start, pos); }
    return true;
  }

  state.pos = start + 2;
  stack = 1;

  while (state.pos + 1 < max) {
    if (state.src.charCodeAt(state.pos) === 0x3D/* = */) {
      if (state.src.charCodeAt(state.pos + 1) === 0x3D/* = */) {
        lastChar = state.src.charCodeAt(state.pos - 1);
        nextChar = state.pos + 2 < max ? state.src.charCodeAt(state.pos + 2) : -1;
        if (nextChar !== 0x3D/* = */ && lastChar !== 0x3D/* = */) {
          if (lastChar !== 0x20 && lastChar !== 0x0A) {
            // closing '=='
            stack--;
          } else if (nextChar !== 0x20 && nextChar !== 0x0A) {
            // opening '=='
            stack++;
          } // else {
            //  // standalone ' == ' indented with spaces
            // }
          if (stack <= 0) {
            found = true;
            break;
          }
        }
      }
    }

    state.parser.skipToken(state);
  }

  if (!found) {
    // parser failed to find ending tag, so it's not valid emphasis
    state.pos = start;
    return false;
  }

  // found!
  state.posMax = state.pos;
  state.pos = start + 2;

  if (!silent) {
    state.push({ type: 'mark_open', level: state.level++ });
    state.parser.tokenize(state);
    state.push({ type: 'mark_close', level: --state.level });
  }

  state.pos = state.posMax + 2;
  state.posMax = max;
  return true;
}

// Process *this* and _that_

function isAlphaNum(code) {
  return (code >= 0x30 /* 0 */ && code <= 0x39 /* 9 */) ||
         (code >= 0x41 /* A */ && code <= 0x5A /* Z */) ||
         (code >= 0x61 /* a */ && code <= 0x7A /* z */);
}

// parse sequence of emphasis markers,
// "start" should point at a valid marker
function scanDelims(state, start) {
  var pos = start, lastChar, nextChar, count,
      can_open = true,
      can_close = true,
      max = state.posMax,
      marker = state.src.charCodeAt(start);

  lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;

  while (pos < max && state.src.charCodeAt(pos) === marker) { pos++; }
  if (pos >= max) { can_open = false; }
  count = pos - start;

  if (count >= 4) {
    // sequence of four or more unescaped markers can't start/end an emphasis
    can_open = can_close = false;
  } else {
    nextChar = pos < max ? state.src.charCodeAt(pos) : -1;

    // check whitespace conditions
    if (nextChar === 0x20 || nextChar === 0x0A) { can_open = false; }
    if (lastChar === 0x20 || lastChar === 0x0A) { can_close = false; }

    if (marker === 0x5F /* _ */) {
      // check if we aren't inside the word
      if (isAlphaNum(lastChar)) { can_open = false; }
      if (isAlphaNum(nextChar)) { can_close = false; }
    }
  }

  return {
    can_open: can_open,
    can_close: can_close,
    delims: count
  };
}

function emphasis(state, silent) {
  var startCount,
      count,
      found,
      oldCount,
      newCount,
      stack,
      res,
      max = state.posMax,
      start = state.pos,
      marker = state.src.charCodeAt(start);

  if (marker !== 0x5F/* _ */ && marker !== 0x2A /* * */) { return false; }
  if (silent) { return false; } // don't run any pairs in validation mode

  res = scanDelims(state, start);
  startCount = res.delims;
  if (!res.can_open) {
    state.pos += startCount;
    if (!silent) { state.pending += state.src.slice(start, state.pos); }
    return true;
  }

  if (state.level >= state.options.maxNesting) { return false; }

  state.pos = start + startCount;
  stack = [ startCount ];

  while (state.pos < max) {
    if (state.src.charCodeAt(state.pos) === marker) {
      res = scanDelims(state, state.pos);
      count = res.delims;
      if (res.can_close) {
        oldCount = stack.pop();
        newCount = count;

        while (oldCount !== newCount) {
          if (newCount < oldCount) {
            stack.push(oldCount - newCount);
            break;
          }

          // assert(newCount > oldCount)
          newCount -= oldCount;

          if (stack.length === 0) { break; }
          state.pos += oldCount;
          oldCount = stack.pop();
        }

        if (stack.length === 0) {
          startCount = oldCount;
          found = true;
          break;
        }
        state.pos += count;
        continue;
      }

      if (res.can_open) { stack.push(count); }
      state.pos += count;
      continue;
    }

    state.parser.skipToken(state);
  }

  if (!found) {
    // parser failed to find ending tag, so it's not valid emphasis
    state.pos = start;
    return false;
  }

  // found!
  state.posMax = state.pos;
  state.pos = start + startCount;

  if (!silent) {
    if (startCount === 2 || startCount === 3) {
      state.push({ type: 'strong_open', level: state.level++ });
    }
    if (startCount === 1 || startCount === 3) {
      state.push({ type: 'em_open', level: state.level++ });
    }

    state.parser.tokenize(state);

    if (startCount === 1 || startCount === 3) {
      state.push({ type: 'em_close', level: --state.level });
    }
    if (startCount === 2 || startCount === 3) {
      state.push({ type: 'strong_close', level: --state.level });
    }
  }

  state.pos = state.posMax + startCount;
  state.posMax = max;
  return true;
}

// Process ~subscript~

// same as UNESCAPE_MD_RE plus a space
var UNESCAPE_RE = /\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;

function sub(state, silent) {
  var found,
      content,
      max = state.posMax,
      start = state.pos;

  if (state.src.charCodeAt(start) !== 0x7E/* ~ */) { return false; }
  if (silent) { return false; } // don't run any pairs in validation mode
  if (start + 2 >= max) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  state.pos = start + 1;

  while (state.pos < max) {
    if (state.src.charCodeAt(state.pos) === 0x7E/* ~ */) {
      found = true;
      break;
    }

    state.parser.skipToken(state);
  }

  if (!found || start + 1 === state.pos) {
    state.pos = start;
    return false;
  }

  content = state.src.slice(start + 1, state.pos);

  // don't allow unescaped spaces/newlines inside
  if (content.match(/(^|[^\\])(\\\\)*\s/)) {
    state.pos = start;
    return false;
  }

  // found!
  state.posMax = state.pos;
  state.pos = start + 1;

  if (!silent) {
    state.push({
      type: 'sub',
      level: state.level,
      content: content.replace(UNESCAPE_RE, '$1')
    });
  }

  state.pos = state.posMax + 1;
  state.posMax = max;
  return true;
}

// Process ^superscript^

// same as UNESCAPE_MD_RE plus a space
var UNESCAPE_RE$1 = /\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;

function sup(state, silent) {
  var found,
      content,
      max = state.posMax,
      start = state.pos;

  if (state.src.charCodeAt(start) !== 0x5E/* ^ */) { return false; }
  if (silent) { return false; } // don't run any pairs in validation mode
  if (start + 2 >= max) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  state.pos = start + 1;

  while (state.pos < max) {
    if (state.src.charCodeAt(state.pos) === 0x5E/* ^ */) {
      found = true;
      break;
    }

    state.parser.skipToken(state);
  }

  if (!found || start + 1 === state.pos) {
    state.pos = start;
    return false;
  }

  content = state.src.slice(start + 1, state.pos);

  // don't allow unescaped spaces/newlines inside
  if (content.match(/(^|[^\\])(\\\\)*\s/)) {
    state.pos = start;
    return false;
  }

  // found!
  state.posMax = state.pos;
  state.pos = start + 1;

  if (!silent) {
    state.push({
      type: 'sup',
      level: state.level,
      content: content.replace(UNESCAPE_RE$1, '$1')
    });
  }

  state.pos = state.posMax + 1;
  state.posMax = max;
  return true;
}

// Process [links](<to> "stuff")


function links(state, silent) {
  var labelStart,
      labelEnd,
      label,
      href,
      title,
      pos,
      ref,
      code,
      isImage = false,
      oldPos = state.pos,
      max = state.posMax,
      start = state.pos,
      marker = state.src.charCodeAt(start);

  if (marker === 0x21/* ! */) {
    isImage = true;
    marker = state.src.charCodeAt(++start);
  }

  if (marker !== 0x5B/* [ */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  labelStart = start + 1;
  labelEnd = parseLinkLabel(state, start);

  // parser failed to find ']', so it's not a valid link
  if (labelEnd < 0) { return false; }

  pos = labelEnd + 1;
  if (pos < max && state.src.charCodeAt(pos) === 0x28/* ( */) {
    //
    // Inline link
    //

    // [link](  <href>  "title"  )
    //        ^^ skipping these spaces
    pos++;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (code !== 0x20 && code !== 0x0A) { break; }
    }
    if (pos >= max) { return false; }

    // [link](  <href>  "title"  )
    //          ^^^^^^ parsing link destination
    start = pos;
    if (parseLinkDestination(state, pos)) {
      href = state.linkContent;
      pos = state.pos;
    } else {
      href = '';
    }

    // [link](  <href>  "title"  )
    //                ^^ skipping these spaces
    start = pos;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (code !== 0x20 && code !== 0x0A) { break; }
    }

    // [link](  <href>  "title"  )
    //                  ^^^^^^^ parsing link title
    if (pos < max && start !== pos && parseLinkTitle(state, pos)) {
      title = state.linkContent;
      pos = state.pos;

      // [link](  <href>  "title"  )
      //                         ^^ skipping these spaces
      for (; pos < max; pos++) {
        code = state.src.charCodeAt(pos);
        if (code !== 0x20 && code !== 0x0A) { break; }
      }
    } else {
      title = '';
    }

    if (pos >= max || state.src.charCodeAt(pos) !== 0x29/* ) */) {
      state.pos = oldPos;
      return false;
    }
    pos++;
  } else {
    //
    // Link reference
    //

    // do not allow nested reference links
    if (state.linkLevel > 0) { return false; }

    // [foo]  [bar]
    //      ^^ optional whitespace (can include newlines)
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (code !== 0x20 && code !== 0x0A) { break; }
    }

    if (pos < max && state.src.charCodeAt(pos) === 0x5B/* [ */) {
      start = pos + 1;
      pos = parseLinkLabel(state, pos);
      if (pos >= 0) {
        label = state.src.slice(start, pos++);
      } else {
        pos = start - 1;
      }
    }

    // covers label === '' and label === undefined
    // (collapsed reference link and shortcut reference link respectively)
    if (!label) {
      if (typeof label === 'undefined') {
        pos = labelEnd + 1;
      }
      label = state.src.slice(labelStart, labelEnd);
    }

    ref = state.env.references[normalizeReference(label)];
    if (!ref) {
      state.pos = oldPos;
      return false;
    }
    href = ref.href;
    title = ref.title;
  }

  //
  // We found the end of the link, and know for a fact it's a valid link;
  // so all that's left to do is to call tokenizer.
  //
  if (!silent) {
    state.pos = labelStart;
    state.posMax = labelEnd;

    if (isImage) {
      state.push({
        type: 'image',
        src: href,
        title: title,
        alt: state.src.substr(labelStart, labelEnd - labelStart),
        level: state.level
      });
    } else {
      state.push({
        type: 'link_open',
        href: href,
        title: title,
        level: state.level++
      });
      state.linkLevel++;
      state.parser.tokenize(state);
      state.linkLevel--;
      state.push({ type: 'link_close', level: --state.level });
    }
  }

  state.pos = pos;
  state.posMax = max;
  return true;
}

// Process inline footnotes (^[...])


function footnote_inline(state, silent) {
  var labelStart,
      labelEnd,
      footnoteId,
      oldLength,
      max = state.posMax,
      start = state.pos;

  if (start + 2 >= max) { return false; }
  if (state.src.charCodeAt(start) !== 0x5E/* ^ */) { return false; }
  if (state.src.charCodeAt(start + 1) !== 0x5B/* [ */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  labelStart = start + 2;
  labelEnd = parseLinkLabel(state, start + 1);

  // parser failed to find ']', so it's not a valid note
  if (labelEnd < 0) { return false; }

  // We found the end of the link, and know for a fact it's a valid link;
  // so all that's left to do is to call tokenizer.
  //
  if (!silent) {
    if (!state.env.footnotes) { state.env.footnotes = {}; }
    if (!state.env.footnotes.list) { state.env.footnotes.list = []; }
    footnoteId = state.env.footnotes.list.length;

    state.pos = labelStart;
    state.posMax = labelEnd;

    state.push({
      type: 'footnote_ref',
      id: footnoteId,
      level: state.level
    });
    state.linkLevel++;
    oldLength = state.tokens.length;
    state.parser.tokenize(state);
    state.env.footnotes.list[footnoteId] = { tokens: state.tokens.splice(oldLength) };
    state.linkLevel--;
  }

  state.pos = labelEnd + 1;
  state.posMax = max;
  return true;
}

// Process footnote references ([^...])

function footnote_ref(state, silent) {
  var label,
      pos,
      footnoteId,
      footnoteSubId,
      max = state.posMax,
      start = state.pos;

  // should be at least 4 chars - "[^x]"
  if (start + 3 > max) { return false; }

  if (!state.env.footnotes || !state.env.footnotes.refs) { return false; }
  if (state.src.charCodeAt(start) !== 0x5B/* [ */) { return false; }
  if (state.src.charCodeAt(start + 1) !== 0x5E/* ^ */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  for (pos = start + 2; pos < max; pos++) {
    if (state.src.charCodeAt(pos) === 0x20) { return false; }
    if (state.src.charCodeAt(pos) === 0x0A) { return false; }
    if (state.src.charCodeAt(pos) === 0x5D /* ] */) {
      break;
    }
  }

  if (pos === start + 2) { return false; } // no empty footnote labels
  if (pos >= max) { return false; }
  pos++;

  label = state.src.slice(start + 2, pos - 1);
  if (typeof state.env.footnotes.refs[':' + label] === 'undefined') { return false; }

  if (!silent) {
    if (!state.env.footnotes.list) { state.env.footnotes.list = []; }

    if (state.env.footnotes.refs[':' + label] < 0) {
      footnoteId = state.env.footnotes.list.length;
      state.env.footnotes.list[footnoteId] = { label: label, count: 0 };
      state.env.footnotes.refs[':' + label] = footnoteId;
    } else {
      footnoteId = state.env.footnotes.refs[':' + label];
    }

    footnoteSubId = state.env.footnotes.list[footnoteId].count;
    state.env.footnotes.list[footnoteId].count++;

    state.push({
      type: 'footnote_ref',
      id: footnoteId,
      subId: footnoteSubId,
      level: state.level
    });
  }

  state.pos = pos;
  state.posMax = max;
  return true;
}

// List of valid url schemas, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#autolinks

var url_schemas = [
  'coap',
  'doi',
  'javascript',
  'aaa',
  'aaas',
  'about',
  'acap',
  'cap',
  'cid',
  'crid',
  'data',
  'dav',
  'dict',
  'dns',
  'file',
  'ftp',
  'geo',
  'go',
  'gopher',
  'h323',
  'http',
  'https',
  'iax',
  'icap',
  'im',
  'imap',
  'info',
  'ipp',
  'iris',
  'iris.beep',
  'iris.xpc',
  'iris.xpcs',
  'iris.lwz',
  'ldap',
  'mailto',
  'mid',
  'msrp',
  'msrps',
  'mtqp',
  'mupdate',
  'news',
  'nfs',
  'ni',
  'nih',
  'nntp',
  'opaquelocktoken',
  'pop',
  'pres',
  'rtsp',
  'service',
  'session',
  'shttp',
  'sieve',
  'sip',
  'sips',
  'sms',
  'snmp',
  'soap.beep',
  'soap.beeps',
  'tag',
  'tel',
  'telnet',
  'tftp',
  'thismessage',
  'tn3270',
  'tip',
  'tv',
  'urn',
  'vemmi',
  'ws',
  'wss',
  'xcon',
  'xcon-userid',
  'xmlrpc.beep',
  'xmlrpc.beeps',
  'xmpp',
  'z39.50r',
  'z39.50s',
  'adiumxtra',
  'afp',
  'afs',
  'aim',
  'apt',
  'attachment',
  'aw',
  'beshare',
  'bitcoin',
  'bolo',
  'callto',
  'chrome',
  'chrome-extension',
  'com-eventbrite-attendee',
  'content',
  'cvs',
  'dlna-playsingle',
  'dlna-playcontainer',
  'dtn',
  'dvb',
  'ed2k',
  'facetime',
  'feed',
  'finger',
  'fish',
  'gg',
  'git',
  'gizmoproject',
  'gtalk',
  'hcp',
  'icon',
  'ipn',
  'irc',
  'irc6',
  'ircs',
  'itms',
  'jar',
  'jms',
  'keyparc',
  'lastfm',
  'ldaps',
  'magnet',
  'maps',
  'market',
  'message',
  'mms',
  'ms-help',
  'msnim',
  'mumble',
  'mvn',
  'notes',
  'oid',
  'palm',
  'paparazzi',
  'platform',
  'proxy',
  'psyc',
  'query',
  'res',
  'resource',
  'rmi',
  'rsync',
  'rtmp',
  'secondlife',
  'sftp',
  'sgn',
  'skype',
  'smb',
  'soldat',
  'spotify',
  'ssh',
  'steam',
  'svn',
  'teamspeak',
  'things',
  'udp',
  'unreal',
  'ut2004',
  'ventrilo',
  'view-source',
  'webcal',
  'wtai',
  'wyciwyg',
  'xfire',
  'xri',
  'ymsgr'
];

// Process autolinks '<protocol:...>'


/*eslint max-len:0*/
var EMAIL_RE    = /^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/;
var AUTOLINK_RE = /^<([a-zA-Z.\-]{1,25}):([^<>\x00-\x20]*)>/;


function autolink(state, silent) {
  var tail, linkMatch, emailMatch, url, fullUrl, pos = state.pos;

  if (state.src.charCodeAt(pos) !== 0x3C/* < */) { return false; }

  tail = state.src.slice(pos);

  if (tail.indexOf('>') < 0) { return false; }

  linkMatch = tail.match(AUTOLINK_RE);

  if (linkMatch) {
    if (url_schemas.indexOf(linkMatch[1].toLowerCase()) < 0) { return false; }

    url = linkMatch[0].slice(1, -1);
    fullUrl = normalizeLink(url);
    if (!state.parser.validateLink(url)) { return false; }

    if (!silent) {
      state.push({
        type: 'link_open',
        href: fullUrl,
        level: state.level
      });
      state.push({
        type: 'text',
        content: url,
        level: state.level + 1
      });
      state.push({ type: 'link_close', level: state.level });
    }

    state.pos += linkMatch[0].length;
    return true;
  }

  emailMatch = tail.match(EMAIL_RE);

  if (emailMatch) {

    url = emailMatch[0].slice(1, -1);

    fullUrl = normalizeLink('mailto:' + url);
    if (!state.parser.validateLink(fullUrl)) { return false; }

    if (!silent) {
      state.push({
        type: 'link_open',
        href: fullUrl,
        level: state.level
      });
      state.push({
        type: 'text',
        content: url,
        level: state.level + 1
      });
      state.push({ type: 'link_close', level: state.level });
    }

    state.pos += emailMatch[0].length;
    return true;
  }

  return false;
}

// Regexps to match html elements

function replace$1(regex, options) {
  regex = regex.source;
  options = options || '';

  return function self(name, val) {
    if (!name) {
      return new RegExp(regex, options);
    }
    val = val.source || val;
    regex = regex.replace(name, val);
    return self;
  };
}


var attr_name     = /[a-zA-Z_:][a-zA-Z0-9:._-]*/;

var unquoted      = /[^"'=<>`\x00-\x20]+/;
var single_quoted = /'[^']*'/;
var double_quoted = /"[^"]*"/;

/*eslint no-spaced-func:0*/
var attr_value  = replace$1(/(?:unquoted|single_quoted|double_quoted)/)
                    ('unquoted', unquoted)
                    ('single_quoted', single_quoted)
                    ('double_quoted', double_quoted)
                    ();

var attribute   = replace$1(/(?:\s+attr_name(?:\s*=\s*attr_value)?)/)
                    ('attr_name', attr_name)
                    ('attr_value', attr_value)
                    ();

var open_tag    = replace$1(/<[A-Za-z][A-Za-z0-9]*attribute*\s*\/?>/)
                    ('attribute', attribute)
                    ();

var close_tag   = /<\/[A-Za-z][A-Za-z0-9]*\s*>/;
var comment     = /<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->/;
var processing  = /<[?].*?[?]>/;
var declaration = /<![A-Z]+\s+[^>]*>/;
var cdata       = /<!\[CDATA\[[\s\S]*?\]\]>/;

var HTML_TAG_RE = replace$1(/^(?:open_tag|close_tag|comment|processing|declaration|cdata)/)
  ('open_tag', open_tag)
  ('close_tag', close_tag)
  ('comment', comment)
  ('processing', processing)
  ('declaration', declaration)
  ('cdata', cdata)
  ();

// Process html tags


function isLetter$2(ch) {
  /*eslint no-bitwise:0*/
  var lc = ch | 0x20; // to lower case
  return (lc >= 0x61/* a */) && (lc <= 0x7a/* z */);
}


function htmltag(state, silent) {
  var ch, match, max, pos = state.pos;

  if (!state.options.html) { return false; }

  // Check start
  max = state.posMax;
  if (state.src.charCodeAt(pos) !== 0x3C/* < */ ||
      pos + 2 >= max) {
    return false;
  }

  // Quick fail on second char
  ch = state.src.charCodeAt(pos + 1);
  if (ch !== 0x21/* ! */ &&
      ch !== 0x3F/* ? */ &&
      ch !== 0x2F/* / */ &&
      !isLetter$2(ch)) {
    return false;
  }

  match = state.src.slice(pos).match(HTML_TAG_RE);
  if (!match) { return false; }

  if (!silent) {
    state.push({
      type: 'htmltag',
      content: state.src.slice(pos, pos + match[0].length),
      level: state.level
    });
  }
  state.pos += match[0].length;
  return true;
}

// Process html entity - &#123;, &#xAF;, &quot;, ...


var DIGITAL_RE = /^&#((?:x[a-f0-9]{1,8}|[0-9]{1,8}));/i;
var NAMED_RE   = /^&([a-z][a-z0-9]{1,31});/i;


function entity(state, silent) {
  var ch, code, match, pos = state.pos, max = state.posMax;

  if (state.src.charCodeAt(pos) !== 0x26/* & */) { return false; }

  if (pos + 1 < max) {
    ch = state.src.charCodeAt(pos + 1);

    if (ch === 0x23 /* # */) {
      match = state.src.slice(pos).match(DIGITAL_RE);
      if (match) {
        if (!silent) {
          code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
          state.pending += isValidEntityCode(code) ? fromCodePoint(code) : fromCodePoint(0xFFFD);
        }
        state.pos += match[0].length;
        return true;
      }
    } else {
      match = state.src.slice(pos).match(NAMED_RE);
      if (match) {
        var decoded = decodeEntity(match[1]);
        if (match[1] !== decoded) {
          if (!silent) { state.pending += decoded; }
          state.pos += match[0].length;
          return true;
        }
      }
    }
  }

  if (!silent) { state.pending += '&'; }
  state.pos++;
  return true;
}

/**
 * Inline Parser `rules`
 */

var _rules$2 = [
  [ 'text',            index_browser_text ],
  [ 'newline',         newline ],
  [ 'escape',          index_browser_escape ],
  [ 'backticks',       backticks ],
  [ 'del',             del ],
  [ 'ins',             ins ],
  [ 'mark',            mark ],
  [ 'emphasis',        emphasis ],
  [ 'sub',             sub ],
  [ 'sup',             sup ],
  [ 'links',           links ],
  [ 'footnote_inline', footnote_inline ],
  [ 'footnote_ref',    footnote_ref ],
  [ 'autolink',        autolink ],
  [ 'htmltag',         htmltag ],
  [ 'entity',          entity ]
];

/**
 * Inline Parser class. Note that link validation is stricter
 * in Remarkable than what is specified by CommonMark. If you
 * want to change this you can use a custom validator.
 *
 * @api private
 */

function ParserInline() {
  this.ruler = new Ruler();
  for (var i = 0; i < _rules$2.length; i++) {
    this.ruler.push(_rules$2[i][0], _rules$2[i][1]);
  }

  // Can be overridden with a custom validator
  this.validateLink = validateLink;
}

/**
 * Skip a single token by running all rules in validation mode.
 * Returns `true` if any rule reports success.
 *
 * @param  {Object} `state`
 * @api privage
 */

ParserInline.prototype.skipToken = function (state) {
  var rules = this.ruler.getRules('');
  var len = rules.length;
  var pos = state.pos;
  var i, cached_pos;

  if ((cached_pos = state.cacheGet(pos)) > 0) {
    state.pos = cached_pos;
    return;
  }

  for (i = 0; i < len; i++) {
    if (rules[i](state, true)) {
      state.cacheSet(pos, state.pos);
      return;
    }
  }

  state.pos++;
  state.cacheSet(pos, state.pos);
};

/**
 * Generate tokens for the given input range.
 *
 * @param  {Object} `state`
 * @api private
 */

ParserInline.prototype.tokenize = function (state) {
  var rules = this.ruler.getRules('');
  var len = rules.length;
  var end = state.posMax;
  var ok, i;

  while (state.pos < end) {

    // Try all possible rules.
    // On success, the rule should:
    //
    // - update `state.pos`
    // - update `state.tokens`
    // - return true
    for (i = 0; i < len; i++) {
      ok = rules[i](state, false);

      if (ok) {
        break;
      }
    }

    if (ok) {
      if (state.pos >= end) { break; }
      continue;
    }

    state.pending += state.src[state.pos++];
  }

  if (state.pending) {
    state.pushPending();
  }
};

/**
 * Parse the given input string.
 *
 * @param  {String} `str`
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @param  {Array} `outTokens`
 * @api private
 */

ParserInline.prototype.parse = function (str, options, env, outTokens) {
  var state = new StateInline(str, this, options, env, outTokens);
  this.tokenize(state);
};

/**
 * Validate the given `url` by checking for bad protocols.
 *
 * @param  {String} `url`
 * @return {Boolean}
 */

function validateLink(url) {
  var BAD_PROTOCOLS = [ 'vbscript', 'javascript', 'file', 'data' ];
  var str = url.trim().toLowerCase();
  // Care about digital entities "javascript&#x3A;alert(1)"
  str = replaceEntities(str);
  if (str.indexOf(':') !== -1 && BAD_PROTOCOLS.indexOf(str.split(':')[0]) !== -1) {
    return false;
  }
  return true;
}

// Remarkable default options

var defaultConfig = {
  options: {
    html:         false,        // Enable HTML tags in source
    xhtmlOut:     false,        // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkTarget:   '',           // set target to open link in

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
    quotes: '“”‘’',

    // Highlighter function. Should return escaped HTML,
    // or '' if input not changed
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting:   20            // Internal protection, recursion limit
  },

  components: {

    core: {
      rules: [
        'block',
        'inline',
        'references',
        'replacements',
        'smartquotes',
        'references',
        'abbr2',
        'footnote_tail'
      ]
    },

    block: {
      rules: [
        'blockquote',
        'code',
        'fences',
        'footnote',
        'heading',
        'hr',
        'htmlblock',
        'lheading',
        'list',
        'paragraph',
        'table'
      ]
    },

    inline: {
      rules: [
        'autolink',
        'backticks',
        'del',
        'emphasis',
        'entity',
        'escape',
        'footnote_ref',
        'htmltag',
        'links',
        'newline',
        'text'
      ]
    }
  }
};

// Remarkable default options

var fullConfig = {
  options: {
    html:         false,        // Enable HTML tags in source
    xhtmlOut:     false,        // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkTarget:   '',           // set target to open link in

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
    quotes:       '“”‘’',

    // Highlighter function. Should return escaped HTML,
    // or '' if input not changed
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight:     null,

    maxNesting:    20            // Internal protection, recursion limit
  },

  components: {
    // Don't restrict core/block/inline rules
    core: {},
    block: {},
    inline: {}
  }
};

// Commonmark default options

var commonmarkConfig = {
  options: {
    html:         true,         // Enable HTML tags in source
    xhtmlOut:     true,         // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkTarget:   '',           // set target to open link in

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
    quotes: '“”‘’',

    // Highlighter function. Should return escaped HTML,
    // or '' if input not changed
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting:   20            // Internal protection, recursion limit
  },

  components: {

    core: {
      rules: [
        'block',
        'inline',
        'references',
        'abbr2'
      ]
    },

    block: {
      rules: [
        'blockquote',
        'code',
        'fences',
        'heading',
        'hr',
        'htmlblock',
        'lheading',
        'list',
        'paragraph'
      ]
    },

    inline: {
      rules: [
        'autolink',
        'backticks',
        'emphasis',
        'entity',
        'escape',
        'htmltag',
        'links',
        'newline',
        'text'
      ]
    }
  }
};

/**
 * Preset configs
 */

var index_browser_config = {
  'default': defaultConfig,
  'full': fullConfig,
  'commonmark': commonmarkConfig
};

/**
 * The `StateCore` class manages state.
 *
 * @param {Object} `instance` Remarkable instance
 * @param {String} `str` Markdown string
 * @param {Object} `env`
 */

function StateCore(instance, str, env) {
  this.src = str;
  this.env = env;
  this.options = instance.options;
  this.tokens = [];
  this.inlineMode = false;

  this.inline = instance.inline;
  this.block = instance.block;
  this.renderer = instance.renderer;
  this.typographer = instance.typographer;
}

/**
 * The main `Remarkable` class. Create an instance of
 * `Remarkable` with a `preset` and/or `options`.
 *
 * @param {String} `preset` If no preset is given, `default` is used.
 * @param {Object} `options`
 */

function Remarkable(preset, options) {
  if (typeof preset !== 'string') {
    options = preset;
    preset = 'default';
  }

  if (options && options.linkify != null) {
    console.warn(
      'linkify option is removed. Use linkify plugin instead:\n\n' +
      'import Remarkable from \'remarkable\';\n' +
      'import linkify from \'remarkable/linkify\';\n' +
      'new Remarkable().use(linkify)\n'
    );
  }

  this.inline   = new ParserInline();
  this.block    = new ParserBlock();
  this.core     = new Core();
  this.renderer = new Renderer();
  this.ruler    = new Ruler();

  this.options  = {};
  this.configure(index_browser_config[preset]);
  this.set(options || {});
}

/**
 * Set options as an alternative to passing them
 * to the constructor.
 *
 * ```js
 * md.set({typographer: true});
 * ```
 * @param {Object} `options`
 * @api public
 */

Remarkable.prototype.set = function (options) {
  index_browser_assign(this.options, options);
};

/**
 * Batch loader for components rules states, and options
 *
 * @param  {Object} `presets`
 */

Remarkable.prototype.configure = function (presets) {
  var self = this;

  if (!presets) { throw new Error('Wrong `remarkable` preset, check name/content'); }
  if (presets.options) { self.set(presets.options); }
  if (presets.components) {
    Object.keys(presets.components).forEach(function (name) {
      if (presets.components[name].rules) {
        self[name].ruler.enable(presets.components[name].rules, true);
      }
    });
  }
};

/**
 * Use a plugin.
 *
 * ```js
 * var md = new Remarkable();
 *
 * md.use(plugin1)
 *   .use(plugin2, opts)
 *   .use(plugin3);
 * ```
 *
 * @param  {Function} `plugin`
 * @param  {Object} `options`
 * @return {Object} `Remarkable` for chaining
 */

Remarkable.prototype.use = function (plugin, options) {
  plugin(this, options);
  return this;
};


/**
 * Parse the input `string` and return a tokens array.
 * Modifies `env` with definitions data.
 *
 * @param  {String} `string`
 * @param  {Object} `env`
 * @return {Array} Array of tokens
 */

Remarkable.prototype.parse = function (str, env) {
  var state = new StateCore(this, str, env);
  this.core.process(state);
  return state.tokens;
};

/**
 * The main `.render()` method that does all the magic :)
 *
 * @param  {String} `string`
 * @param  {Object} `env`
 * @return {String} Rendered HTML.
 */

Remarkable.prototype.render = function (str, env) {
  env = env || {};
  return this.renderer.render(this.parse(str, env), this.options, env);
};

/**
 * Parse the given content `string` as a single string.
 *
 * @param  {String} `string`
 * @param  {Object} `env`
 * @return {Array} Array of tokens
 */

Remarkable.prototype.parseInline = function (str, env) {
  var state = new StateCore(this, str, env);
  state.inlineMode = true;
  this.core.process(state);
  return state.tokens;
};

/**
 * Render a single content `string`, without wrapping it
 * to paragraphs
 *
 * @param  {String} `str`
 * @param  {Object} `env`
 * @return {String}
 */

Remarkable.prototype.renderInline = function (str, env) {
  env = env || {};
  return this.renderer.render(this.parseInline(str, env), this.options, env);
};



// EXTERNAL MODULE: ./src/components/markdown.less
var markdown = __webpack_require__(118);

// EXTERNAL MODULE: ./src/components/markdown-rebrand.less
var markdown_rebrand = __webpack_require__(119);

// CONCATENATED MODULE: ./src/components/markdown.jsx







var markdown_Markdown = function Markdown(_ref)




{var source = _ref.source,className = _ref.className,options = _ref.options,element = _ref.element;
  if (!source) {return null;} // Don't try to render if no text passed in
  var remarkable = new Remarkable('default', options);
  var html = remarkable.render(source);
  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(element, {
    className: "markdown uic ".concat(className),
    dangerouslySetInnerHTML: { __html: html }
  });
};

markdown_Markdown.propTypes = {
  source: prop_types_default.a.string,
  className: prop_types_default.a.string,
  options: prop_types_default.a.object, // eslint-disable-line
  element: prop_types_default.a.elementType
};

markdown_Markdown.defaultProps = {
  source: null,
  className: '',
  options: { html: true },
  element: 'div'
};

/* harmony default export */ var components_markdown = (markdown_Markdown);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(10);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/react-image/umd/index.js
var umd = __webpack_require__(41);
var umd_default = /*#__PURE__*/__webpack_require__.n(umd);

// CONCATENATED MODULE: ./src/components/lazy-image.jsx
function lazy_image_typeof(obj) {"@babel/helpers - typeof";return lazy_image_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, lazy_image_typeof(obj);}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {lazy_image_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function lazy_image_defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function lazy_image_extends() {lazy_image_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return lazy_image_extends.apply(this, arguments);}function lazy_image_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function lazy_image_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function lazy_image_createClass(Constructor, protoProps, staticProps) {if (protoProps) lazy_image_defineProperties(Constructor.prototype, protoProps);if (staticProps) lazy_image_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function lazy_image_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) lazy_image_setPrototypeOf(subClass, superClass);}function lazy_image_setPrototypeOf(o, p) {lazy_image_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return lazy_image_setPrototypeOf(o, p);}function lazy_image_createSuper(Derived) {var hasNativeReflectConstruct = lazy_image_isNativeReflectConstruct();return function _createSuperInternal() {var Super = lazy_image_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = lazy_image_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return lazy_image_possibleConstructorReturn(this, result);};}function lazy_image_possibleConstructorReturn(self, call) {if (call && (lazy_image_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return lazy_image_assertThisInitialized(self);}function lazy_image_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function lazy_image_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function lazy_image_getPrototypeOf(o) {lazy_image_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return lazy_image_getPrototypeOf(o);}




/**
 * Allow ui-common consumers to force lazy-loaded images to check whether they
 * are in the viewport
 */


/**
 * Lazy Loaded Image
 * react-lazyload renders any component once it's near the viewport (offset)
 * react-image is a helper for loading an image with a small placeholder to prevent page jumps
 * https://css-tricks.com/content-jumping-avoid/
 *
 * The `placholder` node should be around the same size as the `src` image. A low quality image
 * of the same dimensions works good for this, or a div of the same dimensions.
 */
// eslint-disable-next-line react/prefer-stateless-function
var lazy_image_LazyImage = /*#__PURE__*/function (_React$PureComponent) {lazy_image_inherits(LazyImage, _React$PureComponent);var _super = lazy_image_createSuper(LazyImage);function LazyImage() {lazy_image_classCallCheck(this, LazyImage);return _super.apply(this, arguments);}lazy_image_createClass(LazyImage, [{ key: "render", value:
    function render() {
      var _this$props =






        this.props,className = _this$props.className,src = _this$props.src,alt = _this$props.alt,lazy = _this$props.lazy,placeholder = _this$props.placeholder,lazyLoadProps = _this$props.lazyLoadProps;

      // Turn off decoding feature in react-image for SVGs to avoid this bug in
      // safari: https://bugs.webkit.org/show_bug.cgi?id=188347
      var isSvg = /.svg/.test(src);
      var image = /*#__PURE__*/
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(umd_default.a, {
        className: className,
        src: src,
        loader: placeholder,
        alt: alt,
        decode: !isSvg });


      if (!lazy) {
        return image;
      }

      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(lib_default.a, lazy_image_extends({}, lazyLoadProps, { placeholder: placeholder }),
        image));


    } }]);return LazyImage;}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.PureComponent);


// See react-lazyload README for info on LazyLoad props: https://github.com/twobin/react-lazyload#props
var lazyLoadPropType = {
  height: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
  once: prop_types_default.a.bool,
  offset: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.array]),
  scroll: prop_types_default.a.bool,
  resize: prop_types_default.a.bool,
  overflow: prop_types_default.a.bool,
  placeholder: prop_types_default.a.node,
  unmountIfInvisible: prop_types_default.a.bool,
  debounce: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.bool]),
  throttle: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.bool])
};

var lazyLoadDefaultProp = {
  height: undefined,
  once: true,
  offset: 100,
  scroll: true,
  resize: false,
  overflow: false,
  placeholder: null,
  unmountIfInvisible: false,
  debounce: undefined,
  throttle: 50
};

lazy_image_LazyImage.propTypes = _objectSpread({
  className: prop_types_default.a.string,
  lazy: prop_types_default.a.bool,
  src: prop_types_default.a.string },

lazyLoadPropType);


lazy_image_LazyImage.defaultProps = _objectSpread({
  className: '',
  lazy: true,
  src: '' },

lazyLoadDefaultProp);


/* harmony default export */ var lazy_image = (lazy_image_LazyImage);
// EXTERNAL MODULE: ./src/components/placeholder-image.less
var placeholder_image = __webpack_require__(137);

// CONCATENATED MODULE: ./src/components/placeholder-image.jsx
var placeholder_image_excluded = ["className"];function placeholder_image_extends() {placeholder_image_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return placeholder_image_extends.apply(this, arguments);}function placeholder_image_objectWithoutProperties(source, excluded) {if (source == null) return {};var target = placeholder_image_objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function placeholder_image_objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}




var placeholder_image_PlaceholderImage = function PlaceholderImage(_ref) {var className = _ref.className,props = placeholder_image_objectWithoutProperties(_ref, placeholder_image_excluded);return /*#__PURE__*/ (
    // eslint-disable-next-line jsx-a11y/alt-text
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("img", placeholder_image_extends({ className: "".concat(className, " placeholder-image") }, props)));};


placeholder_image_PlaceholderImage.propTypes = {
  className: prop_types_default.a.string
};

placeholder_image_PlaceholderImage.defaultProps = {
  className: ''
};

/* harmony default export */ var components_placeholder_image = (placeholder_image_PlaceholderImage);
// EXTERNAL MODULE: ./src/components/gallery-carousel/gallery-carousel-hero.less
var gallery_carousel_hero = __webpack_require__(138);

// CONCATENATED MODULE: ./src/components/gallery-carousel/gallery-carousel-hero.jsx








/**
 * @typedef {object} GalleryCarouselItemData
 * @property {string} id Unique id for image
 * @property {string} heroUrl Image url
 * @property {string} heroPlaceholderUrl Placeholder URL, image is lazy loaded if provided
 * @property {string} heroNavTitle Title of the image
 * @property {string} description Markdown description of the large image
 */

/**
 * @typedef {object} GalleryCarouselHeroProps
 * @property {GalleryCarouselItemData} image
 * @property {object} style
 */

/**
 * The large image displayed under/above (mobile) the carousel navigation
 * @param {GalleryCarouselHeroProps} props
 */
var gallery_carousel_hero_GalleryCarouselHero = function GalleryCarouselHero(_ref) {var image = _ref.image,lazy = _ref.lazy,style = _ref.style;
  var fullImage = /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("img", {
    src: image.heroUrl,
    alt: image.heroNavTitle });


  var placeholderImage = image.heroPlaceholderUrl ? /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_placeholder_image, {
    src: image.heroPlaceholderUrl,
    alt: image.heroNavTitle }) :
  null;

  var imageElement = placeholderImage && lazy ? /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(lazy_image, {
    src: image.heroUrl,
    alt: image.heroNavTitle,
    placeholder: placeholderImage }) :
  fullImage;

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", {
      className: "GalleryCarouselHero",
      style: style },
    imageElement, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "text" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, { source: image.description }))));



};

gallery_carousel_hero_GalleryCarouselHero.propTypes = {
  image: imagePropType.isRequired,
  lazy: prop_types_default.a.bool.isRequired,
  style: prop_types_default.a.shape({
    opacity: prop_types_default.a.string,
    transition: prop_types_default.a.string
  }).isRequired
};

/* harmony default export */ var gallery_carousel_gallery_carousel_hero = (gallery_carousel_hero_GalleryCarouselHero);
// EXTERNAL MODULE: ./src/components/gallery-carousel/gallery-carousel.less
var gallery_carousel = __webpack_require__(139);

// CONCATENATED MODULE: ./src/components/gallery-carousel/gallery-carousel.jsx
function gallery_carousel_typeof(obj) {"@babel/helpers - typeof";return gallery_carousel_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, gallery_carousel_typeof(obj);}function gallery_carousel_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function gallery_carousel_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function gallery_carousel_createClass(Constructor, protoProps, staticProps) {if (protoProps) gallery_carousel_defineProperties(Constructor.prototype, protoProps);if (staticProps) gallery_carousel_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function gallery_carousel_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) gallery_carousel_setPrototypeOf(subClass, superClass);}function gallery_carousel_setPrototypeOf(o, p) {gallery_carousel_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return gallery_carousel_setPrototypeOf(o, p);}function gallery_carousel_createSuper(Derived) {var hasNativeReflectConstruct = gallery_carousel_isNativeReflectConstruct();return function _createSuperInternal() {var Super = gallery_carousel_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = gallery_carousel_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return gallery_carousel_possibleConstructorReturn(this, result);};}function gallery_carousel_possibleConstructorReturn(self, call) {if (call && (gallery_carousel_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return gallery_carousel_assertThisInitialized(self);}function gallery_carousel_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function gallery_carousel_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function gallery_carousel_getPrototypeOf(o) {gallery_carousel_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return gallery_carousel_getPrototypeOf(o);}function gallery_carousel_defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;} // @ts-check








/**
 * @typedef {object} GalleryCarouselItemData
 * @property {string} id Unique id for image
 * @property {string} heroUrl Image url
 * @property {string} heroPlaceholderUrl Placeholder URL, image is lazy loaded if provided
 * @property {string} heroNavTitle Title of the image
 * @property {string} description Markdown description of the large image
 */

/**
 * @typedef {object} GalleryCarouselProps
 * @property {GalleryCarouselItemData[]} data List of image data
 */

/**
 * @typedef {object} GalleryCarouselState
 * @property {GalleryCarouselItemData} previousImage Image behind the current image
 * @property {string} currentTitle Item selected by the child carousel
 * @property {boolean} showSpinner Whether to display the loading spinner
 * @property {GalleryCarouselItemData} currentImage Image to fade in on top of the last image
 * @property {object} currentImageStyle Style object used for fade in effect on top image
 * @property {boolean} lazy Whether to lazy load the image. This is true for the initial image
 * and false after the user interacts with the carousel
 */

/**
 * Creates a carousel navigation for the gallery using their image titles
 * @class
 * @extends {React.Component<GalleryCarouselProps, GalleryCarouselState>}
 */var
gallery_carousel_GalleryCarousel = /*#__PURE__*/function (_React$Component) {gallery_carousel_inherits(GalleryCarousel, _React$Component);var _super = gallery_carousel_createSuper(GalleryCarousel);

















  /**
   * @param {GalleryCarouselProps} props
   */
  function GalleryCarousel(props) {var _this;gallery_carousel_classCallCheck(this, GalleryCarousel);
    _this = _super.call(this, props);gallery_carousel_defineProperty(gallery_carousel_assertThisInitialized(_this), "onChange",


































    function (imageId) {
      _this.setState({ currentTitle: imageId, lazy: false }, function () {
        var selectedImage = _this.getSelectedImage();
        if (selectedImage) {
          _this.loadImage(selectedImage.heroUrl);
        }
      });
    });gallery_carousel_defineProperty(gallery_carousel_assertThisInitialized(_this), "updateImages",


    function () {
      var currentImage = _this.state.currentImage;
      var selectedImage = _this.getSelectedImage();

      if (!selectedImage) {
        return;
      }

      clearTimeout(_this.showSpinnerTimeout);

      _this.setState({
        previousImage: currentImage || selectedImage,
        showSpinner: false,
        currentImage: selectedImage,
        currentImageStyle: { opacity: '0' }
      });

      clearTimeout(_this.styleTimeout);
      _this.styleTimeout = setTimeout(function () {
        _this.setState({ currentImageStyle: { opacity: '1', transition: 'opacity 0.3s' } });
      }, 100);
    });_this.showSpinnerTimeout = null;_this.styleTimeout = null; /** The image instance is used to load and cache images before we fade them into view */if (GalleryCarousel.imageConstructorExists()) {_this.image = new Image();_this.image.onload = _this.updateImages;_this.image.onerror = _this.updateImages;}_this.state = { previousImage: props.data[0] || null, currentTitle: props.data[0] ? props.data[0].id : null, showSpinner: false, currentImage: props.data[0] || null, currentImageStyle: {}, lazy: true };return _this;}gallery_carousel_createClass(GalleryCarousel, [{ key: "componentWillUnmount", value: function componentWillUnmount() {clearTimeout(this.showSpinnerTimeout);clearTimeout(this.styleTimeout);} }, { key: "getSelectedImage", value: function getSelectedImage() {var data = this.props.data;var currentTitle = this.state.currentTitle;return data.find(function (i) {return i.id === currentTitle;});} /**
     * @param {string} imageId
     */ }, { key: "loadImage", value:


    /**
     * Load a new image and fade it in on top of the previous one
     * @param {string} url
     */
    function loadImage(url) {var _this2 = this;
      clearTimeout(this.showSpinnerTimeout);
      this.showSpinnerTimeout = setTimeout(
      function () {return _this2.setState({ showSpinner: true });},
      GalleryCarousel.showSpinnerWait);

      this.image.src = '';
      this.image.src = url;
    } }, { key: "render", value:

    function render() {
      var _this$state =






        this.state,previousImage = _this$state.previousImage,currentImage = _this$state.currentImage,currentImageStyle = _this$state.currentImageStyle,currentTitle = _this$state.currentTitle,showSpinner = _this$state.showSpinner,lazy = _this$state.lazy;

      var data = this.props.data;

      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", {
          className: "GalleryCarousel" }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(gallery_carousel_gallery_carousel_nav, {
          onChange: this.onChange,
          currentTitle: currentTitle,
          data: data.map(GalleryCarousel.toCarouselImage) }), /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "hero-container" }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(gallery_carousel_gallery_carousel_hero, {
          image: previousImage,
          lazy: lazy,
          style: {} }), /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(gallery_carousel_gallery_carousel_hero, {
          image: currentImage,
          lazy: lazy,
          style: currentImageStyle })),

        showSpinner ? /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "loading" }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { id: "spinner" })) :

        null));


    } }], [{ key: "toCarouselImage", value: /**
     * Convert gallery image data to carousel image data
     * @param {GalleryCarouselItemData} image
     */function toCarouselImage(_ref) {var id = _ref.id,heroNavTitle = _ref.heroNavTitle;return { id: id, title: heroNavTitle };} }]);return GalleryCarousel;}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Component);gallery_carousel_defineProperty(gallery_carousel_GalleryCarousel, "windowExists", function () {return typeof window !== 'undefined';});gallery_carousel_defineProperty(gallery_carousel_GalleryCarousel, "imageConstructorExists", function () {return typeof Image !== 'undefined';});gallery_carousel_defineProperty(gallery_carousel_GalleryCarousel, "propTypes", { data: prop_types_default.a.arrayOf(imagePropType).isRequired });gallery_carousel_defineProperty(gallery_carousel_GalleryCarousel, "showSpinnerWait", 300);/* harmony default export */ var gallery_carousel_gallery_carousel = (gallery_carousel_GalleryCarousel);
// CONCATENATED MODULE: ./src/components/gallery-carousel/index.js


// EXTERNAL MODULE: ./src/components/checkbox.less
var components_checkbox = __webpack_require__(140);

// CONCATENATED MODULE: ./src/components/checkbox.jsx
function checkbox_extends() {checkbox_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return checkbox_extends.apply(this, arguments);}
 // eslint-disable-line




var checkbox_Checkbox = function Checkbox(props) {
  var name = props.input ? props.input.name : props.name;
  var value = props.input ? props.input.value : props.value;

  // Handle both redux-form controlled and non-react form controlled check boxes
  // if its not a redux-form controlled and you don't pass 'onChange' it does nothing
  var handleChange;
  if (props.input) {
    handleChange = props.input.onChange;
  } else if (props.onChange) {
    handleChange = function handleChange(event) {
      var target = event.target;
      props.onChange(target.type === 'checkbox' ? target.checked : target.value);
    };
  }

  /* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */
  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "Checkbox ".concat(name, " ").concat(props.className) }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("label", null, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("input", checkbox_extends({
      type: "checkbox" },
    props.input || props, {
      checked: value,
      onChange: handleChange })), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "box" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { id: "checkmark" })),

    props.label)));



};

checkbox_Checkbox.propTypes = {
  name: prop_types_default.a.string,
  onChange: prop_types_default.a.func,
  label: prop_types_default.a.string,
  value: prop_types_default.a.bool,
  input: prop_types_default.a.object, // eslint-disable-line
  className: prop_types_default.a.string
};

checkbox_Checkbox.defaultProps = {
  label: '',
  name: null,
  onChange: null,
  className: '',
  value: false
};

/* harmony default export */ var src_components_checkbox = (checkbox_Checkbox);
// EXTERNAL MODULE: ./src/components/tooltip.less
var tooltip = __webpack_require__(141);

// EXTERNAL MODULE: ./src/components/tooltip-rebrand.less
var tooltip_rebrand = __webpack_require__(142);

// CONCATENATED MODULE: ./src/components/tooltip.jsx

 // eslint-disable-line



var tooltip_Tooltip = function Tooltip(props) {return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "Tooltip uic ".concat(props.position) }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "tooltipContent" }, props.infoText), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "anchor ".concat(props.className) }, props.children)));};



tooltip_Tooltip.propTypes = {
  children: prop_types_default.a.oneOfType([
  prop_types_default.a.arrayOf(prop_types_default.a.node),
  prop_types_default.a.node]).
  isRequired,
  infoText: prop_types_default.a.oneOfType([
  prop_types_default.a.arrayOf(prop_types_default.a.node),
  prop_types_default.a.node,
  prop_types_default.a.string.isRequired]).
  isRequired,
  className: prop_types_default.a.string,
  position: prop_types_default.a.oneOf(['top', 'right', 'bottom', 'left'])
};

tooltip_Tooltip.defaultProps = {
  className: '',
  position: 'right'
};

/* harmony default export */ var components_tooltip = (tooltip_Tooltip);
// EXTERNAL MODULE: ./src/components/form-field.less
var form_field = __webpack_require__(143);

// EXTERNAL MODULE: ./src/components/form-field-rebrand.less
var form_field_rebrand = __webpack_require__(144);

// CONCATENATED MODULE: ./src/components/form-field.jsx










var form_field_FormField = function FormField(props) {
  var infoTooltip;
  if (props.infoText) {
    infoTooltip = /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_tooltip, {
      className: "infoText",
      placement: "right",
      trigger: ['hover', 'click'],
      mouseLeaveDelay: 0.3,
      infoText: props.infoText }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { id: "info" }));


  }
  var label = props.label ? /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "label" },
  props.label,
  infoTooltip) :

  null;

  var error;
  if (!lodash_default.a.get(props.meta, 'valid') && lodash_default.a.get(props.meta, 'touched')) {
    error = lodash_default.a.get(props.meta, 'error');
  }

  var classNames = classnames_default()('FormField uic', props.className, {
    hasError: !lodash_default.a.get(props.meta, 'valid') && lodash_default.a.get(props.meta, 'touched')
  });

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: classNames },
    label,
    props.children, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "error" }, error)));


};

form_field_FormField.propTypes = {
  label: prop_types_default.a.string,
  children: prop_types_default.a.oneOfType([
  prop_types_default.a.arrayOf(prop_types_default.a.node),
  prop_types_default.a.node]).
  isRequired,
  className: prop_types_default.a.string,
  meta: prop_types_default.a.shape({
    valid: prop_types_default.a.bool,
    error: prop_types_default.a.string,
    touched: prop_types_default.a.bool
  }),
  infoText: prop_types_default.a.string
};

form_field_FormField.defaultProps = {
  label: null,
  className: '',
  meta: {
    valid: true,
    error: null,
    touched: false
  },
  infoText: null
};

/* harmony default export */ var components_form_field = (form_field_FormField);
// EXTERNAL MODULE: external {"commonjs":"react-helmet","commonjs2":"react-helmet","amd":"ReactHelmet","root":"ReactHelmet"}
var external_commonjs_react_helmet_commonjs2_react_helmet_amd_ReactHelmet_root_ReactHelmet_ = __webpack_require__(8);
var external_commonjs_react_helmet_commonjs2_react_helmet_amd_ReactHelmet_root_ReactHelmet_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_react_helmet_commonjs2_react_helmet_amd_ReactHelmet_root_ReactHelmet_);

// EXTERNAL MODULE: ./src/components/hero-banner/hero-banner.less
var hero_banner = __webpack_require__(145);

// EXTERNAL MODULE: ./src/components/hero-banner/hero-banner-rebrand.less
var hero_banner_rebrand = __webpack_require__(146);

// CONCATENATED MODULE: ./src/components/hero-banner/hero-banner.jsx









/**
 * Helper for rendering Video element.
 */
var hero_banner_Videos = function Videos(_ref) {var
  videos = _ref.videos;return /*#__PURE__*/ (

    // display: 'none' by default, set to block in desktop media query
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("video", { playsInline: true, autoPlay: true, loop: "loop", muted: true, style: { display: 'none' } },
    videos.map(function (video) {return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("source", {
          key: video.fields.file.contentType,
          src: video.fields.file.url,
          type: video.fields.file.contentType }));})));};




hero_banner_Videos.propTypes = {
  videos: prop_types_default.a.arrayOf(prop_types_default.a.shape({}))
};

hero_banner_Videos.defaultProps = {
  videos: []
};

/**
 * HeroBanner for page heros.
 * Can have a background image and/or video (desktop only).
 */
var hero_banner_HeroBanner = function HeroBanner(_ref2)












{var backgroundImageMobile = _ref2.backgroundImageMobile,backgroundImage = _ref2.backgroundImage,backgroundImagePosition = _ref2.backgroundImagePosition,backgroundImagePositionMobile = _ref2.backgroundImagePositionMobile,className = _ref2.className,ctaButton = _ref2.ctaButton,displayOption = _ref2.displayOption,id = _ref2.id,showOverlay = _ref2.showOverlay,subtext = _ref2.subtext,title = _ref2.title,videos = _ref2.videos;
  // TODO make multiple bg images possible

  // Dangerously setting innerHtml because title comes from Contentful and want to allow markup
  // If we ever allow user or third party to provide this title, we must sanitize the input.
  // Doing this to allow <sup>'s to be used in the title element.
  // eslint-disable-next-line react/no-danger
  var Title = title ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("h1", { className: "title", dangerouslySetInnerHTML: { __html: title } }) : null;
  var SubText = subtext ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, { className: "subTitle", source: subtext }) : null;

  var Video = videos.length ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(hero_banner_Videos, { videos: videos }) : null;

  var overlay = showOverlay ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "overlay" }) : null;

  var heroBackgroundId = "heroBackground-".concat(id);

  var heroBackgroundClassNames = classnames_default()(
  'heroBackground',
  backgroundImagePosition, "".concat(
  backgroundImagePositionMobile, "-mobile"),
  { videoBackground: !!Video });


  var mobileImageStyle = backgroundImageMobile ? /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("style", null, "\n        @media only screen and (max-width: 770px) {\n          #".concat(


  heroBackgroundId, " {\n            background-image: url(").concat(
  backgroundImageMobile, "?w=800);\n          }\n        }\n    ")) :




  null;

  // Preload background image on mobile devices, falling back to desktop version
  // if no mobile version is provided
  var preloadedMobileImage = backgroundImageMobile ? "".concat(backgroundImageMobile, "?w=800") : backgroundImage;
  var preloadedMobileImageLink = preloadedMobileImage ? /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("link", { rel: "preload", href: preloadedMobileImage, as: "image", media: "(max-width: 770px)" }) :
  null;

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "HeroBanner uic fullWidth ".concat(displayOption || className) }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(external_commonjs_react_helmet_commonjs2_react_helmet_amd_ReactHelmet_root_ReactHelmet_default.a, null,
    preloadedMobileImageLink), /*#__PURE__*/

    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("style", null, "\n          #".concat(

    heroBackgroundId, " {\n            background-image: url(").concat(
    backgroundImage, ");\n          }\n        ")),



    mobileImageStyle, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: heroBackgroundClassNames, id: heroBackgroundId },
    Video), /*#__PURE__*/

    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "heroContent" },
    Title,
    SubText,
    ctaButton),

    overlay));


};

hero_banner_HeroBanner.propTypes = {
  backgroundImage: prop_types_default.a.string,
  backgroundImageMobile: prop_types_default.a.string,
  backgroundImagePosition: prop_types_default.a.string,
  backgroundImagePositionMobile: prop_types_default.a.string,
  className: prop_types_default.a.string,
  ctaButton: prop_types_default.a.node,
  displayOption: prop_types_default.a.string,
  id: prop_types_default.a.string,
  showOverlay: prop_types_default.a.bool,
  subtext: prop_types_default.a.string,
  title: prop_types_default.a.string,
  videos: prop_types_default.a.arrayOf(prop_types_default.a.object)
};

hero_banner_HeroBanner.defaultProps = {
  backgroundImage: null,
  backgroundImageMobile: null,
  backgroundImagePosition: 'alignCenter',
  backgroundImagePositionMobile: 'alignCenter',
  className: 'tall',
  id: null,
  ctaButton: null,
  displayOption: null,
  showOverlay: true,
  subtext: null,
  title: null,
  videos: []
};

/* harmony default export */ var hero_banner_hero_banner = (/*#__PURE__*/Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["memo"])(hero_banner_HeroBanner));
// CONCATENATED MODULE: ./src/components/hero-banner/index.js

// EXTERNAL MODULE: ./node_modules/smoothscroll-polyfill/dist/smoothscroll.js
var smoothscroll = __webpack_require__(42);
var smoothscroll_default = /*#__PURE__*/__webpack_require__.n(smoothscroll);

// EXTERNAL MODULE: ./src/components/horizontal-scroll/horizontal-scroll.less
var horizontal_scroll = __webpack_require__(147);

// EXTERNAL MODULE: ./src/components/horizontal-scroll/horizontal-scroll-rebrand.less
var horizontal_scroll_rebrand = __webpack_require__(148);

// CONCATENATED MODULE: ./src/components/horizontal-scroll/horizontal-scroll.jsx
function horizontal_scroll_typeof(obj) {"@babel/helpers - typeof";return horizontal_scroll_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, horizontal_scroll_typeof(obj);}function horizontal_scroll_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function horizontal_scroll_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function horizontal_scroll_createClass(Constructor, protoProps, staticProps) {if (protoProps) horizontal_scroll_defineProperties(Constructor.prototype, protoProps);if (staticProps) horizontal_scroll_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function horizontal_scroll_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) horizontal_scroll_setPrototypeOf(subClass, superClass);}function horizontal_scroll_setPrototypeOf(o, p) {horizontal_scroll_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return horizontal_scroll_setPrototypeOf(o, p);}function horizontal_scroll_createSuper(Derived) {var hasNativeReflectConstruct = horizontal_scroll_isNativeReflectConstruct();return function _createSuperInternal() {var Super = horizontal_scroll_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = horizontal_scroll_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return horizontal_scroll_possibleConstructorReturn(this, result);};}function horizontal_scroll_possibleConstructorReturn(self, call) {if (call && (horizontal_scroll_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return horizontal_scroll_assertThisInitialized(self);}function horizontal_scroll_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function horizontal_scroll_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function horizontal_scroll_getPrototypeOf(o) {horizontal_scroll_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return horizontal_scroll_getPrototypeOf(o);}function horizontal_scroll_defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}









/**
 * Horizontal Scroller that utilizes the native scroll behaviour and allows smooth scrolling
 * with smoothscroll polyfill. Horizontal Scroll makes a best guess for scroll distances by
 * dividing the total scroll area by the length of the children array passed. This works under the
 * assumption that children are equally sized and evenly spaced.
 */var
horizontal_scroll_HorizontalScroll = /*#__PURE__*/function (_Component) {horizontal_scroll_inherits(HorizontalScroll, _Component);var _super = horizontal_scroll_createSuper(HorizontalScroll);
  function HorizontalScroll(props) {var _this;horizontal_scroll_classCallCheck(this, HorizontalScroll);
    _this = _super.call(this, props);horizontal_scroll_defineProperty(horizontal_scroll_assertThisInitialized(_this), "setScrollRef",
















    function (scrollArea) {
      if (!scrollArea) return;
      _this.scrollArea = scrollArea;
      var _this$props = _this.props,children = _this$props.children,scrollStepMultiply = _this$props.scrollStepMultiply;
      // Make best guess for element widths: total scroll width / total number of children
      _this.scrollStepWidth = Math.ceil(scrollArea.scrollWidth / children.length) * scrollStepMultiply;
      _this.handleScroll();
    });_this.state = { showBackArrow: false, showForwardArrow: false };_this.moveBack = _this.moveBack.bind(horizontal_scroll_assertThisInitialized(_this));_this.moveForward = _this.moveForward.bind(horizontal_scroll_assertThisInitialized(_this));_this.handleScroll = _this.handleScroll.bind(horizontal_scroll_assertThisInitialized(_this));_this.throttledHandleScroll = lodash_default.a.throttle(_this.handleScroll, 200);return _this;}horizontal_scroll_createClass(HorizontalScroll, [{ key: "componentDidMount", value: function componentDidMount() {// polyfill smooth scrolling api
      // https://github.com/iamdustan/smoothscroll
      smoothscroll_default.a.polyfill();} }, { key: "moveBack", value: function moveBack() {
      this.scrollArea.scrollBy({
        top: 0,
        left: -1 * this.scrollStepWidth,
        behavior: 'smooth'
      });
    } }, { key: "moveForward", value:

    function moveForward() {
      this.scrollArea.scrollBy({
        top: 0,
        left: this.scrollStepWidth,
        behavior: 'smooth'
      });
    }

    /**
     * Throttled handle scroll. Is throttled in constructor.
     */ }, { key: "handleScroll", value:
    function handleScroll() {
      var _this$scrollArea = this.scrollArea,scrollWidth = _this$scrollArea.scrollWidth,scrollLeft = _this$scrollArea.scrollLeft,offsetWidth = _this$scrollArea.offsetWidth;
      var scrolledLeft = scrollLeft < 10;
      var scrolledRight = scrollLeft > scrollWidth - offsetWidth - 10;
      this.setState({
        showForwardArrow: !scrolledRight,
        showBackArrow: !scrolledLeft
      });
    } }, { key: "render", value:

    function render() {
      var _this$state = this.state,showBackArrow = _this$state.showBackArrow,showForwardArrow = _this$state.showForwardArrow;
      var showMobileArrows = this.props.showMobileArrows;

      var backArrow = /*#__PURE__*/
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", {
        className: classnames_default()('arrow back', { visible: showBackArrow }),
        onKeyPress: this.moveBack,
        onClick: this.moveBack,
        role: "button",
        tabIndex: "0" }, /*#__PURE__*/
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { id: "chevron-light" }));



      var forwardArrow = /*#__PURE__*/
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", {
        className: classnames_default()('arrow forward', { visible: showForwardArrow }),
        onKeyPress: this.moveForward,
        onClick: this.moveForward,
        role: "button",
        tabIndex: "0" }, /*#__PURE__*/
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { id: "chevron-light" }));



      var children = this.props.children;
      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: classnames_default()('HorizontalScroll uic fullWidth', { showMobileArrows: showMobileArrows }) }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { ref: this.setScrollRef, className: "scroll-content", onScroll: this.throttledHandleScroll },
        children),

        backArrow,
        forwardArrow));


    } }]);return HorizontalScroll;}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);



horizontal_scroll_HorizontalScroll.propTypes = {
  children: prop_types_default.a.node,
  showMobileArrows: prop_types_default.a.bool,
  scrollStepMultiply: prop_types_default.a.number
};

horizontal_scroll_HorizontalScroll.defaultProps = {
  children: null,
  showMobileArrows: false,
  scrollStepMultiply: 1
};

/* harmony default export */ var horizontal_scroll_horizontal_scroll = (horizontal_scroll_HorizontalScroll);
// CONCATENATED MODULE: ./src/components/horizontal-scroll/index.js

// CONCATENATED MODULE: ./node_modules/react-hammerjs/dist/react-hammerjs.es.js



var react_hammerjs_es_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function react_hammerjs_es_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function react_hammerjs_es_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function react_hammerjs_es_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// require('hammerjs') when in a browser. This is safe because Hammer is only
// invoked in componentDidMount, which is not executed on the server.
var Hammer = typeof window !== 'undefined' ? __webpack_require__(149) : undefined;

var privateProps = {
	children: true,
	direction: true,
	options: true,
	recognizeWith: true,
	vertical: true
};

/**
 * Hammer Component
 * ================
 */

var handlerToEvent = {
	action: 'tap press',
	onDoubleTap: 'doubletap',
	onPan: 'pan',
	onPanCancel: 'pancancel',
	onPanEnd: 'panend',
	onPanStart: 'panstart',
	onPinch: 'pinch',
	onPinchCancel: 'pinchcancel',
	onPinchEnd: 'pinchend',
	onPinchIn: 'pinchin',
	onPinchOut: 'pinchout',
	onPinchStart: 'pinchstart',
	onPress: 'press',
	onPressUp: 'pressup',
	onRotate: 'rotate',
	onRotateCancel: 'rotatecancel',
	onRotateEnd: 'rotateend',
	onRotateMove: 'rotatemove',
	onRotateStart: 'rotatestart',
	onSwipe: 'swipe',
	onSwipeRight: 'swiperight',
	onSwipeLeft: 'swipeleft',
	onSwipeUp: 'swipeup',
	onSwipeDown: 'swipedown',
	onTap: 'tap'
};

Object.keys(handlerToEvent).forEach(function (i) {
	privateProps[i] = true;
});

function updateHammer(hammer, props) {
	if (props.hasOwnProperty('vertical')) {
		console.warn('vertical is deprecated, please use `direction` instead');
	}

	var directionProp = props.direction;
	if (directionProp || props.hasOwnProperty('vertical')) {
		var direction = directionProp ? directionProp : props.vertical ? 'DIRECTION_ALL' : 'DIRECTION_HORIZONTAL';
		hammer.get('pan').set({ direction: Hammer[direction] });
		hammer.get('swipe').set({ direction: Hammer[direction] });
	}

	if (props.options) {
		Object.keys(props.options).forEach(function (option) {
			if (option === 'recognizers') {
				Object.keys(props.options.recognizers).forEach(function (gesture) {
					var recognizer = hammer.get(gesture);
					recognizer.set(props.options.recognizers[gesture]);
					if (props.options.recognizers[gesture].requireFailure) {
						recognizer.requireFailure(props.options.recognizers[gesture].requireFailure);
					}
				}, this);
			} else {
				var key = option;
				var optionObj = {};
				optionObj[key] = props.options[option];
				hammer.set(optionObj);
			}
		}, this);
	}

	if (props.recognizeWith) {
		Object.keys(props.recognizeWith).forEach(function (gesture) {
			var recognizer = hammer.get(gesture);
			recognizer.recognizeWith(props.recognizeWith[gesture]);
		}, this);
	}

	Object.keys(props).forEach(function (p) {
		var e = handlerToEvent[p];
		if (e) {
			hammer.off(e);
			hammer.on(e, props[p]);
		}
	});
}

var react_hammerjs_es_HammerComponent = function (_React$Component) {
	react_hammerjs_es_inherits(HammerComponent, _React$Component);

	function HammerComponent() {
		react_hammerjs_es_classCallCheck(this, HammerComponent);

		return react_hammerjs_es_possibleConstructorReturn(this, (HammerComponent.__proto__ || Object.getPrototypeOf(HammerComponent)).apply(this, arguments));
	}

	react_hammerjs_es_createClass(HammerComponent, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.hammer = new Hammer(this.domElement);
			updateHammer(this.hammer, this.props);
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			if (this.hammer) {
				updateHammer(this.hammer, this.props);
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (this.hammer) {
				this.hammer.stop();
				this.hammer.destroy();
			}
			this.hammer = null;
		}
	}, {
		key: 'render',
		value: function render() {
			var props = {};

			Object.keys(this.props).forEach(function (i) {
				if (!privateProps[i]) {
					props[i] = this.props[i];
				}
			}, this);

			var self = this;
			props.ref = function (domElement) {
				if (self.props.ref) {
					self.props.ref(domElement);
				}
				self.domElement = domElement;
			};

			// Reuse the child provided
			// This makes it flexible to use whatever element is wanted (div, ul, etc)
			return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.cloneElement(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Children.only(this.props.children), props);
		}
	}]);

	return HammerComponent;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Component);

react_hammerjs_es_HammerComponent.displayName = 'Hammer';
react_hammerjs_es_HammerComponent.propTypes = {
	className: prop_types_default.a.string
};

/* harmony default export */ var react_hammerjs_es = (react_hammerjs_es_HammerComponent);

// EXTERNAL MODULE: ./src/components/nav-carousel.less
var nav_carousel = __webpack_require__(150);

// EXTERNAL MODULE: ./src/components/nav-carousel-rebrand.less
var nav_carousel_rebrand = __webpack_require__(151);

// CONCATENATED MODULE: ./src/components/nav-carousel.jsx
function nav_carousel_typeof(obj) {"@babel/helpers - typeof";return nav_carousel_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, nav_carousel_typeof(obj);}function nav_carousel_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function nav_carousel_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function nav_carousel_createClass(Constructor, protoProps, staticProps) {if (protoProps) nav_carousel_defineProperties(Constructor.prototype, protoProps);if (staticProps) nav_carousel_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function nav_carousel_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) nav_carousel_setPrototypeOf(subClass, superClass);}function nav_carousel_setPrototypeOf(o, p) {nav_carousel_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return nav_carousel_setPrototypeOf(o, p);}function nav_carousel_createSuper(Derived) {var hasNativeReflectConstruct = nav_carousel_isNativeReflectConstruct();return function _createSuperInternal() {var Super = nav_carousel_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = nav_carousel_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return nav_carousel_possibleConstructorReturn(this, result);};}function nav_carousel_possibleConstructorReturn(self, call) {if (call && (nav_carousel_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return nav_carousel_assertThisInitialized(self);}function nav_carousel_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function nav_carousel_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function nav_carousel_getPrototypeOf(o) {nav_carousel_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return nav_carousel_getPrototypeOf(o);}function nav_carousel_defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}










/**
 * NavCarousel is a specialization of Carousel, but displaying named navigation buttons
 * above the sections.
 * The name in the navigation is the Title of the section, and then titles are hidden in
 * the contained sections to avoid weird duplication. The title hiding mechanism depends
 * on headerClass being configurable via component props.
 */var

nav_carousel_NavCarousel = /*#__PURE__*/function (_Carousel) {nav_carousel_inherits(NavCarousel, _Carousel);var _super = nav_carousel_createSuper(NavCarousel);
  function NavCarousel(props) {var _this;nav_carousel_classCallCheck(this, NavCarousel);
    _this = _super.call(this, props);nav_carousel_defineProperty(nav_carousel_assertThisInitialized(_this), "handleSwipe",



    function (event) {
      // react-hammerjs doesn't expose these constants as far as I can tell.
      if (event.direction === 2) {
        _this.moveBack();
      } else if (event.direction === 4) {
        _this.moveForward();
      }
    });nav_carousel_defineProperty(nav_carousel_assertThisInitialized(_this), "setHammerRef",

    function (hammer) {
      // on Hammer component mount
      if (hammer && hammer.domElement) {
        _this.navDiv = hammer.domElement;
        _this.navDiv.addEventListener('scroll', _this.updateScrollIndicators);
        _this.updateScrollIndicators();
      }
      // on Hammer component unmount
      if (!hammer && _this.navDiv) {
        _this.navDiv.removeEventListener('scroll', _this.updateScrollIndicators);
      }
    });nav_carousel_defineProperty(nav_carousel_assertThisInitialized(_this), "bindMoveTo",









































    function (index) {return function () {return _this.move(index);};});_this.updateScrollIndicators = _this.updateScrollIndicators.bind(nav_carousel_assertThisInitialized(_this));return _this;}nav_carousel_createClass(NavCarousel, [{ key: "updateScrollIndicators", value: function updateScrollIndicators() {// You cannot get a reference to navDiv directly because Hammer component overrides ref
      if (this.navDiv) {this.setState({ contentLeft: this.navDiv.scrollLeft > 0, contentRight: this.navDiv.scrollLeft < this.navDiv.scrollWidth - this.navDiv.offsetWidth });}} }, { key: "componentDidMount", value: function componentDidMount() {window.addEventListener('resize', this.updateScrollIndicators);this.updateScrollIndicators();} }, { key: "componentWillUnmount", value: function componentWillUnmount() {window.removeEventListener('resize', this.updateScrollIndicators);} }, { key: "componentDidUpdate", value: function componentDidUpdate(prevProps, prevState) {var currentButton = this.navButtonRefs && this.navButtonRefs[this.state.viewedIndex];if (currentButton && this.navDiv) {// This would be the perfect solution, but does not work in Safari
        // currentButton.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        // Instead, make sure the current selected button is scrolled into view if it changed
        if (this.state.viewedIndex !== prevState.viewedIndex) {// You cannot get a reference to navDiv directly because Hammer component overrides ref
          var currentButtonCenter = currentButton.offsetLeft + currentButton.offsetWidth / 2;this.navDiv.scrollLeft = currentButtonCenter - this.navDiv.offsetWidth / 2;this.updateScrollIndicators();}}} /**
     * Bind MoveTo function to specific index.
     * Returns a function bound to a specific index.
     */ }, { key: "render", value: function render() {var _this2 = this;var visibleChild = this.props.children[this.state.viewedIndex];this.navButtonRefs = []; // if the child component is using backgroundStyleClass in the section, then
      // the title is hidden within a wrapper, which can't have headerClass set on it.
      // TODO: STORE-2587 rewrite how backgroundStyleClass is handled for improved composablity
      if (visibleChild.type !== 'div') {// Override headerClass so we can hide it.
        visibleChild = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.cloneElement(visibleChild, { headerClass: 'subsection-header' });}
      var navigationButtons = [];
      for (var i = 0; i < this.props.children.length; i += 1) {
        var title = lodash_default.a.get(this.props, ['children', i, 'props', 'title']);
        // if the child component is using backgroundStyleClass in the section, then
        // the title is hidden within a wrapper
        if (!title) {
          title = lodash_default.a.get(this.props, ['children', i, 'props', 'children', 'props', 'title']);
        }

        // For widget system, Contentful fields are passed via model rather than spread to children.
        if (!title) {
          title = lodash_default.a.get(this.props, ['children', i, 'props', 'model', 'fields', 'title']);
        }

        navigationButtons.push( /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("button", {
          type: "button",
          ref: function ref(button) {return button && _this2.navButtonRefs.push(button);},
          key: "nav-".concat(i),
          onClick: this.bindMoveTo(i),
          className: "medium ".concat(this.state.viewedIndex === i ? 'selected' : '') },
        title));


      }

      var navClasses = classnames_default()('navWrapper', {
        contentLeft: this.state.contentLeft,
        contentRight: this.state.contentRight
      });

      // Unfortunately, Hammerjs doesn't seem to expose 'DIRECTION_HORIZONTAL' constants
      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "NavCarousel" }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: navClasses }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(react_hammerjs_es, {
          onSwipe: this.handleSwipe,
          direction: "DIRECTION_HORIZONTAL",
          ref: this.setHammerRef }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "navigation" }, navigationButtons))), /*#__PURE__*/


        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(ReactCSSTransitionReplace_default.a, {
          transitionName: "fade-wait",
          transitionEnterTimeout: 300,
          transitionLeaveTimeout: 300 },
        visibleChild)));



    } }]);return NavCarousel;}(components_carousel);


nav_carousel_NavCarousel.propTypes = {
  children: prop_types_default.a.arrayOf(prop_types_default.a.node).isRequired
};

/* harmony default export */ var components_nav_carousel = (nav_carousel_NavCarousel);
// EXTERNAL MODULE: ./node_modules/flat/index.js
var flat = __webpack_require__(21);
var flat_default = /*#__PURE__*/__webpack_require__.n(flat);

// CONCATENATED MODULE: ./src/util/analytics.js
function analytics_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function analytics_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? analytics_ownKeys(Object(source), !0).forEach(function (key) {analytics_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : analytics_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function analytics_defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;} /*
  Analytics Helpers
*/

/**
 * Log an event with GTM. Adds an event to the dataLayer that GTM knows how to log
 * to GA.
 * @param {String} eventName name of event
 * @param {Object} properties Object of associated data
 */
function gtmEvent(eventName, properties) {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(analytics_objectSpread(analytics_objectSpread({}, properties), {}, { event: eventName }));
  }
}

/**
 * Log an event with FullStory.
 * @param {String} eventName name of event
 * @param {Object} properties Object of associated data
 */
function fsEvent(eventName, properties) {
  if (typeof window !== 'undefined') {
    var _window = window,FS = _window.FS;
    if (FS && typeof FS.event === 'function') {
      FS.event(eventName, properties);
    }
  }
}

var segmentIsDefined = function segmentIsDefined() {return typeof window !== 'undefined' && window.analytics;};

/**
 * Identify a Segment user. Uses an auto-generated anonymous ID.
 * https://segment.com/docs/connections/spec/identify/
 * @param {object} [traits]
 */
function segmentIdentifyAnonymous(traits) {
  if (segmentIsDefined()) {
    window.analytics.identify(traits);
  }
}

/**
 * Send an event to Segment
 * https://segment.com/docs/connections/spec/track/
 * @param {string} event
 * @param {object} [properties]
 */
function segmentTrack(event, properties) {
  if (segmentIsDefined()) {
    window.analytics.track(event, properties);
  }
}

/* harmony default export */ var analytics = ({
  fsEvent: fsEvent,
  gtmEvent: gtmEvent,
  segmentIdentifyAnonymous: segmentIdentifyAnonymous,
  segmentTrack: segmentTrack
});
// CONCATENATED MODULE: ./src/components/mad-lib-email/mad-lib-context.jsx
function _slicedToArray(arr, i) {return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();}function _nonIterableRest() {throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);}function _arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}function _iterableToArrayLimit(arr, i) {var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];if (_i == null) return;var _arr = [];var _n = true;var _d = false;var _s, _e;try {for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"] != null) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}function _arrayWithHoles(arr) {if (Array.isArray(arr)) return arr;}


// Instantiate an empty context
var MadLibContext = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createContext([{}, function () {}, {}]);

/**
 * MadLibProvider is a React Context Provider. Children of this provider
 * will have access to this context by using MadLibContext.
 * MadLib works without MadLibProvider. Use MadLibProvider when you have multiple madlibs
 * on a page and want to hide all of them once one has completed.
 * @param {React Node} Children
 */
var mad_lib_context_MadLibProvider = function MadLibProvider(_ref)




{var children = _ref.children,attributions = _ref.attributions,segmentEnabled = _ref.segmentEnabled,googleDatastoreDisabled = _ref.googleDatastoreDisabled;
  var _useState = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useState"])(false),_useState2 = _slicedToArray(_useState, 2),madLibHidden = _useState2[0],setHideMadLib = _useState2[1];

  // helper function to hideMadLib
  function hideMadLib() {
    setHideMadLib(true);
  }

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(MadLibContext.Provider, {
      value: [
      madLibHidden,
      hideMadLib,
      attributions,
      segmentEnabled,
      googleDatastoreDisabled] },

    children));


};

mad_lib_context_MadLibProvider.propTypes = {
  children: prop_types_default.a.node,
  attributions: prop_types_default.a.shape({
    referralCode: prop_types_default.a.string,
    promoLink: prop_types_default.a.string
  }),
  segmentEnabled: prop_types_default.a.bool,
  googleDatastoreDisabled: prop_types_default.a.bool
};

mad_lib_context_MadLibProvider.defaultProps = {
  children: null,
  attributions: {},
  segmentEnabled: false,
  googleDatastoreDisabled: false
};


// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var react_modal_lib = __webpack_require__(22);
var react_modal_lib_default = /*#__PURE__*/__webpack_require__.n(react_modal_lib);

// EXTERNAL MODULE: ./src/components/vertical-scroll-box.less
var vertical_scroll_box = __webpack_require__(162);

// CONCATENATED MODULE: ./src/components/vertical-scroll-box.jsx
function vertical_scroll_box_typeof(obj) {"@babel/helpers - typeof";return vertical_scroll_box_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, vertical_scroll_box_typeof(obj);}function vertical_scroll_box_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function vertical_scroll_box_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function vertical_scroll_box_createClass(Constructor, protoProps, staticProps) {if (protoProps) vertical_scroll_box_defineProperties(Constructor.prototype, protoProps);if (staticProps) vertical_scroll_box_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function vertical_scroll_box_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) vertical_scroll_box_setPrototypeOf(subClass, superClass);}function vertical_scroll_box_setPrototypeOf(o, p) {vertical_scroll_box_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return vertical_scroll_box_setPrototypeOf(o, p);}function vertical_scroll_box_createSuper(Derived) {var hasNativeReflectConstruct = vertical_scroll_box_isNativeReflectConstruct();return function _createSuperInternal() {var Super = vertical_scroll_box_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = vertical_scroll_box_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return vertical_scroll_box_possibleConstructorReturn(this, result);};}function vertical_scroll_box_possibleConstructorReturn(self, call) {if (call && (vertical_scroll_box_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return vertical_scroll_box_assertThisInitialized(self);}function vertical_scroll_box_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function vertical_scroll_box_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function vertical_scroll_box_getPrototypeOf(o) {vertical_scroll_box_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return vertical_scroll_box_getPrototypeOf(o);}


/* eslint "react/prefer-stateless-function": 0 */
// Cannot be a stateless function because the DragDropContext needs an element ref



/*
  On render, will recalculate scroll indicators if the children length changes or if the
  optional updateKey property is not equal to the previous value.
 */var
vertical_scroll_box_VerticalScrollBox = /*#__PURE__*/function (_React$PureComponent) {vertical_scroll_box_inherits(VerticalScrollBox, _React$PureComponent);var _super = vertical_scroll_box_createSuper(VerticalScrollBox);
  function VerticalScrollBox(props) {var _this;vertical_scroll_box_classCallCheck(this, VerticalScrollBox);
    _this = _super.call(this, props);
    _this.state = {};
    _this.updateScrollIndicators = _this.updateScrollIndicators.bind(vertical_scroll_box_assertThisInitialized(_this));
    _this.scrollDidMount = _this.scrollDidMount.bind(vertical_scroll_box_assertThisInitialized(_this));
    _this.scrollBy = _this.scrollBy.bind(vertical_scroll_box_assertThisInitialized(_this));
    _this.scrollTo = _this.scrollTo.bind(vertical_scroll_box_assertThisInitialized(_this));
    _this.outerElementDidMount = _this.outerElementDidMount.bind(vertical_scroll_box_assertThisInitialized(_this));
    _this.scrollContentDidMount = _this.scrollContentDidMount.bind(vertical_scroll_box_assertThisInitialized(_this));
    _this.sizeContent = _this.sizeContent.bind(vertical_scroll_box_assertThisInitialized(_this));
    _this.sizeContentOnBodyAnimationEnd = _this.sizeContentOnBodyAnimationEnd.bind(vertical_scroll_box_assertThisInitialized(_this));return _this;
  }vertical_scroll_box_createClass(VerticalScrollBox, [{ key: "componentDidUpdate", value:

    function componentDidUpdate(oldProps) {
      var _this$props = this.props,children = _this$props.children,updateKey = _this$props.updateKey;
      if (oldProps.children.length !== children.length ||
      oldProps.updateKey !== updateKey)
      {
        this.sizeContent();
      } else {
        this.updateScrollIndicators();
      }
    } }, { key: "componentWillUnmount", value:

    function componentWillUnmount() {
      window.removeEventListener('resize', this.sizeContent);
      document.body.removeEventListener('animationend', this.sizeContentOnBodyAnimationEnd);
      document.body.removeEventListener('transitionend', this.sizeContentOnBodyAnimationEnd);
    } }, { key: "updateScrollIndicators", value:

    function updateScrollIndicators() {
      this.setState({
        contentUp: this.element.scrollTop > 0,
        contentDown: this.element.scrollTop < this.element.scrollHeight - this.element.offsetHeight
      });
    } }, { key: "scrollDidMount", value:

    function scrollDidMount(scroll) {
      var onScroll = this.props.onScroll;
      if (scroll) {
        this.element = scroll;
        scroll.addEventListener('scroll', this.updateScrollIndicators);
        if (onScroll) {
          scroll.addEventListener('scroll', onScroll);
        }
        this.updateScrollIndicators();
        window.addEventListener('resize', this.sizeContent);
      }
    } }, { key: "scrollBy", value:

    function scrollBy(offsetX, offsetY) {
      this.scrollTo(this.element.scrollTop + offsetY, this.element.scrollLeft + offsetX);
    } }, { key: "scrollTo", value:

    function scrollTo(x, y) {
      this.element.scrollTop = x;
      this.element.scrollLeft = y;
      this.updateScrollIndicators();
    } }, { key: "sizeContentOnBodyAnimationEnd", value:

    function sizeContentOnBodyAnimationEnd(e) {
      if (e.target && e.target.contains && e.target.contains(this.outerElement)) {
        this.sizeContent();
      }
    } }, { key: "outerElementDidMount", value:

    function outerElementDidMount(element) {
      this.outerElement = element;
      this.sizeContent();
      document.body.addEventListener('animationend', this.sizeContentOnBodyAnimationEnd);
      document.body.addEventListener('transitionend', this.sizeContentOnBodyAnimationEnd);
    } }, { key: "scrollContentDidMount", value:

    function scrollContentDidMount(element) {
      this.contentElement = element;
      this.sizeContent();
    } }, { key: "sizeContent", value:

    function sizeContent() {
      if (!this.outerElement || !this.contentElement) {
        return;
      }

      this.contentElement.style.width = "".concat(this.outerElement.offsetWidth, "px");
      this.outerElement.style.height = ''; // allow it to resize based on the css
      this.outerElement.style.height = "".concat(this.outerElement.offsetHeight, "px");
      this.updateScrollIndicators();
    } }, { key: "render", value:

    function render() {
      var _this$props2 =


        this.props,children = _this$props2.children,className = _this$props2.className;
      var _this$state =


        this.state,contentUp = _this$state.contentUp,contentDown = _this$state.contentDown;

      var classes = classnames_default()('ScrollBox', className, {
        contentUp: contentUp,
        contentDown: contentDown
      });

      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { ref: this.outerElementDidMount, className: classes }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { ref: this.scrollDidMount, className: "verticalScrollBox" }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { ref: this.scrollContentDidMount, className: "scroll-box-content" },
        children))));




    } }]);return VerticalScrollBox;}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.PureComponent);


vertical_scroll_box_VerticalScrollBox.propTypes = {
  className: prop_types_default.a.string,
  children: prop_types_default.a.node.isRequired,
  onScroll: prop_types_default.a.func,
  updateKey: prop_types_default.a.oneOfType([
  prop_types_default.a.string,
  prop_types_default.a.array,
  prop_types_default.a.bool,
  prop_types_default.a.node])

};

vertical_scroll_box_VerticalScrollBox.defaultProps = {
  className: null,
  onScroll: null,
  updateKey: null
};
// CONCATENATED MODULE: ./src/util/user-util.js

var userDisplayName = function userDisplayName(user) {
  if (user.nickname) {
    return "".concat(user.nickname);
  }
  if (user.first_name) {
    return "".concat(user.first_name, " ").concat(user.last_name[0] || '');
  }
  return user.email;
};
var userFullName = function userFullName(user) {
  if (user.first_name) {
    return "".concat(user.first_name, " ").concat(user.last_name);
  }
  return user.email;
};
// CONCATENATED MODULE: ./src/util/validate-name.js
var MAX_NAME_LENGTH = 50;
var punctuationRegex = /[!"#$%&'()*+,./:;<=>?@^_`{|}~\\]+/;

/**
 * validateName is used to validate names for forms. This prevents names from being too long
 * or containing illegal characters.  We introduced this in ecomm-front-end as a result of
 * someone phishing using our /create-account form.
 * @param {String} name Name to validate
 */
function validateName(name) {
  // Test name length
  // https://ux.stackexchange.com/a/55540
  if (name && name.length > MAX_NAME_LENGTH) {
    return 'Name must be 50 characters or less.';
  }

  // Test for punctuation
  // This same regex is checked in ecomm-core, see PRs for STORE-2790
  // See Facebook's Name Policy https://www.facebook.com/help/292517374180078
  if (punctuationRegex.test(name)) {
    return 'Punctuation not allowed.';
  }

  return null;
}
// CONCATENATED MODULE: ./src/util/react-root.js
var GF_REACT_ROOT = '_gf_react_root';
function react_root_getReactRoot() {
  if (typeof window !== 'undefined') {
    return window[GF_REACT_ROOT];
  }
  return null;
}
// CONCATENATED MODULE: ./src/util/index.js


// eslint-disable-next-line import/prefer-default-export
var userUtil = user_util_namespaceObject;





// EXTERNAL MODULE: ./src/components/dialog/dialog.less
var dialog = __webpack_require__(163);

// EXTERNAL MODULE: ./src/components/dialog/dialog-rebrand.less
var dialog_rebrand = __webpack_require__(164);

// CONCATENATED MODULE: ./src/components/dialog/dialog.jsx
function dialog_typeof(obj) {"@babel/helpers - typeof";return dialog_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, dialog_typeof(obj);}function dialog_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function dialog_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function dialog_createClass(Constructor, protoProps, staticProps) {if (protoProps) dialog_defineProperties(Constructor.prototype, protoProps);if (staticProps) dialog_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function dialog_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) dialog_setPrototypeOf(subClass, superClass);}function dialog_setPrototypeOf(o, p) {dialog_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return dialog_setPrototypeOf(o, p);}function dialog_createSuper(Derived) {var hasNativeReflectConstruct = dialog_isNativeReflectConstruct();return function _createSuperInternal() {var Super = dialog_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = dialog_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return dialog_possibleConstructorReturn(this, result);};}function dialog_possibleConstructorReturn(self, call) {if (call && (dialog_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return dialog_assertThisInitialized(self);}function dialog_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function dialog_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function dialog_getPrototypeOf(o) {dialog_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return dialog_getPrototypeOf(o);}










/**
 * A Modal/Dialog component.  Uses react-modal for the modal implementation.
 * This modal is controlled, so you must implement the logic for whether the modal is
 * open/closed in a wrapping component.  react-modal handles close logic and calls
 * onRequestClose when it determines the modal should close.
 *
 * This component was copied over from ecomm-front-end.
 * Conceptually, a Dialog differs from a Modal in that a Dialog has buttons.
 * Practically, our ui-common Modal implementation is very minimal and used in a few apps.
 * We should move towards this component as it has a more accessible modal implementation.
 *
 * To use this component, you must pass in a `reactRoot` prop or define `reactRoot` on the
 * window. See `../../util/react-root.jsx` for info on defining it.
 *
 * @param {Object} props - React props
 * @param {String} props.overlayClassName - Class for the overlay underneath the modal.
 * @param {String} props.className - Class applied to Modal component
 * @param {String} props.title - Title applied to top of Modal.
 * @param {Boolean} props.isOpen - Controls whether the Modal isOpen)
 * @param {Node} props.actionButtons - React node to render a row of action buttons at bottom
 * @param {Function} props.onRequestClose - Callback when react-modal decides the modal should close
 * @param {Boolean} props.withScrollBox - Includes the content inside a vertically scrolling box.
 * @param {Boolean} props.showTopRightCloseButton - Show an 'x' close button on top right.
 * @param {Boolean} props.shouldCloseOnOverlayClick - click overlay to close the modal (def. true)
 * @param {Boolean} props.shouldCloseOnEsc - If pressing the esc key should close the modal
 * @param {Boolean} props.withPadding - Give left and right padding to dialog content.
 * @param {String} props.reactRoot - This is a query selector for the id of the consuming app's
 *                                   React root element. ie '#root' or '#react'
 */
var dialog_Dialog = /*#__PURE__*/function (_React$Component) {dialog_inherits(Dialog, _React$Component);var _super = dialog_createSuper(Dialog);
  function Dialog(props) {var _this;dialog_classCallCheck(this, Dialog);
    _this = _super.call(this, props);
    if (typeof window !== 'undefined') {
      var reactRoot = _this.getReactRoot();
      // React Modal requires us to register the React root
      // For screenreaders - see Modal.setAppElement
      react_modal_lib_default.a.setAppElement(document.querySelector(reactRoot));
    }return _this;
  }

  // reactRoot passed as prop takes precedence over window
  dialog_createClass(Dialog, [{ key: "getReactRoot", value: function getReactRoot() {
      var reactRoot = this.props.reactRoot;
      return reactRoot || react_root_getReactRoot();
    } }, { key: "render", value:

    function render() {
      var _this$props =












        this.props,overlayClassName = _this$props.overlayClassName,className = _this$props.className,children = _this$props.children,title = _this$props.title,isOpen = _this$props.isOpen,actionButtons = _this$props.actionButtons,onRequestClose = _this$props.onRequestClose,withScrollBox = _this$props.withScrollBox,showTopRightCloseButton = _this$props.showTopRightCloseButton,shouldCloseOnOverlayClick = _this$props.shouldCloseOnOverlayClick,shouldCloseOnEsc = _this$props.shouldCloseOnEsc,withPadding = _this$props.withPadding;

      var content = withScrollBox ? /*#__PURE__*/
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(vertical_scroll_box_VerticalScrollBox, { updateKey: children },
      children) :

      children;
      var header = title ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("h3", { className: "h3" }, title) : null;
      var topRightCloseButton = showTopRightCloseButton ? /*#__PURE__*/
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("button", { type: "button", className: "close-button-top-right", onClick: onRequestClose }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { className: "dynamic", id: "close" })) :
      null;

      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(react_modal_lib_default.a, {
          className: classnames_default()('Dialog uic', className, { withPadding: withPadding, withScrollBox: withScrollBox }),
          overlayClassName: classnames_default()('dialogOverlay uic', overlayClassName),
          contentLabel: title,
          isOpen: isOpen,
          shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
          shouldCloseOnEsc: shouldCloseOnEsc,
          onRequestClose: onRequestClose },
        topRightCloseButton,
        header,
        content, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "actionButtons" }, actionButtons)));


    } }]);return Dialog;}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Component);


dialog_Dialog.propTypes = {
  className: prop_types_default.a.string,
  overlayClassName: prop_types_default.a.string,
  isOpen: prop_types_default.a.bool,
  title: prop_types_default.a.string,
  onRequestClose: prop_types_default.a.func,
  withScrollBox: prop_types_default.a.bool,
  showTopRightCloseButton: prop_types_default.a.bool,
  shouldCloseOnOverlayClick: prop_types_default.a.bool,
  shouldCloseOnEsc: prop_types_default.a.bool,
  children: prop_types_default.a.oneOfType([
  prop_types_default.a.arrayOf(prop_types_default.a.node),
  prop_types_default.a.node]).
  isRequired,
  actionButtons: prop_types_default.a.oneOfType([
  prop_types_default.a.arrayOf(prop_types_default.a.node),
  prop_types_default.a.node]),

  withPadding: prop_types_default.a.bool,
  reactRoot: prop_types_default.a.string
};

dialog_Dialog.defaultProps = {
  className: '',
  overlayClassName: '',
  isOpen: false,
  title: '',
  onRequestClose: null,
  withScrollBox: true,
  showTopRightCloseButton: true,
  shouldCloseOnOverlayClick: true,
  shouldCloseOnEsc: true,
  actionButtons: null,
  withPadding: false,
  reactRoot: null
};

/* harmony default export */ var dialog_dialog = (dialog_Dialog);
// CONCATENATED MODULE: ./src/components/dialog/index.js

// CONCATENATED MODULE: ./src/components/timed-reveal.jsx
function timed_reveal_typeof(obj) {"@babel/helpers - typeof";return timed_reveal_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, timed_reveal_typeof(obj);}function timed_reveal_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function timed_reveal_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function timed_reveal_createClass(Constructor, protoProps, staticProps) {if (protoProps) timed_reveal_defineProperties(Constructor.prototype, protoProps);if (staticProps) timed_reveal_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function timed_reveal_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) timed_reveal_setPrototypeOf(subClass, superClass);}function timed_reveal_setPrototypeOf(o, p) {timed_reveal_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return timed_reveal_setPrototypeOf(o, p);}function timed_reveal_createSuper(Derived) {var hasNativeReflectConstruct = timed_reveal_isNativeReflectConstruct();return function _createSuperInternal() {var Super = timed_reveal_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = timed_reveal_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return timed_reveal_possibleConstructorReturn(this, result);};}function timed_reveal_possibleConstructorReturn(self, call) {if (call && (timed_reveal_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return timed_reveal_assertThisInitialized(self);}function timed_reveal_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function timed_reveal_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function timed_reveal_getPrototypeOf(o) {timed_reveal_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return timed_reveal_getPrototypeOf(o);}


/**
 * TimedReveal is a component to show a component after a delay.
 * On SSR or pre-rendering, it returns null. The timer kicks in when
 * the component mounts on the client.
 *
 * Use like <TimedReveal delay={2000}>Text hidden for 2 seconds</div>
 *
 * @param {Object} props
 * @param {Node} props.children React children. This is what's hidden by TimedReveal
 * @param {Number} props.delay Delay is in milliseconds. Will show children after this time.
 * @param {Function} props.timeDoneCb Callback to tell when the timer is over
 */var
TimedReveal = /*#__PURE__*/function (_React$Component) {timed_reveal_inherits(TimedReveal, _React$Component);var _super = timed_reveal_createSuper(TimedReveal);
  function TimedReveal(props) {var _this;timed_reveal_classCallCheck(this, TimedReveal);
    _this = _super.call(this, props);
    _this.state = {
      timerDone: false
    };return _this;
  }timed_reveal_createClass(TimedReveal, [{ key: "componentDidMount", value:

    function componentDidMount() {var _this2 = this;
      var _this$props = this.props,delay = _this$props.delay,timerDoneCb = _this$props.timerDoneCb;
      this.timeout = setTimeout(function () {
        timerDoneCb();
        _this2.setState({
          timerDone: true
        });
      }, delay);
    } }, { key: "componentWillUnmount", value:

    function componentWillUnmount() {
      clearTimeout(this.timeout);
    } }, { key: "render", value:

    function render() {
      var timerDone = this.state.timerDone;
      var children = this.props.children;
      if (!timerDone) {
        return null;
      }
      return children;
    } }]);return TimedReveal;}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Component);


TimedReveal.propTypes = {
  children: prop_types_default.a.node.isRequired,
  delay: prop_types_default.a.number,
  timerDoneCb: prop_types_default.a.func
};

TimedReveal.defaultProps = {
  delay: 0,
  timerDoneCb: function timerDoneCb() {}
};

/* harmony default export */ var timed_reveal = (TimedReveal);
// EXTERNAL MODULE: external {"commonjs":"isomorphic-fetch","commonjs2":"isomorphic-fetch","amd":"IsomorphicFetch","root":"IsomorphicFetch"}
var external_commonjs_isomorphic_fetch_commonjs2_isomorphic_fetch_amd_IsomorphicFetch_root_IsomorphicFetch_ = __webpack_require__(165);

// CONCATENATED MODULE: ./src/components/mad-lib-email/mad-lib-util.js




/**
 * postEmail submits a users info to our backend that does two things:
 *  - signs them up in a SendGrid email list
 *  - adds their 'reason' answer to a database
 * See https://bitbucket.org/glowforge/gf-email-subscribe-function/ for more info.
 * @param {Object} body Body to be sent to email-subscribe-function
 */
var postEmail = function postEmail(endpoint, body) {return fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    mode: 'cors',
    body: JSON.stringify(body)
  });};

// Storage flag for tracking completion of mad lib
var STORAGE_FLAG = '_gf_mad_lib';

/**
 * Updates localStorage to track whether a user has completed the madlib.
 */
var setStorageFlag = function setStorageFlag() {
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.setItem(STORAGE_FLAG, new Date().toString());
  }
};

/**
 * Checks if user has storage flag.
 * @returns {Boolean} True if has cookie, false if not
 */
var hasStorageFlag = function hasStorageFlag() {
  if (typeof window !== 'undefined' && window.localStorage) {
    return !!window.localStorage.getItem(STORAGE_FLAG);
  }
  return false;
};

/**
 * Function to log to analytics when form is successfully submitted.
 */
function submitFormAnalytics() {
  var EVENT_NAME = 'madlib_email_submitted';
  gtmEvent(EVENT_NAME);
  fsEvent(EVENT_NAME);
}

function dismissedMaxTimesAnalytics() {
  var EVENT_NAME = 'madlib_dismissed_max_times';
  gtmEvent(EVENT_NAME);
  fsEvent(EVENT_NAME);
}

/**
 * Function to log to analytics that a user was shown the form.
 * Used to differentiate traffic between new users and those that
 * have already filled out the form.
 *
 * Is limited to one call, so we don't log this event multiple times.
 */
var shownFormAnalytics = lodash_default.a.once(function () {
  var EVENT_NAME = 'madlib_email_seen';
  gtmEvent(EVENT_NAME);
  fsEvent(EVENT_NAME);
});
// EXTERNAL MODULE: ./src/components/mad-lib-email/mad-lib-popup.less
var mad_lib_popup = __webpack_require__(166);

// CONCATENATED MODULE: ./src/components/mad-lib-email/mad-lib-popup.jsx
function mad_lib_popup_typeof(obj) {"@babel/helpers - typeof";return mad_lib_popup_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, mad_lib_popup_typeof(obj);}function mad_lib_popup_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function mad_lib_popup_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function mad_lib_popup_createClass(Constructor, protoProps, staticProps) {if (protoProps) mad_lib_popup_defineProperties(Constructor.prototype, protoProps);if (staticProps) mad_lib_popup_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function mad_lib_popup_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) mad_lib_popup_setPrototypeOf(subClass, superClass);}function mad_lib_popup_setPrototypeOf(o, p) {mad_lib_popup_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return mad_lib_popup_setPrototypeOf(o, p);}function mad_lib_popup_createSuper(Derived) {var hasNativeReflectConstruct = mad_lib_popup_isNativeReflectConstruct();return function _createSuperInternal() {var Super = mad_lib_popup_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = mad_lib_popup_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return mad_lib_popup_possibleConstructorReturn(this, result);};}function mad_lib_popup_possibleConstructorReturn(self, call) {if (call && (mad_lib_popup_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return mad_lib_popup_assertThisInitialized(self);}function mad_lib_popup_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function mad_lib_popup_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function mad_lib_popup_getPrototypeOf(o) {mad_lib_popup_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return mad_lib_popup_getPrototypeOf(o);}function mad_lib_popup_defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;} /* eslint-disable react/jsx-no-bind */










// Local storage keys
var DISMISSED_KEY = '_gf_mad_lib_dismissed_popup';
var LAST_RENDERED_KEY = '_gf_mad_lib_last_rendered_popup';
var DISMISSED_COUNT_KEY = '_gf_mad_lib_dismissed_popup_count';

/** MadLibPopUp is a controlled popup inside of MadLib. */var
mad_lib_popup_MadLibPopUp = /*#__PURE__*/function (_React$Component) {mad_lib_popup_inherits(MadLibPopUp, _React$Component);var _super = mad_lib_popup_createSuper(MadLibPopUp);















































































  /**
   * Create a popup
   * @param {Object} props - react props
   * @param {Node} props.children - React children
   * @param {Function} props.onClose - cb for onRequestClose
   * @param {String} props.id - Unique ID for popup
   * @param {Number} props.delay - Milliseconds of delay for popup
   * @param {Number} props.maxShowCount - Max number of times to show the popup
   * @param {Nubmer} props.showAgainAfterDays - Number of days to wait to show popup again
   * @returns {MadLibPopUp}
   */
  function MadLibPopUp(props) {var _this;mad_lib_popup_classCallCheck(this, MadLibPopUp);
    _this = _super.call(this, props);mad_lib_popup_defineProperty(mad_lib_popup_assertThisInitialized(_this), "closeDialog",













    function () {
      var _this$props = _this.props,onClose = _this$props.onClose,maxShowCount = _this$props.maxShowCount;
      if (lodash_default.a.isFunction(onClose)) {
        onClose();
      }
      _this.setState({ dismissed: true });
      MadLibPopUp.setDismissed(true);
      MadLibPopUp.incrementDismissedCount();
      if (MadLibPopUp.getDismissedCount() === maxShowCount) {
        dismissedMaxTimesAnalytics();
      }
    });_this.state = { dismissed: true };return _this;}mad_lib_popup_createClass(MadLibPopUp, [{ key: "componentDidMount", value: function componentDidMount() {if (this.shouldShowPopup()) {MadLibPopUp.setDismissed('false');this.setState({ dismissed: false });}MadLibPopUp.setLastRendered(Date.now());} }, { key: "shouldShowPopup", value:

    /**
     * If the user hasn't visited the site for a few days we want to show them this popup again.
     * There is a limit on the total number of times the popup will be displayed
     */
    function shouldShowPopup() {
      var _this$props2 = this.props,showAgainAfterDays = _this$props2.showAgainAfterDays,maxShowCount = _this$props2.maxShowCount;
      var msSinceLastRender = MadLibPopUp.getMsSinceLastRender();
      var dismissedCount = MadLibPopUp.getDismissedCount();
      var dismissed = MadLibPopUp.getDismissed();
      var msInDay = 1000 * 60 * 60 * 24;
      var daysSinceLastRender = msSinceLastRender / msInDay;

      if (dismissed && daysSinceLastRender > showAgainAfterDays && dismissedCount < maxShowCount) {
        return true;
      }

      return !dismissed;
    } }, { key: "render", value:

    function render() {
      var dismissed = this.state.dismissed;

      if (dismissed) {
        return null;
      }

      var _this$props3 =




        this.props,children = _this$props3.children,delay = _this$props3.delay,id = _this$props3.id,hiddenProp = _this$props3.hidden;

      var overlayClasses = classnames_default()("MadLibPopUp-dialogOverlay madlib-id-".concat(id), { hidden: hiddenProp });
      var popup = /*#__PURE__*/
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: classnames_default()('MadLibPopUp') }, /*#__PURE__*/
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(dialog_dialog, {
        overlayClassName: overlayClasses,
        className: "MadLibPopUp-Dialog madlib-id-".concat(id),
        onRequestClose: this.closeDialog,
        withScrollBox: false,
        showTopRightCloseButton: true,
        withPadding: true,
        isOpen: true },
      children));



      if (delay) {
        return /*#__PURE__*/(
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(timed_reveal, { delay: delay },
          popup));


      }
      return popup;
    } }], [{ key: "hasLocalStorage", value: function hasLocalStorage() {return !!(typeof window !== 'undefined' && window.localStorage);} }, { key: "getItem", value: function getItem(key, defaultValue) {if (!MadLibPopUp.hasLocalStorage()) {return defaultValue || null;}return window.localStorage.getItem(key) || defaultValue || null;} }, { key: "setItem", value: function setItem(key, value) {if (!MadLibPopUp.hasLocalStorage()) {return;}window.localStorage.setItem(key, value);} }, { key: "getNumberFromLocalStorage", value: function getNumberFromLocalStorage(key, defaultValue) {var value = MadLibPopUp.getItem(key);if (value === null) {return defaultValue;}var valueAsNumber = parseFloat(value, 10); // eslint-disable-next-line no-restricted-globals
      if (isNaN(valueAsNumber)) {return defaultValue;}return valueAsNumber;} }, { key: "getMsSinceLastRender", value: function getMsSinceLastRender() {var lastRenderedNumber = MadLibPopUp.getNumberFromLocalStorage(LAST_RENDERED_KEY, 0);return Date.now() - lastRenderedNumber;} }, { key: "setDismissedCount", value: function setDismissedCount(dismissedCount) {MadLibPopUp.setItem(DISMISSED_COUNT_KEY, dismissedCount);} }, { key: "getDismissedCount", value: function getDismissedCount() {return MadLibPopUp.getNumberFromLocalStorage(DISMISSED_COUNT_KEY, 0);} }, { key: "setDismissed", value: function setDismissed(dismissed) {MadLibPopUp.setItem(DISMISSED_KEY, dismissed);} }, { key: "getDismissed", value: function getDismissed() {return MadLibPopUp.getItem(DISMISSED_KEY, 'false') === 'true';} }, { key: "incrementDismissedCount", value: function incrementDismissedCount() {MadLibPopUp.setDismissedCount(MadLibPopUp.getDismissedCount() + 1);} }]);return MadLibPopUp;}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Component);mad_lib_popup_defineProperty(mad_lib_popup_MadLibPopUp, "propTypes", { showAgainAfterDays: prop_types_default.a.number, maxShowCount: prop_types_default.a.number, children: prop_types_default.a.node.isRequired, id: prop_types_default.a.string, delay: prop_types_default.a.number, onClose: prop_types_default.a.func, hidden: prop_types_default.a.bool });mad_lib_popup_defineProperty(mad_lib_popup_MadLibPopUp, "defaultProps", { showAgainAfterDays: 3, maxShowCount: 3, id: '', delay: 0, onClose: function onClose() {}, hidden: false });mad_lib_popup_defineProperty(mad_lib_popup_MadLibPopUp, "setLastRendered", function (lastRendered) {mad_lib_popup_MadLibPopUp.setItem(LAST_RENDERED_KEY, lastRendered);});

/* harmony default export */ var mad_lib_email_mad_lib_popup = (mad_lib_popup_MadLibPopUp);
// EXTERNAL MODULE: ./src/components/mad-lib-email/mad-lib.less
var mad_lib = __webpack_require__(167);

// CONCATENATED MODULE: ./src/components/mad-lib-email/mad-lib.jsx
function mad_lib_typeof(obj) {"@babel/helpers - typeof";return mad_lib_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, mad_lib_typeof(obj);}function mad_lib_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function mad_lib_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? mad_lib_ownKeys(Object(source), !0).forEach(function (key) {mad_lib_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : mad_lib_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function mad_lib_slicedToArray(arr, i) {return mad_lib_arrayWithHoles(arr) || mad_lib_iterableToArrayLimit(arr, i) || mad_lib_unsupportedIterableToArray(arr, i) || mad_lib_nonIterableRest();}function mad_lib_nonIterableRest() {throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function mad_lib_unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return mad_lib_arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mad_lib_arrayLikeToArray(o, minLen);}function mad_lib_arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}function mad_lib_iterableToArrayLimit(arr, i) {var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];if (_i == null) return;var _arr = [];var _n = true;var _d = false;var _s, _e;try {for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"] != null) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}function mad_lib_arrayWithHoles(arr) {if (Array.isArray(arr)) return arr;}function mad_lib_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function mad_lib_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function mad_lib_createClass(Constructor, protoProps, staticProps) {if (protoProps) mad_lib_defineProperties(Constructor.prototype, protoProps);if (staticProps) mad_lib_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function mad_lib_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) mad_lib_setPrototypeOf(subClass, superClass);}function mad_lib_setPrototypeOf(o, p) {mad_lib_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return mad_lib_setPrototypeOf(o, p);}function mad_lib_createSuper(Derived) {var hasNativeReflectConstruct = mad_lib_isNativeReflectConstruct();return function _createSuperInternal() {var Super = mad_lib_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = mad_lib_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return mad_lib_possibleConstructorReturn(this, result);};}function mad_lib_possibleConstructorReturn(self, call) {if (call && (mad_lib_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return mad_lib_assertThisInitialized(self);}function mad_lib_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function mad_lib_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function mad_lib_getPrototypeOf(o) {mad_lib_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return mad_lib_getPrototypeOf(o);}function mad_lib_defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}











/**
 * MadLib is implemented as a list element. It's tightly coupled with MadLibForm,
 * which it expects as children. We copy them and pass onSubmit and onCancel as props.
 * @param {Object} props - React props
 * @param {Boolean} props.alwaysShow
 *                  This is for development purposes. If always show is true, it will ignore the
 *                  cookie that is set.
 * @param {Array} props.children
 *                  Children are expected to be MadLibForm components. This can be done via
 *                  Contentful by creating a list of type MadLib, and populating the list with
 *                  MadLibForm list items.
 * @param {Number} props.delay
 *                  When props.popup is true, this is the amount in milliseconds that the popup is
 *                  delayed.
 * @param {String} props.endpoint
 *                  Endpoint to submit form values to. This is for development purposes, as we
 *                  expect a global GF_MADLIB_ENDPOINT to exist.
 * @param {Boolean} props.popup
 *                  When true, will render MadLib in a popup
 * @param {String} props.id Used to log info about which version we are using in Contentful.
 * @param {Number} props.showAgainAfterDays Number of days to wait before showing the popup again
 *                 after it is dismissed.
 * @param {Number} props.maxShowCount Maximum number of times to show the mad lib to a user.
 */var
mad_lib_MadLib = /*#__PURE__*/function (_React$Component) {mad_lib_inherits(MadLib, _React$Component);var _super = mad_lib_createSuper(MadLib);


  function MadLib(props) {var _this;mad_lib_classCallCheck(this, MadLib);
    _this = _super.call(this, props);mad_lib_defineProperty(mad_lib_assertThisInitialized(_this), "getEndpoint",











    function () {
      var endpoint = _this.props.endpoint;
      if (!endpoint) {
        return typeof window !== 'undefined' && window.GF_MADLIB_ENDPOINT;
      }
      return endpoint;
    });mad_lib_defineProperty(mad_lib_assertThisInitialized(_this), "onSubmit",







    function (values) {
      var _this$context = mad_lib_slicedToArray(_this.context, 5),segmentEnabled = _this$context[3],googleDatastoreDisabled = _this$context[4];

      if (segmentEnabled) {
        _this.sendToSegment(values);
      }

      if (!googleDatastoreDisabled) {
        _this.sendToGoogleDatastore(values);
      }

      // immediately setState and change screen.
      // Optimistically moving through the form
      _this.setState(function (state) {return {
          email: values.email || state.email,
          name: values.name || state.name
        };});
      _this.nextScreen();
      submitFormAnalytics();
      _this.setFlag();
    });mad_lib_defineProperty(mad_lib_assertThisInitialized(_this), "sendToGoogleDatastore",

















    function (values) {
      /* eslint-disable react/destructuring-assignment */
      /* eslint-disable prefer-destructuring */
      var email = values.email || _this.state.email;
      var name = values.name || _this.state.name;
      var info = values.info;

      // If segment info, submit that too
      var segment = lodash_default.a.isString(values.segment) ? [values.segment] : lodash_default.a.keys(values.segment);
      segment = segment.length ? segment : undefined;
      var segmentOther = values.segmentOther || undefined;

      var endpoint = _this.getEndpoint();

      // log URL and ID for more analytics around madlib
      var url = window.location.href;
      var id = _this.props.id;

      // Capture the number of times the popup was dismissed
      var popupDismissedCount = mad_lib_email_mad_lib_popup.getDismissedCount();

      var _this$context2 = mad_lib_slicedToArray(_this.context, 3),attributions = _this$context2[2];

      postEmail(endpoint, mad_lib_objectSpread({
        email: email,
        name: name,
        info: info,
        url: url,
        id: id,
        segment: segment,
        segmentOther: segmentOther,
        popupDismissedCount: popupDismissedCount },
      attributions));

    });mad_lib_defineProperty(mad_lib_assertThisInitialized(_this), "sendToSegment",





    function (values) {
      var _this$context3 = mad_lib_slicedToArray(_this.context, 3),attributions = _this$context3[2];
      var id = _this.props.id;
      var screen = _this.state.screen;
      var popupDismissedCount = mad_lib_email_mad_lib_popup.getDismissedCount();

      // Avoid sending empty values to Segment
      var segmentFormValues = lodash_default.a.omitBy(values, lodash_default.a.isEmpty);
      var flattenOptions = { delimiter: '_' };

      // Add form responses to user traits
      segmentIdentifyAnonymous(segmentFormValues);

      // MadLib forms of type `email` will have an email address and name in their
      // form data. We send an event with a special name for this type of form so
      // it can be handled differently by downstream destinations
      if (segmentFormValues.email) {
        segmentTrack('madlib_email_submitted', flat_default()(mad_lib_objectSpread({
          id: id,
          screen: screen,
          popupDismissedCount: popupDismissedCount,
          attributions: attributions },
        segmentFormValues),
        flattenOptions));
      } else {
        // If this is not an `email` form, send all of the form values to
        // Segment.
        segmentTrack('madlib_form_submitted', flat_default()({
          id: id,
          screen: screen,
          formValues: segmentFormValues
        }, flattenOptions));
      }
    });mad_lib_defineProperty(mad_lib_assertThisInitialized(_this), "nextScreen",





    function () {
      _this.setState(function (state) {return {
          screen: state.screen + 1
        };});
    });mad_lib_defineProperty(mad_lib_assertThisInitialized(_this), "shouldHideComponent",




    function () {
      // debugging purposes
      if (_this.props.alwaysShow) {
        return false;
      }
      // if we have no endpoint, don't show the madlib
      if (!_this.getEndpoint()) {
        return true;
      }
      // if there is a flag in local storage, and that flag was not added this flow
      if (hasStorageFlag() && !_this.state.completedThisFlow) {
        return true;
      }

      // When there are multiple MadLibs on the page, this context allows them
      // to share a hidden flag so completing one hides the others;
      var _this$context4 = mad_lib_slicedToArray(_this.context, 1),madLibHidden = _this$context4[0];
      // Also ensure that the flag was not added to this instance of the Mad Lib this flow.
      if (madLibHidden === true && !_this.state.completedThisFlow) {
        return true;
      }

      // we don't hide by default, return false
      return false;
    });_this.state = { screen: 0, completedThisFlow: false };return _this;} /**
   * Endpoint can be passed as a prop for debugging purposes.
   * Otherwise, it should be defined globally.
   * Todo: Pass in via context?
   */mad_lib_createClass(MadLib, [{ key: "setFlag", value: /**
     * Set flag and state for successful submission.
     */function setFlag() {setStorageFlag();this.setState({ completedThisFlow: true });var _this$context5 = mad_lib_slicedToArray(this.context, 2),setHideMadLib = _this$context5[1];setHideMadLib();} /**
     * Submit form values to Google Datastore
     * @param {object} values
     */ }, { key: "render", value: function render() {var _this$props =

        this.props,children = _this$props.children,delay = _this$props.delay,popup = _this$props.popup,id = _this$props.id,hidden = _this$props.hidden,showAgainAfterDays = _this$props.showAgainAfterDays,maxShowCount = _this$props.maxShowCount;
      var screen = this.state.screen;

      var childrenArray = external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Children.toArray(children);
      var child = childrenArray[screen];

      if (!child || this.shouldHideComponent()) {
        // Finished, render nothing
        return null;
      }

      // calling shownFormAnalytics here because of conditional rendering.
      // this func is implented so it can only be called once
      shownFormAnalytics();

      // Pass callbacks to child
      // cloning elements because this allows us to use <sections /> to map contentful data
      // to the MadLibForm. Thus, here we only need to pass callbacks.
      // className is passed to uniquely identify screen for analytics
      var clone = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.cloneElement(child, {
        className: "screen-".concat(screen),
        onSubmit: this.onSubmit,
        onCancel: this.nextScreen
      });

      if (popup) {
        return /*#__PURE__*/(
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(mad_lib_email_mad_lib_popup, {
            hidden: hidden,
            id: id,
            delay: delay,
            onClose: this.cancelFlow,
            showAgainAfterDays: showAgainAfterDays,
            maxShowCount: maxShowCount },
          clone));


      }

      var names = classnames_default()('MadLib-wrapper', "madlib-id-".concat(id), { hidden: hidden });
      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: names },
        clone));


    } }]);return MadLib;}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Component);mad_lib_defineProperty(mad_lib_MadLib, "contextType", MadLibContext);


mad_lib_MadLib.propTypes = {
  alwaysShow: prop_types_default.a.bool,
  children: prop_types_default.a.node,
  delay: prop_types_default.a.number,
  endpoint: prop_types_default.a.string,
  popup: prop_types_default.a.bool,
  id: prop_types_default.a.string,
  hidden: prop_types_default.a.bool,
  showAgainAfterDays: prop_types_default.a.number,
  maxShowCount: prop_types_default.a.number
};

mad_lib_MadLib.defaultProps = {
  alwaysShow: false,
  children: null,
  delay: null,
  endpoint: null,
  popup: false,
  id: '',
  hidden: false,
  showAgainAfterDays: 3,
  maxShowCount: 3
};

/* harmony default export */ var mad_lib_email_mad_lib = (mad_lib_MadLib);
// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}

// EXTERNAL MODULE: ./node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__(14);
var react_fast_compare_default = /*#__PURE__*/__webpack_require__.n(react_fast_compare);

// CONCATENATED MODULE: ./node_modules/deepmerge/dist/es.js
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ var es = (deepmerge_1);

// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(23);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);

// EXTERNAL MODULE: ./node_modules/create-react-context/lib/index.js
var create_react_context_lib = __webpack_require__(43);
var create_react_context_lib_default = /*#__PURE__*/__webpack_require__.n(create_react_context_lib);

// CONCATENATED MODULE: ./node_modules/tiny-warning/dist/tiny-warning.esm.js
var isProduction = "development" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ var tiny_warning_esm = (warning);

// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheClear.js
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ var _listCacheClear = (listCacheClear);

// CONCATENATED MODULE: ./node_modules/lodash-es/eq.js
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ var lodash_es_eq = (eq);

// CONCATENATED MODULE: ./node_modules/lodash-es/_assocIndexOf.js


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (lodash_es_eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ var _assocIndexOf = (assocIndexOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheDelete.js


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ var _listCacheDelete = (listCacheDelete);

// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheGet.js


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ var _listCacheGet = (listCacheGet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheHas.js


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

/* harmony default export */ var _listCacheHas = (listCacheHas);

// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheSet.js


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ var _listCacheSet = (listCacheSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_ListCache.js






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

/* harmony default export */ var _ListCache = (ListCache);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stackClear.js


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

/* harmony default export */ var _stackClear = (stackClear);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stackDelete.js
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ var _stackDelete = (stackDelete);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stackGet.js
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ var _stackGet = (stackGet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stackHas.js
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ var _stackHas = (stackHas);

// EXTERNAL MODULE: ./node_modules/lodash-es/_root.js
var _root = __webpack_require__(4);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Symbol.js


/** Built-in value references. */
var _Symbol_Symbol = _root["a" /* default */].Symbol;

/* harmony default export */ var _Symbol = (_Symbol_Symbol);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ var _getRawTag = (getRawTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString = (objectToString);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (_baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

/* harmony default export */ var _baseGetTag = (baseGetTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/isObject.js
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ var lodash_es_isObject = (isObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/isFunction.js



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!lodash_es_isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ var lodash_es_isFunction = (isFunction);

// CONCATENATED MODULE: ./node_modules/lodash-es/_coreJsData.js


/** Used to detect overreaching core-js shims. */
var coreJsData = _root["a" /* default */]['__core-js_shared__'];

/* harmony default export */ var _coreJsData = (coreJsData);

// CONCATENATED MODULE: ./node_modules/lodash-es/_isMasked.js


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ var _isMasked = (isMasked);

// CONCATENATED MODULE: ./node_modules/lodash-es/_toSource.js
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ var _toSource = (toSource);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsNative.js





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var _baseIsNative_funcProto = Function.prototype,
    _baseIsNative_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var _baseIsNative_funcToString = _baseIsNative_funcProto.toString;

/** Used to check objects for own properties. */
var _baseIsNative_hasOwnProperty = _baseIsNative_objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  _baseIsNative_funcToString.call(_baseIsNative_hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!lodash_es_isObject(value) || _isMasked(value)) {
    return false;
  }
  var pattern = lodash_es_isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

/* harmony default export */ var _baseIsNative = (baseIsNative);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getValue.js
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ var _getValue = (getValue);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getNative.js



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

/* harmony default export */ var _getNative = (getNative);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Map.js



/* Built-in method references that are verified to be native. */
var _Map_Map = _getNative(_root["a" /* default */], 'Map');

/* harmony default export */ var _Map = (_Map_Map);

// CONCATENATED MODULE: ./node_modules/lodash-es/_nativeCreate.js


/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

/* harmony default export */ var _nativeCreate = (nativeCreate);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hashClear.js


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

/* harmony default export */ var _hashClear = (hashClear);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hashDelete.js
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _hashDelete = (hashDelete);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hashGet.js


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var _hashGet_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashGet_hasOwnProperty = _hashGet_objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return _hashGet_hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ var _hashGet = (hashGet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hashHas.js


/** Used for built-in method references. */
var _hashHas_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashHas_hasOwnProperty = _hashHas_objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : _hashHas_hasOwnProperty.call(data, key);
}

/* harmony default export */ var _hashHas = (hashHas);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hashSet.js


/** Used to stand-in for `undefined` hash values. */
var _hashSet_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? _hashSet_HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ var _hashSet = (hashSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Hash.js






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

/* harmony default export */ var _Hash = (Hash);

// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheClear.js




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

/* harmony default export */ var _mapCacheClear = (mapCacheClear);

// CONCATENATED MODULE: ./node_modules/lodash-es/_isKeyable.js
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ var _isKeyable = (isKeyable);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getMapData.js


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ var _getMapData = (getMapData);

// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheDelete.js


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _mapCacheDelete = (mapCacheDelete);

// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheGet.js


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

/* harmony default export */ var _mapCacheGet = (mapCacheGet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheHas.js


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

/* harmony default export */ var _mapCacheHas = (mapCacheHas);

// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheSet.js


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ var _mapCacheSet = (mapCacheSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_MapCache.js






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

/* harmony default export */ var _MapCache = (MapCache);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stackSet.js




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ var _stackSet = (stackSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Stack.js







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

/* harmony default export */ var _Stack = (Stack);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayEach.js
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ var _arrayEach = (arrayEach);

// CONCATENATED MODULE: ./node_modules/lodash-es/_defineProperty.js


var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ var lodash_es_defineProperty = (defineProperty);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseAssignValue.js


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && lodash_es_defineProperty) {
    lodash_es_defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ var _baseAssignValue = (baseAssignValue);

// CONCATENATED MODULE: ./node_modules/lodash-es/_assignValue.js



/** Used for built-in method references. */
var _assignValue_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _assignValue_hasOwnProperty = _assignValue_objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(_assignValue_hasOwnProperty.call(object, key) && lodash_es_eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

/* harmony default export */ var _assignValue = (assignValue);

// CONCATENATED MODULE: ./node_modules/lodash-es/_copyObject.js



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ var _copyObject = (copyObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseTimes.js
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ var _baseTimes = (baseTimes);

// CONCATENATED MODULE: ./node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ var lodash_es_isObjectLike = (isObjectLike);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsArguments.js



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return lodash_es_isObjectLike(value) && _baseGetTag(value) == argsTag;
}

/* harmony default export */ var _baseIsArguments = (baseIsArguments);

// CONCATENATED MODULE: ./node_modules/lodash-es/isArguments.js



/** Used for built-in method references. */
var isArguments_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var isArguments_hasOwnProperty = isArguments_objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = isArguments_objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return lodash_es_isObjectLike(value) && isArguments_hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ var lodash_es_isArguments = (isArguments);

// CONCATENATED MODULE: ./node_modules/lodash-es/isArray.js
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ var lodash_es_isArray = (isArray);

// EXTERNAL MODULE: ./node_modules/lodash-es/isBuffer.js
var isBuffer = __webpack_require__(13);

// CONCATENATED MODULE: ./node_modules/lodash-es/_isIndex.js
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ var _isIndex = (isIndex);

// CONCATENATED MODULE: ./node_modules/lodash-es/isLength.js
/** Used as references for various `Number` constants. */
var isLength_MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= isLength_MAX_SAFE_INTEGER;
}

/* harmony default export */ var lodash_es_isLength = (isLength);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsTypedArray.js




/** `Object#toString` result references. */
var _baseIsTypedArray_argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    _baseIsTypedArray_funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[_baseIsTypedArray_argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[_baseIsTypedArray_funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return lodash_es_isObjectLike(value) &&
    lodash_es_isLength(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

/* harmony default export */ var _baseIsTypedArray = (baseIsTypedArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseUnary.js
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ var _baseUnary = (baseUnary);

// EXTERNAL MODULE: ./node_modules/lodash-es/_nodeUtil.js
var _nodeUtil = __webpack_require__(6);

// CONCATENATED MODULE: ./node_modules/lodash-es/isTypedArray.js




/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

/* harmony default export */ var lodash_es_isTypedArray = (isTypedArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayLikeKeys.js







/** Used for built-in method references. */
var _arrayLikeKeys_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _arrayLikeKeys_hasOwnProperty = _arrayLikeKeys_objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = lodash_es_isArray(value),
      isArg = !isArr && lodash_es_isArguments(value),
      isBuff = !isArr && !isArg && Object(isBuffer["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && lodash_es_isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || _arrayLikeKeys_hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _arrayLikeKeys = (arrayLikeKeys);

// CONCATENATED MODULE: ./node_modules/lodash-es/_isPrototype.js
/** Used for built-in method references. */
var _isPrototype_objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || _isPrototype_objectProto;

  return value === proto;
}

/* harmony default export */ var _isPrototype = (isPrototype);

// CONCATENATED MODULE: ./node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ var _overArg = (overArg);

// CONCATENATED MODULE: ./node_modules/lodash-es/_nativeKeys.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

/* harmony default export */ var _nativeKeys = (nativeKeys);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseKeys.js



/** Used for built-in method references. */
var _baseKeys_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeys_hasOwnProperty = _baseKeys_objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (_baseKeys_hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _baseKeys = (baseKeys);

// CONCATENATED MODULE: ./node_modules/lodash-es/isArrayLike.js



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && lodash_es_isLength(value.length) && !lodash_es_isFunction(value);
}

/* harmony default export */ var lodash_es_isArrayLike = (isArrayLike);

// CONCATENATED MODULE: ./node_modules/lodash-es/keys.js




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return lodash_es_isArrayLike(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

/* harmony default export */ var lodash_es_keys = (keys);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseAssign.js



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, lodash_es_keys(source), object);
}

/* harmony default export */ var _baseAssign = (baseAssign);

// CONCATENATED MODULE: ./node_modules/lodash-es/_nativeKeysIn.js
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _nativeKeysIn = (nativeKeysIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseKeysIn.js




/** Used for built-in method references. */
var _baseKeysIn_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeysIn_hasOwnProperty = _baseKeysIn_objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!lodash_es_isObject(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !_baseKeysIn_hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _baseKeysIn = (baseKeysIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/keysIn.js




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return lodash_es_isArrayLike(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

/* harmony default export */ var lodash_es_keysIn = (keysIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseAssignIn.js



/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, lodash_es_keysIn(source), object);
}

/* harmony default export */ var _baseAssignIn = (baseAssignIn);

// EXTERNAL MODULE: ./node_modules/lodash-es/_cloneBuffer.js
var _cloneBuffer = __webpack_require__(45);

// CONCATENATED MODULE: ./node_modules/lodash-es/_copyArray.js
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ var _copyArray = (copyArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayFilter.js
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ var _arrayFilter = (arrayFilter);

// CONCATENATED MODULE: ./node_modules/lodash-es/stubArray.js
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ var lodash_es_stubArray = (stubArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getSymbols.js



/** Used for built-in method references. */
var _getSymbols_objectProto = Object.prototype;

/** Built-in value references. */
var _getSymbols_propertyIsEnumerable = _getSymbols_objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? lodash_es_stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return _getSymbols_propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ var _getSymbols = (getSymbols);

// CONCATENATED MODULE: ./node_modules/lodash-es/_copySymbols.js



/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

/* harmony default export */ var _copySymbols = (copySymbols);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayPush.js
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ var _arrayPush = (arrayPush);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getPrototype.js


/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

/* harmony default export */ var _getPrototype = (getPrototype);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getSymbolsIn.js





/* Built-in method references for those with the same name as other `lodash` methods. */
var _getSymbolsIn_nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !_getSymbolsIn_nativeGetSymbols ? lodash_es_stubArray : function(object) {
  var result = [];
  while (object) {
    _arrayPush(result, _getSymbols(object));
    object = _getPrototype(object);
  }
  return result;
};

/* harmony default export */ var _getSymbolsIn = (getSymbolsIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_copySymbolsIn.js



/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

/* harmony default export */ var _copySymbolsIn = (copySymbolsIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetAllKeys.js



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return lodash_es_isArray(object) ? result : _arrayPush(result, symbolsFunc(object));
}

/* harmony default export */ var _baseGetAllKeys = (baseGetAllKeys);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getAllKeys.js




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, lodash_es_keys, _getSymbols);
}

/* harmony default export */ var _getAllKeys = (getAllKeys);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getAllKeysIn.js




/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return _baseGetAllKeys(object, lodash_es_keysIn, _getSymbolsIn);
}

/* harmony default export */ var _getAllKeysIn = (getAllKeysIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_DataView.js



/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root["a" /* default */], 'DataView');

/* harmony default export */ var _DataView = (DataView);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Promise.js



/* Built-in method references that are verified to be native. */
var _Promise_Promise = _getNative(_root["a" /* default */], 'Promise');

/* harmony default export */ var _Promise = (_Promise_Promise);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Set.js



/* Built-in method references that are verified to be native. */
var Set = _getNative(_root["a" /* default */], 'Set');

/* harmony default export */ var _Set = (Set);

// CONCATENATED MODULE: ./node_modules/lodash-es/_WeakMap.js



/* Built-in method references that are verified to be native. */
var _WeakMap_WeakMap = _getNative(_root["a" /* default */], 'WeakMap');

/* harmony default export */ var _WeakMap = (_WeakMap_WeakMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getTag.js








/** `Object#toString` result references. */
var _getTag_mapTag = '[object Map]',
    _getTag_objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    _getTag_setTag = '[object Set]',
    _getTag_weakMapTag = '[object WeakMap]';

var _getTag_dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != _getTag_dataViewTag) ||
    (_Map && getTag(new _Map) != _getTag_mapTag) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != _getTag_setTag) ||
    (_WeakMap && getTag(new _WeakMap) != _getTag_weakMapTag)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == _getTag_objectTag ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return _getTag_dataViewTag;
        case mapCtorString: return _getTag_mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return _getTag_setTag;
        case weakMapCtorString: return _getTag_weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ var _getTag = (getTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_initCloneArray.js
/** Used for built-in method references. */
var _initCloneArray_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _initCloneArray_hasOwnProperty = _initCloneArray_objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && _initCloneArray_hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/* harmony default export */ var _initCloneArray = (initCloneArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Uint8Array.js


/** Built-in value references. */
var Uint8Array = _root["a" /* default */].Uint8Array;

/* harmony default export */ var _Uint8Array = (Uint8Array);

// CONCATENATED MODULE: ./node_modules/lodash-es/_cloneArrayBuffer.js


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

/* harmony default export */ var _cloneArrayBuffer = (cloneArrayBuffer);

// CONCATENATED MODULE: ./node_modules/lodash-es/_cloneDataView.js


/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/* harmony default export */ var _cloneDataView = (cloneDataView);

// CONCATENATED MODULE: ./node_modules/lodash-es/_cloneRegExp.js
/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/* harmony default export */ var _cloneRegExp = (cloneRegExp);

// CONCATENATED MODULE: ./node_modules/lodash-es/_cloneSymbol.js


/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/* harmony default export */ var _cloneSymbol = (cloneSymbol);

// CONCATENATED MODULE: ./node_modules/lodash-es/_cloneTypedArray.js


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ var _cloneTypedArray = (cloneTypedArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_initCloneByTag.js






/** `Object#toString` result references. */
var _initCloneByTag_boolTag = '[object Boolean]',
    _initCloneByTag_dateTag = '[object Date]',
    _initCloneByTag_mapTag = '[object Map]',
    _initCloneByTag_numberTag = '[object Number]',
    _initCloneByTag_regexpTag = '[object RegExp]',
    _initCloneByTag_setTag = '[object Set]',
    _initCloneByTag_stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var _initCloneByTag_arrayBufferTag = '[object ArrayBuffer]',
    _initCloneByTag_dataViewTag = '[object DataView]',
    _initCloneByTag_float32Tag = '[object Float32Array]',
    _initCloneByTag_float64Tag = '[object Float64Array]',
    _initCloneByTag_int8Tag = '[object Int8Array]',
    _initCloneByTag_int16Tag = '[object Int16Array]',
    _initCloneByTag_int32Tag = '[object Int32Array]',
    _initCloneByTag_uint8Tag = '[object Uint8Array]',
    _initCloneByTag_uint8ClampedTag = '[object Uint8ClampedArray]',
    _initCloneByTag_uint16Tag = '[object Uint16Array]',
    _initCloneByTag_uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case _initCloneByTag_arrayBufferTag:
      return _cloneArrayBuffer(object);

    case _initCloneByTag_boolTag:
    case _initCloneByTag_dateTag:
      return new Ctor(+object);

    case _initCloneByTag_dataViewTag:
      return _cloneDataView(object, isDeep);

    case _initCloneByTag_float32Tag: case _initCloneByTag_float64Tag:
    case _initCloneByTag_int8Tag: case _initCloneByTag_int16Tag: case _initCloneByTag_int32Tag:
    case _initCloneByTag_uint8Tag: case _initCloneByTag_uint8ClampedTag: case _initCloneByTag_uint16Tag: case _initCloneByTag_uint32Tag:
      return _cloneTypedArray(object, isDeep);

    case _initCloneByTag_mapTag:
      return new Ctor;

    case _initCloneByTag_numberTag:
    case _initCloneByTag_stringTag:
      return new Ctor(object);

    case _initCloneByTag_regexpTag:
      return _cloneRegExp(object);

    case _initCloneByTag_setTag:
      return new Ctor;

    case symbolTag:
      return _cloneSymbol(object);
  }
}

/* harmony default export */ var _initCloneByTag = (initCloneByTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseCreate.js


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!lodash_es_isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ var _baseCreate = (baseCreate);

// CONCATENATED MODULE: ./node_modules/lodash-es/_initCloneObject.js




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

/* harmony default export */ var _initCloneObject = (initCloneObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsMap.js



/** `Object#toString` result references. */
var _baseIsMap_mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return lodash_es_isObjectLike(value) && _getTag(value) == _baseIsMap_mapTag;
}

/* harmony default export */ var _baseIsMap = (baseIsMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/isMap.js




/* Node.js helper references. */
var nodeIsMap = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;

/* harmony default export */ var lodash_es_isMap = (isMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsSet.js



/** `Object#toString` result references. */
var _baseIsSet_setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return lodash_es_isObjectLike(value) && _getTag(value) == _baseIsSet_setTag;
}

/* harmony default export */ var _baseIsSet = (baseIsSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/isSet.js




/* Node.js helper references. */
var nodeIsSet = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;

/* harmony default export */ var lodash_es_isSet = (isSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseClone.js























/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var _baseClone_argsTag = '[object Arguments]',
    _baseClone_arrayTag = '[object Array]',
    _baseClone_boolTag = '[object Boolean]',
    _baseClone_dateTag = '[object Date]',
    _baseClone_errorTag = '[object Error]',
    _baseClone_funcTag = '[object Function]',
    _baseClone_genTag = '[object GeneratorFunction]',
    _baseClone_mapTag = '[object Map]',
    _baseClone_numberTag = '[object Number]',
    _baseClone_objectTag = '[object Object]',
    _baseClone_regexpTag = '[object RegExp]',
    _baseClone_setTag = '[object Set]',
    _baseClone_stringTag = '[object String]',
    _baseClone_symbolTag = '[object Symbol]',
    _baseClone_weakMapTag = '[object WeakMap]';

var _baseClone_arrayBufferTag = '[object ArrayBuffer]',
    _baseClone_dataViewTag = '[object DataView]',
    _baseClone_float32Tag = '[object Float32Array]',
    _baseClone_float64Tag = '[object Float64Array]',
    _baseClone_int8Tag = '[object Int8Array]',
    _baseClone_int16Tag = '[object Int16Array]',
    _baseClone_int32Tag = '[object Int32Array]',
    _baseClone_uint8Tag = '[object Uint8Array]',
    _baseClone_uint8ClampedTag = '[object Uint8ClampedArray]',
    _baseClone_uint16Tag = '[object Uint16Array]',
    _baseClone_uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[_baseClone_argsTag] = cloneableTags[_baseClone_arrayTag] =
cloneableTags[_baseClone_arrayBufferTag] = cloneableTags[_baseClone_dataViewTag] =
cloneableTags[_baseClone_boolTag] = cloneableTags[_baseClone_dateTag] =
cloneableTags[_baseClone_float32Tag] = cloneableTags[_baseClone_float64Tag] =
cloneableTags[_baseClone_int8Tag] = cloneableTags[_baseClone_int16Tag] =
cloneableTags[_baseClone_int32Tag] = cloneableTags[_baseClone_mapTag] =
cloneableTags[_baseClone_numberTag] = cloneableTags[_baseClone_objectTag] =
cloneableTags[_baseClone_regexpTag] = cloneableTags[_baseClone_setTag] =
cloneableTags[_baseClone_stringTag] = cloneableTags[_baseClone_symbolTag] =
cloneableTags[_baseClone_uint8Tag] = cloneableTags[_baseClone_uint8ClampedTag] =
cloneableTags[_baseClone_uint16Tag] = cloneableTags[_baseClone_uint32Tag] = true;
cloneableTags[_baseClone_errorTag] = cloneableTags[_baseClone_funcTag] =
cloneableTags[_baseClone_weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!lodash_es_isObject(value)) {
    return value;
  }
  var isArr = lodash_es_isArray(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == _baseClone_funcTag || tag == _baseClone_genTag;

    if (Object(isBuffer["a" /* default */])(value)) {
      return Object(_cloneBuffer["a" /* default */])(value, isDeep);
    }
    if (tag == _baseClone_objectTag || tag == _baseClone_argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? _copySymbolsIn(value, _baseAssignIn(result, value))
          : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (lodash_es_isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (lodash_es_isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? _getAllKeysIn : _getAllKeys)
    : (isFlat ? lodash_es_keysIn : lodash_es_keys);

  var props = isArr ? undefined : keysFunc(value);
  _arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/* harmony default export */ var _baseClone = (baseClone);

// CONCATENATED MODULE: ./node_modules/lodash-es/clone.js


/** Used to compose bitmasks for cloning. */
var clone_CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone_clone(value) {
  return _baseClone(value, clone_CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ var lodash_es_clone = (clone_clone);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayMap.js
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ var _arrayMap = (arrayMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/isSymbol.js



/** `Object#toString` result references. */
var isSymbol_symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (lodash_es_isObjectLike(value) && _baseGetTag(value) == isSymbol_symbolTag);
}

/* harmony default export */ var lodash_es_isSymbol = (isSymbol);

// CONCATENATED MODULE: ./node_modules/lodash-es/memoize.js


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

/* harmony default export */ var lodash_es_memoize = (memoize);

// CONCATENATED MODULE: ./node_modules/lodash-es/_memoizeCapped.js


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = lodash_es_memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ var _memoizeCapped = (memoizeCapped);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stringToPath.js


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ var _stringToPath = (stringToPath);

// CONCATENATED MODULE: ./node_modules/lodash-es/_toKey.js


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || lodash_es_isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ var _toKey = (toKey);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseToString.js





/** Used as references for various `Number` constants. */
var _baseToString_INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var _baseToString_symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = _baseToString_symbolProto ? _baseToString_symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (lodash_es_isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (lodash_es_isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -_baseToString_INFINITY) ? '-0' : result;
}

/* harmony default export */ var _baseToString = (baseToString);

// CONCATENATED MODULE: ./node_modules/lodash-es/toString.js


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString_toString(value) {
  return value == null ? '' : _baseToString(value);
}

/* harmony default export */ var lodash_es_toString = (toString_toString);

// CONCATENATED MODULE: ./node_modules/lodash-es/toPath.js








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (lodash_es_isArray(value)) {
    return _arrayMap(value, _toKey);
  }
  return lodash_es_isSymbol(value) ? [value] : _copyArray(_stringToPath(lodash_es_toString(value)));
}

/* harmony default export */ var lodash_es_toPath = (toPath);

// CONCATENATED MODULE: ./node_modules/lodash-es/cloneDeep.js


/** Used to compose bitmasks for cloning. */
var cloneDeep_CLONE_DEEP_FLAG = 1,
    cloneDeep_CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return _baseClone(value, cloneDeep_CLONE_DEEP_FLAG | cloneDeep_CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ var lodash_es_cloneDeep = (cloneDeep);

// CONCATENATED MODULE: ./node_modules/formik/dist/formik.esm.js











var formik_esm_a;
var FormikProvider = (formik_esm_a =
/*#__PURE__*/
create_react_context_lib_default()({}), formik_esm_a.Provider),
    FormikConsumer = formik_esm_a.Consumer;
function connect(Comp) {
  var C = function (props) {
    return Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"])(FormikConsumer, null, function (formik) {
      return Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"])(Comp, __assign({}, props, {
        formik: formik
      }));
    });
  };

  var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component';
  C.WrappedComponent = Comp;
  C.displayName = "FormikConnect(" + componentDisplayName + ")";
  return hoist_non_react_statics_cjs_default()(C, Comp);
}

var formik_esm_isFunction = function (obj) {
  return typeof obj === 'function';
};
var formik_esm_isObject = function (obj) {
  return obj !== null && typeof obj === 'object';
};
var isInteger = function (obj) {
  return String(Math.floor(Number(obj))) === obj;
};
var formik_esm_isString = function (obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};
var formik_esm_isNaN = function (obj) {
  return obj !== obj;
};
var isEmptyChildren = function (children) {
  return external_commonjs_react_commonjs2_react_amd_React_root_React_["Children"].count(children) === 0;
};
var isPromise = function (value) {
  return formik_esm_isObject(value) && formik_esm_isFunction(value.then);
};
var isInputEvent = function (value) {
  return value && formik_esm_isObject(value) && formik_esm_isObject(value.target);
};
function getActiveElement(doc) {
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}
function makeCancelable(promise) {
  var hasCanceled = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return hasCanceled ? reject({
        isCanceled: true
      }) : resolve(val);
    }, function (error) {
      return hasCanceled ? reject({
        isCanceled: true
      }) : reject(error);
    });
  });
  return [wrappedPromise, function cancel() {
    hasCanceled = true;
  }];
}
function getIn(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }

  var path = lodash_es_toPath(key);

  while (obj && p < path.length) {
    obj = obj[path[p++]];
  }

  return obj === undefined ? def : obj;
}
function setIn(obj, path, value) {
  var res = lodash_es_clone(obj);
  var resVal = res;
  var i = 0;
  var pathArray = lodash_es_toPath(path);

  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn(obj, pathArray.slice(0, i + 1));

    if (currentObj) {
      resVal = resVal[currentPath] = lodash_es_clone(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  }

  if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
    return obj;
  }

  if (value === undefined) {
    delete resVal[pathArray[i]];
  } else {
    resVal[pathArray[i]] = value;
  }

  if (i === 0 && value === undefined) {
    delete res[pathArray[i]];
  }

  return res;
}
function setNestedObjectValues(object, value, visited, response) {
  if (visited === void 0) {
    visited = new WeakMap();
  }

  if (response === void 0) {
    response = {};
  }

  for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
    var k = _a[_i];
    var val = object[k];

    if (formik_esm_isObject(val)) {
      if (!visited.get(val)) {
        visited.set(val, true);
        response[k] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k]);
      }
    } else {
      response[k] = value;
    }
  }

  return response;
}

var formik_esm_Formik =
/*#__PURE__*/
function (_super) {
  __extends(Formik, _super);

  function Formik(props) {
    var _this = _super.call(this, props) || this;

    _this.hcCache = {};
    _this.hbCache = {};

    _this.registerField = function (name, Comp) {
      _this.fields[name] = Comp;
    };

    _this.unregisterField = function (name) {
      delete _this.fields[name];
    };

    _this.setErrors = function (errors) {
      _this.setState({
        errors: errors
      });
    };

    _this.setTouched = function (touched) {
      _this.setState({
        touched: touched
      }, function () {
        if (_this.props.validateOnBlur) {
          _this.runValidations(_this.state.values);
        }
      });
    };

    _this.setValues = function (values) {
      _this.setState({
        values: values
      }, function () {
        if (_this.props.validateOnChange) {
          _this.runValidations(values);
        }
      });
    };

    _this.setStatus = function (status) {
      _this.setState({
        status: status
      });
    };

    _this.setError = function (error) {
      if (true) {
        console.warn("Warning: Formik's setError(error) is deprecated and may be removed in future releases. Please use Formik's setStatus(status) instead. It works identically. For more info see https://github.com/jaredpalmer/formik#setstatus-status-any--void");
      }

      _this.setState({
        error: error
      });
    };

    _this.setSubmitting = function (isSubmitting) {
      if (_this.didMount) {
        _this.setState({
          isSubmitting: isSubmitting
        });
      }
    };

    _this.validateField = function (field) {
      _this.setState({
        isValidating: true
      });

      return _this.runSingleFieldLevelValidation(field, getIn(_this.state.values, field)).then(function (error) {
        if (_this.didMount) {
          _this.setState({
            errors: setIn(_this.state.errors, field, error),
            isValidating: false
          });
        }

        return error;
      });
    };

    _this.runSingleFieldLevelValidation = function (field, value) {
      return new Promise(function (resolve) {
        return resolve(_this.fields[field].props.validate(value));
      }).then(function (x) {
        return x;
      }, function (e) {
        return e;
      });
    };

    _this.runValidationSchema = function (values) {
      return new Promise(function (resolve) {
        var validationSchema = _this.props.validationSchema;
        var schema = formik_esm_isFunction(validationSchema) ? validationSchema() : validationSchema;
        validateYupSchema(values, schema).then(function () {
          resolve({});
        }, function (err) {
          resolve(yupToFormErrors(err));
        });
      });
    };

    _this.runValidations = function (values) {
      if (values === void 0) {
        values = _this.state.values;
      }

      if (_this.validator) {
        _this.validator();
      }

      var _a = makeCancelable(Promise.all([_this.runFieldLevelValidations(values), _this.props.validationSchema ? _this.runValidationSchema(values) : {}, _this.props.validate ? _this.runValidateHandler(values) : {}]).then(function (_a) {
        var fieldErrors = _a[0],
            schemaErrors = _a[1],
            handlerErrors = _a[2];
        return es.all([fieldErrors, schemaErrors, handlerErrors], {
          arrayMerge: arrayMerge
        });
      })),
          promise = _a[0],
          cancel = _a[1];

      _this.validator = cancel;
      return promise.then(function (errors) {
        if (_this.didMount) {
          _this.setState(function (prevState) {
            if (!react_fast_compare_default()(prevState.errors, errors)) {
              return {
                errors: errors
              };
            }

            return null;
          });
        }

        return errors;
      }).catch(function (x) {
        return x;
      });
    };

    _this.handleChange = function (eventOrPath) {
      var executeChange = function (eventOrValue, maybePath) {
        var field = maybePath;
        var value;

        if (isInputEvent(eventOrValue)) {
          var event_1 = eventOrValue;

          if (event_1.persist) {
            event_1.persist();
          }

          var _a = event_1.target,
              type = _a.type,
              name_1 = _a.name,
              id = _a.id,
              checked = _a.checked,
              outerHTML = _a.outerHTML;
          field = maybePath ? maybePath : name_1 ? name_1 : id;

          if (!field && "development" !== 'production') {
            warnAboutMissingIdentifier({
              htmlContent: outerHTML,
              documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
              handlerName: 'handleChange'
            });
          }

          value = event_1.target.value;

          if (/number|range/.test(type)) {
            var parsed = parseFloat(event_1.target.value);
            value = formik_esm_isNaN(parsed) ? '' : parsed;
          }

          if (/checkbox/.test(type)) {
            value = checked;
          }
        } else {
          value = eventOrValue;
        }

        if (field) {
          _this.setState(function (prevState) {
            return __assign({}, prevState, {
              values: setIn(prevState.values, field, value)
            });
          }, function () {
            if (_this.props.validateOnChange) {
              _this.runValidations(setIn(_this.state.values, field, value));
            }
          });
        }
      };

      if (formik_esm_isString(eventOrPath)) {
        var path_1 = eventOrPath;

        if (!formik_esm_isFunction(_this.hcCache[path_1])) {
          _this.hcCache[path_1] = function (eventOrValue) {
            return executeChange(eventOrValue, path_1);
          };
        }

        return _this.hcCache[path_1];
      } else {
        var event_2 = eventOrPath;
        executeChange(event_2);
      }
    };

    _this.setFieldValue = function (field, value, shouldValidate) {
      if (shouldValidate === void 0) {
        shouldValidate = true;
      }

      if (_this.didMount) {
        _this.setState(function (prevState) {
          return __assign({}, prevState, {
            values: setIn(prevState.values, field, value)
          });
        }, function () {
          if (_this.props.validateOnChange && shouldValidate) {
            _this.runValidations(_this.state.values);
          }
        });
      }
    };

    _this.handleSubmit = function (e) {
      if (e && e.preventDefault) {
        e.preventDefault();
      }

      if ( true && typeof document !== 'undefined') {
        var activeElement = getActiveElement();

        if (activeElement !== null && activeElement instanceof HTMLButtonElement) {
           true ? tiny_warning_esm(!!(activeElement.attributes && activeElement.attributes.getNamedItem('type')), 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : undefined;
        }
      }

      _this.submitForm();
    };

    _this.submitForm = function () {
      _this.setState(function (prevState) {
        return {
          touched: setNestedObjectValues(prevState.values, true),
          isSubmitting: true,
          isValidating: true,
          submitCount: prevState.submitCount + 1
        };
      });

      return _this.runValidations(_this.state.values).then(function (combinedErrors) {
        if (_this.didMount) {
          _this.setState({
            isValidating: false
          });
        }

        var isValid = Object.keys(combinedErrors).length === 0;

        if (isValid) {
          _this.executeSubmit();
        } else if (_this.didMount) {
          _this.setState({
            isSubmitting: false
          });
        }
      });
    };

    _this.executeSubmit = function () {
      _this.props.onSubmit(_this.state.values, _this.getFormikActions());
    };

    _this.handleBlur = function (eventOrPath) {
      var executeBlur = function (maybeEvent, maybePath) {
        var field = maybePath;

        if (isInputEvent(maybeEvent)) {
          var event_3 = maybeEvent;

          if (event_3.persist) {
            event_3.persist();
          }

          var _a = event_3.target,
              name_2 = _a.name,
              id = _a.id,
              outerHTML = _a.outerHTML;
          field = name_2 ? name_2 : id;

          if (!field && "development" !== 'production') {
            warnAboutMissingIdentifier({
              htmlContent: outerHTML,
              documentationAnchorLink: 'handleblur-e-reactfocuseventany--void',
              handlerName: 'handleBlur'
            });
          }
        }

        _this.setState(function (prevState) {
          return {
            touched: setIn(prevState.touched, field, true)
          };
        });

        if (_this.props.validateOnBlur) {
          _this.runValidations(_this.state.values);
        }
      };

      if (formik_esm_isString(eventOrPath)) {
        var path_2 = eventOrPath;

        if (!formik_esm_isFunction(_this.hbCache[path_2])) {
          _this.hbCache[path_2] = function (event) {
            return executeBlur(event, path_2);
          };
        }

        return _this.hbCache[path_2];
      } else {
        var event_4 = eventOrPath;
        executeBlur(event_4);
      }
    };

    _this.setFieldTouched = function (field, touched, shouldValidate) {
      if (touched === void 0) {
        touched = true;
      }

      if (shouldValidate === void 0) {
        shouldValidate = true;
      }

      _this.setState(function (prevState) {
        return __assign({}, prevState, {
          touched: setIn(prevState.touched, field, touched)
        });
      }, function () {
        if (_this.props.validateOnBlur && shouldValidate) {
          _this.runValidations(_this.state.values);
        }
      });
    };

    _this.setFieldError = function (field, message) {
      _this.setState(function (prevState) {
        return __assign({}, prevState, {
          errors: setIn(prevState.errors, field, message)
        });
      });
    };

    _this.resetForm = function (nextValues) {
      var values = nextValues ? nextValues : _this.props.initialValues;
      _this.initialValues = values;

      _this.setState({
        isSubmitting: false,
        isValidating: false,
        errors: {},
        touched: {},
        error: undefined,
        status: _this.props.initialStatus,
        values: values,
        submitCount: 0
      });
    };

    _this.handleReset = function () {
      if (_this.props.onReset) {
        var maybePromisedOnReset = _this.props.onReset(_this.state.values, _this.getFormikActions());

        if (isPromise(maybePromisedOnReset)) {
          maybePromisedOnReset.then(_this.resetForm);
        } else {
          _this.resetForm();
        }
      } else {
        _this.resetForm();
      }
    };

    _this.setFormikState = function (s, callback) {
      return _this.setState(s, callback);
    };

    _this.validateForm = function (values) {
      _this.setState({
        isValidating: true
      });

      return _this.runValidations(values).then(function (errors) {
        if (_this.didMount) {
          _this.setState({
            isValidating: false
          });
        }

        return errors;
      });
    };

    _this.getFormikActions = function () {
      return {
        resetForm: _this.resetForm,
        submitForm: _this.submitForm,
        validateForm: _this.validateForm,
        validateField: _this.validateField,
        setError: _this.setError,
        setErrors: _this.setErrors,
        setFieldError: _this.setFieldError,
        setFieldTouched: _this.setFieldTouched,
        setFieldValue: _this.setFieldValue,
        setStatus: _this.setStatus,
        setSubmitting: _this.setSubmitting,
        setTouched: _this.setTouched,
        setValues: _this.setValues,
        setFormikState: _this.setFormikState
      };
    };

    _this.getFormikComputedProps = function () {
      var isInitialValid = _this.props.isInitialValid;
      var dirty = !react_fast_compare_default()(_this.initialValues, _this.state.values);
      return {
        dirty: dirty,
        isValid: dirty ? _this.state.errors && Object.keys(_this.state.errors).length === 0 : isInitialValid !== false && formik_esm_isFunction(isInitialValid) ? isInitialValid(_this.props) : isInitialValid,
        initialValues: _this.initialValues
      };
    };

    _this.getFormikBag = function () {
      return __assign({}, _this.state, _this.getFormikActions(), _this.getFormikComputedProps(), {
        registerField: _this.registerField,
        unregisterField: _this.unregisterField,
        handleBlur: _this.handleBlur,
        handleChange: _this.handleChange,
        handleReset: _this.handleReset,
        handleSubmit: _this.handleSubmit,
        validateOnChange: _this.props.validateOnChange,
        validateOnBlur: _this.props.validateOnBlur
      });
    };

    _this.getFormikContext = function () {
      return __assign({}, _this.getFormikBag(), {
        validationSchema: _this.props.validationSchema,
        validate: _this.props.validate,
        initialValues: _this.initialValues
      });
    };

    _this.state = {
      values: props.initialValues || {},
      errors: {},
      touched: {},
      isSubmitting: false,
      isValidating: false,
      submitCount: 0,
      status: props.initialStatus
    };
    _this.didMount = false;
    _this.fields = {};
    _this.initialValues = props.initialValues || {};
     true ? tiny_warning_esm(!(props.component && props.render), 'You should not use <Formik component> and <Formik render> in the same <Formik> component; <Formik render> will be ignored') : undefined;
     true ? tiny_warning_esm(!(props.component && props.children && !isEmptyChildren(props.children)), 'You should not use <Formik component> and <Formik children> in the same <Formik> component; <Formik children> will be ignored') : undefined;
     true ? tiny_warning_esm(!(props.render && props.children && !isEmptyChildren(props.children)), 'You should not use <Formik render> and <Formik children> in the same <Formik> component; <Formik children> will be ignored') : undefined;
    return _this;
  }

  Formik.prototype.componentDidMount = function () {
    this.didMount = true;
  };

  Formik.prototype.componentWillUnmount = function () {
    this.didMount = false;

    if (this.validator) {
      this.validator();
    }
  };

  Formik.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.enableReinitialize && !react_fast_compare_default()(prevProps.initialValues, this.props.initialValues)) {
      this.initialValues = this.props.initialValues;
      this.resetForm(this.props.initialValues);
    }
  };

  Formik.prototype.runFieldLevelValidations = function (values) {
    var _this = this;

    var fieldKeysWithValidation = Object.keys(this.fields).filter(function (f) {
      return _this.fields && _this.fields[f] && _this.fields[f].props.validate && formik_esm_isFunction(_this.fields[f].props.validate);
    });
    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function (f) {
      return _this.runSingleFieldLevelValidation(f, getIn(values, f));
    }) : [Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')];
    return Promise.all(fieldValidations).then(function (fieldErrorsList) {
      return fieldErrorsList.reduce(function (prev, curr, index) {
        if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') {
          return prev;
        }

        if (!!curr) {
          prev = setIn(prev, fieldKeysWithValidation[index], curr);
        }

        return prev;
      }, {});
    });
  };

  Formik.prototype.runValidateHandler = function (values) {
    var _this = this;

    return new Promise(function (resolve) {
      var maybePromisedErrors = _this.props.validate(values);

      if (maybePromisedErrors === undefined) {
        resolve({});
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function () {
          resolve({});
        }, function (errors) {
          resolve(errors);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  };

  Formik.prototype.render = function () {
    var _a = this.props,
        component = _a.component,
        render = _a.render,
        children = _a.children;
    var props = this.getFormikBag();
    var ctx = this.getFormikContext();
    return Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"])(FormikProvider, {
      value: ctx
    }, component ? Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"])(component, props) : render ? render(props) : children ? formik_esm_isFunction(children) ? children(props) : !isEmptyChildren(children) ? external_commonjs_react_commonjs2_react_amd_React_root_React_["Children"].only(children) : null : null);
  };

  Formik.defaultProps = {
    validateOnChange: true,
    validateOnBlur: true,
    isInitialValid: false,
    enableReinitialize: false
  };
  return Formik;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);

function warnAboutMissingIdentifier(_a) {
  var htmlContent = _a.htmlContent,
      documentationAnchorLink = _a.documentationAnchorLink,
      handlerName = _a.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n\n    " + htmlContent + "\n\n    Formik cannot determine which value to update. For more info see https://github.com/jaredpalmer/formik#" + documentationAnchorLink + "\n  ");
}

function yupToFormErrors(yupError) {
  var errors = {};

  if (yupError.inner.length === 0) {
    return setIn(errors, yupError.path, yupError.message);
  }

  for (var _i = 0, _a = yupError.inner; _i < _a.length; _i++) {
    var err = _a[_i];

    if (!errors[err.path]) {
      errors = setIn(errors, err.path, err.message);
    }
  }

  return errors;
}
function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }

  if (context === void 0) {
    context = {};
  }

  var validateData = {};

  for (var k in values) {
    if (values.hasOwnProperty(k)) {
      var key = String(k);
      validateData[key] = values[key] !== '' ? values[key] : undefined;
    }
  }

  return schema[sync ? 'validateSync' : 'validate'](validateData, {
    abortEarly: false,
    context: context
  });
}

function arrayMerge(target, source, options) {
  var destination = target.slice();
  source.forEach(function (e, i) {
    if (typeof destination[i] === 'undefined') {
      var cloneRequested = options.clone !== false;
      var shouldClone = cloneRequested && options.isMergeableObject(e);
      destination[i] = shouldClone ? es(Array.isArray(e) ? [] : {}, e, options) : e;
    } else if (options.isMergeableObject(e)) {
      destination[i] = es(target[i], e, options);
    } else if (target.indexOf(e) === -1) {
      destination.push(e);
    }
  });
  return destination;
}

var formik_esm_FieldInner =
/*#__PURE__*/
function (_super) {
  __extends(FieldInner, _super);

  function FieldInner(props) {
    var _this = _super.call(this, props) || this;

    var render = props.render,
        children = props.children,
        component = props.component;
     true ? tiny_warning_esm(!(component && render), 'You should not use <Field component> and <Field render> in the same <Field> component; <Field component> will be ignored') : undefined;
     true ? tiny_warning_esm(!(component && children && formik_esm_isFunction(children)), 'You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.') : undefined;
     true ? tiny_warning_esm(!(render && children && !isEmptyChildren(children)), 'You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored') : undefined;
    return _this;
  }

  FieldInner.prototype.componentDidMount = function () {
    this.props.formik.registerField(this.props.name, this);
  };

  FieldInner.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.name !== prevProps.name) {
      this.props.formik.unregisterField(prevProps.name);
      this.props.formik.registerField(this.props.name, this);
    }

    if (this.props.validate !== prevProps.validate) {
      this.props.formik.registerField(this.props.name, this);
    }
  };

  FieldInner.prototype.componentWillUnmount = function () {
    this.props.formik.unregisterField(this.props.name);
  };

  FieldInner.prototype.render = function () {
    var _a = this.props,
        validate = _a.validate,
        name = _a.name,
        render = _a.render,
        children = _a.children,
        _b = _a.component,
        component = _b === void 0 ? 'input' : _b,
        formik = _a.formik,
        props = __rest(_a, ["validate", "name", "render", "children", "component", "formik"]);

    var _validate = formik.validate,
        _validationSchema = formik.validationSchema,
        restOfFormik = __rest(formik, ["validate", "validationSchema"]);

    var field = {
      value: props.type === 'radio' || props.type === 'checkbox' ? props.value : getIn(formik.values, name),
      name: name,
      onChange: formik.handleChange,
      onBlur: formik.handleBlur
    };
    var bag = {
      field: field,
      form: restOfFormik
    };

    if (render) {
      return render(bag);
    }

    if (formik_esm_isFunction(children)) {
      return children(bag);
    }

    if (typeof component === 'string') {
      var innerRef = props.innerRef,
          rest = __rest(props, ["innerRef"]);

      return Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"])(component, __assign({
        ref: innerRef
      }, field, rest, {
        children: children
      }));
    }

    return Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"])(component, __assign({}, bag, props, {
      children: children
    }));
  };

  return FieldInner;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);

var Field =
/*#__PURE__*/
connect(formik_esm_FieldInner);

var Form =
/*#__PURE__*/
connect(function (_a) {
  var _b = _a.formik,
      handleReset = _b.handleReset,
      handleSubmit = _b.handleSubmit,
      props = __rest(_a, ["formik"]);

  return Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"])("form", __assign({
    onReset: handleReset,
    onSubmit: handleSubmit
  }, props));
});
Form.displayName = 'Form';

function withFormik(_a) {
  var _b = _a.mapPropsToValues,
      mapPropsToValues = _b === void 0 ? function (vanillaProps) {
    var val = {};

    for (var k in vanillaProps) {
      if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') {
        val[k] = vanillaProps[k];
      }
    }

    return val;
  } : _b,
      config = __rest(_a, ["mapPropsToValues"]);

  return function createFormik(Component$$1) {
    var componentDisplayName = Component$$1.displayName || Component$$1.name || Component$$1.constructor && Component$$1.constructor.name || 'Component';

    var C = function (_super) {
      __extends(C, _super);

      function C() {
        var _this = _super !== null && _super.apply(this, arguments) || this;

        _this.validate = function (values) {
          return config.validate(values, _this.props);
        };

        _this.validationSchema = function () {
          return formik_esm_isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
        };

        _this.handleSubmit = function (values, actions) {
          return config.handleSubmit(values, __assign({}, actions, {
            props: _this.props
          }));
        };

        _this.renderFormComponent = function (formikProps) {
          return Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"])(Component$$1, __assign({}, _this.props, formikProps));
        };

        return _this;
      }

      C.prototype.render = function () {
        var _a = this.props,
            children = _a.children,
            props = __rest(_a, ["children"]);

        return Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"])(formik_esm_Formik, __assign({}, props, config, {
          validate: config.validate && this.validate,
          validationSchema: config.validationSchema && this.validationSchema,
          initialValues: mapPropsToValues(this.props),
          initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
          onSubmit: this.handleSubmit,
          render: this.renderFormComponent
        }));
      };

      C.displayName = "WithFormik(" + componentDisplayName + ")";
      return C;
    }(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);

    return hoist_non_react_statics_cjs_default()(C, Component$$1);
  };
}

var move = function (array, from, to) {
  var copy = (array || []).slice();
  var value = copy[from];
  copy.splice(from, 1);
  copy.splice(to, 0, value);
  return copy;
};
var swap = function (array, indexA, indexB) {
  var copy = (array || []).slice();
  var a = copy[indexA];
  copy[indexA] = copy[indexB];
  copy[indexB] = a;
  return copy;
};
var insert = function (array, index, value) {
  var copy = (array || []).slice();
  copy.splice(index, 0, value);
  return copy;
};
var formik_esm_replace = function (array, index, value) {
  var copy = (array || []).slice();
  copy[index] = value;
  return copy;
};

var formik_esm_FieldArrayInner =
/*#__PURE__*/
function (_super) {
  __extends(FieldArrayInner, _super);

  function FieldArrayInner(props) {
    var _this = _super.call(this, props) || this;

    _this.updateArrayField = function (fn, alterTouched, alterErrors) {
      var _a = _this.props,
          name = _a.name,
          validateOnChange = _a.validateOnChange,
          _b = _a.formik,
          setFormikState = _b.setFormikState,
          validateForm = _b.validateForm;
      setFormikState(function (prevState) {
        var updateErrors = typeof alterErrors === 'function' ? alterErrors : fn;
        var updateTouched = typeof alterTouched === 'function' ? alterTouched : fn;
        return __assign({}, prevState, {
          values: setIn(prevState.values, name, fn(getIn(prevState.values, name))),
          errors: alterErrors ? setIn(prevState.errors, name, updateErrors(getIn(prevState.errors, name))) : prevState.errors,
          touched: alterTouched ? setIn(prevState.touched, name, updateTouched(getIn(prevState.touched, name))) : prevState.touched
        });
      }, function () {
        if (validateOnChange) {
          validateForm();
        }
      });
    };

    _this.push = function (value) {
      return _this.updateArrayField(function (array) {
        return (array || []).concat([lodash_es_cloneDeep(value)]);
      }, false, false);
    };

    _this.handlePush = function (value) {
      return function () {
        return _this.push(value);
      };
    };

    _this.swap = function (indexA, indexB) {
      return _this.updateArrayField(function (array) {
        return swap(array, indexA, indexB);
      }, true, true);
    };

    _this.handleSwap = function (indexA, indexB) {
      return function () {
        return _this.swap(indexA, indexB);
      };
    };

    _this.move = function (from, to) {
      return _this.updateArrayField(function (array) {
        return move(array, from, to);
      }, true, true);
    };

    _this.handleMove = function (from, to) {
      return function () {
        return _this.move(from, to);
      };
    };

    _this.insert = function (index, value) {
      return _this.updateArrayField(function (array) {
        return insert(array, index, value);
      }, function (array) {
        return insert(array, index, null);
      }, function (array) {
        return insert(array, index, null);
      });
    };

    _this.handleInsert = function (index, value) {
      return function () {
        return _this.insert(index, value);
      };
    };

    _this.replace = function (index, value) {
      return _this.updateArrayField(function (array) {
        return formik_esm_replace(array, index, value);
      }, false, false);
    };

    _this.handleReplace = function (index, value) {
      return function () {
        return _this.replace(index, value);
      };
    };

    _this.unshift = function (value) {
      var length = -1;

      _this.updateArrayField(function (array) {
        var arr = array ? [value].concat(array) : [value];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];
        if (length < 0) length = arr.length;
        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];
        if (length < 0) length = arr.length;
        return arr;
      });

      return length;
    };

    _this.handleUnshift = function (value) {
      return function () {
        return _this.unshift(value);
      };
    };

    _this.handleRemove = function (index) {
      return function () {
        return _this.remove(index);
      };
    };

    _this.handlePop = function () {
      return function () {
        return _this.pop();
      };
    };

    _this.remove = _this.remove.bind(_this);
    _this.pop = _this.pop.bind(_this);
    return _this;
  }

  FieldArrayInner.prototype.remove = function (index) {
    var result;
    this.updateArrayField(function (array) {
      var copy = array ? array.slice() : [];

      if (!result) {
        result = copy[index];
      }

      if (formik_esm_isFunction(copy.splice)) {
        copy.splice(index, 1);
      }

      return copy;
    }, true, true);
    return result;
  };

  FieldArrayInner.prototype.pop = function () {
    var result;
    this.updateArrayField(function (array) {
      var tmp = array;

      if (!result) {
        result = tmp && tmp.pop && tmp.pop();
      }

      return tmp;
    }, true, true);
    return result;
  };

  FieldArrayInner.prototype.render = function () {
    var arrayHelpers = {
      push: this.push,
      pop: this.pop,
      swap: this.swap,
      move: this.move,
      insert: this.insert,
      replace: this.replace,
      unshift: this.unshift,
      remove: this.remove,
      handlePush: this.handlePush,
      handlePop: this.handlePop,
      handleSwap: this.handleSwap,
      handleMove: this.handleMove,
      handleInsert: this.handleInsert,
      handleReplace: this.handleReplace,
      handleUnshift: this.handleUnshift,
      handleRemove: this.handleRemove
    };

    var _a = this.props,
        component = _a.component,
        render = _a.render,
        children = _a.children,
        name = _a.name,
        _b = _a.formik,
        _validate = _b.validate,
        _validationSchema = _b.validationSchema,
        restOfFormik = __rest(_b, ["validate", "validationSchema"]);

    var props = __assign({}, arrayHelpers, {
      form: restOfFormik,
      name: name
    });

    return component ? Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"])(component, props) : render ? render(props) : children ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? external_commonjs_react_commonjs2_react_amd_React_root_React_["Children"].only(children) : null : null;
  };

  FieldArrayInner.defaultProps = {
    validateOnChange: true
  };
  return FieldArrayInner;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);

var FieldArray =
/*#__PURE__*/
connect(formik_esm_FieldArrayInner);

var formik_esm_FastFieldInner =
/*#__PURE__*/
function (_super) {
  __extends(FastFieldInner, _super);

  function FastFieldInner(props) {
    var _this = _super.call(this, props) || this;

    var render = props.render,
        children = props.children,
        component = props.component;
     true ? tiny_warning_esm(!(component && render), 'You should not use <FastField component> and <FastField render> in the same <FastField> component; <FastField component> will be ignored') : undefined;
     true ? tiny_warning_esm(!(component && children && formik_esm_isFunction(children)), 'You should not use <FastField component> and <FastField children> as a function in the same <FastField> component; <FastField component> will be ignored.') : undefined;
     true ? tiny_warning_esm(!(render && children && !isEmptyChildren(children)), 'You should not use <FastField render> and <FastField children> in the same <FastField> component; <FastField children> will be ignored') : undefined;
    return _this;
  }

  FastFieldInner.prototype.shouldComponentUpdate = function (props) {
    if (this.props.shouldUpdate) {
      return this.props.shouldUpdate(props, this.props);
    } else if (getIn(this.props.formik.values, this.props.name) !== getIn(props.formik.values, this.props.name) || getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || this.props.formik.isSubmitting !== props.formik.isSubmitting) {
      return true;
    } else {
      return false;
    }
  };

  FastFieldInner.prototype.componentDidMount = function () {
    this.props.formik.registerField(this.props.name, this);
  };

  FastFieldInner.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.name !== prevProps.name) {
      this.props.formik.unregisterField(prevProps.name);
      this.props.formik.registerField(this.props.name, this);
    }

    if (this.props.validate !== prevProps.validate) {
      this.props.formik.registerField(this.props.name, this);
    }
  };

  FastFieldInner.prototype.componentWillUnmount = function () {
    this.props.formik.unregisterField(this.props.name);
  };

  FastFieldInner.prototype.render = function () {
    var _a = this.props,
        validate = _a.validate,
        name = _a.name,
        render = _a.render,
        children = _a.children,
        _b = _a.component,
        component = _b === void 0 ? 'input' : _b,
        formik = _a.formik,
        shouldUpdate = _a.shouldUpdate,
        props = __rest(_a, ["validate", "name", "render", "children", "component", "formik", "shouldUpdate"]);

    var _validate = formik.validate,
        _validationSchema = formik.validationSchema,
        restOfFormik = __rest(formik, ["validate", "validationSchema"]);

    var field = {
      value: props.type === 'radio' || props.type === 'checkbox' ? props.value : getIn(formik.values, name),
      name: name,
      onChange: formik.handleChange,
      onBlur: formik.handleBlur
    };
    var bag = {
      field: field,
      form: restOfFormik
    };

    if (render) {
      return render(bag);
    }

    if (formik_esm_isFunction(children)) {
      return children(bag);
    }

    if (typeof component === 'string') {
      var innerRef = props.innerRef,
          rest = __rest(props, ["innerRef"]);

      return Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"])(component, __assign({
        ref: innerRef
      }, field, rest, {
        children: children
      }));
    }

    return Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"])(component, __assign({}, bag, props, {
      children: children
    }));
  };

  return FastFieldInner;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);

var FastField =
/*#__PURE__*/
connect(formik_esm_FastFieldInner);

var formik_esm_ErrorMessageImpl =
/*#__PURE__*/
function (_super) {
  __extends(ErrorMessageImpl, _super);

  function ErrorMessageImpl() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ErrorMessageImpl.prototype.shouldComponentUpdate = function (props) {
    if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) {
      return true;
    } else {
      return false;
    }
  };

  ErrorMessageImpl.prototype.render = function () {
    var _a = this.props,
        component = _a.component,
        formik = _a.formik,
        render = _a.render,
        children = _a.children,
        name = _a.name,
        rest = __rest(_a, ["component", "formik", "render", "children", "name"]);

    var touch = getIn(formik.touched, name);
    var error = getIn(formik.errors, name);
    return !!touch && !!error ? render ? formik_esm_isFunction(render) ? render(error) : null : children ? formik_esm_isFunction(children) ? children(error) : null : component ? Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"])(component, rest, error) : error : null;
  };

  return ErrorMessageImpl;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);

var ErrorMessage =
/*#__PURE__*/
connect(formik_esm_ErrorMessageImpl);


//# sourceMappingURL=formik.esm.js.map

// CONCATENATED MODULE: ./node_modules/libphonenumber-js/metadata.min.json.js
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
/* harmony default export */ var metadata_min_json = ({"version":4,"country_calling_codes":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"383":["XK"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"880":["BD"],"886":["TW"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","00","(?:[01589]\\d|[46])\\d{4}",[5,6]],"AD":["376","00","(?:1|6\\d)\\d{7}|[135-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]]],"AE":["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],"0"],"AF":["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0"],"AG":["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([457]\\d{6})$","268$1",0,"268"],"AI":["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2457]\\d{6})$","264$1",0,"264"],"AL":["355","00","(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0"],"AM":["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],["(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],"0"],"AO":["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]]],"AR":["54","00","(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",[10,11],[["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",1],["(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1",0,"$1 $2 $3-$4"],["(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1",0,"$1 $2 $3-$4"]],"0",0,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?","9$1"],"AS":["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,"1|([267]\\d{6})$","684$1",0,"684"],"AT":["43","00","1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",[4,5,6,7,8,9,10,11,12,13],[["(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],["(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],["(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],"0"],"AU":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",[5,6,7,8,9,10,12],[["(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],"0",0,"0|(183[12])",0,0,0,[["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",[9]],["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,["163\\d{2,6}",[5,6,7,8,9]],["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"AW":["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]]],"AX":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",[5,6,7,8,9,10,11,12],0,"0",0,0,0,0,"18",0,"00"],"AZ":["994","00","365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],"0"],"BA":["387","00","6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0"],"BB":["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","246$1",0,"246"],"BD":["880","00","[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],["(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],"0$1"],["(\\d{4})(\\d{3,6})","$1-$2",["[13-9]|22"],"0$1"],["(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],"0"],"BE":["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0"],"BF":["226","00","[025-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]]],"BG":["359","00","[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0"],"BH":["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[13679]|8[047]"]]]],"BI":["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]]],"BJ":["229","00","(?:[25689]\\d|40)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-689]"]]]],"BL":["590","00","(?:590|(?:69|80)\\d|976)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:2[7-9]|5[12]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["976[01]\\d{5}"]]],"BM":["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-8]\\d{6})$","441$1",0,"441"],"BN":["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","00(?:1\\d)?","(?:[2-467]\\d\\d|8001)\\d{5}",[8,9],[["(\\d)(\\d{7})","$1 $2",["[23]|4[46]"]],["(\\d{8})","$1",["[67]"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"]]],"0",0,"0(1\\d)?"],"BQ":["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]"],"BR":["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],["(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)"]],"0",0,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([3-8]\\d{6})$","242$1",0,"242"],"BT":["975","00","[17]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]]],"BW":["267","00","(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",[7,8,10],[["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-79]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["8"]]]],"BY":["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],["(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],"8",0,"0|80?",0,0,0,0,"8~10"],"BZ":["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]]],"CA":["1","011","(?:[2-8]\\d|90)\\d{8}|3\\d{6}",[7,10],0,"1",0,0,0,0,0,[["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|68|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|13|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",[10]],["",[10]],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",[10]],["900[2-9]\\d{6}",[10]],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-7]|33|44|66|77|88)|622)[2-9]\\d{6}",[10]],0,["310\\d{4}",[7]],0,["600[2-9]\\d{6}",[10]]]],"CC":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"0|([59]\\d{7})$","8$1",0,0,[["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",[9]],["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CD":["243","00","[189]\\d{8}|[1-68]\\d{6}",[7,9],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],"0"],"CF":["236","00","(?:[27]\\d{3}|8776)\\d{4}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]]],"CG":["242","00","222\\d{6}|(?:0\\d|80)\\d{7}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]]],"CH":["41","00","8\\d{11}|[2-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0"],"CI":["225","00","[02]\\d{9}",[10],[["(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",["2"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]]],"CK":["682","00","[2-578]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]]],"CL":["56","(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0","12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",[9,10,11],[["(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-36]"],"($1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]]],"CM":["237","00","[26]\\d{8}|88\\d{6,7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]|88"]]]],"CN":["86","00|1(?:[12]\\d|79)\\d\\d00","1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","(?:10|2[0-57-9])(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1",1],["(\\d{3})(\\d{7,8})","$1 $2",["9"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",1]],"0",0,"0|(1(?:[12]\\d|79)\\d\\d)",0,0,0,0,"00"],"CO":["57","00(?:4(?:[14]4|56)|[579])","(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",[10,11],[["(\\d{3})(\\d{7})","$1 $2",["6"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3[0-357]|91"]],["(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1",0,"$1 $2 $3"]],"0",0,"0(4(?:[14]4|56)|[579])?"],"CR":["506","00","(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"]]],0,0,"(19(?:0[0-2468]|1[09]|20|66|77|99))"],"CU":["53","119","[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",[6,7,8,10],[["(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],["(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["5"],"0$1"],["(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],"0"],"CV":["238","0","(?:[2-59]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]]],"CW":["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]"],"CX":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"0|([59]\\d{7})$","8$1",0,0,[["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",[9]],["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CY":["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]]],"CZ":["420","00","(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["96"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]]],"DE":["49","00","[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],["(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],["(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],["(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],["(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],["(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["15[0568]"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],["(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],["(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],["(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],["(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],"0"],"DJ":["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]]],"DK":["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]]],"DM":["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","767$1",0,"767"],"DO":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8001|8[024]9"],"DZ":["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],"0"],"EC":["593","00","1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)",0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],"0"],"EE":["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"EG":["20","00","[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[189]"],"0$1"]],"0"],"EH":["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,"528[89]"],"ER":["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],"0"],"ES":["34","00","[5-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]]],"ET":["251","00","(?:11|[2-579]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-579]"],"0$1"]],"0"],"FI":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",[5,6,7,8,9,10,11,12],[["(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],["(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],"0$1"],["(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],["(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],"0",0,0,0,0,"1[03-79]|[2-9]",0,"00"],"FJ":["679","0(?:0|52)","45\\d{5}|(?:0800\\d|[235-9])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,0,"00"],"FK":["500","00","[2-7]\\d{4}",[5]],"FM":["691","00","(?:[39]\\d\\d|820)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[389]"]]]],"FO":["298","00","[2-9]\\d{5}",[6],[["(\\d{6})","$1",["[2-9]"]]],0,0,"(10(?:01|[12]0|88))"],"FR":["33","00","[1-9]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],"0"],"GA":["241","00","(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"]],0,0,"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})","$1"],"GB":["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])","[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],"0",0,0,0,0,0,[["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[013579])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-246-9])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",[9,10]],["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]],0," x"],"GD":["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","473$1",0,"473"],"GE":["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],"0"],"GF":["594","00","(?:[56]94|80\\d|976)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"GG":["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,"0|([25-9]\\d{5})$","1481$1",0,0,[["1481[25-9]\\d{5}",[10]],["7(?:(?:781|839)\\d|911[17])\\d{5}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]]],"GH":["233","00","(?:[235]\\d{3}|800)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],"0"],"GI":["350","00","(?:[25]\\d\\d|606)\\d{5}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","00","(?:19|[2-689]\\d|70)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-9]"]]]],"GM":["220","00","[2-9]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"GN":["224","00","722\\d{6}|(?:3|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","00","(?:590|(?:69|80)\\d|976)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1289]|5[3-579]|6[0-289]|7[08]|8[0-689]|9\\d)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["976[01]\\d{5}"]]],"GQ":["240","00","222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","00","5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",[10,11,12],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],["(\\d{3})(\\d{3,4})(\\d{5})","$1 $2 $3",["8"]]]],"GT":["502","00","(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,"1|([3-9]\\d{6})$","671$1",0,"671"],"GW":["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]]],"GY":["592","001","9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-46-9]"]]]],"HK":["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,0,"00"],"HN":["504","00","8\\d{10}|[237-9]\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]]],"HR":["385","00","(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",[6,7,8,9],[["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0"],"HT":["509","00","[2-489]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-489]"]]]],"HU":["36","00","[235-7]\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],"06"],"ID":["62","00[89]","(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12,13],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0"],"IE":["353","00","(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],["(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"IL":["972","0(?:0|1[2-9])","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["(\\d{4})(\\d{3})","$1-$2",["125"]],["(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],["(\\d{4})(\\d{6})","$1-$2",["159"]],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],"0"],"IM":["44","00","1624\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"0|([25-8]\\d{5})$","1624$1",0,"74576|(?:16|7[56])24"],"IN":["91","00","(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",[8,9,10,11,12,13],[["(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],0,1],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],0,1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],"0$1",1],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]","1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",1],["(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",1],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],0,1],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],0,1]],"0"],"IO":["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]]],"IQ":["964","00","(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"IR":["98","00","[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",[4,5,6,7,10],[["(\\d{4,5})","$1",["96"],"0$1"],["(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],"0"],"IS":["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,0,"00"],"IT":["39","00","0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",[6,7,8,9,10,11],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[679])|[378]"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"],["3[1-9]\\d{8}|3[2-9]\\d{7}",[9,10]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],0,0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],"JE":["44","00","1534\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"0|([0-24-8]\\d{5})$","1534$1",0,0,[["1534[0-24-8]\\d{5}"],["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"],["80(?:07(?:35|81)|8901)\\d{4}"],["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],["701511\\d{4}"],0,["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"],["56\\d{8}"]]],"JM":["1","011","(?:[58]\\d\\d|658|900)\\d{7}",[10],0,"1",0,0,0,0,"658|876"],"JO":["962","00","(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"JP":["81","010","00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"]],"0"],"KE":["254","000","(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0"],"KG":["996","00","8\\d{9}|(?:[235-8]\\d|99)\\d{7}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],["(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"KH":["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"KI":["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,"0"],"KM":["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]]],"KN":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","869$1",0,"869"],"KP":["850","00|99","85\\d{6}|(?:19\\d|[2-7])\\d{7}",[8,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0"],"KR":["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1"],["(\\d{4})(\\d{4})","$1-$2",["1"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1"]],"0",0,"0(8(?:[1-46-8]|5\\d\\d))?"],"KW":["965","00","18\\d{5}|(?:[2569]\\d|41)\\d{6}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[245]"]]]],"KY":["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","345$1",0,"345"],"KZ":["7","810","(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",[10,14],0,"8",0,0,0,0,"33|7",0,"8~10"],"LA":["856","00","[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[013-9]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],"0"],"LB":["961","00","[27-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27-9]"]]],"0"],"LC":["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,"1|([2-8]\\d{6})$","758$1",0,"758"],"LI":["423","00","[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2379]|8(?:0[09]|7)","[2379]|8(?:0(?:02|9)|7)"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],"0",0,"0|(1001)"],"LK":["94","00","[1-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],"0"],"LR":["231","00","(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[4-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3578]"],"0$1"]],"0"],"LS":["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]]],"LT":["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(8-$1)",1],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1",1],["(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(8-$1)",1],["(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(8-$1)",1]],"8",0,"[08]"],"LU":["352","00","35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]],0,0,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],"LV":["371","00","(?:[268]\\d|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]]],"LY":["218","00","[2-9]\\d{8}",[9],[["(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],"0"],"MA":["212","00","[5-8]\\d{8}",[9],[["(\\d{5})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29[89]|389)","5(?:29[89]|389)0"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],["(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|9)|892","5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],["(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],"0",0,0,0,0,0,[["5(?:29(?:[189][05]|2[29]|3[01])|389[05])\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[08]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}"],["80\\d{7}"],["89\\d{7}"],0,0,0,0,["592(?:4[0-2]|93)\\d{4}"]]],"MC":["377","00","(?:[3489]|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],"0"],"MD":["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],"0"],"ME":["382","00","(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],"0"],"MF":["590","00","(?:590|(?:69|80)\\d|976)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["976[01]\\d{5}"]]],"MG":["261","00","[23]\\d{8}",[9],[["(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,"0|([24-9]\\d{6})$","20$1"],"MH":["692","011","329\\d{4}|(?:[256]\\d|45)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1"],"MK":["389","00","[2-578]\\d{7}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2|34[47]|4(?:[37]7|5[47]|64)"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],"0"],"ML":["223","00","[24-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]]],"MM":["95","00","1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",[6,7,8,9,10],[["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],["(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],["(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],"0"],"MN":["976","001","[12]\\d{7,9}|[5-9]\\d{7}",[8,9,10],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[5-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],"0"],"MO":["853","00","0800\\d{3}|(?:28|[68]\\d)\\d{6}",[7,8],[["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{4})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","011","[58]\\d{9}|(?:67|90)0\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","670$1",0,"670"],"MQ":["596","00","(?:69|80)\\d{7}|(?:59|97)6\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"MR":["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","011","(?:[58]\\d\\d|664|900)\\d{7}",[10],0,"1",0,"1|([34]\\d{6})$","664$1",0,"664"],"MT":["356","00","3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]]],"MU":["230","0(?:0|[24-7]0|3[03])","(?:5|8\\d\\d)\\d{7}|[2-468]\\d{6}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],["(\\d{4})(\\d{4})","$1 $2",["5"]],["(\\d{5})(\\d{5})","$1 $2",["8"]]],0,0,0,0,0,0,0,"020"],"MV":["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[3467]|9[13-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,0,"00"],"MW":["265","00","(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],"0"],"MX":["52","0[09]","1(?:(?:44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[017]\\d|[235][1-9]|4[0-35-9]|6[0-46-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}",[10,11],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],0,1],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],0,1],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 $3 $4",["1"],0,1]],"01",0,"0(?:[12]|4[45])|1",0,0,0,0,"00"],"MY":["60","00","1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9]|53)|8","1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1(?:[367]|80)"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],"0"],"MZ":["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"NA":["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"NC":["687","00","(?:050|[2-57-9]\\d\\d)\\d{3}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[02-57-9]"]]]],"NE":["227","00","[027-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[04]"]]]],"NF":["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],["(\\d)(\\d{5})","$1 $2",["[13]"]]],0,0,"([0-258]\\d{4})$","3$1"],"NG":["234","009","(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",[7,8,10,11,12,13,14],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["78"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-7]|8[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],["(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],"0"],"NI":["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]]],"NL":["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",[5,6,7,8,9,10,11],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-578]|91"],"0$1"],["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3",["9"],"0$1"]],"0"],"NO":["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[489]|59"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],0,0,0,0,0,"[02-689]|7[0-8]"],"NP":["977","00","(?:1\\d|9)\\d{9}|[1-9]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],"0$1"],["(\\d{3})(\\d{7})","$1-$2",["9"]]],"0"],"NR":["674","00","(?:444|(?:55|8\\d)\\d|666)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]]],"NU":["683","00","(?:[47]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]]],"NZ":["64","0(?:0|161)","[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,8})","$1 $2",["8[1-579]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|[89]0","50(?:[0367]|88)|[89]0"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[59]|80"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7|86"],"0$1"]],"0",0,0,0,0,0,0,"00"],"OM":["968","00","(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[179]"]]]],"PA":["507","00","(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",[7,8,10,11],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["[68]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]]],"PE":["51","00|19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,0,"00"," Anexo "],"PF":["689","00","4\\d{5}(?:\\d{2})?|8\\d{7,8}",[6,8,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4|8[7-9]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"PG":["675","00|140[1-3]","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],["(\\d{4})(\\d{4})","$1 $2",["[78]"]]],0,0,0,0,0,0,0,"00"],"PH":["63","00","(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",[6,8,9,10,11,12,13],[["(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0"],"PK":["92","00","122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["1"]],["(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],"(0$1)"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],["(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],["(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],"0"],"PL":["48","00","(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",[6,7,8,9,10],[["(\\d{5})","$1",["19"]],["(\\d{3})(\\d{3})","$1 $2",["11|20|64"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]]],"PM":["508","00","(?:[45]|80\\d\\d)\\d{5}",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"PR":["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939"],"PS":["970","00","[2489]2\\d{6}|(?:1\\d|5)\\d{8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"PT":["351","00","1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["16|[236-9]"]]]],"PW":["680","01[12]","(?:[24-8]\\d\\d|345|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"PY":["595","00","59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],["(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-6])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],"0"],"QA":["974","00","[2-7]\\d{7}|800\\d{4}(?:\\d{2})?|2\\d{6}",[7,8,9],[["(\\d{3})(\\d{4})","$1 $2",["2[126]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]]]],"RE":["262","00","976\\d{6}|(?:26|[68]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"],"0$1"]],"0",0,0,0,0,"26[23]|69|[89]"],"RO":["40","00","(?:[2378]\\d|90)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[237-9]"],"0$1"]],"0",0,0,0,0,0,0,0," int "],"RS":["381","00","38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",[6,7,8,9,10,11,12],[["(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],["(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],"0"],"RU":["7","810","8\\d{13}|[347-9]\\d{9}",[10,14],[["(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",1],["(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",1],["(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],"8",0,0,0,0,"3[04-689]|[489]",0,"8~10"],"RW":["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]]],"0"],"SA":["966","00","92\\d{7}|(?:[15]|8\\d)\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["9"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],"0"],"SB":["677","0[01]","(?:[1-6]|[7-9]\\d\\d)\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],"SC":["248","010|0[0-2]","800\\d{4}|(?:[249]\\d|64)\\d{5}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],0,0,0,0,0,0,0,"00"],"SD":["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],"0"],"SE":["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44|9)"],"0$1",0,"$1 $2"],["(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3"],["(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1",0,"$1 $2 $3"],["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3 $4"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1",0,"$1 $2 $3 $4"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1",0,"$1 $2 $3 $4 $5"]],"0"],"SG":["65","0[0-3]\\d","(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-5]|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"SH":["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]"],"SI":["386","00|10(?:22|66|88|99)","[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",[5,6,7,8],[["(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],"0",0,0,0,0,0,0,"00"],"SJ":["47","00","0\\d{4}|(?:[489]\\d|[57]9)\\d{6}",[5,8],0,0,0,0,0,0,"79"],"SK":["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],"0"],"SL":["232","00","(?:[237-9]\\d|66)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],"0"],"SM":["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(\\d{4})(\\d{6})","$1 $2",["0"]]],0,0,"([89]\\d{5})$","0549$1"],"SN":["221","00","(?:[378]\\d|93)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]]],"SO":["252","00","[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",[6,7,8,9],[["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],["(\\d)(\\d{7})","$1 $2",["24|[67]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3478]|64|90"]],["(\\d{2})(\\d{5,7})","$1 $2",["1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"]]],"0"],"SR":["597","00","(?:[2-5]|68|[78]\\d)\\d{5}",[6,7],[["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0"],"ST":["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]]],"SV":["503","00","[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","011","7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|(5\\d{6})$","721$1",0,"721"],"SY":["963","00","[1-39]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1",1]],"0"],"SZ":["268","00","0800\\d{4}|(?:[237]\\d|900)\\d{6}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]]],"TA":["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8"],"TC":["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,"1|([2-479]\\d{6})$","649$1",0,"649"],"TD":["235","00|16","(?:22|[69]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],0,0,0,0,0,0,0,"00"],"TG":["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]]],"TH":["66","00[1-9]","(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",[8,9,10,13],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"TJ":["992","810","(?:00|[1-57-9]\\d)\\d{7}",[9],[["(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[34]7|91[78]"]],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0-57-9]"]]],0,0,0,0,0,0,0,"8~10"],"TK":["690","00","[2-47]\\d{3,6}",[4,5,6,7]],"TL":["670","00","7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]]],"TM":["993","810","[1-6]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"TN":["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]]],"TO":["676","00","(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]]],"TR":["90","00","4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",[7,10,12,13],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|616)","5(?:[0-59]|6161)"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",1],["(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",1]],"0"],"TT":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-46-8]\\d{6})$","868$1",0,"868"],"TV":["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7],[["(\\d{2})(\\d{3})","$1 $2",["2"]],["(\\d{2})(\\d{4})","$1 $2",["90"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"TW":["886","0(?:0[25-79]|19)","[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10,11],[["(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,0,0,"#"],"TZ":["255","00[056]","(?:[25-8]\\d|41|90)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["5"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],"0"],"UA":["380","00","[89]\\d{9}|[3-9]\\d{8}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])","3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|89|9[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,0,"0~0"],"UG":["256","00[057]","800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",[9],[["(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],"0"],"US":["1","011","[2-9]\\d{9}|3\\d{6}",[10],[["(\\d{3})(\\d{4})","$1-$2",["310"],0,1],["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[["505(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}"]]],"UY":["598","0(?:0|1[3-9]\\d)","4\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["405|8|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[124]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["4"],"0$1"]],"0",0,0,0,0,0,0,"00"," int. "],"UZ":["998","810","(?:33|55|[679]\\d|88)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[35-9]"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"VA":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],0,0,0,0,0,0,"06698"],"VC":["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","784$1",0,"784"],"VE":["58","00","[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",[10],[["(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1"]],"0"],"VG":["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-578]\\d{6})$","284$1",0,"284"],"VI":["1","011","[58]\\d{9}|(?:34|90)0\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","340$1",0,"340"],"VN":["84","00","[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",1],["(\\d{4})(\\d{4,6})","$1 $2",["1"],0,1],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[69]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3578]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",1]],"0"],"VU":["678","00","[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[57-9]"]]]],"WF":["681","00","(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[478]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"WS":["685","0","(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",[5,6,7,10],[["(\\d{5})","$1",["[2-5]|6[1-9]"]],["(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"XK":["383","00","[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23]"],"0$1"]],"0"],"YE":["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7[24-68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0"],"YT":["262","00","80\\d{7}|(?:26|63)9\\d{6}",[9],0,"0",0,0,0,0,"269|63"],"ZA":["27","00","[1-79]\\d{8}|8\\d{4,9}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"ZM":["260","00","800\\d{6}|(?:21|63|[79]\\d)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],"0"],"ZW":["263","00","2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",[5,6,7,8,9,10],[["(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],["(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],["(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],"0"]},"nonGeographic":{"800":["800",0,"(?:00|[1-9]\\d)\\d{6}",[8],[["(\\d{4})(\\d{4})","$1 $2",["\\d"]]],0,0,0,0,0,0,[0,0,["(?:00|[1-9]\\d)\\d{6}"]]],"808":["808",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,0,["[1-9]\\d{7}"]]],"870":["870",0,"7\\d{11}|[35-7]\\d{8}",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[35-7]"]]],0,0,0,0,0,0,[0,["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]],"878":["878",0,"10\\d{10}",[12],[["(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["10\\d{10}"]]],"881":["881",0,"[0-36-9]\\d{8}",[9],[["(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-36-9]"]]],0,0,0,0,0,0,[0,["[0-36-9]\\d{8}"]]],"882":["882",0,"[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5})","$1 $2",["16|342"]],["(\\d{2})(\\d{6})","$1 $2",["4"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[19]"]],["(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["34[57]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],["(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-3]"]]],0,0,0,0,0,0,[0,["342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}",[7,8,9,10,12]],0,0,0,0,0,0,["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"]]],"883":["883",0,"(?:210|370\\d\\d)\\d{7}|51\\d{7}(?:\\d{3})?",[9,10,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["2"]],["(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[35]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["(?:210|(?:370[1-9]|51[013]0)\\d)\\d{7}|5100\\d{5}"]]],"888":["888",0,"\\d{11}",[11],[["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],0,0,0,0,0,0,[0,0,0,0,0,0,["\\d{11}"]]],"979":["979",0,"[1359]\\d{8}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],0,0,0,0,0,0,[0,0,0,["[1359]\\d{8}"]]]}});
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/constants.js
// The minimum length of the national significant number.
var MIN_LENGTH_FOR_NSN = 2; // The ITU says the maximum length should be 15,
// but one can find longer numbers in Germany.

var MAX_LENGTH_FOR_NSN = 17; // The maximum length of the country calling code.

var MAX_LENGTH_COUNTRY_CODE = 3; // Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).

var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"

var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['

var TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.

var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')
//# sourceMappingURL=constants.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/ParseError.js
function ParseError_typeof(obj) { "@babel/helpers - typeof"; return ParseError_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, ParseError_typeof(obj); }

function ParseError_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ParseError_createClass(Constructor, protoProps, staticProps) { if (protoProps) ParseError_defineProperties(Constructor.prototype, protoProps); if (staticProps) ParseError_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function ParseError_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ParseError_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) ParseError_setPrototypeOf(subClass, superClass); }

function ParseError_createSuper(Derived) { var hasNativeReflectConstruct = ParseError_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ParseError_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ParseError_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ParseError_possibleConstructorReturn(this, result); }; }

function ParseError_possibleConstructorReturn(self, call) { if (call && (ParseError_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return ParseError_assertThisInitialized(self); }

function ParseError_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, ParseError_getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return ParseError_setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (ParseError_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) ParseError_setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function ParseError_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function ParseError_setPrototypeOf(o, p) { ParseError_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ParseError_setPrototypeOf(o, p); }

function ParseError_getPrototypeOf(o) { ParseError_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ParseError_getPrototypeOf(o); }

// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var ParseError = /*#__PURE__*/function (_Error) {
  ParseError_inherits(ParseError, _Error);

  var _super = ParseError_createSuper(ParseError);

  function ParseError(code) {
    var _this;

    ParseError_classCallCheck(this, ParseError);

    _this = _super.call(this, code); // Set the prototype explicitly.
    // Any subclass of FooError will have to manually set the prototype as well.

    Object.setPrototypeOf(ParseError_assertThisInitialized(_this), ParseError.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }

  return ParseError_createClass(ParseError);
}( /*#__PURE__*/_wrapNativeSuper(Error));


//# sourceMappingURL=ParseError.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/tools/semver-compare.js
// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
/* harmony default export */ var semver_compare = (function (a, b) {
  a = a.split('-');
  b = b.split('-');
  var pa = a[0].split('.');
  var pb = b[0].split('.');

  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }

  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }

  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
});
//# sourceMappingURL=semver-compare.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/metadata.js
function metadata_typeof(obj) { "@babel/helpers - typeof"; return metadata_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, metadata_typeof(obj); }

function metadata_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function metadata_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function metadata_createClass(Constructor, protoProps, staticProps) { if (protoProps) metadata_defineProperties(Constructor.prototype, protoProps); if (staticProps) metadata_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

 // Added "possibleLengths" and renamed
// "country_phone_code_to_countries" to "country_calling_codes".

var V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".

var V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.

var V4 = '1.7.35';
var DEFAULT_EXT_PREFIX = ' ext. ';
var CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */

var Metadata = /*#__PURE__*/function () {
  function Metadata(metadata) {
    metadata_classCallCheck(this, Metadata);

    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }

  metadata_createClass(Metadata, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function (_) {
        return _ !== '001';
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
      // It's present in metadata generated from `1.7.35` to `1.7.37`.
      // The test case could be found by searching for "nonGeographical".

      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== undefined;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }

      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    } // Deprecated.

  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      // Supports just passing `callingCode` as the first argument.
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }

      if (countryCode && countryCode !== '001') {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }

        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }

        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = undefined;
      }

      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];

      if (countryCodes) {
        // Metadata before V4 included "non-geographic entity" calling codes
        // inside `country_calling_codes` (for example, `"881":["001"]`).
        // Now the semantics of `country_calling_codes` has changed:
        // it's specifically for "countries" now.
        // Older versions of custom metadata will simply skip parsing
        // "non-geographic entity" phone numbers with new versions
        // of this library: it's not considered a bug,
        // because such numbers are extremely rare,
        // and developers extremely rarely use custom metadata.
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }

        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);

      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);

      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }

      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];

        if (metadata) {
          return metadata;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        // In that metadata, there was no concept of "non-geographic" metadata
        // so metadata for `001` country code was stored along with other countries.
        // The test case can be found by searching for:
        // "should work around `nonGeographic` metadata not existing".
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return this.metadata.countries['001'];
        }
      }
    } // Deprecated.

  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    } // Deprecated.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    } // Deprecated.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    } // Deprecated.

  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    } // Deprecated.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    } // Deprecated.

  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    } // Deprecated.

  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    } // Deprecated.

  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    } // Deprecated.

  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    } // Deprecated.

  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    } // Deprecated.

  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    } // Deprecated.

  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    } // Deprecated.

  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== undefined;
    }
  }]);

  return Metadata;
}();



var NumberingPlan = /*#__PURE__*/function () {
  function NumberingPlan(metadata, globalMetadataObject) {
    metadata_classCallCheck(this, NumberingPlan);

    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }

  metadata_createClass(NumberingPlan, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    } // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.

  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    } // Is always present.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    } // Is only present when a country supports multiple IDD prefixes.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    } // "possible length" data is always present in Google's metadata.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    } // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "formats",
    value: function formats() {
      var _this = this;

      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats.map(function (_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    } // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      // If `national_prefix_for_parsing` is not set explicitly,
      // then infer it from `national_prefix` (if any)
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    } // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      // Versions 1.2.0 - 1.2.4: can be `[]`.

      /* istanbul ignore next */
      if (this.types() && this.types().length === 0) {
        return false;
      } // Versions <= 1.2.4: can be `undefined`.
      // Version >= 1.2.5: can be `0`.


      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && metadata_getType(this.types(), _type2)) {
        return new Type(metadata_getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);

  return NumberingPlan;
}();

var Format = /*#__PURE__*/function () {
  function Format(format, metadata) {
    metadata_classCallCheck(this, Format);

    this._format = format;
    this.metadata = metadata;
  }

  metadata_createClass(Format, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      // National prefix is omitted if there's no national prefix formatting rule
      // set for this country, or when the national prefix formatting rule
      // contains no national prefix itself, or when this rule is set but
      // national prefix is optional for this phone number format
      // (and it is not enforced explicitly)
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    } // Checks whether national prefix formatting rule contains national prefix.

  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
      // when `national_prefix_formatting_rule` is not present.
      // So, `true` or `false` are returned explicitly here, so that
      // `0` number isn't returned.
      ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);

  return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */


var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;

var Type = /*#__PURE__*/function () {
  function Type(type, metadata) {
    metadata_classCallCheck(this, Type);

    this.type = type;
    this.metadata = metadata;
  }

  metadata_createClass(Type, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);

  return Type;
}();

function metadata_getType(types, type) {
  switch (type) {
    case 'FIXED_LINE':
      return types[0];

    case 'MOBILE':
      return types[1];

    case 'TOLL_FREE':
      return types[2];

    case 'PREMIUM_RATE':
      return types[3];

    case 'PERSONAL_NUMBER':
      return types[4];

    case 'VOICEMAIL':
      return types[5];

    case 'UAN':
      return types[6];

    case 'PAGER':
      return types[7];

    case 'VOIP':
      return types[8];

    case 'SHARED_COST':
      return types[9];
  }
}

function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
  } // `country_phone_code_to_countries` was renamed to
  // `country_calling_codes` in `1.0.18`.


  if (!is_object(metadata) || !is_object(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(is_object(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + type_of(metadata) + ': ' + metadata, "."));
  }
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */

var is_object = function is_object(_) {
  return metadata_typeof(_) === 'object';
}; // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */


var type_of = function type_of(_) {
  return metadata_typeof(_);
};
/**
 * Returns extension prefix for a country.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string?}
 * @example
 * // Returns " ext. "
 * getExtPrefix("US")
 */


function getExtPrefix(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).ext();
  }

  return DEFAULT_EXT_PREFIX;
}
/**
 * Returns "country calling code" for a country.
 * Throws an error if the country doesn't exist or isn't supported by this library.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string}
 * @example
 * // Returns "44"
 * getCountryCallingCode("GB")
 */

function getCountryCallingCode(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).countryCallingCode();
  }

  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata) {
  // metadata = new Metadata(metadata)
  // return metadata.hasCountry(country)
  return metadata.countries[country] !== undefined;
}

function setVersion(metadata) {
  var version = metadata.version;

  if (typeof version === 'number') {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (semver_compare(version, V3) === -1) {
      this.v2 = true;
    } else if (semver_compare(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
// function isCountryCode(countryCode) {
// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
// }
//# sourceMappingURL=metadata.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/extension/createExtensionPattern.js
 // The RFC 3966 format for extensions.

var RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */

var createExtensionPattern_getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
/**
 * Helper initialiser method to create the regular-expression pattern to match
 * extensions.
 * Copy-pasted from Google's `libphonenumber`:
 * https://github.com/google/libphonenumber/blob/55b2646ec9393f4d3d6661b9c82ef9e258e8b829/javascript/i18n/phonenumbers/phonenumberutil.js#L759-L766
 * @return {string} RegEx pattern to capture extensions.
 */


function createExtensionPattern(purpose) {
  // We cap the maximum length of an extension based on the ambiguity of the way
  // the extension is prefixed. As per ITU, the officially allowed length for
  // extensions is actually 40, but we don't support this since we haven't seen real
  // examples and this introduces many false interpretations as the extension labels
  // are not standardized.

  /** @type {string} */
  var extLimitAfterExplicitLabel = '20';
  /** @type {string} */

  var extLimitAfterLikelyLabel = '15';
  /** @type {string} */

  var extLimitAfterAmbiguousChar = '9';
  /** @type {string} */

  var extLimitWhenNotSure = '6';
  /** @type {string} */

  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.

  /** @type {string} */

  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  /** @type {string} */

  var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
  // patterns like "ext.".

  /** @type {string} */

  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
  // commonly used or more ambiguous extension labels.

  /** @type {string} */

  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.

  /** @type {string} */

  var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
  // comma as extension label may have it.

  /** @type {string} */

  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
  // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
  // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
  // button with the extension number following.

  /** @type {string} */

  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  /** @type {string} */

  var rfcExtn = RFC3966_EXTN_PREFIX + createExtensionPattern_getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  /** @type {string} */

  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + createExtensionPattern_getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  /** @type {string} */

  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + createExtensionPattern_getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  /** @type {string} */

  var americanStyleExtnWithSuffix = ambiguousSeparator + createExtensionPattern_getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  /** @type {string} */

  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + createExtensionPattern_getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  /** @type {string} */

  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + createExtensionPattern_getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
  // using ";ext=". The second more generic where extension is mentioned with explicit
  // labels like "ext:". In both the above cases we allow more numbers in extension than
  // any other extension labels. The third one captures when single character extension
  // labels or less commonly used labels are used. In such cases we capture fewer
  // extension digits in order to reduce the chance of falsely interpreting two
  // numbers beside each other as a number + extension. The fourth one covers the
  // special case of American numbers where the extension is written with a hash
  // at the end, such as "- 503#". The fifth one is exclusively for extension
  // autodialling formats which are used when dialling and in this case we accept longer
  // extensions. The last one is more liberal on the number of commas that acts as
  // extension labels, so we have a strict cap on the number of digits in such extensions.

  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}
//# sourceMappingURL=createExtensionPattern.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/isViablePhoneNumber.js

 //  Regular expression of viable phone numbers. This is location independent.
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//

var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}'; //
// And this is the second reg-exp:
// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
//

var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.

var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp('^' + '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){1,2}' + '$', 'i');
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
'(?:' + createExtensionPattern() + ')?'; // The combined regular expression for valid phone numbers:
//

var VALID_PHONE_NUMBER_PATTERN = new RegExp( // Either a short two-digit-only phone number
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + VALID_PHONE_NUMBER_WITH_EXTENSION + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
// all. At the moment, checks to see that the string begins with at least 2
// digits, ignoring any punctuation commonly found in phone numbers. This method
// does not require the number to be normalized in advance - but does assume
// that leading non-number symbols have been removed, such as by the method
// `extract_possible_number`.
//

function isViablePhoneNumber(number) {
  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.

function isViablePhoneNumberStart(number) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}
//# sourceMappingURL=isViablePhoneNumber.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/extension/extractExtension.js
 // Regexp of all known extension prefixes used by different regions followed by
// 1 or more valid digits, for use when parsing.

var EXTN_PATTERN = new RegExp('(?:' + createExtensionPattern() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
// connected, usually indicated with extn, ext, x or similar) from the end of
// the number, and returns it.

function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);

  if (start < 0) {
    return {};
  } // If we find a potential extension, and the number preceding this is a viable
  // number, we assume it is an extension.


  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;

  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }

    i++;
  }
}
//# sourceMappingURL=extractExtension.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/parseDigits.js
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = parseDigits_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function parseDigits_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return parseDigits_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return parseDigits_arrayLikeToArray(o, minLen); }

function parseDigits_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  "\uFF10": '0',
  // Fullwidth digit 0
  "\uFF11": '1',
  // Fullwidth digit 1
  "\uFF12": '2',
  // Fullwidth digit 2
  "\uFF13": '3',
  // Fullwidth digit 3
  "\uFF14": '4',
  // Fullwidth digit 4
  "\uFF15": '5',
  // Fullwidth digit 5
  "\uFF16": '6',
  // Fullwidth digit 6
  "\uFF17": '7',
  // Fullwidth digit 7
  "\uFF18": '8',
  // Fullwidth digit 8
  "\uFF19": '9',
  // Fullwidth digit 9
  "\u0660": '0',
  // Arabic-indic digit 0
  "\u0661": '1',
  // Arabic-indic digit 1
  "\u0662": '2',
  // Arabic-indic digit 2
  "\u0663": '3',
  // Arabic-indic digit 3
  "\u0664": '4',
  // Arabic-indic digit 4
  "\u0665": '5',
  // Arabic-indic digit 5
  "\u0666": '6',
  // Arabic-indic digit 6
  "\u0667": '7',
  // Arabic-indic digit 7
  "\u0668": '8',
  // Arabic-indic digit 8
  "\u0669": '9',
  // Arabic-indic digit 9
  "\u06F0": '0',
  // Eastern-Arabic digit 0
  "\u06F1": '1',
  // Eastern-Arabic digit 1
  "\u06F2": '2',
  // Eastern-Arabic digit 2
  "\u06F3": '3',
  // Eastern-Arabic digit 3
  "\u06F4": '4',
  // Eastern-Arabic digit 4
  "\u06F5": '5',
  // Eastern-Arabic digit 5
  "\u06F6": '6',
  // Eastern-Arabic digit 6
  "\u06F7": '7',
  // Eastern-Arabic digit 7
  "\u06F8": '8',
  // Eastern-Arabic digit 8
  "\u06F9": '9' // Eastern-Arabic digit 9

};
function parseDigit(character) {
  return DIGITS[character];
}
/**
 * Parses phone number digits from a string.
 * Drops all punctuation leaving only digits.
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * parseDigits('8 (800) 555')
 * // Outputs '8800555'.
 * ```
 */

function parseDigits(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = _createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    var digit = parseDigit(character);

    if (digit) {
      result += digit;
    }
  }

  return result;
}
//# sourceMappingURL=parseDigits.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/parseIncompletePhoneNumber.js
function parseIncompletePhoneNumber_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = parseIncompletePhoneNumber_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function parseIncompletePhoneNumber_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return parseIncompletePhoneNumber_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return parseIncompletePhoneNumber_arrayLikeToArray(o, minLen); }

function parseIncompletePhoneNumber_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


/**
 * Parses phone number characters from a string.
 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * // Outputs '8800555'.
 * parseIncompletePhoneNumber('8 (800) 555')
 * // Outputs '+7800555'.
 * parseIncompletePhoneNumber('+7 800 555')
 * ```
 */

function parseIncompletePhoneNumber(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = parseIncompletePhoneNumber_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    result += parsePhoneNumberCharacter(character, result) || '';
  }

  return result;
}
/**
 * Parses next character while parsing phone number digits (including a `+`)
 * from text: discards everything except `+` and digits, and `+` is only allowed
 * at the start of a phone number.
 * For example, is used in `react-phone-number-input` where it uses
 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string?} prevParsedCharacters - Previous parsed characters.
 * @param  {object} meta - Optional custom use-case-specific metadata.
 * @return {string?} The parsed character.
 */

function parsePhoneNumberCharacter(character, prevParsedCharacters) {
  // Only allow a leading `+`.
  if (character === '+') {
    // If this `+` is not the first parsed character
    // then discard it.
    if (prevParsedCharacters) {
      return;
    }

    return '+';
  } // Allow digits.


  return parseDigit(character);
}
//# sourceMappingURL=parseIncompletePhoneNumber.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/mergeArrays.js
function mergeArrays_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = mergeArrays_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function mergeArrays_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return mergeArrays_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mergeArrays_arrayLikeToArray(o, minLen); }

function mergeArrays_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Merges two arrays.
 * @param  {*} a
 * @param  {*} b
 * @return {*}
 */
function mergeArrays(a, b) {
  var merged = a.slice();

  for (var _iterator = mergeArrays_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;) {
    var element = _step.value;

    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }

  return merged.sort(function (a, b) {
    return a - b;
  }); // ES6 version, requires Set polyfill.
  // let merged = new Set(a)
  // for (const element of b) {
  // 	merged.add(i)
  // }
  // return Array.from(merged).sort((a, b) => a - b)
}
//# sourceMappingURL=mergeArrays.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/checkNumberLength.js

function checkNumberLength(nationalNumber, metadata) {
  return checkNumberLengthForType(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
// Should only be called for the "new" metadata which has "possible lengths".

function checkNumberLengthForType(nationalNumber, type, metadata) {
  var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
  // This is declared in the XML schema.
  // For size efficiency, where a sub-description (e.g. fixed-line)
  // has the same "<possiblePengths/>" as the "general description", this is missing,
  // so we fall back to the "general description". Where no numbers of the type
  // exist at all, there is one possible length (-1) which is guaranteed
  // not to match the length of any real phone number.

  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
  // Metadata before version `1.0.18` didn't contain `possible_lengths`.

  if (!possible_lengths) {
    return 'IS_POSSIBLE';
  }

  if (type === 'FIXED_LINE_OR_MOBILE') {
    // No such country in metadata.

    /* istanbul ignore next */
    if (!metadata.type('FIXED_LINE')) {
      // The rare case has been encountered where no fixedLine data is available
      // (true for some non-geographic entities), so we just check mobile.
      return checkNumberLengthForType(nationalNumber, 'MOBILE', metadata);
    }

    var mobile_type = metadata.type('MOBILE');

    if (mobile_type) {
      // Merge the mobile data in if there was any. "Concat" creates a new
      // array, it doesn't edit possible_lengths in place, so we don't need a copy.
      // Note that when adding the possible lengths from mobile, we have
      // to again check they aren't empty since if they are this indicates
      // they are the same as the general desc and should be obtained from there.
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
      // re-sort (duplicates are okay). Sorting isn't so expensive because
      // the lists are very small.
      // if (local_lengths) {
      // 	local_lengths = mergeArrays(local_lengths, mobile_type.possibleLengthsLocal())
      // } else {
      // 	local_lengths = mobile_type.possibleLengthsLocal()
      // }
    }
  } // If the type doesn't exist then return 'INVALID_LENGTH'.
  else if (type && !type_info) {
    return 'INVALID_LENGTH';
  }

  var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
  // // This is safe because there is never an overlap beween the possible lengths
  // // and the local-only lengths; this is checked at build time.
  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
  // {
  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
  // }

  var minimum_length = possible_lengths[0];

  if (minimum_length === actual_length) {
    return 'IS_POSSIBLE';
  }

  if (minimum_length > actual_length) {
    return 'TOO_SHORT';
  }

  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return 'TOO_LONG';
  } // We skip the first element since we've already checked it.


  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}
//# sourceMappingURL=checkNumberLength.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/isPossibleNumber_.js


function isPossiblePhoneNumber(input, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }

  metadata = new Metadata(metadata);

  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error('Invalid phone number object passed');
    }

    metadata.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }

    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }

      metadata.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error('Invalid phone number object passed');
      }

      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  } // Old metadata (< 1.0.18) had no "possible length" data.


  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
  } else {
    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
    // were missing for "non-geographical" numbering plans.
    // Just assume the number is possible in such cases:
    // it's unlikely that anyone generated their custom metadata
    // in that short period of time (one day).
    // This code can be removed in some future major version update.
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      // "Non-geographic entities" did't have `possibleLengths`
      // due to a bug in metadata generation process.
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata) {
  //, isInternational) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'IS_POSSIBLE':
      return true;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational

    default:
      return false;
  }
}
//# sourceMappingURL=isPossibleNumber_.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/RFC3966.js
function RFC3966_slicedToArray(arr, i) { return RFC3966_arrayWithHoles(arr) || RFC3966_iterableToArrayLimit(arr, i) || RFC3966_unsupportedIterableToArray(arr, i) || RFC3966_nonIterableRest(); }

function RFC3966_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function RFC3966_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function RFC3966_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function RFC3966_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = RFC3966_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function RFC3966_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return RFC3966_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return RFC3966_arrayLikeToArray(o, minLen); }

function RFC3966_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

 // https://www.ietf.org/rfc/rfc3966.txt

/**
 * @param  {string} text - Phone URI (RFC 3966).
 * @return {object} `{ ?number, ?ext }`.
 */

function parseRFC3966(text) {
  var number;
  var ext; // Replace "tel:" with "tel=" for parsing convenience.

  text = text.replace(/^tel:/, 'tel=');

  for (var _iterator = RFC3966_createForOfIteratorHelperLoose(text.split(';')), _step; !(_step = _iterator()).done;) {
    var part = _step.value;

    var _part$split = part.split('='),
        _part$split2 = RFC3966_slicedToArray(_part$split, 2),
        name = _part$split2[0],
        value = _part$split2[1];

    switch (name) {
      case 'tel':
        number = value;
        break;

      case 'ext':
        ext = value;
        break;

      case 'phone-context':
        // Only "country contexts" are supported.
        // "Domain contexts" are ignored.
        if (value[0] === '+') {
          number = value + number;
        }

        break;
    }
  } // If the phone number is not viable, then abort.


  if (!isViablePhoneNumber(number)) {
    return {};
  }

  var result = {
    number: number
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */

function formatRFC3966(_ref) {
  var number = _ref.number,
      ext = _ref.ext;

  if (!number) {
    return '';
  }

  if (number[0] !== '+') {
    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
  }

  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}
//# sourceMappingURL=RFC3966.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/matchesEntirely.js
/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */
function matchesEntirely(text, regular_expression) {
  // If assigning the `''` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  text = text || '';
  return new RegExp('^(?:' + regular_expression + ')$').test(text);
}
//# sourceMappingURL=matchesEntirely.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/getNumberType.js
function getNumberType_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = getNumberType_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function getNumberType_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return getNumberType_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return getNumberType_arrayLikeToArray(o, minLen); }

function getNumberType_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL']; // Finds out national phone number type (fixed line, mobile, etc)

function getNumberType(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {}; // When `parse()` returned `{}`
  // meaning that the phone number is not a valid one.

  if (!input.country) {
    return;
  }

  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
  // Is this national number even valid for this country

  if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  } // Is it fixed line number


  if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
    // Because duplicate regular expressions are removed
    // to reduce metadata size, if "mobile" pattern is ""
    // then it means it was removed due to being a duplicate of the fixed-line pattern.
    //
    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
      return 'FIXED_LINE_OR_MOBILE';
    } // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
    // For example, for "US" country.
    // Old metadata (< `1.0.18`) had a specific "types" data structure
    // that happened to be `undefined` for `MOBILE` in that case.
    // Newer metadata (>= `1.0.18`) has another data structure that is
    // not `undefined` for `MOBILE` in that case (it's just an empty array).
    // So this `if` is just for backwards compatibility with old metadata.


    if (!metadata.type('MOBILE')) {
      return 'FIXED_LINE_OR_MOBILE';
    } // Check if the number happens to qualify as both fixed line and mobile.
    // (no such country in the minimal metadata set)

    /* istanbul ignore if */


    if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
      return 'FIXED_LINE_OR_MOBILE';
    }

    return 'FIXED_LINE';
  }

  for (var _iterator = getNumberType_createForOfIteratorHelperLoose(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;) {
    var type = _step.value;

    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  type = metadata.type(type);

  if (!type || !type.pattern()) {
    return false;
  } // Check if any possible number lengths are present;
  // if so, we use them to avoid checking
  // the validation pattern if they don't match.
  // If they are absent, this means they match
  // the general description, which we have
  // already checked before a specific number type.


  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }

  return matchesEntirely(nationalNumber, type.pattern());
}
//# sourceMappingURL=getNumberType.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/validate_.js



/**
 * Checks if a given phone number is valid.
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters (including punctuation).
 * If the `number` is an object, it is used as is.
 *
 * The optional `defaultCountry` argument is the default country.
 * I.e. it does not restrict to just that country,
 * e.g. in those cases where several countries share
 * the same phone numbering rules (NANPA, Britain, etc).
 * For example, even though the number `07624 369230`
 * belongs to the Isle of Man ("IM" country code)
 * calling `isValidNumber('07624369230', 'GB', metadata)`
 * still returns `true` because the country is not restricted to `GB`,
 * it's just that `GB` is the default one for the phone numbering rules.
 * For restricting the country see `isValidNumberForRegion()`
 * though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Examples:
 *
 * ```js
 * isValidNumber('+78005553535', metadata)
 * isValidNumber('8005553535', 'RU', metadata)
 * isValidNumber('88005553535', 'RU', metadata)
 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */

function isValidNumber(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata); // This is just to support `isValidNumber({})`
  // for cases when `parseNumber()` returns `{}`.

  if (!input.country) {
    return false;
  }

  metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
  // distinguishing different countries having the same `countryCallingCode`.

  if (metadata.hasTypes()) {
    return getNumberType(input, options, metadata.metadata) !== undefined;
  } // If there are no type regexps for this country in metadata then use
  // `nationalNumberPattern` as a "better than nothing" replacement.


  var national_number = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(national_number, metadata.nationalNumberPattern());
}
//# sourceMappingURL=validate_.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/applyInternationalSeparatorStyle.js
 // Removes brackets and replaces dashes with spaces.
//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
//
// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
// And here's a quote from WikiPedia's "North American Numbering Plan" page:
// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
//
// "The country calling code for all countries participating in the NANP is 1.
// In international format, an NANP number should be listed as +1 301 555 01 00,
// where 301 is an area code (Maryland)."
//
// I personally prefer the international format without any punctuation.
// For example, brackets are remnants of the old age, meaning that the
// phone number part in brackets (so called "area code") can be omitted
// if dialing within the same "area".
// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
// He has a couple of seconds to memorize that number until it passes by.
// If it were spaces instead of hyphens the man wouldn't necessarily get it,
// but with hyphens instead of spaces the grouping is more explicit.
// I personally think that hyphens introduce visual clutter,
// so I prefer replacing them with spaces in international numbers.
// In the modern age all output is done on displays where spaces are clearly distinguishable
// so hyphens can be safely replaced with spaces without losing any legibility.
//

function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
}
//# sourceMappingURL=applyInternationalSeparatorStyle.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/formatNationalNumberUsingFormat.js
 // This was originally set to $1 but there are some countries for which the
// first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly. Therefore, we use `\d`, so that the first
// group actually used in the pattern will be matched.

var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat,
      withNationalPrefix = _ref.withNationalPrefix,
      carrierCode = _ref.carrierCode,
      metadata = _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // This library doesn't use `domestic_carrier_code_formatting_rule`,
  // because that one is only used when formatting phone numbers
  // for dialing from a mobile phone, and this is not a dialing library.
  // carrierCode && format.domesticCarrierCodeFormattingRule()
  // 	// First, replace the $CC in the formatting rule with the desired carrier code.
  // 	// Then, replace the $FG in the formatting rule with the first group
  // 	// and the carrier code combined in the appropriate way.
  // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
  // 	: (
  // 		withNationalPrefix && format.nationalPrefixFormattingRule()
  // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
  // 			: format.format()
  // 	)
  withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());

  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }

  return formattedNumber;
}
//# sourceMappingURL=formatNationalNumberUsingFormat.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/getIddPrefix.js

/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */

var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
// a preferred IDD prefix is returned.

function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);

  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }

  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}
//# sourceMappingURL=getIddPrefix.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/format_.js
function format_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = format_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function format_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return format_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return format_arrayLikeToArray(o, minLen); }

function format_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function format_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function format_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? format_ownKeys(Object(source), !0).forEach(function (key) { format_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : format_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function format_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js





var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  }
}; // Formats a phone number
//
// Example use cases:
//
// ```js
// formatNumber('8005553535', 'RU', 'INTERNATIONAL')
// formatNumber('8005553535', 'RU', 'INTERNATIONAL', metadata)
// formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL')
// formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', metadata)
// formatNumber('+78005553535', 'NATIONAL')
// formatNumber('+78005553535', 'NATIONAL', metadata)
// ```
//

function formatNumber(input, format, options, metadata) {
  // Apply default options.
  if (options) {
    options = format_objectSpread(format_objectSpread({}, DEFAULT_OPTIONS), options);
  } else {
    options = DEFAULT_OPTIONS;
  }

  metadata = new Metadata(metadata);

  if (input.country && input.country !== '001') {
    // Validate `input.country`.
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }

    metadata.country(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || '';

  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
  // but Babel has a bug and it says "duplicate variable declaration".

  var number;

  switch (format) {
    case 'NATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return '';
      }

      number = formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'INTERNATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }

      number = formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'E.164':
      // `E.164` doesn't define "phone number extensions".
      return "+".concat(countryCallingCode).concat(nationalNumber);

    case 'RFC3966':
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?

    case 'IDD':
      if (!options.fromCountry) {
        return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
      }

      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);

    default:
      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
  }
}

function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);

  if (!format) {
    return number;
  }

  return formatNationalNumberUsingFormat(number, format, {
    useInternationalFormat: formatAs === 'INTERNATIONAL',
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode: carrierCode,
    metadata: metadata
  });
}

function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = format_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;) {
    var format = _step.value;

    // Validate leading digits.
    // The test case for "else path" could be found by searching for
    // "format.leadingDigitsPatterns().length === 0".
    if (format.leadingDigitsPatterns().length > 0) {
      // The last leading_digits_pattern is used here, as it is the most detailed
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format

      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    } // Check that the national number matches the phone number format regular expression


    if (matchesEntirely(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}

function addExtension(formattedNumber, ext, metadata, formatExtension) {
  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}

function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata.metadata); // When calling within the same country calling code.

  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
    // but prefix it with the country calling code.

    if (countryCallingCode === '1') {
      return countryCallingCode + ' ' + formattedNumber;
    } // If regions share a country calling code, the country calling code need
    // not be dialled. This also applies when dialling within a region, so this
    // if clause covers both these cases. Technically this is the case for
    // dialling from La Reunion to other overseas departments of France (French
    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
    // this edge case for now and for those cases return the version including
    // country calling code. Details here:
    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
    //


    return formattedNumber;
  }

  var iddPrefix = getIddPrefix(fromCountry, undefined, metadata.metadata);

  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
  }
}
//# sourceMappingURL=format_.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/PhoneNumber.js
function PhoneNumber_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PhoneNumber_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PhoneNumber_ownKeys(Object(source), !0).forEach(function (key) { PhoneNumber_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PhoneNumber_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function PhoneNumber_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function PhoneNumber_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PhoneNumber_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function PhoneNumber_createClass(Constructor, protoProps, staticProps) { if (protoProps) PhoneNumber_defineProperties(Constructor.prototype, protoProps); if (staticProps) PhoneNumber_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }







var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;

var PhoneNumber_PhoneNumber = /*#__PURE__*/function () {
  function PhoneNumber(countryCallingCode, nationalNumber, metadata) {
    PhoneNumber_classCallCheck(this, PhoneNumber);

    if (!countryCallingCode) {
      throw new TypeError('`country` or `countryCallingCode` not passed');
    }

    if (!nationalNumber) {
      throw new TypeError('`nationalNumber` not passed');
    }

    if (!metadata) {
      throw new TypeError('`metadata` not passed');
    }

    var _metadata = new Metadata(metadata); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.


    if (isCountryCode(countryCallingCode)) {
      this.country = countryCallingCode;

      _metadata.country(countryCallingCode);

      countryCallingCode = _metadata.countryCallingCode();
    } else {
      /* istanbul ignore if */
      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (_metadata.isNonGeographicCallingCode(countryCallingCode)) {
          this.country = '001';
        }
      }
    }

    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = '+' + this.countryCallingCode + this.nationalNumber;
    this.metadata = metadata;
  }

  PhoneNumber_createClass(PhoneNumber, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new Metadata(this.metadata);
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    } // // Is just an alias for `this.isValid() && this.country === country`.
    // // https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
    // isValidForRegion(country) {
    // 	return isValidNumberForRegion(this, country, { v2: true }, this.metadata)
    // }

  }, {
    key: "getType",
    value: function getType() {
      return getNumberType(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber(this, _format, options ? PhoneNumber_objectSpread(PhoneNumber_objectSpread({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format('NATIONAL', options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format('INTERNATIONAL', options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format('RFC3966', options);
    }
  }]);

  return PhoneNumber;
}();



var isCountryCode = function isCountryCode(value) {
  return /^[A-Z]{2}$/.test(value);
};
//# sourceMappingURL=PhoneNumber.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/stripIddPrefix.js


var CAPTURING_DIGIT_PATTERN = new RegExp('([' + VALID_DIGITS + '])');
function stripIddPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  } // Check if the number is IDD-prefixed.


  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());

  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  } // Strip IDD prefix.


  number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
  // then those digits are a country calling code.
  // Since no country code starts with a `0`,
  // the code below validates that the next digit (if present) is not `0`.

  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);

  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === '0') {
      return;
    }
  }

  return number;
}
//# sourceMappingURL=stripIddPrefix.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/extractNationalNumberFromPossiblyIncompleteNumber.js
/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    // See METADATA.md for the description of
    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
    // Attempt to parse the first digits as a national prefix.
    var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
    var prefixMatch = prefixPattern.exec(number);

    if (prefixMatch) {
      var nationalNumber;
      var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
      // If a `national_prefix_for_parsing` has any "capturing groups"
      // then it means that the national (significant) number is equal to
      // those "capturing groups" transformed via `national_prefix_transform_rule`,
      // and nothing could be said about the actual national prefix:
      // what is it and was it even there.
      // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
      // then everything it matches is a national prefix.
      // To determine whether `national_prefix_for_parsing` matched any
      // "capturing groups", the value of the result of calling `.exec()`
      // is looked at, and if it has non-undefined values where there're
      // "capturing groups" in the regular expression, then it means
      // that "capturing groups" have been matched.
      // It's not possible to tell whether there'll be any "capturing gropus"
      // before the matching process, because a `national_prefix_for_parsing`
      // could exhibit both behaviors.

      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];

      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
        // then carrier code is the second one.

        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } // If there're no "capturing groups",
      // or if there're "capturing groups" but no
      // `national_prefix_transform_rule`,
      // then just strip the national prefix from the number,
      // and possibly a carrier code.
      // Seems like there could be more.
      else {
        // `prefixBeforeNationalNumber` is the whole substring matched by
        // the `national_prefix_for_parsing` regular expression.
        // There seem to be no guarantees that it's just a national prefix.
        // For example, if there's a carrier code, it's gonna be a
        // part of `prefixBeforeNationalNumber` too.
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
        // then carrier code is the first one.

        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      } // Tries to guess whether a national prefix was present in the input.
      // This is not something copy-pasted from Google's library:
      // they don't seem to have an equivalent for that.
      // So this isn't an "officially approved" way of doing something like that.
      // But since there seems no other existing method, this library uses it.


      var nationalPrefix;

      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
        // `prefixMatch[0]` is `01115`, and `$1` is `11`,
        // and the rest of the phone number is `23456789`.
        // The national number is transformed via `9$1` to `91123456789`.
        // National prefix `0` is detected being present at the start.
        // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {

        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }

      return {
        nationalNumber: nationalNumber,
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode
      };
    }
  }

  return {
    nationalNumber: number
  };
}
//# sourceMappingURL=extractNationalNumberFromPossiblyIncompleteNumber.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/extractNationalNumber.js



/**
 * Strips national prefix and carrier code from a complete phone number.
 * The difference from the non-"FromCompleteNumber" function is that
 * it won't extract national prefix if the resultant number is too short
 * to be a complete number for the selected phone numbering plan.
 * @param  {string} number — Complete phone number digits.
 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */

function extractNationalNumber(number, metadata) {
  // Parsing national prefixes and carrier codes
  // is only required for local phone numbers
  // but some people don't understand that
  // and sometimes write international phone numbers
  // with national prefixes (or maybe even carrier codes).
  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
  // Google's original library forgives such mistakes
  // and so does this library, because it has been requested:
  // https://github.com/catamphetamine/libphonenumber-js/issues/127
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata),
      carrierCode = _extractNationalNumbe.carrierCode,
      nationalNumber = _extractNationalNumbe.nationalNumber;

  if (nationalNumber !== number) {
    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) {
      // Don't strip the national prefix.
      return {
        nationalNumber: number
      };
    } // Check the national (significant) number length after extracting national prefix and carrier code.
    // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.


    if (metadata.possibleLengths()) {
      // The number remaining after stripping the national prefix and carrier code
      // should be long enough to have a possible length for the country.
      // Otherwise, don't strip the national prefix and carrier code,
      // since the original number could be a valid number.
      // This check has been copy-pasted "as is" from Google's original library:
      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
      // It doesn't check for the "possibility" of the original `number`.
      // I guess it's fine not checking that one. It works as is anyway.
      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata)) {
        // Don't strip the national prefix.
        return {
          nationalNumber: number
        };
      }
    }
  }

  return {
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.

function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
  // The equivalent in Google's code is:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
  if (matchesEntirely(nationalNumberBefore, metadata.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata.nationalNumberPattern())) {
    return false;
  } // This "is possible" national number (length) check has been commented out
  // because it's superceded by the (effectively) same check done in the
  // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
  // In other words, why run the same check twice if it could only be run once.
  // // Check the national (significant) number length after extracting national prefix and carrier code.
  // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
  // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
  // if (metadata.possibleLengths()) {
  // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
  // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
  // 		return false
  // 	}
  // }


  return true;
}

function isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'TOO_SHORT':
    case 'INVALID_LENGTH':
      // This library ignores "local-only" phone numbers (for simplicity).
      // See the readme for more info on what are "local-only" phone numbers.
      // case 'IS_POSSIBLE_LOCAL_ONLY':
      return false;

    default:
      return true;
  }
}
//# sourceMappingURL=extractNationalNumber.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js





/**
 * Sometimes some people incorrectly input international phone numbers
 * without the leading `+`. This function corrects such input.
 * @param  {string} number — Phone number digits.
 * @param  {string?} country
 * @param  {string?} callingCode
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`.
 */

function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata) : callingCode;

  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new Metadata(metadata);
    metadata.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);

    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata),
        possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;

    var _extractNationalNumbe2 = extractNationalNumber(number, metadata),
        nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
    // or if it was too long before, we consider the number
    // with the country calling code stripped to be a better result
    // and keep that instead.
    // For example, in Germany (+49), `49` is a valid area code,
    // so if a number starts with `49`, it could be both a valid
    // national German number or an international number without
    // a leading `+`.


    if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata) === 'TOO_LONG') {
      return {
        countryCallingCode: countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }

  return {
    number: number
  };
}
//# sourceMappingURL=extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCode.js




/**
 * Converts a phone number digits (possibly with a `+`)
 * into a calling code and the rest phone number digits.
 * The "rest phone number digits" could include
 * a national prefix, carrier code, and national
 * (significant) number.
 * @param  {string} number — Phone number digits (possibly with a `+`).
 * @param  {string} [country] — Default country.
 * @param  {string} [callingCode] — Default calling code (some phone numbering plans are non-geographic).
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`
 * @example
 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
 * extractCountryCallingCode('2133734253', 'US', null, metadata)
 * extractCountryCallingCode('2133734253', null, '1', metadata)
 * extractCountryCallingCode('+12133734253', null, null, metadata)
 * extractCountryCallingCode('+12133734253', 'RU', null, metadata)
 */

function extractCountryCallingCode_extractCountryCallingCode(number, country, callingCode, metadata) {
  if (!number) {
    return {};
  } // If this is not an international phone number,
  // then either extract an "IDD" prefix, or extract a
  // country calling code from a number by autocorrecting it
  // by prepending a leading `+` in cases when it starts
  // with the country calling code.
  // https://wikitravel.org/en/International_dialling_prefix
  // https://github.com/catamphetamine/libphonenumber-js/issues/376


  if (number[0] !== '+') {
    // Convert an "out-of-country" dialing phone number
    // to a proper international phone number.
    var numberWithoutIDD = stripIddPrefix(number, country, callingCode, metadata); // If an IDD prefix was stripped then
    // convert the number to international one
    // for subsequent parsing.

    if (numberWithoutIDD && numberWithoutIDD !== number) {
      number = '+' + numberWithoutIDD;
    } else {
      // Check to see if the number starts with the country calling code
      // for the default country. If so, we remove the country calling code,
      // and do some checks on the validity of the number before and after.
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata),
            countryCallingCode = _extractCountryCallin.countryCallingCode,
            shorterNumber = _extractCountryCallin.number;

        if (countryCallingCode) {
          return {
            countryCallingCode: countryCallingCode,
            number: shorterNumber
          };
        }
      }

      return {
        number: number
      };
    }
  } // Fast abortion: country codes do not begin with a '0'


  if (number[1] === '0') {
    return {};
  }

  metadata = new Metadata(metadata); // The thing with country phone codes
  // is that they are orthogonal to each other
  // i.e. there's no such country phone code A
  // for which country phone code B exists
  // where B starts with A.
  // Therefore, while scanning digits,
  // if a valid country code is found,
  // that means that it is the country code.
  //

  var i = 2;

  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);

    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }

    i++;
  }

  return {};
}
//# sourceMappingURL=extractCountryCallingCode.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/helpers/getCountryByCallingCode.js
function getCountryByCallingCode_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = getCountryByCallingCode_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function getCountryByCallingCode_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return getCountryByCallingCode_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return getCountryByCallingCode_arrayLikeToArray(o, minLen); }

function getCountryByCallingCode_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



var getCountryByCallingCode_USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function getCountryByCallingCode(callingCode, nationalPhoneNumber, metadata) {
  /* istanbul ignore if */
  if (getCountryByCallingCode_USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
    if (metadata.isNonGeographicCallingCode(callingCode)) {
      return '001';
    }
  } // Is always non-empty, because `callingCode` is always valid


  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return;
  } // If there's just one country corresponding to the country code,
  // then just return it, without further phone number digits validation.


  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }

  return selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata.metadata);
}

function selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata) {
  // Re-create `metadata` because it will be selecting a `country`.
  metadata = new Metadata(metadata);

  for (var _iterator = getCountryByCallingCode_createForOfIteratorHelperLoose(possibleCountries), _step; !(_step = _iterator()).done;) {
    var country = _step.value;
    metadata.country(country); // Leading digits check would be the simplest and fastest one.
    // Leading digits patterns are only defined for about 20% of all countries.
    // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
    // Matching "leading digits" is a sufficient but not necessary condition.

    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    } // Else perform full validation with all of those
    // fixed-line/mobile/etc regular expressions.
    else if (getNumberType({
      phone: nationalPhoneNumber,
      country: country
    }, undefined, metadata.metadata)) {
      return country;
    }
  }
}
//# sourceMappingURL=getCountryByCallingCode.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/parse_.js
// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js















 // We don't allow input strings for parsing to be longer than 250 chars.
// This prevents malicious input from consuming CPU.

var MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.

var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".

var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + '#' + ']+$');
var parse_USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
//
// ```js
// parse('8 (800) 555-35-35', 'RU')
// parse('8 (800) 555-35-35', 'RU', metadata)
// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
// parse('+7 800 555 35 35')
// parse('+7 800 555 35 35', metadata)
// ```
//

function parse_parse(text, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata); // Validate `defaultCountry`.

  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    throw new Error("Unknown country: ".concat(options.defaultCountry));
  } // Parse the phone number.


  var _parseInput = parseInput(text, options.v2, options.extract),
      formattedPhoneNumber = _parseInput.number,
      ext = _parseInput.ext,
      error = _parseInput.error; // If the phone number is not viable then return nothing.


  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === 'TOO_SHORT') {
        throw new ParseError('TOO_SHORT');
      }

      throw new ParseError('NOT_A_NUMBER');
    }

    return {};
  }

  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
      country = _parsePhoneNumber.country,
      nationalNumber = _parsePhoneNumber.nationalNumber,
      countryCallingCode = _parsePhoneNumber.countryCallingCode,
      carrierCode = _parsePhoneNumber.carrierCode;

  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    return {};
  } // Validate national (significant) number length.


  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    // Won't throw here because the regexp already demands length > 1.

    /* istanbul ignore if */
    if (options.v2) {
      throw new ParseError('TOO_SHORT');
    } // Google's demo just throws an error in this case.


    return {};
  } // Validate national (significant) number length.
  //
  // A sidenote:
  //
  // They say that sometimes national (significant) numbers
  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
  // Such numbers will just be discarded.
  //


  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError('TOO_LONG');
    } // Google's demo just throws an error in this case.


    return {};
  }

  if (options.v2) {
    var phoneNumber = new PhoneNumber_PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);

    if (country) {
      phoneNumber.country = country;
    }

    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }

    if (ext) {
      phoneNumber.ext = ext;
    }

    return phoneNumber;
  } // Check if national phone number pattern matches the number.
  // National number pattern is different for each country,
  // even for those ones which are part of the "NANPA" group.


  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;

  if (!options.extended) {
    return valid ? parse_result(country, nationalNumber, ext) : {};
  } // isInternational: countryCallingCode !== undefined


  return {
    country: country,
    countryCallingCode: countryCallingCode,
    carrierCode: carrierCode,
    valid: valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, metadata) ? true : false,
    phone: nationalNumber,
    ext: ext
  };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */

function extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }

  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError('TOO_LONG');
    }

    return;
  }

  if (extract === false) {
    return text;
  } // Attempt to extract a possible number from the string passed in


  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);

  if (startsAt < 0) {
    return;
  }

  return text // Trim everything to the left of the phone number
  .slice(startsAt) // Remove trailing non-numerical characters
  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */


function parseInput(text, v2, extract) {
  // Parse RFC 3966 phone number URI.
  if (text && text.indexOf('tel:') === 0) {
    return parseRFC3966(text);
  }

  var number = extractFormattedPhoneNumber(text, extract, v2); // If the phone number is not viable, then abort.

  if (!number) {
    return {};
  }

  if (!isViablePhoneNumber(number)) {
    if (isViablePhoneNumberStart(number)) {
      return {
        error: 'TOO_SHORT'
      };
    }

    return {};
  } // Attempt to parse extension first, since it doesn't require region-specific
  // data and we want to have the non-normalised number here.


  var withExtensionStripped = extractExtension(number);

  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }

  return {
    number: number
  };
}
/**
 * Creates `parse()` result object.
 */


function parse_result(country, nationalNumber, ext) {
  var result = {
    country: country,
    phone: nationalNumber
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */


function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  // Extract calling code from phone number.
  var _extractCountryCallin = extractCountryCallingCode_extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata),
      countryCallingCode = _extractCountryCallin.countryCallingCode,
      number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.


  var country;

  if (countryCallingCode) {
    metadata.selectNumberingPlan(countryCallingCode);
  } // If `formattedPhoneNumber` is in "national" format
  // then `number` is defined and `countryCallingCode` isn't.
  else if (number && (defaultCountry || defaultCallingCode)) {
    metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);

    if (defaultCountry) {
      country = defaultCountry;
    } else {
      /* istanbul ignore if */
      if (parse_USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(defaultCallingCode)) {
          country = '001';
        }
      }
    }

    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata.metadata);
  } else return {};

  if (!number) {
    return {
      countryCallingCode: countryCallingCode
    };
  }

  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), metadata),
      nationalNumber = _extractNationalNumbe.nationalNumber,
      carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
  // corresponding to the same country phone code
  // (e.g. NANPA countries all having `1` country phone code).
  // Therefore, to reliably determine the exact country,
  // national (significant) number should have been parsed first.
  //
  // When `metadata.json` is generated, all "ambiguous" country phone codes
  // get their countries populated with the full set of
  // "phone number type" regular expressions.
  //


  var exactCountry = getCountryByCallingCode(countryCallingCode, nationalNumber, metadata);

  if (exactCountry) {
    country = exactCountry;
    /* istanbul ignore if */

    if (exactCountry === '001') {// Can't happen with `USE_NON_GEOGRAPHIC_COUNTRY_CODE` being `false`.
      // If `USE_NON_GEOGRAPHIC_COUNTRY_CODE` is set to `true` for some reason,
      // then remove the "istanbul ignore if".
    } else {
      metadata.country(country);
    }
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode,
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}
//# sourceMappingURL=parse_.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/parsePhoneNumber_.js
function parsePhoneNumber_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function parsePhoneNumber_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? parsePhoneNumber_ownKeys(Object(source), !0).forEach(function (key) { parsePhoneNumber_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : parsePhoneNumber_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function parsePhoneNumber_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


function parsePhoneNumber_parsePhoneNumber(text, options, metadata) {
  return parse_parse(text, parsePhoneNumber_objectSpread(parsePhoneNumber_objectSpread({}, options), {}, {
    v2: true
  }), metadata);
}
//# sourceMappingURL=parsePhoneNumber_.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/parsePhoneNumber.js
function parsePhoneNumber_typeof(obj) { "@babel/helpers - typeof"; return parsePhoneNumber_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, parsePhoneNumber_typeof(obj); }

function es6_parsePhoneNumber_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function es6_parsePhoneNumber_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? es6_parsePhoneNumber_ownKeys(Object(source), !0).forEach(function (key) { es6_parsePhoneNumber_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : es6_parsePhoneNumber_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function es6_parsePhoneNumber_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function parsePhoneNumber_slicedToArray(arr, i) { return parsePhoneNumber_arrayWithHoles(arr) || parsePhoneNumber_iterableToArrayLimit(arr, i) || parsePhoneNumber_unsupportedIterableToArray(arr, i) || parsePhoneNumber_nonIterableRest(); }

function parsePhoneNumber_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function parsePhoneNumber_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return parsePhoneNumber_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return parsePhoneNumber_arrayLikeToArray(o, minLen); }

function parsePhoneNumber_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function parsePhoneNumber_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function parsePhoneNumber_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


function es6_parsePhoneNumber_parsePhoneNumber() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return parsePhoneNumber_parsePhoneNumber(text, options, metadata);
}
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args),
      _Array$prototype$slic2 = parsePhoneNumber_slicedToArray(_Array$prototype$slic, 4),
      arg_1 = _Array$prototype$slic2[0],
      arg_2 = _Array$prototype$slic2[1],
      arg_3 = _Array$prototype$slic2[2],
      arg_4 = _Array$prototype$slic2[3];

  var text;
  var options;
  var metadata; // If the phone number is passed as a string.
  // `parsePhoneNumber('88005553535', ...)`.

  if (typeof arg_1 === 'string') {
    text = arg_1;
  } else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
  // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.


  if (!arg_2 || typeof arg_2 === 'string') {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = undefined;
      metadata = arg_3;
    }

    if (arg_2) {
      options = es6_parsePhoneNumber_objectSpread({
        defaultCountry: arg_2
      }, options);
    }
  } // `defaultCountry` is not passed.
  // Example: `parsePhoneNumber('+78005553535', [options], metadata)`.
  else if (parsePhoneNumber_isObject(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata = arg_3;
    } else {
      metadata = arg_2;
    }
  } else throw new Error("Invalid second argument: ".concat(arg_2));

  return {
    text: text,
    options: options,
    metadata: metadata
  };
} // Otherwise istanbul would show this as "branch not covered".

/* istanbul ignore next */

var parsePhoneNumber_isObject = function isObject(_) {
  return parsePhoneNumber_typeof(_) === 'object';
};
//# sourceMappingURL=parsePhoneNumber.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/parsePhoneNumberFromString_.js
function parsePhoneNumberFromString_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function parsePhoneNumberFromString_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? parsePhoneNumberFromString_ownKeys(Object(source), !0).forEach(function (key) { parsePhoneNumberFromString_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : parsePhoneNumberFromString_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function parsePhoneNumberFromString_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function parsePhoneNumberFromString(text, options, metadata) {
  // Validate `defaultCountry`.
  if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata)) {
    options = parsePhoneNumberFromString_objectSpread(parsePhoneNumberFromString_objectSpread({}, options), {}, {
      defaultCountry: undefined
    });
  } // Parse phone number.


  try {
    return parsePhoneNumber_parsePhoneNumber(text, options, metadata);
  } catch (error) {
    /* istanbul ignore else */
    if (error instanceof ParseError) {//
    } else {
      throw error;
    }
  }
}
//# sourceMappingURL=parsePhoneNumberFromString_.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/parsePhoneNumberFromString.js


function parsePhoneNumberFromString_parsePhoneNumberFromString() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return parsePhoneNumberFromString(text, options, metadata);
}
//# sourceMappingURL=parsePhoneNumberFromString.js.map
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/modules/libphonenumber/formatPhoneNumber.js
function formatPhoneNumber_typeof(obj) { "@babel/helpers - typeof"; return formatPhoneNumber_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, formatPhoneNumber_typeof(obj); }


/**
 * Formats a phone number.
 * Is a proxy for `libphonenumber-js`'s `.format()` function of a parsed `PhoneNumber`.
 * @param  {string} value
 * @param  {string} [format]
 * @param  {object} metadata
 * @return {string}
 */

function formatPhoneNumber(value, format, metadata) {
  if (!metadata) {
    if (formatPhoneNumber_typeof(format) === 'object') {
      metadata = format;
      format = 'NATIONAL';
    }
  }

  if (!value) {
    return '';
  }

  var phoneNumber = parsePhoneNumberFromString_parsePhoneNumberFromString(value, metadata);

  if (!phoneNumber) {
    return '';
  } // Deprecated.
  // Legacy `format`s.


  switch (format) {
    case 'National':
      format = 'NATIONAL';
      break;

    case 'International':
      format = 'INTERNATIONAL';
      break;
  }

  return phoneNumber.format(format);
}
function formatPhoneNumberIntl(value, metadata) {
  return formatPhoneNumber(value, 'INTERNATIONAL', metadata);
}
//# sourceMappingURL=formatPhoneNumber.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/isValidPhoneNumber.js
function isValidPhoneNumber_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function isValidPhoneNumber_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? isValidPhoneNumber_ownKeys(Object(source), !0).forEach(function (key) { isValidPhoneNumber_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : isValidPhoneNumber_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function isValidPhoneNumber_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function isValidPhoneNumber() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  options = isValidPhoneNumber_objectSpread(isValidPhoneNumber_objectSpread({}, options), {}, {
    extract: false
  });
  var phoneNumber = parsePhoneNumberFromString(text, options, metadata);
  return phoneNumber && phoneNumber.isValid() || false;
}
//# sourceMappingURL=isValidPhoneNumber.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/isPossiblePhoneNumber.js
function isPossiblePhoneNumber_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function isPossiblePhoneNumber_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? isPossiblePhoneNumber_ownKeys(Object(source), !0).forEach(function (key) { isPossiblePhoneNumber_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : isPossiblePhoneNumber_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function isPossiblePhoneNumber_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function isPossiblePhoneNumber_isPossiblePhoneNumber() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  options = isPossiblePhoneNumber_objectSpread(isPossiblePhoneNumber_objectSpread({}, options), {}, {
    extract: false
  });
  var phoneNumber = parsePhoneNumberFromString(text, options, metadata);
  return phoneNumber && phoneNumber.isPossible() || false;
}
//# sourceMappingURL=isPossiblePhoneNumber.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/getCountries.js

function getCountries(metadata) {
  return new Metadata(metadata).getCountries();
}
//# sourceMappingURL=getCountries.js.map
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/locale/en.json.js
/* harmony default export */ var en_json = ({
  "ext": "ext.",
  "country": "Phone number country",
  "phone": "Phone",
  "AB": "Abkhazia",
  "AC": "Ascension Island",
  "AD": "Andorra",
  "AE": "United Arab Emirates",
  "AF": "Afghanistan",
  "AG": "Antigua and Barbuda",
  "AI": "Anguilla",
  "AL": "Albania",
  "AM": "Armenia",
  "AO": "Angola",
  "AQ": "Antarctica",
  "AR": "Argentina",
  "AS": "American Samoa",
  "AT": "Austria",
  "AU": "Australia",
  "AW": "Aruba",
  "AX": "Åland Islands",
  "AZ": "Azerbaijan",
  "BA": "Bosnia and Herzegovina",
  "BB": "Barbados",
  "BD": "Bangladesh",
  "BE": "Belgium",
  "BF": "Burkina Faso",
  "BG": "Bulgaria",
  "BH": "Bahrain",
  "BI": "Burundi",
  "BJ": "Benin",
  "BL": "Saint Barthélemy",
  "BM": "Bermuda",
  "BN": "Brunei Darussalam",
  "BO": "Bolivia",
  "BQ": "Bonaire, Sint Eustatius and Saba",
  "BR": "Brazil",
  "BS": "Bahamas",
  "BT": "Bhutan",
  "BV": "Bouvet Island",
  "BW": "Botswana",
  "BY": "Belarus",
  "BZ": "Belize",
  "CA": "Canada",
  "CC": "Cocos (Keeling) Islands",
  "CD": "Congo, Democratic Republic of the",
  "CF": "Central African Republic",
  "CG": "Congo",
  "CH": "Switzerland",
  "CI": "Cote d'Ivoire",
  "CK": "Cook Islands",
  "CL": "Chile",
  "CM": "Cameroon",
  "CN": "China",
  "CO": "Colombia",
  "CR": "Costa Rica",
  "CU": "Cuba",
  "CV": "Cape Verde",
  "CW": "Curaçao",
  "CX": "Christmas Island",
  "CY": "Cyprus",
  "CZ": "Czech Republic",
  "DE": "Germany",
  "DJ": "Djibouti",
  "DK": "Denmark",
  "DM": "Dominica",
  "DO": "Dominican Republic",
  "DZ": "Algeria",
  "EC": "Ecuador",
  "EE": "Estonia",
  "EG": "Egypt",
  "EH": "Western Sahara",
  "ER": "Eritrea",
  "ES": "Spain",
  "ET": "Ethiopia",
  "FI": "Finland",
  "FJ": "Fiji",
  "FK": "Falkland Islands",
  "FM": "Federated States of Micronesia",
  "FO": "Faroe Islands",
  "FR": "France",
  "GA": "Gabon",
  "GB": "United Kingdom",
  "GD": "Grenada",
  "GE": "Georgia",
  "GF": "French Guiana",
  "GG": "Guernsey",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GL": "Greenland",
  "GM": "Gambia",
  "GN": "Guinea",
  "GP": "Guadeloupe",
  "GQ": "Equatorial Guinea",
  "GR": "Greece",
  "GS": "South Georgia and the South Sandwich Islands",
  "GT": "Guatemala",
  "GU": "Guam",
  "GW": "Guinea-Bissau",
  "GY": "Guyana",
  "HK": "Hong Kong",
  "HM": "Heard Island and McDonald Islands",
  "HN": "Honduras",
  "HR": "Croatia",
  "HT": "Haiti",
  "HU": "Hungary",
  "ID": "Indonesia",
  "IE": "Ireland",
  "IL": "Israel",
  "IM": "Isle of Man",
  "IN": "India",
  "IO": "British Indian Ocean Territory",
  "IQ": "Iraq",
  "IR": "Iran",
  "IS": "Iceland",
  "IT": "Italy",
  "JE": "Jersey",
  "JM": "Jamaica",
  "JO": "Jordan",
  "JP": "Japan",
  "KE": "Kenya",
  "KG": "Kyrgyzstan",
  "KH": "Cambodia",
  "KI": "Kiribati",
  "KM": "Comoros",
  "KN": "Saint Kitts and Nevis",
  "KP": "North Korea",
  "KR": "South Korea",
  "KW": "Kuwait",
  "KY": "Cayman Islands",
  "KZ": "Kazakhstan",
  "LA": "Laos",
  "LB": "Lebanon",
  "LC": "Saint Lucia",
  "LI": "Liechtenstein",
  "LK": "Sri Lanka",
  "LR": "Liberia",
  "LS": "Lesotho",
  "LT": "Lithuania",
  "LU": "Luxembourg",
  "LV": "Latvia",
  "LY": "Libya",
  "MA": "Morocco",
  "MC": "Monaco",
  "MD": "Moldova",
  "ME": "Montenegro",
  "MF": "Saint Martin (French Part)",
  "MG": "Madagascar",
  "MH": "Marshall Islands",
  "MK": "North Macedonia",
  "ML": "Mali",
  "MM": "Myanmar",
  "MN": "Mongolia",
  "MO": "Macao",
  "MP": "Northern Mariana Islands",
  "MQ": "Martinique",
  "MR": "Mauritania",
  "MS": "Montserrat",
  "MT": "Malta",
  "MU": "Mauritius",
  "MV": "Maldives",
  "MW": "Malawi",
  "MX": "Mexico",
  "MY": "Malaysia",
  "MZ": "Mozambique",
  "NA": "Namibia",
  "NC": "New Caledonia",
  "NE": "Niger",
  "NF": "Norfolk Island",
  "NG": "Nigeria",
  "NI": "Nicaragua",
  "NL": "Netherlands",
  "NO": "Norway",
  "NP": "Nepal",
  "NR": "Nauru",
  "NU": "Niue",
  "NZ": "New Zealand",
  "OM": "Oman",
  "OS": "South Ossetia",
  "PA": "Panama",
  "PE": "Peru",
  "PF": "French Polynesia",
  "PG": "Papua New Guinea",
  "PH": "Philippines",
  "PK": "Pakistan",
  "PL": "Poland",
  "PM": "Saint Pierre and Miquelon",
  "PN": "Pitcairn",
  "PR": "Puerto Rico",
  "PS": "Palestine",
  "PT": "Portugal",
  "PW": "Palau",
  "PY": "Paraguay",
  "QA": "Qatar",
  "RE": "Reunion",
  "RO": "Romania",
  "RS": "Serbia",
  "RU": "Russia",
  "RW": "Rwanda",
  "SA": "Saudi Arabia",
  "SB": "Solomon Islands",
  "SC": "Seychelles",
  "SD": "Sudan",
  "SE": "Sweden",
  "SG": "Singapore",
  "SH": "Saint Helena",
  "SI": "Slovenia",
  "SJ": "Svalbard and Jan Mayen",
  "SK": "Slovakia",
  "SL": "Sierra Leone",
  "SM": "San Marino",
  "SN": "Senegal",
  "SO": "Somalia",
  "SR": "Suriname",
  "SS": "South Sudan",
  "ST": "Sao Tome and Principe",
  "SV": "El Salvador",
  "SX": "Sint Maarten",
  "SY": "Syria",
  "SZ": "Swaziland",
  "TA": "Tristan da Cunha",
  "TC": "Turks and Caicos Islands",
  "TD": "Chad",
  "TF": "French Southern Territories",
  "TG": "Togo",
  "TH": "Thailand",
  "TJ": "Tajikistan",
  "TK": "Tokelau",
  "TL": "Timor-Leste",
  "TM": "Turkmenistan",
  "TN": "Tunisia",
  "TO": "Tonga",
  "TR": "Turkey",
  "TT": "Trinidad and Tobago",
  "TV": "Tuvalu",
  "TW": "Taiwan",
  "TZ": "Tanzania",
  "UA": "Ukraine",
  "UG": "Uganda",
  "UM": "United States Minor Outlying Islands",
  "US": "United States",
  "UY": "Uruguay",
  "UZ": "Uzbekistan",
  "VA": "Holy See (Vatican City State)",
  "VC": "Saint Vincent and the Grenadines",
  "VE": "Venezuela",
  "VG": "Virgin Islands, British",
  "VI": "Virgin Islands, U.S.",
  "VN": "Vietnam",
  "VU": "Vanuatu",
  "WF": "Wallis and Futuna",
  "WS": "Samoa",
  "XK": "Kosovo",
  "YE": "Yemen",
  "YT": "Mayotte",
  "ZA": "South Africa",
  "ZM": "Zambia",
  "ZW": "Zimbabwe",
  "ZZ": "International"
});
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/modules/PropTypes.js

var PropTypes_metadata = prop_types_default.a.shape({
  country_calling_codes: prop_types_default.a.object.isRequired,
  countries: prop_types_default.a.object.isRequired
});
var PropTypes_labels = prop_types_default.a.objectOf(prop_types_default.a.string);
//# sourceMappingURL=PropTypes.js.map
// CONCATENATED MODULE: ./node_modules/input-format/modules/edit.js
// Edits text `value` (if `operation` is passed) and repositions the `caret` if needed.
//
// Example:
//
// value - '88005553535'
// caret - 2 // starting from 0; is positioned before the first zero
// operation - 'Backspace'
//
// Returns
// {
// 	value: '8005553535'
// 	caret: 1
// }
//
// Currently supports just 'Delete' and 'Backspace' operations
//
function edit(value, caret, operation) {
  switch (operation) {
    case 'Backspace':
      // If there exists the previous character,
      // then erase it and reposition the caret.
      if (caret > 0) {
        // Remove the previous character
        value = value.slice(0, caret - 1) + value.slice(caret); // Position the caret where the previous (erased) character was

        caret--;
      }

      break;

    case 'Delete':
      // Remove current digit (if any)
      value = value.slice(0, caret) + value.slice(caret + 1);
      break;
  }

  return {
    value: value,
    caret: caret
  };
}
//# sourceMappingURL=edit.js.map
// CONCATENATED MODULE: ./node_modules/input-format/modules/parse.js
// Parses the `text`.
//
// Returns `{ value, caret }` where `caret` is
// the caret position inside `value`
// corresponding to the `caret_position` inside `text`.
//
// The `text` is parsed by feeding each character sequentially to
// `parse_character(character, value)` function
// and appending the result (if it's not `undefined`) to `value`.
//
// Example:
//
// `text` is `8 (800) 555-35-35`,
// `caret_position` is `4` (before the first `0`).
// `parse_character` is `(character, value) =>
//   if (character >= '0' && character <= '9') { return character }`.
//
// then `parse()` outputs `{ value: '88005553535', caret: 2 }`.
//
function modules_parse_parse(text, caret_position, parse_character) {
  var value = '';
  var focused_input_character_index = 0;
  var index = 0;

  while (index < text.length) {
    var character = parse_character(text[index], value);

    if (character !== undefined) {
      value += character;

      if (caret_position !== undefined) {
        if (caret_position === index) {
          focused_input_character_index = value.length - 1;
        } else if (caret_position > index) {
          focused_input_character_index = value.length;
        }
      }
    }

    index++;
  } // If caret position wasn't specified


  if (caret_position === undefined) {
    // Then set caret position to "after the last input character"
    focused_input_character_index = value.length;
  }

  var result = {
    value: value,
    caret: focused_input_character_index
  };
  return result;
}
//# sourceMappingURL=parse.js.map
// CONCATENATED MODULE: ./node_modules/input-format/modules/helpers.js
function helpers_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = helpers_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function helpers_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return helpers_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return helpers_arrayLikeToArray(o, minLen); }

function helpers_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Counts all occurences of a symbol in a string
function count_occurences(symbol, string) {
  var count = 0; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes)
  // but template placeholder characters don't fall into that range
  // so skipping such miscellaneous "exotic" characters
  // won't matter here for just counting placeholder character occurrences.

  for (var _iterator = helpers_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;

    if (character === symbol) {
      count++;
    }
  }

  return count;
}
//# sourceMappingURL=helpers.js.map
// CONCATENATED MODULE: ./node_modules/input-format/modules/closeBraces.js

function closeBraces(retained_template, template) {
  var placeholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x';
  var empty_placeholder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
  var cut_before = retained_template.length;
  var opening_braces = count_occurences('(', retained_template);
  var closing_braces = count_occurences(')', retained_template);
  var dangling_braces = opening_braces - closing_braces;

  while (dangling_braces > 0 && cut_before < template.length) {
    retained_template += template[cut_before].replace(placeholder, empty_placeholder);

    if (template[cut_before] === ')') {
      dangling_braces--;
    }

    cut_before++;
  }

  return retained_template;
}
//# sourceMappingURL=closeBraces.js.map
// CONCATENATED MODULE: ./node_modules/input-format/modules/templateFormatter.js
function templateFormatter_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = templateFormatter_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function templateFormatter_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return templateFormatter_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return templateFormatter_arrayLikeToArray(o, minLen); }

function templateFormatter_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


 // Takes a `template` where character placeholders
// are denoted by 'x'es (e.g. 'x (xxx) xxx-xx-xx').
//
// Returns a function which takes `value` characters
// and returns the `template` filled with those characters.
// If the `template` can only be partially filled
// then it is cut off.
//
// If `should_close_braces` is `true`,
// then it will also make sure all dangling braces are closed,
// e.g. "8 (8" -> "8 (8  )" (iPhone style phone number input).
//

/* harmony default export */ var templateFormatter = (function (template) {
  var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
  var should_close_braces = arguments.length > 2 ? arguments[2] : undefined;

  if (!template) {
    return function (value) {
      return {
        text: value
      };
    };
  }

  var characters_in_template = count_occurences(placeholder, template);
  return function (value) {
    if (!value) {
      return {
        text: '',
        template: template
      };
    }

    var value_character_index = 0;
    var filled_in_template = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes)
    // but template placeholder characters don't fall into that range
    // and appending UTF-8 characters to a string in parts still works.

    for (var _iterator = templateFormatter_createForOfIteratorHelperLoose(template.split('')), _step; !(_step = _iterator()).done;) {
      var character = _step.value;

      if (character !== placeholder) {
        filled_in_template += character;
        continue;
      }

      filled_in_template += value[value_character_index];
      value_character_index++; // If the last available value character has been filled in,
      // then return the filled in template
      // (either trim the right part or retain it,
      //  if no more character placeholders in there)

      if (value_character_index === value.length) {
        // If there are more character placeholders
        // in the right part of the template
        // then simply trim it.
        if (value.length < characters_in_template) {
          break;
        }
      }
    }

    if (should_close_braces) {
      filled_in_template = closeBraces(filled_in_template, template);
    }

    return {
      text: filled_in_template,
      template: template
    };
  };
});
//# sourceMappingURL=templateFormatter.js.map
// CONCATENATED MODULE: ./node_modules/input-format/modules/format.js
 // Formats `value` value preserving `caret` at the same character.
//
// `{ value, caret }` attribute is the result of `parse()` function call.
//
// Returns `{ text, caret }` where the new `caret` is the caret position
// inside `text` text corresponding to the original `caret` position inside `value`.
//
// `formatter(value)` is a function returning `{ text, template }`.
//
// `text` is the `value` value formatted using `template`.
// It may either cut off the non-filled right part of the `template`
// or it may fill the non-filled character placeholders
// in the right part of the `template` with `spacer`
// which is a space (' ') character by default.
//
// `template` is the template used to format the `value`.
// It can be either a full-length template or a partial template.
//
// `formatter` can also be a string — a `template`
// where character placeholders are denoted by 'x'es.
// In this case `formatter` function is automatically created.
//
// Example:
//
// `value` is '880',
// `caret` is `2` (before the first `0`)
//
// `formatter` is `'880' =>
//   { text: '8 (80 )', template: 'x (xxx) xxx-xx-xx' }`
//
// The result is `{ text: '8 (80 )', caret: 4 }`.
//

function format_format(value, caret, formatter) {
  if (typeof formatter === 'string') {
    formatter = templateFormatter(formatter);
  }

  var _ref = formatter(value) || {},
      text = _ref.text,
      template = _ref.template;

  if (text === undefined) {
    text = value;
  }

  if (template) {
    if (caret === undefined) {
      caret = text.length;
    } else {
      var index = 0;
      var found = false;
      var possibly_last_input_character_index = -1;

      while (index < text.length && index < template.length) {
        // Character placeholder found
        if (text[index] !== template[index]) {
          if (caret === 0) {
            found = true;
            caret = index;
            break;
          }

          possibly_last_input_character_index = index;
          caret--;
        }

        index++;
      } // If the caret was positioned after last input character,
      // then the text caret index is just after the last input character.


      if (!found) {
        caret = possibly_last_input_character_index + 1;
      }
    }
  }

  return {
    text: text,
    caret: caret
  };
}
//# sourceMappingURL=format.js.map
// CONCATENATED MODULE: ./node_modules/input-format/modules/dom.js
function isReadOnly(element) {
  return element.hasAttribute('readonly');
} // Gets <input/> selection bounds

function getSelection(element) {
  // If no selection, return nothing
  if (element.selectionStart === element.selectionEnd) {
    return;
  }

  return {
    start: element.selectionStart,
    end: element.selectionEnd
  };
} // Key codes

var Keys = {
  Backspace: 8,
  Delete: 46
}; // Finds out the operation to be intercepted and performed
// based on the key down event `keyCode`.

function getOperation(event) {
  switch (event.keyCode) {
    case Keys.Backspace:
      return 'Backspace';

    case Keys.Delete:
      return 'Delete';
  }
} // Gets <input/> caret position

function getCaretPosition(element) {
  return element.selectionStart;
} // Sets <input/> caret position

function setCaretPosition(element, caret_position) {
  // Sanity check
  if (caret_position === undefined) {
    return;
  } // Set caret position.
  // There has been an issue with caret positioning on Android devices.
  // https://github.com/catamphetamine/input-format/issues/2
  // I was revisiting this issue and looked for similar issues in other libraries.
  // For example, there's [`text-mask`](https://github.com/text-mask/text-mask) library.
  // They've had exactly the same issue when the caret seemingly refused to be repositioned programmatically.
  // The symptoms were the same: whenever the caret passed through a non-digit character of a mask (a whitespace, a bracket, a dash, etc), it looked as if it placed itself one character before its correct position.
  // https://github.com/text-mask/text-mask/issues/300
  // They seem to have found a basic fix for it: calling `input.setSelectionRange()` in a timeout rather than instantly for Android devices.
  // https://github.com/text-mask/text-mask/pull/400/files
  // I've implemented the same workaround here.


  if (isAndroid()) {
    setTimeout(function () {
      return element.setSelectionRange(caret_position, caret_position);
    }, 0);
  } else {
    element.setSelectionRange(caret_position, caret_position);
  }
}

function isAndroid() {
  // `navigator` is not defined when running mocha tests.
  if (typeof navigator !== 'undefined') {
    return ANDROID_USER_AGENT_REG_EXP.test(navigator.userAgent);
  }
}

var ANDROID_USER_AGENT_REG_EXP = /Android/i;
//# sourceMappingURL=dom.js.map
// CONCATENATED MODULE: ./node_modules/input-format/modules/inputControl.js



 // Deprecated.
// I don't know why this function exists.

function onCut(event, input, _parse, _format, on_change) {
  if (isReadOnly(input)) {
    return;
  } // The actual cut hasn't happened just yet hence the timeout.


  setTimeout(function () {
    return formatInputText(input, _parse, _format, undefined, on_change);
  }, 0);
} // Deprecated.
// I don't know why this function exists.

function onPaste(event, input, _parse, _format, on_change) {
  if (isReadOnly(input)) {
    return;
  }

  var selection = getSelection(input); // If selection is made,
  // just erase the selected text
  // prior to pasting

  if (selection) {
    eraseSelection(input, selection);
  }

  formatInputText(input, _parse, _format, undefined, on_change);
}
function inputControl_onChange(event, input, _parse, _format, on_change) {
  formatInputText(input, _parse, _format, undefined, on_change);
} // "Delete" and "Backspace" keys are special
// in a way that they're not handled by the regular `onChange()` handler
// and instead are intercepted and re-applied manually.
// The reason is that normally hitting "Backspace" or "Delete"
// results in erasing a character, but that character might be any character,
// while it would be a better "user experience" if it erased not just any character
// but the closest "meaningful" character.
// For example, if a template is `(xxx) xxx-xxxx`,
// and the `<input/>` value is `(111) 222-3333`,
// then, if a user begins erasing the `3333` part via "Backspace"
// and reaches the "-" character, then it would just erase the "-" character.
// Nothing wrong with that, but it would be a better "user experience"
// if hitting "Backspace" at that position would erase the closest "meaningful"
// character, which would be the rightmost `2`.
// So, what this `onKeyDown()` handler does is it intercepts
// "Backspace" and "Delete" keys and re-applies those operations manually
// following the logic described above.

function inputControl_onKeyDown(event, input, _parse, _format, on_change) {
  if (isReadOnly(input)) {
    return;
  }

  var operation = getOperation(event);

  switch (operation) {
    case 'Delete':
    case 'Backspace':
      // Intercept this operation and perform it manually.
      event.preventDefault();
      var selection = getSelection(input); // If a selection is made, just erase the selected text.

      if (selection) {
        eraseSelection(input, selection);
        return formatInputText(input, _parse, _format, undefined, on_change);
      } // Else, perform the (character erasing) operation manually.


      return formatInputText(input, _parse, _format, operation, on_change);

    default: // Will be handled normally as part of the `onChange` handler.

  }
}
/**
 * Erases the selected text inside an `<input/>`.
 * @param  {DOMElement} input
 * @param  {Selection} selection
 */

function eraseSelection(input, selection) {
  var text = input.value;
  text = text.slice(0, selection.start) + text.slice(selection.end);
  input.value = text;
  setCaretPosition(input, selection.start);
}
/**
 * Parses and re-formats `<input/>` textual value.
 * E.g. when a user enters something into the `<input/>`
 * that raw input must first be parsed and the re-formatted properly.
 * Is called either after some user input (e.g. entered a character, pasted something)
 * or after the user performed an `operation` (e.g. "Backspace", "Delete").
 * @param  {DOMElement} input
 * @param  {Function} parse
 * @param  {Function} format
 * @param  {string} [operation] - The operation that triggered `<input/>` textual value change. E.g. "Backspace", "Delete".
 * @param  {Function} onChange
 */


function formatInputText(input, _parse, _format, operation, on_change) {
  // Parse `<input/>` textual value.
  // Get the `value` and `caret` position.
  var _parse2 = modules_parse_parse(input.value, getCaretPosition(input), _parse),
      value = _parse2.value,
      caret = _parse2.caret; // If a user performed an operation ("Backspace", "Delete")
  // then apply that operation and get the new `value` and `caret` position.


  if (operation) {
    var newValueAndCaret = edit(value, caret, operation);
    value = newValueAndCaret.value;
    caret = newValueAndCaret.caret;
  } // Format the `value`.
  // (and reposition the caret accordingly)


  var formatted = format_format(value, caret, _format);
  var text = formatted.text;
  caret = formatted.caret; // Set `<input/>` textual value manually
  // to prevent React from resetting the caret position
  // later inside a subsequent `render()`.
  // Doesn't work for custom `inputComponent`s for some reason.

  input.value = text; // Position the caret properly.

  setCaretPosition(input, caret); // If the `<input/>` textual value did change,
  // then the parsed `value` may have changed too.

  on_change(value);
}
//# sourceMappingURL=inputControl.js.map
// CONCATENATED MODULE: ./node_modules/input-format/modules/react/Input.js
var Input_excluded = ["value", "parse", "format", "inputComponent", "onChange", "onKeyDown"];

function Input_extends() { Input_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Input_extends.apply(this, arguments); }

function Input_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Input_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Input_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// This is just `./ReactInput.js` rewritten in Hooks.


 // Usage:
//
// <ReactInput
// 	value={this.state.phone}
// 	onChange={phone => this.setState({ phone })}
// 	parse={character => character}
// 	format={value => ({ text: value, template: 'xxxxxxxx' })}/>
//

function Input_Input(_ref, ref) {
  var value = _ref.value,
      parse = _ref.parse,
      format = _ref.format,
      InputComponent = _ref.inputComponent,
      onChange = _ref.onChange,
      onKeyDown = _ref.onKeyDown,
      rest = Input_objectWithoutProperties(_ref, Input_excluded);

  var internalRef = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useRef"])();
  var setRef = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useCallback"])(function (instance) {
    internalRef.current = instance;

    if (ref) {
      if (typeof ref === 'function') {
        ref(instance);
      } else {
        ref.current = instance;
      }
    }
  }, [ref]);

  var _onChange = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useCallback"])(function (event) {
    return inputControl_onChange(event, internalRef.current, parse, format, onChange);
  }, [internalRef, parse, format, onChange]);

  var _onKeyDown = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useCallback"])(function (event) {
    if (onKeyDown) {
      onKeyDown(event);
    }

    return inputControl_onKeyDown(event, internalRef.current, parse, format, onChange);
  }, [internalRef, parse, format, onChange, onKeyDown]);

  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(InputComponent, Input_extends({}, rest, {
    ref: setRef,
    value: format(isEmptyValue(value) ? '' : value).text,
    onKeyDown: _onKeyDown,
    onChange: _onChange
  }));
}

Input_Input = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.forwardRef(Input_Input);
Input_Input.propTypes = {
  // Parses a single characher of `<input/>` text.
  parse: prop_types_default.a.func.isRequired,
  // Formats `value` into `<input/>` text.
  format: prop_types_default.a.func.isRequired,
  // Renders `<input/>` by default.
  inputComponent: prop_types_default.a.elementType.isRequired,
  // `<input/>` `type` attribute.
  type: prop_types_default.a.string.isRequired,
  // Is parsed from <input/> text.
  value: prop_types_default.a.string,
  // This handler is called each time `<input/>` text is changed.
  onChange: prop_types_default.a.func.isRequired,
  // Passthrough
  onKeyDown: prop_types_default.a.func,
  onCut: prop_types_default.a.func,
  onPaste: prop_types_default.a.func
};
Input_Input.defaultProps = {
  // Renders `<input/>` by default.
  inputComponent: 'input',
  // `<input/>` `type` attribute.
  type: 'text'
};
/* harmony default export */ var react_Input = (Input_Input);

function isEmptyValue(value) {
  return value === undefined || value === null;
}
//# sourceMappingURL=Input.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/AsYouTypeState.js
function AsYouTypeState_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AsYouTypeState_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AsYouTypeState_createClass(Constructor, protoProps, staticProps) { if (protoProps) AsYouTypeState_defineProperties(Constructor.prototype, protoProps); if (staticProps) AsYouTypeState_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var AsYouTypeState = /*#__PURE__*/function () {
  function AsYouTypeState(_ref) {
    var onCountryChange = _ref.onCountryChange,
        onCallingCodeChange = _ref.onCallingCodeChange;

    AsYouTypeState_classCallCheck(this, AsYouTypeState);

    this.onCountryChange = onCountryChange;
    this.onCallingCodeChange = onCallingCodeChange;
  }

  AsYouTypeState_createClass(AsYouTypeState, [{
    key: "reset",
    value: function reset(defaultCountry, defaultCallingCode) {
      this.international = false;
      this.IDDPrefix = undefined;
      this.missingPlus = undefined;
      this.callingCode = undefined;
      this.digits = '';
      this.resetNationalSignificantNumber();
      this.initCountryAndCallingCode(defaultCountry, defaultCallingCode);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function resetNationalSignificantNumber() {
      this.nationalSignificantNumber = this.getNationalDigits();
      this.nationalSignificantNumberMatchesInput = true;
      this.nationalPrefix = undefined;
      this.carrierCode = undefined;
      this.complexPrefixBeforeNationalSignificantNumber = undefined;
    }
  }, {
    key: "update",
    value: function update(properties) {
      for (var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        this[key] = properties[key];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function initCountryAndCallingCode(country, callingCode) {
      this.setCountry(country);
      this.setCallingCode(callingCode);
    }
  }, {
    key: "setCountry",
    value: function setCountry(country) {
      this.country = country;
      this.onCountryChange(country);
    }
  }, {
    key: "setCallingCode",
    value: function setCallingCode(callingCode) {
      this.callingCode = callingCode;
      this.onCallingCodeChange(callingCode, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber(country, callingCode) {
      // Prepend the `+` to parsed input.
      this.international = true; // If a default country was set then reset it
      // because an explicitly international phone
      // number is being entered.

      this.initCountryAndCallingCode(country, callingCode);
    }
  }, {
    key: "appendDigits",
    value: function appendDigits(nextDigits) {
      this.digits += nextDigits;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function appendNationalSignificantNumberDigits(nextDigits) {
      this.nationalSignificantNumber += nextDigits;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */

  }, {
    key: "getNationalDigits",
    value: function getNationalDigits() {
      if (this.international) {
        return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
      }

      return this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function getDigitsWithoutInternationalPrefix() {
      if (this.international) {
        if (this.IDDPrefix) {
          return this.digits.slice(this.IDDPrefix.length);
        }
      }

      return this.digits;
    }
  }]);

  return AsYouTypeState;
}();


//# sourceMappingURL=AsYouTypeState.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.util.js
function AsYouTypeFormatter_util_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = AsYouTypeFormatter_util_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function AsYouTypeFormatter_util_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return AsYouTypeFormatter_util_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AsYouTypeFormatter_util_arrayLikeToArray(o, minLen); }

function AsYouTypeFormatter_util_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Should be the same as `DIGIT_PLACEHOLDER` in `libphonenumber-metadata-generator`.
var DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)

var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER); // Counts all occurences of a symbol in a string.
// Unicode-unsafe (because using `.split()`).

function countOccurences(symbol, string) {
  var count = 0; // Using `.split('')` to iterate through a string here
  // to avoid requiring `Symbol.iterator` polyfill.
  // `.split('')` is generally not safe for Unicode,
  // but in this particular case for counting brackets it is safe.
  // for (const character of string)

  for (var _iterator = AsYouTypeFormatter_util_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;

    if (character === symbol) {
      count++;
    }
  }

  return count;
} // Repeats a string (or a symbol) N times.
// http://stackoverflow.com/questions/202605/repeat-string-javascript

function repeat(string, times) {
  if (times < 1) {
    return '';
  }

  var result = '';

  while (times > 1) {
    if (times & 1) {
      result += string;
    }

    times >>= 1;
    string += string;
  }

  return result + string;
}
function cutAndStripNonPairedParens(string, cutBeforeIndex) {
  if (string[cutBeforeIndex] === ')') {
    cutBeforeIndex++;
  }

  return stripNonPairedParens(string.slice(0, cutBeforeIndex));
}
function closeNonPairedParens(template, cut_before) {
  var retained_template = template.slice(0, cut_before);
  var opening_braces = countOccurences('(', retained_template);
  var closing_braces = countOccurences(')', retained_template);
  var dangling_braces = opening_braces - closing_braces;

  while (dangling_braces > 0 && cut_before < template.length) {
    if (template[cut_before] === ')') {
      dangling_braces--;
    }

    cut_before++;
  }

  return template.slice(0, cut_before);
}
function stripNonPairedParens(string) {
  var dangling_braces = [];
  var i = 0;

  while (i < string.length) {
    if (string[i] === '(') {
      dangling_braces.push(i);
    } else if (string[i] === ')') {
      dangling_braces.pop();
    }

    i++;
  }

  var start = 0;
  var cleared_string = '';
  dangling_braces.push(string.length);

  for (var _i = 0, _dangling_braces = dangling_braces; _i < _dangling_braces.length; _i++) {
    var index = _dangling_braces[_i];
    cleared_string += string.slice(start, index);
    start = index + 1;
  }

  return cleared_string;
}
function populateTemplateWithDigits(template, position, digits) {
  // Using `.split('')` to iterate through a string here
  // to avoid requiring `Symbol.iterator` polyfill.
  // `.split('')` is generally not safe for Unicode,
  // but in this particular case for `digits` it is safe.
  // for (const digit of digits)
  for (var _iterator2 = AsYouTypeFormatter_util_createForOfIteratorHelperLoose(digits.split('')), _step2; !(_step2 = _iterator2()).done;) {
    var digit = _step2.value;

    // If there is room for more digits in current `template`,
    // then set the next digit in the `template`,
    // and return the formatted digits so far.
    // If more digits are entered than the current format could handle.
    if (template.slice(position + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0) {
      return;
    }

    position = template.search(DIGIT_PLACEHOLDER_MATCHER);
    template = template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
  }

  return [template, position];
}
//# sourceMappingURL=AsYouTypeFormatter.util.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.complete.js



function formatCompleteNumber(state, format, _ref) {
  var metadata = _ref.metadata,
      shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
  var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));

  if (matcher.test(state.nationalSignificantNumber)) {
    return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
      metadata: metadata,
      shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
  }
}
function canFormatCompleteNumber(nationalSignificantNumber, metadata) {
  return checkNumberLength(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
}

function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
  var metadata = _ref2.metadata,
      shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
  // `format` has already been checked for `nationalPrefix` requirement.
  var nationalSignificantNumber = state.nationalSignificantNumber,
      international = state.international,
      nationalPrefix = state.nationalPrefix,
      carrierCode = state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
  // If the resulting formatted number is a valid formatted number, then return it.
  //
  // Google's AsYouType formatter is different in a way that it doesn't try
  // to format using the "national prefix formatting rule", and instead it
  // simply prepends a national prefix followed by a " " character.
  // This code does that too, but as a fallback.
  // The reason is that "national prefix formatting rule" may use parentheses,
  // which wouldn't be included has it used the simpler Google's way.
  //

  if (shouldTryNationalPrefixFormattingRule(format)) {
    var formattedNumber = AsYouTypeFormatter_complete_formatNationalNumber(state, format, {
      useNationalPrefixFormattingRule: true,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
      metadata: metadata
    });

    if (formattedNumber) {
      return formattedNumber;
    }
  } // Format the number without using `national_prefix_formatting_rule`.


  return AsYouTypeFormatter_complete_formatNationalNumber(state, format, {
    useNationalPrefixFormattingRule: false,
    getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
    metadata: metadata
  });
}

function AsYouTypeFormatter_complete_formatNationalNumber(state, format, _ref3) {
  var metadata = _ref3.metadata,
      useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
  var formattedNationalNumber = formatNationalNumberUsingFormat(state.nationalSignificantNumber, format, {
    carrierCode: state.carrierCode,
    useInternationalFormat: state.international,
    withNationalPrefix: useNationalPrefixFormattingRule,
    metadata: metadata
  });

  if (!useNationalPrefixFormattingRule) {
    if (state.nationalPrefix) {
      // If a national prefix was extracted, then just prepend it,
      // followed by a " " character.
      formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
    } else if (state.complexPrefixBeforeNationalSignificantNumber) {
      formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
    }
  }

  if (isValidFormattedNationalNumber(formattedNationalNumber, state)) {
    return formattedNationalNumber;
  }
} // Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//


function isValidFormattedNationalNumber(formattedNationalNumber, state) {
  return parseDigits(formattedNationalNumber) === state.getNationalDigits();
}
//# sourceMappingURL=AsYouTypeFormatter.complete.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.PatternParser.js
function AsYouTypeFormatter_PatternParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AsYouTypeFormatter_PatternParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AsYouTypeFormatter_PatternParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) AsYouTypeFormatter_PatternParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) AsYouTypeFormatter_PatternParser_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var PatternParser = /*#__PURE__*/function () {
  function PatternParser() {
    AsYouTypeFormatter_PatternParser_classCallCheck(this, PatternParser);
  }

  AsYouTypeFormatter_PatternParser_createClass(PatternParser, [{
    key: "parse",
    value: function parse(pattern) {
      this.context = [{
        or: true,
        instructions: []
      }];
      this.parsePattern(pattern);

      if (this.context.length !== 1) {
        throw new Error('Non-finalized contexts left when pattern parse ended');
      }

      var _this$context$ = this.context[0],
          branches = _this$context$.branches,
          instructions = _this$context$.instructions;

      if (branches) {
        return {
          op: '|',
          args: branches.concat([expandSingleElementArray(instructions)])
        };
      }
      /* istanbul ignore if */


      if (instructions.length === 0) {
        throw new Error('Pattern is required');
      }

      if (instructions.length === 1) {
        return instructions[0];
      }

      return instructions;
    }
  }, {
    key: "startContext",
    value: function startContext(context) {
      this.context.push(context);
    }
  }, {
    key: "endContext",
    value: function endContext() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function parsePattern(pattern) {
      if (!pattern) {
        throw new Error('Pattern is required');
      }

      var match = pattern.match(OPERATOR);

      if (!match) {
        if (ILLEGAL_CHARACTER_REGEXP.test(pattern)) {
          throw new Error("Illegal characters found in a pattern: ".concat(pattern));
        }

        this.getContext().instructions = this.getContext().instructions.concat(pattern.split(''));
        return;
      }

      var operator = match[1];
      var before = pattern.slice(0, match.index);
      var rightPart = pattern.slice(match.index + operator.length);

      switch (operator) {
        case '(?:':
          if (before) {
            this.parsePattern(before);
          }

          this.startContext({
            or: true,
            instructions: [],
            branches: []
          });
          break;

        case ')':
          if (!this.getContext().or) {
            throw new Error('")" operator must be preceded by "(?:" operator');
          }

          if (before) {
            this.parsePattern(before);
          }

          if (this.getContext().instructions.length === 0) {
            throw new Error('No instructions found after "|" operator in an "or" group');
          }

          var _this$getContext = this.getContext(),
              branches = _this$getContext.branches;

          branches.push(expandSingleElementArray(this.getContext().instructions));
          this.endContext();
          this.getContext().instructions.push({
            op: '|',
            args: branches
          });
          break;

        case '|':
          if (!this.getContext().or) {
            throw new Error('"|" operator can only be used inside "or" groups');
          }

          if (before) {
            this.parsePattern(before);
          } // The top-level is an implicit "or" group, if required.


          if (!this.getContext().branches) {
            // `branches` are not defined only for the root implicit "or" operator.

            /* istanbul ignore else */
            if (this.context.length === 1) {
              this.getContext().branches = [];
            } else {
              throw new Error('"branches" not found in an "or" group context');
            }
          }

          this.getContext().branches.push(expandSingleElementArray(this.getContext().instructions));
          this.getContext().instructions = [];
          break;

        case '[':
          if (before) {
            this.parsePattern(before);
          }

          this.startContext({
            oneOfSet: true
          });
          break;

        case ']':
          if (!this.getContext().oneOfSet) {
            throw new Error('"]" operator must be preceded by "[" operator');
          }

          this.endContext();
          this.getContext().instructions.push({
            op: '[]',
            args: parseOneOfSet(before)
          });
          break;

        /* istanbul ignore next */

        default:
          throw new Error("Unknown operator: ".concat(operator));
      }

      if (rightPart) {
        this.parsePattern(rightPart);
      }
    }
  }]);

  return PatternParser;
}();



function parseOneOfSet(pattern) {
  var values = [];
  var i = 0;

  while (i < pattern.length) {
    if (pattern[i] === '-') {
      if (i === 0 || i === pattern.length - 1) {
        throw new Error("Couldn't parse a one-of set pattern: ".concat(pattern));
      }

      var prevValue = pattern[i - 1].charCodeAt(0) + 1;
      var nextValue = pattern[i + 1].charCodeAt(0) - 1;
      var value = prevValue;

      while (value <= nextValue) {
        values.push(String.fromCharCode(value));
        value++;
      }
    } else {
      values.push(pattern[i]);
    }

    i++;
  }

  return values;
}

var ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/;
var OPERATOR = new RegExp( // any of:
'(' + // or operator
'\\|' + // or
'|' + // or group start
'\\(\\?\\:' + // or
'|' + // or group end
'\\)' + // or
'|' + // one-of set start
'\\[' + // or
'|' + // one-of set end
'\\]' + ')');

function expandSingleElementArray(array) {
  if (array.length === 1) {
    return array[0];
  }

  return array;
}
//# sourceMappingURL=AsYouTypeFormatter.PatternParser.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.PatternMatcher.js
function AsYouTypeFormatter_PatternMatcher_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = AsYouTypeFormatter_PatternMatcher_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function AsYouTypeFormatter_PatternMatcher_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return AsYouTypeFormatter_PatternMatcher_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AsYouTypeFormatter_PatternMatcher_arrayLikeToArray(o, minLen); }

function AsYouTypeFormatter_PatternMatcher_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function AsYouTypeFormatter_PatternMatcher_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AsYouTypeFormatter_PatternMatcher_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AsYouTypeFormatter_PatternMatcher_createClass(Constructor, protoProps, staticProps) { if (protoProps) AsYouTypeFormatter_PatternMatcher_defineProperties(Constructor.prototype, protoProps); if (staticProps) AsYouTypeFormatter_PatternMatcher_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var AsYouTypeFormatter_PatternMatcher_PatternMatcher = /*#__PURE__*/function () {
  function PatternMatcher(pattern) {
    AsYouTypeFormatter_PatternMatcher_classCallCheck(this, PatternMatcher);

    this.matchTree = new PatternParser().parse(pattern);
  }

  AsYouTypeFormatter_PatternMatcher_createClass(PatternMatcher, [{
    key: "match",
    value: function match(string) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          allowOverflow = _ref.allowOverflow;

      if (!string) {
        throw new Error('String is required');
      }

      var result = _match(string.split(''), this.matchTree, true);

      if (result && result.match) {
        delete result.matchedChars;
      }

      if (result && result.overflow) {
        if (!allowOverflow) {
          return;
        }
      }

      return result;
    }
  }]);

  return PatternMatcher;
}();
/**
 * Matches `characters` against a pattern compiled into a `tree`.
 * @param  {string[]} characters
 * @param  {Tree} tree — A pattern compiled into a `tree`. See the `*.d.ts` file for the description of the `tree` structure.
 * @param  {boolean} last — Whether it's the last (rightmost) subtree on its level of the match tree.
 * @return {object} See the `*.d.ts` file for the description of the result object.
 */




function _match(characters, tree, last) {
  // If `tree` is a string, then `tree` is a single character.
  // That's because when a pattern is parsed, multi-character-string parts
  // of a pattern are compiled into arrays of single characters.
  // I still wrote this piece of code for a "general" hypothetical case
  // when `tree` could be a string of several characters, even though
  // such case is not possible with the current implementation.
  if (typeof tree === 'string') {
    var characterString = characters.join('');

    if (tree.indexOf(characterString) === 0) {
      // `tree` is always a single character.
      // If `tree.indexOf(characterString) === 0`
      // then `characters.length === tree.length`.

      /* istanbul ignore else */
      if (characters.length === tree.length) {
        return {
          match: true,
          matchedChars: characters
        };
      } // `tree` is always a single character.
      // If `tree.indexOf(characterString) === 0`
      // then `characters.length === tree.length`.

      /* istanbul ignore next */


      return {
        partialMatch: true // matchedChars: characters

      };
    }

    if (characterString.indexOf(tree) === 0) {
      if (last) {
        // The `else` path is not possible because `tree` is always a single character.
        // The `else` case for `characters.length > tree.length` would be
        // `characters.length <= tree.length` which means `characters.length <= 1`.
        // `characters` array can't be empty, so that means `characters === [tree]`,
        // which would also mean `tree.indexOf(characterString) === 0` and that'd mean
        // that the `if (tree.indexOf(characterString) === 0)` condition before this
        // `if` condition would be entered, and returned from there, not reaching this code.

        /* istanbul ignore else */
        if (characters.length > tree.length) {
          return {
            overflow: true
          };
        }
      }

      return {
        match: true,
        matchedChars: characters.slice(0, tree.length)
      };
    }

    return;
  }

  if (Array.isArray(tree)) {
    var restCharacters = characters.slice();
    var i = 0;

    while (i < tree.length) {
      var subtree = tree[i];

      var result = _match(restCharacters, subtree, last && i === tree.length - 1);

      if (!result) {
        return;
      } else if (result.overflow) {
        return result;
      } else if (result.match) {
        // Continue with the next subtree with the rest of the characters.
        restCharacters = restCharacters.slice(result.matchedChars.length);

        if (restCharacters.length === 0) {
          if (i === tree.length - 1) {
            return {
              match: true,
              matchedChars: characters
            };
          } else {
            return {
              partialMatch: true // matchedChars: characters

            };
          }
        }
      } else {
        /* istanbul ignore else */
        if (result.partialMatch) {
          return {
            partialMatch: true // matchedChars: characters

          };
        } else {
          throw new Error("Unsupported match result:\n".concat(JSON.stringify(result, null, 2)));
        }
      }

      i++;
    } // If `last` then overflow has already been checked
    // by the last element of the `tree` array.

    /* istanbul ignore if */


    if (last) {
      return {
        overflow: true
      };
    }

    return {
      match: true,
      matchedChars: characters.slice(0, characters.length - restCharacters.length)
    };
  }

  switch (tree.op) {
    case '|':
      var partialMatch;

      for (var _iterator = AsYouTypeFormatter_PatternMatcher_createForOfIteratorHelperLoose(tree.args), _step; !(_step = _iterator()).done;) {
        var branch = _step.value;

        var _result = _match(characters, branch, last);

        if (_result) {
          if (_result.overflow) {
            return _result;
          } else if (_result.match) {
            return {
              match: true,
              matchedChars: _result.matchedChars
            };
          } else {
            /* istanbul ignore else */
            if (_result.partialMatch) {
              partialMatch = true;
            } else {
              throw new Error("Unsupported match result:\n".concat(JSON.stringify(_result, null, 2)));
            }
          }
        }
      }

      if (partialMatch) {
        return {
          partialMatch: true // matchedChars: ...

        };
      } // Not even a partial match.


      return;

    case '[]':
      for (var _iterator2 = AsYouTypeFormatter_PatternMatcher_createForOfIteratorHelperLoose(tree.args), _step2; !(_step2 = _iterator2()).done;) {
        var _char = _step2.value;

        if (characters[0] === _char) {
          if (characters.length === 1) {
            return {
              match: true,
              matchedChars: characters
            };
          }

          if (last) {
            return {
              overflow: true
            };
          }

          return {
            match: true,
            matchedChars: [_char]
          };
        }
      } // No character matches.


      return;

    /* istanbul ignore next */

    default:
      throw new Error("Unsupported instruction tree: ".concat(tree));
  }
}
//# sourceMappingURL=AsYouTypeFormatter.PatternMatcher.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.js
function AsYouTypeFormatter_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = AsYouTypeFormatter_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function AsYouTypeFormatter_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return AsYouTypeFormatter_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AsYouTypeFormatter_arrayLikeToArray(o, minLen); }

function AsYouTypeFormatter_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function AsYouTypeFormatter_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AsYouTypeFormatter_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AsYouTypeFormatter_createClass(Constructor, protoProps, staticProps) { if (protoProps) AsYouTypeFormatter_defineProperties(Constructor.prototype, protoProps); if (staticProps) AsYouTypeFormatter_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }








 // Used in phone number format template creation.
// Could be any digit, I guess.

var DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`

var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.

var LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.

var NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// https://github.com/googlei18n/libphonenumber/commit/a395b4fef3caf57c4bc5f082e1152a4d2bd0ba4c
// "We no longer have numbers in formatting matching patterns, only \d."
// Because this library supports generating custom metadata
// some users may still be using old metadata so the relevant
// code seems to stay until some next major version update.

var SUPPORT_LEGACY_FORMATTING_PATTERNS = true; // A pattern that is used to match character classes in regular expressions.
// An example of a character class is "[1-4]".

var CREATE_CHARACTER_CLASS_PATTERN = SUPPORT_LEGACY_FORMATTING_PATTERNS && function () {
  return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.


var CREATE_STANDALONE_DIGIT_PATTERN = SUPPORT_LEGACY_FORMATTING_PATTERNS && function () {
  return /\d(?=[^,}][^,}])/g;
}; // A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//


var NON_ALTERING_FORMAT_REG_EXP = new RegExp('[' + VALID_PUNCTUATION + ']*' + // Google developers say:
// "We require that the first matching group is present in the
//  output pattern to ensure no data is lost while formatting."
'\\$1' + '[' + VALID_PUNCTUATION + ']*' + '(\\$\\d[' + VALID_PUNCTUATION + ']*)*' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.

var MIN_LEADING_DIGITS_LENGTH = 3;

var AsYouTypeFormatter_AsYouTypeFormatter = /*#__PURE__*/function () {
  function AsYouTypeFormatter(_ref) {
    var state = _ref.state,
        metadata = _ref.metadata;

    AsYouTypeFormatter_classCallCheck(this, AsYouTypeFormatter);

    this.metadata = metadata;
    this.resetFormat();
  }

  AsYouTypeFormatter_createClass(AsYouTypeFormatter, [{
    key: "resetFormat",
    value: function resetFormat() {
      this.chosenFormat = undefined;
      this.template = undefined;
      this.nationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan, state) {
      this.resetFormat();

      if (numberingPlan) {
        this.isNANP = numberingPlan.callingCode() === '1';
        this.matchingFormats = numberingPlan.formats();

        if (state.nationalSignificantNumber) {
          this.narrowDownMatchingFormats(state);
        }
      } else {
        this.isNANP = undefined;
        this.matchingFormats = [];
      }
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */

  }, {
    key: "format",
    value: function format(nextDigits, state) {
      var _this = this;

      // See if the phone number digits can be formatted as a complete phone number.
      // If not, use the results from `formatNationalNumberWithNextDigits()`,
      // which formats based on the chosen formatting pattern.
      //
      // Attempting to format complete phone number first is how it's done
      // in Google's `libphonenumber`, so this library just follows it.
      // Google's `libphonenumber` code doesn't explain in detail why does it
      // attempt to format digits as a complete phone number
      // instead of just going with a previoulsy (or newly) chosen `format`:
      //
      // "Checks to see if there is an exact pattern match for these digits.
      //  If so, we should use this instead of any other formatting template
      //  whose leadingDigitsPattern also matches the input."
      //
      if (canFormatCompleteNumber(state.nationalSignificantNumber, this.metadata)) {
        for (var _iterator = AsYouTypeFormatter_createForOfIteratorHelperLoose(this.matchingFormats), _step; !(_step = _iterator()).done;) {
          var format = _step.value;
          var formattedCompleteNumber = formatCompleteNumber(state, format, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
              return _this.shouldTryNationalPrefixFormattingRule(format, {
                international: state.international,
                nationalPrefix: state.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function getSeparatorAfterNationalPrefix(format) {
              return _this.getSeparatorAfterNationalPrefix(format);
            }
          });

          if (formattedCompleteNumber) {
            this.resetFormat();
            this.chosenFormat = format;
            this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, DIGIT_PLACEHOLDER), state);
            this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
            // using the old template needs to be reset.

            this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(DIGIT_PLACEHOLDER);
            return formattedCompleteNumber;
          }
        }
      } // Format the digits as a partial (incomplete) phone number
      // using the previously chosen formatting pattern (or a newly chosen one).


      return this.formatNationalNumberWithNextDigits(nextDigits, state);
    } // Formats the next phone number digits.

  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function formatNationalNumberWithNextDigits(nextDigits, state) {
      var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.

      var newlyChosenFormat = this.chooseFormat(state);

      if (newlyChosenFormat) {
        if (newlyChosenFormat === previouslyChosenFormat) {
          // If it can format the next (current) digits
          // using the previously chosen phone number format
          // then return the updated formatted number.
          return this.formatNextNationalNumberDigits(nextDigits);
        } else {
          // If a more appropriate phone number format
          // has been chosen for these "leading digits",
          // then re-format the national phone number part
          // using the newly selected format.
          return this.formatNextNationalNumberDigits(state.getNationalDigits());
        }
      }
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function narrowDownMatchingFormats(_ref2) {
      var _this2 = this;

      var nationalSignificantNumber = _ref2.nationalSignificantNumber,
          nationalPrefix = _ref2.nationalPrefix,
          international = _ref2.international;
      var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
      // "leading digits" pattern fitting a maximum of 3 leading digits.
      // So, after a user inputs 3 digits of a national (significant) phone number
      // this national (significant) number can already be formatted.
      // The next "leading digits" pattern is for 4 leading digits max,
      // and the "leading digits" pattern after it is for 5 leading digits max, etc.
      // This implementation is different from Google's
      // in that it searches for a fitting format
      // even if the user has entered less than
      // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
      // Because some leading digit patterns already match for a single first digit.

      var leadingDigitsPatternIndex = leadingDigits.length - MIN_LEADING_DIGITS_LENGTH;

      if (leadingDigitsPatternIndex < 0) {
        leadingDigitsPatternIndex = 0;
      }

      this.matchingFormats = this.matchingFormats.filter(function (format) {
        return _this2.formatSuits(format, international, nationalPrefix) && _this2.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
      }); // If there was a phone number format chosen
      // and it no longer holds given the new leading digits then reset it.
      // The test for this `if` condition is marked as:
      // "Reset a chosen format when it no longer holds given the new leading digits".
      // To construct a valid test case for this one can find a country
      // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
      // and yielding another format for 4 `<leadingDigits>` (Australia in this case).

      if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) {
        this.resetFormat();
      }
    }
  }, {
    key: "formatSuits",
    value: function formatSuits(format, international, nationalPrefix) {
      // When a prefix before a national (significant) number is
      // simply a national prefix, then it's parsed as `this.nationalPrefix`.
      // In more complex cases, a prefix before national (significant) number
      // could include a national prefix as well as some "capturing groups",
      // and in that case there's no info whether a national prefix has been parsed.
      // If national prefix is not used when formatting a phone number
      // using this format, but a national prefix has been entered by the user,
      // and was extracted, then discard such phone number format.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
      if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) {
        return false;
      } // If national prefix is mandatory for this phone number format
      // and there're no guarantees that a national prefix is present in user input
      // then discard this phone number format as not suitable.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193


      if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) {
        return false;
      }

      return true;
    }
  }, {
    key: "formatMatches",
    value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
      var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
      // leading digits pattern then it fits.
      // The test case could be found by searching for "leadingDigitsPatternsCount === 0".

      if (leadingDigitsPatternsCount === 0) {
        return true;
      } // Start narrowing down the list of possible formats based on the leading digits.
      // (only previously matched formats take part in the narrowing down process)
      // `leading_digits_patterns` start with 3 digits min
      // and then go up from there one digit at a time.


      leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
      var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Google imposes a requirement on the leading digits
      // to be minimum 3 digits long in order to be eligible
      // for checking those with a leading digits pattern.
      //
      // Since `leading_digits_patterns` start with 3 digits min,
      // Google's original `libphonenumber` library only starts
      // excluding any non-matching formats only when the
      // national number entered so far is at least 3 digits long,
      // otherwise format matching would give false negatives.
      //
      // For example, when the digits entered so far are `2`
      // and the leading digits pattern is `21` –
      // it's quite obvious in this case that the format could be the one
      // but due to the absence of further digits it would give false negative.
      //
      // Also, `leading_digits_patterns` doesn't always correspond to a single
      // digits count. For example, `60|8` pattern would already match `8`
      // but the `60` part would require having at least two leading digits,
      // so the whole pattern would require inputting two digits first in order to
      // decide on whether it matches the input, even when the input is "80".
      //
      // This library — `libphonenumber-js` — allows filtering by `leading_digits_patterns`
      // even when there's only 1 or 2 digits of the national (significant) number.
      // To do that, it uses a non-strict pattern matcher written specifically for that.
      //

      if (leadingDigits.length < MIN_LEADING_DIGITS_LENGTH) {
        // Before leading digits < 3 matching was implemented:
        // return true
        //
        // After leading digits < 3 matching was implemented:
        try {
          return new AsYouTypeFormatter_PatternMatcher_PatternMatcher(leadingDigitsPattern).match(leadingDigits, {
            allowOverflow: true
          }) !== undefined;
        } catch (error)
        /* istanbul ignore next */
        {
          // There's a slight possibility that there could be some undiscovered bug
          // in the pattern matcher code. Since the "leading digits < 3 matching"
          // feature is not "essential" for operation, it can fall back to the old way
          // in case of any issues rather than halting the application's execution.
          console.error(error);
          return true;
        }
      } // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are
      // available then use the usual regular expression matching.
      //
      // The whole pattern is wrapped in round brackets (`()`) because
      // the pattern can use "or" operator (`|`) at the top level of the pattern.
      //


      return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
    }
  }, {
    key: "getFormatFormat",
    value: function getFormatFormat(format, international) {
      return international ? format.internationalFormat() : format.format();
    }
  }, {
    key: "chooseFormat",
    value: function chooseFormat(state) {
      var _this3 = this;

      var _loop = function _loop() {
        var format = _step2.value;

        // If this format is currently being used
        // and is still suitable, then stick to it.
        if (_this3.chosenFormat === format) {
          return "break";
        } // Sometimes, a formatting rule inserts additional digits in a phone number,
        // and "as you type" formatter can't do that: it should only use the digits
        // that the user has input.
        //
        // For example, in Argentina, there's a format for mobile phone numbers:
        //
        // {
        //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
        //    "leading_digits_patterns": ["91"],
        //    "national_prefix_formatting_rule": "0$1",
        //    "format": "$2 15-$3-$4",
        //    "international_format": "$1 $2 $3-$4"
        // }
        //
        // In that format, `international_format` is used instead of `format`
        // because `format` inserts `15` in the formatted number,
        // and `AsYouType` formatter should only use the digits
        // the user has actually input, without adding any extra digits.
        // In this case, it wouldn't make a difference, because the `15`
        // is first stripped when applying `national_prefix_for_parsing`
        // and then re-added when using `format`, so in reality it doesn't
        // add any new digits to the number, but to detect that, the code
        // would have to be more complex: it would have to try formatting
        // the digits using the format and then see if any digits have
        // actually been added or removed, and then, every time a new digit
        // is input, it should re-check whether the chosen format doesn't
        // alter the digits.
        //
        // Google's code doesn't go that far, and so does this library:
        // it simply requires that a `format` doesn't add any additonal
        // digits to user's input.
        //
        // Also, people in general should move from inputting phone numbers
        // in national format (possibly with national prefixes)
        // and use international phone number format instead:
        // it's a logical thing in the modern age of mobile phones,
        // globalization and the internet.
        //

        /* istanbul ignore if */


        if (!NON_ALTERING_FORMAT_REG_EXP.test(_this3.getFormatFormat(format, state.international))) {
          return "continue";
        }

        if (!_this3.createTemplateForFormat(format, state)) {
          // Remove the format if it can't generate a template.
          _this3.matchingFormats = _this3.matchingFormats.filter(function (_) {
            return _ !== format;
          });
          return "continue";
        }

        _this3.chosenFormat = format;
        return "break";
      };

      // When there are multiple available formats, the formatter uses the first
      // format where a formatting template could be created.
      //
      // For some weird reason, `istanbul` says "else path not taken"
      // for the `for of` line below. Supposedly that means that
      // the loop doesn't ever go over the last element in the list.
      // That's true because there always is `this.chosenFormat`
      // when `this.matchingFormats` is non-empty.
      // And, for some weird reason, it doesn't think that the case
      // with empty `this.matchingFormats` qualifies for a valid "else" path.
      // So simply muting this `istanbul` warning.
      // It doesn't skip the contents of the `for of` loop,
      // it just skips the `for of` line.
      //

      /* istanbul ignore next */
      for (var _iterator2 = AsYouTypeFormatter_createForOfIteratorHelperLoose(this.matchingFormats.slice()), _step2; !(_step2 = _iterator2()).done;) {
        var _ret = _loop();

        if (_ret === "break") break;
        if (_ret === "continue") continue;
      }

      if (!this.chosenFormat) {
        // No format matches the national (significant) phone number.
        this.resetFormat();
      }

      return this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function createTemplateForFormat(format, state) {
      // The formatter doesn't format numbers when numberPattern contains '|', e.g.
      // (20|3)\d{4}. In those cases we quickly return.
      // (Though there's no such format in current metadata)

      /* istanbul ignore if */
      if (SUPPORT_LEGACY_FORMATTING_PATTERNS && format.pattern().indexOf('|') >= 0) {
        return;
      } // Get formatting template for this phone number format


      var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
      // for any phone number format, then abort.

      if (template) {
        this.setNationalNumberTemplate(template, state);
        return true;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function getSeparatorAfterNationalPrefix(format) {
      // `US` metadata doesn't have a `national_prefix_formatting_rule`,
      // so the `if` condition below doesn't apply to `US`,
      // but in reality there shoudl be a separator
      // between a national prefix and a national (significant) number.
      // So `US` national prefix separator is a "special" "hardcoded" case.
      if (this.isNANP) {
        return ' ';
      } // If a `format` has a `national_prefix_formatting_rule`
      // and that rule has a separator after a national prefix,
      // then it means that there should be a separator
      // between a national prefix and a national (significant) number.


      if (format && format.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) {
        return ' ';
      } // At this point, there seems to be no clear evidence that
      // there should be a separator between a national prefix
      // and a national (significant) number. So don't insert one.


      return '';
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function getInternationalPrefixBeforeCountryCallingCode(_ref3, options) {
      var IDDPrefix = _ref3.IDDPrefix,
          missingPlus = _ref3.missingPlus;

      if (IDDPrefix) {
        return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
      }

      if (missingPlus) {
        return '';
      }

      return '+';
    }
  }, {
    key: "getTemplate",
    value: function getTemplate(state) {
      if (!this.template) {
        return;
      } // `this.template` holds the template for a "complete" phone number.
      // The currently entered phone number is most likely not "complete",
      // so trim all non-populated digits.


      var index = -1;
      var i = 0;
      var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
        spacing: false
      }) : '';

      while (i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length) {
        index = this.template.indexOf(DIGIT_PLACEHOLDER, index + 1);
        i++;
      }

      return cutAndStripNonPairedParens(this.template, index + 1);
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function setNationalNumberTemplate(template, state) {
      this.nationalNumberTemplate = template;
      this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
      // using the old template needs to be reset.

      this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
      // contains the whole international number
      // if the phone number being input is international:
      // 'x' for the '+' sign, 'x'es for the country phone code,
      // a spacebar and then the template for the formatted national number.

      if (state.international) {
        this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, DIGIT_PLACEHOLDER) + repeat(DIGIT_PLACEHOLDER, state.callingCode.length) + ' ' + template;
      } else {
        this.template = template;
      }
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */

  }, {
    key: "getTemplateForFormat",
    value: function getTemplateForFormat(format, _ref4) {
      var nationalSignificantNumber = _ref4.nationalSignificantNumber,
          international = _ref4.international,
          nationalPrefix = _ref4.nationalPrefix,
          complexPrefixBeforeNationalSignificantNumber = _ref4.complexPrefixBeforeNationalSignificantNumber;
      var pattern = format.pattern();
      /* istanbul ignore else */

      if (SUPPORT_LEGACY_FORMATTING_PATTERNS) {
        pattern = pattern // Replace anything in the form of [..] with \d
        .replace(CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
        .replace(CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
      } // Generate a dummy national number (consisting of `9`s)
      // that fits this format's `pattern`.
      //
      // This match will always succeed,
      // because the "longest dummy phone number"
      // has enough length to accomodate any possible
      // national phone number format pattern.
      //


      var digits = LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
      // for any phone number format, then abort.

      if (nationalSignificantNumber.length > digits.length) {
        return;
      } // Get a formatting template which can be used to efficiently format
      // a partial number where digits are added one by one.
      // Below `strictPattern` is used for the
      // regular expression (with `^` and `$`).
      // This wasn't originally in Google's `libphonenumber`
      // and I guess they don't really need it
      // because they're not using "templates" to format phone numbers
      // but I added `strictPattern` after encountering
      // South Korean phone number formatting bug.
      //
      // Non-strict regular expression bug demonstration:
      //
      // this.nationalSignificantNumber : `111111111` (9 digits)
      //
      // pattern : (\d{2})(\d{3,4})(\d{4})
      // format : `$1 $2 $3`
      // digits : `9999999999` (10 digits)
      //
      // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
      //
      // template : xx xxxx xxxx
      //
      // But the correct template in this case is `xx xxx xxxx`.
      // The template was generated incorrectly because of the
      // `{3,4}` variability in the `pattern`.
      //
      // The fix is, if `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
      // is used instead of `digits`.


      var strictPattern = new RegExp('^' + pattern + '$');
      var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then use it
      // instead of `digits`.

      if (strictPattern.test(nationalNumberDummyDigits)) {
        digits = nationalNumberDummyDigits;
      }

      var numberFormat = this.getFormatFormat(format, international);
      var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
      // and if a `format` does have a national prefix formatting rule,
      // then see if that national prefix formatting rule
      // prepends exactly the same national prefix the user has input.
      // If that's the case, then use the `format` with the national prefix formatting rule.
      // Otherwise, use  the `format` without the national prefix formatting rule,
      // and prepend a national prefix manually to it.

      if (this.shouldTryNationalPrefixFormattingRule(format, {
        international: international,
        nationalPrefix: nationalPrefix
      })) {
        var numberFormatWithNationalPrefix = numberFormat.replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
        // national prefix at the start of a national (significant) number,
        // then such formatting can be used with `AsYouType` formatter.
        // There seems to be no `else` case: everywhere in metadata,
        // national prefix formatting rule is national prefix + $1,
        // or `($1)`, in which case such format isn't even considered
        // when the user has input a national prefix.

        /* istanbul ignore else */

        if (parseDigits(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + parseDigits('$1')) {
          numberFormat = numberFormatWithNationalPrefix;
          nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
          // with `DIGIT_PLACEHOLDER`s.

          if (nationalPrefix) {
            var i = nationalPrefix.length;

            while (i > 0) {
              numberFormat = numberFormat.replace(/\d/, DIGIT_PLACEHOLDER);
              i--;
            }
          }
        }
      } // Generate formatting template for this phone number format.


      var template = digits // Format the dummy phone number according to the format.
      .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
      .replace(new RegExp(DUMMY_DIGIT, 'g'), DIGIT_PLACEHOLDER); // If a prefix of a national (significant) number is not as simple
      // as just a basic national prefix, then just prepend such prefix
      // before the national (significant) number, optionally spacing
      // the two with a whitespace.

      if (!nationalPrefixIncludedInTemplate) {
        if (complexPrefixBeforeNationalSignificantNumber) {
          // Prepend the prefix to the template manually.
          template = repeat(DIGIT_PLACEHOLDER, complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
        } else if (nationalPrefix) {
          // Prepend national prefix to the template manually.
          template = repeat(DIGIT_PLACEHOLDER, nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
        }
      }

      if (international) {
        template = applyInternationalSeparatorStyle(template);
      }

      return template;
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function formatNextNationalNumberDigits(digits) {
      var result = populateTemplateWithDigits(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);

      if (!result) {
        // Reset the format.
        this.resetFormat();
        return;
      }

      this.populatedNationalNumberTemplate = result[0];
      this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.

      return cutAndStripNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
      // for `react-phone-number-input`'s default input (`InputBasic`).
      // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
      // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function shouldTryNationalPrefixFormattingRule(format, _ref5) {
      var international = _ref5.international,
          nationalPrefix = _ref5.nationalPrefix;

      if (format.nationalPrefixFormattingRule()) {
        // In some countries, `national_prefix_formatting_rule` is `($1)`,
        // so it applies even if the user hasn't input a national prefix.
        // `format.usesNationalPrefix()` detects such cases.
        var usesNationalPrefix = format.usesNationalPrefix();

        if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) {
          return true;
        }
      }
    }
  }]);

  return AsYouTypeFormatter;
}();


//# sourceMappingURL=AsYouTypeFormatter.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/AsYouTypeParser.js
function AsYouTypeParser_slicedToArray(arr, i) { return AsYouTypeParser_arrayWithHoles(arr) || AsYouTypeParser_iterableToArrayLimit(arr, i) || AsYouTypeParser_unsupportedIterableToArray(arr, i) || AsYouTypeParser_nonIterableRest(); }

function AsYouTypeParser_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function AsYouTypeParser_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return AsYouTypeParser_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AsYouTypeParser_arrayLikeToArray(o, minLen); }

function AsYouTypeParser_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function AsYouTypeParser_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function AsYouTypeParser_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function AsYouTypeParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AsYouTypeParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AsYouTypeParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) AsYouTypeParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) AsYouTypeParser_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }







var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+';
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp('^' + VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + '$', 'i');
var VALID_FORMATTED_PHONE_NUMBER_PART = '(?:' + '[' + PLUS_CHARS + ']' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*' + '|' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + ')';
var AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.

var COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;

var AsYouTypeParser_AsYouTypeParser = /*#__PURE__*/function () {
  function AsYouTypeParser(_ref) {
    var defaultCountry = _ref.defaultCountry,
        defaultCallingCode = _ref.defaultCallingCode,
        metadata = _ref.metadata,
        onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;

    AsYouTypeParser_classCallCheck(this, AsYouTypeParser);

    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.metadata = metadata;
    this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
  }

  AsYouTypeParser_createClass(AsYouTypeParser, [{
    key: "input",
    value: function input(text, state) {
      var _extractFormattedDigi = extractFormattedDigitsAndPlus(text),
          _extractFormattedDigi2 = AsYouTypeParser_slicedToArray(_extractFormattedDigi, 2),
          formattedDigits = _extractFormattedDigi2[0],
          hasPlus = _extractFormattedDigi2[1];

      var digits = parseDigits(formattedDigits); // Checks for a special case: just a leading `+` has been entered.

      var justLeadingPlus;

      if (hasPlus) {
        if (!state.digits) {
          state.startInternationalNumber();

          if (!digits) {
            justLeadingPlus = true;
          }
        }
      }

      if (digits) {
        this.inputDigits(digits, state);
      }

      return {
        digits: digits,
        justLeadingPlus: justLeadingPlus
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */

  }, {
    key: "inputDigits",
    value: function inputDigits(nextDigits, state) {
      var digits = state.digits;
      var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.

      state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
      // Some users input their phone number in international format,
      // but in an "out-of-country" dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers as soon as there're at least 3 digits.
      // Google's library attempts to extract IDD prefix at 3 digits,
      // so this library just copies that behavior.
      // I guess that's because the most commot IDD prefixes are
      // `00` (Europe) and `011` (US).
      // There exist really long IDD prefixes too:
      // for example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      // An IDD prefix is extracted here, and then every time when
      // there's a new digit and the number couldn't be formatted.

      if (hasReceivedThreeLeadingDigits) {
        this.extractIddPrefix(state);
      }

      if (this.isWaitingForCountryCallingCode(state)) {
        if (!this.extractCountryCallingCode(state)) {
          return;
        }
      } else {
        state.appendNationalSignificantNumberDigits(nextDigits);
      } // If a phone number is being input in international format,
      // then it's not valid for it to have a national prefix.
      // Still, some people incorrectly input such numbers with a national prefix.
      // In such cases, only attempt to strip a national prefix if the number becomes too long.
      // (but that is done later, not here)


      if (!state.international) {
        if (!this.hasExtractedNationalSignificantNumber) {
          this.extractNationalSignificantNumber(state.getNationalDigits(), function (stateUpdate) {
            return state.update(stateUpdate);
          });
        }
      }
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function isWaitingForCountryCallingCode(_ref2) {
      var international = _ref2.international,
          callingCode = _ref2.callingCode;
      return international && !callingCode;
    } // Extracts a country calling code from a number
    // being entered in internatonal format.

  }, {
    key: "extractCountryCallingCode",
    value: function extractCountryCallingCode(state) {
      var _extractCountryCallin = extractCountryCallingCode_extractCountryCallingCode('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
          countryCallingCode = _extractCountryCallin.countryCallingCode,
          number = _extractCountryCallin.number;

      if (countryCallingCode) {
        state.setCallingCode(countryCallingCode);
        state.update({
          nationalSignificantNumber: number
        });
        return true;
      }
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan) {
      if (numberingPlan) {
        this.hasSelectedNumberingPlan = true;

        var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();

        this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
      } else {
        this.hasSelectedNumberingPlan = undefined;
        this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
      }
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */

  }, {
    key: "extractNationalSignificantNumber",
    value: function extractNationalSignificantNumber(nationalDigits, setState) {
      if (!this.hasSelectedNumberingPlan) {
        return;
      }

      var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe.nationalPrefix,
          nationalNumber = _extractNationalNumbe.nationalNumber,
          carrierCode = _extractNationalNumbe.carrierCode;

      if (nationalNumber === nationalDigits) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */

  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
      if (!this.hasExtractedNationalSignificantNumber) {
        return this.extractNationalSignificantNumber(nationalDigits, setState);
      }

      if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        return;
      }

      var _extractNationalNumbe2 = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe2.nationalPrefix,
          nationalNumber = _extractNationalNumbe2.nationalNumber,
          carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
      // then it's always extracted as additional digits are added.
      // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
      // doesn't do anything different from what it currently does.
      // So, just in case, here's this check, though it doesn't occur.

      /* istanbul ignore if */


      if (nationalNumber === prevNationalSignificantNumber) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
      var complexPrefixBeforeNationalSignificantNumber;
      var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.

      var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
      // last substring of the `digits`, then it means that it hasn't been altered:
      // no digits have been removed from the national (significant) number
      // while applying `national_prefix_transform_rule`.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule

      if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
        nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
        // as just a basic national prefix, then such prefix is stored in
        // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
        // prepended "as is" to the national (significant) number to produce
        // a formatted result.

        var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
        // because `onExtractedNationalNumber()` isn't called
        // when a national (significant) number hasn't been actually "extracted":
        // when a national (significant) number is equal to the national part of `digits`,
        // then `onExtractedNationalNumber()` doesn't get called.

        if (prefixBeforeNationalNumber !== nationalPrefix) {
          complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
        }
      }

      setState({
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode,
        nationalSignificantNumber: nationalSignificantNumber,
        nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
        complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
      }); // `onExtractedNationalNumber()` is only called when
      // the national (significant) number actually did change.

      this.hasExtractedNationalSignificantNumber = true;
      this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function reExtractNationalSignificantNumber(state) {
      // Attempt to extract a national prefix.
      //
      // Some people incorrectly input national prefix
      // in an international phone number.
      // For example, some people write British phone numbers as `+44(0)...`.
      //
      // Also, in some rare cases, it is valid for a national prefix
      // to be a part of an international phone number.
      // For example, mobile phone numbers in Mexico are supposed to be
      // dialled internationally using a `1` national prefix,
      // so the national prefix will be part of an international number.
      //
      // Quote from:
      // https://www.mexperience.com/dialing-cell-phones-in-mexico/
      //
      // "Dialing a Mexican cell phone from abroad
      // When you are calling a cell phone number in Mexico from outside Mexico,
      // it’s necessary to dial an additional “1” after Mexico’s country code
      // (which is “52”) and before the area code.
      // You also ignore the 045, and simply dial the area code and the
      // cell phone’s number.
      //
      // If you don’t add the “1”, you’ll receive a recorded announcement
      // asking you to redial using it.
      //
      // For example, if you are calling from the USA to a cell phone
      // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
      // (Note that this is different to calling a land line in Mexico City
      // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
      //
      // Google's demo output:
      // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
      //
      if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, function (stateUpdate) {
        return state.update(stateUpdate);
      })) {
        return true;
      } // If no format matches the phone number, then it could be
      // "a really long IDD" (quote from a comment in Google's library).
      // An IDD prefix is first extracted when the user has entered at least 3 digits,
      // and then here — every time when there's a new digit and the number
      // couldn't be formatted.
      // For example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      //
      // Could also check `!hasReceivedThreeLeadingDigits` here
      // to filter out the case when this check duplicates the one
      // already performed when there're 3 leading digits,
      // but it's not a big deal, and in most cases there
      // will be a suitable `format` when there're 3 leading digits.
      //


      if (this.extractIddPrefix(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      } // Google's AsYouType formatter supports sort of an "autocorrection" feature
      // when it "autocorrects" numbers that have been input for a country
      // with that country's calling code.
      // Such "autocorrection" feature looks weird, but different people have been requesting it:
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      // https://github.com/catamphetamine/libphonenumber-js/issues/375
      // https://github.com/catamphetamine/libphonenumber-js/issues/316


      if (this.fixMissingPlus(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      }
    }
  }, {
    key: "extractIddPrefix",
    value: function extractIddPrefix(state) {
      // An IDD prefix can't be present in a number written with a `+`.
      // Also, don't re-extract an IDD prefix if has already been extracted.
      var international = state.international,
          IDDPrefix = state.IDDPrefix,
          digits = state.digits,
          nationalSignificantNumber = state.nationalSignificantNumber;

      if (international || IDDPrefix) {
        return;
      } // Some users input their phone number in "out-of-country"
      // dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers.


      var numberWithoutIDD = stripIddPrefix(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);

      if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
        // If an IDD prefix was stripped then convert the IDD-prefixed number
        // to international number for subsequent parsing.
        state.update({
          IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
        });
        this.startInternationalNumber(state, {
          country: undefined,
          callingCode: undefined
        });
        return true;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function fixMissingPlus(state) {
      if (!state.international) {
        var _extractCountryCallin2 = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
            newCallingCode = _extractCountryCallin2.countryCallingCode,
            number = _extractCountryCallin2.number;

        if (newCallingCode) {
          state.update({
            missingPlus: true
          });
          this.startInternationalNumber(state, {
            country: state.country,
            callingCode: newCallingCode
          });
          return true;
        }
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber(state, _ref3) {
      var country = _ref3.country,
          callingCode = _ref3.callingCode;
      state.startInternationalNumber(country, callingCode); // If a national (significant) number has been extracted before, reset it.

      if (state.nationalSignificantNumber) {
        state.resetNationalSignificantNumber();
        this.onNationalSignificantNumberChange();
        this.hasExtractedNationalSignificantNumber = undefined;
      }
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function extractCallingCodeAndNationalSignificantNumber(state) {
      if (this.extractCountryCallingCode(state)) {
        // `this.extractCallingCode()` is currently called when the number
        // couldn't be formatted during the standard procedure.
        // Normally, the national prefix would be re-extracted
        // for an international number if such number couldn't be formatted,
        // but since it's already not able to be formatted,
        // there won't be yet another retry, so also extract national prefix here.
        this.extractNationalSignificantNumber(state.getNationalDigits(), function (stateUpdate) {
          return state.update(stateUpdate);
        });
      }
    }
  }]);

  return AsYouTypeParser;
}();
/**
 * Extracts formatted phone number from text (if there's any).
 * @param  {string} text
 * @return {string} [formattedPhoneNumber]
 */




function AsYouTypeParser_extractFormattedPhoneNumber(text) {
  // Attempt to extract a possible number from the string passed in.
  var startsAt = text.search(VALID_FORMATTED_PHONE_NUMBER_PART);

  if (startsAt < 0) {
    return;
  } // Trim everything to the left of the phone number.


  text = text.slice(startsAt); // Trim the `+`.

  var hasPlus;

  if (text[0] === '+') {
    hasPlus = true;
    text = text.slice('+'.length);
  } // Trim everything to the right of the phone number.


  text = text.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.

  if (hasPlus) {
    text = '+' + text;
  }

  return text;
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function _extractFormattedDigitsAndPlus(text) {
  // Extract a formatted phone number part from text.
  var extractedNumber = AsYouTypeParser_extractFormattedPhoneNumber(text) || ''; // Trim a `+`.

  if (extractedNumber[0] === '+') {
    return [extractedNumber.slice('+'.length), true];
  }

  return [extractedNumber];
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function extractFormattedDigitsAndPlus(text) {
  var _extractFormattedDigi3 = _extractFormattedDigitsAndPlus(text),
      _extractFormattedDigi4 = AsYouTypeParser_slicedToArray(_extractFormattedDigi3, 2),
      formattedDigits = _extractFormattedDigi4[0],
      hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
  // can possibly be a part of some valid phone number
  // then parse phone number characters from a formatted phone number.


  if (!VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) {
    formattedDigits = '';
  }

  return [formattedDigits, hasPlus];
}
//# sourceMappingURL=AsYouTypeParser.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/AsYouType.js
function AsYouType_typeof(obj) { "@babel/helpers - typeof"; return AsYouType_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, AsYouType_typeof(obj); }

function AsYouType_slicedToArray(arr, i) { return AsYouType_arrayWithHoles(arr) || AsYouType_iterableToArrayLimit(arr, i) || AsYouType_unsupportedIterableToArray(arr, i) || AsYouType_nonIterableRest(); }

function AsYouType_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function AsYouType_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return AsYouType_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AsYouType_arrayLikeToArray(o, minLen); }

function AsYouType_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function AsYouType_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function AsYouType_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function AsYouType_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AsYouType_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AsYouType_createClass(Constructor, protoProps, staticProps) { if (protoProps) AsYouType_defineProperties(Constructor.prototype, protoProps); if (staticProps) AsYouType_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }







var AsYouType_USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;

var AsYouType_AsYouType = /*#__PURE__*/function () {
  /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */
  function AsYouType(optionsOrDefaultCountry, metadata) {
    AsYouType_classCallCheck(this, AsYouType);

    this.metadata = new Metadata(metadata);

    var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry),
        _this$getCountryAndCa2 = AsYouType_slicedToArray(_this$getCountryAndCa, 2),
        defaultCountry = _this$getCountryAndCa2[0],
        defaultCallingCode = _this$getCountryAndCa2[1];

    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.reset();
  }

  AsYouType_createClass(AsYouType, [{
    key: "getCountryAndCallingCode",
    value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
      // Set `defaultCountry` and `defaultCallingCode` options.
      var defaultCountry;
      var defaultCallingCode; // Turns out `null` also has type "object". Weird.

      if (optionsOrDefaultCountry) {
        if (AsYouType_typeof(optionsOrDefaultCountry) === 'object') {
          defaultCountry = optionsOrDefaultCountry.defaultCountry;
          defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
        } else {
          defaultCountry = optionsOrDefaultCountry;
        }
      }

      if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) {
        defaultCountry = undefined;
      }

      if (defaultCallingCode) {
        /* istanbul ignore if */
        if (AsYouType_USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
          if (this.metadata.isNonGeographicCallingCode(defaultCallingCode)) {
            defaultCountry = '001';
          }
        }
      }

      return [defaultCountry, defaultCallingCode];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */

  }, {
    key: "input",
    value: function input(text) {
      var _this$parser$input = this.parser.input(text, this.state),
          digits = _this$parser$input.digits,
          justLeadingPlus = _this$parser$input.justLeadingPlus;

      if (justLeadingPlus) {
        this.formattedOutput = '+';
      } else if (digits) {
        this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.

        if (this.state.nationalSignificantNumber) {
          this.formatter.narrowDownMatchingFormats(this.state);
        }

        var formattedNationalNumber;

        if (this.metadata.hasSelectedNumberingPlan()) {
          formattedNationalNumber = this.formatter.format(digits, this.state);
        }

        if (formattedNationalNumber === undefined) {
          // See if another national (significant) number could be re-extracted.
          if (this.parser.reExtractNationalSignificantNumber(this.state)) {
            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.

            var nationalDigits = this.state.getNationalDigits();

            if (nationalDigits) {
              formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
            }
          }
        }

        this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
      }

      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this = this;

      this.state = new AsYouTypeState({
        onCountryChange: function onCountryChange(country) {
          // Before version `1.6.0`, the official `AsYouType` formatter API
          // included the `.country` property of an `AsYouType` instance.
          // Since that property (along with the others) have been moved to
          // `this.state`, `this.country` property is emulated for compatibility
          // with the old versions.
          _this.country = country;
        },
        onCallingCodeChange: function onCallingCodeChange(callingCode, country) {
          _this.metadata.selectNumberingPlan(country, callingCode);

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);

          _this.parser.reset(_this.metadata.numberingPlan);
        }
      });
      this.formatter = new AsYouTypeFormatter_AsYouTypeFormatter({
        state: this.state,
        metadata: this.metadata
      });
      this.parser = new AsYouTypeParser_AsYouTypeParser({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
          _this.determineTheCountryIfNeeded();

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
        }
      });
      this.state.reset(this.defaultCountry, this.defaultCallingCode);
      this.formattedOutput = '';
      return this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */

  }, {
    key: "isInternational",
    value: function isInternational() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */

  }, {
    key: "getCallingCode",
    value: function getCallingCode() {
      // If the number is being input in national format and some "default calling code"
      // has been passed to `AsYouType` constructor, then `this.state.callingCode`
      // is equal to that "default calling code".
      //
      // If the number is being input in national format and no "default calling code"
      // has been passed to `AsYouType` constructor, then returns `undefined`,
      // even if a "default country" has been passed to `AsYouType` constructor.
      //
      if (this.isInternational()) {
        return this.state.callingCode;
      }
    } // A legacy alias.

  }, {
    key: "getCountryCallingCode",
    value: function getCountryCallingCode() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */

  }, {
    key: "getCountry",
    value: function getCountry() {
      var digits = this.state.digits; // Return `undefined` if no digits have been input yet.

      if (digits) {
        return this._getCountry();
      }
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */

  }, {
    key: "_getCountry",
    value: function _getCountry() {
      var country = this.state.country;
      /* istanbul ignore if */

      if (AsYouType_USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        // `AsYouType.getCountry()` returns `undefined`
        // for "non-geographic" phone numbering plans.
        if (country === '001') {
          return;
        }
      }

      return country;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function determineTheCountryIfNeeded() {
      // Suppose a user enters a phone number in international format,
      // and there're several countries corresponding to that country calling code,
      // and a country has been derived from the number, and then
      // a user enters one more digit and the number is no longer
      // valid for the derived country, so the country should be re-derived
      // on every new digit in those cases.
      //
      // If the phone number is being input in national format,
      // then it could be a case when `defaultCountry` wasn't specified
      // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
      // and that "calling code" could correspond to a "non-geographic entity",
      // or there could be several countries corresponding to that country calling code.
      // In those cases, `this.country` is `undefined` and should be derived
      // from the number. Again, if country calling code is ambiguous, then
      // `this.country` should be re-derived with each new digit.
      //
      if (!this.state.country || this.isCountryCallingCodeAmbiguous()) {
        this.determineTheCountry();
      }
    } // Prepends `+CountryCode ` in case of an international phone number

  }, {
    key: "getFullNumber",
    value: function getFullNumber(formattedNationalNumber) {
      var _this2 = this;

      if (this.isInternational()) {
        var prefix = function prefix(text) {
          return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
            spacing: text ? true : false
          }) + text;
        };

        var callingCode = this.state.callingCode;

        if (!callingCode) {
          return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
        }

        if (!formattedNationalNumber) {
          return prefix(callingCode);
        }

        return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
      }

      return formattedNationalNumber;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function getNonFormattedNationalNumberWithPrefix() {
      var _this$state = this.state,
          nationalSignificantNumber = _this$state.nationalSignificantNumber,
          complexPrefixBeforeNationalSignificantNumber = _this$state.complexPrefixBeforeNationalSignificantNumber,
          nationalPrefix = _this$state.nationalPrefix;
      var number = nationalSignificantNumber;
      var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;

      if (prefix) {
        number = prefix + number;
      }

      return number;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function getNonFormattedNumber() {
      var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function getNonFormattedTemplate() {
      var number = this.getNonFormattedNumber();

      if (number) {
        return number.replace(/[\+\d]/g, DIGIT_PLACEHOLDER);
      }
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function isCountryCallingCodeAmbiguous() {
      var callingCode = this.state.callingCode;
      var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
      return countryCodes && countryCodes.length > 1;
    } // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.

  }, {
    key: "determineTheCountry",
    value: function determineTheCountry() {
      this.state.setCountry(getCountryByCallingCode(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, this.state.nationalSignificantNumber, this.metadata));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */

  }, {
    key: "getNumberValue",
    value: function getNumberValue() {
      var _this$state2 = this.state,
          digits = _this$state2.digits,
          callingCode = _this$state2.callingCode,
          country = _this$state2.country,
          nationalSignificantNumber = _this$state2.nationalSignificantNumber; // Will return `undefined` if no digits have been input.

      if (!digits) {
        return;
      }

      if (this.isInternational()) {
        if (callingCode) {
          return '+' + callingCode + nationalSignificantNumber;
        } else {
          return '+' + digits;
        }
      } else {
        if (country || callingCode) {
          var callingCode_ = country ? this.metadata.countryCallingCode() : callingCode;
          return '+' + callingCode_ + nationalSignificantNumber;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */

  }, {
    key: "getNumber",
    value: function getNumber() {
      var _this$state3 = this.state,
          nationalSignificantNumber = _this$state3.nationalSignificantNumber,
          carrierCode = _this$state3.carrierCode,
          callingCode = _this$state3.callingCode; // `this._getCountry()` is basically same as `this.state.country`
      // with the only change that it return `undefined` in case of a
      // "non-geographic" numbering plan instead of `"001"` "internal use" value.

      var country = this._getCountry();

      if (!nationalSignificantNumber) {
        return;
      }

      if (!country && !callingCode) {
        return;
      }

      var phoneNumber = new PhoneNumber_PhoneNumber(country || callingCode, nationalSignificantNumber, this.metadata.metadata);

      if (carrierCode) {
        phoneNumber.carrierCode = carrierCode;
      } // Phone number extensions are not supported by "As You Type" formatter.


      return phoneNumber;
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */

  }, {
    key: "isPossible",
    value: function isPossible() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isPossible();
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */

  }, {
    key: "isValid",
    value: function isValid() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isValid();
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */

  }, {
    key: "getNationalNumber",
    value: function getNationalNumber() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */

  }, {
    key: "getChars",
    value: function getChars() {
      return (this.state.international ? '+' : '') + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */

  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
    }
  }]);

  return AsYouType;
}();


//# sourceMappingURL=AsYouType.js.map
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/modules/helpers/inputValuePrefix.js

function getInputValuePrefix(_ref) {
  var country = _ref.country,
      international = _ref.international,
      withCountryCallingCode = _ref.withCountryCallingCode,
      metadata = _ref.metadata;
  return country && international && !withCountryCallingCode ? "+".concat(getCountryCallingCode(country, metadata)) : '';
}
function removeInputValuePrefix(value, prefix) {
  if (prefix) {
    value = value.slice(prefix.length);

    if (value[0] === ' ') {
      value = value.slice(1);
    }
  }

  return value;
}
//# sourceMappingURL=inputValuePrefix.js.map
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/modules/InputSmart.js
var InputSmart_excluded = ["country", "international", "withCountryCallingCode", "metadata"];

function InputSmart_extends() { InputSmart_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return InputSmart_extends.apply(this, arguments); }

function InputSmart_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = InputSmart_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function InputSmart_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






function createInput(defaultMetadata) {
  /**
   * `InputSmart` is a "smarter" implementation of a `Component`
   * that can be passed to `<PhoneInput/>`. It parses and formats
   * the user's and maintains the caret's position in the process.
   * The caret positioning is maintained using `input-format` library.
   * Relies on being run in a DOM environment for calling caret positioning functions.
   */
  function InputSmart(_ref, ref) {
    var country = _ref.country,
        international = _ref.international,
        withCountryCallingCode = _ref.withCountryCallingCode,
        metadata = _ref.metadata,
        rest = InputSmart_objectWithoutProperties(_ref, InputSmart_excluded);

    var format = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useCallback"])(function (value) {
      // "As you type" formatter.
      var formatter = new AsYouType_AsYouType(country, metadata);
      var prefix = getInputValuePrefix({
        country: country,
        international: international,
        withCountryCallingCode: withCountryCallingCode,
        metadata: metadata
      }); // Format the number.

      var text = formatter.input(prefix + value);
      var template = formatter.getTemplate();

      if (prefix) {
        text = removeInputValuePrefix(text, prefix); // `AsYouType.getTemplate()` can be `undefined`.

        if (template) {
          template = removeInputValuePrefix(template, prefix);
        }
      }

      return {
        text: text,
        template: template
      };
    }, [country, metadata]);
    return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(react_Input, InputSmart_extends({}, rest, {
      ref: ref,
      parse: parsePhoneNumberCharacter,
      format: format
    }));
  }

  InputSmart = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.forwardRef(InputSmart);
  InputSmart.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: prop_types_default.a.string.isRequired,

    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: prop_types_default.a.func.isRequired,

    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */
    country: prop_types_default.a.string,

    /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */
    international: prop_types_default.a.bool,

    /**
     * If `country` and `international` properties are set,
     * then by default it won't include "country calling code" in the input field.
     * To change that, pass `withCountryCallingCode` property,
     * and it will include "country calling code" in the input field.
     */
    withCountryCallingCode: prop_types_default.a.bool,

    /**
     * `libphonenumber-js` metadata.
     */
    metadata: prop_types_default.a.object.isRequired
  };
  InputSmart.defaultProps = {
    metadata: defaultMetadata
  };
  return InputSmart;
}
/* harmony default export */ var modules_InputSmart = (createInput());
//# sourceMappingURL=InputSmart.js.map
// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/formatIncompletePhoneNumber.js

/**
 * Formats a (possibly incomplete) phone number.
 * The phone number can be either in E.164 format
 * or in a form of national number digits.
 * @param {string} value - A possibly incomplete phone number. Either in E.164 format or in a form of national number digits.
 * @param {string?} country - Two-letter ("ISO 3166-1 alpha-2") country code.
 * @return {string} Formatted (possibly incomplete) phone number.
 */

function formatIncompletePhoneNumber(value, country, metadata) {
  if (!metadata) {
    metadata = country;
    country = undefined;
  }

  return new AsYouType_AsYouType(country, metadata).input(value);
}
//# sourceMappingURL=formatIncompletePhoneNumber.js.map
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/modules/InputBasic.js
var InputBasic_excluded = ["value", "onChange", "country", "international", "withCountryCallingCode", "metadata", "inputComponent"];

function InputBasic_extends() { InputBasic_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return InputBasic_extends.apply(this, arguments); }

function InputBasic_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = InputBasic_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function InputBasic_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





function InputBasic_createInput(defaultMetadata) {
  /**
   * `InputBasic` is the most basic implementation of a `Component`
   * that can be passed to `<PhoneInput/>`. It parses and formats
   * the user's input but doesn't control the caret in the process:
   * when erasing or inserting digits in the middle of a phone number
   * the caret usually jumps to the end (this is the expected behavior).
   * Why does `InputBasic` exist when there's `InputSmart`?
   * One reason is working around the [Samsung Galaxy smart caret positioning bug]
   * (https://github.com/catamphetamine/react-phone-number-input/issues/75).
   * Another reason is that, unlike `InputSmart`, it doesn't require DOM environment.
   */
  function InputBasic(_ref, ref) {
    var value = _ref.value,
        onChange = _ref.onChange,
        country = _ref.country,
        international = _ref.international,
        withCountryCallingCode = _ref.withCountryCallingCode,
        metadata = _ref.metadata,
        Input = _ref.inputComponent,
        rest = InputBasic_objectWithoutProperties(_ref, InputBasic_excluded);

    var prefix = getInputValuePrefix({
      country: country,
      international: international,
      withCountryCallingCode: withCountryCallingCode,
      metadata: metadata
    });

    var _onChange = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useCallback"])(function (event) {
      var newValue = parseIncompletePhoneNumber(event.target.value); // By default, if a value is something like `"(123)"`
      // then Backspace would only erase the rightmost brace
      // becoming something like `"(123"`
      // which would give the same `"123"` value
      // which would then be formatted back to `"(123)"`
      // and so a user wouldn't be able to erase the phone number.
      // Working around this issue with this simple hack.

      if (newValue === value) {
        var newValueFormatted = InputBasic_format(prefix, newValue, country, metadata);

        if (newValueFormatted.indexOf(event.target.value) === 0) {
          // Trim the last digit (or plus sign).
          newValue = newValue.slice(0, -1);
        }
      }

      onChange(newValue);
    }, [prefix, value, onChange, country, metadata]);

    return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Input, InputBasic_extends({}, rest, {
      ref: ref,
      value: InputBasic_format(prefix, value, country, metadata),
      onChange: _onChange
    }));
  }

  InputBasic = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.forwardRef(InputBasic);
  InputBasic.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: prop_types_default.a.string.isRequired,

    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: prop_types_default.a.func.isRequired,

    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */
    country: prop_types_default.a.string,

    /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */
    international: prop_types_default.a.bool,

    /**
     * If `country` and `international` properties are set,
     * then by default it won't include "country calling code" in the input field.
     * To change that, pass `withCountryCallingCode` property,
     * and it will include "country calling code" in the input field.
     */
    withCountryCallingCode: prop_types_default.a.bool,

    /**
     * `libphonenumber-js` metadata.
     */
    metadata: prop_types_default.a.object.isRequired,

    /**
     * The `<input/>` component.
     */
    inputComponent: prop_types_default.a.elementType.isRequired
  };
  InputBasic.defaultProps = {
    metadata: defaultMetadata,
    inputComponent: 'input'
  };
  return InputBasic;
}
/* harmony default export */ var modules_InputBasic = (InputBasic_createInput());

function InputBasic_format(prefix, value, country, metadata) {
  return removeInputValuePrefix(formatIncompletePhoneNumber(prefix + value, country, metadata), prefix);
}
//# sourceMappingURL=InputBasic.js.map
// CONCATENATED MODULE: ./node_modules/country-flag-icons/modules/unicode.js
/**
 * Creates Unicode flag from a two-letter ISO country code.
 * https://stackoverflow.com/questions/24050671/how-to-put-japan-flag-character-in-a-string
 * @param  {string} country — A two-letter ISO country code (case-insensitive).
 * @return {string}
 */
function getCountryFlag(country) {
  return getRegionalIndicatorSymbol(country[0]) + getRegionalIndicatorSymbol(country[1]);
}
/**
 * Converts a letter to a Regional Indicator Symbol.
 * @param  {string} letter
 * @return {string}
 */

function getRegionalIndicatorSymbol(letter) {
  return String.fromCodePoint(0x1F1E6 - 65 + letter.toUpperCase().charCodeAt(0));
}
//# sourceMappingURL=unicode.js.map
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/modules/CountrySelect.js
var CountrySelect_excluded = ["value", "onChange", "options"],
    _excluded2 = ["value", "options", "className", "iconComponent", "getIconAspectRatio", "arrowComponent", "unicodeFlags"];

function CountrySelect_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = CountrySelect_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function CountrySelect_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return CountrySelect_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return CountrySelect_arrayLikeToArray(o, minLen); }

function CountrySelect_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function CountrySelect_extends() { CountrySelect_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return CountrySelect_extends.apply(this, arguments); }

function CountrySelect_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = CountrySelect_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function CountrySelect_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





function CountrySelect(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      options = _ref.options,
      rest = CountrySelect_objectWithoutProperties(_ref, CountrySelect_excluded);

  var onChange_ = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useCallback"])(function (event) {
    var value = event.target.value;
    onChange(value === 'ZZ' ? undefined : value);
  }, [onChange]);
  var selectedOption = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useMemo"])(function () {
    return getSelectedOption(options, value);
  }, [options, value]); // "ZZ" means "International".
  // (HTML requires each `<option/>` have some string `value`).

  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("select", CountrySelect_extends({}, rest, {
    value: value || 'ZZ',
    onChange: onChange_
  }), options.map(function (_ref2) {
    var value = _ref2.value,
        label = _ref2.label,
        divider = _ref2.divider;
    return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("option", {
      key: divider ? '|' : value || 'ZZ',
      value: divider ? '|' : value || 'ZZ',
      disabled: divider ? true : false,
      style: divider ? DIVIDER_STYLE : undefined
    }, label);
  }));
}
CountrySelect.propTypes = {
  /**
   * A two-letter country code.
   * Example: "US", "RU", etc.
   */
  value: prop_types_default.a.string,

  /**
   * A function of `value: string`.
   * Updates the `value` property.
   */
  onChange: prop_types_default.a.func.isRequired,
  // `<select/>` options.
  options: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    value: prop_types_default.a.string,
    label: prop_types_default.a.string,
    divider: prop_types_default.a.bool
  })).isRequired
};
var DIVIDER_STYLE = {
  fontSize: '1px',
  backgroundColor: 'currentColor',
  color: 'inherit'
};
function CountrySelectWithIcon(_ref3) {
  var value = _ref3.value,
      options = _ref3.options,
      className = _ref3.className,
      Icon = _ref3.iconComponent,
      getIconAspectRatio = _ref3.getIconAspectRatio,
      Arrow = _ref3.arrowComponent,
      unicodeFlags = _ref3.unicodeFlags,
      rest = CountrySelect_objectWithoutProperties(_ref3, _excluded2);

  var selectedOption = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useMemo"])(function () {
    return getSelectedOption(options, value);
  }, [options, value]);
  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", {
    className: "PhoneInputCountry"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(CountrySelect, CountrySelect_extends({}, rest, {
    value: value,
    options: options,
    className: classnames_default()('PhoneInputCountrySelect', className)
  })), unicodeFlags && value && /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", {
    className: "PhoneInputCountryIconUnicode"
  }, getCountryFlag(value)), !(unicodeFlags && value) && /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Icon, {
    "aria-hidden": true,
    country: value,
    label: selectedOption && selectedOption.label,
    aspectRatio: unicodeFlags ? 1 : undefined
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Arrow, null));
}
CountrySelectWithIcon.propTypes = {
  // Country flag component.
  iconComponent: prop_types_default.a.elementType,
  // Select arrow component.
  arrowComponent: prop_types_default.a.elementType.isRequired,
  // Set to `true` to render Unicode flag icons instead of SVG images.
  unicodeFlags: prop_types_default.a.bool
};
CountrySelectWithIcon.defaultProps = {
  arrowComponent: function arrowComponent() {
    return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", {
      className: "PhoneInputCountrySelectArrow"
    });
  }
};

function getSelectedOption(options, value) {
  for (var _iterator = CountrySelect_createForOfIteratorHelperLoose(options), _step; !(_step = _iterator()).done;) {
    var option = _step.value;

    if (!option.divider && option.value === value) {
      return option;
    }
  }
}
//# sourceMappingURL=CountrySelect.js.map
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/modules/Flag.js
var Flag_excluded = ["country", "countryName", "flags", "flagUrl"];

function Flag_extends() { Flag_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Flag_extends.apply(this, arguments); }

function Flag_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Flag_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Flag_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



 // Default country flag icon.
// `<img/>` is wrapped in a `<div/>` to prevent SVGs from exploding in size in IE 11.
// https://github.com/catamphetamine/react-phone-number-input/issues/111

function Flag_FlagComponent(_ref) {
  var country = _ref.country,
      countryName = _ref.countryName,
      flags = _ref.flags,
      flagUrl = _ref.flagUrl,
      rest = Flag_objectWithoutProperties(_ref, Flag_excluded);

  if (flags && flags[country]) {
    return flags[country]({
      title: countryName
    });
  }

  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("img", Flag_extends({}, rest, {
    alt: countryName,
    role: countryName ? undefined : "presentation",
    src: flagUrl.replace('{XX}', country).replace('{xx}', country.toLowerCase())
  }));
}
Flag_FlagComponent.propTypes = {
  // The country to be selected by default.
  // Two-letter country code ("ISO 3166-1 alpha-2").
  country: prop_types_default.a.string.isRequired,
  // Will be HTML `title` attribute of the `<img/>`.
  countryName: prop_types_default.a.string.isRequired,
  // Country flag icon components.
  // By default flag icons are inserted as `<img/>`s
  // with their `src` pointed to `country-flag-icons` gitlab pages website.
  // There might be cases (e.g. an offline application)
  // where having a large (3 megabyte) `<svg/>` flags
  // bundle is more appropriate.
  // `import flags from 'react-phone-number-input/flags'`.
  flags: prop_types_default.a.objectOf(prop_types_default.a.elementType),
  // A URL for a country flag icon.
  // By default it points to `country-flag-icons` gitlab pages website.
  flagUrl: prop_types_default.a.string.isRequired
};
//# sourceMappingURL=Flag.js.map
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/modules/InternationalIcon.js
var InternationalIcon_excluded = ["aspectRatio"],
    InternationalIcon_excluded2 = ["title"],
    _excluded3 = ["title"];

function InternationalIcon_extends() { InternationalIcon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return InternationalIcon_extends.apply(this, arguments); }

function InternationalIcon_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = InternationalIcon_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function InternationalIcon_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function InternationalIcon_InternationalIcon(_ref) {
  var aspectRatio = _ref.aspectRatio,
      rest = InternationalIcon_objectWithoutProperties(_ref, InternationalIcon_excluded);

  if (aspectRatio === 1) {
    return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(InternationalIcon1x1, rest);
  } else {
    return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(InternationalIcon3x2, rest);
  }
}
InternationalIcon_InternationalIcon.propTypes = {
  title: prop_types_default.a.string.isRequired,
  aspectRatio: prop_types_default.a.number
}; // 3x2.
// Using `<title/>` in `<svg/>`s:
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element/title

function InternationalIcon3x2(_ref2) {
  var title = _ref2.title,
      rest = InternationalIcon_objectWithoutProperties(_ref2, InternationalIcon_excluded2);

  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("svg", InternationalIcon_extends({}, rest, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 50"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("title", null, title), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("path", {
    strokeLinecap: "round",
    d: "M47.2,36.1C48.1,36,49,36,50,36c7.4,0,14,1.7,18.5,4.3"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("path", {
    d: "M68.6,9.6C64.2,12.3,57.5,14,50,14c-7.4,0-14-1.7-18.5-4.3"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("line", {
    x1: "26",
    y1: "25",
    x2: "74",
    y2: "25"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("line", {
    x1: "50",
    y1: "1",
    x2: "50",
    y2: "49"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("path", {
    strokeLinecap: "round",
    d: "M46.3,48.7c1.2,0.2,2.5,0.3,3.7,0.3c13.3,0,24-10.7,24-24S63.3,1,50,1S26,11.7,26,25c0,2,0.3,3.9,0.7,5.8"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("path", {
    strokeLinecap: "round",
    d: "M46.8,48.2c1,0.6,2.1,0.8,3.2,0.8c6.6,0,12-10.7,12-24S56.6,1,50,1S38,11.7,38,25c0,1.4,0.1,2.7,0.2,4c0,0.1,0,0.2,0,0.2"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "none",
    fill: "currentColor",
    d: "M12.4,17.9c2.9-2.9,5.4-4.8,0.3-11.2S4.1,5.2,1.3,8.1C-2,11.4,1.1,23.5,13.1,35.6s24.3,15.2,27.5,11.9c2.8-2.8,7.8-6.3,1.4-11.5s-8.3-2.6-11.2,0.3c-2,2-7.2-2.2-11.7-6.7S10.4,19.9,12.4,17.9z"
  }));
}

InternationalIcon3x2.propTypes = {
  title: prop_types_default.a.string.isRequired
}; // 1x1.
// Using `<title/>` in `<svg/>`s:
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element/title

function InternationalIcon1x1(_ref3) {
  var title = _ref3.title,
      rest = InternationalIcon_objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("svg", InternationalIcon_extends({}, rest, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("title", null, title), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("path", {
    d: "M8.45,13A21.44,21.44,0,1,1,37.08,41.56"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("path", {
    d: "M19.36,35.47a36.9,36.9,0,0,1-2.28-13.24C17.08,10.39,21.88.85,27.8.85s10.72,9.54,10.72,21.38c0,6.48-1.44,12.28-3.71,16.21"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("path", {
    d: "M17.41,33.4A39,39,0,0,1,27.8,32.06c6.62,0,12.55,1.5,16.48,3.86"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("path", {
    d: "M44.29,8.53c-3.93,2.37-9.86,3.88-16.49,3.88S15.25,10.9,11.31,8.54"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("line", {
    x1: "27.8",
    y1: "0.85",
    x2: "27.8",
    y2: "34.61"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("line", {
    x1: "15.2",
    y1: "22.23",
    x2: "49.15",
    y2: "22.23"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "transparent",
    fill: "currentColor",
    d: "M9.42,26.64c2.22-2.22,4.15-3.59.22-8.49S3.08,17,.93,19.17c-2.49,2.48-.13,11.74,9,20.89s18.41,11.5,20.89,9c2.15-2.15,5.91-4.77,1-8.71s-6.27-2-8.49.22c-1.55,1.55-5.48-1.69-8.86-5.08S7.87,28.19,9.42,26.64Z"
  }));
}

InternationalIcon1x1.propTypes = {
  title: prop_types_default.a.string.isRequired
};
//# sourceMappingURL=InternationalIcon.js.map
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/modules/helpers/countries.js
function countries_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = countries_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function countries_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return countries_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return countries_arrayLikeToArray(o, minLen); }

function countries_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



/**
 * Sorts country `<select/>` options.
 * Can move some country `<select/>` options
 * to the top of the list, for example.
 * @param  {object[]} countryOptions — Country `<select/>` options.
 * @param  {string[]} [countryOptionsOrder] — Country `<select/>` options order. Example: `["US", "CA", "AU", "|", "..."]`.
 * @return {object[]}
 */

function sortCountryOptions(options, order) {
  if (!order) {
    return options;
  }

  var optionsOnTop = [];
  var optionsOnBottom = [];
  var appendTo = optionsOnTop;

  for (var _iterator = countries_createForOfIteratorHelperLoose(order), _step; !(_step = _iterator()).done;) {
    var element = _step.value;

    if (element === '|') {
      appendTo.push({
        divider: true
      });
    } else if (element === '...' || element === '…') {
      appendTo = optionsOnBottom;
    } else {
      (function () {
        var countryCode = void 0;

        if (element === '🌐') {
          countryCode = undefined;
        } else {
          countryCode = element;
        } // Find the position of the option.


        var index = options.indexOf(options.filter(function (option) {
          return option.value === countryCode;
        })[0]); // Get the option.

        var option = options[index]; // Remove the option from its default position.

        options.splice(index, 1); // Add the option on top.

        appendTo.push(option);
      })();
    }
  }

  return optionsOnTop.concat(options).concat(optionsOnBottom);
}
function getSupportedCountryOptions(countryOptions, metadata) {
  if (countryOptions) {
    countryOptions = countryOptions.filter(function (option) {
      switch (option) {
        case '🌐':
        case '|':
        case '...':
        case '…':
          return true;

        default:
          return isCountrySupportedWithError(option, metadata);
      }
    });

    if (countryOptions.length > 0) {
      return countryOptions;
    }
  }
}
function isCountrySupportedWithError(country, metadata) {
  if (isSupportedCountry(country, metadata)) {
    return true;
  } else {
    console.error("Country not found: ".concat(country));
    return false;
  }
}
function getSupportedCountries(countries, metadata) {
  if (countries) {
    countries = countries.filter(function (country) {
      return isCountrySupportedWithError(country, metadata);
    });

    if (countries.length === 0) {
      countries = undefined;
    }
  }

  return countries;
}
//# sourceMappingURL=countries.js.map
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/modules/CountryIcon.js
var CountryIcon_excluded = ["country", "label", "aspectRatio"];

function CountryIcon_extends() { CountryIcon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return CountryIcon_extends.apply(this, arguments); }

function CountryIcon_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = CountryIcon_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function CountryIcon_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






function createCountryIconComponent(_ref) {
  var flags = _ref.flags,
      flagUrl = _ref.flagUrl,
      FlagComponent = _ref.flagComponent,
      InternationalIcon = _ref.internationalIcon;

  function CountryIcon(_ref2) {
    var country = _ref2.country,
        label = _ref2.label,
        aspectRatio = _ref2.aspectRatio,
        rest = CountryIcon_objectWithoutProperties(_ref2, CountryIcon_excluded);

    // `aspectRatio` is currently a hack for the default "International" icon
    // to render it as a square when Unicode flag icons are used.
    // So `aspectRatio` property is only used with the default "International" icon.
    var _aspectRatio = InternationalIcon === InternationalIcon_InternationalIcon ? aspectRatio : undefined;

    return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", CountryIcon_extends({}, rest, {
      className: classnames_default()('PhoneInputCountryIcon', {
        'PhoneInputCountryIcon--square': _aspectRatio === 1,
        'PhoneInputCountryIcon--border': country
      })
    }), country ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(FlagComponent, {
      country: country,
      countryName: label,
      flags: flags,
      flagUrl: flagUrl,
      className: "PhoneInputCountryIconImg"
    }) : /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(InternationalIcon, {
      title: label,
      aspectRatio: _aspectRatio,
      className: "PhoneInputCountryIconImg"
    }));
  }

  CountryIcon.propTypes = {
    country: prop_types_default.a.string,
    label: prop_types_default.a.string.isRequired,
    aspectRatio: prop_types_default.a.number
  };
  return CountryIcon;
}
/* harmony default export */ var modules_CountryIcon = (createCountryIconComponent({
  // Must be equal to `defaultProps.flagUrl` in `./PhoneInputWithCountry.js`.
  flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg',
  flagComponent: Flag_FlagComponent,
  internationalIcon: InternationalIcon_InternationalIcon
}));
//# sourceMappingURL=CountryIcon.js.map
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/modules/helpers/getInternationalPhoneNumberPrefix.js

var ONLY_DIGITS_REGEXP = /^\d+$/;
function getInternationalPhoneNumberPrefix(country, metadata) {
  // Standard international phone number prefix: "+" and "country calling code".
  var prefix = '+' + getCountryCallingCode(country, metadata); // Get "leading digits" for a phone number of the country.
  // If there're "leading digits" then they can be part of the prefix too.

  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(country);

  if (metadata.numberingPlan.leadingDigits() && ONLY_DIGITS_REGEXP.test(metadata.numberingPlan.leadingDigits())) {
    prefix += metadata.numberingPlan.leadingDigits();
  }

  return prefix;
}
//# sourceMappingURL=getInternationalPhoneNumberPrefix.js.map
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/modules/helpers/phoneInputHelpers.js


/**
 * Decides which country should be pre-selected
 * when the phone number input component is first mounted.
 * @param  {object?} phoneNumber - An instance of `PhoneNumber` class.
 * @param  {string?} country - Pre-defined country (two-letter code).
 * @param  {string[]?} countries - A list of countries available.
 * @param  {object} metadata - `libphonenumber-js` metadata
 * @return {string?}
 */

function getPreSelectedCountry(_ref) {
  var value = _ref.value,
      phoneNumber = _ref.phoneNumber,
      defaultCountry = _ref.defaultCountry,
      getAnyCountry = _ref.getAnyCountry,
      countries = _ref.countries,
      required = _ref.required,
      metadata = _ref.metadata;
  var country; // If can get country from E.164 phone number
  // then it overrides the `country` passed (or not passed).

  if (phoneNumber && phoneNumber.country) {
    // `country` will be left `undefined` in case of non-detection.
    country = phoneNumber.country;
  } else if (defaultCountry) {
    if (!value || couldNumberBelongToCountry(value, defaultCountry, metadata)) {
      country = defaultCountry;
    }
  } // Only pre-select a country if it's in the available `countries` list.


  if (countries && countries.indexOf(country) < 0) {
    country = undefined;
  } // If there will be no "International" option
  // then some `country` must be selected.
  // It will still be the wrong country though.
  // But still country `<select/>` can't be left in a broken state.


  if (!country && required && countries && countries.length > 0) {
    country = getAnyCountry(); // noCountryMatchesTheNumber = true
  }

  return country;
}
/**
 * Generates a sorted list of country `<select/>` options.
 * @param  {string[]} countries - A list of two-letter ("ISO 3166-1 alpha-2") country codes.
 * @param  {object} labels - Custom country labels. E.g. `{ RU: 'Россия', US: 'США', ... }`.
 * @param  {boolean} addInternationalOption - Whether should include "International" option at the top of the list.
 * @return {object[]} A list of objects having shape `{ value : string, label : string }`.
 */

function phoneInputHelpers_getCountrySelectOptions(_ref2) {
  var countries = _ref2.countries,
      countryNames = _ref2.countryNames,
      addInternationalOption = _ref2.addInternationalOption,
      compareStringsLocales = _ref2.compareStringsLocales,
      _compareStrings = _ref2.compareStrings;

  // Default country name comparator uses `String.localeCompare()`.
  if (!_compareStrings) {
    _compareStrings = compareStrings;
  } // Generates a `<Select/>` option for each country.


  var countrySelectOptions = countries.map(function (country) {
    return {
      value: country,
      // All `locale` country names included in this library
      // include all countries (this is checked at build time).
      // The only case when a country name might be missing
      // is when a developer supplies their own `labels` property.
      // To guard against such cases, a missing country name
      // is substituted by country code.
      label: countryNames[country] || country
    };
  }); // Sort the list of countries alphabetically.

  countrySelectOptions.sort(function (a, b) {
    return _compareStrings(a.label, b.label, compareStringsLocales);
  }); // Add the "International" option to the country list (if suitable)

  if (addInternationalOption) {
    countrySelectOptions.unshift({
      label: countryNames.ZZ
    });
  }

  return countrySelectOptions;
}
/**
 * Parses a E.164 phone number to an instance of `PhoneNumber` class.
 * @param {string?} value = E.164 phone number.
 * @param  {object} metadata - `libphonenumber-js` metadata
 * @return {object} Object having shape `{ country: string?, countryCallingCode: string, number: string }`. `PhoneNumber`: https://gitlab.com/catamphetamine/libphonenumber-js#phonenumber.
 * @example
 * parsePhoneNumber('+78005553535')
 */

function phoneInputHelpers_parsePhoneNumber(value, metadata) {
  return parsePhoneNumberFromString_parsePhoneNumberFromString(value || '', metadata);
}
/**
 * Generates national number digits for a parsed phone.
 * May prepend national prefix.
 * The phone number must be a complete and valid phone number.
 * @param  {object} phoneNumber - An instance of `PhoneNumber` class.
 * @param  {object} metadata - `libphonenumber-js` metadata
 * @return {string}
 * @example
 * getNationalNumberDigits({ country: 'RU', phone: '8005553535' })
 * // returns '88005553535'
 */

function generateNationalNumberDigits(phoneNumber) {
  return phoneNumber.formatNational().replace(/\D/g, '');
}
/**
 * Migrates parsed `<input/>` `value` for the newly selected `country`.
 * @param {string?} phoneDigits - Phone number digits (and `+`) parsed from phone number `<input/>` (it's not the same as the `value` property).
 * @param {string?} prevCountry - Previously selected country.
 * @param {string?} newCountry - Newly selected country. Can't be same as previously selected country.
 * @param {object} metadata - `libphonenumber-js` metadata.
 * @param {boolean} useNationalFormat - whether should attempt to convert from international to national number for the new country.
 * @return {string?}
 */

function getPhoneDigitsForNewCountry(phoneDigits, _ref3) {
  var prevCountry = _ref3.prevCountry,
      newCountry = _ref3.newCountry,
      metadata = _ref3.metadata,
      useNationalFormat = _ref3.useNationalFormat;

  if (prevCountry === newCountry) {
    return phoneDigits;
  } // If `parsed_input` is empty
  // then no need to migrate anything.


  if (!phoneDigits) {
    if (useNationalFormat) {
      return '';
    } else {
      // If `phoneDigits` is empty then set `phoneDigits` to
      // `+{getCountryCallingCode(newCountry)}`.
      return getInternationalPhoneNumberPrefix(newCountry, metadata);
    }
  } // If switching to some country.
  // (from "International" or another country)
  // If switching from "International" then `phoneDigits` starts with a `+`.
  // Otherwise it may or may not start with a `+`.


  if (newCountry) {
    // If the phone number was entered in international format
    // then migrate it to the newly selected country.
    // The phone number may be incomplete.
    // The phone number entered not necessarily starts with
    // the previously selected country phone prefix.
    if (phoneDigits[0] === '+') {
      // If the international phone number is for the new country
      // then convert it to local if required.
      if (useNationalFormat) {
        // // If a phone number is being input in international form
        // // and the country can already be derived from it,
        // // and if it is the new country, then format as a national number.
        // const derived_country = getCountryFromPossiblyIncompleteInternationalPhoneNumber(phoneDigits, metadata)
        // if (derived_country === newCountry) {
        // 	return stripCountryCallingCode(phoneDigits, derived_country, metadata)
        // }
        // Actually, the two countries don't necessarily need to match:
        // the condition could be looser here, because several countries
        // might share the same international phone number format
        // (for example, "NANPA" countries like US, Canada, etc).
        // The looser condition would be just "same nternational phone number format"
        // which would mean "same country calling code" in the context of `libphonenumber-js`.
        if (phoneDigits.indexOf('+' + getCountryCallingCode(newCountry, metadata)) === 0) {
          return stripCountryCallingCode(phoneDigits, newCountry, metadata);
        } // Simply discard the previously entered international phone number,
        // because otherwise any "smart" transformation like getting the
        // "national (significant) number" part and then prepending the
        // newly selected country's "country calling code" to it
        // would just be confusing for a user without being actually useful.


        return ''; // // Simply strip the leading `+` character
        // // therefore simply converting all digits into a "local" phone number.
        // // https://github.com/catamphetamine/react-phone-number-input/issues/287
        // return phoneDigits.slice(1)
      }

      if (prevCountry) {
        var newCountryPrefix = getInternationalPhoneNumberPrefix(newCountry, metadata);

        if (phoneDigits.indexOf(newCountryPrefix) === 0) {
          return phoneDigits;
        } else {
          return newCountryPrefix;
        }
      } else {
        var defaultValue = getInternationalPhoneNumberPrefix(newCountry, metadata); // If `phoneDigits`'s country calling code part is the same
        // as for the new `country`, then leave `phoneDigits` as is.

        if (phoneDigits.indexOf(defaultValue) === 0) {
          return phoneDigits;
        } // If `phoneDigits`'s country calling code part is not the same
        // as for the new `country`, then set `phoneDigits` to
        // `+{getCountryCallingCode(newCountry)}`.


        return defaultValue;
      } // // If the international phone number already contains
      // // any country calling code then trim the country calling code part.
      // // (that could also be the newly selected country phone code prefix as well)
      // // `phoneDigits` doesn't neccessarily belong to `prevCountry`.
      // // (e.g. if a user enters an international number
      // //  not belonging to any of the reduced `countries` list).
      // phoneDigits = stripCountryCallingCode(phoneDigits, prevCountry, metadata)
      // // Prepend country calling code prefix
      // // for the newly selected country.
      // return e164(phoneDigits, newCountry, metadata) || `+${getCountryCallingCode(newCountry, metadata)}`

    }
  } // If switching to "International" from a country.
  else {
    // If the phone number was entered in national format.
    if (phoneDigits[0] !== '+') {
      // Format the national phone number as an international one.
      // The phone number entered not necessarily even starts with
      // the previously selected country phone prefix.
      // Even if the phone number belongs to whole another country
      // it will still be parsed into some national phone number.
      //
      // Ignore the now-uncovered `|| ''` code branch:
      // previously `e164()` function could return an empty string
      // even when `phoneDigits` were not empty.
      // Now it always returns some `value` when there're any `phoneDigits`.
      // Still, didn't remove the `|| ''` code branch just in case
      // that logic changes somehow in some future, so there're no
      // possible bugs related to that.
      //
      // (ignore the `|| ''` code branch)

      /* istanbul ignore next */
      return e164(phoneDigits, prevCountry, metadata) || '';
    }
  }

  return phoneDigits;
}
/**
 * Converts phone number digits to a (possibly incomplete) E.164 phone number.
 * @param  {string?} number - A possibly incomplete phone number digits string. Can be a possibly incomplete E.164 phone number.
 * @param  {string?} country
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string?}
 */

function e164(number, country, metadata) {
  if (!number) {
    return;
  } // If the phone number is being input in international format.


  if (number[0] === '+') {
    // If it's just the `+` sign then return nothing.
    if (number === '+') {
      return;
    } // Return a E.164 phone number.
    //
    // Could return `number` "as is" here, but there's a possibility
    // that some user might incorrectly input an international number
    // with a "national prefix". Such numbers aren't considered valid,
    // but `libphonenumber-js` is "forgiving" when it comes to parsing
    // user's input, and this input component follows that behavior.
    //


    var asYouType = new AsYouType_AsYouType(country, metadata);
    asYouType.input(number); // This function would return `undefined` only when `number` is `"+"`,
    // but at this point it is known that `number` is not `"+"`.

    return asYouType.getNumberValue();
  } // For non-international phone numbers
  // an accompanying country code is required.
  // The situation when `country` is `undefined`
  // and a non-international phone number is passed
  // to this function shouldn't happen.


  if (!country) {
    return;
  }

  var partial_national_significant_number = getNationalSignificantNumberDigits(number, country, metadata); //
  // Even if no "national (significant) number" digits have been input,
  // still return a non-`undefined` value.
  // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/113
  //
  // For example, if the user has selected country `US` and entered `"1"`
  // then that `"1"` is just a "national prefix" and no "national (significant) number"
  // digits have been input yet. Still, return `"+1"` as `value` in such cases,
  // because otherwise the app would think that the input is empty and mark it as such
  // while in reality it isn't empty, which might be thought of as a "bug", or just
  // a "weird" behavior.
  //
  // if (partial_national_significant_number) {

  return "+".concat(getCountryCallingCode(country, metadata)).concat(partial_national_significant_number || ''); // }
}
/**
 * Trims phone number digits if they exceed the maximum possible length
 * for a national (significant) number for the country.
 * @param  {string} number - A possibly incomplete phone number digits string. Can be a possibly incomplete E.164 phone number.
 * @param  {string} country
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string} Can be empty.
 */

function trimNumber(number, country, metadata) {
  var nationalSignificantNumberPart = getNationalSignificantNumberDigits(number, country, metadata);

  if (nationalSignificantNumberPart) {
    var overflowDigitsCount = nationalSignificantNumberPart.length - getMaxNumberLength(country, metadata);

    if (overflowDigitsCount > 0) {
      return number.slice(0, number.length - overflowDigitsCount);
    }
  }

  return number;
}

function getMaxNumberLength(country, metadata) {
  // Get "possible lengths" for a phone number of the country.
  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(country); // Return the last "possible length".

  return metadata.numberingPlan.possibleLengths()[metadata.numberingPlan.possibleLengths().length - 1];
} // If the phone number being input is an international one
// then tries to derive the country from the phone number.
// (regardless of whether there's any country currently selected)

/**
 * @param {string} partialE164Number - A possibly incomplete E.164 phone number.
 * @param {string?} country - Currently selected country.
 * @param {string[]?} countries - A list of available countries. If not passed then "all countries" are assumed.
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string?}
 */


function getCountryForPartialE164Number(partialE164Number, _ref4) {
  var country = _ref4.country,
      countries = _ref4.countries,
      required = _ref4.required,
      metadata = _ref4.metadata;

  if (partialE164Number === '+') {
    // Don't change the currently selected country yet.
    return country;
  }

  var derived_country = getCountryFromPossiblyIncompleteInternationalPhoneNumber(partialE164Number, metadata); // If a phone number is being input in international form
  // and the country can already be derived from it,
  // then select that country.

  if (derived_country && (!countries || countries.indexOf(derived_country) >= 0)) {
    return derived_country;
  } // If "International" country option has not been disabled
  // and the international phone number entered doesn't correspond
  // to the currently selected country then reset the currently selected country.
  else if (country && !required && !couldNumberBelongToCountry(partialE164Number, country, metadata)) {
    return undefined;
  } // Don't change the currently selected country.


  return country;
}
/**
 * Parses `<input/>` value. Derives `country` from `input`. Derives an E.164 `value`.
 * @param  {string?} phoneDigits — Parsed `<input/>` value. Examples: `""`, `"+"`, `"+123"`, `"123"`.
 * @param  {string?} prevPhoneDigits — Previous parsed `<input/>` value. Examples: `""`, `"+"`, `"+123"`, `"123"`.
 * @param  {string?} country - Currently selected country.
 * @param  {boolean} countryRequired - Is selecting some country required.
 * @param  {function} getAnyCountry - Can be used to get any country when selecting some country required.
 * @param  {string[]?} countries - A list of available countries. If not passed then "all countries" are assumed.
 * @param  {boolean} international - Set to `true` to force international phone number format (leading `+`). Set to `false` to force "national" phone number format. Is `undefined` by default.
 * @param  {boolean} limitMaxLength — Whether to enable limiting phone number max length.
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {object} An object of shape `{ input, country, value }`.
 */

function onPhoneDigitsChange(phoneDigits, _ref5) {
  var prevPhoneDigits = _ref5.prevPhoneDigits,
      country = _ref5.country,
      defaultCountry = _ref5.defaultCountry,
      countryRequired = _ref5.countryRequired,
      getAnyCountry = _ref5.getAnyCountry,
      countries = _ref5.countries,
      international = _ref5.international,
      limitMaxLength = _ref5.limitMaxLength,
      countryCallingCodeEditable = _ref5.countryCallingCodeEditable,
      metadata = _ref5.metadata;

  if (international && countryCallingCodeEditable === false) {
    var prefix = getInternationalPhoneNumberPrefix(country, metadata); // The `<input/>` value must start with the country calling code.

    if (phoneDigits.indexOf(prefix) !== 0) {
      var _value; // If a phone number input is declared as
      // `international` and `withCountryCallingCode`,
      // then it's gonna be non-empty even before the user
      // has input anything in it.
      // This will result in its contents (the country calling code part)
      // being selected when the user tabs into such field.
      // If the user then starts inputting the national part digits,
      // then `<input/>` value changes from `+xxx` to `y`
      // because inputting anything while having the `<input/>` value
      // selected results in erasing the `<input/>` value.
      // So, the component handles such case by restoring
      // the intended `<input/>` value: `+xxxy`.
      // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/43


      if (phoneDigits && phoneDigits[0] !== '+') {
        phoneDigits = prefix + phoneDigits;
        _value = e164(phoneDigits, country, metadata);
      } else {
        phoneDigits = prefix;
      }

      return {
        phoneDigits: phoneDigits,
        value: _value,
        country: country
      };
    }
  } // If `international` property is `false`, then it means
  // "enforce national-only format during input",
  // so, if that's the case, then remove all `+` characters,
  // but only if some country is currently selected.
  // (not if "International" country is selected).


  if (international === false && country && phoneDigits && phoneDigits[0] === '+') {
    phoneDigits = convertInternationalPhoneDigitsToNational(phoneDigits, country, metadata);
  } // Trim the input to not exceed the maximum possible number length.


  if (phoneDigits && country && limitMaxLength) {
    phoneDigits = trimNumber(phoneDigits, country, metadata);
  } // If this `onChange()` event was triggered
  // as a result of selecting "International" country,
  // then force-prepend a `+` sign if the phone number
  // `<input/>` value isn't in international format.
  // Also, force-prepend a `+` sign if international
  // phone number input format is set.


  if (phoneDigits && phoneDigits[0] !== '+' && (!country || international)) {
    phoneDigits = '+' + phoneDigits;
  } // If the previously entered phone number
  // has been entered in international format
  // and the user decides to erase it,
  // then also reset the `country`
  // because it was most likely automatically selected
  // while the user was typing in the phone number
  // in international format.
  // This fixes the issue when a user is presented
  // with a phone number input with no country selected
  // and then types in their local phone number
  // then discovers that the input's messed up
  // (a `+` has been prepended at the start of their input
  //  and a random country has been selected),
  // decides to undo it all by erasing everything
  // and then types in their local phone number again
  // resulting in a seemingly correct phone number
  // but in reality that phone number has incorrect country.
  // https://github.com/catamphetamine/react-phone-number-input/issues/273


  if (!phoneDigits && prevPhoneDigits && prevPhoneDigits[0] === '+') {
    if (international) {
      country = undefined;
    } else {
      country = defaultCountry;
    }
  } // Also resets such "randomly" selected country
  // as soon as the user erases the number
  // digit-by-digit up to the leading `+` sign.


  if (phoneDigits === '+' && prevPhoneDigits && prevPhoneDigits[0] === '+' && prevPhoneDigits.length > '+'.length) {
    country = undefined;
  } // Generate the new `value` property.


  var value;

  if (phoneDigits) {
    if (phoneDigits[0] === '+') {
      if (phoneDigits === '+') {
        value = undefined;
      } else if (country && getInternationalPhoneNumberPrefix(country, metadata).indexOf(phoneDigits) === 0) {
        // Selected a `country` but started inputting an
        // international phone number for another country.
        // Even though the input value is non-empty,
        // the `value` is assumed `undefined` in such case.
        // The `country` will be reset (or re-selected)
        // immediately after such mismatch has been detected
        // by the phone number input component, and `value`
        // will be set to the currently entered international prefix.
        //
        // For example, if selected `country` `"US"`
        // and started inputting phone number `"+2"`
        // then `value` `undefined` will be returned from this function,
        // and then, immediately after that, `country` will be reset
        // and the `value` will be set to `"+2"`.
        //
        value = undefined;
      } else {
        value = e164(phoneDigits, country, metadata);
      }
    } else {
      value = e164(phoneDigits, country, metadata);
    }
  } // Derive the country from the phone number.
  // (regardless of whether there's any country currently selected,
  //  because there could be several countries corresponding to one country calling code)


  if (value) {
    country = getCountryForPartialE164Number(value, {
      country: country,
      countries: countries,
      metadata: metadata
    }); // If `international` property is `false`, then it means
    // "enforce national-only format during input",
    // so, if that's the case, then remove all `+` characters,
    // but only if some country is currently selected.
    // (not if "International" country is selected).

    if (international === false && country && phoneDigits && phoneDigits[0] === '+') {
      phoneDigits = convertInternationalPhoneDigitsToNational(phoneDigits, country, metadata); // Re-calculate `value` because `phoneDigits` has changed.

      value = e164(phoneDigits, country, metadata);
    }
  }

  if (!country && countryRequired) {
    country = defaultCountry || getAnyCountry();
  }

  return {
    phoneDigits: phoneDigits,
    country: country,
    value: value
  };
}

function convertInternationalPhoneDigitsToNational(input, country, metadata) {
  // Handle the case when a user might have pasted
  // a phone number in international format.
  if (input.indexOf(getInternationalPhoneNumberPrefix(country, metadata)) === 0) {
    // Create "as you type" formatter.
    var formatter = new AsYouType_AsYouType(country, metadata); // Input partial national phone number.

    formatter.input(input); // Return the parsed partial national phone number.

    var phoneNumber = formatter.getNumber();

    if (phoneNumber) {
      // Transform the number to a national one,
      // and remove all non-digits.
      return phoneNumber.formatNational().replace(/\D/g, '');
    } else {
      return '';
    }
  } else {
    // Just remove the `+` sign.
    return input.replace(/\D/g, '');
  }
}
/**
 * Determines the country for a given (possibly incomplete) E.164 phone number.
 * @param  {string} number - A possibly incomplete E.164 phone number.
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string?}
 */


function getCountryFromPossiblyIncompleteInternationalPhoneNumber(number, metadata) {
  var formatter = new AsYouType_AsYouType(null, metadata);
  formatter.input(number); // // `001` is a special "non-geograpical entity" code
  // // in Google's `libphonenumber` library.
  // if (formatter.getCountry() === '001') {
  // 	return
  // }

  return formatter.getCountry();
}
/**
 * Compares two strings.
 * A helper for `Array.sort()`.
 * @param {string} a — First string.
 * @param {string} b — Second string.
 * @param {(string[]|string)} [locales] — The `locales` argument of `String.localeCompare`.
 */

function compareStrings(a, b, locales) {
  // Use `String.localeCompare` if it's available.
  // https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare
  // Which means everyone except IE <= 10 and Safari <= 10.
  // `localeCompare()` is available in latest Node.js versions.

  /* istanbul ignore else */
  if (String.prototype.localeCompare) {
    return a.localeCompare(b, locales);
  }
  /* istanbul ignore next */


  return a < b ? -1 : a > b ? 1 : 0;
}
/**
 * Strips `+${countryCallingCode}` prefix from an E.164 phone number.
 * @param {string} number - (possibly incomplete) E.164 phone number.
 * @param {string?} country - A possible country for this phone number.
 * @param {object} metadata - `libphonenumber-js` metadata.
 * @return {string}
 */

function stripCountryCallingCode(number, country, metadata) {
  // Just an optimization, so that it
  // doesn't have to iterate through all country calling codes.
  if (country) {
    var countryCallingCodePrefix = '+' + getCountryCallingCode(country, metadata); // If `country` fits the actual `number`.

    if (number.length < countryCallingCodePrefix.length) {
      if (countryCallingCodePrefix.indexOf(number) === 0) {
        return '';
      }
    } else {
      if (number.indexOf(countryCallingCodePrefix) === 0) {
        return number.slice(countryCallingCodePrefix.length);
      }
    }
  } // If `country` doesn't fit the actual `number`.
  // Try all available country calling codes.


  for (var _i = 0, _Object$keys = Object.keys(metadata.country_calling_codes); _i < _Object$keys.length; _i++) {
    var country_calling_code = _Object$keys[_i];

    if (number.indexOf(country_calling_code) === '+'.length) {
      return number.slice('+'.length + country_calling_code.length);
    }
  }

  return '';
}
/**
 * Parses a partially entered national phone number digits
 * (or a partially entered E.164 international phone number)
 * and returns the national significant number part.
 * National significant number returned doesn't come with a national prefix.
 * @param {string} number - National number digits. Or possibly incomplete E.164 phone number.
 * @param {string?} country
 * @param {object} metadata - `libphonenumber-js` metadata.
 * @return {string} [result]
 */

function getNationalSignificantNumberDigits(number, country, metadata) {
  // Create "as you type" formatter.
  var formatter = new AsYouType_AsYouType(country, metadata); // Input partial national phone number.

  formatter.input(number); // Return the parsed partial national phone number.

  var phoneNumber = formatter.getNumber();
  return phoneNumber && phoneNumber.nationalNumber;
}
/**
 * Checks if a partially entered E.164 phone number could belong to a country.
 * @param  {string} number
 * @param  {string} country
 * @return {boolean}
 */

function couldNumberBelongToCountry(number, country, metadata) {
  var intlPhoneNumberPrefix = getInternationalPhoneNumberPrefix(country, metadata);
  var i = 0;

  while (i < number.length && i < intlPhoneNumberPrefix.length) {
    if (number[i] !== intlPhoneNumberPrefix[i]) {
      return false;
    }

    i++;
  }

  return true;
}
/**
 * Gets initial "phone digits" (including `+`, if using international format).
 * @return {string} [phoneDigits] Returns `undefined` if there should be no initial "phone digits".
 */

function phoneInputHelpers_getInitialPhoneDigits(_ref6) {
  var value = _ref6.value,
      phoneNumber = _ref6.phoneNumber,
      defaultCountry = _ref6.defaultCountry,
      international = _ref6.international,
      useNationalFormat = _ref6.useNationalFormat,
      metadata = _ref6.metadata;

  // If the `value` (E.164 phone number)
  // belongs to the currently selected country
  // and `useNationalFormat` is `true`
  // then convert `value` (E.164 phone number)
  // to a local phone number digits.
  // E.g. '+78005553535' -> '88005553535'.
  if ((international === false || useNationalFormat) && phoneNumber && phoneNumber.country) {
    return generateNationalNumberDigits(phoneNumber);
  } // If `international` property is `true`,
  // meaning "enforce international phone number format",
  // then always show country calling code in the input field.


  if (!value && international && defaultCountry) {
    return getInternationalPhoneNumberPrefix(defaultCountry, metadata);
  }

  return value;
}
//# sourceMappingURL=phoneInputHelpers.js.map
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/modules/helpers/getPhoneInputWithCountryStateUpdateFromNewProps.js
function getPhoneInputWithCountryStateUpdateFromNewProps_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getPhoneInputWithCountryStateUpdateFromNewProps_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getPhoneInputWithCountryStateUpdateFromNewProps_ownKeys(Object(source), !0).forEach(function (key) { getPhoneInputWithCountryStateUpdateFromNewProps_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getPhoneInputWithCountryStateUpdateFromNewProps_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function getPhoneInputWithCountryStateUpdateFromNewProps_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function getPhoneInputWithCountryStateUpdateFromNewProps(props, prevProps, state) {
  var metadata = props.metadata,
      countries = props.countries,
      newDefaultCountry = props.defaultCountry,
      newValue = props.value,
      newReset = props.reset,
      international = props.international,
      displayInitialValueAsLocalNumber = props.displayInitialValueAsLocalNumber,
      initialValueFormat = props.initialValueFormat;
  var prevDefaultCountry = prevProps.defaultCountry,
      prevValue = prevProps.value,
      prevReset = prevProps.reset;
  var country = state.country,
      value = state.value,
      hasUserSelectedACountry = state.hasUserSelectedACountry;

  var _getInitialPhoneDigits = function _getInitialPhoneDigits(parameters) {
    return phoneInputHelpers_getInitialPhoneDigits(getPhoneInputWithCountryStateUpdateFromNewProps_objectSpread(getPhoneInputWithCountryStateUpdateFromNewProps_objectSpread({}, parameters), {}, {
      international: international,
      useNationalFormat: displayInitialValueAsLocalNumber || initialValueFormat === 'national',
      metadata: metadata
    }));
  }; // Some users requested a way to reset the component
  // (both number `<input/>` and country `<select/>`).
  // Whenever `reset` property changes both number `<input/>`
  // and country `<select/>` are reset.
  // It's not implemented as some instance `.reset()` method
  // because `ref` is forwarded to `<input/>`.
  // It's also not replaced with just resetting `country` on
  // external `value` reset, because a user could select a country
  // and then not input any `value`, and so the selected country
  // would be "stuck", if not using this `reset` property.
  // https://github.com/catamphetamine/react-phone-number-input/issues/300


  if (newReset !== prevReset) {
    return {
      phoneDigits: _getInitialPhoneDigits({
        value: undefined,
        defaultCountry: newDefaultCountry
      }),
      value: undefined,
      country: newDefaultCountry,
      hasUserSelectedACountry: undefined
    };
  } // `value` is the value currently shown in the component:
  // it's stored in the component's `state`, and it's not the `value` property.
  // `prevValue` is "previous `value` property".
  // `newValue` is "new `value` property".
  // If the default country changed
  // (e.g. in case of ajax GeoIP detection after page loaded)
  // then select it, but only if the user hasn't already manually
  // selected a country, and no phone number has been manually entered so far.
  // Because if the user has already started inputting a phone number
  // then they're okay with no country being selected at all ("International")
  // and they don't want to be disturbed, don't want their input to be screwed, etc.


  if (newDefaultCountry !== prevDefaultCountry) {
    var isNewDefaultCountrySupported = !newDefaultCountry || isCountrySupportedWithError(newDefaultCountry, metadata);

    var noValueHasBeenEnteredByTheUser = // By default, "no value has been entered" means `value` is `undefined`.
    !value || // When `international` is `true`, and some country has been pre-selected,
    // then the `<input/>` contains a pre-filled value of `+${countryCallingCode}${leadingDigits}`,
    // so in case of `international` being `true`, "the user hasn't entered anything" situation
    // doesn't just mean `value` is `undefined`, but could also mean `value` is `+${countryCallingCode}`.
    international && value === _getInitialPhoneDigits({
      value: undefined,
      defaultCountry: prevDefaultCountry
    }); // Only update the `defaultCountry` property if no phone number
    // has been entered by the user or pre-set by the application.


    var noValueHasBeenEntered = !newValue && noValueHasBeenEnteredByTheUser;

    if (!hasUserSelectedACountry && isNewDefaultCountrySupported && noValueHasBeenEntered) {
      return {
        country: newDefaultCountry,
        // If `phoneDigits` is empty, then automatically select the new `country`
        // and set `phoneDigits` to `+{getCountryCallingCode(newCountry)}`.
        // The code assumes that "no phone number has been entered by the user",
        // and no `value` property has been passed, so the `phoneNumber` parameter
        // of `_getInitialPhoneDigits({ value, phoneNumber, ... })` is `undefined`.
        phoneDigits: _getInitialPhoneDigits({
          value: undefined,
          defaultCountry: newDefaultCountry
        }),
        // `value` is `undefined` and it stays so.
        value: undefined
      };
    }
  } // If a new `value` is set externally.
  // (e.g. as a result of an ajax API request
  //  to get user's phone after page loaded)
  // The first part — `newValue !== prevValue` —
  // is basically `props.value !== prevProps.value`
  // so it means "if value property was changed externally".
  // The second part — `newValue !== value` —
  // is for ignoring the `getDerivedStateFromProps()` call
  // which happens in `this.onChange()` right after `this.setState()`.
  // If this `getDerivedStateFromProps()` call isn't ignored
  // then the country flag would reset on each input.


  if (newValue !== prevValue && newValue !== value) {
    var phoneNumber;
    var parsedCountry;

    if (newValue) {
      phoneNumber = phoneInputHelpers_parsePhoneNumber(newValue, metadata);
      var supportedCountries = getSupportedCountries(countries, metadata);

      if (phoneNumber && phoneNumber.country) {
        // Ignore `else` because all countries are supported in metadata.

        /* istanbul ignore next */
        if (!supportedCountries || supportedCountries.indexOf(phoneNumber.country) >= 0) {
          parsedCountry = phoneNumber.country;
        }
      } else {
        parsedCountry = getCountryForPartialE164Number(newValue, {
          country: undefined,
          countries: supportedCountries,
          metadata: metadata
        });
      }
    }

    var hasUserSelectedACountryUpdate;

    if (!newValue) {
      // Reset `hasUserSelectedACountry` flag in `state`.
      hasUserSelectedACountryUpdate = {
        hasUserSelectedACountry: undefined
      };
    }

    return getPhoneInputWithCountryStateUpdateFromNewProps_objectSpread(getPhoneInputWithCountryStateUpdateFromNewProps_objectSpread({}, hasUserSelectedACountryUpdate), {}, {
      phoneDigits: _getInitialPhoneDigits({
        phoneNumber: phoneNumber,
        value: newValue,
        defaultCountry: newDefaultCountry
      }),
      value: newValue,
      country: newValue ? parsedCountry : newDefaultCountry
    });
  } // `defaultCountry` didn't change.
  // `value` didn't change.
  // `phoneDigits` didn't change, because `value` didn't change.
  //
  // So no need to update state.

}
//# sourceMappingURL=getPhoneInputWithCountryStateUpdateFromNewProps.js.map
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/modules/PhoneInputWithCountry.js
function PhoneInputWithCountry_typeof(obj) { "@babel/helpers - typeof"; return PhoneInputWithCountry_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, PhoneInputWithCountry_typeof(obj); }

var PhoneInputWithCountry_excluded = ["name", "disabled", "readOnly", "autoComplete", "style", "className", "inputRef", "inputComponent", "numberInputProps", "smartCaret", "countrySelectComponent", "countrySelectProps", "containerComponent", "defaultCountry", "countries", "countryOptionsOrder", "labels", "flags", "flagComponent", "flagUrl", "addInternationalOption", "internationalIcon", "displayInitialValueAsLocalNumber", "initialValueFormat", "onCountryChange", "limitMaxLength", "countryCallingCodeEditable", "focusInputOnCountrySelection", "reset", "metadata", "international", "locales"];

function PhoneInputWithCountry_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PhoneInputWithCountry_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PhoneInputWithCountry_ownKeys(Object(source), !0).forEach(function (key) { PhoneInputWithCountry_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PhoneInputWithCountry_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function PhoneInputWithCountry_extends() { PhoneInputWithCountry_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return PhoneInputWithCountry_extends.apply(this, arguments); }

function PhoneInputWithCountry_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = PhoneInputWithCountry_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function PhoneInputWithCountry_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function PhoneInputWithCountry_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PhoneInputWithCountry_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function PhoneInputWithCountry_createClass(Constructor, protoProps, staticProps) { if (protoProps) PhoneInputWithCountry_defineProperties(Constructor.prototype, protoProps); if (staticProps) PhoneInputWithCountry_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function PhoneInputWithCountry_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) PhoneInputWithCountry_setPrototypeOf(subClass, superClass); }

function PhoneInputWithCountry_setPrototypeOf(o, p) { PhoneInputWithCountry_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return PhoneInputWithCountry_setPrototypeOf(o, p); }

function PhoneInputWithCountry_createSuper(Derived) { var hasNativeReflectConstruct = PhoneInputWithCountry_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = PhoneInputWithCountry_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = PhoneInputWithCountry_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return PhoneInputWithCountry_possibleConstructorReturn(this, result); }; }

function PhoneInputWithCountry_possibleConstructorReturn(self, call) { if (call && (PhoneInputWithCountry_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return PhoneInputWithCountry_assertThisInitialized(self); }

function PhoneInputWithCountry_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function PhoneInputWithCountry_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function PhoneInputWithCountry_getPrototypeOf(o) { PhoneInputWithCountry_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return PhoneInputWithCountry_getPrototypeOf(o); }

function PhoneInputWithCountry_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }















var PhoneInputWithCountry_PhoneNumberInput_ = /*#__PURE__*/function (_React$PureComponent) {
  PhoneInputWithCountry_inherits(PhoneNumberInput_, _React$PureComponent);

  var _super = PhoneInputWithCountry_createSuper(PhoneNumberInput_);

  function PhoneNumberInput_(props) {
    var _this;

    PhoneInputWithCountry_classCallCheck(this, PhoneNumberInput_);

    _this = _super.call(this, props);

    PhoneInputWithCountry_defineProperty(PhoneInputWithCountry_assertThisInitialized(_this), "setInputRef", function (instance) {
      _this.inputRef.current = instance;
      var ref = _this.props.inputRef;

      if (ref) {
        if (typeof ref === 'function') {
          ref(instance);
        } else {
          ref.current = instance;
        }
      }
    });

    PhoneInputWithCountry_defineProperty(PhoneInputWithCountry_assertThisInitialized(_this), "isCountrySupportedWithError", function (country) {
      var metadata = _this.props.metadata;
      return isCountrySupportedWithError(country, metadata);
    });

    PhoneInputWithCountry_defineProperty(PhoneInputWithCountry_assertThisInitialized(_this), "onCountryChange", function (newCountry) {
      var _this$props = _this.props,
          international = _this$props.international,
          metadata = _this$props.metadata,
          onChange = _this$props.onChange,
          focusInputOnCountrySelection = _this$props.focusInputOnCountrySelection;
      var _this$state = _this.state,
          prevPhoneDigits = _this$state.phoneDigits,
          prevCountry = _this$state.country; // After the new `country` has been selected,
      // if the phone number `<input/>` holds any digits
      // then migrate those digits for the new `country`.

      var newPhoneDigits = getPhoneDigitsForNewCountry(prevPhoneDigits, {
        prevCountry: prevCountry,
        newCountry: newCountry,
        metadata: metadata,
        // Convert the phone number to "national" format
        // when the user changes the selected country by hand.
        useNationalFormat: !international
      });
      var newValue = e164(newPhoneDigits, newCountry, metadata); // Focus phone number `<input/>` upon country selection.

      if (focusInputOnCountrySelection) {
        _this.inputRef.current.focus();
      } // If the user has already manually selected a country
      // then don't override that already selected country
      // if the `defaultCountry` property changes.
      // That's what `hasUserSelectedACountry` flag is for.


      _this.setState({
        country: newCountry,
        hasUserSelectedACountry: true,
        phoneDigits: newPhoneDigits,
        value: newValue
      }, function () {
        // Update the new `value` property.
        // Doing it after the `state` has been updated
        // because `onChange()` will trigger `getDerivedStateFromProps()`
        // with the new `value` which will be compared to `state.value` there.
        onChange(newValue);
      });
    });

    PhoneInputWithCountry_defineProperty(PhoneInputWithCountry_assertThisInitialized(_this), "onChange", function (_phoneDigits) {
      var _this$props2 = _this.props,
          defaultCountry = _this$props2.defaultCountry,
          onChange = _this$props2.onChange,
          addInternationalOption = _this$props2.addInternationalOption,
          international = _this$props2.international,
          limitMaxLength = _this$props2.limitMaxLength,
          countryCallingCodeEditable = _this$props2.countryCallingCodeEditable,
          metadata = _this$props2.metadata;
      var _this$state2 = _this.state,
          countries = _this$state2.countries,
          prevPhoneDigits = _this$state2.phoneDigits,
          currentlySelectedCountry = _this$state2.country;

      var _onPhoneDigitsChange = onPhoneDigitsChange(_phoneDigits, {
        prevPhoneDigits: prevPhoneDigits,
        country: currentlySelectedCountry,
        countryRequired: !addInternationalOption,
        defaultCountry: defaultCountry,
        getAnyCountry: function getAnyCountry() {
          return _this.getFirstSupportedCountry({
            countries: countries
          });
        },
        countries: countries,
        international: international,
        limitMaxLength: limitMaxLength,
        countryCallingCodeEditable: countryCallingCodeEditable,
        metadata: metadata
      }),
          phoneDigits = _onPhoneDigitsChange.phoneDigits,
          country = _onPhoneDigitsChange.country,
          value = _onPhoneDigitsChange.value;

      var stateUpdate = {
        phoneDigits: phoneDigits,
        value: value,
        country: country
      };

      if (countryCallingCodeEditable === false) {
        // If it simply did `setState({ phoneDigits: intlPrefix })` here,
        // then it would have no effect when erasing an inital international prefix
        // via Backspace, because `phoneDigits` in `state` wouldn't change
        // as a result, because it was `prefix` and it became `prefix`,
        // so the component wouldn't rerender, and the user would be able
        // to erase the country calling code part, and that part is
        // assumed to be non-eraseable. That's why the component is
        // forcefully rerendered here.
        // https://github.com/catamphetamine/react-phone-number-input/issues/367#issuecomment-721703501
        if (!value && phoneDigits === _this.state.phoneDigits) {
          // Force a re-render of the `<input/>` in order to reset its value.
          stateUpdate.forceRerender = {};
        }
      }

      _this.setState(stateUpdate, // Update the new `value` property.
      // Doing it after the `state` has been updated
      // because `onChange()` will trigger `getDerivedStateFromProps()`
      // with the new `value` which will be compared to `state.value` there.
      function () {
        return onChange(value);
      });
    });

    PhoneInputWithCountry_defineProperty(PhoneInputWithCountry_assertThisInitialized(_this), "_onFocus", function () {
      return _this.setState({
        isFocused: true
      });
    });

    PhoneInputWithCountry_defineProperty(PhoneInputWithCountry_assertThisInitialized(_this), "_onBlur", function () {
      return _this.setState({
        isFocused: false
      });
    });

    PhoneInputWithCountry_defineProperty(PhoneInputWithCountry_assertThisInitialized(_this), "onFocus", function (event) {
      _this._onFocus();

      var onFocus = _this.props.onFocus;

      if (onFocus) {
        onFocus(event);
      }
    });

    PhoneInputWithCountry_defineProperty(PhoneInputWithCountry_assertThisInitialized(_this), "onBlur", function (event) {
      var onBlur = _this.props.onBlur;

      _this._onBlur();

      if (onBlur) {
        onBlur(event);
      }
    });

    PhoneInputWithCountry_defineProperty(PhoneInputWithCountry_assertThisInitialized(_this), "onCountryFocus", function (event) {
      _this._onFocus(); // this.setState({ countrySelectFocused: true })


      var countrySelectProps = _this.props.countrySelectProps;

      if (countrySelectProps) {
        var onFocus = countrySelectProps.onFocus;

        if (onFocus) {
          onFocus(event);
        }
      }
    });

    PhoneInputWithCountry_defineProperty(PhoneInputWithCountry_assertThisInitialized(_this), "onCountryBlur", function (event) {
      _this._onBlur(); // this.setState({ countrySelectFocused: false })


      var countrySelectProps = _this.props.countrySelectProps;

      if (countrySelectProps) {
        var onBlur = countrySelectProps.onBlur;

        if (onBlur) {
          onBlur(event);
        }
      }
    });

    _this.inputRef = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createRef();
    var _this$props3 = _this.props,
        _value = _this$props3.value,
        labels = _this$props3.labels,
        _international = _this$props3.international,
        _addInternationalOption = _this$props3.addInternationalOption,
        displayInitialValueAsLocalNumber = _this$props3.displayInitialValueAsLocalNumber,
        initialValueFormat = _this$props3.initialValueFormat,
        _metadata = _this$props3.metadata;
    var _this$props4 = _this.props,
        _defaultCountry = _this$props4.defaultCountry,
        _countries = _this$props4.countries; // Validate `defaultCountry`.

    if (_defaultCountry) {
      if (!_this.isCountrySupportedWithError(_defaultCountry)) {
        _defaultCountry = undefined;
      }
    } // Validate `countries`.


    _countries = getSupportedCountries(_countries, _metadata);
    var phoneNumber = phoneInputHelpers_parsePhoneNumber(_value, _metadata);
    _this.CountryIcon = createCountryIconComponent(_this.props);
    var preSelectedCountry = getPreSelectedCountry({
      value: _value,
      phoneNumber: phoneNumber,
      defaultCountry: _defaultCountry,
      required: !_addInternationalOption,
      countries: _countries || getCountries(_metadata),
      getAnyCountry: function getAnyCountry() {
        return _this.getFirstSupportedCountry({
          countries: _countries
        });
      },
      metadata: _metadata
    });
    _this.state = {
      // Workaround for `this.props` inside `getDerivedStateFromProps()`.
      props: _this.props,
      // The country selected.
      country: preSelectedCountry,
      // `countries` are stored in `this.state` because they're filtered.
      // For example, a developer might theoretically pass some unsupported
      // countries as part of the `countries` property, and because of that
      // the component uses `this.state.countries` (which are filtered)
      // instead of `this.props.countries`
      // (which could potentially contain unsupported countries).
      countries: _countries,
      // `phoneDigits` state property holds non-formatted user's input.
      // The reason is that there's no way of finding out
      // in which form should `value` be displayed: international or national.
      // E.g. if `value` is `+78005553535` then it could be input
      // by a user both as `8 (800) 555-35-35` and `+7 800 555 35 35`.
      // Hence storing just `value` is not sufficient for correct formatting.
      // E.g. if a user entered `8 (800) 555-35-35`
      // then value is `+78005553535` and `phoneDigits` are `88005553535`
      // and if a user entered `+7 800 555 35 35`
      // then value is `+78005553535` and `phoneDigits` are `+78005553535`.
      phoneDigits: phoneInputHelpers_getInitialPhoneDigits({
        value: _value,
        phoneNumber: phoneNumber,
        defaultCountry: _defaultCountry,
        international: _international,
        useNationalFormat: displayInitialValueAsLocalNumber || initialValueFormat === 'national',
        metadata: _metadata
      }),
      // `value` property is duplicated in state.
      // The reason is that `getDerivedStateFromProps()`
      // needs this `value` to compare to the new `value` property
      // to find out if `phoneDigits` needs updating:
      // If the `value` property was changed externally
      // then it won't be equal to `state.value`
      // in which case `phoneDigits` and `country` should be updated.
      value: _value
    };
    return _this;
  }

  PhoneInputWithCountry_createClass(PhoneNumberInput_, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onCountryChange = this.props.onCountryChange;
      var defaultCountry = this.props.defaultCountry;
      var selectedCountry = this.state.country;

      if (onCountryChange) {
        if (defaultCountry) {
          if (!this.isCountrySupportedWithError(defaultCountry)) {
            defaultCountry = undefined;
          }
        }

        if (selectedCountry !== defaultCountry) {
          onCountryChange(selectedCountry);
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var onCountryChange = this.props.onCountryChange;
      var country = this.state.country; // Call `onCountryChange` when user selects another country.

      if (onCountryChange && country !== prevState.country) {
        onCountryChange(country);
      }
    }
  }, {
    key: "getCountrySelectOptions",
    value: function getCountrySelectOptions(_ref) {
      var countries = _ref.countries;
      var _this$props5 = this.props,
          international = _this$props5.international,
          countryCallingCodeEditable = _this$props5.countryCallingCodeEditable,
          countryOptionsOrder = _this$props5.countryOptionsOrder,
          addInternationalOption = _this$props5.addInternationalOption,
          labels = _this$props5.labels,
          locales = _this$props5.locales,
          metadata = _this$props5.metadata;
      return this.useMemoCountrySelectOptions(function () {
        return sortCountryOptions(phoneInputHelpers_getCountrySelectOptions({
          countries: countries || getCountries(metadata),
          countryNames: labels,
          addInternationalOption: international && countryCallingCodeEditable === false ? false : addInternationalOption,
          compareStringsLocales: locales // compareStrings

        }), getSupportedCountryOptions(countryOptionsOrder, metadata));
      }, [countries, countryOptionsOrder, addInternationalOption, labels, metadata]);
    }
  }, {
    key: "useMemoCountrySelectOptions",
    value: function useMemoCountrySelectOptions(generator, dependencies) {
      if (!this.countrySelectOptionsMemoDependencies || !areEqualArrays(dependencies, this.countrySelectOptionsMemoDependencies)) {
        this.countrySelectOptionsMemo = generator();
        this.countrySelectOptionsMemoDependencies = dependencies;
      }

      return this.countrySelectOptionsMemo;
    }
  }, {
    key: "getFirstSupportedCountry",
    value: function getFirstSupportedCountry(_ref2) {
      var countries = _ref2.countries;
      var countryOptions = this.getCountrySelectOptions({
        countries: countries
      });
      return countryOptions[0].value;
    } // A shorthand for not passing `metadata` as a second argument.

  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          name = _this$props6.name,
          disabled = _this$props6.disabled,
          readOnly = _this$props6.readOnly,
          autoComplete = _this$props6.autoComplete,
          style = _this$props6.style,
          className = _this$props6.className,
          inputRef = _this$props6.inputRef,
          inputComponent = _this$props6.inputComponent,
          numberInputProps = _this$props6.numberInputProps,
          smartCaret = _this$props6.smartCaret,
          CountrySelectComponent = _this$props6.countrySelectComponent,
          countrySelectProps = _this$props6.countrySelectProps,
          ContainerComponent = _this$props6.containerComponent,
          defaultCountry = _this$props6.defaultCountry,
          countriesProperty = _this$props6.countries,
          countryOptionsOrder = _this$props6.countryOptionsOrder,
          labels = _this$props6.labels,
          flags = _this$props6.flags,
          flagComponent = _this$props6.flagComponent,
          flagUrl = _this$props6.flagUrl,
          addInternationalOption = _this$props6.addInternationalOption,
          internationalIcon = _this$props6.internationalIcon,
          displayInitialValueAsLocalNumber = _this$props6.displayInitialValueAsLocalNumber,
          initialValueFormat = _this$props6.initialValueFormat,
          onCountryChange = _this$props6.onCountryChange,
          limitMaxLength = _this$props6.limitMaxLength,
          countryCallingCodeEditable = _this$props6.countryCallingCodeEditable,
          focusInputOnCountrySelection = _this$props6.focusInputOnCountrySelection,
          reset = _this$props6.reset,
          metadata = _this$props6.metadata,
          international = _this$props6.international,
          locales = _this$props6.locales,
          rest = PhoneInputWithCountry_objectWithoutProperties(_this$props6, PhoneInputWithCountry_excluded);

      var _this$state3 = this.state,
          country = _this$state3.country,
          countries = _this$state3.countries,
          phoneDigits = _this$state3.phoneDigits,
          isFocused = _this$state3.isFocused;
      var InputComponent = smartCaret ? modules_InputSmart : modules_InputBasic;
      var countrySelectOptions = this.getCountrySelectOptions({
        countries: countries
      });
      return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(ContainerComponent, {
        style: style,
        className: classnames_default()(className, 'PhoneInput', {
          'PhoneInput--focus': isFocused,
          'PhoneInput--disabled': disabled,
          'PhoneInput--readOnly': readOnly
        })
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(CountrySelectComponent, PhoneInputWithCountry_extends({
        name: name ? "".concat(name, "Country") : undefined,
        "aria-label": labels.country
      }, countrySelectProps, {
        value: country,
        options: countrySelectOptions,
        onChange: this.onCountryChange,
        onFocus: this.onCountryFocus,
        onBlur: this.onCountryBlur,
        disabled: disabled || countrySelectProps && countrySelectProps.disabled,
        readOnly: readOnly || countrySelectProps && countrySelectProps.readOnly,
        iconComponent: this.CountryIcon
      })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(InputComponent, PhoneInputWithCountry_extends({
        ref: this.setInputRef,
        type: "tel",
        autoComplete: autoComplete
      }, numberInputProps, rest, {
        name: name,
        metadata: metadata,
        country: country,
        value: phoneDigits || '',
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        disabled: disabled,
        readOnly: readOnly,
        inputComponent: inputComponent,
        className: classnames_default()('PhoneInputInput', numberInputProps && numberInputProps.className, rest.className)
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: // `state` holds previous props as `props`, and also:
    // * `country` — The currently selected country, e.g. `"RU"`.
    // * `value` — The currently entered phone number (E.164), e.g. `+78005553535`.
    // * `phoneDigits` — The parsed `<input/>` value, e.g. `8005553535`.
    // (and a couple of other less significant properties)
    function getDerivedStateFromProps(props, state) {
      return PhoneInputWithCountry_objectSpread({
        // Emulate `prevProps` via `state.props`.
        props: props
      }, getPhoneInputWithCountryStateUpdateFromNewProps(props, state.props, state));
    }
  }]);

  return PhoneNumberInput_;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.PureComponent); // This wrapper is only to `.forwardRef()` to the `<input/>`.


var PhoneNumberInput = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.forwardRef(function (props, ref) {
  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(PhoneInputWithCountry_PhoneNumberInput_, PhoneInputWithCountry_extends({}, props, {
    inputRef: ref
  }));
});
PhoneNumberInput.propTypes = {
  /**
   * Phone number in `E.164` format.
   *
   * Example:
   *
   * `"+12223333333"`
   *
   * Any "falsy" value like `undefined`, `null` or an empty string `""` is treated like "empty".
   */
  value: prop_types_default.a.string,

  /**
   * A function of `value: string?`.
   *
   * Updates the `value` property as the user inputs a phone number.
   *
   * If the user erases the input value, the argument is `undefined`.
   */
  onChange: prop_types_default.a.func.isRequired,

  /**
   * Toggles the `--focus` CSS class.
   * @ignore
   */
  onFocus: prop_types_default.a.func,

  /**
   * `onBlur` is usually passed by `redux-form`.
   * @ignore
   */
  onBlur: prop_types_default.a.func,

  /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `disabled`.
   */
  disabled: prop_types_default.a.bool,

  /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `readonly`.
   */
  readOnly: prop_types_default.a.bool,

  /**
   * Sets `autoComplete` property for phone number `<input/>`.
   *
   * Web browser's "autocomplete" feature
   * remembers the phone number being input
   * and can also autofill the `<input/>`
   * with previously remembered phone numbers.
   *
   * https://developers.google.com
   * /web/updates/2015/06/checkout-faster-with-autofill
   *
   * For example, can be used to turn it off:
   *
   * "So when should you use `autocomplete="off"`?
   *  One example is when you've implemented your own version
   *  of autocomplete for search. Another example is any form field
   *  where users will input and submit different kinds of information
   *  where it would not be useful to have the browser remember
   *  what was submitted previously".
   */
  // (is `"tel"` by default)
  autoComplete: prop_types_default.a.string.isRequired,

  /**
   * Set to `"national"` to show the initial `value` in
   * "national" format rather than "international".
   *
   * For example, if `initialValueFormat` is `"national"`
   * and the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"(213) 373-4253"`.
   *
   * By default, `initialValueFormat` is `undefined`,
   * meaning that if the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"+1 213 373 4253"`.
   *
   * The reason for such default behaviour is that
   * the newer generation grows up when there are no stationary phones
   * and therefore everyone inputs phone numbers in international format
   * in their smartphones so people gradually get more accustomed to
   * writing phone numbers in international format rather than in local format.
   * Future people won't be using "national" format, only "international".
   */
  // (is `undefined` by default)
  initialValueFormat: prop_types_default.a.oneOf(['national']),
  // `displayInitialValueAsLocalNumber` property has been
  // superceded by `initialValueFormat` property.
  displayInitialValueAsLocalNumber: prop_types_default.a.bool,

  /**
   * The country to be selected by default.
   * For example, can be set after a GeoIP lookup.
   *
   * Example: `"US"`.
   */
  // A two-letter country code ("ISO 3166-1 alpha-2").
  defaultCountry: prop_types_default.a.string,

  /**
   * If specified, only these countries will be available for selection.
   *
   * Example:
   *
   * `["RU", "UA", "KZ"]`
   */
  countries: prop_types_default.a.arrayOf(prop_types_default.a.string),

  /**
   * Custom country `<select/>` option names.
   * Also some labels like "ext" and country `<select/>` `aria-label`.
   *
   * Example:
   *
   * `{ "ZZ": "Международный", RU: "Россия", US: "США", ... }`
   *
   * See the `locales` directory for examples.
   */
  labels: PropTypes_labels.isRequired,

  /**
   * Country `<select/>` options are sorted by their labels.
   * The default sorting function uses `a.localeCompare(b, locales)`,
   * and, if that's not available, falls back to simple `a > b` / `a < b`.
   * Some languages, like Chinese, support multiple sorting variants
   * (called "collations"), and the user might prefer one or another.
   * Also, sometimes the Operating System language is not always
   * the preferred language for a person using a website or an application,
   * so there should be a way to specify custom locale.
   * This `locales` property mimicks the `locales` argument of `Intl` constructors,
   * and can be either a Unicode BCP 47 locale identifier or an array of such locale identifiers.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument
   */
  locales: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.arrayOf(prop_types_default.a.string)]),

  /*
   * Custom country `<select/>` options sorting function.
   * The default one uses `a.localeCompare(b)`, and,
   * if that's not available, falls back to simple `a > b`/`a < b`.
   * There have been requests to add custom sorter for cases
   * like Chinese language and "pinyin" (non-default) sorting order.
   * https://stackoverflow.com/questions/22907288/chinese-sorting-by-pinyin-in-javascript-with-localecompare
  compareStrings: PropTypes.func,
   */

  /**
   * A URL template of a country flag, where
   * "{XX}" is a two-letter country code in upper case,
   * or where "{xx}" is a two-letter country code in lower case.
   * By default it points to `country-flag-icons` gitlab pages website.
   * I imagine someone might want to download those country flag icons
   * and host them on their own servers instead
   * (all flags are available in the `country-flag-icons` library).
   * There's a catch though: new countries may be added in future,
   * so when hosting country flag icons on your own server
   * one should check the `CHANGELOG.md` every time before updating this library,
   * otherwise there's a possibility that some new country flag would be missing.
   */
  flagUrl: prop_types_default.a.string.isRequired,

  /**
   * Custom country flag icon components.
   * These flags will be used instead of the default ones.
   * The the "Flags" section of the readme for more info.
   *
   * The shape is an object where keys are country codes
   * and values are flag icon components.
   * Flag icon components receive the same properties
   * as `flagComponent` (see below).
   *
   * Example:
   *
   * `{ "RU": (props) => <img src="..."/> }`
   *
   * Example:
   *
   * `import flags from 'country-flag-icons/react/3x2'`
   *
   * `import PhoneInput from 'react-phone-number-input'`
   *
   * `<PhoneInput flags={flags} .../>`
   */
  flags: prop_types_default.a.objectOf(prop_types_default.a.elementType),

  /**
   * Country flag icon component.
   *
   * Takes properties:
   *
   * * `country: string` — The country code.
   * * `countryName: string` — The country name.
   * * `flagUrl: string` — The `flagUrl` property (see above).
   * * `flags: object` — The `flags` property (see above).
   */
  flagComponent: prop_types_default.a.elementType.isRequired,

  /**
   * Set to `false` to remove the "International" option from country `<select/>`.
   */
  addInternationalOption: prop_types_default.a.bool.isRequired,

  /**
   * "International" icon component.
   * Should have the same aspect ratio.
   *
   * Receives properties:
   *
   * * `title: string` — "International" country option label.
   */
  internationalIcon: prop_types_default.a.elementType.isRequired,

  /**
   * Can be used to place some countries on top of the list of country `<select/>` options.
   *
   * * `"XX"` — inserts an option for "XX" country.
   * * `"🌐"` — inserts "International" option.
   * * `"|"` — inserts a separator.
   * * `"..."` — inserts options for the rest of the countries (can be omitted, in which case it will be automatically added at the end).
   *
   * Example:
   *
   * `["US", "CA", "AU", "|", "..."]`
   */
  countryOptionsOrder: prop_types_default.a.arrayOf(prop_types_default.a.string),

  /**
   * `<Phone/>` component CSS style object.
   */
  style: prop_types_default.a.object,

  /**
   * `<Phone/>` component CSS class.
   */
  className: prop_types_default.a.string,

  /**
   * Country `<select/>` component.
   *
   * Receives properties:
   *
   * * `name: string?` — HTML `name` attribute.
   * * `value: string?` — The currently selected country code.
   * * `onChange(value: string?)` — Updates the `value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * `options: object[]` — The list of all selectable countries (including "International") each being an object of shape `{ value: string?, label: string }`.
   * * `iconComponent: PropTypes.elementType` — React component that renders a country icon: `<Icon country={value}/>`. If `country` is `undefined` then it renders an "International" icon.
   * * `disabled: boolean?` — HTML `disabled` attribute.
   * * `readOnly: boolean?` — HTML `readOnly` attribute.
   * * `tabIndex: (number|string)?` — HTML `tabIndex` attribute.
   * * `className: string` — CSS class name.
   */
  countrySelectComponent: prop_types_default.a.elementType.isRequired,

  /**
   * Country `<select/>` component props.
   * Along with the usual DOM properties such as `aria-label` and `tabIndex`,
   * some custom properties are supported, such as `arrowComponent` and `unicodeFlags`.
   */
  countrySelectProps: prop_types_default.a.object,

  /**
   * Phone number `<input/>` component.
   *
   * Receives properties:
   *
   * * `value: string` — The formatted `value`.
   * * `onChange(event: Event)` — Updates the formatted `value` from `event.target.value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * Other properties like `type="tel"` or `autoComplete="tel"` that should be passed through to the DOM `<input/>`.
   *
   * Must also either use `React.forwardRef()` to "forward" `ref` to the `<input/>` or implement `.focus()` method.
   */
  inputComponent: prop_types_default.a.elementType.isRequired,

  /**
   * Wrapping `<div/>` component.
   *
   * Receives properties:
   *
   * * `style: object` — A component CSS style object.
   * * `className: string` — Classes to attach to the component, typically changes when component focuses or blurs.
   */
  containerComponent: prop_types_default.a.elementType.isRequired,

  /**
   * Phone number `<input/>` component props.
   */
  numberInputProps: prop_types_default.a.object,

  /**
   * When the user attempts to insert a digit somewhere in the middle of a phone number,
   * the caret position is moved right before the next available digit skipping
   * any punctuation in between. This is called "smart" caret positioning.
   * Another case would be the phone number format changing as a result of
   * the user inserting the digit somewhere in the middle, which would require
   * re-positioning the caret because all digit positions have changed.
   * This "smart" caret positioning feature can be turned off by passing
   * `smartCaret={false}` property: use it in case of any possible issues
   * with caret position during phone number input.
   */
  // Is `true` by default.
  smartCaret: prop_types_default.a.bool.isRequired,

  /**
   * Set to `true` to force "international" phone number format.
   * Set to `false` to force "national" phone number format.
   * By default it's `undefined` meaning that it doesn't enforce any phone number format.
   */
  international: prop_types_default.a.bool,

  /**
   * If set to `true`, the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */
  limitMaxLength: prop_types_default.a.bool.isRequired,

  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: prop_types_default.a.bool.isRequired,

  /**
   * `libphonenumber-js` metadata.
   *
   * Can be used to pass custom `libphonenumber-js` metadata
   * to reduce the overall bundle size for those who compile "custom" metadata.
   */
  metadata: PropTypes_metadata.isRequired,

  /**
   * Is called every time the selected country changes:
   * either programmatically or when user selects it manually from the list.
   */
  // People have been asking for a way to get the selected country.
  // @see  https://github.com/catamphetamine/react-phone-number-input/issues/128
  // For some it's just a "business requirement".
  // I guess it's about gathering as much info on the user as a website can
  // without introducing any addional fields that would complicate the form
  // therefore reducing "conversion" (that's a marketing term).
  // Assuming that the phone number's country is the user's country
  // is not 100% correct but in most cases I guess it's valid.
  onCountryChange: prop_types_default.a.func,

  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: prop_types_default.a.bool.isRequired
};
PhoneNumberInput.defaultProps = {
  /**
   * Remember (and autofill) the value as a phone number.
   */
  autoComplete: 'tel',

  /**
   * Country `<select/>` component.
   */
  countrySelectComponent: CountrySelectWithIcon,

  /**
   * Flag icon component.
   */
  flagComponent: Flag_FlagComponent,

  /**
   * By default, uses icons from `country-flag-icons` gitlab pages website.
   */
  // Must be equal to `flagUrl` in `./CountryIcon.js`.
  flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg',

  /**
   * Default "International" country `<select/>` option icon.
   */
  internationalIcon: InternationalIcon_InternationalIcon,

  /**
   * Phone number `<input/>` component.
   */
  inputComponent: 'input',

  /**
   * Wrapping `<div/>` component.
   */
  containerComponent: 'div',

  /**
   * Some users requested a way to reset the component:
   * both number `<input/>` and country `<select/>`.
   * Whenever `reset` property changes both number `<input/>`
   * and country `<select/>` are reset.
   * It's not implemented as some instance `.reset()` method
   * because `ref` is forwarded to `<input/>`.
   * It's also not replaced with just resetting `country` on
   * external `value` reset, because a user could select a country
   * and then not input any `value`, and so the selected country
   * would be "stuck", if not using this `reset` property.
   */
  // https://github.com/catamphetamine/react-phone-number-input/issues/300
  reset: prop_types_default.a.any,

  /**
   *
   */

  /**
   * Set to `false` to use "basic" caret instead of the "smart" one.
   */
  smartCaret: true,

  /**
   * Whether to add the "International" option
   * to the list of countries.
   */
  addInternationalOption: true,

  /**
   * If set to `true` the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */
  limitMaxLength: false,

  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: true,

  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: true
};
/* harmony default export */ var PhoneInputWithCountry = (PhoneNumberInput);

function areEqualArrays(a, b) {
  if (a.length !== b.length) {
    return false;
  }

  var i = 0;

  while (i < a.length) {
    if (a[i] !== b[i]) {
      return false;
    }

    i++;
  }

  return true;
}
//# sourceMappingURL=PhoneInputWithCountry.js.map
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/modules/PhoneInputWithCountryDefault.js
function PhoneInputWithCountryDefault_extends() { PhoneInputWithCountryDefault_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return PhoneInputWithCountryDefault_extends.apply(this, arguments); }






function createPhoneInput(defaultMetadata) {
  var PhoneInputDefault = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.forwardRef(function (props, ref) {
    return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(PhoneInputWithCountry, PhoneInputWithCountryDefault_extends({
      ref: ref
    }, props));
  });
  PhoneInputDefault.propTypes = {
    metadata: PropTypes_metadata.isRequired,
    labels: PropTypes_labels.isRequired
  };
  PhoneInputDefault.defaultProps = {
    metadata: defaultMetadata,
    labels: en_json
  };
  return PhoneInputDefault;
}
/* harmony default export */ var PhoneInputWithCountryDefault = (createPhoneInput());
//# sourceMappingURL=PhoneInputWithCountryDefault.js.map
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/min/index.js






function call(func, _arguments) {
	var args = Array.prototype.slice.call(_arguments)
	args.push(metadata_min_json)
	return func.apply(this, args)
}

/* harmony default export */ var min = (createPhoneInput(metadata_min_json));

function min_parsePhoneNumber() {
	return call(parsePhoneNumberFromString_parsePhoneNumberFromString, arguments)
}

function min_formatPhoneNumber() {
	return call(formatPhoneNumber, arguments)
}

function min_formatPhoneNumberIntl() {
	return call(formatPhoneNumberIntl, arguments)
}

function min_isValidPhoneNumber() {
	return call(isValidPhoneNumber, arguments)
}

function min_isPossiblePhoneNumber() {
	return call(isPossiblePhoneNumber_isPossiblePhoneNumber, arguments)
}

function min_getCountries() {
	return call(getCountries, arguments)
}

function min_getCountryCallingCode() {
	return call(getCountryCallingCode, arguments)
}

function min_isSupportedCountry() {
	return call(isSupportedCountry, arguments)
}
// CONCATENATED MODULE: ./src/components/contentful-views/util/template-strings.jsx


function normalizeSubstitutionHash(substitutions) {
  if (lodash_default.a.isArray(substitutions)) {
    // eslint-disable-next-line no-param-reassign
    substitutions = lodash_default.a.reduce(
    substitutions,
    function (acc, elem) {return lodash_default.a.set(acc, elem.name, elem.value);},
    {});

  }
  return lodash_default.a.mapKeys(substitutions, function (_value, key) {return lodash_default.a.trim(key);});
}

/**
 * Substitutes strings into a text string replacing {{macro}} the given text
 * string with the appropriate value {macro: 'value'} from simpleStrings. This
 * method accepts both the preferred form of simpleStrings {macro: value, ...} and
 * the legacy form [{name: 'macro', value: 'value'}, ...]
 *
 * Note: Leave the flexible option enabled in user-facing cases. This way, they will see
 * "Hello , how's your Glowforge?" instead of "Hello {{userFirstName}}, how's your Glowforge?"
 *
 * @param  {string} text                - text that may or may not contain {{name}} entries
 * @param  {object of strings}          - name value pairs to replace in passed string
 *                                        simple hash {macro: value}
 * @param  {Object} options             - Additional options to control behavior
 * @param  {boolean} options.flexible   - (default: true) Prefer true. False preserves
 *                                        legacy behavior and will be removed in a future
 *                                        version. When true, use empty string instead of
 *                                        the original macro text for unspecified macros.
 * @return {string}                     - input text with {{name}} replaced by value from
 *                                        simple strings hash
 */
function stringSubstitution(text, simpleStrings) {var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},_ref$flexible = _ref.flexible,flexible = _ref$flexible === void 0 ? true : _ref$flexible;
  if (lodash_default.a.isEmpty(text)) return '';
  // eslint-disable-next-line no-param-reassign
  simpleStrings = simpleStrings || {};

  var substitutionHash = normalizeSubstitutionHash(simpleStrings);

  return text.replace(/{{([^{}]+)}}/g, function (original, name) {
    var defaultValue = flexible ? '' : original;

    var value = lodash_default.a.toString(substitutionHash[lodash_default.a.trim(name)]);
    return lodash_default.a.isEmpty(value) ? defaultValue : value;
  });
}
// CONCATENATED MODULE: ./src/components/contentful-views/util/component-template-string.jsx
function component_template_string_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function component_template_string_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? component_template_string_ownKeys(Object(source), !0).forEach(function (key) {component_template_string_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : component_template_string_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function component_template_string_defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function component_template_string_slicedToArray(arr, i) {return component_template_string_arrayWithHoles(arr) || component_template_string_iterableToArrayLimit(arr, i) || component_template_string_unsupportedIterableToArray(arr, i) || component_template_string_nonIterableRest();}function component_template_string_nonIterableRest() {throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function component_template_string_unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return component_template_string_arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return component_template_string_arrayLikeToArray(o, minLen);}function component_template_string_arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}function component_template_string_iterableToArrayLimit(arr, i) {var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];if (_i == null) return;var _arr = [];var _n = true;var _d = false;var _s, _e;try {for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"] != null) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}function component_template_string_arrayWithHoles(arr) {if (Array.isArray(arr)) return arr;}



/**
 * Substitutes components in to a text string replacing {{macro|value}} with a React
 * render function. Same as stringSubstitution, but with components.
 *
 * Use Cases:
 * - render React components in place of strings.
 * - render a *bold* string in place of the macro text
 * - give the macro text a color
 * @param {string} text - text that may or may not contain {{macro|value}} entries
 * @param {object} components - Mapping of macros to functional components.
 *                              Fn is passed macro or macro value
 * @param {object} [options] - Options for the substitution.
 * @param {bool} [options.markdown] - Use markdown for the text fragments. Default is true.
 * @param {string} [options.markdownWrapperElement] - Element used to wrap markdown.
 * @param {object} [options.remarkableOptions] - Options passed to remarkable.
 */
function componentSubstitution(text, components)


{var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { markdown: true, remarkableOptions: {} };
  if (typeof text !== 'string') {
    return '';
  }

  // Regex to extract macros.
  var split = text.split(/{{([^{}]+)}}/g);
  return split.map(function (macro, index) {
    if (macro.length < 1) {
      return null;
    }

    var _macro$split = macro.split('|'),_macro$split2 = component_template_string_slicedToArray(_macro$split, 2),macroKey = _macro$split2[0],macroValue = _macro$split2[1];
    var render = components[macroKey];
    var value = macroValue || macroKey;

    var fragment;
    if (lodash_default.a.isFunction(render)) {
      fragment = render(value);
    } else {
      fragment = options.markdown ? /*#__PURE__*/

      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, {
        element: options.markdownWrapperElement,
        options: component_template_string_objectSpread({ html: true, breaks: true }, options.remarkableOptions),
        source: macro }) :

      macro;
    }

    // eslint-disable-next-line react/no-array-index-key
    return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Fragment, { key: "".concat(index, "\u2013").concat(macro) }, fragment);
  });
}
// CONCATENATED MODULE: ./src/components/contentful-views/util/meta-tags.js
function meta_tags_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function meta_tags_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function meta_tags_createClass(Constructor, protoProps, staticProps) {if (protoProps) meta_tags_defineProperties(Constructor.prototype, protoProps);if (staticProps) meta_tags_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}

/**
 * MetaTag Helper class.  Creates an array of tags for React-Helmet to inject in to the page.
 * react-isomorphic-render injects meta, link, and title tags in to the head on the server side.
 * It does not inject script tags. See:
 * https://github.com/catamphetamine/react-website/blob/11/source/page-server/html.js#L57
 */var
meta_tags_MetaTags = /*#__PURE__*/function () {
  function MetaTags() {meta_tags_classCallCheck(this, MetaTags);
    this.tags = [];
  }meta_tags_createClass(MetaTags, [{ key: "push", value:

    function push(meta) {
      if (meta.content) {
        this.tags.push(meta);
      }
      return this;
    } }, { key: "pushAll", value:

    function pushAll(metaArray) {
      lodash_default.a.each(metaArray, this.push.bind(this));
      return this;
    } }, { key: "name", value:

    function name(_name, content) {return this.push({ name: _name, content: content });} }, { key: "property", value:

    function property(_property, content) {return this.push({ property: _property, content: content });} }, { key: "twitter", value:

    function twitter(name, content) {return this.name("twitter:".concat(name), content);} }, { key: "openGraph", value:

    function openGraph(name, content) {return this.property("og:".concat(name), content);}

    // Deprecated - Facebook now reads OpenGraph metadata tags
  }, { key: "facebook", value: function facebook(name, content) {return this.property("fb:".concat(name), content);}

    // Deprecated - Pinterest now reads (slightly non-standard) OpenGraph metadata tags
  }, { key: "pinterest", value: function pinterest(name, content) {return this.name("p:".concat(name), content);}

    // The following helpers are designed to support the Page Metadata content type in Contentful
  }, { key: "title", value: function title(value) {return this.twitter('title', value).openGraph('title', value);} }, { key: "description", value:

    function description(value) {
      return this.
      name('description', value).
      twitter('description', value).
      openGraph('description', value);
    } }, { key: "image", value:

    function image(value) {return this.twitter('image', value).openGraph('image', value);} }]);return MetaTags;}();
// CONCATENATED MODULE: ./src/components/contentful-views/util/index.js
// This index file is provided to smooth over the transition from a single
// util.js to a directory of distinct Contentful Component utils. New code
// should import directly from specific files.




// CONCATENATED MODULE: ./node_modules/react-phone-number-input/modules/usePhoneDigits.js
function usePhoneDigits_slicedToArray(arr, i) { return usePhoneDigits_arrayWithHoles(arr) || usePhoneDigits_iterableToArrayLimit(arr, i) || usePhoneDigits_unsupportedIterableToArray(arr, i) || usePhoneDigits_nonIterableRest(); }

function usePhoneDigits_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function usePhoneDigits_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return usePhoneDigits_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return usePhoneDigits_arrayLikeToArray(o, minLen); }

function usePhoneDigits_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function usePhoneDigits_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function usePhoneDigits_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




/**
 * Returns `[phoneDigits, setPhoneDigits]`.
 * "Phone digits" includes not only "digits" but also a `+` sign.
 */

function usePhoneDigits(_ref) {
  var _this = this;

  var value = _ref.value,
      onChange = _ref.onChange,
      country = _ref.country,
      defaultCountry = _ref.defaultCountry,
      international = _ref.international,
      withCountryCallingCode = _ref.withCountryCallingCode,
      useNationalFormatForDefaultCountryValue = _ref.useNationalFormatForDefaultCountryValue,
      metadata = _ref.metadata;
  var countryMismatchDetected = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useRef"])();

  var onCountryMismatch = function onCountryMismatch(value, country, actualCountry) {
    console.error("[react-phone-number-input] Expected phone number ".concat(value, " to correspond to country ").concat(country, " but ").concat(actualCountry ? 'in reality it corresponds to country ' + actualCountry : 'it doesn\'t', "."));
    countryMismatchDetected.current = true;
  };

  var getInitialPhoneDigits = function getInitialPhoneDigits(options) {
    return getPhoneDigitsForValue(value, country, international, withCountryCallingCode, defaultCountry, useNationalFormatForDefaultCountryValue, metadata, function () {
      if (options && options.onCountryMismatch) {
        options.onCountryMismatch();
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      onCountryMismatch.apply(_this, args);
    });
  }; // This is only used to detect `country` property change.


  var _useState = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useState"])(country),
      _useState2 = usePhoneDigits_slicedToArray(_useState, 2),
      prevCountry = _useState2[0],
      setPrevCountry = _useState2[1]; // This is only used to detect `defaultCountry` property change.


  var _useState3 = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useState"])(defaultCountry),
      _useState4 = usePhoneDigits_slicedToArray(_useState3, 2),
      prevDefaultCountry = _useState4[0],
      setPrevDefaultCountry = _useState4[1]; // `phoneDigits` is the `value` passed to the `<input/>`.


  var _useState5 = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useState"])(getInitialPhoneDigits()),
      _useState6 = usePhoneDigits_slicedToArray(_useState5, 2),
      phoneDigits = _useState6[0],
      setPhoneDigits = _useState6[1]; // This is only used to detect `value` property changes.


  var _useState7 = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useState"])(value),
      _useState8 = usePhoneDigits_slicedToArray(_useState7, 2),
      valueForPhoneDigits = _useState8[0],
      setValueForPhoneDigits = _useState8[1]; // Rerender hack.


  var _useState9 = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useState"])(),
      _useState10 = usePhoneDigits_slicedToArray(_useState9, 2),
      rerenderTrigger = _useState10[0],
      setRerenderTrigger = _useState10[1];

  var rerender = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useCallback"])(function () {
    return setRerenderTrigger({});
  }, [setRerenderTrigger]);

  function getValueForPhoneDigits(phoneDigits) {
    // If the user hasn't input any digits then `value` is `undefined`.
    if (!phoneDigits) {
      return;
    }

    if (country && international && !withCountryCallingCode) {
      phoneDigits = "+".concat(getCountryCallingCode(country, metadata)).concat(phoneDigits);
    } // Return the E.164 phone number value.
    //
    // Even if no "national (significant) number" digits have been input,
    // still return a non-`undefined` value.
    // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/113
    //
    // For example, if the user has selected country `US` and entered `"1"`
    // then that `"1"` is just a "national prefix" and no "national (significant) number"
    // digits have been input yet. Still, return `"+1"` as `value` in such cases,
    // because otherwise the app would think that the input is empty and mark it as such
    // while in reality it isn't empty, which might be thought of as a "bug", or just
    // a "weird" behavior.
    //
    // The only case when there's any input and `getNumberValue()` still returns `undefined`
    // is when that input is `"+"`.
    //


    var asYouType = new AsYouType_AsYouType(country || defaultCountry, metadata);
    asYouType.input(phoneDigits);
    return asYouType.getNumberValue();
  } // If `value` property has been changed externally
  // then re-initialize the component.


  Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useEffect"])(function () {
    if (value !== valueForPhoneDigits) {
      setValueForPhoneDigits(value);
      setPhoneDigits(getInitialPhoneDigits());
    }
  }, [value]); // If the `country` has been changed then re-initialize the component.

  Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useEffect"])(function () {
    if (country !== prevCountry) {
      setPrevCountry(country);

      var _countryMismatchDetected;

      var _phoneDigits = getInitialPhoneDigits({
        onCountryMismatch: function onCountryMismatch() {
          _countryMismatchDetected = true;
        }
      });

      setPhoneDigits(_phoneDigits);

      if (_countryMismatchDetected) {
        setValueForPhoneDigits(getValueForPhoneDigits(_phoneDigits));
      }
    }
  }, [country]); // If the `defaultCountry` has been changed then re-initialize the component.

  Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useEffect"])(function () {
    if (defaultCountry !== prevDefaultCountry) {
      setPrevDefaultCountry(defaultCountry);
      setPhoneDigits(getInitialPhoneDigits());
    }
  }, [defaultCountry]); // Update the `value` after `valueForPhoneDigits` has been updated.

  Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useEffect"])(function () {
    if (valueForPhoneDigits !== value) {
      onChange(valueForPhoneDigits);
    }
  }, [valueForPhoneDigits]);
  var onSetPhoneDigits = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useCallback"])(function (phoneDigits) {
    var value;

    if (country) {
      if (international && withCountryCallingCode) {
        // The `<input/>` value must start with the country calling code.
        var prefix = getInternationalPhoneNumberPrefix(country, metadata);

        if (phoneDigits.indexOf(prefix) !== 0) {
          // If a user tabs into a phone number input field
          // that is `international` and `withCountryCallingCode`,
          // and then starts inputting local phone number digits,
          // the first digit would get "swallowed" if the fix below wasn't implemented.
          // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/43
          if (phoneDigits && phoneDigits[0] !== '+') {
            phoneDigits = prefix + phoneDigits;
          } else {
            // // Reset phone digits if they don't start with the correct prefix.
            // // Undo the `<input/>` value change if it doesn't.
            if (countryMismatchDetected.current) {// In case of a `country`/`value` mismatch,
              // if it performed an "undo" here, then
              // it wouldn't let a user edit their phone number at all,
              // so this special case at least allows phone number editing
              // when `value` already doesn't match the `country`.
            } else {
              // If it simply did `phoneDigits = prefix` here,
              // then it could have no effect when erasing phone number
              // via Backspace, because `phoneDigits` in `state` wouldn't change
              // as a result, because it was `prefix` and it became `prefix`,
              // so the component wouldn't rerender, and the user would be able
              // to erase the country calling code part, and that part is
              // assumed to be non-eraseable. That's why the component is
              // forcefully rerendered here.
              setPhoneDigits(prefix);
              setValueForPhoneDigits(undefined); // Force a re-render of the `<input/>` with previous `phoneDigits` value.

              return rerender();
            }
          }
        }
      } else {
        // Entering phone number either in "national" format
        // when `country` has been specified, or in "international" format
        // when `country` has been specified but `withCountryCallingCode` hasn't.
        // Therefore, `+` is not allowed.
        if (phoneDigits && phoneDigits[0] === '+') {
          // Remove the `+`.
          phoneDigits = phoneDigits.slice(1);
        }
      }
    } else if (!defaultCountry) {
      // Force a `+` in the beginning of a `value`
      // when no `country` and `defaultCountry` have been specified.
      if (phoneDigits && phoneDigits[0] !== '+') {
        // Prepend a `+`.
        phoneDigits = '+' + phoneDigits;
      }
    } // Convert `phoneDigits` to `value`.


    if (phoneDigits) {
      value = getValueForPhoneDigits(phoneDigits);
    }

    setPhoneDigits(phoneDigits);
    setValueForPhoneDigits(value);
  }, [country, international, withCountryCallingCode, defaultCountry, metadata, setPhoneDigits, setValueForPhoneDigits, rerender, countryMismatchDetected]);
  return [phoneDigits, onSetPhoneDigits];
}
/**
 * Returns phone number input field value for a E.164 phone number `value`.
 * @param  {string} [value]
 * @param  {string} [country]
 * @param  {boolean} [international]
 * @param  {boolean} [withCountryCallingCode]
 * @param  {string} [defaultCountry]
 * @param  {boolean} [useNationalFormatForDefaultCountryValue]
 * @param  {object} metadata
 * @return {string}
 */

function getPhoneDigitsForValue(value, country, international, withCountryCallingCode, defaultCountry, useNationalFormatForDefaultCountryValue, metadata, onCountryMismatch) {
  if (country && international && withCountryCallingCode) {
    var prefix = getInternationalPhoneNumberPrefix(country, metadata);

    if (value) {
      if (value.indexOf(prefix) !== 0) {
        onCountryMismatch(value, country);
      }

      return value;
    }

    return prefix;
  }

  if (!value) {
    return '';
  }

  if (!country && !defaultCountry) {
    return value;
  }

  var asYouType = new AsYouType_AsYouType(undefined, metadata);
  asYouType.input(value);
  var phoneNumber = asYouType.getNumber();

  if (phoneNumber) {
    if (country) {
      if (phoneNumber.country && phoneNumber.country !== country) {
        onCountryMismatch(value, country, phoneNumber.country);
      } else if (phoneNumber.countryCallingCode !== getCountryCallingCode(country, metadata)) {
        onCountryMismatch(value, country);
      }

      if (international) {
        return phoneNumber.nationalNumber;
      }

      return parseDigits(phoneNumber.formatNational());
    } else {
      // `phoneNumber.countryCallingCode` is compared here  instead of
      // `phoneNumber.country`, because, for example, a person could have
      // previously input a phone number (in "national" format) that isn't
      // 100% valid for the `defaultCountry`, and if `phoneNumber.country`
      // was compared, then it wouldn't match, and such phone number
      // wouldn't be formatted as a "national" one, and instead would be
      // formatted as an "international" one, confusing the user.
      // Comparing `phoneNumber.countryCallingCode` works around such issues.
      //
      // Example: `defaultCountry="US"` and the `<input/>` is empty.
      // The user inputs: "222 333 4444", which gets formatted to "(222) 333-4444".
      // The user then clicks "Save", the page is refreshed, and the user sees
      // that the `<input/>` value is now "+1 222 333 4444" which confuses the user:
      // the user expected the `<input/>` value to be "(222) 333-4444", same as it
      // was when they've just typed it in. The cause of the issue is that "222 333 4444"
      // is not a valid national number for US, and `phoneNumber.country` is compared
      // instead of `phoneNumber.countryCallingCode`. After the `phoneNumber.country`
      // comparison is replaced with `phoneNumber.countryCallingCode` one, the issue
      // is no longer the case.
      //
      if (phoneNumber.countryCallingCode && phoneNumber.countryCallingCode === getCountryCallingCode(defaultCountry, metadata) && useNationalFormatForDefaultCountryValue) {
        return parseDigits(phoneNumber.formatNational());
      }

      return value;
    }
  } else {
    return '';
  }
}
//# sourceMappingURL=usePhoneDigits.js.map
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/modules/PhoneInput.js
var PhoneInput_excluded = ["Component", "country", "defaultCountry", "useNationalFormatForDefaultCountryValue", "value", "onChange", "metadata", "international", "withCountryCallingCode"];

function PhoneInput_extends() { PhoneInput_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return PhoneInput_extends.apply(this, arguments); }

function PhoneInput_slicedToArray(arr, i) { return PhoneInput_arrayWithHoles(arr) || PhoneInput_iterableToArrayLimit(arr, i) || PhoneInput_unsupportedIterableToArray(arr, i) || PhoneInput_nonIterableRest(); }

function PhoneInput_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function PhoneInput_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return PhoneInput_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return PhoneInput_arrayLikeToArray(o, minLen); }

function PhoneInput_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function PhoneInput_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function PhoneInput_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function PhoneInput_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = PhoneInput_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function PhoneInput_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





function PhoneInput_PhoneInput(_ref, ref) {
  var Component = _ref.Component,
      country = _ref.country,
      defaultCountry = _ref.defaultCountry,
      useNationalFormatForDefaultCountryValue = _ref.useNationalFormatForDefaultCountryValue,
      value = _ref.value,
      onChange = _ref.onChange,
      metadata = _ref.metadata,
      international = _ref.international,
      withCountryCallingCode = _ref.withCountryCallingCode,
      rest = PhoneInput_objectWithoutProperties(_ref, PhoneInput_excluded);

  // "Phone digits" includes not only "digits" but also a `+` sign.
  var _usePhoneDigits = usePhoneDigits({
    value: value,
    onChange: onChange,
    country: country,
    defaultCountry: defaultCountry,
    international: international,
    withCountryCallingCode: withCountryCallingCode,
    useNationalFormatForDefaultCountryValue: useNationalFormatForDefaultCountryValue,
    metadata: metadata
  }),
      _usePhoneDigits2 = PhoneInput_slicedToArray(_usePhoneDigits, 2),
      phoneDigits = _usePhoneDigits2[0],
      setPhoneDigits = _usePhoneDigits2[1];

  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Component, PhoneInput_extends({}, rest, {
    ref: ref,
    metadata: metadata,
    international: international,
    withCountryCallingCode: withCountryCallingCode,
    country: country || defaultCountry,
    value: phoneDigits,
    onChange: setPhoneDigits
  }));
}

PhoneInput_PhoneInput = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.forwardRef(PhoneInput_PhoneInput);
PhoneInput_PhoneInput.propTypes = {
  /**
   * The phone number (in E.164 format).
   * Examples: `"+12"`, `"+12133734253"`.
   * An "empty" `value` could be represented by any "falsy" value like `undefined`, `null` or an empty string `""`.
   */
  value: prop_types_default.a.string,

  /**
   * A function of `value: string?`.
   * Updates the `value` property (to `undefined` in case it's empty).
   */
  onChange: prop_types_default.a.func.isRequired,

  /**
   * A two-letter country code for formatting `value`
   * as a national phone number (example: `(213) 373-4253`),
   * or as an international phone number without "country calling code"
   * if `international` property is passed (example: `213 373 4253`).
   * Example: "US".
   * If no `country` is passed then `value`
   * is formatted as an international phone number.
   * (example: `+1 213 373 4253`)
   */
  country: prop_types_default.a.string,

  /**
   * A two-letter country code for formatting `value`
   * when a user inputs a national phone number (example: `(213) 373-4253`).
   * The user can still input a phone number in international format.
   * Example: "US".
   * `country` and `defaultCountry` properties are mutually exclusive.
   */
  defaultCountry: prop_types_default.a.string,

  /**
   * If `country` property is passed along with `international={true}` property
   * then the phone number will be input in "international" format for that `country`
   * (without "country calling code").
   * For example, if `country="US"` property is passed to "without country select" input
   * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
   * But if both `country="US"` and `international={true}` properties are passed then
   * the phone number will be input in the "international" format for `US` (`213 373 4253`)
   * (without "country calling code" `+1`).
   */
  international: prop_types_default.a.bool,

  /**
   * If `country` and `international` properties are set,
   * then by default it won't include "country calling code" in the input field.
   * To change that, pass `withCountryCallingCode` property,
   * and it will include "country calling code" in the input field.
   */
  withCountryCallingCode: prop_types_default.a.bool,

  /**
   * A component that renders the `<input/>` itself and also
   * parses and formats its `value` as the user inputs it.
   */
  Component: prop_types_default.a.elementType.isRequired,

  /**
   * When `defaultCountry` is defined and the initial `value` corresponds to `defaultCountry`,
   * then the `value` will be formatted as a national phone number by default.
   * To format the initial `value` of `defaultCountry` as an international number instead
   * set `useNationalFormatForDefaultCountryValue` property to `true`.
   */
  useNationalFormatForDefaultCountryValue: prop_types_default.a.bool.isRequired,

  /**
   * `libphonenumber-js` metadata.
   */
  metadata: prop_types_default.a.object.isRequired
};
PhoneInput_PhoneInput.defaultProps = {
  /**
   * Set to `true` to force international phone number format
   * (without "country calling code") when `country` is specified.
   */
  // international: false,

  /**
   * Prefer national format when formatting E.164 phone number `value`
   * corresponding to `defaultCountry`.
   */
  useNationalFormatForDefaultCountryValue: true
};
/* harmony default export */ var modules_PhoneInput = (PhoneInput_PhoneInput);
//# sourceMappingURL=PhoneInput.js.map
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/modules/PhoneInputBrowser.js
var PhoneInputBrowser_excluded = ["smartCaret"];

function PhoneInputBrowser_extends() { PhoneInputBrowser_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return PhoneInputBrowser_extends.apply(this, arguments); }

function PhoneInputBrowser_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = PhoneInputBrowser_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function PhoneInputBrowser_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






function PhoneInputBrowser_createInput(defaultMetadata) {
  function PhoneInput(_ref, ref) {
    var smartCaret = _ref.smartCaret,
        rest = PhoneInputBrowser_objectWithoutProperties(_ref, PhoneInputBrowser_excluded);

    return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(modules_PhoneInput, PhoneInputBrowser_extends({}, rest, {
      ref: ref,
      Component: smartCaret ? modules_InputSmart : modules_InputBasic
    }));
  }

  PhoneInput = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.forwardRef(PhoneInput);
  PhoneInput.propTypes = {
    /**
     * HTML `<input/>` `type` attribute.
     */
    type: prop_types_default.a.string,

    /**
     * HTML `<input/>` `autocomplete` attribute.
     */
    autoComplete: prop_types_default.a.string,

    /**
     * By default, the caret position is being "intelligently" managed
     * while a user inputs a phone number.
     * This "smart" caret behavior can be turned off
     * by passing `smartCaret={false}` property.
     * This is just an "escape hatch" for any possible caret position issues.
     */
    // Is `true` by default.
    smartCaret: prop_types_default.a.bool.isRequired,

    /**
     * `libphonenumber-js` metadata.
     */
    metadata: prop_types_default.a.object.isRequired
  };
  PhoneInput.defaultProps = {
    /**
     * HTML `<input/>` `type="tel"`.
     */
    type: 'tel',

    /**
     * Remember (and autofill) the value as a phone number.
     */
    autoComplete: 'tel',

    /**
     * Set to `false` to use "basic" caret instead of the "smart" one.
     */
    smartCaret: true,

    /**
     * `libphonenumber-js` metadata.
     */
    metadata: defaultMetadata
  };
  return PhoneInput;
}
/* harmony default export */ var PhoneInputBrowser = (PhoneInputBrowser_createInput());
//# sourceMappingURL=PhoneInputBrowser.js.map
// CONCATENATED MODULE: ./node_modules/react-phone-number-input/input/index.js






function input_call(func, _arguments) {
	var args = Array.prototype.slice.call(_arguments)
	args.push(metadata_min_json)
	return func.apply(this, args)
}

/* harmony default export */ var react_phone_number_input_input = (PhoneInputBrowser_createInput(metadata_min_json));

function input_parsePhoneNumber() {
	return input_call(parsePhoneNumberFromString_parsePhoneNumberFromString, arguments)
}

function input_formatPhoneNumber() {
	return input_call(formatPhoneNumber, arguments)
}

function input_formatPhoneNumberIntl() {
	return input_call(formatPhoneNumberIntl, arguments)
}

function input_isValidPhoneNumber() {
	return input_call(isValidPhoneNumber, arguments)
}

function input_isPossiblePhoneNumber() {
	return input_call(isPossiblePhoneNumber_isPossiblePhoneNumber, arguments)
}

function input_getCountries() {
	return input_call(getCountries, arguments)
}

function input_getCountryCallingCode() {
	return input_call(getCountryCallingCode, arguments)
}

function input_isSupportedCountry() {
	return input_call(isSupportedCountry, arguments)
}
// CONCATENATED MODULE: ./src/components/mad-lib-email/mad-lib-fields.jsx
var mad_lib_fields_excluded = ["field", "form"],mad_lib_fields_excluded2 = ["onChange", "name", "value"];function mad_lib_fields_extends() {mad_lib_fields_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return mad_lib_fields_extends.apply(this, arguments);}function mad_lib_fields_objectWithoutProperties(source, excluded) {if (source == null) return {};var target = mad_lib_fields_objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function mad_lib_fields_objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}




// Note: Using FastField as these fields don't rely on each other's values.
// https://jaredpalmer.com/formik/docs/api/fastfield

/**
 * Email input field component. To be used with componentSubstitution.
 * @returns {function} A function meant to be passed to componentSubstitutions.
 */
var mad_lib_fields_emailField = function emailField(placeholder) {return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { key: "email", className: "inputField" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "errorMessage" }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(ErrorMessage, { name: "email" })), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(FastField, { className: "input", type: "email", name: "email", placeholder: placeholder })));};



/**
 * Name input field component. To be used with componentSubstitution.
 * @returns {function} A function meant to be passed to componentSubstitutions.
 */
var mad_lib_fields_nameField = function nameField(placeholder) {return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { key: "name", className: "inputField" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "errorMessage" }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(ErrorMessage, { name: "name" })), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(FastField, { className: "input", type: "text", name: "name", placeholder: placeholder })));};



/**
 * Info text area component. To be used with componentSubstitution. Use for longform text answers.
 * @returns {function} A function meant to be passed to componentSubstitutions.
 */
var mad_lib_fields_infoField = function infoField(placeholder) {return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { key: "info", className: "inputField textarea" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "errorMessage" }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(ErrorMessage, { name: "info" })), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(FastField, { className: "input", component: "textarea", name: "info", rows: "3", placeholder: placeholder })));};



/**
 * Custom Formik field. Formats phone number input as a user types
 * https://formik.org/docs/api/field#component
 */
var mad_lib_fields_CustomPhoneInput = function CustomPhoneInput(_ref) {var field = _ref.field,form = _ref.form,props = mad_lib_fields_objectWithoutProperties(_ref, mad_lib_fields_excluded);
  var
    onChange =



    field.onChange,name = field.name,value = field.value,fieldRest = mad_lib_fields_objectWithoutProperties(field, mad_lib_fields_excluded2);
  var setFieldValue = form.setFieldValue;

  var onPhoneInputChange = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useCallback"])(
  function (phoneInputValue) {return setFieldValue(name, phoneInputValue);},
  [name]);


  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(react_phone_number_input_input, mad_lib_fields_extends({
      defaultCountry: "US",
      onChange: onPhoneInputChange,
      name: name },
    fieldRest,
    props)));

};

mad_lib_fields_CustomPhoneInput.propTypes = {
  field: prop_types_default.a.object.isRequired, // eslint-disable-line
  form: prop_types_default.a.object.isRequired // eslint-disable-line
};

/**
 * Phone number input component. To be used with componentSubstitution. Use for phone numbers
 * @returns {function} A function meant to be passed to componentSubstitutions.
 */
var mad_lib_fields_phoneField = function phoneField(placeholder) {return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { key: "phone", className: "inputField" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "errorMessage" }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(ErrorMessage, { name: "phone" })), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(FastField, { className: "input", component: mad_lib_fields_CustomPhoneInput, name: "phone", placeholder: placeholder })));};
// CONCATENATED MODULE: ./src/components/contentful-views/image.jsx
function image_typeof(obj) {"@babel/helpers - typeof";return image_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, image_typeof(obj);}function image_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function image_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? image_ownKeys(Object(source), !0).forEach(function (key) {image_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : image_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function image_defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function image_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function image_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function image_createClass(Constructor, protoProps, staticProps) {if (protoProps) image_defineProperties(Constructor.prototype, protoProps);if (staticProps) image_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function image_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) image_setPrototypeOf(subClass, superClass);}function image_setPrototypeOf(o, p) {image_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return image_setPrototypeOf(o, p);}function image_createSuper(Derived) {var hasNativeReflectConstruct = image_isNativeReflectConstruct();return function _createSuperInternal() {var Super = image_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = image_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return image_possibleConstructorReturn(this, result);};}function image_possibleConstructorReturn(self, call) {if (call && (image_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return image_assertThisInitialized(self);}function image_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function image_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function image_getPrototypeOf(o) {image_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return image_getPrototypeOf(o);}





/**
 * Render an image media type from Contentful.
 *
 * If passed `lazy` will render it as lazy loaded. See ../lazy-image for more info
 *
 * It utilizes the Contentful Image API to retrieve a low quality placeholder image.
 * This prevents content from jumping around when users scroll and images have not yet loaded.
 * The low quality image also is Server Side Rendered.
 */
// eslint-disable-next-line react/prefer-stateless-function
var image_Image = /*#__PURE__*/function (_React$PureComponent) {image_inherits(Image, _React$PureComponent);var _super = image_createSuper(Image);function Image() {image_classCallCheck(this, Image);return _super.apply(this, arguments);}image_createClass(Image, [{ key: "render", value:
    function render() {
      var _this$props =






        this.props,className = _this$props.className,height = _this$props.height,lazy = _this$props.lazy,lazyLoadProps = _this$props.lazyLoadProps,media = _this$props.media,width = _this$props.width;

      var queryPropsMap = {};
      if (width) {
        queryPropsMap.w = width;
      }
      if (height) {
        queryPropsMap.h = height;
      }
      var queryProps = lodash_default()(queryPropsMap).toPairs().map(function (pair) {return "".concat(pair[0], "=").concat(pair[1]);}).join('&');

      var src = lodash_default.a.get(media, 'fields.file.url');
      var alt = lodash_default.a.get(media, 'fields.title');

      // format is jpg for all browser support and quality manipulation
      var lowQualitySrc = "".concat(src, "?fm=jpg&q=1&").concat(queryProps);
      var highQualitySrc = "".concat(src, "?").concat(queryProps);
      var placeholder = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_placeholder_image, { className: className, src: lowQualitySrc, alt: alt });

      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(lazy_image, {
          alt: alt,
          className: className,
          lazy: lazy,
          lazyLoadProps: lazyLoadProps,
          placeholder: placeholder,
          src: highQualitySrc }));

    } }]);return Image;}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.PureComponent);


var imagePropTypes = {
  className: prop_types_default.a.string,
  height: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
  lazy: prop_types_default.a.bool,
  media: prop_types_default.a.shape({
    fields: prop_types_default.a.shape({}),
    sys: prop_types_default.a.shape({})
  }),
  // see ../LazyImage for prop options
  lazyLoadProps: prop_types_default.a.shape(image_objectSpread({}, lazyLoadPropType)),
  width: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
};

var imageDefaultProps = {
  className: '',
  height: null,
  lazy: true,
  media: {},
  // lazy load props
  lazyLoadProps: lazyLoadDefaultProp,
  width: null
};

image_Image.propTypes = imagePropTypes;
image_Image.defaultProps = imageDefaultProps;

/* harmony default export */ var contentful_views_image = (image_Image);
// CONCATENATED MODULE: ./src/components/mad-lib-email/mad-lib-cards/card-checkbox.jsx
/* eslint-disable jsx-a11y/label-has-for */





/**
 * This component is visually similar to a media card, but is a checkbox field.
 * We use the checkbox for storing the value, but hide it visually.
 * We use a <span className='card-checkbox/> to have a custom checkbox implementation.
 * @param {Object} props
 * @param {String} props.name Field name. Used by formik to recognize a field
 * @param {String} props.image Contentful Image media object
 * @param {String} props.label Label for the checkbox / title for the card
 */
function CardCheckbox(_ref) {var name = _ref.name,image = _ref.image,label = _ref.label;
  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "CardCheckbox" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("label", { htmlFor: name }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Field, { id: name, name: name, component: "input", type: "checkbox" }), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "card-content" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(contentful_views_image, { media: image }), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "card-background" }), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "card-label" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "card-checkbox" }),
    label)))));





}

CardCheckbox.propTypes = {
  name: prop_types_default.a.string.isRequired,
  image: prop_types_default.a.shape({}),
  label: prop_types_default.a.node
};

CardCheckbox.defaultProps = {
  image: {},
  label: null
};
// CONCATENATED MODULE: ./src/components/mad-lib-email/mad-lib-cards/card-text-input.jsx
function card_text_input_slicedToArray(arr, i) {return card_text_input_arrayWithHoles(arr) || card_text_input_iterableToArrayLimit(arr, i) || card_text_input_unsupportedIterableToArray(arr, i) || card_text_input_nonIterableRest();}function card_text_input_nonIterableRest() {throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function card_text_input_unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return card_text_input_arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return card_text_input_arrayLikeToArray(o, minLen);}function card_text_input_arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}function card_text_input_iterableToArrayLimit(arr, i) {var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];if (_i == null) return;var _arr = [];var _n = true;var _d = false;var _s, _e;try {for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"] != null) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}function card_text_input_arrayWithHoles(arr) {if (Array.isArray(arr)) return arr;} /* eslint-disable jsx-a11y/label-has-for */






/**
 * A one-off that is similar to the checkbox, but has a text input field.
 * We 'connect()` this component to Formik to allow us to determine if the
 * inner field has a value in it. This allows us to style the input's
 * containing elements.
 * @param {Object} props
 * @param {Object} props.formik Passed the formik values for this form.
 * @param {function} props.handleClick Click callback to provide focus
 */
function UnconnectedCardTextInput(_ref)


{var formik = _ref.formik,placeholder = _ref.placeholder;
  var textInputName = 'segmentOther';

  var _useState = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useState"])(false),_useState2 = card_text_input_slicedToArray(_useState, 2),hasFocus = _useState2[0],setHasFocus = _useState2[1];
  var value = lodash_default.a.get(formik.values, textInputName);
  var checked = lodash_default.a.get(value, 'length') > 0;

  var contentWrapperClasName = classnames_default()('card-content', {
    focus: hasFocus,
    // uses same style as normal checkbox implementation. In this case 'checked' means
    // the input has a value
    checked: checked
  });

  var segmentInputClassName = classnames_default()('segment-input', {
    checked: checked
  });

  // Allows us to setFocus on the text field when the outer card is clicked
  var textInputRef = external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.useRef(null);
  function handleClick() {
    setHasFocus(true);
    textInputRef.current.focus();
  }

  function setHasFocusTrue() {
    setHasFocus(true);
  }

  function setHasFocusFalse() {
    setHasFocus(false);
  }

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "CardCheckbox textInput" }, /*#__PURE__*/







    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: contentWrapperClasName, onClick: handleClick }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "card-background" }), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "card-sizing-helper" }), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Field, {
      className: segmentInputClassName,
      component: "textarea",
      type: "text",
      name: textInputName,
      placeholder: placeholder,
      innerRef: textInputRef,
      onFocus: setHasFocusTrue,
      onBlur: setHasFocusFalse }))));





}

UnconnectedCardTextInput.propTypes = {
  placeholder: prop_types_default.a.string.isRequired,
  formik: prop_types_default.a.shape({
    values: prop_types_default.a.shape({})
  }).isRequired
};

/* harmony default export */ var card_text_input = (connect(UnconnectedCardTextInput));
// EXTERNAL MODULE: ./src/components/mad-lib-email/mad-lib-cards/mad-lib-cards.less
var mad_lib_cards = __webpack_require__(172);

// CONCATENATED MODULE: ./src/components/mad-lib-email/mad-lib-cards/mad-lib-cards.jsx










/**
 * A form screen for MadLib. This is the default export.
 * @param {Array} segmentationCards Array of objects representing options for segments.
 */
function MadLibCards(_ref) {var inDialog = _ref.inDialog,segmentationCards = _ref.segmentationCards;
  var options = lodash_default.a.map(segmentationCards, function (_ref2) {var image = _ref2.image,label = _ref2.title;return /*#__PURE__*/ (
      // by setting the name to `segment.label`, it sets the name as a value on the segment object
      // in the formik form state.
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(CardCheckbox, { key: label, image: image, label: label, name: "segment.".concat(lodash_default.a.kebabCase(label)) }));});


  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { key: "segmentation", className: classnames_default()('MadLibCards inputField', { inDialog: inDialog }) }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "errorMessage" }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(ErrorMessage, { name: "email" })), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "card-checkbox-grid" },
    options, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(card_text_input, { placeholder: "Make a suggestion..." }))));



}

MadLibCards.propTypes = {
  inDialog: prop_types_default.a.bool,
  segmentationCards: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    image: prop_types_default.a.shape({}), // contentful media object
    title: prop_types_default.a.string
  }))
};

MadLibCards.defaultProps = {
  inDialog: false,
  segmentationCards: []
};
// EXTERNAL MODULE: ./src/components/radio.less
var components_radio = __webpack_require__(173);

// CONCATENATED MODULE: ./src/components/radio.jsx
function radio_extends() {radio_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return radio_extends.apply(this, arguments);}function radio_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function radio_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? radio_ownKeys(Object(source), !0).forEach(function (key) {radio_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : radio_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function radio_defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}
 // eslint-disable-line




/*
  The Radio buttons require you to use Redux-From
*/

/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */
// See: https://github.com/evcohen/eslint-plugin-jsx-a11y/issues/51
var radio_Radio = function Radio(props) {
  var input = radio_objectSpread(radio_objectSpread({}, props.input), {}, { disabled: props.disabled });
  var classes = classnames_default()('Radio', input.name, props.className, {
    disabled: input.disabled
  });
  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: classes }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("label", null, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("input", radio_extends({
      type: "radio" },
    input)), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "circle" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "selected" })),

    props.label)));



};

radio_Radio.propTypes = {
  label: prop_types_default.a.node,
  input: prop_types_default.a.object, // eslint-disable-line
  className: prop_types_default.a.string,
  disabled: prop_types_default.a.bool
};

radio_Radio.defaultProps = {
  label: '',
  className: '',
  disabled: false
};

/* harmony default export */ var src_components_radio = (radio_Radio);
// EXTERNAL MODULE: ./src/components/mad-lib-email/mad-lib-radio-buttons.less
var mad_lib_radio_buttons = __webpack_require__(174);

// CONCATENATED MODULE: ./src/components/mad-lib-email/mad-lib-radio-buttons.jsx
function mad_lib_radio_buttons_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function mad_lib_radio_buttons_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? mad_lib_radio_buttons_ownKeys(Object(source), !0).forEach(function (key) {mad_lib_radio_buttons_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : mad_lib_radio_buttons_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function mad_lib_radio_buttons_defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;} // @ts-check









/**
 * @typedef {object} RadioOption
 * @property {string} label
 * @property {string} value
 */

/**
 * @typedef {object} FormikApi
 * @property {object} values
 */

/**
 * Formik API passed to component by `connect` -
 * https://jaredpalmer.com/formik/docs/1.4.4/api/connect
 */
var formikPropType = prop_types_default.a.shape({
  values: prop_types_default.a.object
});

/**
 * Similar to a select menu interface, but renders buttons
 */
var optionPropType = prop_types_default.a.shape({
  label: prop_types_default.a.string.isRequired,
  value: prop_types_default.a.string.isRequired
});

// UI strings and constants
var otherOptionValue = 'other';
var otherOptionFieldNameSuffix = '_other';
var otherLabel = '**Other** - ';
var otherPlaceholder = 'Make a suggestion...';
var optionIsRequiredError = 'Select an option.';
var fieldIsRequiredError = 'This field is required.';

/**
 * Return a Formik validate function for the provided field name.
 * @param {string} name
 */
var getRadioButtonsValidator = function getRadioButtonsValidator(name) {return (
    /**
   * Ensures that the user has selected a value for the radio buttons form type.
   * @param {object} formValues
   * @param {string} name Radio button field name
   */
    function (formValues) {
      var errors = {};

      if (formValues) {
        var otherFieldInputName = "".concat(name).concat(otherOptionFieldNameSuffix);
        var value = formValues[name];
        var otherFieldInputValue = formValues[otherFieldInputName];

        if (!value) {
          errors[name] = optionIsRequiredError;
        } else if (value === otherOptionValue && !otherFieldInputValue) {
          errors[otherFieldInputName] = fieldIsRequiredError;
        }
      }

      return errors;
    });};


/**
 * Get initial form values. Initial values are required for Formik validation to
 * work as expected.
 * @param {string} name
 */
var getRadioButtonsInitialValues = function getRadioButtonsInitialValues(name) {var _ref;return _ref = {}, mad_lib_radio_buttons_defineProperty(_ref,
  name, ''), mad_lib_radio_buttons_defineProperty(_ref, "".concat(
  name).concat(otherOptionFieldNameSuffix), ''), _ref;};


/**
 * Single radio button
 * @param {object} props
 * @param {FormikApi} [props.formik]
 * @param {string} [props.name] Input name, same for all radio buttons in the
 * group
 * @param {RadioOption} [props.option] Contains label for the radio, which can be
 * markdown, and the value to use on the <input />
 * @param {React.ReactNode} [props.children] Optional children to be rendered next to
 * the label, used to render the freeform answer input
 */
var mad_lib_radio_buttons_MadLibRadioButton = function MadLibRadioButton(_ref2)




{var formik = _ref2.formik,name = _ref2.name,option = _ref2.option,children = _ref2.children;
  var id = "".concat(name, "-").concat(option.value);
  var checked = formik.values[name] === option.value;
  var inputProp = {
    name: name,
    value: option.value,
    checked: checked
  };
  var labelMarkdown = /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Fragment, null, /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, { source: option.label }),
  children);



  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Field, {
      key: id,
      name: name,
      type: "radio"
      // eslint-disable-next-line react/jsx-no-bind
      , render: function render(_ref3) {var field = _ref3.field;return /*#__PURE__*/(
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_radio, {
            className: classnames_default()('madLibRadioButton', { selected: checked }),
            label: labelMarkdown,
            input: mad_lib_radio_buttons_objectSpread(mad_lib_radio_buttons_objectSpread({}, field), inputProp) }));} }));


};

mad_lib_radio_buttons_MadLibRadioButton.propTypes = {
  formik: formikPropType,
  name: prop_types_default.a.string,
  option: optionPropType,
  children: prop_types_default.a.element
};

mad_lib_radio_buttons_MadLibRadioButton.defaultProps = {
  formik: { values: {} },
  name: '',
  option: { label: '', value: '' },
  children: null
};

/**
 * Freeform text input that appears next to the `other` option
 * @param {object} props
 * @param {FormikApi} [props.formik]
 * @param {string} [props.name]
 * @param {string} [props.placeholder]
 */
var mad_lib_radio_buttons_MadLibRadioButtonOtherInput = function MadLibRadioButtonOtherInput(_ref4) {var formik = _ref4.formik,name = _ref4.name,placeholder = _ref4.placeholder;
  var otherChecked = formik.values[name] === otherOptionValue;
  var fieldName = "".concat(name).concat(otherOptionFieldNameSuffix);
  var otherInputValue = formik.values[fieldName];
  var componentRef = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useRef"])(null);

  // Focus input when radio is selected
  Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useEffect"])(function () {
    if (!otherChecked) return;
    var inputElement = componentRef.current.querySelector('input');
    if (!inputElement) return;
    inputElement.select();
  }, [otherChecked]);

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { key: "name", className: "otherInput", ref: componentRef },
    otherChecked ? /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Field, {
      className: "input",
      type: "text",
      name: fieldName,
      placeholder: placeholder,
      disabled: !otherChecked }) : /*#__PURE__*/

    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "otherInputPlaceholder" },
    otherInputValue || placeholder), /*#__PURE__*/


    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "errorMessage" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(ErrorMessage, { name: fieldName }))));



};

mad_lib_radio_buttons_MadLibRadioButtonOtherInput.propTypes = {
  formik: formikPropType,
  name: prop_types_default.a.string,
  placeholder: prop_types_default.a.string
};

mad_lib_radio_buttons_MadLibRadioButtonOtherInput.defaultProps = {
  formik: { values: {} },
  name: '',
  placeholder: ''
};

/**
 * List of radio buttons with an additional freeform `other` option added at the end.
 * @param {object} props
 * @param {FormikApi} [props.formik]
 * @param {string} [props.name] Name of the form value that will be populated by radio selection
 * @param {boolean} [props.includeOtherOption] If true, include an "Other" option with a freeform
 * input
 * @param {RadioOption[]} [props.options] List of radio button options with labels and values
 */
var mad_lib_radio_buttons_MadLibRadioButtons = function MadLibRadioButtons(_ref5) {var
    formik = _ref5.formik,
    name = _ref5.name,
    includeOtherOption = _ref5.includeOtherOption,
    options = _ref5.options;return /*#__PURE__*/(

    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "MadLibRadioButtons" },
    options.map(function (option) {return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(mad_lib_radio_buttons_MadLibRadioButton, {
          key: "".concat(name, "-").concat(option.value),
          formik: formik,
          name: name,
          option: option }));}),

    includeOtherOption ? /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(mad_lib_radio_buttons_MadLibRadioButton, {
      formik: formik,
      name: name,
      option: { value: otherOptionValue, label: otherLabel } }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(mad_lib_radio_buttons_MadLibRadioButtonOtherInput, {
      formik: formik,
      name: name,
      placeholder: otherPlaceholder })) :

    null, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "errorMessage" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(ErrorMessage, { name: name }))));};




mad_lib_radio_buttons_MadLibRadioButtons.propTypes = {
  formik: formikPropType,
  name: prop_types_default.a.string,
  includeOtherOption: prop_types_default.a.bool,
  options: prop_types_default.a.arrayOf(optionPropType)
};

mad_lib_radio_buttons_MadLibRadioButtons.defaultProps = {
  formik: { values: {} },
  name: '',
  includeOtherOption: true,
  options: []
};

/* harmony default export */ var mad_lib_email_mad_lib_radio_buttons = (connect(mad_lib_radio_buttons_MadLibRadioButtons));
// CONCATENATED MODULE: ./src/components/contentful-views/button-link.jsx
/**
 * Deprecated.
 * Moved to `components/button-link`.
 * Contentful accessors in `widgets/button-link`
 */


// EXTERNAL MODULE: ./src/components/contentful-views/media-object.less
var media_object = __webpack_require__(175);

// CONCATENATED MODULE: ./src/components/contentful-views/media-object.jsx






var mediaObjectPropTypes = {
  file: prop_types_default.a.shape({
    url: prop_types_default.a.string
  }).isRequired,
  title: prop_types_default.a.string,
  description: prop_types_default.a.string
};

var media_object_MediaObject = function MediaObject(props) {return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "MediaObject" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("img", {
      className: "mediaObjectImage",
      src: "".concat(lodash_default.a.get(props.file, 'url'), "?w=800"),
      alt: props.title }), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "caption" }, props.description)));};



media_object_MediaObject.propTypes = mediaObjectPropTypes;

media_object_MediaObject.defaultProps = {
  title: null,
  description: null
};

/* harmony default export */ var contentful_views_media_object = (media_object_MediaObject);
// CONCATENATED MODULE: ./src/models/page-metadata.js




/**
 * The Model for a contentful Page Metadata.
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/page/fields
 */
var contentfulMetadataPropType = {
  fields: prop_types_default.a.shape({
    pageTitle: prop_types_default.a.string,
    shareTitle: prop_types_default.a.string,
    description: prop_types_default.a.string,
    primaryImage: prop_types_default.a.object,
    openGraphType: prop_types_default.a.string,
    twitterCard: prop_types_default.a.string,
    twitterSite: prop_types_default.a.string,
    additionalMetadata: prop_types_default.a.array,
    jsonLd: prop_types_default.a.object
  })
};

/**
 * Glowforge-internal representation of Page Metadata. This may be obtained by
 * passing a `contentfulMetadataPropType` shape into `interpretMetadataFields`.
 */
var interpretedMetadataPropType = {
  pageTitle: prop_types_default.a.string,
  shareTitle: prop_types_default.a.string,
  description: prop_types_default.a.string,
  primaryImage: prop_types_default.a.shape({
    url: prop_types_default.a.string,
    width: prop_types_default.a.number,
    height: prop_types_default.a.number
  }),
  openGraphType: prop_types_default.a.string,
  twitterCard: prop_types_default.a.string,
  twitterSite: prop_types_default.a.string,
  additionalMetadata: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    name: prop_types_default.a.string,
    property: prop_types_default.a.string,
    content: prop_types_default.a.string,
    httpEquiv: prop_types_default.a.string
  })),
  pageTitleText: prop_types_default.a.string, // Deprecated metadata from parent Page object
  metaDescription: prop_types_default.a.string, // Deprecated metadata from parent Page object
  jsonLd: prop_types_default.a.object
};

/**
 * Helpers for retrieving content from an object that adheres to the 'pageMetadataPropType' model.
 */

var ensureProtocol = function ensureProtocol(url) {return url && url.match(/^\/\/\w/) ? "https:".concat(url) : url;};

var page_metadata_getImageUrl = function getImageUrl() {var image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};return ensureProtocol(lodash_default.a.get(image, ['fields', 'file', 'url']));};

var page_metadata_getImageWidth = function getImageWidth() {var image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};return (
    lodash_default.a.get(image, ['fields', 'file', 'details', 'image', 'width']));};


var page_metadata_getImageHeight = function getImageHeight() {var image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};return (
    lodash_default.a.get(image, ['fields', 'file', 'details', 'image', 'height']));};


var page_metadata_getAdditionalMetadata = function getAdditionalMetadata() {var metadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};return (
    lodash_default.a.map(metadata.additionalMetadata, function (rawMetadata) {return lodash_default.a.get(rawMetadata, 'fields');}));};


var page_metadata_interpretImage = function interpretImage(contentfulImage) {return (
    lodash_default.a.pickBy({
      url: page_metadata_getImageUrl(contentfulImage),
      width: page_metadata_getImageWidth(contentfulImage),
      height: page_metadata_getImageHeight(contentfulImage)
    }, function (value) {return !!value;}));};


/**
 * Interprets Page Metadata model from Contentful into a more usable internal
 * representation (modeled as `interpretedMetadataPropType`.
 *
 * @param contentfulMetadataFields - a contentfulMetadataPropType shape
 * @returns {interpretedMetadataPropType shape}
 */
var page_metadata_interpretMetadata = function interpretMetadata() {var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},_ref$fields = _ref.fields,fields = _ref$fields === void 0 ? {} : _ref$fields;var macros = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};return (
    lodash_default.a.pickBy({
      pageTitle: stringSubstitution(fields.pageTitle, macros),
      shareTitle: stringSubstitution(fields.shareTitle, macros),
      description: stringSubstitution(fields.description, macros),
      primaryImage: page_metadata_interpretImage(fields.primaryImage),
      twitterCard: fields.twitterCard,
      twitterSite: fields.twitterSite,
      additionalMetadata: page_metadata_getAdditionalMetadata(fields),
      jsonLd: fields.jsonLd
    }, function (value) {return !!value;}));};
// CONCATENATED MODULE: ./src/models/page.js




/**
 * TODO: https://glowforge.atlassian.net/browse/STORE-2854 Wrangle Contentful Terminology
 *  - Merge naming for ContentFields and Sections, they both refer to a list of
 *    Contentful Entries, or, Widgets.
 *  - Consider making a class like models/widget.js
 */

/**
 * The Model for a contentful Page.
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/page/fields
 */
var pagePropType = {
  id: prop_types_default.a.string,
  internalName: prop_types_default.a.string,
  metaDescription: prop_types_default.a.string,
  pageTitleText: prop_types_default.a.string, // Deprecated, use pageMetadata instead.
  pageType: prop_types_default.a.string,
  previewText: prop_types_default.a.string,
  sections: prop_types_default.a.arrayOf(prop_types_default.a.object),
  slug: prop_types_default.a.string,
  title: prop_types_default.a.string,
  unorderedShortText: prop_types_default.a.arrayOf(prop_types_default.a.object),
  pageMetadata: prop_types_default.a.shape(contentfulMetadataPropType)
};

var pageStringsPropType = prop_types_default.a.objectOf(prop_types_default.a.string);

/**
 * Helpers for retrieving content from an object that adheres to the 'pagePropType' model.
 */

var page_getContentType = function getContentType(object) {return lodash_default.a.get(object, 'sys.contentType.sys.id');};

/**
 * Gets text strings for a page.  basicTextString is non-markdown text.
 * @param {Object} page See pagePropType
 */
var page_getStringsForPage = function getStringsForPage() {var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};return (
    lodash_default.a.reduce(page.unorderedShortText, function (all, string) {
      if (page_getContentType(string) === 'basicTextString') {
        // eslint-disable-next-line no-param-reassign
        all[lodash_default.a.get(string.fields, 'id')] = lodash_default.a.get(string.fields, 'text');
      }
      return all;
    }, {}));};


/**
 * Gets markdown text strings for a page.  textString is markdown text.
 * @param {Object} page See pagePropType
 */
var page_getMarkdownStringsForPage = function getMarkdownStringsForPage() {var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};return (
    lodash_default.a.reduce(page.unorderedShortText, function (all, string) {
      if (page_getContentType(string) === 'textString') {
        // eslint-disable-next-line no-param-reassign
        all[lodash_default.a.get(string.fields, 'id')] = lodash_default.a.get(string.fields, 'text');
      }
      return all;
    }, {}));};


/**
 * Load a specific section from a page.
 * We require type because IDs are only unique to a type
 * @param {Object} page See pagePropType
 * @param {String} id
 * @param {String} type
 */
var page_getSectionForPageByIdAndType = function getSectionForPageByIdAndType(page, id, type) {return (
    lodash_default.a.get(lodash_default.a.find(page.sections, {
      fields: { id: id },
      sys: {
        contentType: {
          sys: {
            id: type
          }
        }
      }
    }), 'fields'));};


/**
 * From a list of widgets/content, filter by type. This returns an object with
 * 'fields' and 'sys' properties. Useful for mapping content to widgets with
 * 'getWidget(obj)' (See ui-common/components/contentful-views/sections.jsx)
 * @param {Array} contentList Array of Widgets/Content, a Contentful list
 * @param {String} type The type of the content model to retrieve from Contentful
 */
var page_getContentByType = function getContentByType(contentList, type) {return (
    // eslint-disable-next-line implicit-arrow-linebreak
    lodash_default.a.filter(contentList, { sys: { contentType: { sys: { id: type } } } }));};

/**
 * This does the same thing as getContentByType, but for a Page
 * @param {Object} page A mixture of Contentful Data and React props.
 * @param {String} type The type of the content model to retrieve from Contentful
 */
var getSectionsForPageByType = function getSectionsForPageByType(page, type) {return page_getContentByType(page.sections, type);};

/**
 * From a list of widgets/content, filter by type and extract the 'fields' property.
 * @param {Array} contentList Array of Widgets/Content, a Contentful list
 * @param {String} type The type of the content model to retrieve from Contentful
 */
var page_getContentFieldsByType = function getContentFieldsByType(contentList, type) {return lodash_default.a.map(page_getContentByType(contentList, type), 'fields');};
// CONCATENATED MODULE: ./src/models/widget.js
function widget_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function widget_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function widget_createClass(Constructor, protoProps, staticProps) {if (protoProps) widget_defineProperties(Constructor.prototype, protoProps);if (staticProps) widget_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;} /**
 * Widget model defines access to our Contentful Custom Widget model
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/customWidget/fields
 *
 * If you need to access the raw data on a custom widget section add a method here
 */




/**
 * Get all text strings as an object by their dev ids
 * @param  {Object} widget Custom Widget Contentful object
 * @return {Object of strings} only the strings from the contentful object
 */
var widget_getStringsForWidget = function getStringsForWidget() {var widget = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};return lodash_default.a.reduce(widget.textStrings, function (all, string) {
    if (page_getContentType(string) === 'basicTextString') {
      all[lodash_default.a.get(string.fields, 'id')] = lodash_default.a.get(string.fields, 'text'); // eslint-disable-line no-param-reassign
    }
    return all;
  }, {});};

/**
 * Get all markdown strings object by their dev ids
 * @param  {Object} widget Custom Widget Contentful object
 * @return {Object of strings} only the markdown sections from the contentful object
 */
var widget_getMarkdownStringsForWidget = function getMarkdownStringsForWidget() {var widget = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};return (
    lodash_default.a.reduce(widget.textStrings, function (all, string) {
      if (page_getContentType(string) === 'textString') {
        all[lodash_default.a.get(string.fields, 'id')] = lodash_default.a.get(string.fields, 'text'); // eslint-disable-line no-param-reassign
      }
      return all;
    }, {}));};


/**
 * Get all images strings object by their internal content id
 * @param  {Object} widget Custom Widget Contentful object
 * @return {Object{
 *    src: url
 *    alt: decription of the image
 *    title: title of the image
 * }} all images from the contentful object
 */
var widget_getImagesForWidget = function getImagesForWidget() {var widget = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};return lodash_default.a.reduce(widget.images, function (all, image) {
    // eslint-disable-next-line no-param-reassign
    all[lodash_default.a.get(image, 'sys.id')] = {
      src: lodash_default.a.get(image, 'fields.file.url'),
      alt: lodash_default.a.get(image, 'fields.description'),
      title: lodash_default.a.get(image, 'fields.title')
    };
    return all;
  }, {});};

var widgetPropType = {
  textStrings: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    fields: prop_types_default.a.shape({
      id: prop_types_default.a.string,
      text: prop_types_default.a.string
    })
  })),
  sections: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    fields: prop_types_default.a.shape({
      title: prop_types_default.a.string,
      text: prop_types_default.a.string
    })
  }))
};

var widgetDefaultProps = {
  textStrings: [],
  sections: []
};

/**
 * Widget model to make working with raw widget data simpleStrings
 *
 * Wrap any raw widget data in this before sharing it around so we
 * are not tempted to access it directly
 */
var WidgetModel = /*#__PURE__*/function () {
  /**
   * @param {object} widgetData  Custom Widget Contentful object
   */
  function WidgetModel(widgetData) {widget_classCallCheck(this, WidgetModel);
    this.widgetData = widgetData;
  }

  /**
   * @return  {Object of strings} only the strings from the contentful object
   */widget_createClass(WidgetModel, [{ key: "textStrings", get:
    function get() {
      if (!this.textStringsInternal) {
        this.textStringsInternal = widget_getStringsForWidget(this.widgetData.fields);
      }

      return this.textStringsInternal;
    }

    /**
     * @return {Object of strings} only the markdown sections from the contentful object
     */ }, { key: "markdownStrings", get:
    function get() {
      if (!this.markdownStringsInternal) {
        this.markdownStringsInternal = widget_getMarkdownStringsForWidget(this.widgetData.fields);
      }

      return this.markdownStringsInternal;
    }

    /**
     * @return {Object{
     *    src: url
     *    alt: decription of the image
     *    title: title of the image
     * }} all images from the contentful object
     */ }, { key: "images", get:
    function get() {
      if (!this.imagesInternal) {
        this.imagesInternal = widget_getImagesForWidget(this.widgetData.fields);
      }

      return this.imagesInternal;
    } }]);return WidgetModel;}();
// CONCATENATED MODULE: ./src/components/common-prop-types.js


var stringSubstitutionsPropType = prop_types_default.a.oneOfType([
prop_types_default.a.arrayOf(prop_types_default.a.object),
prop_types_default.a.object]);


var customWidgetsPropType = prop_types_default.a.shape({
  component: prop_types_default.a.element,
  props: prop_types_default.a.object
});

/* harmony default export */ var common_prop_types = ({
  stringSubstitutions: stringSubstitutionsPropType
});
// EXTERNAL MODULE: ./src/components/contentful-views/sections.less
var contentful_views_sections = __webpack_require__(176);

// CONCATENATED MODULE: ./src/components/contentful-views/sections.jsx
function sections_extends() {sections_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return sections_extends.apply(this, arguments);} /* eslint-disable import/no-cycle */
/*
  Disabling no-cycle for this file because the getWidget and getSectionsArray functions are used by
  widgets that are imported by this file.  This is a module cycle, but not an issue because the
  dependency cycle is not synchronous. The dependencies are used at runtime not at build/file parse
  time.
  https://railsware.com/blog/how-to-analyze-circular-dependencies-in-es6/
*/












/**
 * TODO: STORE-2847 Dynamic imports for widgets so we can codesplit.
 *
 * Sections is used to render an ordered piece of UI. It maps an array of objects with widget types
 * to widgets. These widgets then extract Contentful data and map it to a React Component. This
 * provides a layer of separation between the UI and Contentful. Widgets are a form of controller,
 * mapping a model to a view.
 *
 * Terminology:
 *  - component
 *    - React Component. Used for rendering UI, no knowledge of Contentful.
 *  - widget
 *    - Has knowledge of Contentful Content Models. Maps a Contentful
 *      Content Model to a piece of UI. Can contain sections and other widgets.
 *    - Is a Higher Order Component for providing components with props.
 *  - sections
 *    - An array of widgets.
 *  - custom widget
 *    - A special Contentful Content Model type, can contain unstructured content made up of text,
 *      images, and other widgets. Used for one-off pieces of UI.
 *      See ecomm-front-end/app/components/company/jobs-home.jsx for an example.
 *
 * Adding components:
 *  - In ui-common/components/, Create a simple component (no Contentful knowledge) that takes in
 *    props and renders UI.
 *  - If the component has a corresponding Content Model or needs data from Contentful, create a
 *    widget in ui-common/widgets/
 *    - Add the component to the widgets map below.
 *  - If the component is a Custom Widget:
 *      Pass a customWidgets object/map to <Sections customWidgets={{...}} />
 *
 *      The customWidgets object should look like:
 *        customWidgets = {
 *         'widgetId-key-from-contentful': {
 *           component: CustomWidget,
 *           props, // props to be passed.
 *          },
 *        };
 *
 *      Where the keys are Widget Ids from Contentful.
 *
 */

/**
 * Mapping of widget types to Widgets.
 * Is populated via Widgets registering themselves with the registerWidget function
 */
var widgets = {};

/**
 * This factory allows us to avoid a circular dependency and widgets not being available soon
 * enough. Register your widget like: `registerWidget('contentType', WidgetComponent)`
 * @param {String} contentType The content type in Contentful. Used as a key in the widgets map.
 * @param {Component} Widget React component / contentful widget for the content type.
 */
function registerWidget(contentType, Widget) {
  widgets[contentType] = Widget;
}

/**
 * getWidget retrieves a widget for a given Contentful model.
 * @param {Object} model Contentful model for the widget
 * @param {*} customWidgets Mappings for any Custom Widgets
 * @param {*} stringSubstitutions See ui-common/components/contentful-views/util.js
 */
var sections_getWidget = function getWidget(model, customWidgets, stringSubstitutions) {
  var type = page_getContentType(model);
  var key = lodash_default.a.get(model, 'sys.id');
  var id = lodash_default.a.get(model, 'fields.id');
  var Widget = widgets[type];
  if (!Widget) {
    // if widget doesn't exist, you might have forgotten to register it.
    // see `registerWidget` above.
    console.warn("ui-common: widget ".concat(type, " not registered."));
    return null;
  }
  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Widget, {
      id: id,
      key: key,
      model: model,
      customWidgets: customWidgets,
      stringSubstitutions: stringSubstitutions }));

};

/* Classes styled in content-page.less */
var ALLOWED_BACKGROUND_CLASSES = [
'greyFullWidth',
'blueFullWidth',
'darkBlueFullWidth',
'blackBackground',
'contentWide',
'contentFull',
'noMarginTop',
'noMarginBottom',
'hiddenSection',
'hiddenDesktop',
'hiddenMobile'];


/**
 * getSectionsArray is used to map data to widgets in an ordered array. There are normal widgets
 * that appear in the widgets mapping at the top of this file, and custom widgets that are provided
 * by the consumer of this function.
 *
 * @param {Array}   sections Array of contentful data.
 * @param {Object}  [customWidgets] Object used to map custom widget data to widgets/components.
 * @param {Object|Array} [stringSubstitutions] Map of strings used to substitute in string templates
 * @returns {Component}
 */
var sections_getSectionsArray = function getSectionsArray(
sections,
customWidgets,
stringSubstitutions) {var
  switchFunction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : lodash_default.a.stubFalse;return (

    lodash_default.a.map(sections, function (section, key) {
      var widgetId = lodash_default.a.get(section, 'fields.id');
      var type = page_getContentType(section);
      var widget;
      switch (type) {
        // These components have been moved to the widget model.
        case 'heroBanner':
        case 'wistiaButton':
        case 'list':
        case 'socialCard':
        case 'madLibForm':
        case 'madLibFlow':{
            widget = sections_getWidget(section, customWidgets, stringSubstitutions);
            break;
          }
        /**
         * TODO: https://glowforge.atlassian.net/browse/STORE-2854
         * - These components need to be moved to the widget model
         * - Define a Section widget to provide a container for components.
         *    - We should not have special cases per component
         */
        case 'buttonLink':{
            widget = sections_getWidget(section, customWidgets, stringSubstitutions);
            widget = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "buttonLink", key: key }, widget);
            break;
          }
        case 'textString':
          widget = /*#__PURE__*/
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, {
            key: key,
            className: "paragraph ".concat(lodash_default.a.get(section, 'fields.id')),
            source: stringSubstitution(lodash_default.a.get(section, 'fields.text'), stringSubstitutions) });

          break;
        case 'mediaObject':
          widget = /*#__PURE__*/
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(contentful_views_media_object, sections_extends({
            key: key,
            className: lodash_default.a.get(section, 'fields.id') },
          lodash_default.a.get(section, 'fields.media.fields')));

          break;
        case 'switch':{
            // Switch relies on the given switchFunction prop to decide which of
            // its variations to render.
            var _$get =


              lodash_default.a.get(section, 'fields'),flagName = _$get.flagName,variations = _$get.variations;

            var recurse = function recurse(variation) {return getSectionsArray(
              variation,
              customWidgets,
              stringSubstitutions,
              switchFunction);};


            return lodash_default.a.chain(variations).
            filter(switchFunction(flagName)).
            map(function (variationSection) {return lodash_default.a.get(variationSection, 'fields.content');}).
            map(recurse).
            value();
          }
        default:{
            var widgetType = lodash_default.a.get(section, 'fields.widgetType', '');
            var customWidget = customWidgets[widgetType];
            if (type === 'customWidget' && customWidget) {
              var Component = customWidget.component;
              widget = /*#__PURE__*/
              external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Component, sections_extends({
                className: widgetType,
                model: new WidgetModel(section) },
              section.fields,
              customWidget.props, {
                stringSubstitutions: stringSubstitutions,
                key: key }));

            } else {
              // TODO refactor to use widget model
              var _Component = widgets[type];
              widget = _Component ? /*#__PURE__*/

              external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(_Component, sections_extends({
                className: widgetId },
              section.fields, {
                customSections: customWidgets,
                stringSubstitutions: stringSubstitutions,
                key: key })) :

              null;
            }
          }}

      var backgroundClass = lodash_default.a.get(section, 'fields.backgroundStyleClass');
      if (backgroundClass) {
        var classNames = lodash_default.a.intersection(
        lodash_default.a.split(backgroundClass, ',').map(function (b) {return b.trim();}), ALLOWED_BACKGROUND_CLASSES).
        join(' ');
        return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "".concat(widgetId, "-wrapper ").concat(classNames, " fullWidth"), key: key }, widget);
      }

      return widget;
    }));};


var sections_Sections = function Sections(_ref) {var
    className = _ref.className,
    sections = _ref.sections,
    customSections = _ref.customSections,
    stringSubstitutions = _ref.stringSubstitutions,
    switchFunction = _ref.switchFunction;return /*#__PURE__*/(

    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "Sections ".concat(className) },
    sections_getSectionsArray(sections, customSections, stringSubstitutions, switchFunction)));};



sections_Sections.propTypes = {
  sections: prop_types_default.a.arrayOf(prop_types_default.a.object),
  className: prop_types_default.a.string,
  customSections: customWidgetsPropType,
  stringSubstitutions: stringSubstitutionsPropType,
  switchFunction: prop_types_default.a.func
};

sections_Sections.defaultProps = {
  sections: null,
  className: '',
  customSections: {},
  stringSubstitutions: {},
  switchFunction: undefined
};

/* harmony default export */ var components_contentful_views_sections = (sections_Sections);
// EXTERNAL MODULE: ./src/components/contentful-views/collapsible-text.less
var collapsible_text = __webpack_require__(177);

// EXTERNAL MODULE: ./src/components/contentful-views/collapsible-text-rebrand.less
var collapsible_text_rebrand = __webpack_require__(178);

// CONCATENATED MODULE: ./src/components/contentful-views/collapsible-text.jsx

 // eslint-disable-line







/**
 *
 * @param {Object} props
 * @param {String} props.className
 * @param {String} props.id
 * @param {Object} props.options Passed to Markdown renderer
 * @param {String} props.text
 * @param {String} props.title
 */
var collapsible_text_CollapsibleText = function CollapsibleText(_ref) {var
    className = _ref.className,
    id = _ref.id,
    options = _ref.options,
    text = _ref.text,
    title = _ref.title;return /*#__PURE__*/(

    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "CollapsibleText uic ".concat(className) }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("input", {
      type: "checkbox",
      name: "accordionToggle",
      id: "row".concat(id),
      key: "input".concat(id),
      "aria-controls": "content".concat(id) }), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "row", id: "content".concat(id), key: "content".concat(id), role: "tabpanel" }, /*#__PURE__*/

    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("label", { className: "titleText", htmlFor: "row".concat(id) }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { id: "chevron-bold" }), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "text" }, title)), /*#__PURE__*/

    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, { className: "content", source: text, options: options }))));};




collapsible_text_CollapsibleText.propTypes = {
  id: prop_types_default.a.string.isRequired,
  title: prop_types_default.a.string.isRequired,
  text: prop_types_default.a.string.isRequired,
  className: prop_types_default.a.string,
  options: prop_types_default.a.object // eslint-disable-line
};

collapsible_text_CollapsibleText.defaultProps = {
  className: '',
  options: { html: true }
};

registerWidget('collapsibleTextSection', collapsible_text_CollapsibleText);

/* harmony default export */ var contentful_views_collapsible_text = (collapsible_text_CollapsibleText);
// CONCATENATED MODULE: ./src/components/contentful-views/counter/incremental-counter.jsx
function incremental_counter_slicedToArray(arr, i) {return incremental_counter_arrayWithHoles(arr) || incremental_counter_iterableToArrayLimit(arr, i) || incremental_counter_unsupportedIterableToArray(arr, i) || incremental_counter_nonIterableRest();}function incremental_counter_nonIterableRest() {throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function incremental_counter_unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return incremental_counter_arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return incremental_counter_arrayLikeToArray(o, minLen);}function incremental_counter_arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}function incremental_counter_iterableToArrayLimit(arr, i) {var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];if (_i == null) return;var _arr = [];var _n = true;var _d = false;var _s, _e;try {for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"] != null) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}function incremental_counter_arrayWithHoles(arr) {if (Array.isArray(arr)) return arr;}


/**
 * Renders an incremental counter that automatically keeps increasing a given
 * integer value by 1 until it reaches the end value or, if no end value given,
 * keeps counting forever.
 *
 */
var incremental_counter_IncrementalCounter = function IncrementalCounter(_ref)



{var end = _ref.end,start = _ref.start,speed = _ref.speed;
  var _useState = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useState"])(start || 0),_useState2 = incremental_counter_slicedToArray(_useState, 2),currentVal = _useState2[0],setCurrentVal = _useState2[1];
  var timer = Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useRef"])(null);

  Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["useEffect"])(function () {
    if (end && end > currentVal) {
      timer.current = setTimeout(function () {
        setCurrentVal(function (val) {return val + 1;});
      }, 1000 * speed);
    } else {
      timer.current = setTimeout(function () {
        setCurrentVal(function (val) {return val + 1;});
      }, 1000 * speed);
    }

    return function () {
      clearTimeout(timer.current);
    };
  }, [currentVal]);

  var places = [];
  var currentValString = currentVal.toString();

  for (var i = 0; i < currentValString.length; i += 1) {
    var currentPlace = currentValString[currentValString.length - (i + 1)];

    if (i % 3 === 0 && i > 0) {
      places.unshift( /*#__PURE__*/
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "counter-comma" }, ","));

    }

    places.unshift( /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "counter-place", key: "".concat(Math.pow(10, i + 1), "-place") }, currentPlace));

  }

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "counter" },
    places));


};

var incrementalCounterPropTypes = {
  /** Sets an end value for counter to stop increasing */
  end: prop_types_default.a.number,
  /** Sets a start value for counter to begin increasing from */
  start: prop_types_default.a.number,
  /** Sets a multiplier for seconds between increments */
  speed: prop_types_default.a.number
};

incremental_counter_IncrementalCounter.propTypes = incrementalCounterPropTypes;

incremental_counter_IncrementalCounter.defaultProps = {
  end: null,
  start: 1,
  speed: 1.0
};
/* harmony default export */ var incremental_counter = (incremental_counter_IncrementalCounter);
// EXTERNAL MODULE: ./src/components/contentful-views/counter/counter.less
var counter_counter = __webpack_require__(179);

// EXTERNAL MODULE: ./src/components/contentful-views/counter/counter-rebrand.less
var counter_rebrand = __webpack_require__(180);

// CONCATENATED MODULE: ./src/components/contentful-views/counter/counter.jsx











/**
 * Array of counter layouts
 */
var COUNTER_POSITIONS = ['Row Layout', 'Column Layout'];

/**
 * Counter Parent that allows for the set up and use of the Incremental Counter
 * component within a styled text layout and shows/hides different parts
 * depending on the response values.
 */
var counter_Counter = function Counter(_ref)














{var callToActionButton = _ref.callToActionButton,className = _ref.className,counterPosition = _ref.counterPosition,endMobileText = _ref.endMobileText,endText = _ref.endText,endVal = _ref.endVal,hasCounterOnMobile = _ref.hasCounterOnMobile,mobilePlaceHolder = _ref.mobilePlaceHolder,showUnderline = _ref.showUnderline,speed = _ref.speed,startMobileText = _ref.startMobileText,startText = _ref.startText,startVal = _ref.startVal,stringSubstitutions = _ref.stringSubstitutions;
  var endTextContent = endText && /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, {
    className: "".concat(endMobileText && 'hide-mobile', " counter-text"),
    source: stringSubstitution(endText, stringSubstitutions) });

  var startTextContent = startText && /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, {
    className: "".concat(startMobileText && 'hide-mobile', " counter-text"),
    source: stringSubstitution(startText, stringSubstitutions) });


  /** FOR MOBILE */
  var endMobileTextContent = endMobileText && /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, {
    className: "counter-text-mobile",
    source: stringSubstitution(endMobileText, stringSubstitutions) });

  var startMobileTextContent = startMobileText && /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, {
    className: "counter-text-mobile",
    source: stringSubstitution(startMobileText, stringSubstitutions) });

  var mobilePlaceHolderContent = mobilePlaceHolder && !hasCounterOnMobile && /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, {
    className: "counter-text-mobile counter-placeholder ".concat(showUnderline && 'underline'),
    source: stringSubstitution(mobilePlaceHolder, stringSubstitutions) });


  var ctaButton = callToActionButton && sections_getWidget(callToActionButton);

  var counter = /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "".concat(showUnderline && 'underline', " ").concat(!hasCounterOnMobile && 'hide-mobile', " counter-text") }, /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(incremental_counter, {
    end: endVal,
    start: startVal,
    speed: speed || 1.0 }));



  var counterLayout = /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "".concat(counterPosition.toLowerCase().replace(' ', '-')) },
  startTextContent,
  startMobileTextContent,
  counter,
  mobilePlaceHolderContent,
  endTextContent,
  endMobileTextContent);



  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "counter-parent uic ".concat(className) },
    counterLayout,
    ctaButton));


};

var counterPropTypes = {
  /** The call to action button - a Contentful reference */
  callToActionButton: prop_types_default.a.shape({
    fields: prop_types_default.a.shape(buttonLinkPropTypes)
  }),
  className: prop_types_default.a.string,
  /** Text that appends to counter. Hides if it's mobile counterpart has a value */
  counterPosition: prop_types_default.a.oneOf(COUNTER_POSITIONS),
  /** Text that appends to counter on mobile views */
  endMobileText: prop_types_default.a.string,
  /** Text that appends to counter on non-mobile views */
  endText: prop_types_default.a.string,
  /** Int that the counter stops increasing at */
  endVal: prop_types_default.a.number,
  /** Allows hiding of counter on mobile views */
  hasCounterOnMobile: prop_types_default.a.bool,
  /** Text that can be showed instead of the counter */
  mobilePlaceHolder: prop_types_default.a.string,
  /** Allows custom underline to be placed under counter */
  showUnderline: prop_types_default.a.bool,
  /** Time between changes in seconds */
  speed: prop_types_default.a.number,
  /** Text that prepends to counter on mobile views */
  startMobileText: prop_types_default.a.string,
  /** Text that prepends to counter. Hides if it's mobile counterpart has a value */
  startText: prop_types_default.a.string,
  /** Int that the counter could start at */
  startVal: prop_types_default.a.number,
  /** */
  stringSubstitutions: common_prop_types.stringSubstitutions
};

counter_Counter.propTypes = counterPropTypes;

counter_Counter.defaultProps = {
  callToActionButton: null,
  className: '',
  counterPosition: COUNTER_POSITIONS[0],
  endMobileText: null,
  endText: null,
  endVal: null,
  hasCounterOnMobile: true,
  mobilePlaceHolder: null,
  showUnderline: false,
  speed: null,
  startMobileText: null,
  startText: null,
  startVal: null,
  stringSubstitutions: {}
};

registerWidget('counter', counter_Counter);

/* harmony default export */ var contentful_views_counter_counter = (counter_Counter);
// CONCATENATED MODULE: ./src/components/contentful-views/page-metadata.jsx





/**
 * Render a React Helmet component to build a rich set of metadata into the
 * page's <head>. Values deeper down the component tree override higher ones,
 * so this can easily be used to create and then override default values
 * throughout the page.
 * This does not render any directly displayed markup.
 * Page Metadata model in Contentful:
 *    https://app.contentful.com/spaces/ljtyf78xujn2/content_types/pageMetadata/fields
 */
var page_metadata_PageMetadata = function PageMetadata(props) {
  var
    pageTitle =









    props.pageTitle,shareTitle = props.shareTitle,description = props.description,primaryImage = props.primaryImage,twitterCard = props.twitterCard,twitterSite = props.twitterSite,additionalMetadata = props.additionalMetadata,pageTitleText = props.pageTitleText,metaDescription = props.metaDescription,jsonLd = props.jsonLd;

  // MetaTags literally handles <meta> tags. This includes the official
  // page description <meta name="description".../> as well as OpenGraph and
  // Twitter metadata tags e.g. <meta name="twitter:title".../> but, notably,
  // does not include the <title> tag, which are handed to Helmet separately.
  var meta = new meta_tags_MetaTags().
  title(shareTitle || pageTitle || pageTitleText) // (og|twitter):title
  .description(description || metaDescription).
  image(primaryImage && primaryImage.url).
  openGraph('image:width', primaryImage && primaryImage.width).
  openGraph('image:height', primaryImage && primaryImage.height).
  twitter('card', twitterCard).
  twitter('site', twitterSite).
  pushAll(additionalMetadata);

  var jsonLdScript = jsonLd ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("script", { type: "application/ld+json" }, JSON.stringify(jsonLd)) : null;

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(external_commonjs_react_helmet_commonjs2_react_helmet_amd_ReactHelmet_root_ReactHelmet_default.a, {
      title: pageTitle || pageTitleText // The actual <title> tag on the page
      , meta: meta.tags },
    jsonLdScript));


};

page_metadata_PageMetadata.propTypes = interpretedMetadataPropType;

page_metadata_PageMetadata.defaultProps = {
  pageTitle: null,
  shareTitle: null,
  description: null,
  primaryImage: { url: null, width: null, height: null },
  openGraphType: null,
  twitterCard: null,
  twitterSite: null,
  additionalMetadata: [],
  pageTitleText: null,
  metaDescription: null,
  jsonLd: null
};

/* harmony default export */ var page_metadata = (page_metadata_PageMetadata);
// CONCATENATED MODULE: ./src/components/contentful-views/page.jsx
function page_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function page_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? page_ownKeys(Object(source), !0).forEach(function (key) {page_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : page_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function page_defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function page_extends() {page_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return page_extends.apply(this, arguments);}








/**
 * Renders components based off of Contentful Page Model :
 * example: https://app.contentful.com/spaces/ljtyf78xujn2/entries/3ryy5hMRpuCkWEGUIEkQ68
 */
var page_Page = function Page(props) {
  var
    pageType =






    props.pageType,title = props.title,pageTitleText = props.pageTitleText,metaDescription = props.metaDescription,stringSubstitutions = props.stringSubstitutions,pageMetadata = props.pageMetadata,className = props.className;

  var helmet = includeWhen(
  pageType === 'standalone',
  function () {return /*#__PURE__*/(
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(page_metadata, page_extends({},
      page_metadata_interpretMetadata(pageMetadata, stringSubstitutions), {
        pageTitleText: pageTitleText || title,
        metaDescription: stringSubstitution(metaDescription, stringSubstitutions) })));});



  var header = includeWhen(
  title,
  function () {return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("h1", { className: "h1" }, stringSubstitution(title, stringSubstitutions));});


  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "Page contentPage uic ".concat(className) },
    helmet,
    header, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_contentful_views_sections, page_extends({}, props, { className: "content" }))));


};

page_Page.propTypes = page_objectSpread(page_objectSpread({},
pagePropType), {}, {
  className: prop_types_default.a.string });


page_Page.defaultProps = {
  className: ''
};

/* harmony default export */ var contentful_views_page = (page_Page);
// EXTERNAL MODULE: ./src/components/contentful-views/quote.less
var contentful_views_quote = __webpack_require__(181);

// EXTERNAL MODULE: ./src/components/contentful-views/quote-rebrand.less
var quote_rebrand = __webpack_require__(182);

// CONCATENATED MODULE: ./src/components/contentful-views/quote.jsx









/**
 * @param {Object} props
 * @param {String} props.className
 * @param {String} props.quote Markdown
 * @param {Object} props.person Contentful fields
 */
var quote_Quote = function Quote(_ref) {var
    className = _ref.className,
    quote = _ref.quote,
    person = _ref.person;return /*#__PURE__*/(

    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "Quote uic ".concat(className) }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "person" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("img", {
      src: lodash_default.a.get(person, 'fields.photo[0].fields.file.url'),
      alt: lodash_default.a.get(person, 'fields.name') })), /*#__PURE__*/

    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "quoteText" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, { source: "".concat(quote) }), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "name" }, "\xA0 \u2014 \xA0", "".concat(



    lodash_default.a.get(person, 'fields.name'), ", ").concat(lodash_default.a.get(person, 'fields.title'))))));};





quote_Quote.propTypes = {
  /**
   * This expects a Contentful shape, legacy.
   * To-do: Move this to own folder and create widget to separate
   * Contentful from UI
   * */
  person: prop_types_default.a.shape({}).isRequired,
  /**
   * Markdown string
   */
  quote: prop_types_default.a.string.isRequired,
  className: prop_types_default.a.string
};

quote_Quote.defaultProps = {
  className: ''
};

registerWidget('quote', quote_Quote);

/* harmony default export */ var components_contentful_views_quote = (quote_Quote);
// EXTERNAL MODULE: ./src/components/text-and-image-section/text-and-image-section.less
var text_and_image_section = __webpack_require__(183);

// EXTERNAL MODULE: ./src/components/text-and-image-section/text-and-image-section-rebrand.less
var text_and_image_section_rebrand = __webpack_require__(184);

// CONCATENATED MODULE: ./src/components/text-and-image-section/text-and-image-section.jsx








/**
 * Text and Image Section v2, now with better spacing. Used for SMB section.
 */

// classnames for Contentful widths
var WIDTH_CLASS = {
  '25%': 'quarter',
  '33%': 'third',
  '50%': 'half',
  '66%': 'two-thirds',
  '75%': 'three-quarters',
  '100%': 'one'
};

// helper for retrieving from WIDTH_CLASS map
var text_and_image_section_getWidthClass = function getWidthClass(percent) {return lodash_default.a.get(WIDTH_CLASS, percent);};

// Width class for text widths.
var OPPOSITE_WIDTH_CLASS = {
  quarter: 'three-quarters',
  third: 'two-thirds',
  half: 'half',
  'two-thirds': 'third',
  'three-quarters': 'quarter',
  one: 'two-thirds'
};

// helper for retreiving from OPPOSITE_WIDTH_CLASS map
var text_and_image_section_getRemainingWidth = function getRemainingWidth(widthClass) {return lodash_default.a.get(OPPOSITE_WIDTH_CLASS, widthClass);};

/**
 * Helper for rendering Header.
 */
var text_and_image_section_HeaderElement = function HeaderElement(_ref) {var
    className = _ref.className,
    title = _ref.title,
    subTitle = _ref.subTitle;return /*#__PURE__*/(

    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: className },
    title,
    subTitle));};



text_and_image_section_HeaderElement.propTypes = {
  className: prop_types_default.a.string,
  title: prop_types_default.a.node,
  subTitle: prop_types_default.a.node
};

text_and_image_section_HeaderElement.defaultProps = {
  className: null,
  title: null,
  subTitle: null
};

/**
 * UI for text and image section.
 * This is one section with two distinct containers.
 * The text container contains a header, some Markdown content, and a CTA.
 * The Image container contains a fluid image.
 *
 * There are 4 options for desktop layout:
 *  - Top Image Card
 *  - Bottom Image Card
 *  - Left Image Card
 *  - Right Image Card
 * On Mobile, these sections become one organized like:
 *  - Header
 *  - Image
 *  - Content
 *
 * @param {String} className Class given to the Text and Image section
 * @param {Node}   ctaButton Button react node
 * @param {String} ctaPosition Class determining CTA horizontal alignment
 * @param {String} displayType where to display the header on desktop. Mobile it's always on top.
 * @param {String} headerLocation See PropTypes for options.
 * @param {String} image Image url
 * @param {String} imageWidth See PropTypes for options.
 * @param {String} subTitle sub header
 * @param {String} title Main header
 * @param {Node}   wistiaButton Wistia Button react node
 */
var text_and_image_section_TextAndImageSection = function TextAndImageSection(_ref2)











{var className = _ref2.className,ctaButton = _ref2.ctaButton,ctaPosition = _ref2.ctaPosition,displayType = _ref2.displayType,headerLocation = _ref2.headerLocation,image = _ref2.image,imageWidth = _ref2.imageWidth,subTitleText = _ref2.subTitle,bodyContent = _ref2.bodyContent,titleText = _ref2.title,wistiaButton = _ref2.wistiaButton;
  var title = titleText && /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("h2", { className: "title h1" }, titleText);

  var subTitle = subTitleText && /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("h3", { className: "subTitle" }, subTitleText);

  var isInlineHeader = headerLocation === 'inline';
  // Render two headers if inline. Mobile header displays topLeft, desktop displays inline
  var headerClasses = isInlineHeader ? 'header inlineTop' : "header ".concat(lodash_default.a.camelCase(headerLocation));
  var header = (title || subTitle) && /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(text_and_image_section_HeaderElement, {
    className: headerClasses,
    title: title,
    subTitle: subTitle });


  // Desktop inline header
  var inlineHeader = isInlineHeader ? /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(text_and_image_section_HeaderElement, {
    className: "header inline",
    title: title,
    subTitle: subTitle }) :
  null;

  // Determine width of image
  var imageWidthClass = imageWidth ? text_and_image_section_getWidthClass(imageWidth) : '';

  // Text takes up remaining width
  var textSize = text_and_image_section_getRemainingWidth(imageWidthClass);

  var imageElement = image && /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("img", { src: image, alt: "", className: "image" });

  var textContent = bodyContent && /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "textContent" }, bodyContent);

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: classnames_default()('TextAndImageSection-beta uic', className, displayType) },
    header, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: classnames_default()('contentWrapper', displayType) }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: classnames_default()('imageContainer', imageWidthClass) },
    imageElement,
    wistiaButton), /*#__PURE__*/

    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: classnames_default()('textContainer', textSize) },
    inlineHeader,
    textContent, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: classnames_default()('ctaWrapper', "ctaWrapper-".concat(ctaPosition)) }, ctaButton)))));




};

var textAndImageSectionPropTypes = {
  className: prop_types_default.a.string,
  ctaButton: prop_types_default.a.node,
  ctaPosition: prop_types_default.a.oneOf(['left', 'center', 'right']),
  displayType: prop_types_default.a.oneOf(['leftImageCard', 'rightImageCard', 'topImageCard', 'bottomImageCard']),
  headerLocation: prop_types_default.a.oneOf(['inline', 'topCenter', 'topLeft']),
  image: prop_types_default.a.string,
  imageWidth: prop_types_default.a.string,
  subTitle: prop_types_default.a.string,
  bodyContent: prop_types_default.a.node,
  title: prop_types_default.a.string,
  wistiaButton: prop_types_default.a.node
};

text_and_image_section_TextAndImageSection.propTypes = textAndImageSectionPropTypes;

text_and_image_section_TextAndImageSection.defaultProps = {
  className: '',
  ctaButton: null,
  ctaPosition: 'left',
  displayType: 'leftImageCard',
  headerLocation: 'inline',
  image: null,
  imageWidth: null,
  subTitle: null,
  bodyContent: null,
  title: null,
  wistiaButton: null
};

/* harmony default export */ var text_and_image_section_text_and_image_section = (text_and_image_section_TextAndImageSection);
// CONCATENATED MODULE: ./src/components/text-and-image-section/index.js

// EXTERNAL MODULE: ./src/components/contentful-views/text-and-image-section.less
var contentful_views_text_and_image_section = __webpack_require__(185);

// EXTERNAL MODULE: ./src/components/contentful-views/text-and-image-section-rebrand.less
var contentful_views_text_and_image_section_rebrand = __webpack_require__(186);

// CONCATENATED MODULE: ./src/components/contentful-views/text-and-image-section.jsx
function text_and_image_section_extends() {text_and_image_section_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return text_and_image_section_extends.apply(this, arguments);}















var DISPLAY_CLASSES = ['Left Image Card', 'Right Image Card', 'Top Image Card', 'Bottom Image Card'];
var PAGE_WIDTH = 800;
var SIDE_IMAGE_WIDTHS = {
  small: Math.round(PAGE_WIDTH / 4),
  medium: Math.round(PAGE_WIDTH / 3),
  large: Math.round(PAGE_WIDTH / 2),
  huge: Math.round(PAGE_WIDTH * 0.75),
  original: null
};
var VERTICAL_IMAGE_WIDTHS = {
  small: Math.round(PAGE_WIDTH / 2),
  medium: Math.round(PAGE_WIDTH * 0.75),
  large: Math.round(PAGE_WIDTH),
  huge: Math.round(PAGE_WIDTH),
  original: null
};
var IMAGE_PROPORTION_TO_PERCENT = {
  small: '33%',
  medium: '50%',
  large: '66%',
  original: '66%',
  huge: '75%'
};

var contentful_views_text_and_image_section_TextAndImageSection = function TextAndImageSection(_ref)


















{var callToActionButton = _ref.callToActionButton,ctaPosition = _ref.ctaPosition,className = _ref.className,displayType = _ref.displayType,headerClass = _ref.headerClass,headerLocation = _ref.headerLocation,icons = _ref.icons,imageIndex = _ref.imageIndex,imageProportionText = _ref.imageProportion,images = _ref.images,imageWidth = _ref.imageWidth,stringSubstitutions = _ref.stringSubstitutions,subTitleText = _ref.subTitle,text = _ref.text,titleText = _ref.title,v2 = _ref.v2,variant = _ref.variant,wistiaVideo = _ref.wistiaVideo;
  var subbedTitleText = titleText && stringSubstitution(titleText, stringSubstitutions);
  var title = subbedTitleText && /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("h2", { className: headerClass },
  subbedTitleText);


  var subbedSubTitleText = subTitleText && stringSubstitution(subTitleText, stringSubstitutions);
  var subTitle = subTitleText && /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("h3", { className: "subTitle h3" }, subbedSubTitleText);

  var icon = icons && /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, text_and_image_section_extends({ className: "imageSection" }, icons[0].fields));
  var displayClass = lodash_default.a.includes(DISPLAY_CLASSES, displayType) ? lodash_default.a.camelCase(displayType) : 'leftImageCard';
  var ctaButton = callToActionButton && sections_getWidget(callToActionButton);

  var headerLocationClass = lodash_default.a.camelCase(headerLocation);
  var header = /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "header ".concat(headerLocationClass) },
  title,
  subTitle);


  var hasInlineHeader = headerLocation === 'Inline';

  var imageProportion = lodash_default.a.toLower(imageProportionText);
  var maxImageWidth;
  if (lodash_default.a.includes(['leftImageCard', 'rightImageCard'], displayClass)) {
    maxImageWidth = SIDE_IMAGE_WIDTHS[imageProportion];
  } else if (lodash_default.a.includes(['topImageCard', 'bottomImageCard'], displayClass)) {
    maxImageWidth = VERTICAL_IMAGE_WIDTHS[imageProportion];
  }

  // TODO: Responsive Images? https://css-tricks.com/responsive-images-youre-just-changing-resolutions-use-srcset/
  // Responsive images are the responsibility of the implementor, pass in a responsive image
  var image = images && images[imageIndex] ? /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(contentful_views_image, {
    media: images[imageIndex],
    className: "imageSection ".concat(imageProportion),
    width: maxImageWidth }) :
  null;

  var bodyContent = text && /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, { className: "paragraph", source: stringSubstitution(text, stringSubstitutions) });

  if (v2) {
    image = image && lodash_default.a.get(images, "[".concat(imageIndex, "].fields.file.url"));
    // Get correct imageWidth for v2
    var v2ImageWidth;
    if (imageWidth) {
      v2ImageWidth = imageWidth;
    } else if (imageProportion) {
      v2ImageWidth = IMAGE_PROPORTION_TO_PERCENT[imageProportion];
    }

    var wistiaButton = wistiaVideo && sections_getWidget(wistiaVideo);
    return /*#__PURE__*/(
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(text_and_image_section_text_and_image_section, {
        className: className,
        ctaButton: ctaButton,
        ctaPosition: ctaPosition,
        displayType: displayClass,
        headerClass: headerClass,
        headerLocation: headerLocationClass,
        icon: icon,
        image: image,
        imageProportion: imageProportion,
        subTitle: subbedSubTitleText,
        bodyContent: bodyContent,
        title: subbedTitleText,
        wistiaButton: wistiaButton,
        imageWidth: v2ImageWidth }));

  }

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: classnames_default()('TextAndImageSection uic', className, displayClass, variant) },
    hasInlineHeader || header, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "section-body ".concat(displayClass) },
    image,
    icon, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "textSection" },
    hasInlineHeader && header,
    bodyContent,
    ctaButton))));




};

var text_and_image_section_textAndImageSectionPropTypes = {
  callToActionButton: prop_types_default.a.shape({
    fields: prop_types_default.a.shape(buttonLinkPropTypes)
  }),
  ctaPosition: prop_types_default.a.string,
  className: prop_types_default.a.string,
  displayType: prop_types_default.a.string,
  headerClass: prop_types_default.a.string,
  headerLocation: prop_types_default.a.oneOf(['Inline', 'Top Center', 'Top Left']),
  icons: prop_types_default.a.arrayOf(prop_types_default.a.object),
  imageIndex: prop_types_default.a.number,
  imageProportion: prop_types_default.a.oneOf(['Small', 'Medium', 'Large', 'Huge', 'Original']),
  images: prop_types_default.a.arrayOf(prop_types_default.a.object),
  imageWidth: prop_types_default.a.string,
  stringSubstitutions: common_prop_types.stringSubstitutions,
  subTitle: prop_types_default.a.string,
  text: prop_types_default.a.string,
  title: prop_types_default.a.string,
  v2: prop_types_default.a.bool,
  variant: prop_types_default.a.oneOf(['default', 'contained', 'containedBrand', 'slide']),
  wistiaVideo: prop_types_default.a.shape({
    fields: prop_types_default.a.shape({})
  })
};

contentful_views_text_and_image_section_TextAndImageSection.propTypes = text_and_image_section_textAndImageSectionPropTypes;

contentful_views_text_and_image_section_TextAndImageSection.defaultProps = {
  callToActionButton: null,
  ctaPosition: null,
  className: '',
  displayType: null,
  headerClass: 'h2',
  headerLocation: 'Inline',
  icons: null,
  imageIndex: 0,
  imageProportion: 'Small',
  images: null,
  imageWidth: null,
  stringSubstitutions: {},
  subTitle: null,
  text: null,
  title: null,
  v2: false,
  variant: 'default',
  wistiaVideo: null
};

registerWidget('textAndImageSection', contentful_views_text_and_image_section_TextAndImageSection);

/* harmony default export */ var components_contentful_views_text_and_image_section = (contentful_views_text_and_image_section_TextAndImageSection);
// CONCATENATED MODULE: ./src/components/contentful-views/text-section.jsx







/**
 * @param {Object} props
 * @param {String} props.title
 * @param {String} props.headerClass
 * @param {String} props.className
 * @param {Object} props.stringSubstitutions
 */
var text_section_TextSection = function TextSection(_ref)





{var className = _ref.className,headerClass = _ref.headerClass,text = _ref.text,title = _ref.title,stringSubstitutions = _ref.stringSubstitutions;
  var titleElement = title ? /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("h2", { className: "uic ".concat(headerClass) },
  stringSubstitution(title, stringSubstitutions)) :

  null;
  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "TextSection ".concat(className) },
    titleElement, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, { className: "paragraph", source: stringSubstitution(text, stringSubstitutions) })));


};

var textSectionPropTypes = {
  className: prop_types_default.a.string,
  headerClass: prop_types_default.a.string,
  stringSubstitutions: common_prop_types.stringSubstitutions,
  text: prop_types_default.a.string.isRequired,
  title: prop_types_default.a.string
};

text_section_TextSection.propTypes = textSectionPropTypes;

text_section_TextSection.defaultProps = {
  className: '',
  headerClass: 'h2',
  stringSubstitutions: {},
  title: null
};

registerWidget('textSection', text_section_TextSection);

/* harmony default export */ var text_section = (text_section_TextSection);
// EXTERNAL MODULE: ./src/components/contentful-views/video-section.less
var video_section = __webpack_require__(187);

// CONCATENATED MODULE: ./src/components/contentful-views/video-section.jsx









/**
 * @param {Object} props
 * @param {String} props.title
 * @param {String} props.subTitle
 * @param {String} props.headerClass
 * @param {Object} props.stringSubstitutions
 * @param {String} props.caption
 * @param {String} props.videoUrl
 * @param {String} props.className
 */
var video_section_VideoSection = function VideoSection(_ref)







{var title = _ref.title,subTitle = _ref.subTitle,headerClass = _ref.headerClass,stringSubstitutions = _ref.stringSubstitutions,caption = _ref.caption,videoUrl = _ref.videoUrl,className = _ref.className;
  var titleString = stringSubstitution(title, stringSubstitutions);
  var titleElement = title && /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("h2", { className: headerClass },
  titleString);


  var subTitleElement = subTitle && /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("h3", { className: "subTitle" }, stringSubstitution(subTitle, stringSubstitutions));
  var captionElement = caption && /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, { className: "caption", source: stringSubstitution(caption, stringSubstitutions) });
  var titleSection = (titleElement || subTitleElement) && /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "titleSection" },
  titleElement,
  subTitleElement);


  var youtubeURL = videoUrl.replace('watch?v=', 'embed/');
  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "VideoSection uic ".concat(className) },
    titleSection, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("iframe", { title: titleString, width: "800", height: "400", src: youtubeURL }),
    captionElement));


};

var video_section_textSectionPropTypes = {
  title: prop_types_default.a.string,
  subTitle: prop_types_default.a.string,
  caption: prop_types_default.a.string,
  videoUrl: prop_types_default.a.string.isRequired,
  className: prop_types_default.a.string,
  headerClass: prop_types_default.a.string,
  stringSubstitutions: common_prop_types.stringSubstitutions
};

video_section_VideoSection.propTypes = video_section_textSectionPropTypes;

video_section_VideoSection.defaultProps = {
  title: null,
  subTitle: null,
  caption: null,
  className: '',
  headerClass: 'h2',
  stringSubstitutions: {}
};

registerWidget('videoSection', video_section_VideoSection);

/* harmony default export */ var contentful_views_video_section = (video_section_VideoSection);
// EXTERNAL MODULE: ./src/components/contentful-views/video.less
var contentful_views_video = __webpack_require__(188);

// CONCATENATED MODULE: ./src/components/contentful-views/video.jsx





var video_Video = function Video(_ref) {var title = _ref.title,embedLink = _ref.embedLink,caption = _ref.caption;return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "Video" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("h2", { className: "h2" }, title), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("iframe", {
      title: title,
      src: embedLink,
      width: "560",
      height: "315",
      frameBorder: "0",
      allowFullScreen: true }), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "caption" }, caption)));};



video_Video.propTypes = {
  title: prop_types_default.a.string,
  embedLink: prop_types_default.a.string.isRequired,
  caption: prop_types_default.a.string
};

video_Video.defaultProps = {
  title: null,
  caption: null
};

/* harmony default export */ var components_contentful_views_video = (video_Video);
// EXTERNAL MODULE: ./src/components/contentful-views/wistia-section.less
var wistia_section = __webpack_require__(189);

// CONCATENATED MODULE: ./src/components/contentful-views/wistia-section.jsx









/**
 * Wistia Section
 * @param {Object} props React Props
 * @param {String} props.caption
 * @param {String} props.className
 * @param {String} props.embedCode
 * @param {String} props.headerClass
 * @param {Object} props.stringSubstitutions
 * @param {String} props.subTitle
 * @param {String} props.title
 */
var wistia_section_WistiaSection = function WistiaSection(_ref)







{var caption = _ref.caption,className = _ref.className,embedCode = _ref.embedCode,headerClass = _ref.headerClass,stringSubstitutions = _ref.stringSubstitutions,subTitle = _ref.subTitle,title = _ref.title;
  var titleHeader = title && /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("h2", { className: headerClass },
  stringSubstitution(title, stringSubstitutions));


  var subTitleHeader = subTitle && /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("h3", { className: "subTitle" }, stringSubstitution(subTitle, stringSubstitutions));
  var titleSection = (titleHeader || subTitleHeader) && /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "titleSection" },
  titleHeader,
  subTitleHeader);


  var captionElement = caption && /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, { className: "caption", source: stringSubstitution(caption, stringSubstitutions) });
  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "WistiaSection uic ".concat(className) },
    titleSection, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, { source: embedCode }),
    captionElement));


};

wistia_section_WistiaSection.propTypes = {
  caption: prop_types_default.a.string,
  className: prop_types_default.a.string,
  embedCode: prop_types_default.a.string.isRequired,
  headerClass: prop_types_default.a.string,
  stringSubstitutions: common_prop_types.stringSubstitutions,
  subTitle: prop_types_default.a.string,
  title: prop_types_default.a.string
};

wistia_section_WistiaSection.defaultProps = {
  caption: null,
  className: '',
  headerClass: 'h2',
  stringSubstitutions: {},
  subTitle: null,
  title: null
};

registerWidget('wistiaSection', wistia_section_WistiaSection);

/* harmony default export */ var contentful_views_wistia_section = (wistia_section_WistiaSection);
// CONCATENATED MODULE: ./src/components/contentful-views/index.js















// EXTERNAL MODULE: ./src/components/mad-lib-email/mad-lib-form.less
var mad_lib_form = __webpack_require__(190);

// EXTERNAL MODULE: ./src/components/mad-lib-email/mad-lib-form-rebrand.less
var mad_lib_form_rebrand = __webpack_require__(191);

// CONCATENATED MODULE: ./src/components/mad-lib-email/mad-lib-form.jsx
function mad_lib_form_typeof(obj) {"@babel/helpers - typeof";return mad_lib_form_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, mad_lib_form_typeof(obj);}function mad_lib_form_extends() {mad_lib_form_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return mad_lib_form_extends.apply(this, arguments);}function mad_lib_form_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function mad_lib_form_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? mad_lib_form_ownKeys(Object(source), !0).forEach(function (key) {mad_lib_form_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : mad_lib_form_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function mad_lib_form_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function mad_lib_form_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function mad_lib_form_createClass(Constructor, protoProps, staticProps) {if (protoProps) mad_lib_form_defineProperties(Constructor.prototype, protoProps);if (staticProps) mad_lib_form_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function mad_lib_form_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) mad_lib_form_setPrototypeOf(subClass, superClass);}function mad_lib_form_setPrototypeOf(o, p) {mad_lib_form_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return mad_lib_form_setPrototypeOf(o, p);}function mad_lib_form_createSuper(Derived) {var hasNativeReflectConstruct = mad_lib_form_isNativeReflectConstruct();return function _createSuperInternal() {var Super = mad_lib_form_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = mad_lib_form_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return mad_lib_form_possibleConstructorReturn(this, result);};}function mad_lib_form_possibleConstructorReturn(self, call) {if (call && (mad_lib_form_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return mad_lib_form_assertThisInitialized(self);}function mad_lib_form_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function mad_lib_form_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function mad_lib_form_getPrototypeOf(o) {mad_lib_form_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return mad_lib_form_getPrototypeOf(o);}function mad_lib_form_defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}

















var FORM_TYPE_EMAIL = 'email';
var FORM_TYPE_INFO = 'info';

/**
 * Validates email form values
 * @param {String} args.email Email field
 * @param {String} args.name Name field
 */
var mad_lib_form_validateEmail = function validateEmail(_ref) {var email = _ref.email,name = _ref.name;
  var errors = {};

  // validate name
  var nameValidError = validateName(name);
  if (nameValidError) {
    errors.name = nameValidError;
  } else if (!name) {
    errors.name = 'Name is required.';
  }

  // validate email
  if (!email) {
    errors.email = 'Email is required.';
  }

  return errors;
};

/**
 * Validates an `info` form type, which could have any of the fields in
 * `fieldSubstitutions`. For an `info` form, all inputs are considered optional,
 * but we will validate names and phone numbers if a user decides to provide
 * them. Email addresses are validated using the browser's built-in validation
 * @param {object} args
 * @param {String} args.name
 * @param {String} args.phone
 */
var mad_lib_form_validateInfo = function validateInfo(_ref2)


{var name = _ref2.name,phone = _ref2.phone;
  var errors = {};

  var nameValidError = name && validateName(name);
  if (nameValidError) {
    errors.name = nameValidError;
  }

  if (phone && !min_isPossiblePhoneNumber(phone)) {
    errors.phone = 'Invalid phone number';
  }

  return errors;
};

/**
 * validateForm is called by Formik to validate form values.
 * https://jaredpalmer.com/formik/docs/api/formik#validate-values-values-formikerrors-values-promise-any
 * @param {Object} Fields value object passed by Formik.
 * @returns {Object} Object of field keys with error strings, empty if no errors.
 */
var mad_lib_form_validateForm = function validateForm(formType) {
  if (formType === FORM_TYPE_EMAIL) {
    return mad_lib_form_validateEmail;
  }
  if (formType === FORM_TYPE_INFO) {
    return mad_lib_form_validateInfo;
  }
  return function () {};
};

/**
 * fieldSubstitutions returns an object mapping macros to components.
 * Passed to componentSubstitution as component argument.
 * @param {Object} placeholders Object of values to be used as placeholders for input fields.
 */
var fieldSubstitutions = {
  email: mad_lib_fields_emailField,
  name: mad_lib_fields_nameField,
  info: mad_lib_fields_infoField,
  phone: mad_lib_fields_phoneField
};

/**
 * MadLibForm renders form elements inline with text, creating a fill-in-the blank form.
 * There are several form types to choose from, see the `formType` prop.
 */var
mad_lib_form_MadLibForm = /*#__PURE__*/function (_React$PureComponent) {mad_lib_form_inherits(MadLibForm, _React$PureComponent);var _super = mad_lib_form_createSuper(MadLibForm);function MadLibForm() {var _this;mad_lib_form_classCallCheck(this, MadLibForm);for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}_this = _super.call.apply(_super, [this].concat(args));mad_lib_form_defineProperty(mad_lib_form_assertThisInitialized(_this), "submitForm",





























































    function (values, formikActions) {
      var onSubmit = _this.props.onSubmit;
      onSubmit(values, formikActions);
    });return _this;}mad_lib_form_createClass(MadLibForm, [{ key: "render", value:

    function render() {
      var _this$props =















        this.props,bannerImage = _this$props.bannerImage,className = _this$props.className,cancelCTA = _this$props.cancelCTA,formType = _this$props.formType,image = _this$props.image,inDialog = _this$props.inDialog,onCancel = _this$props.onCancel,pendingText = _this$props.pendingText,primaryCTA = _this$props.primaryCTA,salutation = _this$props.salutation,secondarySalutation = _this$props.secondarySalutation,salutationColor = _this$props.salutationColor,text = _this$props.text,segmentationCards = _this$props.segmentationCards,radioButtons = _this$props.radioButtons;
      var initialValues = {
        email: '',
        name: '',
        phone: '',
        segment: {}
      };
      var validate = null;

      var cards;
      if (formType === 'cards') {
        cards = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(MadLibCards, { segmentationCards: segmentationCards, inDialog: inDialog });
      }

      var radios;
      if (formType === 'radioButtons' && radioButtons) {
        validate = getRadioButtonsValidator(radioButtons.name);
        initialValues = mad_lib_form_objectSpread(mad_lib_form_objectSpread({},
        initialValues),
        getRadioButtonsInitialValues(radioButtons.name));

        radios = /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(mad_lib_email_mad_lib_radio_buttons, {
          name: radioButtons.name,
          includeOtherOption: radioButtons.includeOtherOption,
          options: radioButtons.options });

      }

      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: classnames_default()('MadLibForm uic', formType, className, { inDialog: inDialog }) },
        image ? /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "madLibSideContent" }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "madLibImage" }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(contentful_views_image, { media: image }))) :


        null, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "madLibMainContent" },
        bannerImage ? /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "madLibBanner" }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(contentful_views_image, { media: bannerImage }), /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("p", { className: "salutation" }, salutation)) : /*#__PURE__*/


        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("p", { className: classnames_default()('salutation', salutationColor) }, salutation),

        secondarySalutation ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("p", { className: "h3" }, secondarySalutation) : null, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(formik_esm_Formik, {
          initialValues: initialValues,
          validate: validate || mad_lib_form_validateForm(formType),
          onSubmit: this.submitForm },
        function (_ref3) {var isSubmitting = _ref3.isSubmitting;return /*#__PURE__*/(
            external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Form, null, /*#__PURE__*/
            external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "madLibText" },
            componentSubstitution(text, fieldSubstitutions),
            cards),

            radios, /*#__PURE__*/
            external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "buttonGroup" },
            includeWhen(!lodash_default.a.isEmpty(primaryCTA), function () {return /*#__PURE__*/(
                external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_button, mad_lib_form_extends({},
                primaryCTA.props, {
                  disabled: isSubmitting,
                  isSubmit: true }),
                isSubmitting ? pendingText : primaryCTA.text));}),


            includeWhen(!lodash_default.a.isEmpty(cancelCTA), function () {return /*#__PURE__*/(
                external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_button, mad_lib_form_extends({},
                cancelCTA.props, {
                  onClick: onCancel,
                  disabled: isSubmitting }),
                cancelCTA.text));}))));}))));









    } }]);return MadLibForm;}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.PureComponent);mad_lib_form_defineProperty(mad_lib_form_MadLibForm, "propTypes", { /** Image to display behind the salutation text. */bannerImage: prop_types_default.a.shape({}), className: prop_types_default.a.string, /**
   * Type of form, only two options now.
   * Use the appropriate value for text macros provided.
   */formType: prop_types_default.a.oneOf(['email', 'info', 'cards', 'radioButtons']), /** Image displayed to left of fields on desktop, and above fields on mobile. */image: prop_types_default.a.shape({}), /** Tell this Form that it is in a dialog and to update styles. */inDialog: prop_types_default.a.bool, /** Callback to cancel form editing. */onCancel: prop_types_default.a.func, onSubmit: prop_types_default.a.func, /** Text for the primaryCTA when submit is pending. */pendingText: prop_types_default.a.string, /** Object of values for rendering primary Button */primaryCTA: prop_types_default.a.shape({ props: prop_types_default.a.shape({}), text: prop_types_default.a.string }), /** If provided, renders radio buttons */radioButtons: prop_types_default.a.shape({ name: prop_types_default.a.string, includeOtherOption: prop_types_default.a.bool, options: prop_types_default.a.arrayOf(prop_types_default.a.shape({ value: prop_types_default.a.string, label: prop_types_default.a.string })) }), /** Salutation / header value */salutation: prop_types_default.a.string, /** Text below the primary salutation */secondarySalutation: prop_types_default.a.string, /** classes for salutation to affect color. 'blue', 'red' */salutationColor: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.shape({})]), segmentationCards: prop_types_default.a.arrayOf(prop_types_default.a.shape({ image: prop_types_default.a.shape({}), // contentful media object
    title: prop_types_default.a.string })), /** Object of values for rendering secondary Button */cancelCTA: prop_types_default.a.shape({ props: prop_types_default.a.shape({}), text: prop_types_default.a.string }), /**
   * Mad Lib text, {{macro}}s for rendering form fields.
   * Accepted macros are: {{name}}, {{info}}, {{email}}, {{phone}}
   */text: prop_types_default.a.string });mad_lib_form_MadLibForm.defaultProps = { bannerImage: null, className: null, image: null, formType: null,
  inDialog: false,
  onCancel: lodash_default.a.noop,
  onSubmit: lodash_default.a.noop,
  pendingText: 'Submitting',
  primaryCTA: {},
  radioButtons: null,
  salutation: null,
  secondarySalutation: null,
  salutationColor: null,
  segmentationCards: [],
  cancelCTA: {},
  text: null
};

/* harmony default export */ var mad_lib_email_mad_lib_form = (mad_lib_form_MadLibForm);
// CONCATENATED MODULE: ./src/components/mad-lib-email/mad-lib-form-widget.jsx






/**
 * Helper to extract needed fields from ButtonLink Contentful model
 * @param {Object} model Contentful model for button link
 */
var mad_lib_form_widget_ctaModel = function ctaModel(model) {return model ? {
    props: {
      type: lodash_default.a.get(model, 'fields.type'),
      size: lodash_default.a.get(model, 'fields.size')
    },
    text: lodash_default.a.get(model, 'fields.text')
  } : null;};

/**
 * Contentful Widget to map MadLibForm to it's custom component.
 */
var mad_lib_form_widget_MadLibFormWidget = function MadLibFormWidget(_ref)




{var model = _ref.model,onSubmit = _ref.onSubmit,onCancel = _ref.onCancel,className = _ref.className;
  var id = lodash_default.a.get(model, 'fields.id');
  var salutation = lodash_default.a.get(model, 'fields.salutation');
  var salutationColor = lodash_default.a.lowerCase(lodash_default.a.get(model, 'fields.salutationColor'));
  var secondarySalutation = lodash_default.a.get(model, 'fields.secondarySalutation');
  var bannerImage = lodash_default.a.get(model, 'fields.bannerImage');
  var image = lodash_default.a.get(model, 'fields.image');
  var cancelCTA = mad_lib_form_widget_ctaModel(lodash_default.a.get(model, 'fields.cancelCta'));
  var text = lodash_default.a.get(model, 'fields.madLibText');
  var primaryCTA = mad_lib_form_widget_ctaModel(lodash_default.a.get(model, 'fields.cta'));
  var pendingText = lodash_default.a.get(model, 'fields.pendingText');
  var formType = lodash_default.a.get(model, 'fields.formType');
  var segmentationCards = lodash_default.a.map(lodash_default.a.get(model, 'fields.segmentationCards'), function (_ref2) {var
    fields = _ref2.fields;return (
      {
        title: lodash_default.a.get(fields, 'title'),
        image: lodash_default.a.get(fields, 'images[0]')
      });});
  var radioButtonOptions = lodash_default.a.map(lodash_default.a.get(model, 'fields.segmentationCards'), function (_ref3) {var
    fields = _ref3.fields;return (
      {
        value: lodash_default.a.get(fields, 'id'),
        label: lodash_default.a.get(fields, 'text')
      });});
  // Hard-coding radio button form field name to match existing pattern
  var radioButtonsFieldName = id || 'segment';
  var includeOtherOption = lodash_default.a.get(model, 'fields.includeOtherOption', true);
  var radioButtons = {
    name: radioButtonsFieldName,
    includeOtherOption: includeOtherOption,
    options: radioButtonOptions
  };

  // Return function so we can pass in onSubmit.
  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(mad_lib_email_mad_lib_form, {
      bannerImage: bannerImage,
      className: className,
      cancelCTA: cancelCTA,
      image: image,
      formType: formType,
      onCancel: onCancel,
      onSubmit: onSubmit,
      pendingText: pendingText,
      primaryCTA: primaryCTA,
      salutation: salutation,
      salutationColor: salutationColor,
      secondarySalutation: secondarySalutation,
      segmentationCards: segmentationCards,
      radioButtons: radioButtons,
      text: text }));

};

mad_lib_form_widget_MadLibFormWidget.propTypes = {
  model: prop_types_default.a.shape({}),
  onSubmit: prop_types_default.a.func,
  onCancel: prop_types_default.a.func,
  className: prop_types_default.a.string
};

mad_lib_form_widget_MadLibFormWidget.defaultProps = {
  model: {},
  onSubmit: lodash_default.a.noop,
  onCancel: lodash_default.a.noop,
  className: null
};

registerWidget('madLibForm', mad_lib_form_widget_MadLibFormWidget);

/* harmony default export */ var mad_lib_form_widget = (mad_lib_form_widget_MadLibFormWidget);
// CONCATENATED MODULE: ./src/components/mad-lib-email/mad-lib-widget.jsx






/**
 * Avoid passing NaN as prop and pass `undefined` instead so default
 * prop will be used by descendant components
 */
var mad_lib_widget_getNumber = function getNumber(object, path) {
  var value = lodash_default.a.get(object, path);
  var number = Number(value);
  // eslint-disable-next-line no-restricted-globals
  return isNaN(number) ? undefined : number;
};

/**
 * Contentful Widget to map MadLibForm to it's custom component.
 */
var mad_lib_widget_MadLibWidget = function MadLibWidget(_ref) {var model = _ref.model;
  var madLibScreens = lodash_default.a.get(model, 'fields.madLibScreens');
  var popup = !!lodash_default.a.get(model, 'fields.popup');
  var delay = mad_lib_widget_getNumber(model, 'fields.delay');
  var id = lodash_default.a.get(model, 'fields.id');
  var hidden = lodash_default.a.get(model, 'fields.hidden');
  var showAgainAfterDays = mad_lib_widget_getNumber(model, 'fields.showAgainAfterDays');
  var maxShowCount = mad_lib_widget_getNumber(model, 'fields.maxShowCount');

  var children = sections_getSectionsArray(madLibScreens);
  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(mad_lib_email_mad_lib, {
      delay: delay,
      popup: popup,
      id: id,
      hidden: hidden,
      showAgainAfterDays: showAgainAfterDays,
      maxShowCount: maxShowCount },
    children));


};

mad_lib_widget_MadLibWidget.propTypes = {
  model: prop_types_default.a.shape({})
};

mad_lib_widget_MadLibWidget.defaultProps = {
  model: {}
};

registerWidget('madLibFlow', mad_lib_widget_MadLibWidget);

/* harmony default export */ var mad_lib_widget = (mad_lib_widget_MadLibWidget);
// CONCATENATED MODULE: ./src/components/mad-lib-email/index.js



// eslint-disable-next-line import/no-cycle


// EXTERNAL MODULE: ./src/components/list/list.less
var list_list = __webpack_require__(192);

// EXTERNAL MODULE: ./src/components/list/list-rebrand.less
var list_rebrand = __webpack_require__(193);

// CONCATENATED MODULE: ./src/components/list/list.jsx











/**
 * Renders a header, subtitle, and list (children).
 * @param children - React children, should be a an array.
 * @param className - Class applied to wrapper element.
 * @param subTitle - Text used for Subtitle.
 * @param title - Text used for title.
 * @param displayOption - Decides how to display list, see proptypes
 */
var list_List = function List(_ref)





{var children = _ref.children,className = _ref.className,displayOption = _ref.displayOption,subTitle = _ref.subTitle,title = _ref.title;
  var listView;
  switch (displayOption) {
    case 'Carousel':{
        listView = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_carousel, null, children);
        break;
      }
    case 'Horizontal Scroll':{
        listView = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(horizontal_scroll_horizontal_scroll, null, children);
        break;
      }
    case 'NavCarousel':{
        listView = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_nav_carousel, null, children);
        break;
      }
    // Special List, renders itself
    case 'Mad Lib Flow':{
        return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(mad_lib_email_mad_lib, { className: className }, children);
      }
    default:{
        // Ported from previous list implementation
        // All the rest are legacy default styles that rely on the following dom structure.
        // Eventually should break these in to own components
        listView = /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "Sections" },
        children);


      }}


  var hasTitle = !!(title || subTitle);

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: classnames_default()('List uic', className, { hasTitle: hasTitle }) },
    title ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("h2", { className: "h2 title" }, title) : null,
    subTitle ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "subTitle" }, subTitle) : null,
    listView));


};

list_List.propTypes = {
  children: prop_types_default.a.arrayOf(prop_types_default.a.node),
  className: prop_types_default.a.string,
  displayOption: prop_types_default.a.oneOf([
  'Vertical List',
  'Full Width',
  'Grid',
  'Grid Two Columns',
  'Grid Three Columns',
  'Grid Four Columns',
  'Grid Five Columns',
  'Grid Six Columns',
  'Carousel',
  'NavCarousel',
  'Image Grid',
  'Horizontal Scroll',
  'Mad Lib Flow']),

  subTitle: prop_types_default.a.node,
  title: prop_types_default.a.node
};

list_List.defaultProps = {
  children: null,
  className: '',
  displayOption: 'Vertical List',
  subTitle: '',
  title: ''
};

/* harmony default export */ var components_list_list = (list_List);
// CONCATENATED MODULE: ./src/components/list/index.js

// EXTERNAL MODULE: ./src/components/machine-badge.less
var machine_badge = __webpack_require__(194);

// EXTERNAL MODULE: ./src/components/machine-badge-rebrand.less
var machine_badge_rebrand = __webpack_require__(195);

// CONCATENATED MODULE: ./src/components/machine-badge.jsx








/**
 * Renders a machine icon (typically shown next to its name or serial) based on
 * model.
 *
 * Usage:
 *
 *  <MachineIcon model='<basic|plus|pro>' />
 *
 */
var machine_badge_MachineIcon = function MachineIcon(props) {return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { id: "badge-icon-".concat(lodash_default.a.toLower(props.model)) }));};


machine_badge_MachineIcon.propTypes = {
  model: prop_types_default.a.string
};

machine_badge_MachineIcon.defaultProps = {
  model: 'basic'
};

/**
 * Renders a machine badge (typically shown next to its name or serial) based on
 * model.
 *
 * Usage:
 *
 *  <MachineBadge model='<basic|plus|pro>' />
 *
 */
var machine_badge_MachineBadge = function MachineBadge(props) {
  /* HD units will use the same badging as current machines, so this will
   * check the type of unit regardless of HD status or not, and then pass
   * just the model part we care about to the badging class.
  */
  var model = lodash_default.a.toLower(props.model);
  if (model.includes('pro')) {model = 'pro';}
  if (model.includes('plus')) {model = 'plus';}

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "MachineBadge ".concat(model, "-model uic") }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(machine_badge_MachineIcon, { model: model }), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", null, model)));


};

machine_badge_MachineBadge.propTypes = machine_badge_MachineIcon.propTypes;

machine_badge_MachineBadge.defaultProps = machine_badge_MachineIcon.defaultProps;

/* harmony default export */ var components_machine_badge = (machine_badge_MachineBadge);
// EXTERNAL MODULE: ./src/components/media-cards/media-card.less
var media_card = __webpack_require__(196);

// CONCATENATED MODULE: ./src/components/media-cards/media-card.jsx






/**
 * UI for Card
 * If passed onClick, will be tabbable and clickable.
 */
var media_card_MediaCard = function MediaCard(_ref) {var
    children = _ref.children,
    className = _ref.className,
    image = _ref.image,
    text = _ref.text,
    title = _ref.title,
    onClick = _ref.onClick;return /*#__PURE__*/(

    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", {
      role: "button",
      tabIndex: "0",
      className: "MediaCard ".concat(className),
      onClick: onClick,
      onKeyPress: onClick }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "card-image" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("img", { src: image.src, alt: image.alt })), /*#__PURE__*/

    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "card-content" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("h3", { className: "card-title" }, title), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, { source: text }),
    children)));};




media_card_MediaCard.propTypes = {
  image: prop_types_default.a.shape({
    src: prop_types_default.a.string,
    alt: prop_types_default.a.string
  }),
  title: prop_types_default.a.string,
  text: prop_types_default.a.string,
  className: prop_types_default.a.string,
  onClick: prop_types_default.a.func,
  children: prop_types_default.a.node
};

media_card_MediaCard.defaultProps = {
  image: {},
  title: null,
  text: null,
  className: '',
  onClick: null,
  children: null
};

/* harmony default export */ var media_cards_media_card = (media_card_MediaCard);
// CONCATENATED MODULE: ./src/components/media-cards/index.js

// EXTERNAL MODULE: ./src/components/modal.less
var modal = __webpack_require__(197);

// CONCATENATED MODULE: ./src/components/modal.jsx
function modal_typeof(obj) {"@babel/helpers - typeof";return modal_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, modal_typeof(obj);}function modal_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function modal_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function modal_createClass(Constructor, protoProps, staticProps) {if (protoProps) modal_defineProperties(Constructor.prototype, protoProps);if (staticProps) modal_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function modal_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) modal_setPrototypeOf(subClass, superClass);}function modal_setPrototypeOf(o, p) {modal_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return modal_setPrototypeOf(o, p);}function modal_createSuper(Derived) {var hasNativeReflectConstruct = modal_isNativeReflectConstruct();return function _createSuperInternal() {var Super = modal_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = modal_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return modal_possibleConstructorReturn(this, result);};}function modal_possibleConstructorReturn(self, call) {if (call && (modal_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return modal_assertThisInitialized(self);}function modal_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function modal_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function modal_getPrototypeOf(o) {modal_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return modal_getPrototypeOf(o);}




/**
 * Note: Deprecate this modal. Use dialog/dialog.jsx instead. This implementation is not
 * very accessible.
 *
 * Modal is a full screen overlay that can be optionally dismissed by clicking esc or
 * click outside the modal contents IF onRequestClose is provided. Otherwise will
 * have to be programmatically removed from render via child interaction or other.
 */var
modal_Modal = /*#__PURE__*/function (_React$Component) {modal_inherits(Modal, _React$Component);var _super = modal_createSuper(Modal);
  function Modal(props) {var _this;modal_classCallCheck(this, Modal);
    _this = _super.call(this, props);
    _this.handleClickOutside = _this.handleClickOutside.bind(modal_assertThisInitialized(_this));return _this;
  }

  /**
   * If this component can close itself automatically (onRequestClose supplied)
   * then accept clicks on the modal-overlay div as a request to close.
   */modal_createClass(Modal, [{ key: "handleClickOutside", value:
    function handleClickOutside(evt) {
      var onRequestClose = this.props.onRequestClose;
      if (onRequestClose && evt.target.className === 'modal-overlay') {
        onRequestClose();
      }
    }

    // keyboard events for a11y are connected using keyboardCommands.
    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
    /* eslint-disable jsx-a11y/click-events-have-key-events */ }, { key: "render", value:
    function render() {
      var _this$props = this.props,children = _this$props.children,className = _this$props.className;
      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "Modal ".concat(className) }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "modal-overlay", onClick: this.handleClickOutside, role: "dialog" }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "modal-content" },
        children))));




    }
    /* eslint-enable jsx-a11y/no-noninteractive-element-interactions */
    /* eslint-enable jsx-a11y/click-events-have-key-events */ }]);return Modal;}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Component);


modal_Modal.propTypes = {
  onRequestClose: prop_types_default.a.func,
  className: prop_types_default.a.string,
  children: prop_types_default.a.node.isRequired
};

modal_Modal.defaultProps = {
  onRequestClose: function onRequestClose() {},
  className: ''
};

/* harmony default export */ var components_modal = (keyboardCommands(
modal_Modal,
[{
  keys: 'escape',
  connectCommand: function connectCommand(props) {
    if (props.onRequestClose) {props.onRequestClose();}
  }
}]));
// EXTERNAL MODULE: ./node_modules/react-addons-css-transition-group/index.js
var react_addons_css_transition_group = __webpack_require__(46);
var react_addons_css_transition_group_default = /*#__PURE__*/__webpack_require__.n(react_addons_css_transition_group);

// EXTERNAL MODULE: ./src/components/notification.less
var components_notification = __webpack_require__(202);

// EXTERNAL MODULE: ./src/components/notification-rebrand.less
var notification_rebrand = __webpack_require__(203);

// CONCATENATED MODULE: ./src/components/notification.jsx

 // eslint-disable-line







var LEVEL_TO_ICON = {
  success: 'check-circle',
  warning: 'exclamation-circle',
  error: 'times-circle',
  info: 'info-circle'
};

var notification_Notification = function Notification(props) {
  var actionButton;
  if (props.onCallToAction && props.callToActionText) {
    actionButton = /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_button, { size: "small", type: "text", className: "action", onClick: props.onCallToAction },
    props.callToActionText);


  }

  var timerBar;
  if (props.timeRemaining) {
    var timePercent = props.timeRemaining / (props.timeTotal || props.timeRemaining) * 100;
    timerBar = /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", {
      className: "timer-bar",
      style: {
        width: "".concat(timePercent, "%"),
        'animation-duration': "".concat(props.timeRemaining, "ms")
      } });

  }

  var header;
  var iconId = props.iconId ? props.iconId : LEVEL_TO_ICON[props.level];
  var svgIcon = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { id: iconId, className: "level" });
  if (props.hideHeader !== true) {
    var closeButton = props.onDismiss ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { id: "close", className: "closeButton", onClick: props.onDismiss }) : null;
    header = /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "header h4" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("h4", { className: "h4" }, props.title),
    closeButton);


  }

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "Notification uic ".concat(props.level) }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "container" },
    svgIcon, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "body" },
    header, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, { source: props.text }),
    actionButton),

    timerBar)));



};

notification_Notification.propTypes = {
  hideHeader: prop_types_default.a.bool,
  title: prop_types_default.a.string,
  text: prop_types_default.a.string,
  iconId: prop_types_default.a.string,
  level: prop_types_default.a.oneOf(['success', 'warning', 'error', 'info']),
  timeTotal: prop_types_default.a.number,
  timeRemaining: prop_types_default.a.number,
  onCallToAction: prop_types_default.a.func,
  callToActionText: prop_types_default.a.string,
  onDismiss: prop_types_default.a.func // Add ability to dismiss with X
};

notification_Notification.defaultProps = {
  hideHeader: false,
  text: null,
  iconId: null,
  title: '',
  onCallToAction: null,
  callToActionText: null,
  level: 'info',
  onDismiss: null,
  timeTotal: null,
  timeRemaining: null
};

/* harmony default export */ var src_components_notification = (notification_Notification);
// EXTERNAL MODULE: ./src/components/notification-list.less
var notification_list = __webpack_require__(204);

// CONCATENATED MODULE: ./src/components/notification-list.jsx
function notification_list_extends() {notification_list_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return notification_list_extends.apply(this, arguments);}
 // eslint-disable-line




var notification_list_NotificationList = function NotificationList(props) {return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "NotificationList ".concat(props.className) }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(react_addons_css_transition_group_default.a, {
      transitionName: "notification",
      transitionEnterTimeout: 300,
      transitionLeaveTimeout: 300 },
    props.notifications.map(function (notification) {return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_notification, notification_list_extends({ key: notification.id }, notification)));}))));};





notification_list_NotificationList.propTypes = {
  notifications: prop_types_default.a.arrayOf(prop_types_default.a.shape(src_components_notification.propTypes)).isRequired,
  className: prop_types_default.a.string
};

notification_list_NotificationList.defaultProps = {
  className: 'inline'
};

/* harmony default export */ var components_notification_list = (notification_list_NotificationList);
// EXTERNAL MODULE: external {"commonjs":"react-dom","commonjs2":"react-dom","amd":"ReactDOM","root":"ReactDOM"}
var external_commonjs_react_dom_commonjs2_react_dom_amd_ReactDOM_root_ReactDOM_ = __webpack_require__(5);

// CONCATENATED MODULE: ./node_modules/react-onclickoutside/dist/react-onclickoutside.es.js
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  react_onclickoutside_es_setPrototypeOf(subClass, superClass);
}

function react_onclickoutside_es_setPrototypeOf(o, p) {
  react_onclickoutside_es_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return react_onclickoutside_es_setPrototypeOf(o, p);
}

function react_onclickoutside_es_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function react_onclickoutside_es_assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  // Also cover shadowRoot node by checking current.host


  while (current.parentNode || current.host) {
    // Only check normal node without shadowRoot
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode || current.host;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var react_onclickoutside_es_uid = autoInc();var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return Object(external_commonjs_react_dom_commonjs2_react_dom_amd_ReactDOM_root_ReactDOM_["findDOMNode"])(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(react_onclickoutside_es_assertThisInitialized(_this), eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(react_onclickoutside_es_assertThisInitialized(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = react_onclickoutside_es_uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    }
    /**
     * Remove all document's event listeners for this component
     */
    ;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    }
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */
    ;

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props;
          _this$props.excludeScrollbar;
          var props = react_onclickoutside_es_objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(external_commonjs_react_commonjs2_react_amd_React_root_React_["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}/* harmony default export */ var react_onclickoutside_es = (onClickOutsideHOC);
// CONCATENATED MODULE: ./src/components/on-click-outside.jsx
function on_click_outside_typeof(obj) {"@babel/helpers - typeof";return on_click_outside_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, on_click_outside_typeof(obj);}function on_click_outside_extends() {on_click_outside_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return on_click_outside_extends.apply(this, arguments);}function on_click_outside_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function on_click_outside_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function on_click_outside_createClass(Constructor, protoProps, staticProps) {if (protoProps) on_click_outside_defineProperties(Constructor.prototype, protoProps);if (staticProps) on_click_outside_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function on_click_outside_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) on_click_outside_setPrototypeOf(subClass, superClass);}function on_click_outside_setPrototypeOf(o, p) {on_click_outside_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return on_click_outside_setPrototypeOf(o, p);}function on_click_outside_createSuper(Derived) {var hasNativeReflectConstruct = on_click_outside_isNativeReflectConstruct();return function _createSuperInternal() {var Super = on_click_outside_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = on_click_outside_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return on_click_outside_possibleConstructorReturn(this, result);};}function on_click_outside_possibleConstructorReturn(self, call) {if (call && (on_click_outside_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return on_click_outside_assertThisInitialized(self);}function on_click_outside_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function on_click_outside_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function on_click_outside_getPrototypeOf(o) {on_click_outside_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return on_click_outside_getPrototypeOf(o);}


/**
 * The component being passed must implement `handleClickOutside(event)`.
 *
 * Ensures that click outside listens for pointerdown as well since it can block
 * mousedown and touchdown events if default is prevented on it
 */
var on_click_outside_withOnClickOutside = function withOnClickOutside(Component) {
  var WrappedComponent = react_onclickoutside_es(Component);

  // Consumers, like KeyboardCommands, need to give refs to this component, which needs a class:
  // eslint-disable-next-line react/prefer-stateless-function
  return /*#__PURE__*/function (_React$PureComponent) {on_click_outside_inherits(_class, _React$PureComponent);var _super = on_click_outside_createSuper(_class);function _class() {on_click_outside_classCallCheck(this, _class);return _super.apply(this, arguments);}on_click_outside_createClass(_class, [{ key: "render", value:
      function render() {
        return /*#__PURE__*/(
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(WrappedComponent, on_click_outside_extends({},
          this.props, {
            eventTypes: ['mousedown', 'touchstart', 'pointerdown'] })));

      } }]);return _class;}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.PureComponent);

};

/* harmony default export */ var on_click_outside = (on_click_outside_withOnClickOutside);
// EXTERNAL MODULE: ./src/components/pageable-grid-list/pageable-grid-list.less
var pageable_grid_list = __webpack_require__(205);

// EXTERNAL MODULE: ./src/components/pageable-grid-list/pageable-grid-list-rebrand.less
var pageable_grid_list_rebrand = __webpack_require__(206);

// CONCATENATED MODULE: ./src/components/pageable-grid-list/pageable-grid-list.jsx
function pageable_grid_list_typeof(obj) {"@babel/helpers - typeof";return pageable_grid_list_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, pageable_grid_list_typeof(obj);}function pageable_grid_list_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function pageable_grid_list_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function pageable_grid_list_createClass(Constructor, protoProps, staticProps) {if (protoProps) pageable_grid_list_defineProperties(Constructor.prototype, protoProps);if (staticProps) pageable_grid_list_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function pageable_grid_list_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) pageable_grid_list_setPrototypeOf(subClass, superClass);}function pageable_grid_list_setPrototypeOf(o, p) {pageable_grid_list_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return pageable_grid_list_setPrototypeOf(o, p);}function pageable_grid_list_createSuper(Derived) {var hasNativeReflectConstruct = pageable_grid_list_isNativeReflectConstruct();return function _createSuperInternal() {var Super = pageable_grid_list_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = pageable_grid_list_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return pageable_grid_list_possibleConstructorReturn(this, result);};}function pageable_grid_list_possibleConstructorReturn(self, call) {if (call && (pageable_grid_list_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return pageable_grid_list_assertThisInitialized(self);}function pageable_grid_list_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function pageable_grid_list_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function pageable_grid_list_getPrototypeOf(o) {pageable_grid_list_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return pageable_grid_list_getPrototypeOf(o);}







// 400 pixel scroll offset for mobile infinite scroll.
var SCROLL_OFFSET = 400;

/**
 * Pageable grid list. If `shouldPage` isn't passed in as prop, this will
 *  not page.
 *
 * If `shouldPage` is passed:
 * Renders a grid of paged items, that are multiples of items per page
 * which is passed in `props`. Note that this DOES NOT support server
 * pagination. All data required for pagination must be ready at initial
 * render.
 */var
pageable_grid_list_PageableGridList = /*#__PURE__*/function (_React$Component) {pageable_grid_list_inherits(PageableGridList, _React$Component);var _super = pageable_grid_list_createSuper(PageableGridList);
  function PageableGridList(props) {var _this;pageable_grid_list_classCallCheck(this, PageableGridList);
    _this = _super.call(this, props);
    _this.state = {
      page: 1
    };
    // memoized array for visible items.
    _this.visibleItems = [];
    _this.incrementPage = _this.incrementPage.bind(pageable_grid_list_assertThisInitialized(_this));
    _this.getVisibleItems = _this.getVisibleItems.bind(pageable_grid_list_assertThisInitialized(_this));
    _this.handleScroll = _this.handleScroll.bind(pageable_grid_list_assertThisInitialized(_this));
    _this.removeScrollListener = _this.removeScrollListener.bind(pageable_grid_list_assertThisInitialized(_this));

    // setup scroll listener
    _this.gridRef = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createRef();
    _this.throttledScroll = lodash_default.a.throttle(_this.handleScroll, 200);return _this;
  }

  // Add scroll listener if `shouldPage`
  pageable_grid_list_createClass(PageableGridList, [{ key: "componentDidMount", value: function componentDidMount() {
      // Add scroll listener to grid on client
      var shouldPage = this.props.shouldPage;
      if (shouldPage) {
        this.gridRef.current.addEventListener('scroll', this.throttledScroll);
      }
    } }, { key: "componentWillUnmount", value:

    function componentWillUnmount() {
      // Cancel scroll listener
      this.removeScrollListener();
    }

    /**
     * Memoized getter for paged items.  We show `itemsPerPage` cards
     * at a time in the desktop grid view.
     * @param {Array} items full array of items
     */ }, { key: "getVisibleItems", value:
    function getVisibleItems() {
      var _this$props = this.props,itemsPerPage = _this$props.itemsPerPage,listItems = _this$props.listItems;
      var page = this.state.page;
      var numPagedItems = page * itemsPerPage;
      if (this.visibleItems.length < numPagedItems) {
        this.visibleItems = listItems.slice(0, numPagedItems);
      }
      return this.visibleItems;
    } }, { key: "removeScrollListener", value:

    function removeScrollListener() {
      this.throttledScroll.cancel();
      this.gridRef.current.removeEventListener('scroll', this.throttledScroll);
    }

    /**
     * Handle grid scroll.  Used to infinite scroll mobile view.
     */ }, { key: "handleScroll", value:
    function handleScroll() {
      var listItems = this.props.listItems;
      // Have we loaded all the items yet?
      if (this.getVisibleItems().length < listItems.length) {
        var _this$gridRef$current = this.gridRef.current,clientWidth = _this$gridRef$current.clientWidth,scrollWidth = _this$gridRef$current.scrollWidth,scrollLeft = _this$gridRef$current.scrollLeft;
        // if grid is overflowed horizontally, we're on mobile.
        if (scrollWidth > clientWidth) {
          var rightEdge = scrollLeft + clientWidth;
          // If rightEdge of grid is within SCROLL_OFFSET pixels of end, load more items
          if (scrollWidth - rightEdge < SCROLL_OFFSET) {
            this.incrementPage();
          }
        }
      } else {
        // All items have been loaded, no longer need to scroll.
        this.removeScrollListener();
      }
    }

    /**
     * Increment the page to trigger a re-render and show the
     * next set of items.
     */ }, { key: "incrementPage", value:
    function incrementPage() {
      var page = this.state.page;
      this.setState({
        page: page + 1
      });
    } }, { key: "render", value:

    function render() {
      // Get paged/memoized list of items.
      var _this$props2 =






        this.props,className = _this$props2.className,listItems = _this$props2.listItems,showMoreText = _this$props2.showMoreText,swipeToShowMoreText = _this$props2.swipeToShowMoreText,title = _this$props2.title,shouldPage = _this$props2.shouldPage;
      var items = shouldPage ? this.getVisibleItems(listItems) : listItems;
      var titleElement = title ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("h2", { className: "title" }, title) : null;

      var showMoreClasses = '';
      var showMoreButton;
      if (shouldPage && items.length < listItems.length) {
        showMoreClasses = 'moreItems';
        showMoreButton = /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_button, {
          className: "button",
          type: "secondary",
          onClick: this.incrementPage },
        showMoreText);


      }

      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: classnames_default()('PageableGridList uic', className) },
        titleElement, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "cards-grid", ref: this.gridRef },
        items), /*#__PURE__*/

        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "showMore ".concat(showMoreClasses) }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "text" }, swipeToShowMoreText),
        showMoreButton)));



    } }]);return PageableGridList;}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Component);


pageable_grid_list_PageableGridList.propTypes = {
  className: prop_types_default.a.string,
  itemsPerPage: prop_types_default.a.number,
  listItems: prop_types_default.a.arrayOf(prop_types_default.a.node),
  showMoreText: prop_types_default.a.string,
  shouldPage: prop_types_default.a.bool,
  swipeToShowMoreText: prop_types_default.a.string,
  title: prop_types_default.a.string
};

pageable_grid_list_PageableGridList.defaultProps = {
  className: null,
  itemsPerPage: 8,
  listItems: [],
  showMoreText: 'See More',
  shouldPage: false,
  swipeToShowMoreText: 'Swipe To See More',
  title: null
};

/* harmony default export */ var pageable_grid_list_pageable_grid_list = (pageable_grid_list_PageableGridList);
// CONCATENATED MODULE: ./src/components/pageable-grid-list/index.js

// EXTERNAL MODULE: ./src/components/popover.less
var popover = __webpack_require__(207);

// CONCATENATED MODULE: ./src/components/popover.jsx
function popover_typeof(obj) {"@babel/helpers - typeof";return popover_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, popover_typeof(obj);}function popover_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function popover_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function popover_createClass(Constructor, protoProps, staticProps) {if (protoProps) popover_defineProperties(Constructor.prototype, protoProps);if (staticProps) popover_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function popover_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) popover_setPrototypeOf(subClass, superClass);}function popover_setPrototypeOf(o, p) {popover_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return popover_setPrototypeOf(o, p);}function popover_createSuper(Derived) {var hasNativeReflectConstruct = popover_isNativeReflectConstruct();return function _createSuperInternal() {var Super = popover_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = popover_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return popover_possibleConstructorReturn(this, result);};}function popover_possibleConstructorReturn(self, call) {if (call && (popover_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return popover_assertThisInitialized(self);}function popover_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function popover_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function popover_getPrototypeOf(o) {popover_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return popover_getPrototypeOf(o);}


var

popover_Popover = /*#__PURE__*/function (_React$Component) {popover_inherits(Popover, _React$Component);var _super = popover_createSuper(Popover);
  function Popover(props) {var _this;popover_classCallCheck(this, Popover);
    _this = _super.call(this, props);
    _this.handleClickOutside = _this.handleClickOutside.bind(popover_assertThisInitialized(_this));return _this;
  }popover_createClass(Popover, [{ key: "handleClickOutside", value:

    function handleClickOutside() {
      var _this$props = this.props,open = _this$props.open,onRequestClose = _this$props.onRequestClose;
      if (!open) {
        return;
      }
      if (onRequestClose) {
        onRequestClose();
      }
    } }, { key: "render", value:

    function render() {
      var children = this.props.children;
      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "Popover" },
        children));


    } }]);return Popover;}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Component);


popover_Popover.propTypes = {
  open: prop_types_default.a.bool.isRequired,
  children: prop_types_default.a.node,
  onRequestClose: prop_types_default.a.func
};

popover_Popover.defaultProps = {
  children: null,
  onRequestClose: function onRequestClose() {}
};
// EXTERNAL MODULE: ./node_modules/react-slider/react-slider.js
var react_slider = __webpack_require__(47);
var react_slider_default = /*#__PURE__*/__webpack_require__.n(react_slider);

// EXTERNAL MODULE: ./src/components/range-slider.less
var range_slider = __webpack_require__(210);

// CONCATENATED MODULE: ./src/components/range-slider.jsx
function range_slider_extends() {range_slider_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return range_slider_extends.apply(this, arguments);} // eslint-disable-line





/*
  Range slider config comes from https://github.com/mpowaga/react-slider
  passed forward for use.
*/

var range_slider_RangeSlider = function RangeSlider(props) {return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(react_slider_default.a, range_slider_extends({
      pearling: true },
    props, {
      className: "RangeSlider ".concat(props.className) })));};


range_slider_RangeSlider.propTypes = {
  className: prop_types_default.a.string
};

range_slider_RangeSlider.defaultProps = {
  className: ''
};

/* harmony default export */ var components_range_slider = (range_slider_RangeSlider);
// EXTERNAL MODULE: ./node_modules/react-input-autosize/lib/AutosizeInput.js
var AutosizeInput = __webpack_require__(48);
var AutosizeInput_default = /*#__PURE__*/__webpack_require__.n(AutosizeInput);

// CONCATENATED MODULE: ./node_modules/react-select/dist/react-select.es.js






var react_select_es_arrowRenderer = function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

react_select_es_arrowRenderer.propTypes = {
	onMouseDown: prop_types_default.a.func
};

var react_select_es_clearRenderer = function clearRenderer() {
	return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

var react_select_es_map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < react_select_es_map.length; i++) {
		str = str.replace(react_select_es_map[i].letters, react_select_es_map[i].base);
	}
	return str;
};

var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var react_select_es_isValid = function isValid(value) {
	return typeof value !== 'undefined' && value !== null && value !== '';
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
		if (!filterValue) return true;

		var value = option[props.valueKey];
		var label = option[props.labelKey];
		var hasValue = react_select_es_isValid(value);
		var hasLabel = react_select_es_isValid(label);

		if (!hasValue && !hasLabel) {
			return false;
		}

		var valueTest = hasValue ? String(value) : null;
		var labelTest = hasLabel ? String(label) : null;

		if (props.ignoreAccents) {
			if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}

		return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
};

var react_select_es_menuRenderer = function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] === option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = classnames_default()(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
};

react_select_es_menuRenderer.propTypes = {
	focusOption: prop_types_default.a.func,
	focusedOption: prop_types_default.a.object,
	inputValue: prop_types_default.a.string,
	instancePrefix: prop_types_default.a.string,
	onFocus: prop_types_default.a.func,
	onOptionRef: prop_types_default.a.func,
	onSelect: prop_types_default.a.func,
	optionClassName: prop_types_default.a.string,
	optionComponent: prop_types_default.a.func,
	optionRenderer: prop_types_default.a.func,
	options: prop_types_default.a.array,
	removeValue: prop_types_default.a.func,
	selectValue: prop_types_default.a.func,
	valueArray: prop_types_default.a.array,
	valueKey: prop_types_default.a.string
};

var blockEvent = (function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
});

var react_select_es_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var react_select_es_defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var react_select_es_extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var react_select_es_Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = classnames_default()(this.props.className, option.className);

			return option.disabled ? external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: blockEvent,
					onClick: blockEvent },
				this.props.children
			) : external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Component);

react_select_es_Option.propTypes = {
	children: prop_types_default.a.node,
	className: prop_types_default.a.string, // className (based on mouse position)
	instancePrefix: prop_types_default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: prop_types_default.a.bool, // the option is disabled
	isFocused: prop_types_default.a.bool, // the option is focused
	isSelected: prop_types_default.a.bool, // the option is selected
	onFocus: prop_types_default.a.func, // method to handle mouseEnter on option element
	onSelect: prop_types_default.a.func, // method to handle click on option element
	onUnfocus: prop_types_default.a.func, // method to handle mouseLeave on option element
	option: prop_types_default.a.object.isRequired, // object that is base for that option
	optionIndex: prop_types_default.a.number // index of the option, used to generate unique ids for aria
};

var react_select_es_Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
				'div',
				{ className: classnames_default()('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Component);

react_select_es_Value.propTypes = {
	children: prop_types_default.a.node,
	disabled: prop_types_default.a.bool, // disabled prop passed to ReactSelect
	id: prop_types_default.a.string, // Unique id for the value - used for aria
	onClick: prop_types_default.a.func, // method to handle click on value label
	onRemove: prop_types_default.a.func, // method to handle removal of the value
	value: prop_types_default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.node]);
var stringOrNumber = prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]);

var instanceId = 1;

var shouldShowValue = function shouldShowValue(state, props) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	if (!inputValue) return true;

	if (!onSelectResetsInput) {
		return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
	}

	return false;
};

var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
	var valueType = typeof value === 'undefined' ? 'undefined' : react_select_es_typeof(value);
	if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
	var options = props.options,
	    valueKey = props.valueKey;

	if (!options) return;
	for (var i = 0; i < options.length; i++) {
		if (String(options[i][valueKey]) === String(value)) return options[i];
	}
};

var handleRequired = function handleRequired(value, multi) {
	if (!value) return true;
	return multi ? value.length === 0 : Object.keys(value).length === 0;
};

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}

			if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
				this.setState({ inputValue: this.handleInputValueChange('') });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = Object(external_commonjs_react_dom_commonjs2_react_dom_amd_ReactDOM_root_ReactDOM_["findDOMNode"])(this.focused);
				var menuNode = Object(external_commonjs_react_dom_commonjs2_react_dom_amd_ReactDOM_root_ReactDOM_["findDOMNode"])(this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = Object(external_commonjs_react_dom_commonjs2_react_dom_amd_ReactDOM_root_ReactDOM_["findDOMNode"])(this.focused);
				var menuDOM = Object(external_commonjs_react_dom_commonjs2_react_dom_amd_ReactDOM_root_ReactDOM_["findDOMNode"])(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
			var pref = document.addEventListener ? '' : 'on';

			document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
			document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false,
						focusedOption: null
					});
				}

				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen,
					focusedOption: null
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				var toOpen = true;

				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				if (this._focusAfterClear) {
					toOpen = false;
					this._focusAfterClear = false;
				}

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: toOpen,
					isPseudoFocused: false,
					focusedOption: null
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
				this.setState({ focusedOption: null });
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (this.state.isOpen) {
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			} else {
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				this.setState({
					isOpen: true
				});
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;

			var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

			if (this.props.onFocus) {
				this.props.onFocus(event);
			}

			this.setState({
				isFocused: true,
				isOpen: !!toOpen
			});

			this._focusAfterClear = false;
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				inputValue: newInputValue,
				isOpen: true,
				isPseudoFocused: false
			});
		}
	}, {
		key: 'setInputValue',
		value: function setInputValue(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : react_select_es_typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			this.setState({
				inputValue: newValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : react_select_es_typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						break;
					}
					event.preventDefault();
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					break;
				case 27:
					// escape
					event.preventDefault();
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						break;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						break;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					event.preventDefault();
					this.focusPreviousOption();
					break;
				case 40:
					// down
					event.preventDefault();
					this.focusNextOption();
					break;
				case 33:
					// page up
					event.preventDefault();
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					event.preventDefault();
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
			}
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param {String|Number|Array} value		- the value of the select input
   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value) {
			var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : react_select_es_typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this2 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this3 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
			if (this.props.multi) {
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this3.getValueArray(_this3.props.value);
					if (valueArray.some(function (i) {
						return i[_this3.props.valueKey] === value[_this3.props.valueKey];
					})) {
						_this3.removeValue(value);
					} else {
						_this3.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (!this.props.closeOnSelect) {
				return;
			}
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this4 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.preventDefault();

			this.setValue(this.getResetValue());
			this.setState({
				inputValue: this.handleInputValueChange(''),
				isOpen: false
			}, this.focus);

			this._focusAfterClear = true;
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				var newState = {
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
					isOpen: true
				};
				if (this.props.onSelectResetsInput) {
					newState.inputValue = '';
				}
				this.setState(newState);
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var _potentialIndex = focusedIndex + this.props.pageSize;
				if (_potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = _potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
				return showPlaceholder ? external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
						ValueComponent,
						{
							disabled: _this5.props.disabled || value.clearableValue === false,
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							placeholder: _this5.props.placeholder,
							value: value,
							values: valueArray
						},
						renderLabel(value, i),
						external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (shouldShowValue(this.state, this.props)) {
				if (isOpen) onClick = null;
				return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						id: this._instancePrefix + '-value-item',
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						placeholder: this.props.placeholder,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = classnames_default()('Select-input', this.props.inputProps.className);
			var isOpen = this.state.isOpen;

			var ariaOwns = classnames_default()((_classNames = {}, react_select_es_defineProperty(_classNames, this._instancePrefix + '-list', isOpen), react_select_es_defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var value = this.state.inputValue;
			if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
				// it hides input value when it is not focused and was not reset on select
				value = '';
			}

			var inputProps = react_select_es_extends({}, this.props.inputProps, {
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-expanded': '' + isOpen,
				'aria-haspopup': '' + isOpen,
				'aria-label': this.props['aria-label'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-owns': ariaOwns,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				role: 'combobox',
				required: this.state.required,
				tabIndex: this.props.tabIndex,
				value: value
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var divProps = objectWithoutProperties(this.props.inputProps, []);


				var _ariaOwns = classnames_default()(react_select_es_defineProperty({}, this._instancePrefix + '-list', isOpen));
				return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement('div', react_select_es_extends({}, divProps, {
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-disabled': '' + this.props.disabled,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					className: className,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					role: 'combobox',
					style: { border: 0, width: 1, display: 'inline-block' },
					tabIndex: this.props.tabIndex || 0
				}));
			}

			if (this.props.autosize) {
				return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(AutosizeInput_default.a, react_select_es_extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
			}
			return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
				external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement('input', react_select_es_extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
			var clear = this.props.clearRenderer();

			return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
				'span',
				{
					'aria-label': ariaLabel,
					className: 'Select-clear-zone',
					onMouseDown: this.clearValue,
					onTouchEnd: this.handleTouchEndClearValue,
					onTouchMove: this.handleTouchMove,
					onTouchStart: this.handleTouchStart,
					title: ariaLabel
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					trimFilter: this.props.trimFilter,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onOptionRef: this.onOptionRef,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					removeValue: this.removeValue,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey
				});
			} else if (this.props.noResultsText) {
				return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement('input', {
					disabled: this.props.disabled,
					name: this.props.name,
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					type: 'hidden',
					value: value
				});
			}
			return valueArray.map(function (item, index) {
				return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement('input', {
					disabled: _this7.props.disabled,
					key: 'hidden.' + index,
					name: _this7.props.name,
					ref: 'value' + index,
					type: 'hidden',
					value: stringifyValue(item[_this7.props.valueKey])
				});
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
					'div',
					{
						className: 'Select-menu',
						id: this._instancePrefix + '-list',
						onMouseDown: this.handleMouseDownOnMenu,
						onScroll: this.handleMenuScroll,
						ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						},
						role: 'listbox',
						style: this.props.menuStyle,
						tabIndex: -1
					},
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = classnames_default()('Select', this.props.className, {
				'has-value': valueArray.length,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'Select--multi': this.props.multi,
				'Select--rtl': this.props.rtl,
				'Select--single': !this.props.multi
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						style: this.props.style
					},
					external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
						'div',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Component);

Select$1.propTypes = {
	'aria-describedby': prop_types_default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': prop_types_default.a.string, // aria label (for assistive tech)
	'aria-labelledby': prop_types_default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: prop_types_default.a.func, // create the drop-down caret element
	autoBlur: prop_types_default.a.bool, // automatically blur the component when an option is selected
	autoFocus: prop_types_default.a.bool, // autofocus the component on mount
	autofocus: prop_types_default.a.bool, // deprecated; use autoFocus instead
	autosize: prop_types_default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: prop_types_default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: prop_types_default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: prop_types_default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: prop_types_default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: prop_types_default.a.bool, // should it be possible to reset value
	closeOnSelect: prop_types_default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: prop_types_default.a.bool, // whether delete removes an item if there is no text input
	delimiter: prop_types_default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: prop_types_default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: prop_types_default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: prop_types_default.a.func, // method to filter a single option (option, filterString)
	filterOptions: prop_types_default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: prop_types_default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: prop_types_default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: prop_types_default.a.bool, // whether to perform case-insensitive filtering
	inputProps: prop_types_default.a.object, // custom attributes for the Input
	inputRenderer: prop_types_default.a.func, // returns a custom input component
	instanceId: prop_types_default.a.string, // set the components instanceId
	isLoading: prop_types_default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: prop_types_default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: prop_types_default.a.string, // path of the label value in option objects
	matchPos: prop_types_default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: prop_types_default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: prop_types_default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: prop_types_default.a.object, // optional style to apply to the menu container
	menuRenderer: prop_types_default.a.func, // renders a custom menu with options
	menuStyle: prop_types_default.a.object, // optional style to apply to the menu
	multi: prop_types_default.a.bool, // multi-value input
	name: prop_types_default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: prop_types_default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: prop_types_default.a.bool, // whether input is cleared on blur
	onChange: prop_types_default.a.func, // onChange handler: function (newValue) {}
	onClose: prop_types_default.a.func, // fires when the menu is closed
	onCloseResetsInput: prop_types_default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: prop_types_default.a.func, // onFocus handler: function (event) {}
	onInputChange: prop_types_default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: prop_types_default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: prop_types_default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: prop_types_default.a.func, // fires when the menu is opened
	onSelectResetsInput: prop_types_default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: prop_types_default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: prop_types_default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: prop_types_default.a.bool, // always open options menu on focus
	optionClassName: prop_types_default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: prop_types_default.a.func, // option component to render in dropdown
	optionRenderer: prop_types_default.a.func, // optionRenderer: function (option) {}
	options: prop_types_default.a.array, // array of options
	pageSize: prop_types_default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: prop_types_default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: prop_types_default.a.bool, // applies HTML5 required attribute when needed
	resetValue: prop_types_default.a.any, // value to use when you clear the control
	rtl: prop_types_default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: prop_types_default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: prop_types_default.a.bool, // whether to enable searching feature or not
	simpleValue: prop_types_default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: prop_types_default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: prop_types_default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: prop_types_default.a.bool, // whether to trim whitespace around filter value
	value: prop_types_default.a.any, // initial field value
	valueComponent: prop_types_default.a.func, // value component to render
	valueKey: prop_types_default.a.string, // path of the label value in option objects
	valueRenderer: prop_types_default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: prop_types_default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: react_select_es_arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: react_select_es_clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: react_select_es_menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onCloseResetsInput: true,
	onSelectResetsInput: true,
	openOnClick: true,
	optionComponent: react_select_es_Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: react_select_es_Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: prop_types_default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: prop_types_default.a.any, // object to use to cache results; set to null/false to disable caching
	children: prop_types_default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: prop_types_default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: prop_types_default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: prop_types_default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: prop_types_default.a.oneOfType([// replaces the placeholder while options are loading
	prop_types_default.a.string, prop_types_default.a.node]),
	multi: prop_types_default.a.bool, // multi-value input
	noResultsText: prop_types_default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	prop_types_default.a.string, prop_types_default.a.node]),
	onChange: prop_types_default.a.func, // onChange handler: function (newValue) {}
	onInputChange: prop_types_default.a.func, // optional for keeping track of what is being typed
	options: prop_types_default.a.array.isRequired, // array of options
	placeholder: prop_types_default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	prop_types_default.a.string, prop_types_default.a.node]),
	searchPromptText: prop_types_default.a.oneOfType([// label to prompt for search input
	prop_types_default.a.string, prop_types_default.a.node]),
	value: prop_types_default.a.any // initial field value
};

var defaultCache = {};

var react_select_es_defaultChildren = function defaultChildren(props) {
	return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Select$1, props);
};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: react_select_es_defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : react_select_es_typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(react_select_es_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option, options: options });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator,
			    showNewOptionAtTop = _props2.showNewOptionAtTop;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					if (showNewOptionAtTop) {
						filteredOptions.unshift(this._createPlaceholderOption);
					} else {
						filteredOptions.push(this._createPlaceholderOption);
					}
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(react_select_es_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = react_select_es_extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Component);

var defaultChildren$2 = function defaultChildren(props) {
	return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Select$1, props);
};

var isOptionUnique = function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	if (!options || !options.length) {
		return true;
	}

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

var isValidNewOption = function isValidNewOption(_ref4) {
	var label = _ref4.label;
	return !!label;
};

var newOptionCreator = function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';

	return option;
};

var promptTextCreator = function promptTextCreator(label) {
	return 'Create option "' + label + '"';
};

var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: react_select_es_menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
	showNewOptionAtTop: true
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: prop_types_default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: prop_types_default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: prop_types_default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: prop_types_default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: prop_types_default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: prop_types_default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: prop_types_default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: prop_types_default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: prop_types_default.a.func,

	// See Select.propTypes.options
	options: prop_types_default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: prop_types_default.a.func,

	ref: prop_types_default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: prop_types_default.a.func,

	// Where to show prompt/placeholder option text.
	// true: new option prompt at top of list (default)
	// false: new option prompt at bottom of list
	showNewOptionAtTop: prop_types_default.a.bool
};

var react_select_es_AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(react_select_es_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Component);

var defaultChildren$1 = function defaultChildren(props) {
	return external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Select$1, props);
};

react_select_es_AsyncCreatableSelect.propTypes = {
	children: prop_types_default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

react_select_es_AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = react_select_es_AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = react_select_es_Value;
Select$1.Option = react_select_es_Option;


/* harmony default export */ var react_select_es = (Select$1);

// EXTERNAL MODULE: ./src/components/select.less
var components_select = __webpack_require__(211);

// EXTERNAL MODULE: ./src/components/select-rebrand.less
var select_rebrand = __webpack_require__(212);

// CONCATENATED MODULE: ./src/components/select.jsx
var select_excluded = ["input"];function select_extends() {select_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return select_extends.apply(this, arguments);}function select_objectWithoutProperties(source, excluded) {if (source == null) return {};var target = select_objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function select_objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}








// This is a wrapper where we hook up our own css
// See https://github.com/JedWatson/react-select for root component API

/* eslint-disable react/jsx-no-bind */
// see https://github.com/erikras/redux-form/issues/82 with onBlur issue
var select_SelectElement = function SelectElement(props) {
  var input = props.input,otherProps = select_objectWithoutProperties(props, select_excluded);

  var onHiddenInputChange = function onHiddenInputChange(e) {return props.input.onChange(
    props.options[lodash_default.a.parseInt(e.target.value)]);};


  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_form_field, props, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("select", {
      className: "selectAutoCompleteHidden uic",
      onChange: onHiddenInputChange,
      autoComplete: props.autoComplete },
    lodash_default.a.map(props.options,
    function (option, idx) {return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("option", { key: option.label, value: idx }, option.label);})), /*#__PURE__*/

    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(react_select_es, select_extends({},
    otherProps,
    input, {
      onBlur: function onBlur() {
        if (input) input.onBlur(input.value);
      } }))));


};

select_SelectElement.propTypes = {
  input: prop_types_default.a.object, // eslint-disable-line
  autoComplete: prop_types_default.a.string,
  value: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
  options: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    value: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    label: prop_types_default.a.string
  })).isRequired
};

select_SelectElement.defaultProps = {
  value: '',
  autoComplete: null
};

/* harmony default export */ var src_components_select = (select_SelectElement);
// EXTERNAL MODULE: ./src/components/slide-in-panel.less
var slide_in_panel = __webpack_require__(213);

// CONCATENATED MODULE: ./src/components/slide-in-panel.jsx







var slide_in_panel_SlideInPanel = function SlideInPanel(_ref)




{var isVisible = _ref.isVisible,onCloseClick = _ref.onCloseClick,headerText = _ref.headerText,children = _ref.children;
  if (true && document && document.body) {
    document.body.classList.toggle('modal', isVisible);
  }

  var blockUi = isVisible ? /*#__PURE__*/

  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("button", {
    type: "button",
    className: "clearButton block-ui backdrop",
    onClick: onCloseClick }) :

  null;

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "SlideInPanel" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: classnames_default()('wrapper', { visible: isVisible }) }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("h3", { className: "header" },
    headerText, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { className: "closeButton", id: "close", onClick: onCloseClick })),

    children),

    blockUi));


};

slide_in_panel_SlideInPanel.propTypes = {
  onCloseClick: prop_types_default.a.func.isRequired,
  children: prop_types_default.a.node.isRequired,
  isVisible: prop_types_default.a.bool,
  headerText: prop_types_default.a.string
};

slide_in_panel_SlideInPanel.defaultProps = {
  isVisible: false,
  headerText: ''
};

/* harmony default export */ var components_slide_in_panel = (slide_in_panel_SlideInPanel);
// EXTERNAL MODULE: ./src/components/text.less
var components_text = __webpack_require__(214);

// CONCATENATED MODULE: ./src/components/text.jsx
var text_excluded = ["input", "meta"];function text_extends() {text_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return text_extends.apply(this, arguments);}function text_objectWithoutProperties(source, excluded) {if (source == null) return {};var target = text_objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function text_objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}





var text_Text = function Text(props) {
  var input = props.input,meta = props.meta,otherProps = text_objectWithoutProperties(props, text_excluded); // eslint-disable-line no-unused-vars

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_form_field, text_extends({}, otherProps, { meta: meta }), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("input", text_extends({},
    otherProps,
    input))));


};

text_Text.propTypes = {
  type: prop_types_default.a.oneOf(['text', 'password', 'number']),
  input: prop_types_default.a.object.isRequired, // eslint-disable-line
  meta: components_form_field.propTypes.meta,
  autoComplete: prop_types_default.a.string,
  placeholder: prop_types_default.a.string,
  label: components_form_field.propTypes.label,
  className: components_form_field.propTypes.className
};

text_Text.defaultProps = {
  type: 'text',
  label: components_form_field.defaultProps.label,
  meta: components_form_field.defaultProps.meta,
  className: '',
  autoComplete: null,
  placeholder: null
};

/* harmony default export */ var src_components_text = (text_Text);
// EXTERNAL MODULE: ./src/components/toggle-button.less
var toggle_button = __webpack_require__(215);

// EXTERNAL MODULE: ./src/components/toggle-button-rebrand.less
var toggle_button_rebrand = __webpack_require__(216);

// CONCATENATED MODULE: ./src/components/toggle-button.jsx
function toggle_button_typeof(obj) {"@babel/helpers - typeof";return toggle_button_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, toggle_button_typeof(obj);}function toggle_button_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function toggle_button_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function toggle_button_createClass(Constructor, protoProps, staticProps) {if (protoProps) toggle_button_defineProperties(Constructor.prototype, protoProps);if (staticProps) toggle_button_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function toggle_button_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) toggle_button_setPrototypeOf(subClass, superClass);}function toggle_button_setPrototypeOf(o, p) {toggle_button_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return toggle_button_setPrototypeOf(o, p);}function toggle_button_createSuper(Derived) {var hasNativeReflectConstruct = toggle_button_isNativeReflectConstruct();return function _createSuperInternal() {var Super = toggle_button_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = toggle_button_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return toggle_button_possibleConstructorReturn(this, result);};}function toggle_button_possibleConstructorReturn(self, call) {if (call && (toggle_button_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return toggle_button_assertThisInitialized(self);}function toggle_button_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function toggle_button_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function toggle_button_getPrototypeOf(o) {toggle_button_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return toggle_button_getPrototypeOf(o);}






/**
 * Pass in a numeric id for onToggleChange to work
 */var
toggle_button_ToggleButton = /*#__PURE__*/function (_Component) {toggle_button_inherits(ToggleButton, _Component);var _super = toggle_button_createSuper(ToggleButton);
  function ToggleButton(props) {var _this;toggle_button_classCallCheck(this, ToggleButton);
    _this = _super.call(this, props);
    _this.onChange = _this.onChange.bind(toggle_button_assertThisInitialized(_this));return _this;
  }toggle_button_createClass(ToggleButton, [{ key: "onChange", value:

    function onChange() {
      var _this$props = this.props,disabled = _this$props.disabled,id = _this$props.id,onToggleChange = _this$props.onToggleChange;
      // After you select a button it needs to de-focus so it doesn't have the blue focus border.
      this.button.blur();
      if (!disabled && id) onToggleChange(id);
    } }, { key: "render", value:

    function render() {var _this2 = this;
      var style = {};
      var _this$props2 =

        this.props,image = _this$props2.image,size = _this$props2.size,color = _this$props2.color,showText = _this$props2.showText,active = _this$props2.active,disabled = _this$props2.disabled,title = _this$props2.title,name = _this$props2.name;
      if (image) style.backgroundImage = "url(".concat(image, ")");
      if (color) style.backgroundColor = "".concat(color);

      var classname = classnames_default()('ToggleButton uic', size, {
        hasImage: image,
        noText: !showText,
        active: active,
        disabled: disabled
      });

      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("button", {
          type: "button",
          className: classname,
          ref: function ref(el) {_this2.button = el;},
          onClick: this.onChange,
          title: title }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "content", style: style },
        showText ? name : null)));



    } }]);return ToggleButton;}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);


toggle_button_ToggleButton.propTypes = {
  name: prop_types_default.a.string.isRequired,
  id: prop_types_default.a.number,
  onToggleChange: prop_types_default.a.func.isRequired,
  image: prop_types_default.a.string,
  color: prop_types_default.a.string,
  size: prop_types_default.a.string,
  showText: prop_types_default.a.bool,
  active: prop_types_default.a.bool,
  disabled: prop_types_default.a.bool,
  title: prop_types_default.a.string
};

toggle_button_ToggleButton.defaultProps = {
  id: null,
  image: null,
  color: null,
  title: null,
  showText: true,
  active: false,
  disabled: false,
  size: 'medium'
};


/* harmony default export */ var components_toggle_button = (toggle_button_ToggleButton);
// EXTERNAL MODULE: ./src/components/wistia-button/wistia-button.less
var wistia_button = __webpack_require__(217);

// EXTERNAL MODULE: ./src/components/wistia-button/wistia-button-rebrand.less
var wistia_button_rebrand = __webpack_require__(218);

// CONCATENATED MODULE: ./src/components/wistia-button/wistia-button.jsx
function wistia_button_typeof(obj) {"@babel/helpers - typeof";return wistia_button_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, wistia_button_typeof(obj);}function wistia_button_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function wistia_button_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function wistia_button_createClass(Constructor, protoProps, staticProps) {if (protoProps) wistia_button_defineProperties(Constructor.prototype, protoProps);if (staticProps) wistia_button_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function wistia_button_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) wistia_button_setPrototypeOf(subClass, superClass);}function wistia_button_setPrototypeOf(o, p) {wistia_button_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return wistia_button_setPrototypeOf(o, p);}function wistia_button_createSuper(Derived) {var hasNativeReflectConstruct = wistia_button_isNativeReflectConstruct();return function _createSuperInternal() {var Super = wistia_button_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = wistia_button_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return wistia_button_possibleConstructorReturn(this, result);};}function wistia_button_possibleConstructorReturn(self, call) {if (call && (wistia_button_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return wistia_button_assertThisInitialized(self);}function wistia_button_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function wistia_button_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function wistia_button_getPrototypeOf(o) {wistia_button_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return wistia_button_getPrototypeOf(o);}







/**
 * Wistia Button for Wistia video Popovers.
 * For Wistia dev docs, see https://wistia.com/support/developers
 * ^ Warning, their dev docs are poorly organized.
 */var
wistia_button_WistiaButton = /*#__PURE__*/function (_Component) {wistia_button_inherits(WistiaButton, _Component);var _super = wistia_button_createSuper(WistiaButton);














  function WistiaButton() {var _this;wistia_button_classCallCheck(this, WistiaButton);
    _this = _super.call(this);
    _this.timeout = null;
    _this.state = {
      includeWistia: false
    };
    _this.showPopover = _this.showPopover.bind(wistia_button_assertThisInitialized(_this));return _this;
  }wistia_button_createClass(WistiaButton, [{ key: "componentDidMount", value:

    function componentDidMount() {var _this2 = this;
      var shareLink = this.props.shareLink;
      var videoId = WistiaButton.getVideoId(shareLink);
      if (videoId) {
        /* eslint-disable no-underscore-dangle */
        // Add video to Wistia queue, store ref to it's video object
        window._wq = window._wq || [];
        window._wq.push({
          id: videoId,
          async: true,
          popover: true,
          popoverContent: 'link',
          onReady: function onReady(videoRef) {
            _this2.videoRef = videoRef;
          }
        });
        /* eslint-enable no-underscore-dangle */
      }
    } }, { key: "componentWillUnmount", value:

    function componentWillUnmount() {var _this3 = this;
      if (this.videoRef) {
        this.videoRef.popover.hide();
        setTimeout(function () {return _this3.videoRef.remove();});
      }
      clearTimeout(this.timeout);
    }

    /**
     * After the video has loaded, we can interact with it via
     * Wistia's JS api
     */ }, { key: "showPopover", value:
    function showPopover() {var _this4 = this;
      this.setState({ includeWistia: true });

      clearTimeout(this.timeout);

      var playIfReady = function playIfReady() {
        if (_this4.videoRef) {
          _this4.videoRef.popover.show();
          setTimeout(function () {return _this4.videoRef.play();});
        } else {
          _this4.timeout = setTimeout(function () {return playIfReady();}, 50);
        }
      };

      playIfReady();
    } }, { key: "render", value:

    function render() {
      var _this$props =






        this.props,buttonText = _this$props.buttonText,className = _this$props.className,preload = _this$props.preload,shareLink = _this$props.shareLink,size = _this$props.size,type = _this$props.type;

      var
      includeWistia =
      this.state.includeWistia;

      var isPlayButton = type === 'playButton';
      var buttonType = isPlayButton ? 'clearButton' : type;
      var icon = isPlayButton ? 'play-button' : 'play-circle';
      var text = isPlayButton ? null : buttonText;

      var videoId = WistiaButton.getVideoId(shareLink);

      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: classnames_default()('WistiaButton-wrapper uic', { playButton: isPlayButton }) },
        includeWistia ? /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(external_commonjs_react_helmet_commonjs2_react_helmet_amd_ReactHelmet_root_ReactHelmet_default.a, null, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("script", { src: "https://fast.wistia.com/assets/external/E-v1.js", type: "text/javascript", async: true })) :

        null, /*#__PURE__*/


        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", {
          className:
          classnames_default()(
          'wistia_embed', "wistia_async_".concat(
          videoId),
          'popover=true',
          {
            'preload=true': preload
          }) }), /*#__PURE__*/


        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_button, {
          icon: icon,
          onClick: this.showPopover,
          "aria-label": "Play Button for video: ".concat(buttonText),
          type: buttonType,
          size: size,
          className: classnames_default()('WistiaButton', className, { playButton: isPlayButton }) },

        text)));



    } }], [{ key: "getVideoId", value: /**
     * Helper to extract the video id from a Wistia share link
     * Example format: https://glowforge.wistia.com/medias/xotlq75gkt
     * @param {String} shareLink Link from Wistia's share feature for a video
     */function getVideoId(shareLink) {// Regexp to extract the video id from a Wistia share url.\
      // The final group is the only one matched, and is in the [1] position.
      // Wistia provided this Regex
      var regexp = /https?:\/\/(?:.+)?(?:wistia\.com|wi\.st)\/(?:medias|embed)\/(.*)/;var groups = shareLink.match(regexp);return groups && groups[1];} }]);return WistiaButton;}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);wistia_button_WistiaButton.propTypes = { buttonText: prop_types_default.a.string, className: prop_types_default.a.string, preload: prop_types_default.a.bool, shareLink: prop_types_default.a.string,
  size: prop_types_default.a.oneOf(['small', 'medium', 'large']),
  type: prop_types_default.a.oneOf(['text', 'default', 'primary', 'secondary', 'playButton'])
};

wistia_button_WistiaButton.defaultProps = {
  buttonText: '',
  className: '',
  preload: false,
  shareLink: '',
  size: 'medium',
  type: 'default'
};

/* harmony default export */ var wistia_button_wistia_button = (wistia_button_WistiaButton);
// CONCATENATED MODULE: ./src/components/wistia-button/index.js

// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(24);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);

// CONCATENATED MODULE: ./src/components/with-popover.jsx
function with_popover_typeof(obj) {"@babel/helpers - typeof";return with_popover_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, with_popover_typeof(obj);}function with_popover_extends() {with_popover_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return with_popover_extends.apply(this, arguments);}function with_popover_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function with_popover_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function with_popover_createClass(Constructor, protoProps, staticProps) {if (protoProps) with_popover_defineProperties(Constructor.prototype, protoProps);if (staticProps) with_popover_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function with_popover_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) with_popover_setPrototypeOf(subClass, superClass);}function with_popover_setPrototypeOf(o, p) {with_popover_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return with_popover_setPrototypeOf(o, p);}function with_popover_createSuper(Derived) {var hasNativeReflectConstruct = with_popover_isNativeReflectConstruct();return function _createSuperInternal() {var Super = with_popover_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = with_popover_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return with_popover_possibleConstructorReturn(this, result);};}function with_popover_possibleConstructorReturn(self, call) {if (call && (with_popover_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return with_popover_assertThisInitialized(self);}function with_popover_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function with_popover_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function with_popover_getPrototypeOf(o) {with_popover_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return with_popover_getPrototypeOf(o);}







function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var ClosablePopopver = keyboardCommands(
on_click_outside(popover_Popover),
[{
  keys: 'escape',
  connectCommand: function connectCommand(props) {
    if (props.onRequestClose) {props.onRequestClose();}
  }
}]);


var currentInstanceID = 0;

/**
 * @typedef {Object} withPopoverOptions All of these are optional
 * @property {String} targetDirection 'left' | 'right' | 'up' | 'down', (default is 'down')
 * @property {String} anchorTargetAlign 'start' | 'end', (default is 'start')
 * @property {String} class to put on the button wrapping the anchor
 *
 * @param {Object} props
 * @param {React.Component} props.Anchor Anchor component to toggle open/close
 * @param {React.Component} props.Content Component that is rendered in popover
 * @param {withPopoverOptions?} props.options
 *
 * A higher order component for creating a popover for a given anchor with the given content
 * Usage: withPopover(anchor, content, options)
 *
 * The popover can be closed from the Content component via the requestPopoverClose method
 * passed to the Content component as a prop.
 *
 * Examples for targetDirection and anchorTargetAlign:
 * targetDirection = 'down', anchorTargetAlign = 'start'
 *  ------
 * |anchor|
 *  ------
 *  ---------
 * | popover |
 *  ---------
 *
 * targetDirection = 'down', anchorTargetAlign = 'end'
 *      ------
 *     |anchor|
 *      ------
 *   ---------
 *  | popover |
 *   ---------
 *
 * targetDirection = 'right', anchorTargetAlign = 'end'
 *          ---------
 *         | popover |
 *  ------ |         |
 * |anchor||         |
 *  ------  ---------
 *
 * If you wish to control the visibility of the popover from the outside provide the following props
 *
 * popoverOpen: boolean representing if the popover is open
 * onClickAnchor: Callback that will be passed the current open state of the popover.
 *
 * Legacy:
 * onClosePopover: method that closes the popover so that click away and escape keys can work
 */
function withPopover(Anchor, Content) {var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};var
  WithPopover = /*#__PURE__*/function (_React$Component) {with_popover_inherits(WithPopover, _React$Component);var _super = with_popover_createSuper(WithPopover);
    function WithPopover(props) {var _this;with_popover_classCallCheck(this, WithPopover);
      _this = _super.call(this, props);
      var popoverOpen = props.popoverOpen;

      // unique key to identify this instance
      currentInstanceID += 1;
      _this.instanceId = currentInstanceID;

      _this.onClickAnchor = _this.onClickAnchor.bind(with_popover_assertThisInitialized(_this));
      if (_this.onClosePopover) {
        _this.onClosePopover = _this.onClosePopover.bind(with_popover_assertThisInitialized(_this));
      }

      _this.state = {
        popoverOpen: popoverOpen || false
      };return _this;
    }with_popover_createClass(WithPopover, [{ key: "onClickAnchor", value:










      function onClickAnchor() {
        var _this$props = this.props,onClosePopover = _this$props.onClosePopover,onClickAnchor = _this$props.onClickAnchor;
        var popoverOpen = this.state.popoverOpen;

        /**
         * When the component is controlled (popoverOpen !== undefined)
         * we want to fire this callback any time the anchor is clicked.
         */
        if (onClickAnchor && popoverOpen !== undefined) {
          onClickAnchor(popoverOpen);
          return;
        }

        /**
         * Legacy functionality, onClosePopover() was only called when
         * popoverOpen is true. There was previously no way to re-open
         * a closed popover.
         */
        // only toggle on state if we are not controlling it from props
        if (onClosePopover && popoverOpen) {
          onClosePopover();
          return;
        }

        this.setState({
          popoverOpen: !popoverOpen
        });
      } }, { key: "onClosePopover", value:

      function onClosePopover() {
        var onClosePopover = this.props.onClosePopover;
        // only toggle on state if we are not controlling it from props
        if (onClosePopover) {
          onClosePopover();
        }
        this.setState({
          popoverOpen: false
        });
      } }, { key: "renderPopover", value:

      function renderPopover(instanceClass) {
        var popoverOpen = this.state.popoverOpen;
        var clickOutsideToClose = this.props.clickOutsideToClose;

        return /*#__PURE__*/(
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "Popover-position" }, /*#__PURE__*/
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "Popover-position-safari-fix" }, /*#__PURE__*/
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "Popover-arrow" }), /*#__PURE__*/
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(ClosablePopopver, {
            open: popoverOpen,
            onRequestClose: clickOutsideToClose ? this.onClosePopover : null
            // exclude the target itself from clickoutside so the popover's
            //  visibility is toggled
            , outsideClickIgnoreClass: instanceClass }, /*#__PURE__*/
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Content, with_popover_extends({}, this.props, { requestPopoverClose: this.onClosePopover }))))));




      } }, { key: "render", value:

      function render() {var _this2 = this;
        // adjust popover position based on targetDirection and anchorTargetAlign
        // set the proper class name. Actual adjustment happens in css.
        var positionClass = options ? "".concat(
        options.targetDirection || 'down', " ").concat(options.anchorTargetAlign || 'start') :
        'down start';

        // use a unique instance class so that every anchor is tracked separately
        // and clicking from one anchor to another closes the popout properly
        var instanceClass = "Popover-instance-".concat(this.instanceId);

        var className = this.props.className;
        var popoverOpen = this.state.popoverOpen;
        var topLevelClasses = bind_default()({ header: options.hasHeader },
        ['Popover-container', positionClass, className]);

        return /*#__PURE__*/(
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: topLevelClasses }, /*#__PURE__*/
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("button", {
            type: "button",
            className: bind_default()({
              open: popoverOpen
            }, ['Popover-anchor', instanceClass, options.anchorClass]),
            onClick: this.onClickAnchor }, /*#__PURE__*/
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Anchor, this.props)),


          includeWhen(popoverOpen, function () {return _this2.renderPopover(instanceClass);})));


      } }], [{ key: "getDerivedStateFromProps", value: function getDerivedStateFromProps(_ref) {var popoverOpen = _ref.popoverOpen; // override state if externally controlled
        if (popoverOpen !== undefined) {return { popoverOpen: popoverOpen };} // keep internal state if not externally controlled
        return null;} }]);return WithPopover;}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Component);
  WithPopover.propTypes = {
    className: prop_types_default.a.string,
    clickOutsideToClose: prop_types_default.a.bool,
    onClickAnchor: prop_types_default.a.func,
    onClosePopover: prop_types_default.a.func,
    popoverOpen: prop_types_default.a.bool
  };

  WithPopover.defaultProps = {
    className: '',
    clickOutsideToClose: true,
    onClickAnchor: undefined,
    onClosePopover: undefined,
    popoverOpen: undefined
  };

  WithPopover.displayName = "WithPopover(".concat(getDisplayName(Anchor), ")");
  return WithPopover;
}
// CONCATENATED MODULE: ./src/components/navigation/navigation-item.jsx





/**
 * NavigationItem provides interprets individual entries in a TopNav config.
 * Clients of TopNav can choose to pass their own implementation in order to
 * provide custom logic or link types, such as react-isomorphic-router Link
 * components, for their own use cases. This ui common implementaiton provides
 * a reasonable default and a base to work from for clients that need
 * specialized logic.
 */
var navigation_item_NavigationItem = function NavigationItem(_ref) {var tab = _ref.tab,className = _ref.className,onClick = _ref.onClick;
  var _ref2 =







    tab || {},disabled = _ref2.disabled,secondary = _ref2.secondary,separator = _ref2.separator,url = _ref2.url,text = _ref2.text,openInNewTab = _ref2.openInNewTab,active = _ref2.active;

  if (disabled || secondary) return null;

  var item = null;
  if (separator) {
    item = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("hr", { className: "navSeparator" });
  } else {
    var classes = classnames_default()(className, { active: active });
    item = /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("a", {
      className: classes,
      href: url,
      target: openInNewTab ? '_blank' : '_self',
      onClick: onClick },
    text);


  }

  return item;
};

navigation_item_NavigationItem.propTypes = {
  tab: prop_types_default.a.shape({
    enabled: prop_types_default.a.bool,
    secondary: prop_types_default.a.bool,
    separator: prop_types_default.a.bool,
    local: prop_types_default.a.bool,
    url: prop_types_default.a.string,
    text: prop_types_default.a.string,
    openInNewTab: prop_types_default.a.bool
  }).isRequired,
  className: prop_types_default.a.oneOf([
  // NavigationItem's a tag could be styled as a clear link (without hover/contrasting color/under
  // -line styles.
  'clearLink']),

  onClick: prop_types_default.a.func
};

navigation_item_NavigationItem.defaultProps = {
  className: null,
  onClick: lodash_default.a.noop
};

/* harmony default export */ var navigation_item = (navigation_item_NavigationItem);
// CONCATENATED MODULE: ./src/contentful-widgets/button-link.jsx
function button_link_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function button_link_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? button_link_ownKeys(Object(source), !0).forEach(function (key) {button_link_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : button_link_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function button_link_defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function button_link_extends() {button_link_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return button_link_extends.apply(this, arguments);}






/**
 * Maps to the ButtonLink content model on Contentful
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/buttonLink/fields}
 */
var button_link_ButtonLinkWidget = function ButtonLinkWidget(_ref) {var model = _ref.model;
  var icon = lodash_default.a.get(model, 'fields.icon.fields.id');
  icon = icon && /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { id: icon, className: "buttonIcon" });

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(button_link, button_link_extends({}, lodash_default.a.get(model, 'fields'), { icon: icon })));

};

button_link_ButtonLinkWidget.propTypes = {
  model: prop_types_default.a.shape({
    fields: prop_types_default.a.shape(button_link_objectSpread({},
    buttonLinkPropTypes))

  })
};

button_link_ButtonLinkWidget.defaultProps = {
  model: {}
};

registerWidget('buttonLink', button_link_ButtonLinkWidget);

/* harmony default export */ var contentful_widgets_button_link = (button_link_ButtonLinkWidget);
// EXTERNAL MODULE: ./src/components/footer/footer.less
var footer = __webpack_require__(219);

// CONCATENATED MODULE: ./src/components/footer/footer.jsx







// ensure button-link widget is registered with Sections




var footer_Footer = function Footer(_ref)






{var globalFooterLinks = _ref.globalFooterLinks,globalFooterLogo = _ref.globalFooterLogo,globalFooterCopyright = _ref.globalFooterCopyright,globalFooterAddress = _ref.globalFooterAddress,NavigationItem = _ref.NavigationItem,children = _ref.children;
  var footerLinks = lodash_default.a.map(globalFooterLinks, function (group, index) {return /*#__PURE__*/(
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "grouping", key: index }, /*#__PURE__*/
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "title" }, group.title), /*#__PURE__*/
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_contentful_views_sections, { sections: group.items })));});



  // Notes:
  // privacy policy is still served from ecomm-core, so don't attempt to use react-isomorphic-link
  // children: render any extra content above the sitemap + company info, in this footer
  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "Footer" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "marketing" },
    children, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "links" },
    footerLinks)), /*#__PURE__*/


    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "companyInfo" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { className: "logo", core: false, svgAsset: globalFooterLogo }), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("a", { className: "csLink", href: "mailto:hello@glowforge.com" }, "hello@glowforge.com"), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "copyright" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, { source: globalFooterCopyright }), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "legal" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(NavigationItem, {
      tab: {
        local: false,
        text: 'Terms of Purchase and Service',
        url: '/terms'
      } }), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(NavigationItem, {
      tab: {
        local: false,
        text: 'Privacy Policy',
        url: '/privacy-policy'
      } }), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(NavigationItem, {
      tab: {
        local: false,
        text: 'Referral Program Terms',
        url: '/m/referral-terms'
      } })), /*#__PURE__*/

    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "address" }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, { source: globalFooterAddress }))))));




};

footer_Footer.propTypes = {
  // Contentful driven props -
  //    Footer is mostly populated from the raw contentful `global-footer`
  //    section data

  // globalFooterLinks: extracted from fields.content[{fields: {title, listItems}}]
  //  into fields.content[{title, items}] for only buttonLink items.
  //  This eventually gets applied as the grouped links for the left-side sitemap under
  //  .marketing > .links
  globalFooterLinks: prop_types_default.a.arrayOf(prop_types_default.a.any).isRequired,
  // globalFooterLogo: extracted from an entry in fields.content that has
  //   fields.id: 'glowforge-footer-logo', with the value from fields.svgAsset.
  //   Used in the companyInfo logo div
  globalFooterLogo: prop_types_default.a.objectOf(prop_types_default.a.any).isRequired,
  // globalFooterCopyright: from a fields.text field in fields.content with a footer-copyright id
  //   Used in the companyInfo div
  globalFooterCopyright: prop_types_default.a.string.isRequired,
  // globalFooterCopyright: from a fields.text field in fields.content, id: footer-company-address
  //   Used in the companyInfo div
  globalFooterAddress: prop_types_default.a.string.isRequired,

  // A NavigationItem component (see ui-common and ecomm-frontend declarations).
  NavigationItem: prop_types_default.a.func,

  // React elements to insert above the grouped links (sitemap), within the marketing div
  //   Currently used for email marketing sign-up.
  children: prop_types_default.a.oneOfType([prop_types_default.a.arrayOf(prop_types_default.a.node), prop_types_default.a.node])
};

footer_Footer.defaultProps = {
  NavigationItem: navigation_item,
  children: null
};

/* harmony default export */ var footer_footer = (footer_Footer);
// CONCATENATED MODULE: ./src/components/navigation/user-menu.jsx







function user_menu_Anchor(props) {
  var user = props.user;
  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", null, userDisplayName(user));
}

user_menu_Anchor.propTypes = {
  user: prop_types_default.a.shape({}).isRequired
};

/**
 * UserMenu is a sub navigation for User related routes on desktop sized screens.
 * It is rendered inside of a popover.
 */
function UserMenu(_ref)



{var routes = _ref.routes,secondaryLinks = _ref.secondaryLinks,user = _ref.user;
  var subMenu = lodash_default.a.map(secondaryLinks, function (item, index) {return /*#__PURE__*/(
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { key: index }, /*#__PURE__*/
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(navigation_item, { tab: item, className: "clearLink" })));});



  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "UserMenu" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "secondaryLinks" }, subMenu), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "user" }, "Logged in as", /*#__PURE__*/

    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "full-name" }, userFullName(user))), /*#__PURE__*/

    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(navigation_item, { tab: routes.settings }), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "divider" }, "|"), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(navigation_item, { tab: routes.logout })));


}

UserMenu.propTypes = {
  routes: prop_types_default.a.shape({
    settings: prop_types_default.a.object,
    logout: prop_types_default.a.object,
    login: prop_types_default.a.object
  }),
  user: prop_types_default.a.shape({}).isRequired,
  secondaryLinks: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    url: prop_types_default.a.string,
    text: prop_types_default.a.string
  }))
};

UserMenu.defaultProps = {
  secondaryLinks: [],
  routes: {}
};

/* harmony default export */ var user_menu = (withPopover(user_menu_Anchor, UserMenu, {
  anchorTargetAlign: 'end',
  anchorClass: 'UserMenuAnchor clearButton'
}));
// EXTERNAL MODULE: ./src/components/navigation/top-nav.less
var top_nav = __webpack_require__(220);

// CONCATENATED MODULE: ./src/components/navigation/top-nav.jsx
function top_nav_typeof(obj) {"@babel/helpers - typeof";return top_nav_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, top_nav_typeof(obj);}function top_nav_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function top_nav_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? top_nav_ownKeys(Object(source), !0).forEach(function (key) {top_nav_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : top_nav_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function top_nav_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function top_nav_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function top_nav_createClass(Constructor, protoProps, staticProps) {if (protoProps) top_nav_defineProperties(Constructor.prototype, protoProps);if (staticProps) top_nav_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function top_nav_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) top_nav_setPrototypeOf(subClass, superClass);}function top_nav_setPrototypeOf(o, p) {top_nav_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return top_nav_setPrototypeOf(o, p);}function top_nav_createSuper(Derived) {var hasNativeReflectConstruct = top_nav_isNativeReflectConstruct();return function _createSuperInternal() {var Super = top_nav_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = top_nav_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return top_nav_possibleConstructorReturn(this, result);};}function top_nav_possibleConstructorReturn(self, call) {if (call && (top_nav_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return top_nav_assertThisInitialized(self);}function top_nav_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function top_nav_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function top_nav_getPrototypeOf(o) {top_nav_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return top_nav_getPrototypeOf(o);}function top_nav_defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}





// eslint-disable-next-line import/no-named-as-default








var userPropType = prop_types_default.a.shape({
  first_name: prop_types_default.a.string,
  last_name: prop_types_default.a.string
});

var routePropType = prop_types_default.a.shape({
  link: prop_types_default.a.node,
  separator: prop_types_default.a.bool,
  disabled: prop_types_default.a.bool
});

/**
 * Top Navigation for a Glowforge site.
 * This is currently used by ecomm and discover pages. It provides different
 * styles for marketing pages vs. shop/catalog/order pages. The contents of the
 * nav bar are controlled by several configuration properties that contain
 * information about what routes should be linked to from different sections of
 * the nav bar. The main sections, from left to right, are:
 *  - Logo -  the Glowforge logo bug is a link controlled by a simple url passed
 *    as logoLink.
 *  - Primary Tabs - the main navigational links that take up most of the nav
 *    bar. These are expected as an array of routes (see routePropType).
 *  - Button Section - attached to the right side of the navbar, the button
 *    section provides a prominent call to action for an entire page. This is
 *    implemented as the buttonSection prop, which expects a React node since
 *    its implementation is very differnt depending on the client.
 *  - User Menu - at the far right is the user menu, which has a set of fixed
 *    routes (settings, logout, and login) as well as an array of secondary
 *    routes. See user-menu.jsx for more details.
 *
 * Also see top-nav.sandbox.jsx for example usage of the TopNav component.
 */var
top_nav_TopNav = /*#__PURE__*/function (_Component) {top_nav_inherits(TopNav, _Component);var _super = top_nav_createSuper(TopNav);


























  function TopNav(props) {var _this;top_nav_classCallCheck(this, TopNav);
    _this = _super.call(this, props);top_nav_defineProperty(top_nav_assertThisInitialized(_this), "getUserSection",










    function () {
      var _this$props =





        _this.props,user = _this$props.user,hideUserSection = _this$props.hideUserSection,userRoutes = _this$props.userRoutes,userSecondaryLinks = _this$props.userSecondaryLinks,NavigationItem = _this$props.NavigationItem;

      if (hideUserSection) return null;

      // User is in pending state if user is undefined (default prop)
      // User is either an empty object (not signed in) or an object with data (signed in)
      // This allows a fade in of the sign in link, which prevents the `Buy Now` from jumping
      // Only apparent on pages that don't preload user data on server
      var pendingUser = user === undefined;
      if (lodash_default.a.isEmpty(user) || pendingUser) {
        return /*#__PURE__*/(
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: classnames_default()('signIn', { pendingUser: pendingUser }) }, /*#__PURE__*/
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(NavigationItem, { tab: userRoutes.login, className: "clearLink" })));


      }
      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(user_menu, {
          routes: userRoutes,
          secondaryLinks: userSecondaryLinks,
          user: user }));

    });top_nav_defineProperty(top_nav_assertThisInitialized(_this), "mobileUserSection",

    function () {
      var _this$props2 =



        _this.props,hideUserSection = _this$props2.hideUserSection,userRoutes = _this$props2.userRoutes,user = _this$props2.user;

      if (hideUserSection) return [];

      // user signed in routes.
      if (!lodash_default.a.isEmpty(user)) {
        return [
        { separator: true, mobileOnly: true }, top_nav_objectSpread(top_nav_objectSpread({},

        userRoutes.settings), {}, {
          text: userFullName(user),
          mobileOnly: true }), top_nav_objectSpread(top_nav_objectSpread({},


        userRoutes.referrals), {}, {
          mobileOnly: true }), top_nav_objectSpread(top_nav_objectSpread({},


        userRoutes.logout), {}, {
          mobileOnly: true })];


      }
      // user not signed in routes
      return [
      { separator: true, mobileOnly: true }, top_nav_objectSpread(top_nav_objectSpread({},

      userRoutes.login), {}, {
        mobileOnly: true })];


    });top_nav_defineProperty(top_nav_assertThisInitialized(_this), "getNavigationItems",





    function () {
      var _this$props3 =


        _this.props,primaryRoutes = _this$props3.primaryRoutes,NavigationItem = _this$props3.NavigationItem;

      return lodash_default()(primaryRoutes.concat(_this.mobileUserSection())).
      filter(Boolean).
      filter(function (tab) {return !tab.disabled;}).
      map(function (tab, index) {return /*#__PURE__*/(
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("li", {
            className: "item ".concat(tab.mobileOnly ? 'mobile-only' : ''),
            key: tab.url || index }, /*#__PURE__*/
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(NavigationItem, { tab: tab, onClick: _this.closeNav, className: "clearLink" })));}).


      value();
    });top_nav_defineProperty(top_nav_assertThisInitialized(_this), "toggleNav",




    function () {
      var showMobileNav = _this.state.showMobileNav;
      _this.setState({ showMobileNav: !showMobileNav });
    });top_nav_defineProperty(top_nav_assertThisInitialized(_this), "closeNav",




    function () {
      _this.setState({ showMobileNav: false });
    });top_nav_defineProperty(top_nav_assertThisInitialized(_this), "handleClickOutside",




    function () {
      _this.closeNav();
    });_this.state = { showMobileNav: false };return _this;} /**
   * Gets the user section if signed in, otherwise shows a login tab.
   * If hidden, returns null.
   * @returns {Node}
   */top_nav_createClass(TopNav, [{ key: "render", value: function render() {var navItems = this.getNavigationItems();var userSection = this.getUserSection();

      var _this$props4 =




        this.props,hideNavLinks = _this$props4.hideNavLinks,marketing = _this$props4.marketing,logoLink = _this$props4.logoLink,buttonSection = _this$props4.buttonSection;
      var
      showMobileNav =
      this.state.showMobileNav;

      // Show menu button if nav links explicitly hidden or there are nav items to show
      var menuButton = hideNavLinks || !lodash_default.a.isEmpty(navItems) ? /*#__PURE__*/
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { className: "menuButton", id: "menu", onClick: this.toggleNav }) :
      null;

      var userSectionClasses = classnames_default()('userSection', {
        'mobile-hidden': !lodash_default.a.isEmpty(navItems)
      });

      var navClassses = classnames_default()('TopNav', {
        noNavLinks: lodash_default.a.isEmpty(navItems),
        MarketingNavigation: marketing
      });

      var tabsClasses = classnames_default()('tabs', {
        show: showMobileNav
      });

      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { role: "navigation", className: navClassses }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "icon brand" }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("a", {
          href: logoLink,
          className: "logo legacy" }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { className: "mobile", id: "glowforge-icon" })), /*#__PURE__*/

        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("a", {
          href: logoLink,
          className: "logo rebrand" }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { className: "desktop", id: "glowforge-logo" }), /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(src_components_svg, { className: "mobile", id: "glowforge-icon" }))), /*#__PURE__*/


        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("ul", { className: tabsClasses },
        navItems), /*#__PURE__*/

        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "mobileButtonSection" },
        buttonSection), /*#__PURE__*/

        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "menuSection" }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "desktopButtonSection" },
        buttonSection), /*#__PURE__*/

        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: userSectionClasses },
        userSection),

        menuButton)));



    } }]);return TopNav;}(external_commonjs_react_commonjs2_react_amd_React_root_React_["Component"]);top_nav_defineProperty(top_nav_TopNav, "propTypes", { logoLink: prop_types_default.a.string, user: userPropType, userRoutes: prop_types_default.a.objectOf(routePropType), userSecondaryLinks: prop_types_default.a.arrayOf(routePropType), primaryRoutes: prop_types_default.a.arrayOf(routePropType), buttonSection: prop_types_default.a.node, hideNavLinks: prop_types_default.a.bool, hideUserSection: prop_types_default.a.bool, marketing: prop_types_default.a.bool, NavigationItem: prop_types_default.a.func });top_nav_defineProperty(top_nav_TopNav, "defaultProps", { user: undefined, logoLink: 'https://glowforge.com', userRoutes: {}, userSecondaryLinks: [], primaryRoutes: [], buttonSection: null, hideNavLinks: false, hideUserSection: false, marketing: false, NavigationItem: navigation_item });


/* harmony default export */ var navigation_top_nav = (on_click_outside(top_nav_TopNav));
// CONCATENATED MODULE: ./src/components/navigation/index.js

// eslint-disable-next-line import/prefer-default-export

// CONCATENATED MODULE: ./src/components/index.js


var reactUtils = react_utils_namespaceObject;







































// EXTERNAL MODULE: ./src/components/social/icons/share-alt-regular.svg
var share_alt_regular = __webpack_require__(49);
var share_alt_regular_default = /*#__PURE__*/__webpack_require__.n(share_alt_regular);

// EXTERNAL MODULE: ./src/components/social/icons/share-alt-light.svg
var share_alt_light = __webpack_require__(50);
var share_alt_light_default = /*#__PURE__*/__webpack_require__.n(share_alt_light);

// EXTERNAL MODULE: ./src/components/social/icons/envelope-solid.svg
var envelope_solid = __webpack_require__(51);
var envelope_solid_default = /*#__PURE__*/__webpack_require__.n(envelope_solid);

// EXTERNAL MODULE: ./src/components/social/icons/facebook-f-brands.svg
var facebook_f_brands = __webpack_require__(52);
var facebook_f_brands_default = /*#__PURE__*/__webpack_require__.n(facebook_f_brands);

// EXTERNAL MODULE: ./src/components/social/icons/linkedin-in-brands.svg
var linkedin_in_brands = __webpack_require__(53);
var linkedin_in_brands_default = /*#__PURE__*/__webpack_require__.n(linkedin_in_brands);

// EXTERNAL MODULE: ./src/components/social/icons/pinterest-p-brands.svg
var pinterest_p_brands = __webpack_require__(54);
var pinterest_p_brands_default = /*#__PURE__*/__webpack_require__.n(pinterest_p_brands);

// EXTERNAL MODULE: ./src/components/social/icons/tumblr-brands.svg
var tumblr_brands = __webpack_require__(55);
var tumblr_brands_default = /*#__PURE__*/__webpack_require__.n(tumblr_brands);

// EXTERNAL MODULE: ./src/components/social/icons/twitter-brands.svg
var twitter_brands = __webpack_require__(56);
var twitter_brands_default = /*#__PURE__*/__webpack_require__.n(twitter_brands);

// EXTERNAL MODULE: ./src/components/social/icons/instagram-brands.svg
var instagram_brands = __webpack_require__(57);
var instagram_brands_default = /*#__PURE__*/__webpack_require__.n(instagram_brands);

// EXTERNAL MODULE: ./src/components/social/social-icon.less
var social_icon = __webpack_require__(221);

// CONCATENATED MODULE: ./src/components/social/social-icon.jsx















var socialSites = [
'share',
'shareLight',
'email',
'facebook',
'linkedin',
'pinterest',
'tumblr',
'twitter',
'instagram'];


var social_icon_iconForSite = function iconForSite(site) {
  switch (site) {
    case 'share':
      return share_alt_regular_default.a;
    case 'shareLight':
      return share_alt_light_default.a;
    case 'email':
      return envelope_solid_default.a;
    case 'facebook':
      return facebook_f_brands_default.a;
    case 'linkedin':
      return linkedin_in_brands_default.a;
    case 'pinterest':
      return pinterest_p_brands_default.a;
    case 'tumblr':
      return tumblr_brands_default.a;
    case 'twitter':
      return twitter_brands_default.a;
    case 'instagram':
      return instagram_brands_default.a;
    default:
      return function () {return null;};}

};

/**
 * A Glowforge-standard icon representing the given social site. The general
 * approach is to use a field of the appropriate brand-color (e.g. facebook
 * blue, pinterest red) with a minimal logo bug over top. There are several
 * appearance variants provided:
 *
 * round - a round field dot
 * square - a square with rounded corners
 * clear - transparent background with the logo inheriting the current css
 *         `color`. This is useful for overlays.
 *
 * @param props
 * @param props.className - Applied to the div wrapping the svg
 * @param props.site - which social site?
 * @param props.size - standard sizes small, medium, or large
 * @param props.appearance - available styles square, round, clear
 * @returns {*}
 * @constructor
 */
var social_icon_SocialIcon = function SocialIcon(_ref)




{var className = _ref.className,site = _ref.site,size = _ref.size,appearance = _ref.appearance;
  var Icon = social_icon_iconForSite(site);

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: classnames_default()('SocialIcon', site, size, appearance, className) }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(Icon, { className: "icon" })));


};

social_icon_SocialIcon.propTypes = {
  className: prop_types_default.a.string,
  site: prop_types_default.a.oneOf(socialSites).isRequired,
  size: prop_types_default.a.oneOf(['small', 'medium', 'large', 'fit']),
  appearance: prop_types_default.a.oneOf(['square', 'round', 'clear'])
};

social_icon_SocialIcon.defaultProps = {
  className: '',
  size: 'medium',
  appearance: 'square'
};

/* harmony default export */ var social_social_icon = (social_icon_SocialIcon);
// EXTERNAL MODULE: ./src/components/social/share-button.less
var share_button = __webpack_require__(222);

// CONCATENATED MODULE: ./src/components/social/share-button.jsx
function share_button_typeof(obj) {"@babel/helpers - typeof";return share_button_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, share_button_typeof(obj);}function share_button_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function share_button_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? share_button_ownKeys(Object(source), !0).forEach(function (key) {share_button_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : share_button_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function share_button_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function share_button_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function share_button_createClass(Constructor, protoProps, staticProps) {if (protoProps) share_button_defineProperties(Constructor.prototype, protoProps);if (staticProps) share_button_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function share_button_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) share_button_setPrototypeOf(subClass, superClass);}function share_button_setPrototypeOf(o, p) {share_button_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return share_button_setPrototypeOf(o, p);}function share_button_createSuper(Derived) {var hasNativeReflectConstruct = share_button_isNativeReflectConstruct();return function _createSuperInternal() {var Super = share_button_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = share_button_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return share_button_possibleConstructorReturn(this, result);};}function share_button_possibleConstructorReturn(self, call) {if (call && (share_button_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return share_button_assertThisInitialized(self);}function share_button_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function share_button_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function share_button_getPrototypeOf(o) {share_button_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return share_button_getPrototypeOf(o);}function share_button_defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}






var emailBase = 'mailto:';
var facebookBase = 'https://www.facebook.com/sharer/sharer.php';
var linkedinBase = 'https://www.linkedin.com/shareArticle';
var pinterestBase = 'http://pinterest.com/pin/create/button/';
var tumblrBase = 'http://www.tumblr.com/share/link';
var twitterBase = 'https://twitter.com/intent/tweet';

// Simple helper to convert key-values into an url-safe query string, dropping
// any keys that have no value.
function queryString(map) {
  var encodedParams = lodash_default.a.chain(map).
  omitBy(lodash_default.a.isEmpty).
  map(function (value, key) {return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));}).
  join('&').
  value();

  return "?".concat(encodedParams);
}

/**
 * A Glowforge-standard social media site icon that can be clicked to launch a
 * popup prompting the user to share some content to that social site.
 * Depending on the site, different properties will be used or ignored. The
 * most commonly used properties are `url`, `hashtag`, and `text`. This
 * component will evolve to match Glowforge's standard for how share prompts
 * work on each site, as well as changes to each site's API, so clients should
 * pass data for as many props as possible to take advantage of new
 * functionality with future releases.
 *
 * @param site - which social site this button is for, e.g. 'facebook', 'twitter'
 * @param url - the url of the content being shared e.g. 'https://glowforge.com/akkika'
 * @param hashtag - do not include the # character e.g. 'glowforge'
 * @param text - the primary short-text to use as default content for the user's post
 * @param quote - a quote from Glowforge to include alongside the link iteslf
 * @param image - an image to share (only currently supported by pinterest)
 * @param props.size - passed on to SocialIcon - standard sizes small, medium, or large
 * @param props.appearance - passed on to SocialIcon - available styles square, round, clear
 * @returns {*}
 * @constructor
 */var
share_button_ShareButton = /*#__PURE__*/function (_React$PureComponent) {share_button_inherits(ShareButton, _React$PureComponent);var _super = share_button_createSuper(ShareButton);function ShareButton() {var _this;share_button_classCallCheck(this, ShareButton);for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}_this = _super.call.apply(_super, [this].concat(args));share_button_defineProperty(share_button_assertThisInitialized(_this), "showInWindow",

































    function (event) {
      var site = _this.props.site;
      event.preventDefault();
      window.open(_this.shareUrl(), "".concat(site, "-share-popup"), 'width=640,height=400');
    });return _this;}share_button_createClass(ShareButton, [{ key: "shareUrl", value:

    function shareUrl() {
      var _this$props =






        this.props,site = _this$props.site,url = _this$props.url,hashtag = _this$props.hashtag,text = _this$props.text,quote = _this$props.quote,image = _this$props.image;

      switch (site) {
        case 'email':
          return emailBase + queryString({ subject: text, body: url });
        case 'facebook':
          return facebookBase + queryString({ u: url, hashtag: "#".concat(hashtag), quote: quote });
        case 'linkedin':
          return linkedinBase + queryString({
            mini: 'true',
            url: url,
            summary: text,
            source: 'Glowforge'
          });
        case 'pinterest':
          return pinterestBase + queryString({
            "do": 'buttonPin',
            media: image,
            url: url,
            description: text
          });
        case 'tumblr':
          return tumblrBase + queryString({ url: url });
        case 'twitter':
          return twitterBase + queryString({ url: url, text: text, hashtags: hashtag });
        default:
          return null;}

    } }, { key: "render", value:

    function render() {
      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "ShareButton" }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("a", {
          href: this.shareUrl(),
          target: "_blank",
          rel: "noopener noreferrer",
          onClick: this.showInWindow }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(social_social_icon, this.props))));



    } }], [{ key: "currentLocation", value: function currentLocation() {if (typeof window === 'undefined') {return null;}return lodash_default.a.get(window, ['location', 'href']);} }]);return ShareButton;}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.PureComponent);share_button_defineProperty(share_button_ShareButton, "propTypes", share_button_objectSpread(share_button_objectSpread({}, social_social_icon.propTypes), {}, { url: prop_types_default.a.string, hashtag: prop_types_default.a.string, text: prop_types_default.a.string, quote: prop_types_default.a.string, image: prop_types_default.a.string, // Override `site` from `SocialIcon` to limit to the sites supported here.
  site: prop_types_default.a.oneOf(['email', 'facebook', 'linkedin', 'pinterest', 'tumblr', 'twitter']).isRequired }));share_button_defineProperty(share_button_ShareButton, "defaultProps", { url: share_button_ShareButton.currentLocation(), hashtag: 'glowforge', text: null, quote: null, image: null });

/* harmony default export */ var social_share_button = (share_button_ShareButton);
// EXTERNAL MODULE: ./src/components/social/share-group.less
var share_group = __webpack_require__(223);

// CONCATENATED MODULE: ./src/components/social/share-group.jsx
var share_group_excluded = ["sites"];function share_group_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function share_group_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? share_group_ownKeys(Object(source), !0).forEach(function (key) {share_group_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : share_group_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function share_group_defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function share_group_extends() {share_group_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return share_group_extends.apply(this, arguments);}function share_group_objectWithoutProperties(source, excluded) {if (source == null) return {};var target = share_group_objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function share_group_objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}






/**
 * Render a list of `ShareButton`s, one for each of the given `sites`. All the
 * rest of the props are passed through to each `ShareButton`, which will
 * handle rendering a share button as required. This is a convenience
 * component to provide consistent styling for a group of `ShareButton`s that
 * share the same content to different social sites.
 *
 * @type {{[p: string]: *}} sites - ordered (left-to-right) list of sites to render buttons for
 * @param url - passed on to ShareButton - the url of the content being shared
 * @param hashtag - passed on to ShareButton - do not include the # character e.g. 'glowforge'
 * @param text - passed on to ShareButton - the primary short-text to pre-populate share content
 * @param quote - passed on to ShareButton - a quote from Glowforge to include alongside the url
 * @param image - passed on to ShareButton - an image to share (only supported by pinterest)
 * @param props.size - passed on to SocialIcon - standard sizes small, medium, or large
 * @param props.appearance - passed on to SocialIcon - available styles square, round, clear
 */
var share_group_ShareGroup = function ShareGroup(_ref)


{var sites = _ref.sites,childProps = share_group_objectWithoutProperties(_ref, share_group_excluded);
  var buttons = lodash_default.a.map(sites, function (site) {return /*#__PURE__*/(
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("li", { className: "siteItem", key: site }, /*#__PURE__*/
      external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(social_share_button, share_group_extends({ site: site }, childProps))));});



  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "ShareGroup" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("ul", { className: "siteList" },
    buttons)));



};

share_group_ShareGroup.propTypes = share_group_objectSpread(share_group_objectSpread({},

lodash_default.a.omit(social_share_button.propTypes, ['site'])), {}, {
  sites: prop_types_default.a.arrayOf(social_share_button.propTypes.site).isRequired });


/* harmony default export */ var social_share_group = (share_group_ShareGroup);
// EXTERNAL MODULE: ./src/components/social/share-widget.less
var share_widget = __webpack_require__(224);

// CONCATENATED MODULE: ./src/components/social/share-widget.jsx
function share_widget_typeof(obj) {"@babel/helpers - typeof";return share_widget_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, share_widget_typeof(obj);}var share_widget_excluded = ["className", "pageTitle", "expandDirection"];function share_widget_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function share_widget_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? share_widget_ownKeys(Object(source), !0).forEach(function (key) {share_widget_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : share_widget_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function share_widget_extends() {share_widget_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return share_widget_extends.apply(this, arguments);}function share_widget_objectWithoutProperties(source, excluded) {if (source == null) return {};var target = share_widget_objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function share_widget_objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}function share_widget_classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function share_widget_defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function share_widget_createClass(Constructor, protoProps, staticProps) {if (protoProps) share_widget_defineProperties(Constructor.prototype, protoProps);if (staticProps) share_widget_defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;}function share_widget_inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });Object.defineProperty(subClass, "prototype", { writable: false });if (superClass) share_widget_setPrototypeOf(subClass, superClass);}function share_widget_setPrototypeOf(o, p) {share_widget_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return share_widget_setPrototypeOf(o, p);}function share_widget_createSuper(Derived) {var hasNativeReflectConstruct = share_widget_isNativeReflectConstruct();return function _createSuperInternal() {var Super = share_widget_getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = share_widget_getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return share_widget_possibleConstructorReturn(this, result);};}function share_widget_possibleConstructorReturn(self, call) {if (call && (share_widget_typeof(call) === "object" || typeof call === "function")) {return call;} else if (call !== void 0) {throw new TypeError("Derived constructors may only return object or undefined");}return share_widget_assertThisInitialized(self);}function share_widget_assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function share_widget_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function share_widget_getPrototypeOf(o) {share_widget_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {return o.__proto__ || Object.getPrototypeOf(o);};return share_widget_getPrototypeOf(o);}function share_widget_defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}









/**
 * Standard component for displaying share options on content pages. This is
 * intended for use on pages that target users high in the purchase funnel and
 * existing customers who may share content to their social networks,
 * promoting Glowforge. Deeper in the funnel, emphasis should be placed on
 * a purchase-related call to action instead of social.
 *
 * This component delegates rendering of individual ShareButtons to ShareGroup.
 *
 * @type {{[p: string]: *}} sites - passed on to ShareGroup - ordered list of social sites
 * @param pageTitle - the title of the page to be shared e.g. `document.title`
 * @param expandDirection - left | right - the side on which the ShareGroup appears
 * @param url - passed on to ShareButton - the canonical url of the content being shared
 * @param hashtag - passed on to ShareButton - do not include the # character e.g. 'glowforge'
 * @param text - passed on to ShareButton - the primary short-text to pre-populate share content
 * @param quote - passed on to ShareButton - a quote from Glowforge to include alongside the url
 * @param image - passed on to ShareButton - an image to share (only supported by pinterest)
 * @param props.size - passed on to SocialIcon - standard sizes small, medium, or large
 * @param props.appearance - passed on to SocialIcon - available styles square, round, clear
 */var
share_widget_ShareWidget = /*#__PURE__*/function (_React$PureComponent) {share_widget_inherits(ShareWidget, _React$PureComponent);var _super = share_widget_createSuper(ShareWidget);






















  function ShareWidget(props) {var _this;share_widget_classCallCheck(this, ShareWidget);
    _this = _super.call(this, props);share_widget_defineProperty(share_widget_assertThisInitialized(_this), "mouseIn",



    function () {
      _this.setState({ showFlyout: true });
    });share_widget_defineProperty(share_widget_assertThisInitialized(_this), "mouseOut",

    function () {
      _this.setState({ showFlyout: false });
    });_this.state = { showFlyout: false };return _this;}share_widget_createClass(ShareWidget, [{ key: "render", value:

    function render() {
      var _this$props =




        this.props,className = _this$props.className,pageTitle = _this$props.pageTitle,expandDirection = _this$props.expandDirection,childProps = share_widget_objectWithoutProperties(_this$props, share_widget_excluded);
      var showFlyout = this.state.showFlyout;

      var flyout = includeWhen(showFlyout, function () {return /*#__PURE__*/(
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "flyout" }, /*#__PURE__*/
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "pageTitle" }, pageTitle), /*#__PURE__*/
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "buttons" }, /*#__PURE__*/
          external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(social_share_group, share_widget_extends({ size: "small" }, childProps)))));});




      var wrapperClasses = classnames_default()(
      ['ShareWidget', expandDirection, className],
      { active: showFlyout });


      var shareIcon = showFlyout ? 'share' : 'shareLight';

      return /*#__PURE__*/(
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", {
          className: wrapperClasses,
          onMouseEnter: this.mouseIn,
          onMouseLeave: this.mouseOut }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "inlineWrapper" }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "shareTrigger" }, /*#__PURE__*/
        external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(social_social_icon, { site: shareIcon, appearance: "clear", size: "fit" })),

        flyout)));



    } }], [{ key: "documentTitle", value: function documentTitle() {if (typeof window === 'undefined') {return null;}return lodash_default.a.get(window, ['document', 'title']);} }]);return ShareWidget;}(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.PureComponent);share_widget_defineProperty(share_widget_ShareWidget, "propTypes", share_widget_objectSpread(share_widget_objectSpread({}, social_share_group.propTypes), {}, { className: prop_types_default.a.string, pageTitle: prop_types_default.a.string, expandDirection: prop_types_default.a.oneOf(['left', 'right']) }));share_widget_defineProperty(share_widget_ShareWidget, "defaultProps", { className: null, expandDirection: 'right', pageTitle: share_widget_ShareWidget.documentTitle() || 'Glowforge', // eslint-disable-next-line react/default-props-match-prop-types
  url: undefined });

/* harmony default export */ var social_share_widget = (share_widget_ShareWidget);
// EXTERNAL MODULE: ./src/components/social/social-card.less
var social_card = __webpack_require__(225);

// EXTERNAL MODULE: ./src/components/social/social-card-rebrand.less
var social_card_rebrand = __webpack_require__(226);

// CONCATENATED MODULE: ./src/components/social/social-card.jsx
function _toConsumableArray(arr) {return _arrayWithoutHoles(arr) || _iterableToArray(arr) || social_card_unsupportedIterableToArray(arr) || _nonIterableSpread();}function _nonIterableSpread() {throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function social_card_unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return social_card_arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return social_card_arrayLikeToArray(o, minLen);}function _iterableToArray(iter) {if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);}function _arrayWithoutHoles(arr) {if (Array.isArray(arr)) return social_card_arrayLikeToArray(arr);}function social_card_arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}








var FULL_AREA_LINK = 'fullAreaLink';

var social_card_SocialCard = function SocialCard(_ref)







{var authorHandle = _ref.authorHandle,authorName = _ref.authorName,authorPhotoUrl = _ref.authorPhotoUrl,displayType = _ref.displayType,photoUrl = _ref.photoUrl,text = _ref.text,url = _ref.url;
  var authorInfo;
  if (authorPhotoUrl && authorName && authorHandle) {
    authorInfo = /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "authorInfo" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(lazy_image, { className: "authorPhoto", src: "".concat(authorPhotoUrl, "?w=50&h=50&fm=jpg") }), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "authorTextInfo" }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "authorName" }, authorName), /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("span", { className: "authorHandle" }, authorHandle)));



  }

  var socialIcon;

  if (displayType && displayType !== FULL_AREA_LINK) {
    socialIcon = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(social_social_icon, { className: "socialIcon", appearance: "clear", site: displayType });
    if (url) {
      socialIcon = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("a", { href: url, target: "_blank", rel: "noreferrer noopener" }, socialIcon);
    }
  }

  var postContent = text ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "postContent" }, text) : null;
  var placeholder = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_placeholder_image, { src: "".concat(photoUrl, "?q=1&w=250&h=250&fm=jpg"), alt: "" });

  var visualContent = /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.Fragment, null, /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(lazy_image, {
    height: 250,
    offset: 500,
    className: "postPhoto",
    placeholder: placeholder,
    src: "".concat(photoUrl, "?w=250&h=250&fm=jpg") }),
  socialIcon, /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "cardText" },
  postContent,
  authorInfo));




  // If the whole social card is clickable, wrap it in an anchor tag
  if (displayType && displayType === FULL_AREA_LINK && url) {
    visualContent = /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("a", { href: url, target: "_blank", rel: "noreferrer noopener", className: "clearLink" },
    visualContent);


  }

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "SocialCard uic" },
    visualContent));


};

social_card_SocialCard.propTypes = {
  authorHandle: prop_types_default.a.string,
  authorName: prop_types_default.a.string,
  authorPhotoUrl: prop_types_default.a.string,
  displayType: prop_types_default.a.oneOf([].concat(_toConsumableArray(socialSites), [FULL_AREA_LINK])),
  photoUrl: prop_types_default.a.string,
  text: prop_types_default.a.string,
  url: prop_types_default.a.string
};

social_card_SocialCard.defaultProps = {
  authorHandle: null,
  authorName: null,
  authorPhotoUrl: null,
  displayType: null,
  photoUrl: null,
  text: null,
  url: null
};

/* harmony default export */ var social_social_card = (social_card_SocialCard);
// CONCATENATED MODULE: ./src/components/social/index.js





// CONCATENATED MODULE: ./src/models/footer.js


/**
 * Helpers for extracting Footer props from the contentful section, global-footer
 */
var footer_getInContentWithID = function getInContentWithID(content, id, path) {return lodash_default.a.get(lodash_default.a.find(content, { fields: { id: id } }), path);};

var getFooterText = function getFooterText(content, id) {return footer_getInContentWithID(content, id, 'fields.text');};

var getFooterLogo = function getFooterLogo(content) {return footer_getInContentWithID(content, 'glowforge-footer-logo', 'fields.svgAsset');};

var footer_getFooterLinks = function getFooterLinks(content) {return lodash_default()(content).
  filter(function (item) {return item.fields;}).
  filter(function (item) {return page_getContentType(item) === 'list';}).
  map(function (item) {return {
      title: item.fields.title,
      items: item.fields.listItems.filter(function (listItem) {return page_getContentType(listItem) === 'buttonLink';})
    };}).
  value();};

var footer_getContentfulGlobalFooterProps = function getContentfulGlobalFooterProps(data) {
  var content = lodash_default.a.get(data, 'fields.content');
  return content && {
    globalFooterLinks: footer_getFooterLinks(content),
    globalFooterLogo: getFooterLogo(content, 'glowforge-footer-logo'),
    globalFooterCopyright: getFooterText(content, 'footer-copyright'),
    globalFooterAddress: getFooterText(content, 'footer-company-address')
  };
};

/* harmony default export */ var models_footer = (footer_getContentfulGlobalFooterProps);
// CONCATENATED MODULE: ./src/models/index.js




// EXTERNAL MODULE: ./src/contentful-widgets/embeddable-share-widget.less
var embeddable_share_widget = __webpack_require__(227);

// EXTERNAL MODULE: ./src/contentful-widgets/embeddable-share-widget-rebrand.less
var embeddable_share_widget_rebrand = __webpack_require__(228);

// CONCATENATED MODULE: ./src/contentful-widgets/embeddable-share-widget.jsx










/**
 * Maps to the Share Widget content model on Contentful
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/shareWidget/fields
 * @param {Object} props
 * @param {String} props.position
 * @param {String} props.shareText
 * @param {String} props.shareUrl
 * @param {String} props.sites
 * @param {Object} props.stringSubstitutions
 */
var embeddable_share_widget_EmbeddableShareWidget = function EmbeddableShareWidget(_ref)





{var position = _ref.position,shareText = _ref.shareText,shareUrl = _ref.shareUrl,sites = _ref.sites,stringSubstitutions = _ref.stringSubstitutions;
  // `position` refers to the side of the page we're on. The ShareWidget
  // should expand in the opposite direction.
  var expandDirection = position.match(/right$/) ? 'left' : 'right';
  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement("div", { className: "EmbeddableShareWidget uic fullWidth ".concat(position) }, /*#__PURE__*/
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(social_share_widget, {
      className: "wrapper",
      appearance: "round",
      sites: sites,
      expandDirection: expandDirection,
      url: shareUrl && stringSubstitution(shareUrl, stringSubstitutions),
      text: shareText })));


};

embeddable_share_widget_EmbeddableShareWidget.propTypes = {
  sites: prop_types_default.a.arrayOf(prop_types_default.a.string).isRequired,
  position: prop_types_default.a.oneOf(['left', 'right']),
  shareUrl: prop_types_default.a.string,
  shareText: prop_types_default.a.string,
  stringSubstitutions: stringSubstitutionsPropType
};

embeddable_share_widget_EmbeddableShareWidget.defaultProps = {
  position: 'left',
  // `undefined`, as opposed to null, allows the next component to use its default
  shareUrl: undefined,
  shareText: undefined,
  stringSubstitutions: {}
};

registerWidget('shareWidget', embeddable_share_widget_EmbeddableShareWidget);

/* harmony default export */ var contentful_widgets_embeddable_share_widget = (embeddable_share_widget_EmbeddableShareWidget);
// CONCATENATED MODULE: ./src/contentful-widgets/list.jsx











/**
 * ListWidget mapping for Contentful List content types.
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/list/fields
 */
var list_ListWidget = function ListWidget(_ref)

{var customWidgets = _ref.customWidgets,stringSubstitutions = _ref.stringSubstitutions,model = _ref.model,id = _ref.id;
  var className = id; // legacy, id was being passed as class name.
  var displayOption = lodash_default.a.get(model, 'fields.displayOption');
  var listItems = lodash_default.a.get(model, 'fields.listItems');
  var text = lodash_default.a.get(model, 'fields.text');
  var title = lodash_default.a.get(model, 'fields.title');

  var titleText = stringSubstitution(title, stringSubstitutions);
  var subTitle = text ? /*#__PURE__*/
  external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_markdown, { className: "subTitle paragraph", source: stringSubstitution(text, stringSubstitutions) }) :
  null;

  var children = sections_getSectionsArray(listItems, customWidgets);

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(components_list_list, {
      className: classnames_default()(className, lodash_default.a.camelCase(displayOption)),
      displayOption: displayOption,
      subTitle: subTitle,
      title: titleText },
    children));


};

list_ListWidget.propTypes = {
  customWidgets: customWidgetsPropType,
  stringSubstitutions: stringSubstitutionsPropType,
  id: prop_types_default.a.string,
  model: prop_types_default.a.shape({})
};

list_ListWidget.defaultProps = {
  customWidgets: {},
  stringSubstitutions: {},
  id: null,
  model: {}
};

registerWidget('list', list_ListWidget);

/* harmony default export */ var contentful_widgets_list = (list_ListWidget);
// CONCATENATED MODULE: ./src/contentful-widgets/social-card.jsx
var social_card_excluded = ["authorPhoto", "photo"];function social_card_extends() {social_card_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return social_card_extends.apply(this, arguments);}function social_card_objectWithoutProperties(source, excluded) {if (source == null) return {};var target = social_card_objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function social_card_objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}





/**
 * Maps to the Social Card content model on Contentful
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/socialCard/fields
 * @param {Object} props
 * @param {Object} props.model
 */
var social_card_SocialCardWidget = function SocialCardWidget(_ref) {var model = _ref.model;
  var _$get =



    lodash_default.a.get(model, 'fields'),authorPhoto = _$get.authorPhoto,photo = _$get.photo,fields = social_card_objectWithoutProperties(_$get, social_card_excluded);
  var authorPhotoUrl = lodash_default.a.get(authorPhoto, 'fields.file.url');
  var photoUrl = lodash_default.a.get(photo, 'fields.file.url');
  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(social_social_card, social_card_extends({
      key: photoUrl,
      authorPhotoUrl: authorPhotoUrl,
      photoUrl: photoUrl },
    fields)));

};

social_card_SocialCardWidget.propTypes = {
  model: prop_types_default.a.shape({
    fields: prop_types_default.a.shape({})
  })
};

social_card_SocialCardWidget.defaultProps = {
  model: {
    fields: {}
  }
};

registerWidget('socialCard', social_card_SocialCardWidget);

/* harmony default export */ var contentful_widgets_social_card = (social_card_SocialCardWidget);
// CONCATENATED MODULE: ./src/contentful-widgets/wistia-button.jsx






/**
 * Maps to the Wistia Button content model on Contentful
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/wistiaButton/fields}
 * @param {Object} props
 * @param {Object} model
 */
var wistia_button_WistiaButtonWidget = function WistiaButtonWidget(_ref) {var model = _ref.model;return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(wistia_button_wistia_button, lodash_default.a.get(model, 'fields'));};

wistia_button_WistiaButtonWidget.propTypes = {
  model: prop_types_default.a.shape({})
};

wistia_button_WistiaButtonWidget.defaultProps = {
  model: {}
};

registerWidget('wistiaButton', wistia_button_WistiaButtonWidget);

/* harmony default export */ var contentful_widgets_wistia_button = (wistia_button_WistiaButtonWidget);
// CONCATENATED MODULE: ./src/contentful-widgets/hero-banner-widget.jsx
function hero_banner_widget_extends() {hero_banner_widget_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return hero_banner_widget_extends.apply(this, arguments);}





/**
 * HeroBanner for all the heroes out there (especially you).
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/heroBanner/fields
 * @param {Object} props
 * @param {Object} props.model
 */
var hero_banner_widget_HeroBannerWidget = function HeroBannerWidget(_ref) {var model = _ref.model;
  var ctaButton = sections_getWidget(lodash_default.a.get(model, 'fields.ctaButton'));
  var backgroundImage = lodash_default.a.get(model, 'fields.backgroundImage.fields.file.url');
  var backgroundImageMobile = lodash_default.a.get(model, 'fields.backgroundImageMobile.fields.file.url');
  var videos = lodash_default.a.get(model, 'fields.video');

  return /*#__PURE__*/(
    external_commonjs_react_commonjs2_react_amd_React_root_React_default.a.createElement(hero_banner_hero_banner, hero_banner_widget_extends({},
    model.fields, {
      backgroundImage: backgroundImage,
      backgroundImageMobile: backgroundImageMobile,
      ctaButton: ctaButton,
      videos: videos })));

};

hero_banner_widget_HeroBannerWidget.propTypes = {
  model: prop_types_default.a.shape({})
};

hero_banner_widget_HeroBannerWidget.defaultProps = {
  model: {}
};

registerWidget('heroBanner', hero_banner_widget_HeroBannerWidget);

/* harmony default export */ var hero_banner_widget = (hero_banner_widget_HeroBannerWidget);
// CONCATENATED MODULE: ./src/contentful-widgets/index.js






// CONCATENATED MODULE: ./src/index.js
// This builds a file 'main.css' which contains all styling for both a base
// ui-common application - typography, resets, common css classes, etc. and
// for all exported components. Ideally, only the CSS used by each consuming
// application should need to be included.
























/***/ })
/******/ ]);
});
//# sourceMappingURL=main.js.map

/***/ }),

/***/ "./node_modules/@glowforge/ui-common/stylesheets/base.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./client/index.js");


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[0]);


// WEBPACK FOOTER //
// main.286ad8fe86413fa80853.js